/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
import * as $protobuf from "protobufjs/minimal";

const $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

const $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

export const PBEntity = $root.PBEntity = (() => {

    const PBEntity = {};

    PBEntity.AccAmtLog = (function () {

        function AccAmtLog(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        AccAmtLog.prototype.AFID = "";
        AccAmtLog.prototype.AccID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        AccAmtLog.prototype.MchID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        AccAmtLog.prototype.UseID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        AccAmtLog.prototype.AccCate = 0;
        AccAmtLog.prototype.UseCate = 0;
        AccAmtLog.prototype.Dir = 0;
        AccAmtLog.prototype.RecordCate = 0;
        AccAmtLog.prototype.TransCate = 0;
        AccAmtLog.prototype.TransAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        AccAmtLog.prototype.TransTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        AccAmtLog.prototype.ReID = "";
        AccAmtLog.prototype.ToUserID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        AccAmtLog.prototype.Notes = "";
        AccAmtLog.prototype.CreateTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        AccAmtLog.prototype.CreaterID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        AccAmtLog.prototype.UpdateTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        AccAmtLog.prototype.UpdaterID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        AccAmtLog.prototype.Estate = 0;

        AccAmtLog.create = function create(properties) {
            return new AccAmtLog(properties);
        };

        AccAmtLog.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.AFID != null && Object.hasOwnProperty.call(m, "AFID"))
                w.uint32(10).string(m.AFID);
            if (m.AccID != null && Object.hasOwnProperty.call(m, "AccID"))
                w.uint32(16).uint64(m.AccID);
            if (m.MchID != null && Object.hasOwnProperty.call(m, "MchID"))
                w.uint32(24).uint64(m.MchID);
            if (m.UseID != null && Object.hasOwnProperty.call(m, "UseID"))
                w.uint32(32).uint64(m.UseID);
            if (m.AccCate != null && Object.hasOwnProperty.call(m, "AccCate"))
                w.uint32(40).int32(m.AccCate);
            if (m.UseCate != null && Object.hasOwnProperty.call(m, "UseCate"))
                w.uint32(48).int32(m.UseCate);
            if (m.Dir != null && Object.hasOwnProperty.call(m, "Dir"))
                w.uint32(56).int32(m.Dir);
            if (m.RecordCate != null && Object.hasOwnProperty.call(m, "RecordCate"))
                w.uint32(64).int32(m.RecordCate);
            if (m.TransCate != null && Object.hasOwnProperty.call(m, "TransCate"))
                w.uint32(72).int32(m.TransCate);
            if (m.TransAmt != null && Object.hasOwnProperty.call(m, "TransAmt"))
                w.uint32(80).int64(m.TransAmt);
            if (m.TransTime != null && Object.hasOwnProperty.call(m, "TransTime"))
                w.uint32(88).int64(m.TransTime);
            if (m.ReID != null && Object.hasOwnProperty.call(m, "ReID"))
                w.uint32(98).string(m.ReID);
            if (m.ToUserID != null && Object.hasOwnProperty.call(m, "ToUserID"))
                w.uint32(104).uint64(m.ToUserID);
            if (m.Notes != null && Object.hasOwnProperty.call(m, "Notes"))
                w.uint32(114).string(m.Notes);
            if (m.CreateTime != null && Object.hasOwnProperty.call(m, "CreateTime"))
                w.uint32(120).int64(m.CreateTime);
            if (m.CreaterID != null && Object.hasOwnProperty.call(m, "CreaterID"))
                w.uint32(128).uint64(m.CreaterID);
            if (m.UpdateTime != null && Object.hasOwnProperty.call(m, "UpdateTime"))
                w.uint32(136).int64(m.UpdateTime);
            if (m.UpdaterID != null && Object.hasOwnProperty.call(m, "UpdaterID"))
                w.uint32(144).uint64(m.UpdaterID);
            if (m.Estate != null && Object.hasOwnProperty.call(m, "Estate"))
                w.uint32(152).int32(m.Estate);
            return w;
        };

        AccAmtLog.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.AccAmtLog();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        m.AFID = r.string();
                        break;
                    }
                    case 2: {
                        m.AccID = r.uint64();
                        break;
                    }
                    case 3: {
                        m.MchID = r.uint64();
                        break;
                    }
                    case 4: {
                        m.UseID = r.uint64();
                        break;
                    }
                    case 5: {
                        m.AccCate = r.int32();
                        break;
                    }
                    case 6: {
                        m.UseCate = r.int32();
                        break;
                    }
                    case 7: {
                        m.Dir = r.int32();
                        break;
                    }
                    case 8: {
                        m.RecordCate = r.int32();
                        break;
                    }
                    case 9: {
                        m.TransCate = r.int32();
                        break;
                    }
                    case 10: {
                        m.TransAmt = r.int64();
                        break;
                    }
                    case 11: {
                        m.TransTime = r.int64();
                        break;
                    }
                    case 12: {
                        m.ReID = r.string();
                        break;
                    }
                    case 13: {
                        m.ToUserID = r.uint64();
                        break;
                    }
                    case 14: {
                        m.Notes = r.string();
                        break;
                    }
                    case 15: {
                        m.CreateTime = r.int64();
                        break;
                    }
                    case 16: {
                        m.CreaterID = r.uint64();
                        break;
                    }
                    case 17: {
                        m.UpdateTime = r.int64();
                        break;
                    }
                    case 18: {
                        m.UpdaterID = r.uint64();
                        break;
                    }
                    case 19: {
                        m.Estate = r.int32();
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        AccAmtLog.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.AccAmtLog";
        };

        return AccAmtLog;
    })();

    PBEntity.AccAmtLogs = (function () {

        function AccAmtLogs(p) {
            this.AccAmtLogs = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        AccAmtLogs.prototype.AccAmtLogs = $util.emptyArray;

        AccAmtLogs.create = function create(properties) {
            return new AccAmtLogs(properties);
        };

        AccAmtLogs.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.AccAmtLogs != null && m.AccAmtLogs.length) {
                for (var i = 0; i < m.AccAmtLogs.length; ++i)
                    $root.PBEntity.AccAmtLog.encode(m.AccAmtLogs[i], w.uint32(10).fork()).ldelim();
            }
            return w;
        };

        AccAmtLogs.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.AccAmtLogs();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        if (!(m.AccAmtLogs && m.AccAmtLogs.length))
                            m.AccAmtLogs = [];
                        m.AccAmtLogs.push($root.PBEntity.AccAmtLog.decode(r, r.uint32()));
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        AccAmtLogs.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.AccAmtLogs";
        };

        return AccAmtLogs;
    })();

    PBEntity.AccPointsLog = (function () {

        function AccPointsLog(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        AccPointsLog.prototype.APID = "";
        AccPointsLog.prototype.AccID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        AccPointsLog.prototype.MchID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        AccPointsLog.prototype.UseID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        AccPointsLog.prototype.UseCate = 0;
        AccPointsLog.prototype.Dir = 0;
        AccPointsLog.prototype.TransCate = 0;
        AccPointsLog.prototype.TransAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        AccPointsLog.prototype.TransTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        AccPointsLog.prototype.ReID = "";
        AccPointsLog.prototype.ToUserID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        AccPointsLog.prototype.Notes = "";
        AccPointsLog.prototype.CreateTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        AccPointsLog.prototype.CreaterID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        AccPointsLog.prototype.UpdateTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        AccPointsLog.prototype.UpdaterID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        AccPointsLog.prototype.Estate = 0;

        AccPointsLog.create = function create(properties) {
            return new AccPointsLog(properties);
        };

        AccPointsLog.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.APID != null && Object.hasOwnProperty.call(m, "APID"))
                w.uint32(10).string(m.APID);
            if (m.AccID != null && Object.hasOwnProperty.call(m, "AccID"))
                w.uint32(16).uint64(m.AccID);
            if (m.MchID != null && Object.hasOwnProperty.call(m, "MchID"))
                w.uint32(24).uint64(m.MchID);
            if (m.UseID != null && Object.hasOwnProperty.call(m, "UseID"))
                w.uint32(32).uint64(m.UseID);
            if (m.UseCate != null && Object.hasOwnProperty.call(m, "UseCate"))
                w.uint32(40).int32(m.UseCate);
            if (m.Dir != null && Object.hasOwnProperty.call(m, "Dir"))
                w.uint32(48).int32(m.Dir);
            if (m.TransCate != null && Object.hasOwnProperty.call(m, "TransCate"))
                w.uint32(56).int32(m.TransCate);
            if (m.TransAmt != null && Object.hasOwnProperty.call(m, "TransAmt"))
                w.uint32(64).int64(m.TransAmt);
            if (m.TransTime != null && Object.hasOwnProperty.call(m, "TransTime"))
                w.uint32(72).int64(m.TransTime);
            if (m.ReID != null && Object.hasOwnProperty.call(m, "ReID"))
                w.uint32(82).string(m.ReID);
            if (m.ToUserID != null && Object.hasOwnProperty.call(m, "ToUserID"))
                w.uint32(88).uint64(m.ToUserID);
            if (m.Notes != null && Object.hasOwnProperty.call(m, "Notes"))
                w.uint32(98).string(m.Notes);
            if (m.CreateTime != null && Object.hasOwnProperty.call(m, "CreateTime"))
                w.uint32(104).int64(m.CreateTime);
            if (m.CreaterID != null && Object.hasOwnProperty.call(m, "CreaterID"))
                w.uint32(112).uint64(m.CreaterID);
            if (m.UpdateTime != null && Object.hasOwnProperty.call(m, "UpdateTime"))
                w.uint32(120).int64(m.UpdateTime);
            if (m.UpdaterID != null && Object.hasOwnProperty.call(m, "UpdaterID"))
                w.uint32(128).uint64(m.UpdaterID);
            if (m.Estate != null && Object.hasOwnProperty.call(m, "Estate"))
                w.uint32(136).int32(m.Estate);
            return w;
        };

        AccPointsLog.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.AccPointsLog();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        m.APID = r.string();
                        break;
                    }
                    case 2: {
                        m.AccID = r.uint64();
                        break;
                    }
                    case 3: {
                        m.MchID = r.uint64();
                        break;
                    }
                    case 4: {
                        m.UseID = r.uint64();
                        break;
                    }
                    case 5: {
                        m.UseCate = r.int32();
                        break;
                    }
                    case 6: {
                        m.Dir = r.int32();
                        break;
                    }
                    case 7: {
                        m.TransCate = r.int32();
                        break;
                    }
                    case 8: {
                        m.TransAmt = r.int64();
                        break;
                    }
                    case 9: {
                        m.TransTime = r.int64();
                        break;
                    }
                    case 10: {
                        m.ReID = r.string();
                        break;
                    }
                    case 11: {
                        m.ToUserID = r.uint64();
                        break;
                    }
                    case 12: {
                        m.Notes = r.string();
                        break;
                    }
                    case 13: {
                        m.CreateTime = r.int64();
                        break;
                    }
                    case 14: {
                        m.CreaterID = r.uint64();
                        break;
                    }
                    case 15: {
                        m.UpdateTime = r.int64();
                        break;
                    }
                    case 16: {
                        m.UpdaterID = r.uint64();
                        break;
                    }
                    case 17: {
                        m.Estate = r.int32();
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        AccPointsLog.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.AccPointsLog";
        };

        return AccPointsLog;
    })();

    PBEntity.AccPointsLogs = (function () {

        function AccPointsLogs(p) {
            this.AccPointsLogs = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        AccPointsLogs.prototype.AccPointsLogs = $util.emptyArray;

        AccPointsLogs.create = function create(properties) {
            return new AccPointsLogs(properties);
        };

        AccPointsLogs.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.AccPointsLogs != null && m.AccPointsLogs.length) {
                for (var i = 0; i < m.AccPointsLogs.length; ++i)
                    $root.PBEntity.AccPointsLog.encode(m.AccPointsLogs[i], w.uint32(10).fork()).ldelim();
            }
            return w;
        };

        AccPointsLogs.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.AccPointsLogs();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        if (!(m.AccPointsLogs && m.AccPointsLogs.length))
                            m.AccPointsLogs = [];
                        m.AccPointsLogs.push($root.PBEntity.AccPointsLog.decode(r, r.uint32()));
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        AccPointsLogs.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.AccPointsLogs";
        };

        return AccPointsLogs;
    })();

    PBEntity.Account = (function () {

        function Account(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        Account.prototype.AccID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        Account.prototype.Category = 0;
        Account.prototype.MchID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        Account.prototype.UseID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        Account.prototype.UserName = "";
        Account.prototype.UseCategory = 0;
        Account.prototype.AccountName = "";
        Account.prototype.AccountNo = "";
        Account.prototype.Level = 0;
        Account.prototype.Amount = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Account.prototype.FreezeAmount = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Account.prototype.TotalAmount = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Account.prototype.Points = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Account.prototype.FreezePoints = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Account.prototype.TotalPoints = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Account.prototype.LevelPoints = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Account.prototype.IsSys = 0;
        Account.prototype.Notes = "";
        Account.prototype.Priority = 0;
        Account.prototype.Sex = 0;
        Account.prototype.BirthMonth = 0;
        Account.prototype.BirthDay = 0;
        Account.prototype.Mobile = "";
        Account.prototype.MobileIsVerify = 0;
        Account.prototype.IsPerfectInfo = 0;
        Account.prototype.PerfectInfoTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Account.prototype.CouponCount = 0;
        Account.prototype.FirstOrderTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Account.prototype.UserID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        Account.prototype.CreateTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Account.prototype.CreaterID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        Account.prototype.UpdateTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Account.prototype.UpdaterID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        Account.prototype.Estate = 0;

        Account.create = function create(properties) {
            return new Account(properties);
        };

        Account.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.AccID != null && Object.hasOwnProperty.call(m, "AccID"))
                w.uint32(8).uint64(m.AccID);
            if (m.Category != null && Object.hasOwnProperty.call(m, "Category"))
                w.uint32(16).int32(m.Category);
            if (m.MchID != null && Object.hasOwnProperty.call(m, "MchID"))
                w.uint32(24).uint64(m.MchID);
            if (m.UseID != null && Object.hasOwnProperty.call(m, "UseID"))
                w.uint32(32).uint64(m.UseID);
            if (m.UserName != null && Object.hasOwnProperty.call(m, "UserName"))
                w.uint32(42).string(m.UserName);
            if (m.UseCategory != null && Object.hasOwnProperty.call(m, "UseCategory"))
                w.uint32(48).int32(m.UseCategory);
            if (m.AccountName != null && Object.hasOwnProperty.call(m, "AccountName"))
                w.uint32(58).string(m.AccountName);
            if (m.AccountNo != null && Object.hasOwnProperty.call(m, "AccountNo"))
                w.uint32(66).string(m.AccountNo);
            if (m.Level != null && Object.hasOwnProperty.call(m, "Level"))
                w.uint32(72).int32(m.Level);
            if (m.Amount != null && Object.hasOwnProperty.call(m, "Amount"))
                w.uint32(80).int64(m.Amount);
            if (m.FreezeAmount != null && Object.hasOwnProperty.call(m, "FreezeAmount"))
                w.uint32(88).int64(m.FreezeAmount);
            if (m.TotalAmount != null && Object.hasOwnProperty.call(m, "TotalAmount"))
                w.uint32(96).int64(m.TotalAmount);
            if (m.Points != null && Object.hasOwnProperty.call(m, "Points"))
                w.uint32(104).int64(m.Points);
            if (m.FreezePoints != null && Object.hasOwnProperty.call(m, "FreezePoints"))
                w.uint32(112).int64(m.FreezePoints);
            if (m.TotalPoints != null && Object.hasOwnProperty.call(m, "TotalPoints"))
                w.uint32(120).int64(m.TotalPoints);
            if (m.LevelPoints != null && Object.hasOwnProperty.call(m, "LevelPoints"))
                w.uint32(128).int64(m.LevelPoints);
            if (m.IsSys != null && Object.hasOwnProperty.call(m, "IsSys"))
                w.uint32(136).int32(m.IsSys);
            if (m.Notes != null && Object.hasOwnProperty.call(m, "Notes"))
                w.uint32(146).string(m.Notes);
            if (m.Priority != null && Object.hasOwnProperty.call(m, "Priority"))
                w.uint32(152).int32(m.Priority);
            if (m.Sex != null && Object.hasOwnProperty.call(m, "Sex"))
                w.uint32(160).int32(m.Sex);
            if (m.BirthMonth != null && Object.hasOwnProperty.call(m, "BirthMonth"))
                w.uint32(168).int32(m.BirthMonth);
            if (m.BirthDay != null && Object.hasOwnProperty.call(m, "BirthDay"))
                w.uint32(176).int32(m.BirthDay);
            if (m.Mobile != null && Object.hasOwnProperty.call(m, "Mobile"))
                w.uint32(186).string(m.Mobile);
            if (m.MobileIsVerify != null && Object.hasOwnProperty.call(m, "MobileIsVerify"))
                w.uint32(192).int32(m.MobileIsVerify);
            if (m.IsPerfectInfo != null && Object.hasOwnProperty.call(m, "IsPerfectInfo"))
                w.uint32(200).int32(m.IsPerfectInfo);
            if (m.PerfectInfoTime != null && Object.hasOwnProperty.call(m, "PerfectInfoTime"))
                w.uint32(208).int64(m.PerfectInfoTime);
            if (m.CouponCount != null && Object.hasOwnProperty.call(m, "CouponCount"))
                w.uint32(216).int32(m.CouponCount);
            if (m.FirstOrderTime != null && Object.hasOwnProperty.call(m, "FirstOrderTime"))
                w.uint32(224).int64(m.FirstOrderTime);
            if (m.UserID != null && Object.hasOwnProperty.call(m, "UserID"))
                w.uint32(232).uint64(m.UserID);
            if (m.CreateTime != null && Object.hasOwnProperty.call(m, "CreateTime"))
                w.uint32(240).int64(m.CreateTime);
            if (m.CreaterID != null && Object.hasOwnProperty.call(m, "CreaterID"))
                w.uint32(248).uint64(m.CreaterID);
            if (m.UpdateTime != null && Object.hasOwnProperty.call(m, "UpdateTime"))
                w.uint32(256).int64(m.UpdateTime);
            if (m.UpdaterID != null && Object.hasOwnProperty.call(m, "UpdaterID"))
                w.uint32(264).uint64(m.UpdaterID);
            if (m.Estate != null && Object.hasOwnProperty.call(m, "Estate"))
                w.uint32(272).int32(m.Estate);
            return w;
        };

        Account.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.Account();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        m.AccID = r.uint64();
                        break;
                    }
                    case 2: {
                        m.Category = r.int32();
                        break;
                    }
                    case 3: {
                        m.MchID = r.uint64();
                        break;
                    }
                    case 4: {
                        m.UseID = r.uint64();
                        break;
                    }
                    case 5: {
                        m.UserName = r.string();
                        break;
                    }
                    case 6: {
                        m.UseCategory = r.int32();
                        break;
                    }
                    case 7: {
                        m.AccountName = r.string();
                        break;
                    }
                    case 8: {
                        m.AccountNo = r.string();
                        break;
                    }
                    case 9: {
                        m.Level = r.int32();
                        break;
                    }
                    case 10: {
                        m.Amount = r.int64();
                        break;
                    }
                    case 11: {
                        m.FreezeAmount = r.int64();
                        break;
                    }
                    case 12: {
                        m.TotalAmount = r.int64();
                        break;
                    }
                    case 13: {
                        m.Points = r.int64();
                        break;
                    }
                    case 14: {
                        m.FreezePoints = r.int64();
                        break;
                    }
                    case 15: {
                        m.TotalPoints = r.int64();
                        break;
                    }
                    case 16: {
                        m.LevelPoints = r.int64();
                        break;
                    }
                    case 17: {
                        m.IsSys = r.int32();
                        break;
                    }
                    case 18: {
                        m.Notes = r.string();
                        break;
                    }
                    case 19: {
                        m.Priority = r.int32();
                        break;
                    }
                    case 20: {
                        m.Sex = r.int32();
                        break;
                    }
                    case 21: {
                        m.BirthMonth = r.int32();
                        break;
                    }
                    case 22: {
                        m.BirthDay = r.int32();
                        break;
                    }
                    case 23: {
                        m.Mobile = r.string();
                        break;
                    }
                    case 24: {
                        m.MobileIsVerify = r.int32();
                        break;
                    }
                    case 25: {
                        m.IsPerfectInfo = r.int32();
                        break;
                    }
                    case 26: {
                        m.PerfectInfoTime = r.int64();
                        break;
                    }
                    case 27: {
                        m.CouponCount = r.int32();
                        break;
                    }
                    case 28: {
                        m.FirstOrderTime = r.int64();
                        break;
                    }
                    case 29: {
                        m.UserID = r.uint64();
                        break;
                    }
                    case 30: {
                        m.CreateTime = r.int64();
                        break;
                    }
                    case 31: {
                        m.CreaterID = r.uint64();
                        break;
                    }
                    case 32: {
                        m.UpdateTime = r.int64();
                        break;
                    }
                    case 33: {
                        m.UpdaterID = r.uint64();
                        break;
                    }
                    case 34: {
                        m.Estate = r.int32();
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        Account.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.Account";
        };

        return Account;
    })();

    PBEntity.Accounts = (function () {

        function Accounts(p) {
            this.Accounts = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        Accounts.prototype.Accounts = $util.emptyArray;

        Accounts.create = function create(properties) {
            return new Accounts(properties);
        };

        Accounts.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.Accounts != null && m.Accounts.length) {
                for (var i = 0; i < m.Accounts.length; ++i)
                    $root.PBEntity.Account.encode(m.Accounts[i], w.uint32(10).fork()).ldelim();
            }
            return w;
        };

        Accounts.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.Accounts();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        if (!(m.Accounts && m.Accounts.length))
                            m.Accounts = [];
                        m.Accounts.push($root.PBEntity.Account.decode(r, r.uint32()));
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        Accounts.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.Accounts";
        };

        return Accounts;
    })();

    PBEntity.Agent = (function () {

        function Agent(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        Agent.prototype.ID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        Agent.prototype.Name = "";
        Agent.prototype.Category = 0;
        Agent.prototype.AdminID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        Agent.prototype.CertType = 0;
        Agent.prototype.CertName = "";
        Agent.prototype.CertNo = "";
        Agent.prototype.Phone = "";
        Agent.prototype.Email = "";
        Agent.prototype.ProvinceID = 0;
        Agent.prototype.CityID = 0;
        Agent.prototype.AreaName = "";
        Agent.prototype.Address = "";
        Agent.prototype.BankCategory = 0;
        Agent.prototype.BankCategoryName = "";
        Agent.prototype.BankProvinceID = 0;
        Agent.prototype.BankCityID = 0;
        Agent.prototype.BankAreaName = "";
        Agent.prototype.BankAccName = "";
        Agent.prototype.BankAccNo = "";
        Agent.prototype.ProfitAmountRate = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Agent.prototype.ProfitAmountMin = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Agent.prototype.ProfitCountRate = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Agent.prototype.ProfitCountMin = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Agent.prototype.WeChatPayMode = 0;
        Agent.prototype.WeChatMchID = "";
        Agent.prototype.WeChatMchKey = "";
        Agent.prototype.WeChatSSLNo = "";
        Agent.prototype.WeChatSSLPwd = "";
        Agent.prototype.WeChatSSLFileID = "";
        Agent.prototype.WeChatCert = "";
        Agent.prototype.WeChatApiV3Key = "";
        Agent.prototype.WeChatApiV3No = "";
        Agent.prototype.WeChatApiV3Cert = "";
        Agent.prototype.WeChatMinRate = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Agent.prototype.ZFBPayMode = 0;
        Agent.prototype.ZFBPID = "";
        Agent.prototype.ZFBAppID = "";
        Agent.prototype.ZFBSignType = "";
        Agent.prototype.ZFBAESKey = "";
        Agent.prototype.ZFBMinRate = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Agent.prototype.ZFBPrvCert = "";
        Agent.prototype.ZFBPubCert = "";
        Agent.prototype.Notes = "";
        Agent.prototype.CreateTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Agent.prototype.CreaterID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        Agent.prototype.UpdateTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Agent.prototype.UpdaterID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        Agent.prototype.Estate = 0;
        Agent.prototype.ZFBGatewayHost = "";
        Agent.prototype.ZFBNotifyURL = "";
        Agent.prototype.ZFBAuthRedirectURL = "";
        Agent.prototype.IsPermGroup = 0;
        Agent.prototype.IsPermAgency = 0;
        Agent.prototype.IsPermApply = 0;
        Agent.prototype.IsPermWxapply = 0;
        Agent.prototype.IsPermZFBApply = 0;
        Agent.prototype.IsDPAgency = 0;

        Agent.create = function create(properties) {
            return new Agent(properties);
        };

        Agent.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.ID != null && Object.hasOwnProperty.call(m, "ID"))
                w.uint32(8).uint64(m.ID);
            if (m.Name != null && Object.hasOwnProperty.call(m, "Name"))
                w.uint32(18).string(m.Name);
            if (m.Category != null && Object.hasOwnProperty.call(m, "Category"))
                w.uint32(24).int32(m.Category);
            if (m.AdminID != null && Object.hasOwnProperty.call(m, "AdminID"))
                w.uint32(32).uint64(m.AdminID);
            if (m.CertType != null && Object.hasOwnProperty.call(m, "CertType"))
                w.uint32(40).int32(m.CertType);
            if (m.CertName != null && Object.hasOwnProperty.call(m, "CertName"))
                w.uint32(50).string(m.CertName);
            if (m.CertNo != null && Object.hasOwnProperty.call(m, "CertNo"))
                w.uint32(58).string(m.CertNo);
            if (m.Phone != null && Object.hasOwnProperty.call(m, "Phone"))
                w.uint32(66).string(m.Phone);
            if (m.Email != null && Object.hasOwnProperty.call(m, "Email"))
                w.uint32(74).string(m.Email);
            if (m.ProvinceID != null && Object.hasOwnProperty.call(m, "ProvinceID"))
                w.uint32(80).int32(m.ProvinceID);
            if (m.CityID != null && Object.hasOwnProperty.call(m, "CityID"))
                w.uint32(88).int32(m.CityID);
            if (m.AreaName != null && Object.hasOwnProperty.call(m, "AreaName"))
                w.uint32(98).string(m.AreaName);
            if (m.Address != null && Object.hasOwnProperty.call(m, "Address"))
                w.uint32(106).string(m.Address);
            if (m.BankCategory != null && Object.hasOwnProperty.call(m, "BankCategory"))
                w.uint32(112).int32(m.BankCategory);
            if (m.BankCategoryName != null && Object.hasOwnProperty.call(m, "BankCategoryName"))
                w.uint32(122).string(m.BankCategoryName);
            if (m.BankProvinceID != null && Object.hasOwnProperty.call(m, "BankProvinceID"))
                w.uint32(128).int32(m.BankProvinceID);
            if (m.BankCityID != null && Object.hasOwnProperty.call(m, "BankCityID"))
                w.uint32(136).int32(m.BankCityID);
            if (m.BankAreaName != null && Object.hasOwnProperty.call(m, "BankAreaName"))
                w.uint32(146).string(m.BankAreaName);
            if (m.BankAccName != null && Object.hasOwnProperty.call(m, "BankAccName"))
                w.uint32(154).string(m.BankAccName);
            if (m.BankAccNo != null && Object.hasOwnProperty.call(m, "BankAccNo"))
                w.uint32(162).string(m.BankAccNo);
            if (m.ProfitAmountRate != null && Object.hasOwnProperty.call(m, "ProfitAmountRate"))
                w.uint32(168).int64(m.ProfitAmountRate);
            if (m.ProfitAmountMin != null && Object.hasOwnProperty.call(m, "ProfitAmountMin"))
                w.uint32(176).int64(m.ProfitAmountMin);
            if (m.ProfitCountRate != null && Object.hasOwnProperty.call(m, "ProfitCountRate"))
                w.uint32(184).int64(m.ProfitCountRate);
            if (m.ProfitCountMin != null && Object.hasOwnProperty.call(m, "ProfitCountMin"))
                w.uint32(192).int64(m.ProfitCountMin);
            if (m.WeChatPayMode != null && Object.hasOwnProperty.call(m, "WeChatPayMode"))
                w.uint32(200).int32(m.WeChatPayMode);
            if (m.WeChatMchID != null && Object.hasOwnProperty.call(m, "WeChatMchID"))
                w.uint32(210).string(m.WeChatMchID);
            if (m.WeChatMchKey != null && Object.hasOwnProperty.call(m, "WeChatMchKey"))
                w.uint32(218).string(m.WeChatMchKey);
            if (m.WeChatSSLNo != null && Object.hasOwnProperty.call(m, "WeChatSSLNo"))
                w.uint32(226).string(m.WeChatSSLNo);
            if (m.WeChatSSLPwd != null && Object.hasOwnProperty.call(m, "WeChatSSLPwd"))
                w.uint32(234).string(m.WeChatSSLPwd);
            if (m.WeChatSSLFileID != null && Object.hasOwnProperty.call(m, "WeChatSSLFileID"))
                w.uint32(242).string(m.WeChatSSLFileID);
            if (m.WeChatCert != null && Object.hasOwnProperty.call(m, "WeChatCert"))
                w.uint32(250).string(m.WeChatCert);
            if (m.WeChatApiV3Key != null && Object.hasOwnProperty.call(m, "WeChatApiV3Key"))
                w.uint32(258).string(m.WeChatApiV3Key);
            if (m.WeChatApiV3No != null && Object.hasOwnProperty.call(m, "WeChatApiV3No"))
                w.uint32(266).string(m.WeChatApiV3No);
            if (m.WeChatApiV3Cert != null && Object.hasOwnProperty.call(m, "WeChatApiV3Cert"))
                w.uint32(274).string(m.WeChatApiV3Cert);
            if (m.WeChatMinRate != null && Object.hasOwnProperty.call(m, "WeChatMinRate"))
                w.uint32(280).int64(m.WeChatMinRate);
            if (m.ZFBPayMode != null && Object.hasOwnProperty.call(m, "ZFBPayMode"))
                w.uint32(288).int32(m.ZFBPayMode);
            if (m.ZFBPID != null && Object.hasOwnProperty.call(m, "ZFBPID"))
                w.uint32(298).string(m.ZFBPID);
            if (m.ZFBAppID != null && Object.hasOwnProperty.call(m, "ZFBAppID"))
                w.uint32(306).string(m.ZFBAppID);
            if (m.ZFBSignType != null && Object.hasOwnProperty.call(m, "ZFBSignType"))
                w.uint32(314).string(m.ZFBSignType);
            if (m.ZFBAESKey != null && Object.hasOwnProperty.call(m, "ZFBAESKey"))
                w.uint32(322).string(m.ZFBAESKey);
            if (m.ZFBMinRate != null && Object.hasOwnProperty.call(m, "ZFBMinRate"))
                w.uint32(328).int64(m.ZFBMinRate);
            if (m.ZFBPrvCert != null && Object.hasOwnProperty.call(m, "ZFBPrvCert"))
                w.uint32(338).string(m.ZFBPrvCert);
            if (m.ZFBPubCert != null && Object.hasOwnProperty.call(m, "ZFBPubCert"))
                w.uint32(346).string(m.ZFBPubCert);
            if (m.Notes != null && Object.hasOwnProperty.call(m, "Notes"))
                w.uint32(354).string(m.Notes);
            if (m.CreateTime != null && Object.hasOwnProperty.call(m, "CreateTime"))
                w.uint32(360).int64(m.CreateTime);
            if (m.CreaterID != null && Object.hasOwnProperty.call(m, "CreaterID"))
                w.uint32(368).uint64(m.CreaterID);
            if (m.UpdateTime != null && Object.hasOwnProperty.call(m, "UpdateTime"))
                w.uint32(376).int64(m.UpdateTime);
            if (m.UpdaterID != null && Object.hasOwnProperty.call(m, "UpdaterID"))
                w.uint32(384).uint64(m.UpdaterID);
            if (m.Estate != null && Object.hasOwnProperty.call(m, "Estate"))
                w.uint32(392).int32(m.Estate);
            if (m.ZFBGatewayHost != null && Object.hasOwnProperty.call(m, "ZFBGatewayHost"))
                w.uint32(402).string(m.ZFBGatewayHost);
            if (m.ZFBNotifyURL != null && Object.hasOwnProperty.call(m, "ZFBNotifyURL"))
                w.uint32(410).string(m.ZFBNotifyURL);
            if (m.ZFBAuthRedirectURL != null && Object.hasOwnProperty.call(m, "ZFBAuthRedirectURL"))
                w.uint32(418).string(m.ZFBAuthRedirectURL);
            if (m.IsPermGroup != null && Object.hasOwnProperty.call(m, "IsPermGroup"))
                w.uint32(424).int32(m.IsPermGroup);
            if (m.IsPermAgency != null && Object.hasOwnProperty.call(m, "IsPermAgency"))
                w.uint32(432).int32(m.IsPermAgency);
            if (m.IsPermApply != null && Object.hasOwnProperty.call(m, "IsPermApply"))
                w.uint32(440).int32(m.IsPermApply);
            if (m.IsPermWxapply != null && Object.hasOwnProperty.call(m, "IsPermWxapply"))
                w.uint32(448).int32(m.IsPermWxapply);
            if (m.IsPermZFBApply != null && Object.hasOwnProperty.call(m, "IsPermZFBApply"))
                w.uint32(456).int32(m.IsPermZFBApply);
            if (m.IsDPAgency != null && Object.hasOwnProperty.call(m, "IsDPAgency"))
                w.uint32(464).int32(m.IsDPAgency);
            return w;
        };

        Agent.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.Agent();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        m.ID = r.uint64();
                        break;
                    }
                    case 2: {
                        m.Name = r.string();
                        break;
                    }
                    case 3: {
                        m.Category = r.int32();
                        break;
                    }
                    case 4: {
                        m.AdminID = r.uint64();
                        break;
                    }
                    case 5: {
                        m.CertType = r.int32();
                        break;
                    }
                    case 6: {
                        m.CertName = r.string();
                        break;
                    }
                    case 7: {
                        m.CertNo = r.string();
                        break;
                    }
                    case 8: {
                        m.Phone = r.string();
                        break;
                    }
                    case 9: {
                        m.Email = r.string();
                        break;
                    }
                    case 10: {
                        m.ProvinceID = r.int32();
                        break;
                    }
                    case 11: {
                        m.CityID = r.int32();
                        break;
                    }
                    case 12: {
                        m.AreaName = r.string();
                        break;
                    }
                    case 13: {
                        m.Address = r.string();
                        break;
                    }
                    case 14: {
                        m.BankCategory = r.int32();
                        break;
                    }
                    case 15: {
                        m.BankCategoryName = r.string();
                        break;
                    }
                    case 16: {
                        m.BankProvinceID = r.int32();
                        break;
                    }
                    case 17: {
                        m.BankCityID = r.int32();
                        break;
                    }
                    case 18: {
                        m.BankAreaName = r.string();
                        break;
                    }
                    case 19: {
                        m.BankAccName = r.string();
                        break;
                    }
                    case 20: {
                        m.BankAccNo = r.string();
                        break;
                    }
                    case 21: {
                        m.ProfitAmountRate = r.int64();
                        break;
                    }
                    case 22: {
                        m.ProfitAmountMin = r.int64();
                        break;
                    }
                    case 23: {
                        m.ProfitCountRate = r.int64();
                        break;
                    }
                    case 24: {
                        m.ProfitCountMin = r.int64();
                        break;
                    }
                    case 25: {
                        m.WeChatPayMode = r.int32();
                        break;
                    }
                    case 26: {
                        m.WeChatMchID = r.string();
                        break;
                    }
                    case 27: {
                        m.WeChatMchKey = r.string();
                        break;
                    }
                    case 28: {
                        m.WeChatSSLNo = r.string();
                        break;
                    }
                    case 29: {
                        m.WeChatSSLPwd = r.string();
                        break;
                    }
                    case 30: {
                        m.WeChatSSLFileID = r.string();
                        break;
                    }
                    case 31: {
                        m.WeChatCert = r.string();
                        break;
                    }
                    case 32: {
                        m.WeChatApiV3Key = r.string();
                        break;
                    }
                    case 33: {
                        m.WeChatApiV3No = r.string();
                        break;
                    }
                    case 34: {
                        m.WeChatApiV3Cert = r.string();
                        break;
                    }
                    case 35: {
                        m.WeChatMinRate = r.int64();
                        break;
                    }
                    case 36: {
                        m.ZFBPayMode = r.int32();
                        break;
                    }
                    case 37: {
                        m.ZFBPID = r.string();
                        break;
                    }
                    case 38: {
                        m.ZFBAppID = r.string();
                        break;
                    }
                    case 39: {
                        m.ZFBSignType = r.string();
                        break;
                    }
                    case 40: {
                        m.ZFBAESKey = r.string();
                        break;
                    }
                    case 41: {
                        m.ZFBMinRate = r.int64();
                        break;
                    }
                    case 42: {
                        m.ZFBPrvCert = r.string();
                        break;
                    }
                    case 43: {
                        m.ZFBPubCert = r.string();
                        break;
                    }
                    case 44: {
                        m.Notes = r.string();
                        break;
                    }
                    case 45: {
                        m.CreateTime = r.int64();
                        break;
                    }
                    case 46: {
                        m.CreaterID = r.uint64();
                        break;
                    }
                    case 47: {
                        m.UpdateTime = r.int64();
                        break;
                    }
                    case 48: {
                        m.UpdaterID = r.uint64();
                        break;
                    }
                    case 49: {
                        m.Estate = r.int32();
                        break;
                    }
                    case 50: {
                        m.ZFBGatewayHost = r.string();
                        break;
                    }
                    case 51: {
                        m.ZFBNotifyURL = r.string();
                        break;
                    }
                    case 52: {
                        m.ZFBAuthRedirectURL = r.string();
                        break;
                    }
                    case 53: {
                        m.IsPermGroup = r.int32();
                        break;
                    }
                    case 54: {
                        m.IsPermAgency = r.int32();
                        break;
                    }
                    case 55: {
                        m.IsPermApply = r.int32();
                        break;
                    }
                    case 56: {
                        m.IsPermWxapply = r.int32();
                        break;
                    }
                    case 57: {
                        m.IsPermZFBApply = r.int32();
                        break;
                    }
                    case 58: {
                        m.IsDPAgency = r.int32();
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        Agent.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.Agent";
        };

        return Agent;
    })();

    PBEntity.Agents = (function () {

        function Agents(p) {
            this.Agents = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        Agents.prototype.Agents = $util.emptyArray;

        Agents.create = function create(properties) {
            return new Agents(properties);
        };

        Agents.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.Agents != null && m.Agents.length) {
                for (var i = 0; i < m.Agents.length; ++i)
                    $root.PBEntity.Agent.encode(m.Agents[i], w.uint32(10).fork()).ldelim();
            }
            return w;
        };

        Agents.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.Agents();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        if (!(m.Agents && m.Agents.length))
                            m.Agents = [];
                        m.Agents.push($root.PBEntity.Agent.decode(r, r.uint32()));
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        Agents.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.Agents";
        };

        return Agents;
    })();

    PBEntity.AlipayUser = (function () {

        function AlipayUser(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        AlipayUser.prototype.AliOpenID = "";
        AlipayUser.prototype.AliUnionID = "";
        AlipayUser.prototype.AliUserID = "";
        AlipayUser.prototype.UserID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        AlipayUser.prototype.NickName = "";
        AlipayUser.prototype.Sex = 0;
        AlipayUser.prototype.Province = "";
        AlipayUser.prototype.City = "";
        AlipayUser.prototype.Country = "";
        AlipayUser.prototype.HeadImgURL = "";
        AlipayUser.prototype.HeadImgDownloadState = 0;
        AlipayUser.prototype.AccessToken = "";
        AlipayUser.prototype.ExpiresIn = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        AlipayUser.prototype.RefreshToken = "";
        AlipayUser.prototype.ReExpiresIn = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        AlipayUser.prototype.NaoCount = 0;
        AlipayUser.prototype.NsoCount = 0;
        AlipayUser.prototype.NfoCount = 0;
        AlipayUser.prototype.AuthStart = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        AlipayUser.prototype.UpdateTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        AlipayUser.prototype.UpdaterID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        AlipayUser.prototype.Estate = 0;

        AlipayUser.create = function create(properties) {
            return new AlipayUser(properties);
        };

        AlipayUser.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.AliOpenID != null && Object.hasOwnProperty.call(m, "AliOpenID"))
                w.uint32(10).string(m.AliOpenID);
            if (m.AliUnionID != null && Object.hasOwnProperty.call(m, "AliUnionID"))
                w.uint32(18).string(m.AliUnionID);
            if (m.AliUserID != null && Object.hasOwnProperty.call(m, "AliUserID"))
                w.uint32(26).string(m.AliUserID);
            if (m.UserID != null && Object.hasOwnProperty.call(m, "UserID"))
                w.uint32(32).uint64(m.UserID);
            if (m.NickName != null && Object.hasOwnProperty.call(m, "NickName"))
                w.uint32(42).string(m.NickName);
            if (m.Sex != null && Object.hasOwnProperty.call(m, "Sex"))
                w.uint32(48).int32(m.Sex);
            if (m.Province != null && Object.hasOwnProperty.call(m, "Province"))
                w.uint32(58).string(m.Province);
            if (m.City != null && Object.hasOwnProperty.call(m, "City"))
                w.uint32(66).string(m.City);
            if (m.Country != null && Object.hasOwnProperty.call(m, "Country"))
                w.uint32(74).string(m.Country);
            if (m.HeadImgURL != null && Object.hasOwnProperty.call(m, "HeadImgURL"))
                w.uint32(82).string(m.HeadImgURL);
            if (m.HeadImgDownloadState != null && Object.hasOwnProperty.call(m, "HeadImgDownloadState"))
                w.uint32(88).int32(m.HeadImgDownloadState);
            if (m.AccessToken != null && Object.hasOwnProperty.call(m, "AccessToken"))
                w.uint32(98).string(m.AccessToken);
            if (m.ExpiresIn != null && Object.hasOwnProperty.call(m, "ExpiresIn"))
                w.uint32(104).int64(m.ExpiresIn);
            if (m.RefreshToken != null && Object.hasOwnProperty.call(m, "RefreshToken"))
                w.uint32(114).string(m.RefreshToken);
            if (m.ReExpiresIn != null && Object.hasOwnProperty.call(m, "ReExpiresIn"))
                w.uint32(120).int64(m.ReExpiresIn);
            if (m.NaoCount != null && Object.hasOwnProperty.call(m, "NaoCount"))
                w.uint32(128).int32(m.NaoCount);
            if (m.NsoCount != null && Object.hasOwnProperty.call(m, "NsoCount"))
                w.uint32(136).int32(m.NsoCount);
            if (m.NfoCount != null && Object.hasOwnProperty.call(m, "NfoCount"))
                w.uint32(144).int32(m.NfoCount);
            if (m.AuthStart != null && Object.hasOwnProperty.call(m, "AuthStart"))
                w.uint32(152).int64(m.AuthStart);
            if (m.UpdateTime != null && Object.hasOwnProperty.call(m, "UpdateTime"))
                w.uint32(160).int64(m.UpdateTime);
            if (m.UpdaterID != null && Object.hasOwnProperty.call(m, "UpdaterID"))
                w.uint32(168).uint64(m.UpdaterID);
            if (m.Estate != null && Object.hasOwnProperty.call(m, "Estate"))
                w.uint32(176).int32(m.Estate);
            return w;
        };

        AlipayUser.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.AlipayUser();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        m.AliOpenID = r.string();
                        break;
                    }
                    case 2: {
                        m.AliUnionID = r.string();
                        break;
                    }
                    case 3: {
                        m.AliUserID = r.string();
                        break;
                    }
                    case 4: {
                        m.UserID = r.uint64();
                        break;
                    }
                    case 5: {
                        m.NickName = r.string();
                        break;
                    }
                    case 6: {
                        m.Sex = r.int32();
                        break;
                    }
                    case 7: {
                        m.Province = r.string();
                        break;
                    }
                    case 8: {
                        m.City = r.string();
                        break;
                    }
                    case 9: {
                        m.Country = r.string();
                        break;
                    }
                    case 10: {
                        m.HeadImgURL = r.string();
                        break;
                    }
                    case 11: {
                        m.HeadImgDownloadState = r.int32();
                        break;
                    }
                    case 12: {
                        m.AccessToken = r.string();
                        break;
                    }
                    case 13: {
                        m.ExpiresIn = r.int64();
                        break;
                    }
                    case 14: {
                        m.RefreshToken = r.string();
                        break;
                    }
                    case 15: {
                        m.ReExpiresIn = r.int64();
                        break;
                    }
                    case 16: {
                        m.NaoCount = r.int32();
                        break;
                    }
                    case 17: {
                        m.NsoCount = r.int32();
                        break;
                    }
                    case 18: {
                        m.NfoCount = r.int32();
                        break;
                    }
                    case 19: {
                        m.AuthStart = r.int64();
                        break;
                    }
                    case 20: {
                        m.UpdateTime = r.int64();
                        break;
                    }
                    case 21: {
                        m.UpdaterID = r.uint64();
                        break;
                    }
                    case 22: {
                        m.Estate = r.int32();
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        AlipayUser.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.AlipayUser";
        };

        return AlipayUser;
    })();

    PBEntity.AlipayUsers = (function () {

        function AlipayUsers(p) {
            this.AlipayUsers = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        AlipayUsers.prototype.AlipayUsers = $util.emptyArray;

        AlipayUsers.create = function create(properties) {
            return new AlipayUsers(properties);
        };

        AlipayUsers.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.AlipayUsers != null && m.AlipayUsers.length) {
                for (var i = 0; i < m.AlipayUsers.length; ++i)
                    $root.PBEntity.AlipayUser.encode(m.AlipayUsers[i], w.uint32(10).fork()).ldelim();
            }
            return w;
        };

        AlipayUsers.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.AlipayUsers();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        if (!(m.AlipayUsers && m.AlipayUsers.length))
                            m.AlipayUsers = [];
                        m.AlipayUsers.push($root.PBEntity.AlipayUser.decode(r, r.uint32()));
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        AlipayUsers.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.AlipayUsers";
        };

        return AlipayUsers;
    })();

    PBEntity.Area = (function () {

        function Area(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        Area.prototype.ID = 0;
        Area.prototype.Name = "";
        Area.prototype.Code = "";
        Area.prototype.Cate = 0;
        Area.prototype.ParentID = 0;
        Area.prototype.Weight = 0;
        Area.prototype.FullName = "";
        Area.prototype.Priority = 0;
        Area.prototype.IsSelect = 0;
        Area.prototype.CreateTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Area.prototype.UpdateTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Area.prototype.Estate = 0;
        Area.prototype.DefaultParentID = 0;
        Area.prototype.AreaCode = "";
        Area.prototype.IsDD = 0;

        Area.create = function create(properties) {
            return new Area(properties);
        };

        Area.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.ID != null && Object.hasOwnProperty.call(m, "ID"))
                w.uint32(8).int32(m.ID);
            if (m.Name != null && Object.hasOwnProperty.call(m, "Name"))
                w.uint32(18).string(m.Name);
            if (m.Code != null && Object.hasOwnProperty.call(m, "Code"))
                w.uint32(26).string(m.Code);
            if (m.Cate != null && Object.hasOwnProperty.call(m, "Cate"))
                w.uint32(32).int32(m.Cate);
            if (m.ParentID != null && Object.hasOwnProperty.call(m, "ParentID"))
                w.uint32(40).int32(m.ParentID);
            if (m.Weight != null && Object.hasOwnProperty.call(m, "Weight"))
                w.uint32(48).int32(m.Weight);
            if (m.FullName != null && Object.hasOwnProperty.call(m, "FullName"))
                w.uint32(58).string(m.FullName);
            if (m.Priority != null && Object.hasOwnProperty.call(m, "Priority"))
                w.uint32(64).int32(m.Priority);
            if (m.IsSelect != null && Object.hasOwnProperty.call(m, "IsSelect"))
                w.uint32(72).int32(m.IsSelect);
            if (m.CreateTime != null && Object.hasOwnProperty.call(m, "CreateTime"))
                w.uint32(80).int64(m.CreateTime);
            if (m.UpdateTime != null && Object.hasOwnProperty.call(m, "UpdateTime"))
                w.uint32(88).int64(m.UpdateTime);
            if (m.Estate != null && Object.hasOwnProperty.call(m, "Estate"))
                w.uint32(96).int32(m.Estate);
            if (m.DefaultParentID != null && Object.hasOwnProperty.call(m, "DefaultParentID"))
                w.uint32(104).int32(m.DefaultParentID);
            if (m.AreaCode != null && Object.hasOwnProperty.call(m, "AreaCode"))
                w.uint32(114).string(m.AreaCode);
            if (m.IsDD != null && Object.hasOwnProperty.call(m, "IsDD"))
                w.uint32(120).int32(m.IsDD);
            return w;
        };

        Area.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.Area();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        m.ID = r.int32();
                        break;
                    }
                    case 2: {
                        m.Name = r.string();
                        break;
                    }
                    case 3: {
                        m.Code = r.string();
                        break;
                    }
                    case 4: {
                        m.Cate = r.int32();
                        break;
                    }
                    case 5: {
                        m.ParentID = r.int32();
                        break;
                    }
                    case 6: {
                        m.Weight = r.int32();
                        break;
                    }
                    case 7: {
                        m.FullName = r.string();
                        break;
                    }
                    case 8: {
                        m.Priority = r.int32();
                        break;
                    }
                    case 9: {
                        m.IsSelect = r.int32();
                        break;
                    }
                    case 10: {
                        m.CreateTime = r.int64();
                        break;
                    }
                    case 11: {
                        m.UpdateTime = r.int64();
                        break;
                    }
                    case 12: {
                        m.Estate = r.int32();
                        break;
                    }
                    case 13: {
                        m.DefaultParentID = r.int32();
                        break;
                    }
                    case 14: {
                        m.AreaCode = r.string();
                        break;
                    }
                    case 15: {
                        m.IsDD = r.int32();
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        Area.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.Area";
        };

        return Area;
    })();

    PBEntity.Areas = (function () {

        function Areas(p) {
            this.Areas = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        Areas.prototype.Areas = $util.emptyArray;

        Areas.create = function create(properties) {
            return new Areas(properties);
        };

        Areas.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.Areas != null && m.Areas.length) {
                for (var i = 0; i < m.Areas.length; ++i)
                    $root.PBEntity.Area.encode(m.Areas[i], w.uint32(10).fork()).ldelim();
            }
            return w;
        };

        Areas.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.Areas();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        if (!(m.Areas && m.Areas.length))
                            m.Areas = [];
                        m.Areas.push($root.PBEntity.Area.decode(r, r.uint32()));
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        Areas.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.Areas";
        };

        return Areas;
    })();

    PBEntity.AuthCode = (function () {

        function AuthCode(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        AuthCode.prototype.AuthCodeID = "";
        AuthCode.prototype.MchID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        AuthCode.prototype.UserID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        AuthCode.prototype.Category = 0;
        AuthCode.prototype.AuthUserID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        AuthCode.prototype.AuthResult = 0;
        AuthCode.prototype.AuthTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        AuthCode.prototype.AuthIP = "";
        AuthCode.prototype.Notes = "";
        AuthCode.prototype.CanUseTime = 0;
        AuthCode.prototype.Expires = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        AuthCode.prototype.CreateTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        AuthCode.prototype.CreaterID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        AuthCode.prototype.UpdateTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        AuthCode.prototype.UpdaterID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        AuthCode.prototype.Estate = 0;

        AuthCode.create = function create(properties) {
            return new AuthCode(properties);
        };

        AuthCode.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.AuthCodeID != null && Object.hasOwnProperty.call(m, "AuthCodeID"))
                w.uint32(10).string(m.AuthCodeID);
            if (m.MchID != null && Object.hasOwnProperty.call(m, "MchID"))
                w.uint32(16).uint64(m.MchID);
            if (m.UserID != null && Object.hasOwnProperty.call(m, "UserID"))
                w.uint32(24).uint64(m.UserID);
            if (m.Category != null && Object.hasOwnProperty.call(m, "Category"))
                w.uint32(32).int32(m.Category);
            if (m.AuthUserID != null && Object.hasOwnProperty.call(m, "AuthUserID"))
                w.uint32(40).uint64(m.AuthUserID);
            if (m.AuthResult != null && Object.hasOwnProperty.call(m, "AuthResult"))
                w.uint32(48).int32(m.AuthResult);
            if (m.AuthTime != null && Object.hasOwnProperty.call(m, "AuthTime"))
                w.uint32(56).int64(m.AuthTime);
            if (m.AuthIP != null && Object.hasOwnProperty.call(m, "AuthIP"))
                w.uint32(66).string(m.AuthIP);
            if (m.Notes != null && Object.hasOwnProperty.call(m, "Notes"))
                w.uint32(74).string(m.Notes);
            if (m.CanUseTime != null && Object.hasOwnProperty.call(m, "CanUseTime"))
                w.uint32(80).int32(m.CanUseTime);
            if (m.Expires != null && Object.hasOwnProperty.call(m, "Expires"))
                w.uint32(88).int64(m.Expires);
            if (m.CreateTime != null && Object.hasOwnProperty.call(m, "CreateTime"))
                w.uint32(96).int64(m.CreateTime);
            if (m.CreaterID != null && Object.hasOwnProperty.call(m, "CreaterID"))
                w.uint32(104).uint64(m.CreaterID);
            if (m.UpdateTime != null && Object.hasOwnProperty.call(m, "UpdateTime"))
                w.uint32(112).int64(m.UpdateTime);
            if (m.UpdaterID != null && Object.hasOwnProperty.call(m, "UpdaterID"))
                w.uint32(120).uint64(m.UpdaterID);
            if (m.Estate != null && Object.hasOwnProperty.call(m, "Estate"))
                w.uint32(128).int32(m.Estate);
            return w;
        };

        AuthCode.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.AuthCode();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        m.AuthCodeID = r.string();
                        break;
                    }
                    case 2: {
                        m.MchID = r.uint64();
                        break;
                    }
                    case 3: {
                        m.UserID = r.uint64();
                        break;
                    }
                    case 4: {
                        m.Category = r.int32();
                        break;
                    }
                    case 5: {
                        m.AuthUserID = r.uint64();
                        break;
                    }
                    case 6: {
                        m.AuthResult = r.int32();
                        break;
                    }
                    case 7: {
                        m.AuthTime = r.int64();
                        break;
                    }
                    case 8: {
                        m.AuthIP = r.string();
                        break;
                    }
                    case 9: {
                        m.Notes = r.string();
                        break;
                    }
                    case 10: {
                        m.CanUseTime = r.int32();
                        break;
                    }
                    case 11: {
                        m.Expires = r.int64();
                        break;
                    }
                    case 12: {
                        m.CreateTime = r.int64();
                        break;
                    }
                    case 13: {
                        m.CreaterID = r.uint64();
                        break;
                    }
                    case 14: {
                        m.UpdateTime = r.int64();
                        break;
                    }
                    case 15: {
                        m.UpdaterID = r.uint64();
                        break;
                    }
                    case 16: {
                        m.Estate = r.int32();
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        AuthCode.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.AuthCode";
        };

        return AuthCode;
    })();

    PBEntity.AuthCodes = (function () {

        function AuthCodes(p) {
            this.AuthCodes = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        AuthCodes.prototype.AuthCodes = $util.emptyArray;

        AuthCodes.create = function create(properties) {
            return new AuthCodes(properties);
        };

        AuthCodes.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.AuthCodes != null && m.AuthCodes.length) {
                for (var i = 0; i < m.AuthCodes.length; ++i)
                    $root.PBEntity.AuthCode.encode(m.AuthCodes[i], w.uint32(10).fork()).ldelim();
            }
            return w;
        };

        AuthCodes.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.AuthCodes();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        if (!(m.AuthCodes && m.AuthCodes.length))
                            m.AuthCodes = [];
                        m.AuthCodes.push($root.PBEntity.AuthCode.decode(r, r.uint32()));
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        AuthCodes.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.AuthCodes";
        };

        return AuthCodes;
    })();

    PBEntity.BankConfig = (function () {

        function BankConfig(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        BankConfig.prototype.BankID = 0;
        BankConfig.prototype.BankName = "";
        BankConfig.prototype.IsChkPersLen = 0;
        BankConfig.prototype.PersLen = "";
        BankConfig.prototype.IsChkPubLen = 0;
        BankConfig.prototype.PubLen = "";
        BankConfig.prototype.IsInpNamq = 0;
        BankConfig.prototype.IsActive = 0;

        BankConfig.create = function create(properties) {
            return new BankConfig(properties);
        };

        BankConfig.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.BankID != null && Object.hasOwnProperty.call(m, "BankID"))
                w.uint32(8).int32(m.BankID);
            if (m.BankName != null && Object.hasOwnProperty.call(m, "BankName"))
                w.uint32(18).string(m.BankName);
            if (m.IsChkPersLen != null && Object.hasOwnProperty.call(m, "IsChkPersLen"))
                w.uint32(24).int32(m.IsChkPersLen);
            if (m.PersLen != null && Object.hasOwnProperty.call(m, "PersLen"))
                w.uint32(34).string(m.PersLen);
            if (m.IsChkPubLen != null && Object.hasOwnProperty.call(m, "IsChkPubLen"))
                w.uint32(40).int32(m.IsChkPubLen);
            if (m.PubLen != null && Object.hasOwnProperty.call(m, "PubLen"))
                w.uint32(50).string(m.PubLen);
            if (m.IsInpNamq != null && Object.hasOwnProperty.call(m, "IsInpNamq"))
                w.uint32(56).int32(m.IsInpNamq);
            if (m.IsActive != null && Object.hasOwnProperty.call(m, "IsActive"))
                w.uint32(64).int32(m.IsActive);
            return w;
        };

        BankConfig.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.BankConfig();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        m.BankID = r.int32();
                        break;
                    }
                    case 2: {
                        m.BankName = r.string();
                        break;
                    }
                    case 3: {
                        m.IsChkPersLen = r.int32();
                        break;
                    }
                    case 4: {
                        m.PersLen = r.string();
                        break;
                    }
                    case 5: {
                        m.IsChkPubLen = r.int32();
                        break;
                    }
                    case 6: {
                        m.PubLen = r.string();
                        break;
                    }
                    case 7: {
                        m.IsInpNamq = r.int32();
                        break;
                    }
                    case 8: {
                        m.IsActive = r.int32();
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        BankConfig.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.BankConfig";
        };

        return BankConfig;
    })();

    PBEntity.BankConfigs = (function () {

        function BankConfigs(p) {
            this.BankConfigs = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        BankConfigs.prototype.BankConfigs = $util.emptyArray;

        BankConfigs.create = function create(properties) {
            return new BankConfigs(properties);
        };

        BankConfigs.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.BankConfigs != null && m.BankConfigs.length) {
                for (var i = 0; i < m.BankConfigs.length; ++i)
                    $root.PBEntity.BankConfig.encode(m.BankConfigs[i], w.uint32(10).fork()).ldelim();
            }
            return w;
        };

        BankConfigs.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.BankConfigs();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        if (!(m.BankConfigs && m.BankConfigs.length))
                            m.BankConfigs = [];
                        m.BankConfigs.push($root.PBEntity.BankConfig.decode(r, r.uint32()));
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        BankConfigs.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.BankConfigs";
        };

        return BankConfigs;
    })();

    PBEntity.Cart = (function () {

        function Cart(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        Cart.prototype.CartID = "";
        Cart.prototype.MchID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        Cart.prototype.UserID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        Cart.prototype.ReID = "";
        Cart.prototype.SalesCate = 0;
        Cart.prototype.GoodsID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        Cart.prototype.Name1 = "";
        Cart.prototype.Name2 = "";
        Cart.prototype.Name3 = "";
        Cart.prototype.SkuID = "";
        Cart.prototype.SpecsID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        Cart.prototype.OptID1 = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        Cart.prototype.OptID2 = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        Cart.prototype.OptID3 = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        Cart.prototype.GoodsImg = "";
        Cart.prototype.IsMain = 0;
        Cart.prototype.IsVal = 0;
        Cart.prototype.IsAdjPrice = 0;
        Cart.prototype.Price = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Cart.prototype.VIPPrice = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Cart.prototype.BaseQty = 0;
        Cart.prototype.Quantity = 0;
        Cart.prototype.BelongCID = "";
        Cart.prototype.GsmOptID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        Cart.prototype.GsmID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        Cart.prototype.SideDishCount = 0;
        Cart.prototype.SideDishPrice = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Cart.prototype.VIPSideDishPrice = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Cart.prototype.TaxablePrice = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Cart.prototype.IsTax = 0;
        Cart.prototype.TaxAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Cart.prototype.IsSF = 0;
        Cart.prototype.SFAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Cart.prototype.BatchID = "";
        Cart.prototype.IsSelect = 0;
        Cart.prototype.CreateTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Cart.prototype.CreaterID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        Cart.prototype.UpdateTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Cart.prototype.UpdaterID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        Cart.prototype.Estate = 0;

        Cart.create = function create(properties) {
            return new Cart(properties);
        };

        Cart.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.CartID != null && Object.hasOwnProperty.call(m, "CartID"))
                w.uint32(10).string(m.CartID);
            if (m.MchID != null && Object.hasOwnProperty.call(m, "MchID"))
                w.uint32(16).uint64(m.MchID);
            if (m.UserID != null && Object.hasOwnProperty.call(m, "UserID"))
                w.uint32(24).uint64(m.UserID);
            if (m.ReID != null && Object.hasOwnProperty.call(m, "ReID"))
                w.uint32(34).string(m.ReID);
            if (m.SalesCate != null && Object.hasOwnProperty.call(m, "SalesCate"))
                w.uint32(40).int32(m.SalesCate);
            if (m.GoodsID != null && Object.hasOwnProperty.call(m, "GoodsID"))
                w.uint32(48).uint64(m.GoodsID);
            if (m.Name1 != null && Object.hasOwnProperty.call(m, "Name1"))
                w.uint32(58).string(m.Name1);
            if (m.Name2 != null && Object.hasOwnProperty.call(m, "Name2"))
                w.uint32(66).string(m.Name2);
            if (m.Name3 != null && Object.hasOwnProperty.call(m, "Name3"))
                w.uint32(74).string(m.Name3);
            if (m.SkuID != null && Object.hasOwnProperty.call(m, "SkuID"))
                w.uint32(82).string(m.SkuID);
            if (m.SpecsID != null && Object.hasOwnProperty.call(m, "SpecsID"))
                w.uint32(88).uint64(m.SpecsID);
            if (m.OptID1 != null && Object.hasOwnProperty.call(m, "OptID1"))
                w.uint32(96).uint64(m.OptID1);
            if (m.OptID2 != null && Object.hasOwnProperty.call(m, "OptID2"))
                w.uint32(104).uint64(m.OptID2);
            if (m.OptID3 != null && Object.hasOwnProperty.call(m, "OptID3"))
                w.uint32(112).uint64(m.OptID3);
            if (m.GoodsImg != null && Object.hasOwnProperty.call(m, "GoodsImg"))
                w.uint32(122).string(m.GoodsImg);
            if (m.IsMain != null && Object.hasOwnProperty.call(m, "IsMain"))
                w.uint32(128).int32(m.IsMain);
            if (m.IsVal != null && Object.hasOwnProperty.call(m, "IsVal"))
                w.uint32(136).int32(m.IsVal);
            if (m.IsAdjPrice != null && Object.hasOwnProperty.call(m, "IsAdjPrice"))
                w.uint32(144).int32(m.IsAdjPrice);
            if (m.Price != null && Object.hasOwnProperty.call(m, "Price"))
                w.uint32(152).int64(m.Price);
            if (m.VIPPrice != null && Object.hasOwnProperty.call(m, "VIPPrice"))
                w.uint32(160).int64(m.VIPPrice);
            if (m.BaseQty != null && Object.hasOwnProperty.call(m, "BaseQty"))
                w.uint32(169).double(m.BaseQty);
            if (m.Quantity != null && Object.hasOwnProperty.call(m, "Quantity"))
                w.uint32(177).double(m.Quantity);
            if (m.BelongCID != null && Object.hasOwnProperty.call(m, "BelongCID"))
                w.uint32(186).string(m.BelongCID);
            if (m.GsmOptID != null && Object.hasOwnProperty.call(m, "GsmOptID"))
                w.uint32(192).uint64(m.GsmOptID);
            if (m.GsmID != null && Object.hasOwnProperty.call(m, "GsmID"))
                w.uint32(200).uint64(m.GsmID);
            if (m.SideDishCount != null && Object.hasOwnProperty.call(m, "SideDishCount"))
                w.uint32(208).int32(m.SideDishCount);
            if (m.SideDishPrice != null && Object.hasOwnProperty.call(m, "SideDishPrice"))
                w.uint32(216).int64(m.SideDishPrice);
            if (m.VIPSideDishPrice != null && Object.hasOwnProperty.call(m, "VIPSideDishPrice"))
                w.uint32(224).int64(m.VIPSideDishPrice);
            if (m.TaxablePrice != null && Object.hasOwnProperty.call(m, "TaxablePrice"))
                w.uint32(232).int64(m.TaxablePrice);
            if (m.IsTax != null && Object.hasOwnProperty.call(m, "IsTax"))
                w.uint32(240).int32(m.IsTax);
            if (m.TaxAmt != null && Object.hasOwnProperty.call(m, "TaxAmt"))
                w.uint32(248).int64(m.TaxAmt);
            if (m.IsSF != null && Object.hasOwnProperty.call(m, "IsSF"))
                w.uint32(256).int32(m.IsSF);
            if (m.SFAmt != null && Object.hasOwnProperty.call(m, "SFAmt"))
                w.uint32(264).int64(m.SFAmt);
            if (m.BatchID != null && Object.hasOwnProperty.call(m, "BatchID"))
                w.uint32(274).string(m.BatchID);
            if (m.IsSelect != null && Object.hasOwnProperty.call(m, "IsSelect"))
                w.uint32(280).int32(m.IsSelect);
            if (m.CreateTime != null && Object.hasOwnProperty.call(m, "CreateTime"))
                w.uint32(288).int64(m.CreateTime);
            if (m.CreaterID != null && Object.hasOwnProperty.call(m, "CreaterID"))
                w.uint32(296).uint64(m.CreaterID);
            if (m.UpdateTime != null && Object.hasOwnProperty.call(m, "UpdateTime"))
                w.uint32(304).int64(m.UpdateTime);
            if (m.UpdaterID != null && Object.hasOwnProperty.call(m, "UpdaterID"))
                w.uint32(312).uint64(m.UpdaterID);
            if (m.Estate != null && Object.hasOwnProperty.call(m, "Estate"))
                w.uint32(320).int32(m.Estate);
            return w;
        };

        Cart.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.Cart();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        m.CartID = r.string();
                        break;
                    }
                    case 2: {
                        m.MchID = r.uint64();
                        break;
                    }
                    case 3: {
                        m.UserID = r.uint64();
                        break;
                    }
                    case 4: {
                        m.ReID = r.string();
                        break;
                    }
                    case 5: {
                        m.SalesCate = r.int32();
                        break;
                    }
                    case 6: {
                        m.GoodsID = r.uint64();
                        break;
                    }
                    case 7: {
                        m.Name1 = r.string();
                        break;
                    }
                    case 8: {
                        m.Name2 = r.string();
                        break;
                    }
                    case 9: {
                        m.Name3 = r.string();
                        break;
                    }
                    case 10: {
                        m.SkuID = r.string();
                        break;
                    }
                    case 11: {
                        m.SpecsID = r.uint64();
                        break;
                    }
                    case 12: {
                        m.OptID1 = r.uint64();
                        break;
                    }
                    case 13: {
                        m.OptID2 = r.uint64();
                        break;
                    }
                    case 14: {
                        m.OptID3 = r.uint64();
                        break;
                    }
                    case 15: {
                        m.GoodsImg = r.string();
                        break;
                    }
                    case 16: {
                        m.IsMain = r.int32();
                        break;
                    }
                    case 17: {
                        m.IsVal = r.int32();
                        break;
                    }
                    case 18: {
                        m.IsAdjPrice = r.int32();
                        break;
                    }
                    case 19: {
                        m.Price = r.int64();
                        break;
                    }
                    case 20: {
                        m.VIPPrice = r.int64();
                        break;
                    }
                    case 21: {
                        m.BaseQty = r.double();
                        break;
                    }
                    case 22: {
                        m.Quantity = r.double();
                        break;
                    }
                    case 23: {
                        m.BelongCID = r.string();
                        break;
                    }
                    case 24: {
                        m.GsmOptID = r.uint64();
                        break;
                    }
                    case 25: {
                        m.GsmID = r.uint64();
                        break;
                    }
                    case 26: {
                        m.SideDishCount = r.int32();
                        break;
                    }
                    case 27: {
                        m.SideDishPrice = r.int64();
                        break;
                    }
                    case 28: {
                        m.VIPSideDishPrice = r.int64();
                        break;
                    }
                    case 29: {
                        m.TaxablePrice = r.int64();
                        break;
                    }
                    case 30: {
                        m.IsTax = r.int32();
                        break;
                    }
                    case 31: {
                        m.TaxAmt = r.int64();
                        break;
                    }
                    case 32: {
                        m.IsSF = r.int32();
                        break;
                    }
                    case 33: {
                        m.SFAmt = r.int64();
                        break;
                    }
                    case 34: {
                        m.BatchID = r.string();
                        break;
                    }
                    case 35: {
                        m.IsSelect = r.int32();
                        break;
                    }
                    case 36: {
                        m.CreateTime = r.int64();
                        break;
                    }
                    case 37: {
                        m.CreaterID = r.uint64();
                        break;
                    }
                    case 38: {
                        m.UpdateTime = r.int64();
                        break;
                    }
                    case 39: {
                        m.UpdaterID = r.uint64();
                        break;
                    }
                    case 40: {
                        m.Estate = r.int32();
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        Cart.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.Cart";
        };

        return Cart;
    })();

    PBEntity.Carts = (function () {

        function Carts(p) {
            this.Carts = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        Carts.prototype.Carts = $util.emptyArray;

        Carts.create = function create(properties) {
            return new Carts(properties);
        };

        Carts.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.Carts != null && m.Carts.length) {
                for (var i = 0; i < m.Carts.length; ++i)
                    $root.PBEntity.Cart.encode(m.Carts[i], w.uint32(10).fork()).ldelim();
            }
            return w;
        };

        Carts.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.Carts();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        if (!(m.Carts && m.Carts.length))
                            m.Carts = [];
                        m.Carts.push($root.PBEntity.Cart.decode(r, r.uint32()));
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        Carts.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.Carts";
        };

        return Carts;
    })();

    PBEntity.Coupon = (function () {

        function Coupon(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        Coupon.prototype.CopuonID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        Coupon.prototype.MchID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        Coupon.prototype.CSTitle1 = "";
        Coupon.prototype.CSTitle2 = "";
        Coupon.prototype.CSTitle3 = "";
        Coupon.prototype.CSCate = 0;
        Coupon.prototype.IsShopShow = 0;
        Coupon.prototype.IsNewUser = 0;
        Coupon.prototype.IsVIP = 0;
        Coupon.prototype.GetCate = 0;
        Coupon.prototype.LimitCountCate = 0;
        Coupon.prototype.EveryCount = 0;
        Coupon.prototype.MaxCount = 0;
        Coupon.prototype.GetCount = 0;
        Coupon.prototype.Price = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Coupon.prototype.IsShop = 0;
        Coupon.prototype.IsTakeAway = 0;
        Coupon.prototype.IsYourself = 0;
        Coupon.prototype.IsAndDis = 0;
        Coupon.prototype.IsAndPromo = 0;
        Coupon.prototype.MinAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Coupon.prototype.IsLimitGC = 0;
        Coupon.prototype.LimitGCJson = "";
        Coupon.prototype.IsLimitTime = 0;
        Coupon.prototype.STime = 0;
        Coupon.prototype.ETime = 0;
        Coupon.prototype.IsSaleAmt = 0;
        Coupon.prototype.SaleAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Coupon.prototype.IsGiveAmt = 0;
        Coupon.prototype.GiveAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Coupon.prototype.IsGivePoints = 0;
        Coupon.prototype.GivePoints = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Coupon.prototype.IsGiveGoods = 0;
        Coupon.prototype.GiveMaxGoods = 0;
        Coupon.prototype.IsBuyGoods = 0;
        Coupon.prototype.IsDis = 0;
        Coupon.prototype.DisRate = 0;
        Coupon.prototype.DisMaxAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Coupon.prototype.IsPostage = 0;
        Coupon.prototype.PostageAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Coupon.prototype.IsHalf = 0;
        Coupon.prototype.HalfMax = 0;
        Coupon.prototype.IsBofo = 0;
        Coupon.prototype.BofoMax = 0;
        Coupon.prototype.SDate = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Coupon.prototype.EDate = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Coupon.prototype.TermCate = 0;
        Coupon.prototype.TermStartCate = 0;
        Coupon.prototype.TermDay = 0;
        Coupon.prototype.TermSDate = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Coupon.prototype.TermEDate = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Coupon.prototype.CouponState = 0;
        Coupon.prototype.Notes = "";
        Coupon.prototype.GroupID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        Coupon.prototype.PublishTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Coupon.prototype.PublishUserID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        Coupon.prototype.CloseTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Coupon.prototype.CloseUserID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        Coupon.prototype.CloseCate = 0;
        Coupon.prototype.OrderValue = 0;
        Coupon.prototype.CreateTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Coupon.prototype.CreaterID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        Coupon.prototype.UpdateTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Coupon.prototype.UpdaterID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        Coupon.prototype.Estate = 0;

        Coupon.create = function create(properties) {
            return new Coupon(properties);
        };

        Coupon.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.CopuonID != null && Object.hasOwnProperty.call(m, "CopuonID"))
                w.uint32(8).uint64(m.CopuonID);
            if (m.MchID != null && Object.hasOwnProperty.call(m, "MchID"))
                w.uint32(16).uint64(m.MchID);
            if (m.CSTitle1 != null && Object.hasOwnProperty.call(m, "CSTitle1"))
                w.uint32(26).string(m.CSTitle1);
            if (m.CSTitle2 != null && Object.hasOwnProperty.call(m, "CSTitle2"))
                w.uint32(34).string(m.CSTitle2);
            if (m.CSTitle3 != null && Object.hasOwnProperty.call(m, "CSTitle3"))
                w.uint32(42).string(m.CSTitle3);
            if (m.CSCate != null && Object.hasOwnProperty.call(m, "CSCate"))
                w.uint32(48).int32(m.CSCate);
            if (m.IsShopShow != null && Object.hasOwnProperty.call(m, "IsShopShow"))
                w.uint32(56).int32(m.IsShopShow);
            if (m.IsNewUser != null && Object.hasOwnProperty.call(m, "IsNewUser"))
                w.uint32(64).int32(m.IsNewUser);
            if (m.IsVIP != null && Object.hasOwnProperty.call(m, "IsVIP"))
                w.uint32(72).int32(m.IsVIP);
            if (m.GetCate != null && Object.hasOwnProperty.call(m, "GetCate"))
                w.uint32(80).int32(m.GetCate);
            if (m.LimitCountCate != null && Object.hasOwnProperty.call(m, "LimitCountCate"))
                w.uint32(88).int32(m.LimitCountCate);
            if (m.EveryCount != null && Object.hasOwnProperty.call(m, "EveryCount"))
                w.uint32(96).int32(m.EveryCount);
            if (m.MaxCount != null && Object.hasOwnProperty.call(m, "MaxCount"))
                w.uint32(104).int32(m.MaxCount);
            if (m.GetCount != null && Object.hasOwnProperty.call(m, "GetCount"))
                w.uint32(112).int32(m.GetCount);
            if (m.Price != null && Object.hasOwnProperty.call(m, "Price"))
                w.uint32(120).int64(m.Price);
            if (m.IsShop != null && Object.hasOwnProperty.call(m, "IsShop"))
                w.uint32(128).int32(m.IsShop);
            if (m.IsTakeAway != null && Object.hasOwnProperty.call(m, "IsTakeAway"))
                w.uint32(136).int32(m.IsTakeAway);
            if (m.IsYourself != null && Object.hasOwnProperty.call(m, "IsYourself"))
                w.uint32(144).int32(m.IsYourself);
            if (m.IsAndDis != null && Object.hasOwnProperty.call(m, "IsAndDis"))
                w.uint32(152).int32(m.IsAndDis);
            if (m.IsAndPromo != null && Object.hasOwnProperty.call(m, "IsAndPromo"))
                w.uint32(160).int32(m.IsAndPromo);
            if (m.MinAmt != null && Object.hasOwnProperty.call(m, "MinAmt"))
                w.uint32(168).int64(m.MinAmt);
            if (m.IsLimitGC != null && Object.hasOwnProperty.call(m, "IsLimitGC"))
                w.uint32(176).int32(m.IsLimitGC);
            if (m.LimitGCJson != null && Object.hasOwnProperty.call(m, "LimitGCJson"))
                w.uint32(186).string(m.LimitGCJson);
            if (m.IsLimitTime != null && Object.hasOwnProperty.call(m, "IsLimitTime"))
                w.uint32(192).int32(m.IsLimitTime);
            if (m.STime != null && Object.hasOwnProperty.call(m, "STime"))
                w.uint32(201).double(m.STime);
            if (m.ETime != null && Object.hasOwnProperty.call(m, "ETime"))
                w.uint32(209).double(m.ETime);
            if (m.IsSaleAmt != null && Object.hasOwnProperty.call(m, "IsSaleAmt"))
                w.uint32(216).int32(m.IsSaleAmt);
            if (m.SaleAmt != null && Object.hasOwnProperty.call(m, "SaleAmt"))
                w.uint32(224).int64(m.SaleAmt);
            if (m.IsGiveAmt != null && Object.hasOwnProperty.call(m, "IsGiveAmt"))
                w.uint32(232).int32(m.IsGiveAmt);
            if (m.GiveAmt != null && Object.hasOwnProperty.call(m, "GiveAmt"))
                w.uint32(240).int64(m.GiveAmt);
            if (m.IsGivePoints != null && Object.hasOwnProperty.call(m, "IsGivePoints"))
                w.uint32(248).int32(m.IsGivePoints);
            if (m.GivePoints != null && Object.hasOwnProperty.call(m, "GivePoints"))
                w.uint32(256).int64(m.GivePoints);
            if (m.IsGiveGoods != null && Object.hasOwnProperty.call(m, "IsGiveGoods"))
                w.uint32(264).int32(m.IsGiveGoods);
            if (m.GiveMaxGoods != null && Object.hasOwnProperty.call(m, "GiveMaxGoods"))
                w.uint32(272).int32(m.GiveMaxGoods);
            if (m.IsBuyGoods != null && Object.hasOwnProperty.call(m, "IsBuyGoods"))
                w.uint32(280).int32(m.IsBuyGoods);
            if (m.IsDis != null && Object.hasOwnProperty.call(m, "IsDis"))
                w.uint32(288).int32(m.IsDis);
            if (m.DisRate != null && Object.hasOwnProperty.call(m, "DisRate"))
                w.uint32(296).int32(m.DisRate);
            if (m.DisMaxAmt != null && Object.hasOwnProperty.call(m, "DisMaxAmt"))
                w.uint32(304).int64(m.DisMaxAmt);
            if (m.IsPostage != null && Object.hasOwnProperty.call(m, "IsPostage"))
                w.uint32(312).int32(m.IsPostage);
            if (m.PostageAmt != null && Object.hasOwnProperty.call(m, "PostageAmt"))
                w.uint32(320).int64(m.PostageAmt);
            if (m.IsHalf != null && Object.hasOwnProperty.call(m, "IsHalf"))
                w.uint32(328).int32(m.IsHalf);
            if (m.HalfMax != null && Object.hasOwnProperty.call(m, "HalfMax"))
                w.uint32(336).int32(m.HalfMax);
            if (m.IsBofo != null && Object.hasOwnProperty.call(m, "IsBofo"))
                w.uint32(344).int32(m.IsBofo);
            if (m.BofoMax != null && Object.hasOwnProperty.call(m, "BofoMax"))
                w.uint32(352).int32(m.BofoMax);
            if (m.SDate != null && Object.hasOwnProperty.call(m, "SDate"))
                w.uint32(360).int64(m.SDate);
            if (m.EDate != null && Object.hasOwnProperty.call(m, "EDate"))
                w.uint32(368).int64(m.EDate);
            if (m.TermCate != null && Object.hasOwnProperty.call(m, "TermCate"))
                w.uint32(376).int32(m.TermCate);
            if (m.TermStartCate != null && Object.hasOwnProperty.call(m, "TermStartCate"))
                w.uint32(384).int32(m.TermStartCate);
            if (m.TermDay != null && Object.hasOwnProperty.call(m, "TermDay"))
                w.uint32(392).int32(m.TermDay);
            if (m.TermSDate != null && Object.hasOwnProperty.call(m, "TermSDate"))
                w.uint32(400).int64(m.TermSDate);
            if (m.TermEDate != null && Object.hasOwnProperty.call(m, "TermEDate"))
                w.uint32(408).int64(m.TermEDate);
            if (m.CouponState != null && Object.hasOwnProperty.call(m, "CouponState"))
                w.uint32(416).int32(m.CouponState);
            if (m.Notes != null && Object.hasOwnProperty.call(m, "Notes"))
                w.uint32(426).string(m.Notes);
            if (m.GroupID != null && Object.hasOwnProperty.call(m, "GroupID"))
                w.uint32(432).uint64(m.GroupID);
            if (m.PublishTime != null && Object.hasOwnProperty.call(m, "PublishTime"))
                w.uint32(440).int64(m.PublishTime);
            if (m.PublishUserID != null && Object.hasOwnProperty.call(m, "PublishUserID"))
                w.uint32(448).uint64(m.PublishUserID);
            if (m.CloseTime != null && Object.hasOwnProperty.call(m, "CloseTime"))
                w.uint32(456).int64(m.CloseTime);
            if (m.CloseUserID != null && Object.hasOwnProperty.call(m, "CloseUserID"))
                w.uint32(464).uint64(m.CloseUserID);
            if (m.CloseCate != null && Object.hasOwnProperty.call(m, "CloseCate"))
                w.uint32(472).int32(m.CloseCate);
            if (m.OrderValue != null && Object.hasOwnProperty.call(m, "OrderValue"))
                w.uint32(480).int32(m.OrderValue);
            if (m.CreateTime != null && Object.hasOwnProperty.call(m, "CreateTime"))
                w.uint32(488).int64(m.CreateTime);
            if (m.CreaterID != null && Object.hasOwnProperty.call(m, "CreaterID"))
                w.uint32(496).uint64(m.CreaterID);
            if (m.UpdateTime != null && Object.hasOwnProperty.call(m, "UpdateTime"))
                w.uint32(504).int64(m.UpdateTime);
            if (m.UpdaterID != null && Object.hasOwnProperty.call(m, "UpdaterID"))
                w.uint32(512).uint64(m.UpdaterID);
            if (m.Estate != null && Object.hasOwnProperty.call(m, "Estate"))
                w.uint32(520).int32(m.Estate);
            return w;
        };

        Coupon.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.Coupon();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        m.CopuonID = r.uint64();
                        break;
                    }
                    case 2: {
                        m.MchID = r.uint64();
                        break;
                    }
                    case 3: {
                        m.CSTitle1 = r.string();
                        break;
                    }
                    case 4: {
                        m.CSTitle2 = r.string();
                        break;
                    }
                    case 5: {
                        m.CSTitle3 = r.string();
                        break;
                    }
                    case 6: {
                        m.CSCate = r.int32();
                        break;
                    }
                    case 7: {
                        m.IsShopShow = r.int32();
                        break;
                    }
                    case 8: {
                        m.IsNewUser = r.int32();
                        break;
                    }
                    case 9: {
                        m.IsVIP = r.int32();
                        break;
                    }
                    case 10: {
                        m.GetCate = r.int32();
                        break;
                    }
                    case 11: {
                        m.LimitCountCate = r.int32();
                        break;
                    }
                    case 12: {
                        m.EveryCount = r.int32();
                        break;
                    }
                    case 13: {
                        m.MaxCount = r.int32();
                        break;
                    }
                    case 14: {
                        m.GetCount = r.int32();
                        break;
                    }
                    case 15: {
                        m.Price = r.int64();
                        break;
                    }
                    case 16: {
                        m.IsShop = r.int32();
                        break;
                    }
                    case 17: {
                        m.IsTakeAway = r.int32();
                        break;
                    }
                    case 18: {
                        m.IsYourself = r.int32();
                        break;
                    }
                    case 19: {
                        m.IsAndDis = r.int32();
                        break;
                    }
                    case 20: {
                        m.IsAndPromo = r.int32();
                        break;
                    }
                    case 21: {
                        m.MinAmt = r.int64();
                        break;
                    }
                    case 22: {
                        m.IsLimitGC = r.int32();
                        break;
                    }
                    case 23: {
                        m.LimitGCJson = r.string();
                        break;
                    }
                    case 24: {
                        m.IsLimitTime = r.int32();
                        break;
                    }
                    case 25: {
                        m.STime = r.double();
                        break;
                    }
                    case 26: {
                        m.ETime = r.double();
                        break;
                    }
                    case 27: {
                        m.IsSaleAmt = r.int32();
                        break;
                    }
                    case 28: {
                        m.SaleAmt = r.int64();
                        break;
                    }
                    case 29: {
                        m.IsGiveAmt = r.int32();
                        break;
                    }
                    case 30: {
                        m.GiveAmt = r.int64();
                        break;
                    }
                    case 31: {
                        m.IsGivePoints = r.int32();
                        break;
                    }
                    case 32: {
                        m.GivePoints = r.int64();
                        break;
                    }
                    case 33: {
                        m.IsGiveGoods = r.int32();
                        break;
                    }
                    case 34: {
                        m.GiveMaxGoods = r.int32();
                        break;
                    }
                    case 35: {
                        m.IsBuyGoods = r.int32();
                        break;
                    }
                    case 36: {
                        m.IsDis = r.int32();
                        break;
                    }
                    case 37: {
                        m.DisRate = r.int32();
                        break;
                    }
                    case 38: {
                        m.DisMaxAmt = r.int64();
                        break;
                    }
                    case 39: {
                        m.IsPostage = r.int32();
                        break;
                    }
                    case 40: {
                        m.PostageAmt = r.int64();
                        break;
                    }
                    case 41: {
                        m.IsHalf = r.int32();
                        break;
                    }
                    case 42: {
                        m.HalfMax = r.int32();
                        break;
                    }
                    case 43: {
                        m.IsBofo = r.int32();
                        break;
                    }
                    case 44: {
                        m.BofoMax = r.int32();
                        break;
                    }
                    case 45: {
                        m.SDate = r.int64();
                        break;
                    }
                    case 46: {
                        m.EDate = r.int64();
                        break;
                    }
                    case 47: {
                        m.TermCate = r.int32();
                        break;
                    }
                    case 48: {
                        m.TermStartCate = r.int32();
                        break;
                    }
                    case 49: {
                        m.TermDay = r.int32();
                        break;
                    }
                    case 50: {
                        m.TermSDate = r.int64();
                        break;
                    }
                    case 51: {
                        m.TermEDate = r.int64();
                        break;
                    }
                    case 52: {
                        m.CouponState = r.int32();
                        break;
                    }
                    case 53: {
                        m.Notes = r.string();
                        break;
                    }
                    case 54: {
                        m.GroupID = r.uint64();
                        break;
                    }
                    case 55: {
                        m.PublishTime = r.int64();
                        break;
                    }
                    case 56: {
                        m.PublishUserID = r.uint64();
                        break;
                    }
                    case 57: {
                        m.CloseTime = r.int64();
                        break;
                    }
                    case 58: {
                        m.CloseUserID = r.uint64();
                        break;
                    }
                    case 59: {
                        m.CloseCate = r.int32();
                        break;
                    }
                    case 60: {
                        m.OrderValue = r.int32();
                        break;
                    }
                    case 61: {
                        m.CreateTime = r.int64();
                        break;
                    }
                    case 62: {
                        m.CreaterID = r.uint64();
                        break;
                    }
                    case 63: {
                        m.UpdateTime = r.int64();
                        break;
                    }
                    case 64: {
                        m.UpdaterID = r.uint64();
                        break;
                    }
                    case 65: {
                        m.Estate = r.int32();
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        Coupon.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.Coupon";
        };

        return Coupon;
    })();

    PBEntity.Coupons = (function () {

        function Coupons(p) {
            this.Coupons = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        Coupons.prototype.Coupons = $util.emptyArray;

        Coupons.create = function create(properties) {
            return new Coupons(properties);
        };

        Coupons.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.Coupons != null && m.Coupons.length) {
                for (var i = 0; i < m.Coupons.length; ++i)
                    $root.PBEntity.Coupon.encode(m.Coupons[i], w.uint32(10).fork()).ldelim();
            }
            return w;
        };

        Coupons.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.Coupons();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        if (!(m.Coupons && m.Coupons.length))
                            m.Coupons = [];
                        m.Coupons.push($root.PBEntity.Coupon.decode(r, r.uint32()));
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        Coupons.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.Coupons";
        };

        return Coupons;
    })();

    PBEntity.CouponRecord = (function () {

        function CouponRecord(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        CouponRecord.prototype.CRecID = "";
        CouponRecord.prototype.CouponID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        CouponRecord.prototype.MchID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        CouponRecord.prototype.UserID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        CouponRecord.prototype.ReceiveCate = 0;
        CouponRecord.prototype.ReceiveTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        CouponRecord.prototype.CanSDate = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        CouponRecord.prototype.CanEDate = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        CouponRecord.prototype.UseState = 0;
        CouponRecord.prototype.UseTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        CouponRecord.prototype.ReID = "";
        CouponRecord.prototype.UseNotes = "";
        CouponRecord.prototype.OnSaleAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        CouponRecord.prototype.CSSaleAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        CouponRecord.prototype.CSIsGiveGoods = 0;
        CouponRecord.prototype.CSIsGiveAmt = 0;
        CouponRecord.prototype.CSGiveAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        CouponRecord.prototype.CSIsGivePoints = 0;
        CouponRecord.prototype.CSGivePoints = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        CouponRecord.prototype.GroupID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        CouponRecord.prototype.FromIP = "";
        CouponRecord.prototype.FromTokeID = "";
        CouponRecord.prototype.CreateTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        CouponRecord.prototype.CreaterID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        CouponRecord.prototype.UpdateTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        CouponRecord.prototype.UpdaterID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        CouponRecord.prototype.Estate = 0;

        CouponRecord.create = function create(properties) {
            return new CouponRecord(properties);
        };

        CouponRecord.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.CRecID != null && Object.hasOwnProperty.call(m, "CRecID"))
                w.uint32(10).string(m.CRecID);
            if (m.CouponID != null && Object.hasOwnProperty.call(m, "CouponID"))
                w.uint32(16).uint64(m.CouponID);
            if (m.MchID != null && Object.hasOwnProperty.call(m, "MchID"))
                w.uint32(24).uint64(m.MchID);
            if (m.UserID != null && Object.hasOwnProperty.call(m, "UserID"))
                w.uint32(32).uint64(m.UserID);
            if (m.ReceiveCate != null && Object.hasOwnProperty.call(m, "ReceiveCate"))
                w.uint32(40).int32(m.ReceiveCate);
            if (m.ReceiveTime != null && Object.hasOwnProperty.call(m, "ReceiveTime"))
                w.uint32(48).int64(m.ReceiveTime);
            if (m.CanSDate != null && Object.hasOwnProperty.call(m, "CanSDate"))
                w.uint32(56).int64(m.CanSDate);
            if (m.CanEDate != null && Object.hasOwnProperty.call(m, "CanEDate"))
                w.uint32(64).int64(m.CanEDate);
            if (m.UseState != null && Object.hasOwnProperty.call(m, "UseState"))
                w.uint32(72).int32(m.UseState);
            if (m.UseTime != null && Object.hasOwnProperty.call(m, "UseTime"))
                w.uint32(80).int64(m.UseTime);
            if (m.ReID != null && Object.hasOwnProperty.call(m, "ReID"))
                w.uint32(90).string(m.ReID);
            if (m.UseNotes != null && Object.hasOwnProperty.call(m, "UseNotes"))
                w.uint32(98).string(m.UseNotes);
            if (m.OnSaleAmt != null && Object.hasOwnProperty.call(m, "OnSaleAmt"))
                w.uint32(104).int64(m.OnSaleAmt);
            if (m.CSSaleAmt != null && Object.hasOwnProperty.call(m, "CSSaleAmt"))
                w.uint32(112).int64(m.CSSaleAmt);
            if (m.CSIsGiveGoods != null && Object.hasOwnProperty.call(m, "CSIsGiveGoods"))
                w.uint32(120).int32(m.CSIsGiveGoods);
            if (m.CSIsGiveAmt != null && Object.hasOwnProperty.call(m, "CSIsGiveAmt"))
                w.uint32(128).int32(m.CSIsGiveAmt);
            if (m.CSGiveAmt != null && Object.hasOwnProperty.call(m, "CSGiveAmt"))
                w.uint32(136).int64(m.CSGiveAmt);
            if (m.CSIsGivePoints != null && Object.hasOwnProperty.call(m, "CSIsGivePoints"))
                w.uint32(144).int32(m.CSIsGivePoints);
            if (m.CSGivePoints != null && Object.hasOwnProperty.call(m, "CSGivePoints"))
                w.uint32(152).int64(m.CSGivePoints);
            if (m.GroupID != null && Object.hasOwnProperty.call(m, "GroupID"))
                w.uint32(160).uint64(m.GroupID);
            if (m.FromIP != null && Object.hasOwnProperty.call(m, "FromIP"))
                w.uint32(170).string(m.FromIP);
            if (m.FromTokeID != null && Object.hasOwnProperty.call(m, "FromTokeID"))
                w.uint32(178).string(m.FromTokeID);
            if (m.CreateTime != null && Object.hasOwnProperty.call(m, "CreateTime"))
                w.uint32(184).int64(m.CreateTime);
            if (m.CreaterID != null && Object.hasOwnProperty.call(m, "CreaterID"))
                w.uint32(192).uint64(m.CreaterID);
            if (m.UpdateTime != null && Object.hasOwnProperty.call(m, "UpdateTime"))
                w.uint32(200).int64(m.UpdateTime);
            if (m.UpdaterID != null && Object.hasOwnProperty.call(m, "UpdaterID"))
                w.uint32(208).uint64(m.UpdaterID);
            if (m.Estate != null && Object.hasOwnProperty.call(m, "Estate"))
                w.uint32(216).int32(m.Estate);
            return w;
        };

        CouponRecord.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.CouponRecord();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        m.CRecID = r.string();
                        break;
                    }
                    case 2: {
                        m.CouponID = r.uint64();
                        break;
                    }
                    case 3: {
                        m.MchID = r.uint64();
                        break;
                    }
                    case 4: {
                        m.UserID = r.uint64();
                        break;
                    }
                    case 5: {
                        m.ReceiveCate = r.int32();
                        break;
                    }
                    case 6: {
                        m.ReceiveTime = r.int64();
                        break;
                    }
                    case 7: {
                        m.CanSDate = r.int64();
                        break;
                    }
                    case 8: {
                        m.CanEDate = r.int64();
                        break;
                    }
                    case 9: {
                        m.UseState = r.int32();
                        break;
                    }
                    case 10: {
                        m.UseTime = r.int64();
                        break;
                    }
                    case 11: {
                        m.ReID = r.string();
                        break;
                    }
                    case 12: {
                        m.UseNotes = r.string();
                        break;
                    }
                    case 13: {
                        m.OnSaleAmt = r.int64();
                        break;
                    }
                    case 14: {
                        m.CSSaleAmt = r.int64();
                        break;
                    }
                    case 15: {
                        m.CSIsGiveGoods = r.int32();
                        break;
                    }
                    case 16: {
                        m.CSIsGiveAmt = r.int32();
                        break;
                    }
                    case 17: {
                        m.CSGiveAmt = r.int64();
                        break;
                    }
                    case 18: {
                        m.CSIsGivePoints = r.int32();
                        break;
                    }
                    case 19: {
                        m.CSGivePoints = r.int64();
                        break;
                    }
                    case 20: {
                        m.GroupID = r.uint64();
                        break;
                    }
                    case 21: {
                        m.FromIP = r.string();
                        break;
                    }
                    case 22: {
                        m.FromTokeID = r.string();
                        break;
                    }
                    case 23: {
                        m.CreateTime = r.int64();
                        break;
                    }
                    case 24: {
                        m.CreaterID = r.uint64();
                        break;
                    }
                    case 25: {
                        m.UpdateTime = r.int64();
                        break;
                    }
                    case 26: {
                        m.UpdaterID = r.uint64();
                        break;
                    }
                    case 27: {
                        m.Estate = r.int32();
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        CouponRecord.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.CouponRecord";
        };

        return CouponRecord;
    })();

    PBEntity.CouponRecords = (function () {

        function CouponRecords(p) {
            this.CouponRecords = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        CouponRecords.prototype.CouponRecords = $util.emptyArray;

        CouponRecords.create = function create(properties) {
            return new CouponRecords(properties);
        };

        CouponRecords.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.CouponRecords != null && m.CouponRecords.length) {
                for (var i = 0; i < m.CouponRecords.length; ++i)
                    $root.PBEntity.CouponRecord.encode(m.CouponRecords[i], w.uint32(10).fork()).ldelim();
            }
            return w;
        };

        CouponRecords.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.CouponRecords();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        if (!(m.CouponRecords && m.CouponRecords.length))
                            m.CouponRecords = [];
                        m.CouponRecords.push($root.PBEntity.CouponRecord.decode(r, r.uint32()));
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        CouponRecords.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.CouponRecords";
        };

        return CouponRecords;
    })();

    PBEntity.DeskReserve = (function () {

        function DeskReserve(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        DeskReserve.prototype.DeskResID = "";
        DeskReserve.prototype.MchID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        DeskReserve.prototype.Category = 0;
        DeskReserve.prototype.UserID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        DeskReserve.prototype.ReservUserName = "";
        DeskReserve.prototype.Num = 0;
        DeskReserve.prototype.DeskID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        DeskReserve.prototype.DeskName1 = "";
        DeskReserve.prototype.DeskName2 = "";
        DeskReserve.prototype.DeskName3 = "";
        DeskReserve.prototype.DeskCategory = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        DeskReserve.prototype.DeskCategoryName = "";
        DeskReserve.prototype.ReservTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        DeskReserve.prototype.LinkName = "";
        DeskReserve.prototype.LinkPhone = "";
        DeskReserve.prototype.NeedToilet = 0;
        DeskReserve.prototype.NeedWindow = 0;
        DeskReserve.prototype.NeedKTV = 0;
        DeskReserve.prototype.NeedChildChair = 0;
        DeskReserve.prototype.ReservNotes = "";
        DeskReserve.prototype.IsPrpay = 0;
        DeskReserve.prototype.PrpayAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        DeskReserve.prototype.PrpayPayState = 0;
        DeskReserve.prototype.PrpayPayID = "";
        DeskReserve.prototype.PrpayPayTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        DeskReserve.prototype.PrpayUseState = 0;
        DeskReserve.prototype.KeepTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        DeskReserve.prototype.ApproveUserID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        DeskReserve.prototype.ApproveUserName = "";
        DeskReserve.prototype.ApproveTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        DeskReserve.prototype.AllocateDeskID = "";
        DeskReserve.prototype.AllocateDeskName = "";
        DeskReserve.prototype.ApproveNotes = "";
        DeskReserve.prototype.ApproveResult = 0;
        DeskReserve.prototype.CancelUserID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        DeskReserve.prototype.CancelUserName = "";
        DeskReserve.prototype.CancelTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        DeskReserve.prototype.CancelNotes = "";
        DeskReserve.prototype.ReservState = 0;
        DeskReserve.prototype.DeskUseID = "";
        DeskReserve.prototype.IsPrint = 0;
        DeskReserve.prototype.ShowSpecialOption = 0;
        DeskReserve.prototype.CreaterID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        DeskReserve.prototype.CreateTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        DeskReserve.prototype.UpdateTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        DeskReserve.prototype.UpdaterID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        DeskReserve.prototype.Estate = 0;

        DeskReserve.create = function create(properties) {
            return new DeskReserve(properties);
        };

        DeskReserve.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.DeskResID != null && Object.hasOwnProperty.call(m, "DeskResID"))
                w.uint32(10).string(m.DeskResID);
            if (m.MchID != null && Object.hasOwnProperty.call(m, "MchID"))
                w.uint32(16).uint64(m.MchID);
            if (m.Category != null && Object.hasOwnProperty.call(m, "Category"))
                w.uint32(24).int32(m.Category);
            if (m.UserID != null && Object.hasOwnProperty.call(m, "UserID"))
                w.uint32(32).uint64(m.UserID);
            if (m.ReservUserName != null && Object.hasOwnProperty.call(m, "ReservUserName"))
                w.uint32(42).string(m.ReservUserName);
            if (m.Num != null && Object.hasOwnProperty.call(m, "Num"))
                w.uint32(48).uint32(m.Num);
            if (m.DeskID != null && Object.hasOwnProperty.call(m, "DeskID"))
                w.uint32(56).uint64(m.DeskID);
            if (m.DeskName1 != null && Object.hasOwnProperty.call(m, "DeskName1"))
                w.uint32(66).string(m.DeskName1);
            if (m.DeskName2 != null && Object.hasOwnProperty.call(m, "DeskName2"))
                w.uint32(74).string(m.DeskName2);
            if (m.DeskName3 != null && Object.hasOwnProperty.call(m, "DeskName3"))
                w.uint32(82).string(m.DeskName3);
            if (m.DeskCategory != null && Object.hasOwnProperty.call(m, "DeskCategory"))
                w.uint32(88).uint64(m.DeskCategory);
            if (m.DeskCategoryName != null && Object.hasOwnProperty.call(m, "DeskCategoryName"))
                w.uint32(98).string(m.DeskCategoryName);
            if (m.ReservTime != null && Object.hasOwnProperty.call(m, "ReservTime"))
                w.uint32(104).int64(m.ReservTime);
            if (m.LinkName != null && Object.hasOwnProperty.call(m, "LinkName"))
                w.uint32(114).string(m.LinkName);
            if (m.LinkPhone != null && Object.hasOwnProperty.call(m, "LinkPhone"))
                w.uint32(122).string(m.LinkPhone);
            if (m.NeedToilet != null && Object.hasOwnProperty.call(m, "NeedToilet"))
                w.uint32(128).int32(m.NeedToilet);
            if (m.NeedWindow != null && Object.hasOwnProperty.call(m, "NeedWindow"))
                w.uint32(136).int32(m.NeedWindow);
            if (m.NeedKTV != null && Object.hasOwnProperty.call(m, "NeedKTV"))
                w.uint32(144).int32(m.NeedKTV);
            if (m.NeedChildChair != null && Object.hasOwnProperty.call(m, "NeedChildChair"))
                w.uint32(152).int32(m.NeedChildChair);
            if (m.ReservNotes != null && Object.hasOwnProperty.call(m, "ReservNotes"))
                w.uint32(162).string(m.ReservNotes);
            if (m.IsPrpay != null && Object.hasOwnProperty.call(m, "IsPrpay"))
                w.uint32(168).int32(m.IsPrpay);
            if (m.PrpayAmt != null && Object.hasOwnProperty.call(m, "PrpayAmt"))
                w.uint32(176).int64(m.PrpayAmt);
            if (m.PrpayPayState != null && Object.hasOwnProperty.call(m, "PrpayPayState"))
                w.uint32(184).int32(m.PrpayPayState);
            if (m.PrpayPayID != null && Object.hasOwnProperty.call(m, "PrpayPayID"))
                w.uint32(194).string(m.PrpayPayID);
            if (m.PrpayPayTime != null && Object.hasOwnProperty.call(m, "PrpayPayTime"))
                w.uint32(200).int64(m.PrpayPayTime);
            if (m.PrpayUseState != null && Object.hasOwnProperty.call(m, "PrpayUseState"))
                w.uint32(208).int32(m.PrpayUseState);
            if (m.KeepTime != null && Object.hasOwnProperty.call(m, "KeepTime"))
                w.uint32(216).int64(m.KeepTime);
            if (m.ApproveUserID != null && Object.hasOwnProperty.call(m, "ApproveUserID"))
                w.uint32(224).uint64(m.ApproveUserID);
            if (m.ApproveUserName != null && Object.hasOwnProperty.call(m, "ApproveUserName"))
                w.uint32(234).string(m.ApproveUserName);
            if (m.ApproveTime != null && Object.hasOwnProperty.call(m, "ApproveTime"))
                w.uint32(240).int64(m.ApproveTime);
            if (m.AllocateDeskID != null && Object.hasOwnProperty.call(m, "AllocateDeskID"))
                w.uint32(250).string(m.AllocateDeskID);
            if (m.AllocateDeskName != null && Object.hasOwnProperty.call(m, "AllocateDeskName"))
                w.uint32(258).string(m.AllocateDeskName);
            if (m.ApproveNotes != null && Object.hasOwnProperty.call(m, "ApproveNotes"))
                w.uint32(266).string(m.ApproveNotes);
            if (m.ApproveResult != null && Object.hasOwnProperty.call(m, "ApproveResult"))
                w.uint32(272).int32(m.ApproveResult);
            if (m.CancelUserID != null && Object.hasOwnProperty.call(m, "CancelUserID"))
                w.uint32(280).uint64(m.CancelUserID);
            if (m.CancelUserName != null && Object.hasOwnProperty.call(m, "CancelUserName"))
                w.uint32(290).string(m.CancelUserName);
            if (m.CancelTime != null && Object.hasOwnProperty.call(m, "CancelTime"))
                w.uint32(296).int64(m.CancelTime);
            if (m.CancelNotes != null && Object.hasOwnProperty.call(m, "CancelNotes"))
                w.uint32(306).string(m.CancelNotes);
            if (m.ReservState != null && Object.hasOwnProperty.call(m, "ReservState"))
                w.uint32(312).int32(m.ReservState);
            if (m.DeskUseID != null && Object.hasOwnProperty.call(m, "DeskUseID"))
                w.uint32(322).string(m.DeskUseID);
            if (m.IsPrint != null && Object.hasOwnProperty.call(m, "IsPrint"))
                w.uint32(328).int32(m.IsPrint);
            if (m.ShowSpecialOption != null && Object.hasOwnProperty.call(m, "ShowSpecialOption"))
                w.uint32(336).int32(m.ShowSpecialOption);
            if (m.CreaterID != null && Object.hasOwnProperty.call(m, "CreaterID"))
                w.uint32(344).uint64(m.CreaterID);
            if (m.CreateTime != null && Object.hasOwnProperty.call(m, "CreateTime"))
                w.uint32(352).int64(m.CreateTime);
            if (m.UpdateTime != null && Object.hasOwnProperty.call(m, "UpdateTime"))
                w.uint32(360).int64(m.UpdateTime);
            if (m.UpdaterID != null && Object.hasOwnProperty.call(m, "UpdaterID"))
                w.uint32(368).uint64(m.UpdaterID);
            if (m.Estate != null && Object.hasOwnProperty.call(m, "Estate"))
                w.uint32(376).int32(m.Estate);
            return w;
        };

        DeskReserve.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.DeskReserve();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        m.DeskResID = r.string();
                        break;
                    }
                    case 2: {
                        m.MchID = r.uint64();
                        break;
                    }
                    case 3: {
                        m.Category = r.int32();
                        break;
                    }
                    case 4: {
                        m.UserID = r.uint64();
                        break;
                    }
                    case 5: {
                        m.ReservUserName = r.string();
                        break;
                    }
                    case 6: {
                        m.Num = r.uint32();
                        break;
                    }
                    case 7: {
                        m.DeskID = r.uint64();
                        break;
                    }
                    case 8: {
                        m.DeskName1 = r.string();
                        break;
                    }
                    case 9: {
                        m.DeskName2 = r.string();
                        break;
                    }
                    case 10: {
                        m.DeskName3 = r.string();
                        break;
                    }
                    case 11: {
                        m.DeskCategory = r.uint64();
                        break;
                    }
                    case 12: {
                        m.DeskCategoryName = r.string();
                        break;
                    }
                    case 13: {
                        m.ReservTime = r.int64();
                        break;
                    }
                    case 14: {
                        m.LinkName = r.string();
                        break;
                    }
                    case 15: {
                        m.LinkPhone = r.string();
                        break;
                    }
                    case 16: {
                        m.NeedToilet = r.int32();
                        break;
                    }
                    case 17: {
                        m.NeedWindow = r.int32();
                        break;
                    }
                    case 18: {
                        m.NeedKTV = r.int32();
                        break;
                    }
                    case 19: {
                        m.NeedChildChair = r.int32();
                        break;
                    }
                    case 20: {
                        m.ReservNotes = r.string();
                        break;
                    }
                    case 21: {
                        m.IsPrpay = r.int32();
                        break;
                    }
                    case 22: {
                        m.PrpayAmt = r.int64();
                        break;
                    }
                    case 23: {
                        m.PrpayPayState = r.int32();
                        break;
                    }
                    case 24: {
                        m.PrpayPayID = r.string();
                        break;
                    }
                    case 25: {
                        m.PrpayPayTime = r.int64();
                        break;
                    }
                    case 26: {
                        m.PrpayUseState = r.int32();
                        break;
                    }
                    case 27: {
                        m.KeepTime = r.int64();
                        break;
                    }
                    case 28: {
                        m.ApproveUserID = r.uint64();
                        break;
                    }
                    case 29: {
                        m.ApproveUserName = r.string();
                        break;
                    }
                    case 30: {
                        m.ApproveTime = r.int64();
                        break;
                    }
                    case 31: {
                        m.AllocateDeskID = r.string();
                        break;
                    }
                    case 32: {
                        m.AllocateDeskName = r.string();
                        break;
                    }
                    case 33: {
                        m.ApproveNotes = r.string();
                        break;
                    }
                    case 34: {
                        m.ApproveResult = r.int32();
                        break;
                    }
                    case 35: {
                        m.CancelUserID = r.uint64();
                        break;
                    }
                    case 36: {
                        m.CancelUserName = r.string();
                        break;
                    }
                    case 37: {
                        m.CancelTime = r.int64();
                        break;
                    }
                    case 38: {
                        m.CancelNotes = r.string();
                        break;
                    }
                    case 39: {
                        m.ReservState = r.int32();
                        break;
                    }
                    case 40: {
                        m.DeskUseID = r.string();
                        break;
                    }
                    case 41: {
                        m.IsPrint = r.int32();
                        break;
                    }
                    case 42: {
                        m.ShowSpecialOption = r.int32();
                        break;
                    }
                    case 43: {
                        m.CreaterID = r.uint64();
                        break;
                    }
                    case 44: {
                        m.CreateTime = r.int64();
                        break;
                    }
                    case 45: {
                        m.UpdateTime = r.int64();
                        break;
                    }
                    case 46: {
                        m.UpdaterID = r.uint64();
                        break;
                    }
                    case 47: {
                        m.Estate = r.int32();
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        DeskReserve.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.DeskReserve";
        };

        return DeskReserve;
    })();

    PBEntity.DeskReserves = (function () {

        function DeskReserves(p) {
            this.DeskReserves = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        DeskReserves.prototype.DeskReserves = $util.emptyArray;

        DeskReserves.create = function create(properties) {
            return new DeskReserves(properties);
        };

        DeskReserves.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.DeskReserves != null && m.DeskReserves.length) {
                for (var i = 0; i < m.DeskReserves.length; ++i)
                    $root.PBEntity.DeskReserve.encode(m.DeskReserves[i], w.uint32(10).fork()).ldelim();
            }
            return w;
        };

        DeskReserves.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.DeskReserves();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        if (!(m.DeskReserves && m.DeskReserves.length))
                            m.DeskReserves = [];
                        m.DeskReserves.push($root.PBEntity.DeskReserve.decode(r, r.uint32()));
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        DeskReserves.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.DeskReserves";
        };

        return DeskReserves;
    })();

    PBEntity.DeskUseRecord = (function () {

        function DeskUseRecord(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        DeskUseRecord.prototype.DeskUseID = "";
        DeskUseRecord.prototype.DeskID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        DeskUseRecord.prototype.MchID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        DeskUseRecord.prototype.DeskCateID = "";
        DeskUseRecord.prototype.UserID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        DeskUseRecord.prototype.DeskName1 = "";
        DeskUseRecord.prototype.DeskName2 = "";
        DeskUseRecord.prototype.DeskName3 = "";
        DeskUseRecord.prototype.UseFrom = 0;
        DeskUseRecord.prototype.UseFromID = "";
        DeskUseRecord.prototype.OpenUserID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        DeskUseRecord.prototype.OpenUserName = "";
        DeskUseRecord.prototype.OpenUserCate = 0;
        DeskUseRecord.prototype.OpenTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        DeskUseRecord.prototype.DaySeq = 0;
        DeskUseRecord.prototype.UseNotes = "";
        DeskUseRecord.prototype.IsPrpay = 0;
        DeskUseRecord.prototype.PrpayAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        DeskUseRecord.prototype.PrpayID = "";
        DeskUseRecord.prototype.IsMinAmt = 0;
        DeskUseRecord.prototype.MinAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        DeskUseRecord.prototype.IsTeaFee = 0;
        DeskUseRecord.prototype.TeaFee = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        DeskUseRecord.prototype.IsAtTeaFee = 0;
        DeskUseRecord.prototype.IsTablewareFee = 0;
        DeskUseRecord.prototype.TablewareFee = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        DeskUseRecord.prototype.IsAtTablewareFee = 0;
        DeskUseRecord.prototype.MinNum = 0;
        DeskUseRecord.prototype.PlanNum = 0;
        DeskUseRecord.prototype.ActualNum = 0;
        DeskUseRecord.prototype.OrderCount = 0;
        DeskUseRecord.prototype.TotalRevenueAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        DeskUseRecord.prototype.IsMakeUp = 0;
        DeskUseRecord.prototype.MakeUpAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        DeskUseRecord.prototype.TotalDisSaleAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        DeskUseRecord.prototype.IsAdj = 0;
        DeskUseRecord.prototype.AdjAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        DeskUseRecord.prototype.UseState = 0;
        DeskUseRecord.prototype.TotalWaitPayAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        DeskUseRecord.prototype.TotalWaitPayCount = 0;
        DeskUseRecord.prototype.IsRefund = 0;
        DeskUseRecord.prototype.PayTotalCount = 0;
        DeskUseRecord.prototype.PayTotalAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        DeskUseRecord.prototype.PayRevenueAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        DeskUseRecord.prototype.PayReceiptAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        DeskUseRecord.prototype.PayStatus = 0;
        DeskUseRecord.prototype.OrderPayID = "";
        DeskUseRecord.prototype.PayID = "";
        DeskUseRecord.prototype.CloseTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        DeskUseRecord.prototype.CloseUserID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        DeskUseRecord.prototype.CloseUserName = "";
        DeskUseRecord.prototype.CloseNotes = "";
        DeskUseRecord.prototype.CloseCate = 0;
        DeskUseRecord.prototype.RefundAmtCount = 0;
        DeskUseRecord.prototype.RefundAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        DeskUseRecord.prototype.CreateTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        DeskUseRecord.prototype.CreaterID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        DeskUseRecord.prototype.UpdateTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        DeskUseRecord.prototype.UpdaterID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        DeskUseRecord.prototype.Estate = 0;

        DeskUseRecord.create = function create(properties) {
            return new DeskUseRecord(properties);
        };

        DeskUseRecord.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.DeskUseID != null && Object.hasOwnProperty.call(m, "DeskUseID"))
                w.uint32(10).string(m.DeskUseID);
            if (m.DeskID != null && Object.hasOwnProperty.call(m, "DeskID"))
                w.uint32(16).uint64(m.DeskID);
            if (m.MchID != null && Object.hasOwnProperty.call(m, "MchID"))
                w.uint32(24).uint64(m.MchID);
            if (m.DeskCateID != null && Object.hasOwnProperty.call(m, "DeskCateID"))
                w.uint32(34).string(m.DeskCateID);
            if (m.UserID != null && Object.hasOwnProperty.call(m, "UserID"))
                w.uint32(40).uint64(m.UserID);
            if (m.DeskName1 != null && Object.hasOwnProperty.call(m, "DeskName1"))
                w.uint32(50).string(m.DeskName1);
            if (m.DeskName2 != null && Object.hasOwnProperty.call(m, "DeskName2"))
                w.uint32(58).string(m.DeskName2);
            if (m.DeskName3 != null && Object.hasOwnProperty.call(m, "DeskName3"))
                w.uint32(66).string(m.DeskName3);
            if (m.UseFrom != null && Object.hasOwnProperty.call(m, "UseFrom"))
                w.uint32(72).int32(m.UseFrom);
            if (m.UseFromID != null && Object.hasOwnProperty.call(m, "UseFromID"))
                w.uint32(82).string(m.UseFromID);
            if (m.OpenUserID != null && Object.hasOwnProperty.call(m, "OpenUserID"))
                w.uint32(88).uint64(m.OpenUserID);
            if (m.OpenUserName != null && Object.hasOwnProperty.call(m, "OpenUserName"))
                w.uint32(98).string(m.OpenUserName);
            if (m.OpenUserCate != null && Object.hasOwnProperty.call(m, "OpenUserCate"))
                w.uint32(104).int32(m.OpenUserCate);
            if (m.OpenTime != null && Object.hasOwnProperty.call(m, "OpenTime"))
                w.uint32(112).int64(m.OpenTime);
            if (m.DaySeq != null && Object.hasOwnProperty.call(m, "DaySeq"))
                w.uint32(120).int32(m.DaySeq);
            if (m.UseNotes != null && Object.hasOwnProperty.call(m, "UseNotes"))
                w.uint32(130).string(m.UseNotes);
            if (m.IsPrpay != null && Object.hasOwnProperty.call(m, "IsPrpay"))
                w.uint32(136).int32(m.IsPrpay);
            if (m.PrpayAmt != null && Object.hasOwnProperty.call(m, "PrpayAmt"))
                w.uint32(144).int64(m.PrpayAmt);
            if (m.PrpayID != null && Object.hasOwnProperty.call(m, "PrpayID"))
                w.uint32(154).string(m.PrpayID);
            if (m.IsMinAmt != null && Object.hasOwnProperty.call(m, "IsMinAmt"))
                w.uint32(160).int32(m.IsMinAmt);
            if (m.MinAmt != null && Object.hasOwnProperty.call(m, "MinAmt"))
                w.uint32(168).int64(m.MinAmt);
            if (m.IsTeaFee != null && Object.hasOwnProperty.call(m, "IsTeaFee"))
                w.uint32(176).int32(m.IsTeaFee);
            if (m.TeaFee != null && Object.hasOwnProperty.call(m, "TeaFee"))
                w.uint32(184).int64(m.TeaFee);
            if (m.IsAtTeaFee != null && Object.hasOwnProperty.call(m, "IsAtTeaFee"))
                w.uint32(192).int32(m.IsAtTeaFee);
            if (m.IsTablewareFee != null && Object.hasOwnProperty.call(m, "IsTablewareFee"))
                w.uint32(200).int32(m.IsTablewareFee);
            if (m.TablewareFee != null && Object.hasOwnProperty.call(m, "TablewareFee"))
                w.uint32(208).int64(m.TablewareFee);
            if (m.IsAtTablewareFee != null && Object.hasOwnProperty.call(m, "IsAtTablewareFee"))
                w.uint32(216).int32(m.IsAtTablewareFee);
            if (m.MinNum != null && Object.hasOwnProperty.call(m, "MinNum"))
                w.uint32(224).int32(m.MinNum);
            if (m.PlanNum != null && Object.hasOwnProperty.call(m, "PlanNum"))
                w.uint32(232).int32(m.PlanNum);
            if (m.ActualNum != null && Object.hasOwnProperty.call(m, "ActualNum"))
                w.uint32(240).int32(m.ActualNum);
            if (m.OrderCount != null && Object.hasOwnProperty.call(m, "OrderCount"))
                w.uint32(248).int32(m.OrderCount);
            if (m.TotalRevenueAmt != null && Object.hasOwnProperty.call(m, "TotalRevenueAmt"))
                w.uint32(256).int64(m.TotalRevenueAmt);
            if (m.IsMakeUp != null && Object.hasOwnProperty.call(m, "IsMakeUp"))
                w.uint32(264).int32(m.IsMakeUp);
            if (m.MakeUpAmt != null && Object.hasOwnProperty.call(m, "MakeUpAmt"))
                w.uint32(272).int64(m.MakeUpAmt);
            if (m.TotalDisSaleAmt != null && Object.hasOwnProperty.call(m, "TotalDisSaleAmt"))
                w.uint32(280).int64(m.TotalDisSaleAmt);
            if (m.IsAdj != null && Object.hasOwnProperty.call(m, "IsAdj"))
                w.uint32(288).int32(m.IsAdj);
            if (m.AdjAmt != null && Object.hasOwnProperty.call(m, "AdjAmt"))
                w.uint32(296).int64(m.AdjAmt);
            if (m.UseState != null && Object.hasOwnProperty.call(m, "UseState"))
                w.uint32(304).int32(m.UseState);
            if (m.TotalWaitPayAmt != null && Object.hasOwnProperty.call(m, "TotalWaitPayAmt"))
                w.uint32(312).int64(m.TotalWaitPayAmt);
            if (m.TotalWaitPayCount != null && Object.hasOwnProperty.call(m, "TotalWaitPayCount"))
                w.uint32(320).int32(m.TotalWaitPayCount);
            if (m.IsRefund != null && Object.hasOwnProperty.call(m, "IsRefund"))
                w.uint32(328).int32(m.IsRefund);
            if (m.PayTotalCount != null && Object.hasOwnProperty.call(m, "PayTotalCount"))
                w.uint32(336).int32(m.PayTotalCount);
            if (m.PayTotalAmt != null && Object.hasOwnProperty.call(m, "PayTotalAmt"))
                w.uint32(344).int64(m.PayTotalAmt);
            if (m.PayRevenueAmt != null && Object.hasOwnProperty.call(m, "PayRevenueAmt"))
                w.uint32(352).int64(m.PayRevenueAmt);
            if (m.PayReceiptAmt != null && Object.hasOwnProperty.call(m, "PayReceiptAmt"))
                w.uint32(360).int64(m.PayReceiptAmt);
            if (m.PayStatus != null && Object.hasOwnProperty.call(m, "PayStatus"))
                w.uint32(368).int32(m.PayStatus);
            if (m.OrderPayID != null && Object.hasOwnProperty.call(m, "OrderPayID"))
                w.uint32(378).string(m.OrderPayID);
            if (m.PayID != null && Object.hasOwnProperty.call(m, "PayID"))
                w.uint32(386).string(m.PayID);
            if (m.CloseTime != null && Object.hasOwnProperty.call(m, "CloseTime"))
                w.uint32(392).int64(m.CloseTime);
            if (m.CloseUserID != null && Object.hasOwnProperty.call(m, "CloseUserID"))
                w.uint32(400).uint64(m.CloseUserID);
            if (m.CloseUserName != null && Object.hasOwnProperty.call(m, "CloseUserName"))
                w.uint32(410).string(m.CloseUserName);
            if (m.CloseNotes != null && Object.hasOwnProperty.call(m, "CloseNotes"))
                w.uint32(418).string(m.CloseNotes);
            if (m.CloseCate != null && Object.hasOwnProperty.call(m, "CloseCate"))
                w.uint32(424).int32(m.CloseCate);
            if (m.RefundAmtCount != null && Object.hasOwnProperty.call(m, "RefundAmtCount"))
                w.uint32(432).int32(m.RefundAmtCount);
            if (m.RefundAmt != null && Object.hasOwnProperty.call(m, "RefundAmt"))
                w.uint32(440).int64(m.RefundAmt);
            if (m.CreateTime != null && Object.hasOwnProperty.call(m, "CreateTime"))
                w.uint32(448).int64(m.CreateTime);
            if (m.CreaterID != null && Object.hasOwnProperty.call(m, "CreaterID"))
                w.uint32(456).uint64(m.CreaterID);
            if (m.UpdateTime != null && Object.hasOwnProperty.call(m, "UpdateTime"))
                w.uint32(464).int64(m.UpdateTime);
            if (m.UpdaterID != null && Object.hasOwnProperty.call(m, "UpdaterID"))
                w.uint32(472).uint64(m.UpdaterID);
            if (m.Estate != null && Object.hasOwnProperty.call(m, "Estate"))
                w.uint32(480).int32(m.Estate);
            return w;
        };

        DeskUseRecord.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.DeskUseRecord();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        m.DeskUseID = r.string();
                        break;
                    }
                    case 2: {
                        m.DeskID = r.uint64();
                        break;
                    }
                    case 3: {
                        m.MchID = r.uint64();
                        break;
                    }
                    case 4: {
                        m.DeskCateID = r.string();
                        break;
                    }
                    case 5: {
                        m.UserID = r.uint64();
                        break;
                    }
                    case 6: {
                        m.DeskName1 = r.string();
                        break;
                    }
                    case 7: {
                        m.DeskName2 = r.string();
                        break;
                    }
                    case 8: {
                        m.DeskName3 = r.string();
                        break;
                    }
                    case 9: {
                        m.UseFrom = r.int32();
                        break;
                    }
                    case 10: {
                        m.UseFromID = r.string();
                        break;
                    }
                    case 11: {
                        m.OpenUserID = r.uint64();
                        break;
                    }
                    case 12: {
                        m.OpenUserName = r.string();
                        break;
                    }
                    case 13: {
                        m.OpenUserCate = r.int32();
                        break;
                    }
                    case 14: {
                        m.OpenTime = r.int64();
                        break;
                    }
                    case 15: {
                        m.DaySeq = r.int32();
                        break;
                    }
                    case 16: {
                        m.UseNotes = r.string();
                        break;
                    }
                    case 17: {
                        m.IsPrpay = r.int32();
                        break;
                    }
                    case 18: {
                        m.PrpayAmt = r.int64();
                        break;
                    }
                    case 19: {
                        m.PrpayID = r.string();
                        break;
                    }
                    case 20: {
                        m.IsMinAmt = r.int32();
                        break;
                    }
                    case 21: {
                        m.MinAmt = r.int64();
                        break;
                    }
                    case 22: {
                        m.IsTeaFee = r.int32();
                        break;
                    }
                    case 23: {
                        m.TeaFee = r.int64();
                        break;
                    }
                    case 24: {
                        m.IsAtTeaFee = r.int32();
                        break;
                    }
                    case 25: {
                        m.IsTablewareFee = r.int32();
                        break;
                    }
                    case 26: {
                        m.TablewareFee = r.int64();
                        break;
                    }
                    case 27: {
                        m.IsAtTablewareFee = r.int32();
                        break;
                    }
                    case 28: {
                        m.MinNum = r.int32();
                        break;
                    }
                    case 29: {
                        m.PlanNum = r.int32();
                        break;
                    }
                    case 30: {
                        m.ActualNum = r.int32();
                        break;
                    }
                    case 31: {
                        m.OrderCount = r.int32();
                        break;
                    }
                    case 32: {
                        m.TotalRevenueAmt = r.int64();
                        break;
                    }
                    case 33: {
                        m.IsMakeUp = r.int32();
                        break;
                    }
                    case 34: {
                        m.MakeUpAmt = r.int64();
                        break;
                    }
                    case 35: {
                        m.TotalDisSaleAmt = r.int64();
                        break;
                    }
                    case 36: {
                        m.IsAdj = r.int32();
                        break;
                    }
                    case 37: {
                        m.AdjAmt = r.int64();
                        break;
                    }
                    case 38: {
                        m.UseState = r.int32();
                        break;
                    }
                    case 39: {
                        m.TotalWaitPayAmt = r.int64();
                        break;
                    }
                    case 40: {
                        m.TotalWaitPayCount = r.int32();
                        break;
                    }
                    case 41: {
                        m.IsRefund = r.int32();
                        break;
                    }
                    case 42: {
                        m.PayTotalCount = r.int32();
                        break;
                    }
                    case 43: {
                        m.PayTotalAmt = r.int64();
                        break;
                    }
                    case 44: {
                        m.PayRevenueAmt = r.int64();
                        break;
                    }
                    case 45: {
                        m.PayReceiptAmt = r.int64();
                        break;
                    }
                    case 46: {
                        m.PayStatus = r.int32();
                        break;
                    }
                    case 47: {
                        m.OrderPayID = r.string();
                        break;
                    }
                    case 48: {
                        m.PayID = r.string();
                        break;
                    }
                    case 49: {
                        m.CloseTime = r.int64();
                        break;
                    }
                    case 50: {
                        m.CloseUserID = r.uint64();
                        break;
                    }
                    case 51: {
                        m.CloseUserName = r.string();
                        break;
                    }
                    case 52: {
                        m.CloseNotes = r.string();
                        break;
                    }
                    case 53: {
                        m.CloseCate = r.int32();
                        break;
                    }
                    case 54: {
                        m.RefundAmtCount = r.int32();
                        break;
                    }
                    case 55: {
                        m.RefundAmt = r.int64();
                        break;
                    }
                    case 56: {
                        m.CreateTime = r.int64();
                        break;
                    }
                    case 57: {
                        m.CreaterID = r.uint64();
                        break;
                    }
                    case 58: {
                        m.UpdateTime = r.int64();
                        break;
                    }
                    case 59: {
                        m.UpdaterID = r.uint64();
                        break;
                    }
                    case 60: {
                        m.Estate = r.int32();
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        DeskUseRecord.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.DeskUseRecord";
        };

        return DeskUseRecord;
    })();

    PBEntity.DeskUseRecords = (function () {

        function DeskUseRecords(p) {
            this.DeskUseRecords = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        DeskUseRecords.prototype.DeskUseRecords = $util.emptyArray;

        DeskUseRecords.create = function create(properties) {
            return new DeskUseRecords(properties);
        };

        DeskUseRecords.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.DeskUseRecords != null && m.DeskUseRecords.length) {
                for (var i = 0; i < m.DeskUseRecords.length; ++i)
                    $root.PBEntity.DeskUseRecord.encode(m.DeskUseRecords[i], w.uint32(10).fork()).ldelim();
            }
            return w;
        };

        DeskUseRecords.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.DeskUseRecords();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        if (!(m.DeskUseRecords && m.DeskUseRecords.length))
                            m.DeskUseRecords = [];
                        m.DeskUseRecords.push($root.PBEntity.DeskUseRecord.decode(r, r.uint32()));
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        DeskUseRecords.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.DeskUseRecords";
        };

        return DeskUseRecords;
    })();

    PBEntity.Goods = (function () {

        function Goods(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        Goods.prototype.GoodsID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        Goods.prototype.MchID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        Goods.prototype.Name1 = "";
        Goods.prototype.Name2 = "";
        Goods.prototype.Name3 = "";
        Goods.prototype.CategoryID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        Goods.prototype.SalesCategory = 0;
        Goods.prototype.HasSpecs = 0;
        Goods.prototype.HasSideDish = 0;
        Goods.prototype.IsSideDishPricing = 0;
        Goods.prototype.MinSideDish = 0;
        Goods.prototype.MaxSideDish = 0;
        Goods.prototype.IsGlobalDish = 0;
        Goods.prototype.MinPrice = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Goods.prototype.MaxPrice = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Goods.prototype.Stock = 0;
        Goods.prototype.UnitID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        Goods.prototype.CostPrice = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Goods.prototype.DefaultPrice = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Goods.prototype.DefaultStock = 0;
        Goods.prototype.NeedCalcStock = 0;
        Goods.prototype.AllowZeroSale = 0;
        Goods.prototype.NeedResetStock = 0;
        Goods.prototype.IsImg = 0;
        Goods.prototype.CoverImg = "";
        Goods.prototype.IsTop = 0;
        Goods.prototype.IsOnline = 0;
        Goods.prototype.IsPos = 0;
        Goods.prototype.IsSF = 0;
        Goods.prototype.IsTax = 0;
        Goods.prototype.Priority = 0;
        Goods.prototype.Notes = "";
        Goods.prototype.PackingFee = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Goods.prototype.MinSaleNum = 0;
        Goods.prototype.DefaultDisRate = 0;
        Goods.prototype.IsSales = 0;
        Goods.prototype.IsByWeigh = 0;
        Goods.prototype.OptGAMode1 = 0;
        Goods.prototype.OptGAGID1 = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        Goods.prototype.OptGAMode2 = 0;
        Goods.prototype.OptGAGID2 = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        Goods.prototype.OptGAMode3 = 0;
        Goods.prototype.OptGAGID3 = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        Goods.prototype.IsVIP = 0;
        Goods.prototype.VIPPrice = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Goods.prototype.IsPlan = 0;
        Goods.prototype.PlanStartDate = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Goods.prototype.PlanEndDate = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Goods.prototype.PlanStartTime = 0;
        Goods.prototype.PlanEndTime = 0;
        Goods.prototype.PlanIsWeek = 0;
        Goods.prototype.DefaultWeight = 0;
        Goods.prototype.PlanWeek = "";
        Goods.prototype.LastResetStockTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Goods.prototype.CreateTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Goods.prototype.CreaterID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        Goods.prototype.UpdateTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Goods.prototype.UpdaterID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        Goods.prototype.Estate = 0;

        Goods.create = function create(properties) {
            return new Goods(properties);
        };

        Goods.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.GoodsID != null && Object.hasOwnProperty.call(m, "GoodsID"))
                w.uint32(8).uint64(m.GoodsID);
            if (m.MchID != null && Object.hasOwnProperty.call(m, "MchID"))
                w.uint32(16).uint64(m.MchID);
            if (m.Name1 != null && Object.hasOwnProperty.call(m, "Name1"))
                w.uint32(26).string(m.Name1);
            if (m.Name2 != null && Object.hasOwnProperty.call(m, "Name2"))
                w.uint32(34).string(m.Name2);
            if (m.Name3 != null && Object.hasOwnProperty.call(m, "Name3"))
                w.uint32(42).string(m.Name3);
            if (m.CategoryID != null && Object.hasOwnProperty.call(m, "CategoryID"))
                w.uint32(48).uint64(m.CategoryID);
            if (m.SalesCategory != null && Object.hasOwnProperty.call(m, "SalesCategory"))
                w.uint32(56).int32(m.SalesCategory);
            if (m.HasSpecs != null && Object.hasOwnProperty.call(m, "HasSpecs"))
                w.uint32(64).int32(m.HasSpecs);
            if (m.HasSideDish != null && Object.hasOwnProperty.call(m, "HasSideDish"))
                w.uint32(72).int32(m.HasSideDish);
            if (m.IsSideDishPricing != null && Object.hasOwnProperty.call(m, "IsSideDishPricing"))
                w.uint32(80).int32(m.IsSideDishPricing);
            if (m.MinSideDish != null && Object.hasOwnProperty.call(m, "MinSideDish"))
                w.uint32(88).int32(m.MinSideDish);
            if (m.MaxSideDish != null && Object.hasOwnProperty.call(m, "MaxSideDish"))
                w.uint32(96).int32(m.MaxSideDish);
            if (m.IsGlobalDish != null && Object.hasOwnProperty.call(m, "IsGlobalDish"))
                w.uint32(104).int32(m.IsGlobalDish);
            if (m.MinPrice != null && Object.hasOwnProperty.call(m, "MinPrice"))
                w.uint32(112).int64(m.MinPrice);
            if (m.MaxPrice != null && Object.hasOwnProperty.call(m, "MaxPrice"))
                w.uint32(120).int64(m.MaxPrice);
            if (m.Stock != null && Object.hasOwnProperty.call(m, "Stock"))
                w.uint32(129).double(m.Stock);
            if (m.UnitID != null && Object.hasOwnProperty.call(m, "UnitID"))
                w.uint32(136).uint64(m.UnitID);
            if (m.CostPrice != null && Object.hasOwnProperty.call(m, "CostPrice"))
                w.uint32(144).int64(m.CostPrice);
            if (m.DefaultPrice != null && Object.hasOwnProperty.call(m, "DefaultPrice"))
                w.uint32(152).int64(m.DefaultPrice);
            if (m.DefaultStock != null && Object.hasOwnProperty.call(m, "DefaultStock"))
                w.uint32(161).double(m.DefaultStock);
            if (m.NeedCalcStock != null && Object.hasOwnProperty.call(m, "NeedCalcStock"))
                w.uint32(168).int32(m.NeedCalcStock);
            if (m.AllowZeroSale != null && Object.hasOwnProperty.call(m, "AllowZeroSale"))
                w.uint32(176).int32(m.AllowZeroSale);
            if (m.NeedResetStock != null && Object.hasOwnProperty.call(m, "NeedResetStock"))
                w.uint32(184).int32(m.NeedResetStock);
            if (m.IsImg != null && Object.hasOwnProperty.call(m, "IsImg"))
                w.uint32(192).int32(m.IsImg);
            if (m.CoverImg != null && Object.hasOwnProperty.call(m, "CoverImg"))
                w.uint32(202).string(m.CoverImg);
            if (m.IsTop != null && Object.hasOwnProperty.call(m, "IsTop"))
                w.uint32(208).int32(m.IsTop);
            if (m.IsOnline != null && Object.hasOwnProperty.call(m, "IsOnline"))
                w.uint32(216).int32(m.IsOnline);
            if (m.IsPos != null && Object.hasOwnProperty.call(m, "IsPos"))
                w.uint32(224).int32(m.IsPos);
            if (m.IsSF != null && Object.hasOwnProperty.call(m, "IsSF"))
                w.uint32(232).int32(m.IsSF);
            if (m.IsTax != null && Object.hasOwnProperty.call(m, "IsTax"))
                w.uint32(240).int32(m.IsTax);
            if (m.Priority != null && Object.hasOwnProperty.call(m, "Priority"))
                w.uint32(248).int32(m.Priority);
            if (m.Notes != null && Object.hasOwnProperty.call(m, "Notes"))
                w.uint32(258).string(m.Notes);
            if (m.PackingFee != null && Object.hasOwnProperty.call(m, "PackingFee"))
                w.uint32(264).int64(m.PackingFee);
            if (m.MinSaleNum != null && Object.hasOwnProperty.call(m, "MinSaleNum"))
                w.uint32(272).int32(m.MinSaleNum);
            if (m.DefaultDisRate != null && Object.hasOwnProperty.call(m, "DefaultDisRate"))
                w.uint32(280).int32(m.DefaultDisRate);
            if (m.IsSales != null && Object.hasOwnProperty.call(m, "IsSales"))
                w.uint32(288).int32(m.IsSales);
            if (m.IsByWeigh != null && Object.hasOwnProperty.call(m, "IsByWeigh"))
                w.uint32(296).int32(m.IsByWeigh);
            if (m.OptGAMode1 != null && Object.hasOwnProperty.call(m, "OptGAMode1"))
                w.uint32(304).int32(m.OptGAMode1);
            if (m.OptGAGID1 != null && Object.hasOwnProperty.call(m, "OptGAGID1"))
                w.uint32(312).uint64(m.OptGAGID1);
            if (m.OptGAMode2 != null && Object.hasOwnProperty.call(m, "OptGAMode2"))
                w.uint32(320).int32(m.OptGAMode2);
            if (m.OptGAGID2 != null && Object.hasOwnProperty.call(m, "OptGAGID2"))
                w.uint32(328).uint64(m.OptGAGID2);
            if (m.OptGAMode3 != null && Object.hasOwnProperty.call(m, "OptGAMode3"))
                w.uint32(336).int32(m.OptGAMode3);
            if (m.OptGAGID3 != null && Object.hasOwnProperty.call(m, "OptGAGID3"))
                w.uint32(344).uint64(m.OptGAGID3);
            if (m.IsVIP != null && Object.hasOwnProperty.call(m, "IsVIP"))
                w.uint32(352).int32(m.IsVIP);
            if (m.VIPPrice != null && Object.hasOwnProperty.call(m, "VIPPrice"))
                w.uint32(360).int64(m.VIPPrice);
            if (m.IsPlan != null && Object.hasOwnProperty.call(m, "IsPlan"))
                w.uint32(368).int32(m.IsPlan);
            if (m.PlanStartDate != null && Object.hasOwnProperty.call(m, "PlanStartDate"))
                w.uint32(376).int64(m.PlanStartDate);
            if (m.PlanEndDate != null && Object.hasOwnProperty.call(m, "PlanEndDate"))
                w.uint32(384).int64(m.PlanEndDate);
            if (m.PlanStartTime != null && Object.hasOwnProperty.call(m, "PlanStartTime"))
                w.uint32(393).double(m.PlanStartTime);
            if (m.PlanEndTime != null && Object.hasOwnProperty.call(m, "PlanEndTime"))
                w.uint32(401).double(m.PlanEndTime);
            if (m.PlanIsWeek != null && Object.hasOwnProperty.call(m, "PlanIsWeek"))
                w.uint32(408).int32(m.PlanIsWeek);
            if (m.DefaultWeight != null && Object.hasOwnProperty.call(m, "DefaultWeight"))
                w.uint32(417).double(m.DefaultWeight);
            if (m.PlanWeek != null && Object.hasOwnProperty.call(m, "PlanWeek"))
                w.uint32(426).string(m.PlanWeek);
            if (m.LastResetStockTime != null && Object.hasOwnProperty.call(m, "LastResetStockTime"))
                w.uint32(432).int64(m.LastResetStockTime);
            if (m.CreateTime != null && Object.hasOwnProperty.call(m, "CreateTime"))
                w.uint32(440).int64(m.CreateTime);
            if (m.CreaterID != null && Object.hasOwnProperty.call(m, "CreaterID"))
                w.uint32(448).uint64(m.CreaterID);
            if (m.UpdateTime != null && Object.hasOwnProperty.call(m, "UpdateTime"))
                w.uint32(456).int64(m.UpdateTime);
            if (m.UpdaterID != null && Object.hasOwnProperty.call(m, "UpdaterID"))
                w.uint32(464).uint64(m.UpdaterID);
            if (m.Estate != null && Object.hasOwnProperty.call(m, "Estate"))
                w.uint32(472).int32(m.Estate);
            return w;
        };

        Goods.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.Goods();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        m.GoodsID = r.uint64();
                        break;
                    }
                    case 2: {
                        m.MchID = r.uint64();
                        break;
                    }
                    case 3: {
                        m.Name1 = r.string();
                        break;
                    }
                    case 4: {
                        m.Name2 = r.string();
                        break;
                    }
                    case 5: {
                        m.Name3 = r.string();
                        break;
                    }
                    case 6: {
                        m.CategoryID = r.uint64();
                        break;
                    }
                    case 7: {
                        m.SalesCategory = r.int32();
                        break;
                    }
                    case 8: {
                        m.HasSpecs = r.int32();
                        break;
                    }
                    case 9: {
                        m.HasSideDish = r.int32();
                        break;
                    }
                    case 10: {
                        m.IsSideDishPricing = r.int32();
                        break;
                    }
                    case 11: {
                        m.MinSideDish = r.int32();
                        break;
                    }
                    case 12: {
                        m.MaxSideDish = r.int32();
                        break;
                    }
                    case 13: {
                        m.IsGlobalDish = r.int32();
                        break;
                    }
                    case 14: {
                        m.MinPrice = r.int64();
                        break;
                    }
                    case 15: {
                        m.MaxPrice = r.int64();
                        break;
                    }
                    case 16: {
                        m.Stock = r.double();
                        break;
                    }
                    case 17: {
                        m.UnitID = r.uint64();
                        break;
                    }
                    case 18: {
                        m.CostPrice = r.int64();
                        break;
                    }
                    case 19: {
                        m.DefaultPrice = r.int64();
                        break;
                    }
                    case 20: {
                        m.DefaultStock = r.double();
                        break;
                    }
                    case 21: {
                        m.NeedCalcStock = r.int32();
                        break;
                    }
                    case 22: {
                        m.AllowZeroSale = r.int32();
                        break;
                    }
                    case 23: {
                        m.NeedResetStock = r.int32();
                        break;
                    }
                    case 24: {
                        m.IsImg = r.int32();
                        break;
                    }
                    case 25: {
                        m.CoverImg = r.string();
                        break;
                    }
                    case 26: {
                        m.IsTop = r.int32();
                        break;
                    }
                    case 27: {
                        m.IsOnline = r.int32();
                        break;
                    }
                    case 28: {
                        m.IsPos = r.int32();
                        break;
                    }
                    case 29: {
                        m.IsSF = r.int32();
                        break;
                    }
                    case 30: {
                        m.IsTax = r.int32();
                        break;
                    }
                    case 31: {
                        m.Priority = r.int32();
                        break;
                    }
                    case 32: {
                        m.Notes = r.string();
                        break;
                    }
                    case 33: {
                        m.PackingFee = r.int64();
                        break;
                    }
                    case 34: {
                        m.MinSaleNum = r.int32();
                        break;
                    }
                    case 35: {
                        m.DefaultDisRate = r.int32();
                        break;
                    }
                    case 36: {
                        m.IsSales = r.int32();
                        break;
                    }
                    case 37: {
                        m.IsByWeigh = r.int32();
                        break;
                    }
                    case 38: {
                        m.OptGAMode1 = r.int32();
                        break;
                    }
                    case 39: {
                        m.OptGAGID1 = r.uint64();
                        break;
                    }
                    case 40: {
                        m.OptGAMode2 = r.int32();
                        break;
                    }
                    case 41: {
                        m.OptGAGID2 = r.uint64();
                        break;
                    }
                    case 42: {
                        m.OptGAMode3 = r.int32();
                        break;
                    }
                    case 43: {
                        m.OptGAGID3 = r.uint64();
                        break;
                    }
                    case 44: {
                        m.IsVIP = r.int32();
                        break;
                    }
                    case 45: {
                        m.VIPPrice = r.int64();
                        break;
                    }
                    case 46: {
                        m.IsPlan = r.int32();
                        break;
                    }
                    case 47: {
                        m.PlanStartDate = r.int64();
                        break;
                    }
                    case 48: {
                        m.PlanEndDate = r.int64();
                        break;
                    }
                    case 49: {
                        m.PlanStartTime = r.double();
                        break;
                    }
                    case 50: {
                        m.PlanEndTime = r.double();
                        break;
                    }
                    case 51: {
                        m.PlanIsWeek = r.int32();
                        break;
                    }
                    case 52: {
                        m.DefaultWeight = r.double();
                        break;
                    }
                    case 53: {
                        m.PlanWeek = r.string();
                        break;
                    }
                    case 54: {
                        m.LastResetStockTime = r.int64();
                        break;
                    }
                    case 55: {
                        m.CreateTime = r.int64();
                        break;
                    }
                    case 56: {
                        m.CreaterID = r.uint64();
                        break;
                    }
                    case 57: {
                        m.UpdateTime = r.int64();
                        break;
                    }
                    case 58: {
                        m.UpdaterID = r.uint64();
                        break;
                    }
                    case 59: {
                        m.Estate = r.int32();
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        Goods.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.Goods";
        };

        return Goods;
    })();

    PBEntity.Goodss = (function () {

        function Goodss(p) {
            this.Goodss = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        Goodss.prototype.Goodss = $util.emptyArray;

        Goodss.create = function create(properties) {
            return new Goodss(properties);
        };

        Goodss.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.Goodss != null && m.Goodss.length) {
                for (var i = 0; i < m.Goodss.length; ++i)
                    $root.PBEntity.Goods.encode(m.Goodss[i], w.uint32(10).fork()).ldelim();
            }
            return w;
        };

        Goodss.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.Goodss();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        if (!(m.Goodss && m.Goodss.length))
                            m.Goodss = [];
                        m.Goodss.push($root.PBEntity.Goods.decode(r, r.uint32()));
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        Goodss.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.Goodss";
        };

        return Goodss;
    })();

    PBEntity.GoodsAttr = (function () {

        function GoodsAttr(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        GoodsAttr.prototype.GattrID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        GoodsAttr.prototype.MchID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        GoodsAttr.prototype.Category = 0;
        GoodsAttr.prototype.GagID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        GoodsAttr.prototype.Name1 = "";
        GoodsAttr.prototype.Name2 = "";
        GoodsAttr.prototype.Name3 = "";
        GoodsAttr.prototype.Priority = 0;
        GoodsAttr.prototype.IsSys = 0;
        GoodsAttr.prototype.CreateTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        GoodsAttr.prototype.CreaterID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        GoodsAttr.prototype.UpdateTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        GoodsAttr.prototype.UpdaterID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        GoodsAttr.prototype.Estate = 0;

        GoodsAttr.create = function create(properties) {
            return new GoodsAttr(properties);
        };

        GoodsAttr.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.GattrID != null && Object.hasOwnProperty.call(m, "GattrID"))
                w.uint32(8).uint64(m.GattrID);
            if (m.MchID != null && Object.hasOwnProperty.call(m, "MchID"))
                w.uint32(16).uint64(m.MchID);
            if (m.Category != null && Object.hasOwnProperty.call(m, "Category"))
                w.uint32(24).int32(m.Category);
            if (m.GagID != null && Object.hasOwnProperty.call(m, "GagID"))
                w.uint32(32).uint64(m.GagID);
            if (m.Name1 != null && Object.hasOwnProperty.call(m, "Name1"))
                w.uint32(42).string(m.Name1);
            if (m.Name2 != null && Object.hasOwnProperty.call(m, "Name2"))
                w.uint32(50).string(m.Name2);
            if (m.Name3 != null && Object.hasOwnProperty.call(m, "Name3"))
                w.uint32(58).string(m.Name3);
            if (m.Priority != null && Object.hasOwnProperty.call(m, "Priority"))
                w.uint32(64).int32(m.Priority);
            if (m.IsSys != null && Object.hasOwnProperty.call(m, "IsSys"))
                w.uint32(72).int32(m.IsSys);
            if (m.CreateTime != null && Object.hasOwnProperty.call(m, "CreateTime"))
                w.uint32(80).int64(m.CreateTime);
            if (m.CreaterID != null && Object.hasOwnProperty.call(m, "CreaterID"))
                w.uint32(88).uint64(m.CreaterID);
            if (m.UpdateTime != null && Object.hasOwnProperty.call(m, "UpdateTime"))
                w.uint32(96).int64(m.UpdateTime);
            if (m.UpdaterID != null && Object.hasOwnProperty.call(m, "UpdaterID"))
                w.uint32(104).uint64(m.UpdaterID);
            if (m.Estate != null && Object.hasOwnProperty.call(m, "Estate"))
                w.uint32(112).int32(m.Estate);
            return w;
        };

        GoodsAttr.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.GoodsAttr();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        m.GattrID = r.uint64();
                        break;
                    }
                    case 2: {
                        m.MchID = r.uint64();
                        break;
                    }
                    case 3: {
                        m.Category = r.int32();
                        break;
                    }
                    case 4: {
                        m.GagID = r.uint64();
                        break;
                    }
                    case 5: {
                        m.Name1 = r.string();
                        break;
                    }
                    case 6: {
                        m.Name2 = r.string();
                        break;
                    }
                    case 7: {
                        m.Name3 = r.string();
                        break;
                    }
                    case 8: {
                        m.Priority = r.int32();
                        break;
                    }
                    case 9: {
                        m.IsSys = r.int32();
                        break;
                    }
                    case 10: {
                        m.CreateTime = r.int64();
                        break;
                    }
                    case 11: {
                        m.CreaterID = r.uint64();
                        break;
                    }
                    case 12: {
                        m.UpdateTime = r.int64();
                        break;
                    }
                    case 13: {
                        m.UpdaterID = r.uint64();
                        break;
                    }
                    case 14: {
                        m.Estate = r.int32();
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        GoodsAttr.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.GoodsAttr";
        };

        return GoodsAttr;
    })();

    PBEntity.GoodsAttrs = (function () {

        function GoodsAttrs(p) {
            this.GoodsAttrs = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        GoodsAttrs.prototype.GoodsAttrs = $util.emptyArray;

        GoodsAttrs.create = function create(properties) {
            return new GoodsAttrs(properties);
        };

        GoodsAttrs.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.GoodsAttrs != null && m.GoodsAttrs.length) {
                for (var i = 0; i < m.GoodsAttrs.length; ++i)
                    $root.PBEntity.GoodsAttr.encode(m.GoodsAttrs[i], w.uint32(10).fork()).ldelim();
            }
            return w;
        };

        GoodsAttrs.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.GoodsAttrs();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        if (!(m.GoodsAttrs && m.GoodsAttrs.length))
                            m.GoodsAttrs = [];
                        m.GoodsAttrs.push($root.PBEntity.GoodsAttr.decode(r, r.uint32()));
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        GoodsAttrs.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.GoodsAttrs";
        };

        return GoodsAttrs;
    })();

    PBEntity.GoodsAttrGroup = (function () {

        function GoodsAttrGroup(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        GoodsAttrGroup.prototype.GagID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        GoodsAttrGroup.prototype.Name1 = "";
        GoodsAttrGroup.prototype.Name2 = "";
        GoodsAttrGroup.prototype.Name3 = "";
        GoodsAttrGroup.prototype.MchID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        GoodsAttrGroup.prototype.Category = 0;
        GoodsAttrGroup.prototype.AffectPrice = 0;
        GoodsAttrGroup.prototype.Priority = 0;
        GoodsAttrGroup.prototype.CreateTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        GoodsAttrGroup.prototype.CreaterID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        GoodsAttrGroup.prototype.UpdateTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        GoodsAttrGroup.prototype.UpdaterID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        GoodsAttrGroup.prototype.Estate = 0;

        GoodsAttrGroup.create = function create(properties) {
            return new GoodsAttrGroup(properties);
        };

        GoodsAttrGroup.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.GagID != null && Object.hasOwnProperty.call(m, "GagID"))
                w.uint32(8).uint64(m.GagID);
            if (m.Name1 != null && Object.hasOwnProperty.call(m, "Name1"))
                w.uint32(18).string(m.Name1);
            if (m.Name2 != null && Object.hasOwnProperty.call(m, "Name2"))
                w.uint32(26).string(m.Name2);
            if (m.Name3 != null && Object.hasOwnProperty.call(m, "Name3"))
                w.uint32(34).string(m.Name3);
            if (m.MchID != null && Object.hasOwnProperty.call(m, "MchID"))
                w.uint32(40).uint64(m.MchID);
            if (m.Category != null && Object.hasOwnProperty.call(m, "Category"))
                w.uint32(48).int32(m.Category);
            if (m.AffectPrice != null && Object.hasOwnProperty.call(m, "AffectPrice"))
                w.uint32(56).int32(m.AffectPrice);
            if (m.Priority != null && Object.hasOwnProperty.call(m, "Priority"))
                w.uint32(64).int32(m.Priority);
            if (m.CreateTime != null && Object.hasOwnProperty.call(m, "CreateTime"))
                w.uint32(72).int64(m.CreateTime);
            if (m.CreaterID != null && Object.hasOwnProperty.call(m, "CreaterID"))
                w.uint32(80).uint64(m.CreaterID);
            if (m.UpdateTime != null && Object.hasOwnProperty.call(m, "UpdateTime"))
                w.uint32(88).int64(m.UpdateTime);
            if (m.UpdaterID != null && Object.hasOwnProperty.call(m, "UpdaterID"))
                w.uint32(96).uint64(m.UpdaterID);
            if (m.Estate != null && Object.hasOwnProperty.call(m, "Estate"))
                w.uint32(104).int32(m.Estate);
            return w;
        };

        GoodsAttrGroup.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.GoodsAttrGroup();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        m.GagID = r.uint64();
                        break;
                    }
                    case 2: {
                        m.Name1 = r.string();
                        break;
                    }
                    case 3: {
                        m.Name2 = r.string();
                        break;
                    }
                    case 4: {
                        m.Name3 = r.string();
                        break;
                    }
                    case 5: {
                        m.MchID = r.uint64();
                        break;
                    }
                    case 6: {
                        m.Category = r.int32();
                        break;
                    }
                    case 7: {
                        m.AffectPrice = r.int32();
                        break;
                    }
                    case 8: {
                        m.Priority = r.int32();
                        break;
                    }
                    case 9: {
                        m.CreateTime = r.int64();
                        break;
                    }
                    case 10: {
                        m.CreaterID = r.uint64();
                        break;
                    }
                    case 11: {
                        m.UpdateTime = r.int64();
                        break;
                    }
                    case 12: {
                        m.UpdaterID = r.uint64();
                        break;
                    }
                    case 13: {
                        m.Estate = r.int32();
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        GoodsAttrGroup.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.GoodsAttrGroup";
        };

        return GoodsAttrGroup;
    })();

    PBEntity.GoodsAttrGroups = (function () {

        function GoodsAttrGroups(p) {
            this.GoodsAttrGroups = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        GoodsAttrGroups.prototype.GoodsAttrGroups = $util.emptyArray;

        GoodsAttrGroups.create = function create(properties) {
            return new GoodsAttrGroups(properties);
        };

        GoodsAttrGroups.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.GoodsAttrGroups != null && m.GoodsAttrGroups.length) {
                for (var i = 0; i < m.GoodsAttrGroups.length; ++i)
                    $root.PBEntity.GoodsAttrGroup.encode(m.GoodsAttrGroups[i], w.uint32(10).fork()).ldelim();
            }
            return w;
        };

        GoodsAttrGroups.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.GoodsAttrGroups();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        if (!(m.GoodsAttrGroups && m.GoodsAttrGroups.length))
                            m.GoodsAttrGroups = [];
                        m.GoodsAttrGroups.push($root.PBEntity.GoodsAttrGroup.decode(r, r.uint32()));
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        GoodsAttrGroups.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.GoodsAttrGroups";
        };

        return GoodsAttrGroups;
    })();

    PBEntity.GoodsCategory = (function () {

        function GoodsCategory(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        GoodsCategory.prototype.CategoryID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        GoodsCategory.prototype.MchID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        GoodsCategory.prototype.Name1 = "";
        GoodsCategory.prototype.Name2 = "";
        GoodsCategory.prototype.Name3 = "";
        GoodsCategory.prototype.PrintCategory = 0;
        GoodsCategory.prototype.Priority = 0;
        GoodsCategory.prototype.IsOnline = 0;
        GoodsCategory.prototype.IsPos = 0;
        GoodsCategory.prototype.ImgFileID = "";
        GoodsCategory.prototype.IsSys = 0;
        GoodsCategory.prototype.IsMust = 0;
        GoodsCategory.prototype.CreateTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        GoodsCategory.prototype.CreaterID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        GoodsCategory.prototype.UpdateTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        GoodsCategory.prototype.UpdaterID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        GoodsCategory.prototype.Estate = 0;

        GoodsCategory.create = function create(properties) {
            return new GoodsCategory(properties);
        };

        GoodsCategory.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.CategoryID != null && Object.hasOwnProperty.call(m, "CategoryID"))
                w.uint32(8).uint64(m.CategoryID);
            if (m.MchID != null && Object.hasOwnProperty.call(m, "MchID"))
                w.uint32(16).uint64(m.MchID);
            if (m.Name1 != null && Object.hasOwnProperty.call(m, "Name1"))
                w.uint32(26).string(m.Name1);
            if (m.Name2 != null && Object.hasOwnProperty.call(m, "Name2"))
                w.uint32(34).string(m.Name2);
            if (m.Name3 != null && Object.hasOwnProperty.call(m, "Name3"))
                w.uint32(42).string(m.Name3);
            if (m.PrintCategory != null && Object.hasOwnProperty.call(m, "PrintCategory"))
                w.uint32(48).int32(m.PrintCategory);
            if (m.Priority != null && Object.hasOwnProperty.call(m, "Priority"))
                w.uint32(56).int32(m.Priority);
            if (m.IsOnline != null && Object.hasOwnProperty.call(m, "IsOnline"))
                w.uint32(64).int32(m.IsOnline);
            if (m.IsPos != null && Object.hasOwnProperty.call(m, "IsPos"))
                w.uint32(72).int32(m.IsPos);
            if (m.ImgFileID != null && Object.hasOwnProperty.call(m, "ImgFileID"))
                w.uint32(82).string(m.ImgFileID);
            if (m.IsSys != null && Object.hasOwnProperty.call(m, "IsSys"))
                w.uint32(88).int32(m.IsSys);
            if (m.IsMust != null && Object.hasOwnProperty.call(m, "IsMust"))
                w.uint32(96).int32(m.IsMust);
            if (m.CreateTime != null && Object.hasOwnProperty.call(m, "CreateTime"))
                w.uint32(104).int64(m.CreateTime);
            if (m.CreaterID != null && Object.hasOwnProperty.call(m, "CreaterID"))
                w.uint32(112).uint64(m.CreaterID);
            if (m.UpdateTime != null && Object.hasOwnProperty.call(m, "UpdateTime"))
                w.uint32(120).int64(m.UpdateTime);
            if (m.UpdaterID != null && Object.hasOwnProperty.call(m, "UpdaterID"))
                w.uint32(128).uint64(m.UpdaterID);
            if (m.Estate != null && Object.hasOwnProperty.call(m, "Estate"))
                w.uint32(136).int32(m.Estate);
            return w;
        };

        GoodsCategory.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.GoodsCategory();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        m.CategoryID = r.uint64();
                        break;
                    }
                    case 2: {
                        m.MchID = r.uint64();
                        break;
                    }
                    case 3: {
                        m.Name1 = r.string();
                        break;
                    }
                    case 4: {
                        m.Name2 = r.string();
                        break;
                    }
                    case 5: {
                        m.Name3 = r.string();
                        break;
                    }
                    case 6: {
                        m.PrintCategory = r.int32();
                        break;
                    }
                    case 7: {
                        m.Priority = r.int32();
                        break;
                    }
                    case 8: {
                        m.IsOnline = r.int32();
                        break;
                    }
                    case 9: {
                        m.IsPos = r.int32();
                        break;
                    }
                    case 10: {
                        m.ImgFileID = r.string();
                        break;
                    }
                    case 11: {
                        m.IsSys = r.int32();
                        break;
                    }
                    case 12: {
                        m.IsMust = r.int32();
                        break;
                    }
                    case 13: {
                        m.CreateTime = r.int64();
                        break;
                    }
                    case 14: {
                        m.CreaterID = r.uint64();
                        break;
                    }
                    case 15: {
                        m.UpdateTime = r.int64();
                        break;
                    }
                    case 16: {
                        m.UpdaterID = r.uint64();
                        break;
                    }
                    case 17: {
                        m.Estate = r.int32();
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        GoodsCategory.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.GoodsCategory";
        };

        return GoodsCategory;
    })();

    PBEntity.GoodsCategorys = (function () {

        function GoodsCategorys(p) {
            this.GoodsCategorys = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        GoodsCategorys.prototype.GoodsCategorys = $util.emptyArray;

        GoodsCategorys.create = function create(properties) {
            return new GoodsCategorys(properties);
        };

        GoodsCategorys.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.GoodsCategorys != null && m.GoodsCategorys.length) {
                for (var i = 0; i < m.GoodsCategorys.length; ++i)
                    $root.PBEntity.GoodsCategory.encode(m.GoodsCategorys[i], w.uint32(10).fork()).ldelim();
            }
            return w;
        };

        GoodsCategorys.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.GoodsCategorys();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        if (!(m.GoodsCategorys && m.GoodsCategorys.length))
                            m.GoodsCategorys = [];
                        m.GoodsCategorys.push($root.PBEntity.GoodsCategory.decode(r, r.uint32()));
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        GoodsCategorys.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.GoodsCategorys";
        };

        return GoodsCategorys;
    })();

    PBEntity.GoodsExtend = (function () {

        function GoodsExtend(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        GoodsExtend.prototype.GoodsID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        GoodsExtend.prototype.MchID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        GoodsExtend.prototype.SideDishJson = "";
        GoodsExtend.prototype.SKUListJson = "";
        GoodsExtend.prototype.Option1ListJson = "";
        GoodsExtend.prototype.Option2ListJson = "";
        GoodsExtend.prototype.Option3ListJson = "";
        GoodsExtend.prototype.GsmJson = "";

        GoodsExtend.create = function create(properties) {
            return new GoodsExtend(properties);
        };

        GoodsExtend.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.GoodsID != null && Object.hasOwnProperty.call(m, "GoodsID"))
                w.uint32(8).uint64(m.GoodsID);
            if (m.MchID != null && Object.hasOwnProperty.call(m, "MchID"))
                w.uint32(16).uint64(m.MchID);
            if (m.SideDishJson != null && Object.hasOwnProperty.call(m, "SideDishJson"))
                w.uint32(26).string(m.SideDishJson);
            if (m.SKUListJson != null && Object.hasOwnProperty.call(m, "SKUListJson"))
                w.uint32(34).string(m.SKUListJson);
            if (m.Option1ListJson != null && Object.hasOwnProperty.call(m, "Option1ListJson"))
                w.uint32(42).string(m.Option1ListJson);
            if (m.Option2ListJson != null && Object.hasOwnProperty.call(m, "Option2ListJson"))
                w.uint32(50).string(m.Option2ListJson);
            if (m.Option3ListJson != null && Object.hasOwnProperty.call(m, "Option3ListJson"))
                w.uint32(58).string(m.Option3ListJson);
            if (m.GsmJson != null && Object.hasOwnProperty.call(m, "GsmJson"))
                w.uint32(66).string(m.GsmJson);
            return w;
        };

        GoodsExtend.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.GoodsExtend();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        m.GoodsID = r.uint64();
                        break;
                    }
                    case 2: {
                        m.MchID = r.uint64();
                        break;
                    }
                    case 3: {
                        m.SideDishJson = r.string();
                        break;
                    }
                    case 4: {
                        m.SKUListJson = r.string();
                        break;
                    }
                    case 5: {
                        m.Option1ListJson = r.string();
                        break;
                    }
                    case 6: {
                        m.Option2ListJson = r.string();
                        break;
                    }
                    case 7: {
                        m.Option3ListJson = r.string();
                        break;
                    }
                    case 8: {
                        m.GsmJson = r.string();
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        GoodsExtend.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.GoodsExtend";
        };

        return GoodsExtend;
    })();

    PBEntity.GoodsExtends = (function () {

        function GoodsExtends(p) {
            this.GoodsExtends = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        GoodsExtends.prototype.GoodsExtends = $util.emptyArray;

        GoodsExtends.create = function create(properties) {
            return new GoodsExtends(properties);
        };

        GoodsExtends.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.GoodsExtends != null && m.GoodsExtends.length) {
                for (var i = 0; i < m.GoodsExtends.length; ++i)
                    $root.PBEntity.GoodsExtend.encode(m.GoodsExtends[i], w.uint32(10).fork()).ldelim();
            }
            return w;
        };

        GoodsExtends.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.GoodsExtends();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        if (!(m.GoodsExtends && m.GoodsExtends.length))
                            m.GoodsExtends = [];
                        m.GoodsExtends.push($root.PBEntity.GoodsExtend.decode(r, r.uint32()));
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        GoodsExtends.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.GoodsExtends";
        };

        return GoodsExtends;
    })();

    PBEntity.GoodsGsm = (function () {

        function GoodsGsm(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        GoodsGsm.prototype.GsmID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        GoodsGsm.prototype.MchID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        GoodsGsm.prototype.BelongGID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        GoodsGsm.prototype.GsmCate = 0;
        GoodsGsm.prototype.GsmName1 = "";
        GoodsGsm.prototype.GsmName2 = "";
        GoodsGsm.prototype.GsmName3 = "";
        GoodsGsm.prototype.MinItem = 0;
        GoodsGsm.prototype.MaxItem = 0;
        GoodsGsm.prototype.IsRepeat = 0;
        GoodsGsm.prototype.MinPrice = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        GoodsGsm.prototype.MinVIPPrice = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        GoodsGsm.prototype.ValPriceCate = 0;
        GoodsGsm.prototype.ItemCount = 0;
        GoodsGsm.prototype.Priority = 0;
        GoodsGsm.prototype.CreateTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        GoodsGsm.prototype.CreaterID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        GoodsGsm.prototype.UpdateTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        GoodsGsm.prototype.UpdaterID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        GoodsGsm.prototype.Estate = 0;

        GoodsGsm.create = function create(properties) {
            return new GoodsGsm(properties);
        };

        GoodsGsm.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.GsmID != null && Object.hasOwnProperty.call(m, "GsmID"))
                w.uint32(8).uint64(m.GsmID);
            if (m.MchID != null && Object.hasOwnProperty.call(m, "MchID"))
                w.uint32(16).uint64(m.MchID);
            if (m.BelongGID != null && Object.hasOwnProperty.call(m, "BelongGID"))
                w.uint32(24).uint64(m.BelongGID);
            if (m.GsmCate != null && Object.hasOwnProperty.call(m, "GsmCate"))
                w.uint32(32).int32(m.GsmCate);
            if (m.GsmName1 != null && Object.hasOwnProperty.call(m, "GsmName1"))
                w.uint32(42).string(m.GsmName1);
            if (m.GsmName2 != null && Object.hasOwnProperty.call(m, "GsmName2"))
                w.uint32(50).string(m.GsmName2);
            if (m.GsmName3 != null && Object.hasOwnProperty.call(m, "GsmName3"))
                w.uint32(58).string(m.GsmName3);
            if (m.MinItem != null && Object.hasOwnProperty.call(m, "MinItem"))
                w.uint32(64).int32(m.MinItem);
            if (m.MaxItem != null && Object.hasOwnProperty.call(m, "MaxItem"))
                w.uint32(72).int32(m.MaxItem);
            if (m.IsRepeat != null && Object.hasOwnProperty.call(m, "IsRepeat"))
                w.uint32(80).int32(m.IsRepeat);
            if (m.MinPrice != null && Object.hasOwnProperty.call(m, "MinPrice"))
                w.uint32(88).int64(m.MinPrice);
            if (m.MinVIPPrice != null && Object.hasOwnProperty.call(m, "MinVIPPrice"))
                w.uint32(96).int64(m.MinVIPPrice);
            if (m.ValPriceCate != null && Object.hasOwnProperty.call(m, "ValPriceCate"))
                w.uint32(104).int32(m.ValPriceCate);
            if (m.ItemCount != null && Object.hasOwnProperty.call(m, "ItemCount"))
                w.uint32(112).int32(m.ItemCount);
            if (m.Priority != null && Object.hasOwnProperty.call(m, "Priority"))
                w.uint32(120).int32(m.Priority);
            if (m.CreateTime != null && Object.hasOwnProperty.call(m, "CreateTime"))
                w.uint32(128).int64(m.CreateTime);
            if (m.CreaterID != null && Object.hasOwnProperty.call(m, "CreaterID"))
                w.uint32(136).uint64(m.CreaterID);
            if (m.UpdateTime != null && Object.hasOwnProperty.call(m, "UpdateTime"))
                w.uint32(144).int64(m.UpdateTime);
            if (m.UpdaterID != null && Object.hasOwnProperty.call(m, "UpdaterID"))
                w.uint32(152).uint64(m.UpdaterID);
            if (m.Estate != null && Object.hasOwnProperty.call(m, "Estate"))
                w.uint32(160).int32(m.Estate);
            return w;
        };

        GoodsGsm.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.GoodsGsm();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        m.GsmID = r.uint64();
                        break;
                    }
                    case 2: {
                        m.MchID = r.uint64();
                        break;
                    }
                    case 3: {
                        m.BelongGID = r.uint64();
                        break;
                    }
                    case 4: {
                        m.GsmCate = r.int32();
                        break;
                    }
                    case 5: {
                        m.GsmName1 = r.string();
                        break;
                    }
                    case 6: {
                        m.GsmName2 = r.string();
                        break;
                    }
                    case 7: {
                        m.GsmName3 = r.string();
                        break;
                    }
                    case 8: {
                        m.MinItem = r.int32();
                        break;
                    }
                    case 9: {
                        m.MaxItem = r.int32();
                        break;
                    }
                    case 10: {
                        m.IsRepeat = r.int32();
                        break;
                    }
                    case 11: {
                        m.MinPrice = r.int64();
                        break;
                    }
                    case 12: {
                        m.MinVIPPrice = r.int64();
                        break;
                    }
                    case 13: {
                        m.ValPriceCate = r.int32();
                        break;
                    }
                    case 14: {
                        m.ItemCount = r.int32();
                        break;
                    }
                    case 15: {
                        m.Priority = r.int32();
                        break;
                    }
                    case 16: {
                        m.CreateTime = r.int64();
                        break;
                    }
                    case 17: {
                        m.CreaterID = r.uint64();
                        break;
                    }
                    case 18: {
                        m.UpdateTime = r.int64();
                        break;
                    }
                    case 19: {
                        m.UpdaterID = r.uint64();
                        break;
                    }
                    case 20: {
                        m.Estate = r.int32();
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        GoodsGsm.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.GoodsGsm";
        };

        return GoodsGsm;
    })();

    PBEntity.GoodsGsms = (function () {

        function GoodsGsms(p) {
            this.GoodsGsms = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        GoodsGsms.prototype.GoodsGsms = $util.emptyArray;

        GoodsGsms.create = function create(properties) {
            return new GoodsGsms(properties);
        };

        GoodsGsms.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.GoodsGsms != null && m.GoodsGsms.length) {
                for (var i = 0; i < m.GoodsGsms.length; ++i)
                    $root.PBEntity.GoodsGsm.encode(m.GoodsGsms[i], w.uint32(10).fork()).ldelim();
            }
            return w;
        };

        GoodsGsms.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.GoodsGsms();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        if (!(m.GoodsGsms && m.GoodsGsms.length))
                            m.GoodsGsms = [];
                        m.GoodsGsms.push($root.PBEntity.GoodsGsm.decode(r, r.uint32()));
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        GoodsGsms.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.GoodsGsms";
        };

        return GoodsGsms;
    })();

    PBEntity.GoodsGsmOption = (function () {

        function GoodsGsmOption(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        GoodsGsmOption.prototype.GsoID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        GoodsGsmOption.prototype.MchID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        GoodsGsmOption.prototype.BelongGID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        GoodsGsmOption.prototype.GsmID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        GoodsGsmOption.prototype.GoodsID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        GoodsGsmOption.prototype.SpecsID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        GoodsGsmOption.prototype.IsPrice = 0;
        GoodsGsmOption.prototype.GsmPrice = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        GoodsGsmOption.prototype.GsmVIPPrice = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        GoodsGsmOption.prototype.DefaultQuantity = 0;
        GoodsGsmOption.prototype.Num = 0;
        GoodsGsmOption.prototype.Priority = 0;
        GoodsGsmOption.prototype.CreateTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        GoodsGsmOption.prototype.CreaterID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        GoodsGsmOption.prototype.UpdateTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        GoodsGsmOption.prototype.UpdaterID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        GoodsGsmOption.prototype.Estate = 0;

        GoodsGsmOption.create = function create(properties) {
            return new GoodsGsmOption(properties);
        };

        GoodsGsmOption.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.GsoID != null && Object.hasOwnProperty.call(m, "GsoID"))
                w.uint32(8).uint64(m.GsoID);
            if (m.MchID != null && Object.hasOwnProperty.call(m, "MchID"))
                w.uint32(16).uint64(m.MchID);
            if (m.BelongGID != null && Object.hasOwnProperty.call(m, "BelongGID"))
                w.uint32(24).uint64(m.BelongGID);
            if (m.GsmID != null && Object.hasOwnProperty.call(m, "GsmID"))
                w.uint32(32).uint64(m.GsmID);
            if (m.GoodsID != null && Object.hasOwnProperty.call(m, "GoodsID"))
                w.uint32(40).uint64(m.GoodsID);
            if (m.SpecsID != null && Object.hasOwnProperty.call(m, "SpecsID"))
                w.uint32(48).uint64(m.SpecsID);
            if (m.IsPrice != null && Object.hasOwnProperty.call(m, "IsPrice"))
                w.uint32(56).int32(m.IsPrice);
            if (m.GsmPrice != null && Object.hasOwnProperty.call(m, "GsmPrice"))
                w.uint32(64).int64(m.GsmPrice);
            if (m.GsmVIPPrice != null && Object.hasOwnProperty.call(m, "GsmVIPPrice"))
                w.uint32(72).int64(m.GsmVIPPrice);
            if (m.DefaultQuantity != null && Object.hasOwnProperty.call(m, "DefaultQuantity"))
                w.uint32(80).int32(m.DefaultQuantity);
            if (m.Num != null && Object.hasOwnProperty.call(m, "Num"))
                w.uint32(88).int32(m.Num);
            if (m.Priority != null && Object.hasOwnProperty.call(m, "Priority"))
                w.uint32(96).int32(m.Priority);
            if (m.CreateTime != null && Object.hasOwnProperty.call(m, "CreateTime"))
                w.uint32(104).int64(m.CreateTime);
            if (m.CreaterID != null && Object.hasOwnProperty.call(m, "CreaterID"))
                w.uint32(112).uint64(m.CreaterID);
            if (m.UpdateTime != null && Object.hasOwnProperty.call(m, "UpdateTime"))
                w.uint32(120).int64(m.UpdateTime);
            if (m.UpdaterID != null && Object.hasOwnProperty.call(m, "UpdaterID"))
                w.uint32(128).uint64(m.UpdaterID);
            if (m.Estate != null && Object.hasOwnProperty.call(m, "Estate"))
                w.uint32(136).int32(m.Estate);
            return w;
        };

        GoodsGsmOption.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.GoodsGsmOption();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        m.GsoID = r.uint64();
                        break;
                    }
                    case 2: {
                        m.MchID = r.uint64();
                        break;
                    }
                    case 3: {
                        m.BelongGID = r.uint64();
                        break;
                    }
                    case 4: {
                        m.GsmID = r.uint64();
                        break;
                    }
                    case 5: {
                        m.GoodsID = r.uint64();
                        break;
                    }
                    case 6: {
                        m.SpecsID = r.uint64();
                        break;
                    }
                    case 7: {
                        m.IsPrice = r.int32();
                        break;
                    }
                    case 8: {
                        m.GsmPrice = r.int64();
                        break;
                    }
                    case 9: {
                        m.GsmVIPPrice = r.int64();
                        break;
                    }
                    case 10: {
                        m.DefaultQuantity = r.int32();
                        break;
                    }
                    case 11: {
                        m.Num = r.int32();
                        break;
                    }
                    case 12: {
                        m.Priority = r.int32();
                        break;
                    }
                    case 13: {
                        m.CreateTime = r.int64();
                        break;
                    }
                    case 14: {
                        m.CreaterID = r.uint64();
                        break;
                    }
                    case 15: {
                        m.UpdateTime = r.int64();
                        break;
                    }
                    case 16: {
                        m.UpdaterID = r.uint64();
                        break;
                    }
                    case 17: {
                        m.Estate = r.int32();
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        GoodsGsmOption.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.GoodsGsmOption";
        };

        return GoodsGsmOption;
    })();

    PBEntity.GoodsGsmOptions = (function () {

        function GoodsGsmOptions(p) {
            this.GoodsGsmOptions = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        GoodsGsmOptions.prototype.GoodsGsmOptions = $util.emptyArray;

        GoodsGsmOptions.create = function create(properties) {
            return new GoodsGsmOptions(properties);
        };

        GoodsGsmOptions.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.GoodsGsmOptions != null && m.GoodsGsmOptions.length) {
                for (var i = 0; i < m.GoodsGsmOptions.length; ++i)
                    $root.PBEntity.GoodsGsmOption.encode(m.GoodsGsmOptions[i], w.uint32(10).fork()).ldelim();
            }
            return w;
        };

        GoodsGsmOptions.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.GoodsGsmOptions();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        if (!(m.GoodsGsmOptions && m.GoodsGsmOptions.length))
                            m.GoodsGsmOptions = [];
                        m.GoodsGsmOptions.push($root.PBEntity.GoodsGsmOption.decode(r, r.uint32()));
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        GoodsGsmOptions.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.GoodsGsmOptions";
        };

        return GoodsGsmOptions;
    })();

    PBEntity.GoodsOptionAttr = (function () {

        function GoodsOptionAttr(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        GoodsOptionAttr.prototype.BelongGID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        GoodsOptionAttr.prototype.GaID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        GoodsOptionAttr.prototype.UseCate = 0;
        GoodsOptionAttr.prototype.AttrNum = 0;
        GoodsOptionAttr.prototype.MchID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        GoodsOptionAttr.prototype.IsDefault = 0;
        GoodsOptionAttr.prototype.Priority = 0;
        GoodsOptionAttr.prototype.CreateTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        GoodsOptionAttr.prototype.CreaterID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        GoodsOptionAttr.prototype.UpdateTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        GoodsOptionAttr.prototype.UpdaterID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        GoodsOptionAttr.prototype.Estate = 0;

        GoodsOptionAttr.create = function create(properties) {
            return new GoodsOptionAttr(properties);
        };

        GoodsOptionAttr.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.BelongGID != null && Object.hasOwnProperty.call(m, "BelongGID"))
                w.uint32(8).uint64(m.BelongGID);
            if (m.GaID != null && Object.hasOwnProperty.call(m, "GaID"))
                w.uint32(16).uint64(m.GaID);
            if (m.UseCate != null && Object.hasOwnProperty.call(m, "UseCate"))
                w.uint32(24).int32(m.UseCate);
            if (m.AttrNum != null && Object.hasOwnProperty.call(m, "AttrNum"))
                w.uint32(32).int32(m.AttrNum);
            if (m.MchID != null && Object.hasOwnProperty.call(m, "MchID"))
                w.uint32(40).uint64(m.MchID);
            if (m.IsDefault != null && Object.hasOwnProperty.call(m, "IsDefault"))
                w.uint32(48).int32(m.IsDefault);
            if (m.Priority != null && Object.hasOwnProperty.call(m, "Priority"))
                w.uint32(56).int32(m.Priority);
            if (m.CreateTime != null && Object.hasOwnProperty.call(m, "CreateTime"))
                w.uint32(64).int64(m.CreateTime);
            if (m.CreaterID != null && Object.hasOwnProperty.call(m, "CreaterID"))
                w.uint32(72).uint64(m.CreaterID);
            if (m.UpdateTime != null && Object.hasOwnProperty.call(m, "UpdateTime"))
                w.uint32(80).int64(m.UpdateTime);
            if (m.UpdaterID != null && Object.hasOwnProperty.call(m, "UpdaterID"))
                w.uint32(88).uint64(m.UpdaterID);
            if (m.Estate != null && Object.hasOwnProperty.call(m, "Estate"))
                w.uint32(96).int32(m.Estate);
            return w;
        };

        GoodsOptionAttr.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.GoodsOptionAttr();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        m.BelongGID = r.uint64();
                        break;
                    }
                    case 2: {
                        m.GaID = r.uint64();
                        break;
                    }
                    case 3: {
                        m.UseCate = r.int32();
                        break;
                    }
                    case 4: {
                        m.AttrNum = r.int32();
                        break;
                    }
                    case 5: {
                        m.MchID = r.uint64();
                        break;
                    }
                    case 6: {
                        m.IsDefault = r.int32();
                        break;
                    }
                    case 7: {
                        m.Priority = r.int32();
                        break;
                    }
                    case 8: {
                        m.CreateTime = r.int64();
                        break;
                    }
                    case 9: {
                        m.CreaterID = r.uint64();
                        break;
                    }
                    case 10: {
                        m.UpdateTime = r.int64();
                        break;
                    }
                    case 11: {
                        m.UpdaterID = r.uint64();
                        break;
                    }
                    case 12: {
                        m.Estate = r.int32();
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        GoodsOptionAttr.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.GoodsOptionAttr";
        };

        return GoodsOptionAttr;
    })();

    PBEntity.GoodsOptionAttrs = (function () {

        function GoodsOptionAttrs(p) {
            this.GoodsOptionAttrs = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        GoodsOptionAttrs.prototype.GoodsOptionAttrs = $util.emptyArray;

        GoodsOptionAttrs.create = function create(properties) {
            return new GoodsOptionAttrs(properties);
        };

        GoodsOptionAttrs.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.GoodsOptionAttrs != null && m.GoodsOptionAttrs.length) {
                for (var i = 0; i < m.GoodsOptionAttrs.length; ++i)
                    $root.PBEntity.GoodsOptionAttr.encode(m.GoodsOptionAttrs[i], w.uint32(10).fork()).ldelim();
            }
            return w;
        };

        GoodsOptionAttrs.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.GoodsOptionAttrs();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        if (!(m.GoodsOptionAttrs && m.GoodsOptionAttrs.length))
                            m.GoodsOptionAttrs = [];
                        m.GoodsOptionAttrs.push($root.PBEntity.GoodsOptionAttr.decode(r, r.uint32()));
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        GoodsOptionAttrs.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.GoodsOptionAttrs";
        };

        return GoodsOptionAttrs;
    })();

    PBEntity.GoodsSKU = (function () {

        function GoodsSKU(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        GoodsSKU.prototype.SkuID = "";
        GoodsSKU.prototype.MchID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        GoodsSKU.prototype.GoodsID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        GoodsSKU.prototype.SpecsID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        GoodsSKU.prototype.CategoryID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        GoodsSKU.prototype.CostPrice = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        GoodsSKU.prototype.Price = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        GoodsSKU.prototype.NeedCalcStock = 0;
        GoodsSKU.prototype.AllowZeroSale = 0;
        GoodsSKU.prototype.StockCount = 0;
        GoodsSKU.prototype.IsImg = 0;
        GoodsSKU.prototype.CoverImg = "";
        GoodsSKU.prototype.Notes = "";
        GoodsSKU.prototype.DefaultStock = 0;
        GoodsSKU.prototype.UnitID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        GoodsSKU.prototype.Priority = 0;
        GoodsSKU.prototype.PackingFee = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        GoodsSKU.prototype.DefaultDisRate = 0;
        GoodsSKU.prototype.OriPrice = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        GoodsSKU.prototype.IsSales = 0;
        GoodsSKU.prototype.IsByWeigh = 0;
        GoodsSKU.prototype.IsVIP = 0;
        GoodsSKU.prototype.VIPPrice = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        GoodsSKU.prototype.Weight = 0;
        GoodsSKU.prototype.NeedResetStock = 0;
        GoodsSKU.prototype.Estate = 0;

        GoodsSKU.create = function create(properties) {
            return new GoodsSKU(properties);
        };

        GoodsSKU.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.SkuID != null && Object.hasOwnProperty.call(m, "SkuID"))
                w.uint32(10).string(m.SkuID);
            if (m.MchID != null && Object.hasOwnProperty.call(m, "MchID"))
                w.uint32(16).uint64(m.MchID);
            if (m.GoodsID != null && Object.hasOwnProperty.call(m, "GoodsID"))
                w.uint32(24).uint64(m.GoodsID);
            if (m.SpecsID != null && Object.hasOwnProperty.call(m, "SpecsID"))
                w.uint32(32).uint64(m.SpecsID);
            if (m.CategoryID != null && Object.hasOwnProperty.call(m, "CategoryID"))
                w.uint32(40).uint64(m.CategoryID);
            if (m.CostPrice != null && Object.hasOwnProperty.call(m, "CostPrice"))
                w.uint32(48).int64(m.CostPrice);
            if (m.Price != null && Object.hasOwnProperty.call(m, "Price"))
                w.uint32(56).int64(m.Price);
            if (m.NeedCalcStock != null && Object.hasOwnProperty.call(m, "NeedCalcStock"))
                w.uint32(64).int32(m.NeedCalcStock);
            if (m.AllowZeroSale != null && Object.hasOwnProperty.call(m, "AllowZeroSale"))
                w.uint32(72).int32(m.AllowZeroSale);
            if (m.StockCount != null && Object.hasOwnProperty.call(m, "StockCount"))
                w.uint32(81).double(m.StockCount);
            if (m.IsImg != null && Object.hasOwnProperty.call(m, "IsImg"))
                w.uint32(88).int32(m.IsImg);
            if (m.CoverImg != null && Object.hasOwnProperty.call(m, "CoverImg"))
                w.uint32(98).string(m.CoverImg);
            if (m.Notes != null && Object.hasOwnProperty.call(m, "Notes"))
                w.uint32(106).string(m.Notes);
            if (m.DefaultStock != null && Object.hasOwnProperty.call(m, "DefaultStock"))
                w.uint32(113).double(m.DefaultStock);
            if (m.UnitID != null && Object.hasOwnProperty.call(m, "UnitID"))
                w.uint32(120).uint64(m.UnitID);
            if (m.Priority != null && Object.hasOwnProperty.call(m, "Priority"))
                w.uint32(128).int32(m.Priority);
            if (m.PackingFee != null && Object.hasOwnProperty.call(m, "PackingFee"))
                w.uint32(136).int64(m.PackingFee);
            if (m.DefaultDisRate != null && Object.hasOwnProperty.call(m, "DefaultDisRate"))
                w.uint32(144).int32(m.DefaultDisRate);
            if (m.OriPrice != null && Object.hasOwnProperty.call(m, "OriPrice"))
                w.uint32(152).int64(m.OriPrice);
            if (m.IsSales != null && Object.hasOwnProperty.call(m, "IsSales"))
                w.uint32(160).int32(m.IsSales);
            if (m.IsByWeigh != null && Object.hasOwnProperty.call(m, "IsByWeigh"))
                w.uint32(168).int32(m.IsByWeigh);
            if (m.IsVIP != null && Object.hasOwnProperty.call(m, "IsVIP"))
                w.uint32(176).int32(m.IsVIP);
            if (m.VIPPrice != null && Object.hasOwnProperty.call(m, "VIPPrice"))
                w.uint32(184).int64(m.VIPPrice);
            if (m.Weight != null && Object.hasOwnProperty.call(m, "Weight"))
                w.uint32(193).double(m.Weight);
            if (m.NeedResetStock != null && Object.hasOwnProperty.call(m, "NeedResetStock"))
                w.uint32(200).int32(m.NeedResetStock);
            if (m.Estate != null && Object.hasOwnProperty.call(m, "Estate"))
                w.uint32(208).int32(m.Estate);
            return w;
        };

        GoodsSKU.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.GoodsSKU();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        m.SkuID = r.string();
                        break;
                    }
                    case 2: {
                        m.MchID = r.uint64();
                        break;
                    }
                    case 3: {
                        m.GoodsID = r.uint64();
                        break;
                    }
                    case 4: {
                        m.SpecsID = r.uint64();
                        break;
                    }
                    case 5: {
                        m.CategoryID = r.uint64();
                        break;
                    }
                    case 6: {
                        m.CostPrice = r.int64();
                        break;
                    }
                    case 7: {
                        m.Price = r.int64();
                        break;
                    }
                    case 8: {
                        m.NeedCalcStock = r.int32();
                        break;
                    }
                    case 9: {
                        m.AllowZeroSale = r.int32();
                        break;
                    }
                    case 10: {
                        m.StockCount = r.double();
                        break;
                    }
                    case 11: {
                        m.IsImg = r.int32();
                        break;
                    }
                    case 12: {
                        m.CoverImg = r.string();
                        break;
                    }
                    case 13: {
                        m.Notes = r.string();
                        break;
                    }
                    case 14: {
                        m.DefaultStock = r.double();
                        break;
                    }
                    case 15: {
                        m.UnitID = r.uint64();
                        break;
                    }
                    case 16: {
                        m.Priority = r.int32();
                        break;
                    }
                    case 17: {
                        m.PackingFee = r.int64();
                        break;
                    }
                    case 18: {
                        m.DefaultDisRate = r.int32();
                        break;
                    }
                    case 19: {
                        m.OriPrice = r.int64();
                        break;
                    }
                    case 20: {
                        m.IsSales = r.int32();
                        break;
                    }
                    case 21: {
                        m.IsByWeigh = r.int32();
                        break;
                    }
                    case 22: {
                        m.IsVIP = r.int32();
                        break;
                    }
                    case 23: {
                        m.VIPPrice = r.int64();
                        break;
                    }
                    case 24: {
                        m.Weight = r.double();
                        break;
                    }
                    case 25: {
                        m.NeedResetStock = r.int32();
                        break;
                    }
                    case 26: {
                        m.Estate = r.int32();
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        GoodsSKU.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.GoodsSKU";
        };

        return GoodsSKU;
    })();

    PBEntity.GoodsSKUs = (function () {

        function GoodsSKUs(p) {
            this.GoodsSKUs = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        GoodsSKUs.prototype.GoodsSKUs = $util.emptyArray;

        GoodsSKUs.create = function create(properties) {
            return new GoodsSKUs(properties);
        };

        GoodsSKUs.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.GoodsSKUs != null && m.GoodsSKUs.length) {
                for (var i = 0; i < m.GoodsSKUs.length; ++i)
                    $root.PBEntity.GoodsSKU.encode(m.GoodsSKUs[i], w.uint32(10).fork()).ldelim();
            }
            return w;
        };

        GoodsSKUs.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.GoodsSKUs();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        if (!(m.GoodsSKUs && m.GoodsSKUs.length))
                            m.GoodsSKUs = [];
                        m.GoodsSKUs.push($root.PBEntity.GoodsSKU.decode(r, r.uint32()));
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        GoodsSKUs.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.GoodsSKUs";
        };

        return GoodsSKUs;
    })();

    PBEntity.GoodsSideDish = (function () {

        function GoodsSideDish(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        GoodsSideDish.prototype.BelongGoodsID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        GoodsSideDish.prototype.GoodsID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        GoodsSideDish.prototype.MchID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        GoodsSideDish.prototype.IsDefault = 0;
        GoodsSideDish.prototype.Priority = 0;
        GoodsSideDish.prototype.CreateTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        GoodsSideDish.prototype.CreaterID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        GoodsSideDish.prototype.UpdateTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        GoodsSideDish.prototype.UpdaterID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        GoodsSideDish.prototype.Estate = 0;

        GoodsSideDish.create = function create(properties) {
            return new GoodsSideDish(properties);
        };

        GoodsSideDish.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.BelongGoodsID != null && Object.hasOwnProperty.call(m, "BelongGoodsID"))
                w.uint32(8).uint64(m.BelongGoodsID);
            if (m.GoodsID != null && Object.hasOwnProperty.call(m, "GoodsID"))
                w.uint32(16).uint64(m.GoodsID);
            if (m.MchID != null && Object.hasOwnProperty.call(m, "MchID"))
                w.uint32(24).uint64(m.MchID);
            if (m.IsDefault != null && Object.hasOwnProperty.call(m, "IsDefault"))
                w.uint32(32).int32(m.IsDefault);
            if (m.Priority != null && Object.hasOwnProperty.call(m, "Priority"))
                w.uint32(40).int32(m.Priority);
            if (m.CreateTime != null && Object.hasOwnProperty.call(m, "CreateTime"))
                w.uint32(48).int64(m.CreateTime);
            if (m.CreaterID != null && Object.hasOwnProperty.call(m, "CreaterID"))
                w.uint32(56).uint64(m.CreaterID);
            if (m.UpdateTime != null && Object.hasOwnProperty.call(m, "UpdateTime"))
                w.uint32(64).int64(m.UpdateTime);
            if (m.UpdaterID != null && Object.hasOwnProperty.call(m, "UpdaterID"))
                w.uint32(72).uint64(m.UpdaterID);
            if (m.Estate != null && Object.hasOwnProperty.call(m, "Estate"))
                w.uint32(80).int32(m.Estate);
            return w;
        };

        GoodsSideDish.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.GoodsSideDish();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        m.BelongGoodsID = r.uint64();
                        break;
                    }
                    case 2: {
                        m.GoodsID = r.uint64();
                        break;
                    }
                    case 3: {
                        m.MchID = r.uint64();
                        break;
                    }
                    case 4: {
                        m.IsDefault = r.int32();
                        break;
                    }
                    case 5: {
                        m.Priority = r.int32();
                        break;
                    }
                    case 6: {
                        m.CreateTime = r.int64();
                        break;
                    }
                    case 7: {
                        m.CreaterID = r.uint64();
                        break;
                    }
                    case 8: {
                        m.UpdateTime = r.int64();
                        break;
                    }
                    case 9: {
                        m.UpdaterID = r.uint64();
                        break;
                    }
                    case 10: {
                        m.Estate = r.int32();
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        GoodsSideDish.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.GoodsSideDish";
        };

        return GoodsSideDish;
    })();

    PBEntity.GoodsSideDishs = (function () {

        function GoodsSideDishs(p) {
            this.GoodsSideDishs = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        GoodsSideDishs.prototype.GoodsSideDishs = $util.emptyArray;

        GoodsSideDishs.create = function create(properties) {
            return new GoodsSideDishs(properties);
        };

        GoodsSideDishs.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.GoodsSideDishs != null && m.GoodsSideDishs.length) {
                for (var i = 0; i < m.GoodsSideDishs.length; ++i)
                    $root.PBEntity.GoodsSideDish.encode(m.GoodsSideDishs[i], w.uint32(10).fork()).ldelim();
            }
            return w;
        };

        GoodsSideDishs.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.GoodsSideDishs();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        if (!(m.GoodsSideDishs && m.GoodsSideDishs.length))
                            m.GoodsSideDishs = [];
                        m.GoodsSideDishs.push($root.PBEntity.GoodsSideDish.decode(r, r.uint32()));
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        GoodsSideDishs.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.GoodsSideDishs";
        };

        return GoodsSideDishs;
    })();

    PBEntity.GoodsUnit = (function () {

        function GoodsUnit(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        GoodsUnit.prototype.UnitID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        GoodsUnit.prototype.MchID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        GoodsUnit.prototype.Name1 = "";
        GoodsUnit.prototype.Name2 = "";
        GoodsUnit.prototype.Name3 = "";
        GoodsUnit.prototype.Priority = 0;
        GoodsUnit.prototype.IsSys = 0;
        GoodsUnit.prototype.CreateTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        GoodsUnit.prototype.CreaterID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        GoodsUnit.prototype.UpdateTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        GoodsUnit.prototype.UpdaterID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        GoodsUnit.prototype.Estate = 0;

        GoodsUnit.create = function create(properties) {
            return new GoodsUnit(properties);
        };

        GoodsUnit.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.UnitID != null && Object.hasOwnProperty.call(m, "UnitID"))
                w.uint32(8).uint64(m.UnitID);
            if (m.MchID != null && Object.hasOwnProperty.call(m, "MchID"))
                w.uint32(16).uint64(m.MchID);
            if (m.Name1 != null && Object.hasOwnProperty.call(m, "Name1"))
                w.uint32(26).string(m.Name1);
            if (m.Name2 != null && Object.hasOwnProperty.call(m, "Name2"))
                w.uint32(34).string(m.Name2);
            if (m.Name3 != null && Object.hasOwnProperty.call(m, "Name3"))
                w.uint32(42).string(m.Name3);
            if (m.Priority != null && Object.hasOwnProperty.call(m, "Priority"))
                w.uint32(48).int32(m.Priority);
            if (m.IsSys != null && Object.hasOwnProperty.call(m, "IsSys"))
                w.uint32(56).int32(m.IsSys);
            if (m.CreateTime != null && Object.hasOwnProperty.call(m, "CreateTime"))
                w.uint32(64).int64(m.CreateTime);
            if (m.CreaterID != null && Object.hasOwnProperty.call(m, "CreaterID"))
                w.uint32(72).uint64(m.CreaterID);
            if (m.UpdateTime != null && Object.hasOwnProperty.call(m, "UpdateTime"))
                w.uint32(80).int64(m.UpdateTime);
            if (m.UpdaterID != null && Object.hasOwnProperty.call(m, "UpdaterID"))
                w.uint32(88).uint64(m.UpdaterID);
            if (m.Estate != null && Object.hasOwnProperty.call(m, "Estate"))
                w.uint32(96).int32(m.Estate);
            return w;
        };

        GoodsUnit.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.GoodsUnit();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        m.UnitID = r.uint64();
                        break;
                    }
                    case 2: {
                        m.MchID = r.uint64();
                        break;
                    }
                    case 3: {
                        m.Name1 = r.string();
                        break;
                    }
                    case 4: {
                        m.Name2 = r.string();
                        break;
                    }
                    case 5: {
                        m.Name3 = r.string();
                        break;
                    }
                    case 6: {
                        m.Priority = r.int32();
                        break;
                    }
                    case 7: {
                        m.IsSys = r.int32();
                        break;
                    }
                    case 8: {
                        m.CreateTime = r.int64();
                        break;
                    }
                    case 9: {
                        m.CreaterID = r.uint64();
                        break;
                    }
                    case 10: {
                        m.UpdateTime = r.int64();
                        break;
                    }
                    case 11: {
                        m.UpdaterID = r.uint64();
                        break;
                    }
                    case 12: {
                        m.Estate = r.int32();
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        GoodsUnit.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.GoodsUnit";
        };

        return GoodsUnit;
    })();

    PBEntity.GoodsUnits = (function () {

        function GoodsUnits(p) {
            this.GoodsUnits = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        GoodsUnits.prototype.GoodsUnits = $util.emptyArray;

        GoodsUnits.create = function create(properties) {
            return new GoodsUnits(properties);
        };

        GoodsUnits.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.GoodsUnits != null && m.GoodsUnits.length) {
                for (var i = 0; i < m.GoodsUnits.length; ++i)
                    $root.PBEntity.GoodsUnit.encode(m.GoodsUnits[i], w.uint32(10).fork()).ldelim();
            }
            return w;
        };

        GoodsUnits.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.GoodsUnits();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        if (!(m.GoodsUnits && m.GoodsUnits.length))
                            m.GoodsUnits = [];
                        m.GoodsUnits.push($root.PBEntity.GoodsUnit.decode(r, r.uint32()));
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        GoodsUnits.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.GoodsUnits";
        };

        return GoodsUnits;
    })();

    PBEntity.LicenseType = (function () {

        function LicenseType(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        LicenseType.prototype.LicenseTypeID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        LicenseType.prototype.Name1 = "";
        LicenseType.prototype.Name2 = "";
        LicenseType.prototype.Name3 = "";
        LicenseType.prototype.SysName = "";
        LicenseType.prototype.MchCategory = 0;
        LicenseType.prototype.Period = 0;
        LicenseType.prototype.Price = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        LicenseType.prototype.AgentPrice = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        LicenseType.prototype.OnlineSales = 0;
        LicenseType.prototype.HasReserve = 0;
        LicenseType.prototype.HasRecharge = 0;
        LicenseType.prototype.HasTakeaway = 0;
        LicenseType.prototype.HasYourself = 0;
        LicenseType.prototype.HasShopTable = 0;
        LicenseType.prototype.Priority = 0;
        LicenseType.prototype.AllowPayLater = 0;
        LicenseType.prototype.SaleNotes1 = "";
        LicenseType.prototype.SaleNotes2 = "";
        LicenseType.prototype.SaleNotes3 = "";
        LicenseType.prototype.SysNotes = "";
        LicenseType.prototype.PMTakeaway = 0;
        LicenseType.prototype.PMTakestore = 0;
        LicenseType.prototype.PMYourself = 0;
        LicenseType.prototype.PMShop = 0;
        LicenseType.prototype.HasEmpReserve = 0;
        LicenseType.prototype.HasEmpTakeaway = 0;
        LicenseType.prototype.HasEmpYourself = 0;
        LicenseType.prototype.HasEmpShop = 0;
        LicenseType.prototype.HasPMPTakeaway = 0;
        LicenseType.prototype.HasPMPYourself = 0;
        LicenseType.prototype.HasPMPShop = 0;
        LicenseType.prototype.AllowAgent = 0;
        LicenseType.prototype.MaxEmpCount = 0;
        LicenseType.prototype.CreaterID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        LicenseType.prototype.UpdateTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        LicenseType.prototype.UpdaterID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        LicenseType.prototype.Estate = 0;

        LicenseType.create = function create(properties) {
            return new LicenseType(properties);
        };

        LicenseType.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.LicenseTypeID != null && Object.hasOwnProperty.call(m, "LicenseTypeID"))
                w.uint32(8).uint64(m.LicenseTypeID);
            if (m.Name1 != null && Object.hasOwnProperty.call(m, "Name1"))
                w.uint32(18).string(m.Name1);
            if (m.Name2 != null && Object.hasOwnProperty.call(m, "Name2"))
                w.uint32(26).string(m.Name2);
            if (m.Name3 != null && Object.hasOwnProperty.call(m, "Name3"))
                w.uint32(34).string(m.Name3);
            if (m.SysName != null && Object.hasOwnProperty.call(m, "SysName"))
                w.uint32(42).string(m.SysName);
            if (m.MchCategory != null && Object.hasOwnProperty.call(m, "MchCategory"))
                w.uint32(48).int32(m.MchCategory);
            if (m.Period != null && Object.hasOwnProperty.call(m, "Period"))
                w.uint32(56).int32(m.Period);
            if (m.Price != null && Object.hasOwnProperty.call(m, "Price"))
                w.uint32(64).int64(m.Price);
            if (m.AgentPrice != null && Object.hasOwnProperty.call(m, "AgentPrice"))
                w.uint32(72).int64(m.AgentPrice);
            if (m.OnlineSales != null && Object.hasOwnProperty.call(m, "OnlineSales"))
                w.uint32(80).int32(m.OnlineSales);
            if (m.HasReserve != null && Object.hasOwnProperty.call(m, "HasReserve"))
                w.uint32(88).int32(m.HasReserve);
            if (m.HasRecharge != null && Object.hasOwnProperty.call(m, "HasRecharge"))
                w.uint32(96).int32(m.HasRecharge);
            if (m.HasTakeaway != null && Object.hasOwnProperty.call(m, "HasTakeaway"))
                w.uint32(104).int32(m.HasTakeaway);
            if (m.HasYourself != null && Object.hasOwnProperty.call(m, "HasYourself"))
                w.uint32(112).int32(m.HasYourself);
            if (m.HasShopTable != null && Object.hasOwnProperty.call(m, "HasShopTable"))
                w.uint32(120).int32(m.HasShopTable);
            if (m.Priority != null && Object.hasOwnProperty.call(m, "Priority"))
                w.uint32(128).int32(m.Priority);
            if (m.AllowPayLater != null && Object.hasOwnProperty.call(m, "AllowPayLater"))
                w.uint32(136).int32(m.AllowPayLater);
            if (m.SaleNotes1 != null && Object.hasOwnProperty.call(m, "SaleNotes1"))
                w.uint32(146).string(m.SaleNotes1);
            if (m.SaleNotes2 != null && Object.hasOwnProperty.call(m, "SaleNotes2"))
                w.uint32(154).string(m.SaleNotes2);
            if (m.SaleNotes3 != null && Object.hasOwnProperty.call(m, "SaleNotes3"))
                w.uint32(162).string(m.SaleNotes3);
            if (m.SysNotes != null && Object.hasOwnProperty.call(m, "SysNotes"))
                w.uint32(170).string(m.SysNotes);
            if (m.PMTakeaway != null && Object.hasOwnProperty.call(m, "PMTakeaway"))
                w.uint32(176).int32(m.PMTakeaway);
            if (m.PMTakestore != null && Object.hasOwnProperty.call(m, "PMTakestore"))
                w.uint32(184).int32(m.PMTakestore);
            if (m.PMYourself != null && Object.hasOwnProperty.call(m, "PMYourself"))
                w.uint32(192).int32(m.PMYourself);
            if (m.PMShop != null && Object.hasOwnProperty.call(m, "PMShop"))
                w.uint32(200).int32(m.PMShop);
            if (m.HasEmpReserve != null && Object.hasOwnProperty.call(m, "HasEmpReserve"))
                w.uint32(208).int32(m.HasEmpReserve);
            if (m.HasEmpTakeaway != null && Object.hasOwnProperty.call(m, "HasEmpTakeaway"))
                w.uint32(216).int32(m.HasEmpTakeaway);
            if (m.HasEmpYourself != null && Object.hasOwnProperty.call(m, "HasEmpYourself"))
                w.uint32(224).int32(m.HasEmpYourself);
            if (m.HasEmpShop != null && Object.hasOwnProperty.call(m, "HasEmpShop"))
                w.uint32(232).int32(m.HasEmpShop);
            if (m.HasPMPTakeaway != null && Object.hasOwnProperty.call(m, "HasPMPTakeaway"))
                w.uint32(240).int32(m.HasPMPTakeaway);
            if (m.HasPMPYourself != null && Object.hasOwnProperty.call(m, "HasPMPYourself"))
                w.uint32(248).int32(m.HasPMPYourself);
            if (m.HasPMPShop != null && Object.hasOwnProperty.call(m, "HasPMPShop"))
                w.uint32(256).int32(m.HasPMPShop);
            if (m.AllowAgent != null && Object.hasOwnProperty.call(m, "AllowAgent"))
                w.uint32(264).int32(m.AllowAgent);
            if (m.MaxEmpCount != null && Object.hasOwnProperty.call(m, "MaxEmpCount"))
                w.uint32(272).int32(m.MaxEmpCount);
            if (m.CreaterID != null && Object.hasOwnProperty.call(m, "CreaterID"))
                w.uint32(280).uint64(m.CreaterID);
            if (m.UpdateTime != null && Object.hasOwnProperty.call(m, "UpdateTime"))
                w.uint32(288).int64(m.UpdateTime);
            if (m.UpdaterID != null && Object.hasOwnProperty.call(m, "UpdaterID"))
                w.uint32(296).uint64(m.UpdaterID);
            if (m.Estate != null && Object.hasOwnProperty.call(m, "Estate"))
                w.uint32(304).int32(m.Estate);
            return w;
        };

        LicenseType.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.LicenseType();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        m.LicenseTypeID = r.uint64();
                        break;
                    }
                    case 2: {
                        m.Name1 = r.string();
                        break;
                    }
                    case 3: {
                        m.Name2 = r.string();
                        break;
                    }
                    case 4: {
                        m.Name3 = r.string();
                        break;
                    }
                    case 5: {
                        m.SysName = r.string();
                        break;
                    }
                    case 6: {
                        m.MchCategory = r.int32();
                        break;
                    }
                    case 7: {
                        m.Period = r.int32();
                        break;
                    }
                    case 8: {
                        m.Price = r.int64();
                        break;
                    }
                    case 9: {
                        m.AgentPrice = r.int64();
                        break;
                    }
                    case 10: {
                        m.OnlineSales = r.int32();
                        break;
                    }
                    case 11: {
                        m.HasReserve = r.int32();
                        break;
                    }
                    case 12: {
                        m.HasRecharge = r.int32();
                        break;
                    }
                    case 13: {
                        m.HasTakeaway = r.int32();
                        break;
                    }
                    case 14: {
                        m.HasYourself = r.int32();
                        break;
                    }
                    case 15: {
                        m.HasShopTable = r.int32();
                        break;
                    }
                    case 16: {
                        m.Priority = r.int32();
                        break;
                    }
                    case 17: {
                        m.AllowPayLater = r.int32();
                        break;
                    }
                    case 18: {
                        m.SaleNotes1 = r.string();
                        break;
                    }
                    case 19: {
                        m.SaleNotes2 = r.string();
                        break;
                    }
                    case 20: {
                        m.SaleNotes3 = r.string();
                        break;
                    }
                    case 21: {
                        m.SysNotes = r.string();
                        break;
                    }
                    case 22: {
                        m.PMTakeaway = r.int32();
                        break;
                    }
                    case 23: {
                        m.PMTakestore = r.int32();
                        break;
                    }
                    case 24: {
                        m.PMYourself = r.int32();
                        break;
                    }
                    case 25: {
                        m.PMShop = r.int32();
                        break;
                    }
                    case 26: {
                        m.HasEmpReserve = r.int32();
                        break;
                    }
                    case 27: {
                        m.HasEmpTakeaway = r.int32();
                        break;
                    }
                    case 28: {
                        m.HasEmpYourself = r.int32();
                        break;
                    }
                    case 29: {
                        m.HasEmpShop = r.int32();
                        break;
                    }
                    case 30: {
                        m.HasPMPTakeaway = r.int32();
                        break;
                    }
                    case 31: {
                        m.HasPMPYourself = r.int32();
                        break;
                    }
                    case 32: {
                        m.HasPMPShop = r.int32();
                        break;
                    }
                    case 33: {
                        m.AllowAgent = r.int32();
                        break;
                    }
                    case 34: {
                        m.MaxEmpCount = r.int32();
                        break;
                    }
                    case 35: {
                        m.CreaterID = r.uint64();
                        break;
                    }
                    case 36: {
                        m.UpdateTime = r.int64();
                        break;
                    }
                    case 37: {
                        m.UpdaterID = r.uint64();
                        break;
                    }
                    case 38: {
                        m.Estate = r.int32();
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        LicenseType.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.LicenseType";
        };

        return LicenseType;
    })();

    PBEntity.LicenseTypes = (function () {

        function LicenseTypes(p) {
            this.LicenseTypes = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        LicenseTypes.prototype.LicenseTypes = $util.emptyArray;

        LicenseTypes.create = function create(properties) {
            return new LicenseTypes(properties);
        };

        LicenseTypes.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.LicenseTypes != null && m.LicenseTypes.length) {
                for (var i = 0; i < m.LicenseTypes.length; ++i)
                    $root.PBEntity.LicenseType.encode(m.LicenseTypes[i], w.uint32(10).fork()).ldelim();
            }
            return w;
        };

        LicenseTypes.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.LicenseTypes();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        if (!(m.LicenseTypes && m.LicenseTypes.length))
                            m.LicenseTypes = [];
                        m.LicenseTypes.push($root.PBEntity.LicenseType.decode(r, r.uint32()));
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        LicenseTypes.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.LicenseTypes";
        };

        return LicenseTypes;
    })();

    PBEntity.MQClient = (function () {

        function MQClient(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        MQClient.prototype.ID = "";
        MQClient.prototype.ClientID = "";
        MQClient.prototype.PassWord = "";
        MQClient.prototype.VerifyCate = 0;
        MQClient.prototype.MchID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        MQClient.prototype.UserID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        MQClient.prototype.Category = 0;
        MQClient.prototype.IsLimitTopic = 0;
        MQClient.prototype.TopicList = "";
        MQClient.prototype.Perm = 0;
        MQClient.prototype.Name = "";
        MQClient.prototype.ConnectStatus = 0;
        MQClient.prototype.LastConnectTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        MQClient.prototype.LastConnectIP = "";
        MQClient.prototype.OfflineTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        MQClient.prototype.CreateTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        MQClient.prototype.CreaterID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        MQClient.prototype.UpdateTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        MQClient.prototype.UpdaterID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        MQClient.prototype.Estate = 0;

        MQClient.create = function create(properties) {
            return new MQClient(properties);
        };

        MQClient.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.ID != null && Object.hasOwnProperty.call(m, "ID"))
                w.uint32(10).string(m.ID);
            if (m.ClientID != null && Object.hasOwnProperty.call(m, "ClientID"))
                w.uint32(18).string(m.ClientID);
            if (m.PassWord != null && Object.hasOwnProperty.call(m, "PassWord"))
                w.uint32(26).string(m.PassWord);
            if (m.VerifyCate != null && Object.hasOwnProperty.call(m, "VerifyCate"))
                w.uint32(32).int32(m.VerifyCate);
            if (m.MchID != null && Object.hasOwnProperty.call(m, "MchID"))
                w.uint32(40).uint64(m.MchID);
            if (m.UserID != null && Object.hasOwnProperty.call(m, "UserID"))
                w.uint32(48).uint64(m.UserID);
            if (m.Category != null && Object.hasOwnProperty.call(m, "Category"))
                w.uint32(56).int32(m.Category);
            if (m.IsLimitTopic != null && Object.hasOwnProperty.call(m, "IsLimitTopic"))
                w.uint32(64).int32(m.IsLimitTopic);
            if (m.TopicList != null && Object.hasOwnProperty.call(m, "TopicList"))
                w.uint32(74).string(m.TopicList);
            if (m.Perm != null && Object.hasOwnProperty.call(m, "Perm"))
                w.uint32(80).int32(m.Perm);
            if (m.Name != null && Object.hasOwnProperty.call(m, "Name"))
                w.uint32(90).string(m.Name);
            if (m.ConnectStatus != null && Object.hasOwnProperty.call(m, "ConnectStatus"))
                w.uint32(96).int32(m.ConnectStatus);
            if (m.LastConnectTime != null && Object.hasOwnProperty.call(m, "LastConnectTime"))
                w.uint32(104).int64(m.LastConnectTime);
            if (m.LastConnectIP != null && Object.hasOwnProperty.call(m, "LastConnectIP"))
                w.uint32(114).string(m.LastConnectIP);
            if (m.OfflineTime != null && Object.hasOwnProperty.call(m, "OfflineTime"))
                w.uint32(120).int64(m.OfflineTime);
            if (m.CreateTime != null && Object.hasOwnProperty.call(m, "CreateTime"))
                w.uint32(128).int64(m.CreateTime);
            if (m.CreaterID != null && Object.hasOwnProperty.call(m, "CreaterID"))
                w.uint32(136).uint64(m.CreaterID);
            if (m.UpdateTime != null && Object.hasOwnProperty.call(m, "UpdateTime"))
                w.uint32(144).int64(m.UpdateTime);
            if (m.UpdaterID != null && Object.hasOwnProperty.call(m, "UpdaterID"))
                w.uint32(152).uint64(m.UpdaterID);
            if (m.Estate != null && Object.hasOwnProperty.call(m, "Estate"))
                w.uint32(160).int32(m.Estate);
            return w;
        };

        MQClient.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.MQClient();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        m.ID = r.string();
                        break;
                    }
                    case 2: {
                        m.ClientID = r.string();
                        break;
                    }
                    case 3: {
                        m.PassWord = r.string();
                        break;
                    }
                    case 4: {
                        m.VerifyCate = r.int32();
                        break;
                    }
                    case 5: {
                        m.MchID = r.uint64();
                        break;
                    }
                    case 6: {
                        m.UserID = r.uint64();
                        break;
                    }
                    case 7: {
                        m.Category = r.int32();
                        break;
                    }
                    case 8: {
                        m.IsLimitTopic = r.int32();
                        break;
                    }
                    case 9: {
                        m.TopicList = r.string();
                        break;
                    }
                    case 10: {
                        m.Perm = r.int32();
                        break;
                    }
                    case 11: {
                        m.Name = r.string();
                        break;
                    }
                    case 12: {
                        m.ConnectStatus = r.int32();
                        break;
                    }
                    case 13: {
                        m.LastConnectTime = r.int64();
                        break;
                    }
                    case 14: {
                        m.LastConnectIP = r.string();
                        break;
                    }
                    case 15: {
                        m.OfflineTime = r.int64();
                        break;
                    }
                    case 16: {
                        m.CreateTime = r.int64();
                        break;
                    }
                    case 17: {
                        m.CreaterID = r.uint64();
                        break;
                    }
                    case 18: {
                        m.UpdateTime = r.int64();
                        break;
                    }
                    case 19: {
                        m.UpdaterID = r.uint64();
                        break;
                    }
                    case 20: {
                        m.Estate = r.int32();
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        MQClient.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.MQClient";
        };

        return MQClient;
    })();

    PBEntity.MQClients = (function () {

        function MQClients(p) {
            this.MQClients = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        MQClients.prototype.MQClients = $util.emptyArray;

        MQClients.create = function create(properties) {
            return new MQClients(properties);
        };

        MQClients.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.MQClients != null && m.MQClients.length) {
                for (var i = 0; i < m.MQClients.length; ++i)
                    $root.PBEntity.MQClient.encode(m.MQClients[i], w.uint32(10).fork()).ldelim();
            }
            return w;
        };

        MQClients.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.MQClients();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        if (!(m.MQClients && m.MQClients.length))
                            m.MQClients = [];
                        m.MQClients.push($root.PBEntity.MQClient.decode(r, r.uint32()));
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        MQClients.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.MQClients";
        };

        return MQClients;
    })();

    PBEntity.MchApply = (function () {

        function MchApply(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        MchApply.prototype.ApplyID = "";
        MchApply.prototype.ApplicantID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        MchApply.prototype.ApplyDate = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        MchApply.prototype.ApplyIP = "";
        MchApply.prototype.Name = "";
        MchApply.prototype.ShortName = "";
        MchApply.prototype.CertType = 0;
        MchApply.prototype.CertNo = "";
        MchApply.prototype.Address = "";
        MchApply.prototype.LegalPerson = "";
        MchApply.prototype.LegalPersonMobile = "";
        MchApply.prototype.CSPhone = "";
        MchApply.prototype.BusCategory = 0;
        MchApply.prototype.ImgCount = 0;
        MchApply.prototype.ApproveTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        MchApply.prototype.ApproverID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        MchApply.prototype.ApproveIP = "";
        MchApply.prototype.ApproveNotes = "";
        MchApply.prototype.Category = 0;
        MchApply.prototype.BelongID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        MchApply.prototype.MchID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        MchApply.prototype.ApplyState = 0;
        MchApply.prototype.LicenseTypeID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        MchApply.prototype.IsExpire = 0;
        MchApply.prototype.ExpireTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        MchApply.prototype.CountryID = 0;
        MchApply.prototype.CountryName = "";
        MchApply.prototype.ProvinceID = 0;
        MchApply.prototype.ProvinceName = "";
        MchApply.prototype.CityID = 0;
        MchApply.prototype.CityName = "";
        MchApply.prototype.AgentID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        MchApply.prototype.OpenMode = 0;
        MchApply.prototype.LocalAddr = "";
        MchApply.prototype.LocalLongitude = 0;
        MchApply.prototype.LocalLatitude = 0;
        MchApply.prototype.CreateTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        MchApply.prototype.CreaterID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        MchApply.prototype.UpdateTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        MchApply.prototype.UpdaterID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        MchApply.prototype.Estate = 0;

        MchApply.create = function create(properties) {
            return new MchApply(properties);
        };

        MchApply.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.ApplyID != null && Object.hasOwnProperty.call(m, "ApplyID"))
                w.uint32(10).string(m.ApplyID);
            if (m.ApplicantID != null && Object.hasOwnProperty.call(m, "ApplicantID"))
                w.uint32(16).uint64(m.ApplicantID);
            if (m.ApplyDate != null && Object.hasOwnProperty.call(m, "ApplyDate"))
                w.uint32(24).int64(m.ApplyDate);
            if (m.ApplyIP != null && Object.hasOwnProperty.call(m, "ApplyIP"))
                w.uint32(34).string(m.ApplyIP);
            if (m.Name != null && Object.hasOwnProperty.call(m, "Name"))
                w.uint32(42).string(m.Name);
            if (m.ShortName != null && Object.hasOwnProperty.call(m, "ShortName"))
                w.uint32(50).string(m.ShortName);
            if (m.CertType != null && Object.hasOwnProperty.call(m, "CertType"))
                w.uint32(56).int32(m.CertType);
            if (m.CertNo != null && Object.hasOwnProperty.call(m, "CertNo"))
                w.uint32(66).string(m.CertNo);
            if (m.Address != null && Object.hasOwnProperty.call(m, "Address"))
                w.uint32(74).string(m.Address);
            if (m.LegalPerson != null && Object.hasOwnProperty.call(m, "LegalPerson"))
                w.uint32(82).string(m.LegalPerson);
            if (m.LegalPersonMobile != null && Object.hasOwnProperty.call(m, "LegalPersonMobile"))
                w.uint32(90).string(m.LegalPersonMobile);
            if (m.CSPhone != null && Object.hasOwnProperty.call(m, "CSPhone"))
                w.uint32(98).string(m.CSPhone);
            if (m.BusCategory != null && Object.hasOwnProperty.call(m, "BusCategory"))
                w.uint32(104).int32(m.BusCategory);
            if (m.ImgCount != null && Object.hasOwnProperty.call(m, "ImgCount"))
                w.uint32(112).int32(m.ImgCount);
            if (m.ApproveTime != null && Object.hasOwnProperty.call(m, "ApproveTime"))
                w.uint32(120).int64(m.ApproveTime);
            if (m.ApproverID != null && Object.hasOwnProperty.call(m, "ApproverID"))
                w.uint32(128).uint64(m.ApproverID);
            if (m.ApproveIP != null && Object.hasOwnProperty.call(m, "ApproveIP"))
                w.uint32(138).string(m.ApproveIP);
            if (m.ApproveNotes != null && Object.hasOwnProperty.call(m, "ApproveNotes"))
                w.uint32(146).string(m.ApproveNotes);
            if (m.Category != null && Object.hasOwnProperty.call(m, "Category"))
                w.uint32(152).int32(m.Category);
            if (m.BelongID != null && Object.hasOwnProperty.call(m, "BelongID"))
                w.uint32(160).uint64(m.BelongID);
            if (m.MchID != null && Object.hasOwnProperty.call(m, "MchID"))
                w.uint32(168).uint64(m.MchID);
            if (m.ApplyState != null && Object.hasOwnProperty.call(m, "ApplyState"))
                w.uint32(176).int32(m.ApplyState);
            if (m.LicenseTypeID != null && Object.hasOwnProperty.call(m, "LicenseTypeID"))
                w.uint32(184).uint64(m.LicenseTypeID);
            if (m.IsExpire != null && Object.hasOwnProperty.call(m, "IsExpire"))
                w.uint32(192).int32(m.IsExpire);
            if (m.ExpireTime != null && Object.hasOwnProperty.call(m, "ExpireTime"))
                w.uint32(200).int64(m.ExpireTime);
            if (m.CountryID != null && Object.hasOwnProperty.call(m, "CountryID"))
                w.uint32(208).int32(m.CountryID);
            if (m.CountryName != null && Object.hasOwnProperty.call(m, "CountryName"))
                w.uint32(218).string(m.CountryName);
            if (m.ProvinceID != null && Object.hasOwnProperty.call(m, "ProvinceID"))
                w.uint32(224).int32(m.ProvinceID);
            if (m.ProvinceName != null && Object.hasOwnProperty.call(m, "ProvinceName"))
                w.uint32(234).string(m.ProvinceName);
            if (m.CityID != null && Object.hasOwnProperty.call(m, "CityID"))
                w.uint32(240).int32(m.CityID);
            if (m.CityName != null && Object.hasOwnProperty.call(m, "CityName"))
                w.uint32(250).string(m.CityName);
            if (m.AgentID != null && Object.hasOwnProperty.call(m, "AgentID"))
                w.uint32(256).uint64(m.AgentID);
            if (m.OpenMode != null && Object.hasOwnProperty.call(m, "OpenMode"))
                w.uint32(264).int32(m.OpenMode);
            if (m.LocalAddr != null && Object.hasOwnProperty.call(m, "LocalAddr"))
                w.uint32(274).string(m.LocalAddr);
            if (m.LocalLongitude != null && Object.hasOwnProperty.call(m, "LocalLongitude"))
                w.uint32(281).double(m.LocalLongitude);
            if (m.LocalLatitude != null && Object.hasOwnProperty.call(m, "LocalLatitude"))
                w.uint32(289).double(m.LocalLatitude);
            if (m.CreateTime != null && Object.hasOwnProperty.call(m, "CreateTime"))
                w.uint32(296).int64(m.CreateTime);
            if (m.CreaterID != null && Object.hasOwnProperty.call(m, "CreaterID"))
                w.uint32(304).uint64(m.CreaterID);
            if (m.UpdateTime != null && Object.hasOwnProperty.call(m, "UpdateTime"))
                w.uint32(312).int64(m.UpdateTime);
            if (m.UpdaterID != null && Object.hasOwnProperty.call(m, "UpdaterID"))
                w.uint32(320).uint64(m.UpdaterID);
            if (m.Estate != null && Object.hasOwnProperty.call(m, "Estate"))
                w.uint32(328).int32(m.Estate);
            return w;
        };

        MchApply.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.MchApply();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        m.ApplyID = r.string();
                        break;
                    }
                    case 2: {
                        m.ApplicantID = r.uint64();
                        break;
                    }
                    case 3: {
                        m.ApplyDate = r.int64();
                        break;
                    }
                    case 4: {
                        m.ApplyIP = r.string();
                        break;
                    }
                    case 5: {
                        m.Name = r.string();
                        break;
                    }
                    case 6: {
                        m.ShortName = r.string();
                        break;
                    }
                    case 7: {
                        m.CertType = r.int32();
                        break;
                    }
                    case 8: {
                        m.CertNo = r.string();
                        break;
                    }
                    case 9: {
                        m.Address = r.string();
                        break;
                    }
                    case 10: {
                        m.LegalPerson = r.string();
                        break;
                    }
                    case 11: {
                        m.LegalPersonMobile = r.string();
                        break;
                    }
                    case 12: {
                        m.CSPhone = r.string();
                        break;
                    }
                    case 13: {
                        m.BusCategory = r.int32();
                        break;
                    }
                    case 14: {
                        m.ImgCount = r.int32();
                        break;
                    }
                    case 15: {
                        m.ApproveTime = r.int64();
                        break;
                    }
                    case 16: {
                        m.ApproverID = r.uint64();
                        break;
                    }
                    case 17: {
                        m.ApproveIP = r.string();
                        break;
                    }
                    case 18: {
                        m.ApproveNotes = r.string();
                        break;
                    }
                    case 19: {
                        m.Category = r.int32();
                        break;
                    }
                    case 20: {
                        m.BelongID = r.uint64();
                        break;
                    }
                    case 21: {
                        m.MchID = r.uint64();
                        break;
                    }
                    case 22: {
                        m.ApplyState = r.int32();
                        break;
                    }
                    case 23: {
                        m.LicenseTypeID = r.uint64();
                        break;
                    }
                    case 24: {
                        m.IsExpire = r.int32();
                        break;
                    }
                    case 25: {
                        m.ExpireTime = r.int64();
                        break;
                    }
                    case 26: {
                        m.CountryID = r.int32();
                        break;
                    }
                    case 27: {
                        m.CountryName = r.string();
                        break;
                    }
                    case 28: {
                        m.ProvinceID = r.int32();
                        break;
                    }
                    case 29: {
                        m.ProvinceName = r.string();
                        break;
                    }
                    case 30: {
                        m.CityID = r.int32();
                        break;
                    }
                    case 31: {
                        m.CityName = r.string();
                        break;
                    }
                    case 32: {
                        m.AgentID = r.uint64();
                        break;
                    }
                    case 33: {
                        m.OpenMode = r.int32();
                        break;
                    }
                    case 34: {
                        m.LocalAddr = r.string();
                        break;
                    }
                    case 35: {
                        m.LocalLongitude = r.double();
                        break;
                    }
                    case 36: {
                        m.LocalLatitude = r.double();
                        break;
                    }
                    case 37: {
                        m.CreateTime = r.int64();
                        break;
                    }
                    case 38: {
                        m.CreaterID = r.uint64();
                        break;
                    }
                    case 39: {
                        m.UpdateTime = r.int64();
                        break;
                    }
                    case 40: {
                        m.UpdaterID = r.uint64();
                        break;
                    }
                    case 41: {
                        m.Estate = r.int32();
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        MchApply.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.MchApply";
        };

        return MchApply;
    })();

    PBEntity.MchApplys = (function () {

        function MchApplys(p) {
            this.MchApplys = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        MchApplys.prototype.MchApplys = $util.emptyArray;

        MchApplys.create = function create(properties) {
            return new MchApplys(properties);
        };

        MchApplys.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.MchApplys != null && m.MchApplys.length) {
                for (var i = 0; i < m.MchApplys.length; ++i)
                    $root.PBEntity.MchApply.encode(m.MchApplys[i], w.uint32(10).fork()).ldelim();
            }
            return w;
        };

        MchApplys.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.MchApplys();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        if (!(m.MchApplys && m.MchApplys.length))
                            m.MchApplys = [];
                        m.MchApplys.push($root.PBEntity.MchApply.decode(r, r.uint32()));
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        MchApplys.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.MchApplys";
        };

        return MchApplys;
    })();

    PBEntity.MchAuth = (function () {

        function MchAuth(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        MchAuth.prototype.MchID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        MchAuth.prototype.SubjectType = 0;
        MchAuth.prototype.SubjectName = "";
        MchAuth.prototype.SubjectShortName = "";
        MchAuth.prototype.SubjectNo = "";
        MchAuth.prototype.SubjectPhone = "";
        MchAuth.prototype.ProvinceID = 0;
        MchAuth.prototype.CityID = 0;
        MchAuth.prototype.DistrictID = 0;
        MchAuth.prototype.CityName = "";
        MchAuth.prototype.ProvinceName = "";
        MchAuth.prototype.DistrictName = "";
        MchAuth.prototype.SubjectAddress = "";
        MchAuth.prototype.BusinessPhoto = "";
        MchAuth.prototype.BusCategory = 0;
        MchAuth.prototype.SanitaryPermitPhoto = "";
        MchAuth.prototype.StoreHeadPhoto = "";
        MchAuth.prototype.StoreInsidePhoto = "";
        MchAuth.prototype.LPName = "";
        MchAuth.prototype.LPCType = 0;
        MchAuth.prototype.LPCNumber = "";
        MchAuth.prototype.LPCAddress = "";
        MchAuth.prototype.LPMobile = "";
        MchAuth.prototype.LPContact = "";
        MchAuth.prototype.LPEmail = "";
        MchAuth.prototype.LPCValidityDateStart = "";
        MchAuth.prototype.LPCValidityDateEnd = "";
        MchAuth.prototype.LPCPhotoFront = "";
        MchAuth.prototype.LPCPhotoBack = "";
        MchAuth.prototype.LPIsSP = 0;
        MchAuth.prototype.SPName = "";
        MchAuth.prototype.SPCType = 0;
        MchAuth.prototype.SPCNumber = "";
        MchAuth.prototype.SPCAddress = "";
        MchAuth.prototype.SPMobile = "";
        MchAuth.prototype.SPContact = "";
        MchAuth.prototype.SPCValidityDateStart = "";
        MchAuth.prototype.SPCValidityDateEnd = "";
        MchAuth.prototype.SPCPhotoFront = "";
        MchAuth.prototype.SPCPhotoBack = "";
        MchAuth.prototype.BankAccType = 0;
        MchAuth.prototype.BankID = 0;
        MchAuth.prototype.BankAccName = "";
        MchAuth.prototype.BankCityID = 0;
        MchAuth.prototype.BankCityName = "";
        MchAuth.prototype.BankAddrCode = "";
        MchAuth.prototype.BankBranchID = "";
        MchAuth.prototype.BankName = "";
        MchAuth.prototype.BankAccNo = "";
        MchAuth.prototype.AuthState = 0;
        MchAuth.prototype.AuthTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        MchAuth.prototype.CreaterID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        MchAuth.prototype.CreateTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        MchAuth.prototype.UpdaterID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        MchAuth.prototype.UpdateTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        MchAuth.prototype.Estate = 0;

        MchAuth.create = function create(properties) {
            return new MchAuth(properties);
        };

        MchAuth.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.MchID != null && Object.hasOwnProperty.call(m, "MchID"))
                w.uint32(8).uint64(m.MchID);
            if (m.SubjectType != null && Object.hasOwnProperty.call(m, "SubjectType"))
                w.uint32(16).int32(m.SubjectType);
            if (m.SubjectName != null && Object.hasOwnProperty.call(m, "SubjectName"))
                w.uint32(26).string(m.SubjectName);
            if (m.SubjectShortName != null && Object.hasOwnProperty.call(m, "SubjectShortName"))
                w.uint32(34).string(m.SubjectShortName);
            if (m.SubjectNo != null && Object.hasOwnProperty.call(m, "SubjectNo"))
                w.uint32(42).string(m.SubjectNo);
            if (m.SubjectPhone != null && Object.hasOwnProperty.call(m, "SubjectPhone"))
                w.uint32(50).string(m.SubjectPhone);
            if (m.ProvinceID != null && Object.hasOwnProperty.call(m, "ProvinceID"))
                w.uint32(56).int32(m.ProvinceID);
            if (m.CityID != null && Object.hasOwnProperty.call(m, "CityID"))
                w.uint32(64).int32(m.CityID);
            if (m.DistrictID != null && Object.hasOwnProperty.call(m, "DistrictID"))
                w.uint32(72).int32(m.DistrictID);
            if (m.CityName != null && Object.hasOwnProperty.call(m, "CityName"))
                w.uint32(82).string(m.CityName);
            if (m.ProvinceName != null && Object.hasOwnProperty.call(m, "ProvinceName"))
                w.uint32(90).string(m.ProvinceName);
            if (m.DistrictName != null && Object.hasOwnProperty.call(m, "DistrictName"))
                w.uint32(98).string(m.DistrictName);
            if (m.SubjectAddress != null && Object.hasOwnProperty.call(m, "SubjectAddress"))
                w.uint32(106).string(m.SubjectAddress);
            if (m.BusinessPhoto != null && Object.hasOwnProperty.call(m, "BusinessPhoto"))
                w.uint32(114).string(m.BusinessPhoto);
            if (m.BusCategory != null && Object.hasOwnProperty.call(m, "BusCategory"))
                w.uint32(120).int32(m.BusCategory);
            if (m.SanitaryPermitPhoto != null && Object.hasOwnProperty.call(m, "SanitaryPermitPhoto"))
                w.uint32(130).string(m.SanitaryPermitPhoto);
            if (m.StoreHeadPhoto != null && Object.hasOwnProperty.call(m, "StoreHeadPhoto"))
                w.uint32(138).string(m.StoreHeadPhoto);
            if (m.StoreInsidePhoto != null && Object.hasOwnProperty.call(m, "StoreInsidePhoto"))
                w.uint32(146).string(m.StoreInsidePhoto);
            if (m.LPName != null && Object.hasOwnProperty.call(m, "LPName"))
                w.uint32(154).string(m.LPName);
            if (m.LPCType != null && Object.hasOwnProperty.call(m, "LPCType"))
                w.uint32(160).int32(m.LPCType);
            if (m.LPCNumber != null && Object.hasOwnProperty.call(m, "LPCNumber"))
                w.uint32(170).string(m.LPCNumber);
            if (m.LPCAddress != null && Object.hasOwnProperty.call(m, "LPCAddress"))
                w.uint32(178).string(m.LPCAddress);
            if (m.LPMobile != null && Object.hasOwnProperty.call(m, "LPMobile"))
                w.uint32(186).string(m.LPMobile);
            if (m.LPContact != null && Object.hasOwnProperty.call(m, "LPContact"))
                w.uint32(194).string(m.LPContact);
            if (m.LPEmail != null && Object.hasOwnProperty.call(m, "LPEmail"))
                w.uint32(202).string(m.LPEmail);
            if (m.LPCValidityDateStart != null && Object.hasOwnProperty.call(m, "LPCValidityDateStart"))
                w.uint32(210).string(m.LPCValidityDateStart);
            if (m.LPCValidityDateEnd != null && Object.hasOwnProperty.call(m, "LPCValidityDateEnd"))
                w.uint32(218).string(m.LPCValidityDateEnd);
            if (m.LPCPhotoFront != null && Object.hasOwnProperty.call(m, "LPCPhotoFront"))
                w.uint32(226).string(m.LPCPhotoFront);
            if (m.LPCPhotoBack != null && Object.hasOwnProperty.call(m, "LPCPhotoBack"))
                w.uint32(234).string(m.LPCPhotoBack);
            if (m.LPIsSP != null && Object.hasOwnProperty.call(m, "LPIsSP"))
                w.uint32(240).int32(m.LPIsSP);
            if (m.SPName != null && Object.hasOwnProperty.call(m, "SPName"))
                w.uint32(250).string(m.SPName);
            if (m.SPCType != null && Object.hasOwnProperty.call(m, "SPCType"))
                w.uint32(256).int32(m.SPCType);
            if (m.SPCNumber != null && Object.hasOwnProperty.call(m, "SPCNumber"))
                w.uint32(266).string(m.SPCNumber);
            if (m.SPCAddress != null && Object.hasOwnProperty.call(m, "SPCAddress"))
                w.uint32(274).string(m.SPCAddress);
            if (m.SPMobile != null && Object.hasOwnProperty.call(m, "SPMobile"))
                w.uint32(282).string(m.SPMobile);
            if (m.SPContact != null && Object.hasOwnProperty.call(m, "SPContact"))
                w.uint32(290).string(m.SPContact);
            if (m.SPCValidityDateStart != null && Object.hasOwnProperty.call(m, "SPCValidityDateStart"))
                w.uint32(298).string(m.SPCValidityDateStart);
            if (m.SPCValidityDateEnd != null && Object.hasOwnProperty.call(m, "SPCValidityDateEnd"))
                w.uint32(306).string(m.SPCValidityDateEnd);
            if (m.SPCPhotoFront != null && Object.hasOwnProperty.call(m, "SPCPhotoFront"))
                w.uint32(314).string(m.SPCPhotoFront);
            if (m.SPCPhotoBack != null && Object.hasOwnProperty.call(m, "SPCPhotoBack"))
                w.uint32(322).string(m.SPCPhotoBack);
            if (m.BankAccType != null && Object.hasOwnProperty.call(m, "BankAccType"))
                w.uint32(328).int32(m.BankAccType);
            if (m.BankID != null && Object.hasOwnProperty.call(m, "BankID"))
                w.uint32(336).int32(m.BankID);
            if (m.BankAccName != null && Object.hasOwnProperty.call(m, "BankAccName"))
                w.uint32(346).string(m.BankAccName);
            if (m.BankCityID != null && Object.hasOwnProperty.call(m, "BankCityID"))
                w.uint32(352).int32(m.BankCityID);
            if (m.BankCityName != null && Object.hasOwnProperty.call(m, "BankCityName"))
                w.uint32(362).string(m.BankCityName);
            if (m.BankAddrCode != null && Object.hasOwnProperty.call(m, "BankAddrCode"))
                w.uint32(370).string(m.BankAddrCode);
            if (m.BankBranchID != null && Object.hasOwnProperty.call(m, "BankBranchID"))
                w.uint32(378).string(m.BankBranchID);
            if (m.BankName != null && Object.hasOwnProperty.call(m, "BankName"))
                w.uint32(386).string(m.BankName);
            if (m.BankAccNo != null && Object.hasOwnProperty.call(m, "BankAccNo"))
                w.uint32(394).string(m.BankAccNo);
            if (m.AuthState != null && Object.hasOwnProperty.call(m, "AuthState"))
                w.uint32(400).int32(m.AuthState);
            if (m.AuthTime != null && Object.hasOwnProperty.call(m, "AuthTime"))
                w.uint32(408).int64(m.AuthTime);
            if (m.CreaterID != null && Object.hasOwnProperty.call(m, "CreaterID"))
                w.uint32(416).uint64(m.CreaterID);
            if (m.CreateTime != null && Object.hasOwnProperty.call(m, "CreateTime"))
                w.uint32(424).int64(m.CreateTime);
            if (m.UpdaterID != null && Object.hasOwnProperty.call(m, "UpdaterID"))
                w.uint32(432).uint64(m.UpdaterID);
            if (m.UpdateTime != null && Object.hasOwnProperty.call(m, "UpdateTime"))
                w.uint32(440).int64(m.UpdateTime);
            if (m.Estate != null && Object.hasOwnProperty.call(m, "Estate"))
                w.uint32(448).int32(m.Estate);
            return w;
        };

        MchAuth.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.MchAuth();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        m.MchID = r.uint64();
                        break;
                    }
                    case 2: {
                        m.SubjectType = r.int32();
                        break;
                    }
                    case 3: {
                        m.SubjectName = r.string();
                        break;
                    }
                    case 4: {
                        m.SubjectShortName = r.string();
                        break;
                    }
                    case 5: {
                        m.SubjectNo = r.string();
                        break;
                    }
                    case 6: {
                        m.SubjectPhone = r.string();
                        break;
                    }
                    case 7: {
                        m.ProvinceID = r.int32();
                        break;
                    }
                    case 8: {
                        m.CityID = r.int32();
                        break;
                    }
                    case 9: {
                        m.DistrictID = r.int32();
                        break;
                    }
                    case 10: {
                        m.CityName = r.string();
                        break;
                    }
                    case 11: {
                        m.ProvinceName = r.string();
                        break;
                    }
                    case 12: {
                        m.DistrictName = r.string();
                        break;
                    }
                    case 13: {
                        m.SubjectAddress = r.string();
                        break;
                    }
                    case 14: {
                        m.BusinessPhoto = r.string();
                        break;
                    }
                    case 15: {
                        m.BusCategory = r.int32();
                        break;
                    }
                    case 16: {
                        m.SanitaryPermitPhoto = r.string();
                        break;
                    }
                    case 17: {
                        m.StoreHeadPhoto = r.string();
                        break;
                    }
                    case 18: {
                        m.StoreInsidePhoto = r.string();
                        break;
                    }
                    case 19: {
                        m.LPName = r.string();
                        break;
                    }
                    case 20: {
                        m.LPCType = r.int32();
                        break;
                    }
                    case 21: {
                        m.LPCNumber = r.string();
                        break;
                    }
                    case 22: {
                        m.LPCAddress = r.string();
                        break;
                    }
                    case 23: {
                        m.LPMobile = r.string();
                        break;
                    }
                    case 24: {
                        m.LPContact = r.string();
                        break;
                    }
                    case 25: {
                        m.LPEmail = r.string();
                        break;
                    }
                    case 26: {
                        m.LPCValidityDateStart = r.string();
                        break;
                    }
                    case 27: {
                        m.LPCValidityDateEnd = r.string();
                        break;
                    }
                    case 28: {
                        m.LPCPhotoFront = r.string();
                        break;
                    }
                    case 29: {
                        m.LPCPhotoBack = r.string();
                        break;
                    }
                    case 30: {
                        m.LPIsSP = r.int32();
                        break;
                    }
                    case 31: {
                        m.SPName = r.string();
                        break;
                    }
                    case 32: {
                        m.SPCType = r.int32();
                        break;
                    }
                    case 33: {
                        m.SPCNumber = r.string();
                        break;
                    }
                    case 34: {
                        m.SPCAddress = r.string();
                        break;
                    }
                    case 35: {
                        m.SPMobile = r.string();
                        break;
                    }
                    case 36: {
                        m.SPContact = r.string();
                        break;
                    }
                    case 37: {
                        m.SPCValidityDateStart = r.string();
                        break;
                    }
                    case 38: {
                        m.SPCValidityDateEnd = r.string();
                        break;
                    }
                    case 39: {
                        m.SPCPhotoFront = r.string();
                        break;
                    }
                    case 40: {
                        m.SPCPhotoBack = r.string();
                        break;
                    }
                    case 41: {
                        m.BankAccType = r.int32();
                        break;
                    }
                    case 42: {
                        m.BankID = r.int32();
                        break;
                    }
                    case 43: {
                        m.BankAccName = r.string();
                        break;
                    }
                    case 44: {
                        m.BankCityID = r.int32();
                        break;
                    }
                    case 45: {
                        m.BankCityName = r.string();
                        break;
                    }
                    case 46: {
                        m.BankAddrCode = r.string();
                        break;
                    }
                    case 47: {
                        m.BankBranchID = r.string();
                        break;
                    }
                    case 48: {
                        m.BankName = r.string();
                        break;
                    }
                    case 49: {
                        m.BankAccNo = r.string();
                        break;
                    }
                    case 50: {
                        m.AuthState = r.int32();
                        break;
                    }
                    case 51: {
                        m.AuthTime = r.int64();
                        break;
                    }
                    case 52: {
                        m.CreaterID = r.uint64();
                        break;
                    }
                    case 53: {
                        m.CreateTime = r.int64();
                        break;
                    }
                    case 54: {
                        m.UpdaterID = r.uint64();
                        break;
                    }
                    case 55: {
                        m.UpdateTime = r.int64();
                        break;
                    }
                    case 56: {
                        m.Estate = r.int32();
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        MchAuth.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.MchAuth";
        };

        return MchAuth;
    })();

    PBEntity.MchAuths = (function () {

        function MchAuths(p) {
            this.MchAuths = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        MchAuths.prototype.MchAuths = $util.emptyArray;

        MchAuths.create = function create(properties) {
            return new MchAuths(properties);
        };

        MchAuths.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.MchAuths != null && m.MchAuths.length) {
                for (var i = 0; i < m.MchAuths.length; ++i)
                    $root.PBEntity.MchAuth.encode(m.MchAuths[i], w.uint32(10).fork()).ldelim();
            }
            return w;
        };

        MchAuths.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.MchAuths();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        if (!(m.MchAuths && m.MchAuths.length))
                            m.MchAuths = [];
                        m.MchAuths.push($root.PBEntity.MchAuth.decode(r, r.uint32()));
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        MchAuths.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.MchAuths";
        };

        return MchAuths;
    })();

    PBEntity.MchChannel = (function () {

        function MchChannel(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        MchChannel.prototype.MchID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        MchChannel.prototype.Name = "";
        MchChannel.prototype.NeedPwd = 0;
        MchChannel.prototype.Pwd = "";
        MchChannel.prototype.IsPromo = 0;
        MchChannel.prototype.PromoCategory = 0;
        MchChannel.prototype.PromoAmount = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        MchChannel.prototype.DiscountRate = 0;
        MchChannel.prototype.MaxPromoAmount = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        MchChannel.prototype.IsShop = 0;
        MchChannel.prototype.IsTakeAway = 0;
        MchChannel.prototype.IsYourself = 0;
        MchChannel.prototype.IsLimitTime = 0;
        MchChannel.prototype.StartTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        MchChannel.prototype.EndTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        MchChannel.prototype.CreateTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        MchChannel.prototype.CreaterID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        MchChannel.prototype.UpdateTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        MchChannel.prototype.UpdaterID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        MchChannel.prototype.QRCodeType = 0;
        MchChannel.prototype.QRCodeID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        MchChannel.prototype.Estate = 0;
        MchChannel.prototype.JoinLimitPhone = 0;

        MchChannel.create = function create(properties) {
            return new MchChannel(properties);
        };

        MchChannel.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.MchID != null && Object.hasOwnProperty.call(m, "MchID"))
                w.uint32(8).uint64(m.MchID);
            if (m.Name != null && Object.hasOwnProperty.call(m, "Name"))
                w.uint32(18).string(m.Name);
            if (m.NeedPwd != null && Object.hasOwnProperty.call(m, "NeedPwd"))
                w.uint32(24).int32(m.NeedPwd);
            if (m.Pwd != null && Object.hasOwnProperty.call(m, "Pwd"))
                w.uint32(34).string(m.Pwd);
            if (m.IsPromo != null && Object.hasOwnProperty.call(m, "IsPromo"))
                w.uint32(40).int32(m.IsPromo);
            if (m.PromoCategory != null && Object.hasOwnProperty.call(m, "PromoCategory"))
                w.uint32(48).int32(m.PromoCategory);
            if (m.PromoAmount != null && Object.hasOwnProperty.call(m, "PromoAmount"))
                w.uint32(56).int64(m.PromoAmount);
            if (m.DiscountRate != null && Object.hasOwnProperty.call(m, "DiscountRate"))
                w.uint32(64).int32(m.DiscountRate);
            if (m.MaxPromoAmount != null && Object.hasOwnProperty.call(m, "MaxPromoAmount"))
                w.uint32(72).int64(m.MaxPromoAmount);
            if (m.IsShop != null && Object.hasOwnProperty.call(m, "IsShop"))
                w.uint32(80).int32(m.IsShop);
            if (m.IsTakeAway != null && Object.hasOwnProperty.call(m, "IsTakeAway"))
                w.uint32(88).int32(m.IsTakeAway);
            if (m.IsYourself != null && Object.hasOwnProperty.call(m, "IsYourself"))
                w.uint32(96).int32(m.IsYourself);
            if (m.IsLimitTime != null && Object.hasOwnProperty.call(m, "IsLimitTime"))
                w.uint32(104).int32(m.IsLimitTime);
            if (m.StartTime != null && Object.hasOwnProperty.call(m, "StartTime"))
                w.uint32(112).int64(m.StartTime);
            if (m.EndTime != null && Object.hasOwnProperty.call(m, "EndTime"))
                w.uint32(120).int64(m.EndTime);
            if (m.CreateTime != null && Object.hasOwnProperty.call(m, "CreateTime"))
                w.uint32(128).int64(m.CreateTime);
            if (m.CreaterID != null && Object.hasOwnProperty.call(m, "CreaterID"))
                w.uint32(136).uint64(m.CreaterID);
            if (m.UpdateTime != null && Object.hasOwnProperty.call(m, "UpdateTime"))
                w.uint32(144).int64(m.UpdateTime);
            if (m.UpdaterID != null && Object.hasOwnProperty.call(m, "UpdaterID"))
                w.uint32(152).uint64(m.UpdaterID);
            if (m.QRCodeType != null && Object.hasOwnProperty.call(m, "QRCodeType"))
                w.uint32(160).int32(m.QRCodeType);
            if (m.QRCodeID != null && Object.hasOwnProperty.call(m, "QRCodeID"))
                w.uint32(168).uint64(m.QRCodeID);
            if (m.Estate != null && Object.hasOwnProperty.call(m, "Estate"))
                w.uint32(176).int32(m.Estate);
            if (m.JoinLimitPhone != null && Object.hasOwnProperty.call(m, "JoinLimitPhone"))
                w.uint32(184).int32(m.JoinLimitPhone);
            return w;
        };

        MchChannel.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.MchChannel();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        m.MchID = r.uint64();
                        break;
                    }
                    case 2: {
                        m.Name = r.string();
                        break;
                    }
                    case 3: {
                        m.NeedPwd = r.int32();
                        break;
                    }
                    case 4: {
                        m.Pwd = r.string();
                        break;
                    }
                    case 5: {
                        m.IsPromo = r.int32();
                        break;
                    }
                    case 6: {
                        m.PromoCategory = r.int32();
                        break;
                    }
                    case 7: {
                        m.PromoAmount = r.int64();
                        break;
                    }
                    case 8: {
                        m.DiscountRate = r.int32();
                        break;
                    }
                    case 9: {
                        m.MaxPromoAmount = r.int64();
                        break;
                    }
                    case 10: {
                        m.IsShop = r.int32();
                        break;
                    }
                    case 11: {
                        m.IsTakeAway = r.int32();
                        break;
                    }
                    case 12: {
                        m.IsYourself = r.int32();
                        break;
                    }
                    case 13: {
                        m.IsLimitTime = r.int32();
                        break;
                    }
                    case 14: {
                        m.StartTime = r.int64();
                        break;
                    }
                    case 15: {
                        m.EndTime = r.int64();
                        break;
                    }
                    case 16: {
                        m.CreateTime = r.int64();
                        break;
                    }
                    case 17: {
                        m.CreaterID = r.uint64();
                        break;
                    }
                    case 18: {
                        m.UpdateTime = r.int64();
                        break;
                    }
                    case 19: {
                        m.UpdaterID = r.uint64();
                        break;
                    }
                    case 20: {
                        m.QRCodeType = r.int32();
                        break;
                    }
                    case 21: {
                        m.QRCodeID = r.uint64();
                        break;
                    }
                    case 22: {
                        m.Estate = r.int32();
                        break;
                    }
                    case 23: {
                        m.JoinLimitPhone = r.int32();
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        MchChannel.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.MchChannel";
        };

        return MchChannel;
    })();

    PBEntity.MchChannels = (function () {

        function MchChannels(p) {
            this.MchChannels = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        MchChannels.prototype.MchChannels = $util.emptyArray;

        MchChannels.create = function create(properties) {
            return new MchChannels(properties);
        };

        MchChannels.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.MchChannels != null && m.MchChannels.length) {
                for (var i = 0; i < m.MchChannels.length; ++i)
                    $root.PBEntity.MchChannel.encode(m.MchChannels[i], w.uint32(10).fork()).ldelim();
            }
            return w;
        };

        MchChannels.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.MchChannels();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        if (!(m.MchChannels && m.MchChannels.length))
                            m.MchChannels = [];
                        m.MchChannels.push($root.PBEntity.MchChannel.decode(r, r.uint32()));
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        MchChannels.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.MchChannels";
        };

        return MchChannels;
    })();

    PBEntity.MchCharge = (function () {

        function MchCharge(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        MchCharge.prototype.ID = "";
        MchCharge.prototype.MchID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        MchCharge.prototype.UserID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        MchCharge.prototype.UUID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        MchCharge.prototype.TransDate = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        MchCharge.prototype.ChargeCategory = 0;
        MchCharge.prototype.ReID = "";
        MchCharge.prototype.AtTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        MchCharge.prototype.AtChannel = 0;
        MchCharge.prototype.OrderNotes = "";
        MchCharge.prototype.OrderState = 0;
        MchCharge.prototype.RevenueAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        MchCharge.prototype.IsUsePoints = 0;
        MchCharge.prototype.UsePoints = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        MchCharge.prototype.UsePointsRate = 0;
        MchCharge.prototype.UsePointsAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        MchCharge.prototype.ReceiptAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        MchCharge.prototype.IsUseAdvAmt = 0;
        MchCharge.prototype.UseAdvAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        MchCharge.prototype.PayPlatform = 0;
        MchCharge.prototype.PayChannel = 0;
        MchCharge.prototype.PayState = 0;
        MchCharge.prototype.PayExpires = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        MchCharge.prototype.PayTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        MchCharge.prototype.PayAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        MchCharge.prototype.PayID = "";
        MchCharge.prototype.GroupID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        MchCharge.prototype.AgentID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        MchCharge.prototype.IsRefund = 0;
        MchCharge.prototype.IsComm = 0;
        MchCharge.prototype.FromIP = "";
        MchCharge.prototype.FromTokeID = "";
        MchCharge.prototype.CheckState = 0;
        MchCharge.prototype.IsPrint = 0;
        MchCharge.prototype.IsSubsMsg = 0;
        MchCharge.prototype.IsNotice = 0;
        MchCharge.prototype.FinishTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        MchCharge.prototype.RefundAmtState = 0;
        MchCharge.prototype.RefundAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        MchCharge.prototype.CreateTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        MchCharge.prototype.CreaterID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        MchCharge.prototype.UpdateTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        MchCharge.prototype.UpdaterID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        MchCharge.prototype.Estate = 0;

        MchCharge.create = function create(properties) {
            return new MchCharge(properties);
        };

        MchCharge.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.ID != null && Object.hasOwnProperty.call(m, "ID"))
                w.uint32(10).string(m.ID);
            if (m.MchID != null && Object.hasOwnProperty.call(m, "MchID"))
                w.uint32(16).uint64(m.MchID);
            if (m.UserID != null && Object.hasOwnProperty.call(m, "UserID"))
                w.uint32(24).uint64(m.UserID);
            if (m.UUID != null && Object.hasOwnProperty.call(m, "UUID"))
                w.uint32(32).uint64(m.UUID);
            if (m.TransDate != null && Object.hasOwnProperty.call(m, "TransDate"))
                w.uint32(40).int64(m.TransDate);
            if (m.ChargeCategory != null && Object.hasOwnProperty.call(m, "ChargeCategory"))
                w.uint32(48).int32(m.ChargeCategory);
            if (m.ReID != null && Object.hasOwnProperty.call(m, "ReID"))
                w.uint32(58).string(m.ReID);
            if (m.AtTime != null && Object.hasOwnProperty.call(m, "AtTime"))
                w.uint32(64).int64(m.AtTime);
            if (m.AtChannel != null && Object.hasOwnProperty.call(m, "AtChannel"))
                w.uint32(72).int32(m.AtChannel);
            if (m.OrderNotes != null && Object.hasOwnProperty.call(m, "OrderNotes"))
                w.uint32(82).string(m.OrderNotes);
            if (m.OrderState != null && Object.hasOwnProperty.call(m, "OrderState"))
                w.uint32(88).int32(m.OrderState);
            if (m.RevenueAmt != null && Object.hasOwnProperty.call(m, "RevenueAmt"))
                w.uint32(96).int64(m.RevenueAmt);
            if (m.IsUsePoints != null && Object.hasOwnProperty.call(m, "IsUsePoints"))
                w.uint32(104).int32(m.IsUsePoints);
            if (m.UsePoints != null && Object.hasOwnProperty.call(m, "UsePoints"))
                w.uint32(112).int64(m.UsePoints);
            if (m.UsePointsRate != null && Object.hasOwnProperty.call(m, "UsePointsRate"))
                w.uint32(120).int32(m.UsePointsRate);
            if (m.UsePointsAmt != null && Object.hasOwnProperty.call(m, "UsePointsAmt"))
                w.uint32(128).int64(m.UsePointsAmt);
            if (m.ReceiptAmt != null && Object.hasOwnProperty.call(m, "ReceiptAmt"))
                w.uint32(136).int64(m.ReceiptAmt);
            if (m.IsUseAdvAmt != null && Object.hasOwnProperty.call(m, "IsUseAdvAmt"))
                w.uint32(144).int32(m.IsUseAdvAmt);
            if (m.UseAdvAmt != null && Object.hasOwnProperty.call(m, "UseAdvAmt"))
                w.uint32(152).int64(m.UseAdvAmt);
            if (m.PayPlatform != null && Object.hasOwnProperty.call(m, "PayPlatform"))
                w.uint32(160).int32(m.PayPlatform);
            if (m.PayChannel != null && Object.hasOwnProperty.call(m, "PayChannel"))
                w.uint32(168).int32(m.PayChannel);
            if (m.PayState != null && Object.hasOwnProperty.call(m, "PayState"))
                w.uint32(176).int32(m.PayState);
            if (m.PayExpires != null && Object.hasOwnProperty.call(m, "PayExpires"))
                w.uint32(184).int64(m.PayExpires);
            if (m.PayTime != null && Object.hasOwnProperty.call(m, "PayTime"))
                w.uint32(192).int64(m.PayTime);
            if (m.PayAmt != null && Object.hasOwnProperty.call(m, "PayAmt"))
                w.uint32(200).int64(m.PayAmt);
            if (m.PayID != null && Object.hasOwnProperty.call(m, "PayID"))
                w.uint32(210).string(m.PayID);
            if (m.GroupID != null && Object.hasOwnProperty.call(m, "GroupID"))
                w.uint32(216).uint64(m.GroupID);
            if (m.AgentID != null && Object.hasOwnProperty.call(m, "AgentID"))
                w.uint32(224).uint64(m.AgentID);
            if (m.IsRefund != null && Object.hasOwnProperty.call(m, "IsRefund"))
                w.uint32(232).int32(m.IsRefund);
            if (m.IsComm != null && Object.hasOwnProperty.call(m, "IsComm"))
                w.uint32(240).int32(m.IsComm);
            if (m.FromIP != null && Object.hasOwnProperty.call(m, "FromIP"))
                w.uint32(250).string(m.FromIP);
            if (m.FromTokeID != null && Object.hasOwnProperty.call(m, "FromTokeID"))
                w.uint32(258).string(m.FromTokeID);
            if (m.CheckState != null && Object.hasOwnProperty.call(m, "CheckState"))
                w.uint32(264).int32(m.CheckState);
            if (m.IsPrint != null && Object.hasOwnProperty.call(m, "IsPrint"))
                w.uint32(272).int32(m.IsPrint);
            if (m.IsSubsMsg != null && Object.hasOwnProperty.call(m, "IsSubsMsg"))
                w.uint32(280).int32(m.IsSubsMsg);
            if (m.IsNotice != null && Object.hasOwnProperty.call(m, "IsNotice"))
                w.uint32(288).int32(m.IsNotice);
            if (m.FinishTime != null && Object.hasOwnProperty.call(m, "FinishTime"))
                w.uint32(296).int64(m.FinishTime);
            if (m.RefundAmtState != null && Object.hasOwnProperty.call(m, "RefundAmtState"))
                w.uint32(304).int32(m.RefundAmtState);
            if (m.RefundAmt != null && Object.hasOwnProperty.call(m, "RefundAmt"))
                w.uint32(312).int64(m.RefundAmt);
            if (m.CreateTime != null && Object.hasOwnProperty.call(m, "CreateTime"))
                w.uint32(320).int64(m.CreateTime);
            if (m.CreaterID != null && Object.hasOwnProperty.call(m, "CreaterID"))
                w.uint32(328).uint64(m.CreaterID);
            if (m.UpdateTime != null && Object.hasOwnProperty.call(m, "UpdateTime"))
                w.uint32(336).int64(m.UpdateTime);
            if (m.UpdaterID != null && Object.hasOwnProperty.call(m, "UpdaterID"))
                w.uint32(344).uint64(m.UpdaterID);
            if (m.Estate != null && Object.hasOwnProperty.call(m, "Estate"))
                w.uint32(352).int32(m.Estate);
            return w;
        };

        MchCharge.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.MchCharge();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        m.ID = r.string();
                        break;
                    }
                    case 2: {
                        m.MchID = r.uint64();
                        break;
                    }
                    case 3: {
                        m.UserID = r.uint64();
                        break;
                    }
                    case 4: {
                        m.UUID = r.uint64();
                        break;
                    }
                    case 5: {
                        m.TransDate = r.int64();
                        break;
                    }
                    case 6: {
                        m.ChargeCategory = r.int32();
                        break;
                    }
                    case 7: {
                        m.ReID = r.string();
                        break;
                    }
                    case 8: {
                        m.AtTime = r.int64();
                        break;
                    }
                    case 9: {
                        m.AtChannel = r.int32();
                        break;
                    }
                    case 10: {
                        m.OrderNotes = r.string();
                        break;
                    }
                    case 11: {
                        m.OrderState = r.int32();
                        break;
                    }
                    case 12: {
                        m.RevenueAmt = r.int64();
                        break;
                    }
                    case 13: {
                        m.IsUsePoints = r.int32();
                        break;
                    }
                    case 14: {
                        m.UsePoints = r.int64();
                        break;
                    }
                    case 15: {
                        m.UsePointsRate = r.int32();
                        break;
                    }
                    case 16: {
                        m.UsePointsAmt = r.int64();
                        break;
                    }
                    case 17: {
                        m.ReceiptAmt = r.int64();
                        break;
                    }
                    case 18: {
                        m.IsUseAdvAmt = r.int32();
                        break;
                    }
                    case 19: {
                        m.UseAdvAmt = r.int64();
                        break;
                    }
                    case 20: {
                        m.PayPlatform = r.int32();
                        break;
                    }
                    case 21: {
                        m.PayChannel = r.int32();
                        break;
                    }
                    case 22: {
                        m.PayState = r.int32();
                        break;
                    }
                    case 23: {
                        m.PayExpires = r.int64();
                        break;
                    }
                    case 24: {
                        m.PayTime = r.int64();
                        break;
                    }
                    case 25: {
                        m.PayAmt = r.int64();
                        break;
                    }
                    case 26: {
                        m.PayID = r.string();
                        break;
                    }
                    case 27: {
                        m.GroupID = r.uint64();
                        break;
                    }
                    case 28: {
                        m.AgentID = r.uint64();
                        break;
                    }
                    case 29: {
                        m.IsRefund = r.int32();
                        break;
                    }
                    case 30: {
                        m.IsComm = r.int32();
                        break;
                    }
                    case 31: {
                        m.FromIP = r.string();
                        break;
                    }
                    case 32: {
                        m.FromTokeID = r.string();
                        break;
                    }
                    case 33: {
                        m.CheckState = r.int32();
                        break;
                    }
                    case 34: {
                        m.IsPrint = r.int32();
                        break;
                    }
                    case 35: {
                        m.IsSubsMsg = r.int32();
                        break;
                    }
                    case 36: {
                        m.IsNotice = r.int32();
                        break;
                    }
                    case 37: {
                        m.FinishTime = r.int64();
                        break;
                    }
                    case 38: {
                        m.RefundAmtState = r.int32();
                        break;
                    }
                    case 39: {
                        m.RefundAmt = r.int64();
                        break;
                    }
                    case 40: {
                        m.CreateTime = r.int64();
                        break;
                    }
                    case 41: {
                        m.CreaterID = r.uint64();
                        break;
                    }
                    case 42: {
                        m.UpdateTime = r.int64();
                        break;
                    }
                    case 43: {
                        m.UpdaterID = r.uint64();
                        break;
                    }
                    case 44: {
                        m.Estate = r.int32();
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        MchCharge.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.MchCharge";
        };

        return MchCharge;
    })();

    PBEntity.MchCharges = (function () {

        function MchCharges(p) {
            this.MchCharges = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        MchCharges.prototype.MchCharges = $util.emptyArray;

        MchCharges.create = function create(properties) {
            return new MchCharges(properties);
        };

        MchCharges.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.MchCharges != null && m.MchCharges.length) {
                for (var i = 0; i < m.MchCharges.length; ++i)
                    $root.PBEntity.MchCharge.encode(m.MchCharges[i], w.uint32(10).fork()).ldelim();
            }
            return w;
        };

        MchCharges.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.MchCharges();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        if (!(m.MchCharges && m.MchCharges.length))
                            m.MchCharges = [];
                        m.MchCharges.push($root.PBEntity.MchCharge.decode(r, r.uint32()));
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        MchCharges.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.MchCharges";
        };

        return MchCharges;
    })();

    PBEntity.MchDesk = (function () {

        function MchDesk(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        MchDesk.prototype.DeskID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        MchDesk.prototype.MchID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        MchDesk.prototype.Name1 = "";
        MchDesk.prototype.Category = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        MchDesk.prototype.Name2 = "";
        MchDesk.prototype.Name3 = "";
        MchDesk.prototype.MinMembers = 0;
        MchDesk.prototype.SMinMembers = 0;
        MchDesk.prototype.SMaxMembers = 0;
        MchDesk.prototype.Priority = 0;
        MchDesk.prototype.State = 0;
        MchDesk.prototype.QRCodeType = 0;
        MchDesk.prototype.QRCodeID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        MchDesk.prototype.CurStartTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        MchDesk.prototype.CurMembers = 0;
        MchDesk.prototype.CurNotes = "";
        MchDesk.prototype.CurUseFrom = 0;
        MchDesk.prototype.CurDeskUseID = "";
        MchDesk.prototype.CurDaySeq = 0;
        MchDesk.prototype.CurOpenUserID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        MchDesk.prototype.CreateTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        MchDesk.prototype.CreaterID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        MchDesk.prototype.UpdateTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        MchDesk.prototype.UpdaterID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        MchDesk.prototype.Estate = 0;

        MchDesk.create = function create(properties) {
            return new MchDesk(properties);
        };

        MchDesk.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.DeskID != null && Object.hasOwnProperty.call(m, "DeskID"))
                w.uint32(8).uint64(m.DeskID);
            if (m.MchID != null && Object.hasOwnProperty.call(m, "MchID"))
                w.uint32(16).uint64(m.MchID);
            if (m.Name1 != null && Object.hasOwnProperty.call(m, "Name1"))
                w.uint32(26).string(m.Name1);
            if (m.Category != null && Object.hasOwnProperty.call(m, "Category"))
                w.uint32(32).uint64(m.Category);
            if (m.Name2 != null && Object.hasOwnProperty.call(m, "Name2"))
                w.uint32(42).string(m.Name2);
            if (m.Name3 != null && Object.hasOwnProperty.call(m, "Name3"))
                w.uint32(50).string(m.Name3);
            if (m.MinMembers != null && Object.hasOwnProperty.call(m, "MinMembers"))
                w.uint32(56).int32(m.MinMembers);
            if (m.SMinMembers != null && Object.hasOwnProperty.call(m, "SMinMembers"))
                w.uint32(64).int32(m.SMinMembers);
            if (m.SMaxMembers != null && Object.hasOwnProperty.call(m, "SMaxMembers"))
                w.uint32(72).int32(m.SMaxMembers);
            if (m.Priority != null && Object.hasOwnProperty.call(m, "Priority"))
                w.uint32(80).int32(m.Priority);
            if (m.State != null && Object.hasOwnProperty.call(m, "State"))
                w.uint32(88).int32(m.State);
            if (m.QRCodeType != null && Object.hasOwnProperty.call(m, "QRCodeType"))
                w.uint32(96).int32(m.QRCodeType);
            if (m.QRCodeID != null && Object.hasOwnProperty.call(m, "QRCodeID"))
                w.uint32(104).uint64(m.QRCodeID);
            if (m.CurStartTime != null && Object.hasOwnProperty.call(m, "CurStartTime"))
                w.uint32(112).int64(m.CurStartTime);
            if (m.CurMembers != null && Object.hasOwnProperty.call(m, "CurMembers"))
                w.uint32(120).int32(m.CurMembers);
            if (m.CurNotes != null && Object.hasOwnProperty.call(m, "CurNotes"))
                w.uint32(130).string(m.CurNotes);
            if (m.CurUseFrom != null && Object.hasOwnProperty.call(m, "CurUseFrom"))
                w.uint32(136).int32(m.CurUseFrom);
            if (m.CurDeskUseID != null && Object.hasOwnProperty.call(m, "CurDeskUseID"))
                w.uint32(146).string(m.CurDeskUseID);
            if (m.CurDaySeq != null && Object.hasOwnProperty.call(m, "CurDaySeq"))
                w.uint32(152).int32(m.CurDaySeq);
            if (m.CurOpenUserID != null && Object.hasOwnProperty.call(m, "CurOpenUserID"))
                w.uint32(160).uint64(m.CurOpenUserID);
            if (m.CreateTime != null && Object.hasOwnProperty.call(m, "CreateTime"))
                w.uint32(168).int64(m.CreateTime);
            if (m.CreaterID != null && Object.hasOwnProperty.call(m, "CreaterID"))
                w.uint32(176).uint64(m.CreaterID);
            if (m.UpdateTime != null && Object.hasOwnProperty.call(m, "UpdateTime"))
                w.uint32(184).int64(m.UpdateTime);
            if (m.UpdaterID != null && Object.hasOwnProperty.call(m, "UpdaterID"))
                w.uint32(192).uint64(m.UpdaterID);
            if (m.Estate != null && Object.hasOwnProperty.call(m, "Estate"))
                w.uint32(200).int32(m.Estate);
            return w;
        };

        MchDesk.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.MchDesk();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        m.DeskID = r.uint64();
                        break;
                    }
                    case 2: {
                        m.MchID = r.uint64();
                        break;
                    }
                    case 3: {
                        m.Name1 = r.string();
                        break;
                    }
                    case 4: {
                        m.Category = r.uint64();
                        break;
                    }
                    case 5: {
                        m.Name2 = r.string();
                        break;
                    }
                    case 6: {
                        m.Name3 = r.string();
                        break;
                    }
                    case 7: {
                        m.MinMembers = r.int32();
                        break;
                    }
                    case 8: {
                        m.SMinMembers = r.int32();
                        break;
                    }
                    case 9: {
                        m.SMaxMembers = r.int32();
                        break;
                    }
                    case 10: {
                        m.Priority = r.int32();
                        break;
                    }
                    case 11: {
                        m.State = r.int32();
                        break;
                    }
                    case 12: {
                        m.QRCodeType = r.int32();
                        break;
                    }
                    case 13: {
                        m.QRCodeID = r.uint64();
                        break;
                    }
                    case 14: {
                        m.CurStartTime = r.int64();
                        break;
                    }
                    case 15: {
                        m.CurMembers = r.int32();
                        break;
                    }
                    case 16: {
                        m.CurNotes = r.string();
                        break;
                    }
                    case 17: {
                        m.CurUseFrom = r.int32();
                        break;
                    }
                    case 18: {
                        m.CurDeskUseID = r.string();
                        break;
                    }
                    case 19: {
                        m.CurDaySeq = r.int32();
                        break;
                    }
                    case 20: {
                        m.CurOpenUserID = r.uint64();
                        break;
                    }
                    case 21: {
                        m.CreateTime = r.int64();
                        break;
                    }
                    case 22: {
                        m.CreaterID = r.uint64();
                        break;
                    }
                    case 23: {
                        m.UpdateTime = r.int64();
                        break;
                    }
                    case 24: {
                        m.UpdaterID = r.uint64();
                        break;
                    }
                    case 25: {
                        m.Estate = r.int32();
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        MchDesk.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.MchDesk";
        };

        return MchDesk;
    })();

    PBEntity.MchDesks = (function () {

        function MchDesks(p) {
            this.MchDesks = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        MchDesks.prototype.MchDesks = $util.emptyArray;

        MchDesks.create = function create(properties) {
            return new MchDesks(properties);
        };

        MchDesks.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.MchDesks != null && m.MchDesks.length) {
                for (var i = 0; i < m.MchDesks.length; ++i)
                    $root.PBEntity.MchDesk.encode(m.MchDesks[i], w.uint32(10).fork()).ldelim();
            }
            return w;
        };

        MchDesks.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.MchDesks();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        if (!(m.MchDesks && m.MchDesks.length))
                            m.MchDesks = [];
                        m.MchDesks.push($root.PBEntity.MchDesk.decode(r, r.uint32()));
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        MchDesks.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.MchDesks";
        };

        return MchDesks;
    })();

    PBEntity.MchDeskCategory = (function () {

        function MchDeskCategory(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        MchDeskCategory.prototype.DeskCateID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        MchDeskCategory.prototype.MchID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        MchDeskCategory.prototype.Name1 = "";
        MchDeskCategory.prototype.Name2 = "";
        MchDeskCategory.prototype.Name3 = "";
        MchDeskCategory.prototype.IsOnline = 0;
        MchDeskCategory.prototype.IsPos = 0;
        MchDeskCategory.prototype.Priority = 0;
        MchDeskCategory.prototype.IsDeposit = 0;
        MchDeskCategory.prototype.Deposit = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        MchDeskCategory.prototype.IsMinAmount = 0;
        MchDeskCategory.prototype.MinAmount = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        MchDeskCategory.prototype.IsTeaFee = 0;
        MchDeskCategory.prototype.TeaFee = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        MchDeskCategory.prototype.IsMealSeatFee = 0;
        MchDeskCategory.prototype.MealSeatFee = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        MchDeskCategory.prototype.IsOpenBySelf = 0;
        MchDeskCategory.prototype.CreateTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        MchDeskCategory.prototype.CreaterID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        MchDeskCategory.prototype.UpdateTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        MchDeskCategory.prototype.UpdaterID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        MchDeskCategory.prototype.Estate = 0;

        MchDeskCategory.create = function create(properties) {
            return new MchDeskCategory(properties);
        };

        MchDeskCategory.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.DeskCateID != null && Object.hasOwnProperty.call(m, "DeskCateID"))
                w.uint32(8).uint64(m.DeskCateID);
            if (m.MchID != null && Object.hasOwnProperty.call(m, "MchID"))
                w.uint32(16).uint64(m.MchID);
            if (m.Name1 != null && Object.hasOwnProperty.call(m, "Name1"))
                w.uint32(26).string(m.Name1);
            if (m.Name2 != null && Object.hasOwnProperty.call(m, "Name2"))
                w.uint32(34).string(m.Name2);
            if (m.Name3 != null && Object.hasOwnProperty.call(m, "Name3"))
                w.uint32(42).string(m.Name3);
            if (m.IsOnline != null && Object.hasOwnProperty.call(m, "IsOnline"))
                w.uint32(48).int32(m.IsOnline);
            if (m.IsPos != null && Object.hasOwnProperty.call(m, "IsPos"))
                w.uint32(56).int32(m.IsPos);
            if (m.Priority != null && Object.hasOwnProperty.call(m, "Priority"))
                w.uint32(64).int32(m.Priority);
            if (m.IsDeposit != null && Object.hasOwnProperty.call(m, "IsDeposit"))
                w.uint32(72).int32(m.IsDeposit);
            if (m.Deposit != null && Object.hasOwnProperty.call(m, "Deposit"))
                w.uint32(80).int64(m.Deposit);
            if (m.IsMinAmount != null && Object.hasOwnProperty.call(m, "IsMinAmount"))
                w.uint32(88).int32(m.IsMinAmount);
            if (m.MinAmount != null && Object.hasOwnProperty.call(m, "MinAmount"))
                w.uint32(96).int64(m.MinAmount);
            if (m.IsTeaFee != null && Object.hasOwnProperty.call(m, "IsTeaFee"))
                w.uint32(104).int32(m.IsTeaFee);
            if (m.TeaFee != null && Object.hasOwnProperty.call(m, "TeaFee"))
                w.uint32(112).int64(m.TeaFee);
            if (m.IsMealSeatFee != null && Object.hasOwnProperty.call(m, "IsMealSeatFee"))
                w.uint32(120).int32(m.IsMealSeatFee);
            if (m.MealSeatFee != null && Object.hasOwnProperty.call(m, "MealSeatFee"))
                w.uint32(128).int64(m.MealSeatFee);
            if (m.IsOpenBySelf != null && Object.hasOwnProperty.call(m, "IsOpenBySelf"))
                w.uint32(136).int32(m.IsOpenBySelf);
            if (m.CreateTime != null && Object.hasOwnProperty.call(m, "CreateTime"))
                w.uint32(144).int64(m.CreateTime);
            if (m.CreaterID != null && Object.hasOwnProperty.call(m, "CreaterID"))
                w.uint32(152).uint64(m.CreaterID);
            if (m.UpdateTime != null && Object.hasOwnProperty.call(m, "UpdateTime"))
                w.uint32(160).int64(m.UpdateTime);
            if (m.UpdaterID != null && Object.hasOwnProperty.call(m, "UpdaterID"))
                w.uint32(168).uint64(m.UpdaterID);
            if (m.Estate != null && Object.hasOwnProperty.call(m, "Estate"))
                w.uint32(176).int32(m.Estate);
            return w;
        };

        MchDeskCategory.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.MchDeskCategory();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        m.DeskCateID = r.uint64();
                        break;
                    }
                    case 2: {
                        m.MchID = r.uint64();
                        break;
                    }
                    case 3: {
                        m.Name1 = r.string();
                        break;
                    }
                    case 4: {
                        m.Name2 = r.string();
                        break;
                    }
                    case 5: {
                        m.Name3 = r.string();
                        break;
                    }
                    case 6: {
                        m.IsOnline = r.int32();
                        break;
                    }
                    case 7: {
                        m.IsPos = r.int32();
                        break;
                    }
                    case 8: {
                        m.Priority = r.int32();
                        break;
                    }
                    case 9: {
                        m.IsDeposit = r.int32();
                        break;
                    }
                    case 10: {
                        m.Deposit = r.int64();
                        break;
                    }
                    case 11: {
                        m.IsMinAmount = r.int32();
                        break;
                    }
                    case 12: {
                        m.MinAmount = r.int64();
                        break;
                    }
                    case 13: {
                        m.IsTeaFee = r.int32();
                        break;
                    }
                    case 14: {
                        m.TeaFee = r.int64();
                        break;
                    }
                    case 15: {
                        m.IsMealSeatFee = r.int32();
                        break;
                    }
                    case 16: {
                        m.MealSeatFee = r.int64();
                        break;
                    }
                    case 17: {
                        m.IsOpenBySelf = r.int32();
                        break;
                    }
                    case 18: {
                        m.CreateTime = r.int64();
                        break;
                    }
                    case 19: {
                        m.CreaterID = r.uint64();
                        break;
                    }
                    case 20: {
                        m.UpdateTime = r.int64();
                        break;
                    }
                    case 21: {
                        m.UpdaterID = r.uint64();
                        break;
                    }
                    case 22: {
                        m.Estate = r.int32();
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        MchDeskCategory.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.MchDeskCategory";
        };

        return MchDeskCategory;
    })();

    PBEntity.MchDeskCategorys = (function () {

        function MchDeskCategorys(p) {
            this.MchDeskCategorys = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        MchDeskCategorys.prototype.MchDeskCategorys = $util.emptyArray;

        MchDeskCategorys.create = function create(properties) {
            return new MchDeskCategorys(properties);
        };

        MchDeskCategorys.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.MchDeskCategorys != null && m.MchDeskCategorys.length) {
                for (var i = 0; i < m.MchDeskCategorys.length; ++i)
                    $root.PBEntity.MchDeskCategory.encode(m.MchDeskCategorys[i], w.uint32(10).fork()).ldelim();
            }
            return w;
        };

        MchDeskCategorys.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.MchDeskCategorys();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        if (!(m.MchDeskCategorys && m.MchDeskCategorys.length))
                            m.MchDeskCategorys = [];
                        m.MchDeskCategorys.push($root.PBEntity.MchDeskCategory.decode(r, r.uint32()));
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        MchDeskCategorys.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.MchDeskCategorys";
        };

        return MchDeskCategorys;
    })();

    PBEntity.MchEmps = (function () {

        function MchEmps(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        MchEmps.prototype.MchID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        MchEmps.prototype.UserID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        MchEmps.prototype.Dept = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        MchEmps.prototype.Category = 0;
        MchEmps.prototype.Mail = "";
        MchEmps.prototype.Name1 = "";
        MchEmps.prototype.Name2 = "";
        MchEmps.prototype.Name3 = "";
        MchEmps.prototype.Mobile = "";
        MchEmps.prototype.WorkState = 0;
        MchEmps.prototype.IsPos = 0;
        MchEmps.prototype.IsWeb = 0;
        MchEmps.prototype.IsSubcReserve = 0;
        MchEmps.prototype.IsSubcOrder = 0;
        MchEmps.prototype.IsSubcPayOrder = 0;
        MchEmps.prototype.IsSubcRCPay = 0;
        MchEmps.prototype.IsSubPrint = 0;
        MchEmps.prototype.SubcCount = 0;
        MchEmps.prototype.LastLoginTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        MchEmps.prototype.LastLoginIP = "";
        MchEmps.prototype.LastLoginID = "";
        MchEmps.prototype.IsJoinGroup = 0;
        MchEmps.prototype.LastSubcPrintTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        MchEmps.prototype.LastSubcPrintToken = "";
        MchEmps.prototype.SubcPrintTokenExpired = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        MchEmps.prototype.IsSubcAdvPay = 0;
        MchEmps.prototype.IsSubcDelivery = 0;
        MchEmps.prototype.IsSubscribe = 0;
        MchEmps.prototype.SyncSubscribe = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        MchEmps.prototype.CreateTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        MchEmps.prototype.CreaterID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        MchEmps.prototype.UpdateTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        MchEmps.prototype.UpdaterID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        MchEmps.prototype.Estate = 0;

        MchEmps.create = function create(properties) {
            return new MchEmps(properties);
        };

        MchEmps.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.MchID != null && Object.hasOwnProperty.call(m, "MchID"))
                w.uint32(8).uint64(m.MchID);
            if (m.UserID != null && Object.hasOwnProperty.call(m, "UserID"))
                w.uint32(16).uint64(m.UserID);
            if (m.Dept != null && Object.hasOwnProperty.call(m, "Dept"))
                w.uint32(24).int64(m.Dept);
            if (m.Category != null && Object.hasOwnProperty.call(m, "Category"))
                w.uint32(32).int32(m.Category);
            if (m.Mail != null && Object.hasOwnProperty.call(m, "Mail"))
                w.uint32(42).string(m.Mail);
            if (m.Name1 != null && Object.hasOwnProperty.call(m, "Name1"))
                w.uint32(50).string(m.Name1);
            if (m.Name2 != null && Object.hasOwnProperty.call(m, "Name2"))
                w.uint32(58).string(m.Name2);
            if (m.Name3 != null && Object.hasOwnProperty.call(m, "Name3"))
                w.uint32(66).string(m.Name3);
            if (m.Mobile != null && Object.hasOwnProperty.call(m, "Mobile"))
                w.uint32(74).string(m.Mobile);
            if (m.WorkState != null && Object.hasOwnProperty.call(m, "WorkState"))
                w.uint32(80).int32(m.WorkState);
            if (m.IsPos != null && Object.hasOwnProperty.call(m, "IsPos"))
                w.uint32(88).int32(m.IsPos);
            if (m.IsWeb != null && Object.hasOwnProperty.call(m, "IsWeb"))
                w.uint32(96).int32(m.IsWeb);
            if (m.IsSubcReserve != null && Object.hasOwnProperty.call(m, "IsSubcReserve"))
                w.uint32(104).int32(m.IsSubcReserve);
            if (m.IsSubcOrder != null && Object.hasOwnProperty.call(m, "IsSubcOrder"))
                w.uint32(112).int32(m.IsSubcOrder);
            if (m.IsSubcPayOrder != null && Object.hasOwnProperty.call(m, "IsSubcPayOrder"))
                w.uint32(120).int32(m.IsSubcPayOrder);
            if (m.IsSubcRCPay != null && Object.hasOwnProperty.call(m, "IsSubcRCPay"))
                w.uint32(128).int32(m.IsSubcRCPay);
            if (m.IsSubPrint != null && Object.hasOwnProperty.call(m, "IsSubPrint"))
                w.uint32(136).int32(m.IsSubPrint);
            if (m.SubcCount != null && Object.hasOwnProperty.call(m, "SubcCount"))
                w.uint32(144).int32(m.SubcCount);
            if (m.LastLoginTime != null && Object.hasOwnProperty.call(m, "LastLoginTime"))
                w.uint32(152).int64(m.LastLoginTime);
            if (m.LastLoginIP != null && Object.hasOwnProperty.call(m, "LastLoginIP"))
                w.uint32(162).string(m.LastLoginIP);
            if (m.LastLoginID != null && Object.hasOwnProperty.call(m, "LastLoginID"))
                w.uint32(170).string(m.LastLoginID);
            if (m.IsJoinGroup != null && Object.hasOwnProperty.call(m, "IsJoinGroup"))
                w.uint32(176).int32(m.IsJoinGroup);
            if (m.LastSubcPrintTime != null && Object.hasOwnProperty.call(m, "LastSubcPrintTime"))
                w.uint32(184).int64(m.LastSubcPrintTime);
            if (m.LastSubcPrintToken != null && Object.hasOwnProperty.call(m, "LastSubcPrintToken"))
                w.uint32(194).string(m.LastSubcPrintToken);
            if (m.SubcPrintTokenExpired != null && Object.hasOwnProperty.call(m, "SubcPrintTokenExpired"))
                w.uint32(200).int64(m.SubcPrintTokenExpired);
            if (m.IsSubcAdvPay != null && Object.hasOwnProperty.call(m, "IsSubcAdvPay"))
                w.uint32(208).int32(m.IsSubcAdvPay);
            if (m.IsSubcDelivery != null && Object.hasOwnProperty.call(m, "IsSubcDelivery"))
                w.uint32(216).int32(m.IsSubcDelivery);
            if (m.IsSubscribe != null && Object.hasOwnProperty.call(m, "IsSubscribe"))
                w.uint32(224).int32(m.IsSubscribe);
            if (m.SyncSubscribe != null && Object.hasOwnProperty.call(m, "SyncSubscribe"))
                w.uint32(232).int64(m.SyncSubscribe);
            if (m.CreateTime != null && Object.hasOwnProperty.call(m, "CreateTime"))
                w.uint32(240).int64(m.CreateTime);
            if (m.CreaterID != null && Object.hasOwnProperty.call(m, "CreaterID"))
                w.uint32(248).uint64(m.CreaterID);
            if (m.UpdateTime != null && Object.hasOwnProperty.call(m, "UpdateTime"))
                w.uint32(256).int64(m.UpdateTime);
            if (m.UpdaterID != null && Object.hasOwnProperty.call(m, "UpdaterID"))
                w.uint32(264).uint64(m.UpdaterID);
            if (m.Estate != null && Object.hasOwnProperty.call(m, "Estate"))
                w.uint32(272).int32(m.Estate);
            return w;
        };

        MchEmps.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.MchEmps();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        m.MchID = r.uint64();
                        break;
                    }
                    case 2: {
                        m.UserID = r.uint64();
                        break;
                    }
                    case 3: {
                        m.Dept = r.int64();
                        break;
                    }
                    case 4: {
                        m.Category = r.int32();
                        break;
                    }
                    case 5: {
                        m.Mail = r.string();
                        break;
                    }
                    case 6: {
                        m.Name1 = r.string();
                        break;
                    }
                    case 7: {
                        m.Name2 = r.string();
                        break;
                    }
                    case 8: {
                        m.Name3 = r.string();
                        break;
                    }
                    case 9: {
                        m.Mobile = r.string();
                        break;
                    }
                    case 10: {
                        m.WorkState = r.int32();
                        break;
                    }
                    case 11: {
                        m.IsPos = r.int32();
                        break;
                    }
                    case 12: {
                        m.IsWeb = r.int32();
                        break;
                    }
                    case 13: {
                        m.IsSubcReserve = r.int32();
                        break;
                    }
                    case 14: {
                        m.IsSubcOrder = r.int32();
                        break;
                    }
                    case 15: {
                        m.IsSubcPayOrder = r.int32();
                        break;
                    }
                    case 16: {
                        m.IsSubcRCPay = r.int32();
                        break;
                    }
                    case 17: {
                        m.IsSubPrint = r.int32();
                        break;
                    }
                    case 18: {
                        m.SubcCount = r.int32();
                        break;
                    }
                    case 19: {
                        m.LastLoginTime = r.int64();
                        break;
                    }
                    case 20: {
                        m.LastLoginIP = r.string();
                        break;
                    }
                    case 21: {
                        m.LastLoginID = r.string();
                        break;
                    }
                    case 22: {
                        m.IsJoinGroup = r.int32();
                        break;
                    }
                    case 23: {
                        m.LastSubcPrintTime = r.int64();
                        break;
                    }
                    case 24: {
                        m.LastSubcPrintToken = r.string();
                        break;
                    }
                    case 25: {
                        m.SubcPrintTokenExpired = r.int64();
                        break;
                    }
                    case 26: {
                        m.IsSubcAdvPay = r.int32();
                        break;
                    }
                    case 27: {
                        m.IsSubcDelivery = r.int32();
                        break;
                    }
                    case 28: {
                        m.IsSubscribe = r.int32();
                        break;
                    }
                    case 29: {
                        m.SyncSubscribe = r.int64();
                        break;
                    }
                    case 30: {
                        m.CreateTime = r.int64();
                        break;
                    }
                    case 31: {
                        m.CreaterID = r.uint64();
                        break;
                    }
                    case 32: {
                        m.UpdateTime = r.int64();
                        break;
                    }
                    case 33: {
                        m.UpdaterID = r.uint64();
                        break;
                    }
                    case 34: {
                        m.Estate = r.int32();
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        MchEmps.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.MchEmps";
        };

        return MchEmps;
    })();

    PBEntity.MchEmpss = (function () {

        function MchEmpss(p) {
            this.MchEmpss = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        MchEmpss.prototype.MchEmpss = $util.emptyArray;

        MchEmpss.create = function create(properties) {
            return new MchEmpss(properties);
        };

        MchEmpss.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.MchEmpss != null && m.MchEmpss.length) {
                for (var i = 0; i < m.MchEmpss.length; ++i)
                    $root.PBEntity.MchEmps.encode(m.MchEmpss[i], w.uint32(10).fork()).ldelim();
            }
            return w;
        };

        MchEmpss.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.MchEmpss();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        if (!(m.MchEmpss && m.MchEmpss.length))
                            m.MchEmpss = [];
                        m.MchEmpss.push($root.PBEntity.MchEmps.decode(r, r.uint32()));
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        MchEmpss.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.MchEmpss";
        };

        return MchEmpss;
    })();

    PBEntity.MchLicensePay = (function () {

        function MchLicensePay(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        MchLicensePay.prototype.LicensePayID = "";
        MchLicensePay.prototype.MchID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        MchLicensePay.prototype.ApplyID = "";
        MchLicensePay.prototype.MchName = "";
        MchLicensePay.prototype.MchShortName = "";
        MchLicensePay.prototype.IsNew = 0;
        MchLicensePay.prototype.OldLicenseTypeID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        MchLicensePay.prototype.OldLicenseTypeName = "";
        MchLicensePay.prototype.OldMchCategory = 0;
        MchLicensePay.prototype.OldLicenseTypePrice = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        MchLicensePay.prototype.OldPeriod = 0;
        MchLicensePay.prototype.LicenseTypeID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        MchLicensePay.prototype.LicenseTypeName = "";
        MchLicensePay.prototype.MchCategory = 0;
        MchLicensePay.prototype.LicenseTypePrice = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        MchLicensePay.prototype.Period = 0;
        MchLicensePay.prototype.TotalAmount = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        MchLicensePay.prototype.LicenseBeginTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        MchLicensePay.prototype.LicenseEndTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        MchLicensePay.prototype.ApplyTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        MchLicensePay.prototype.ApplicantID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        MchLicensePay.prototype.PayID = "";
        MchLicensePay.prototype.PayTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        MchLicensePay.prototype.PayState = 0;
        MchLicensePay.prototype.RecordMode = 0;
        MchLicensePay.prototype.ApplyNotes = "";
        MchLicensePay.prototype.IsCancel = 0;
        MchLicensePay.prototype.CancelerID = 0;
        MchLicensePay.prototype.CancelTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        MchLicensePay.prototype.CancelNotes = "";
        MchLicensePay.prototype.AgentID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        MchLicensePay.prototype.CreateTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        MchLicensePay.prototype.CreaterID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        MchLicensePay.prototype.UpdateTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        MchLicensePay.prototype.UpdaterID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        MchLicensePay.prototype.Estate = 0;

        MchLicensePay.create = function create(properties) {
            return new MchLicensePay(properties);
        };

        MchLicensePay.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.LicensePayID != null && Object.hasOwnProperty.call(m, "LicensePayID"))
                w.uint32(10).string(m.LicensePayID);
            if (m.MchID != null && Object.hasOwnProperty.call(m, "MchID"))
                w.uint32(16).uint64(m.MchID);
            if (m.ApplyID != null && Object.hasOwnProperty.call(m, "ApplyID"))
                w.uint32(26).string(m.ApplyID);
            if (m.MchName != null && Object.hasOwnProperty.call(m, "MchName"))
                w.uint32(34).string(m.MchName);
            if (m.MchShortName != null && Object.hasOwnProperty.call(m, "MchShortName"))
                w.uint32(42).string(m.MchShortName);
            if (m.IsNew != null && Object.hasOwnProperty.call(m, "IsNew"))
                w.uint32(48).int32(m.IsNew);
            if (m.OldLicenseTypeID != null && Object.hasOwnProperty.call(m, "OldLicenseTypeID"))
                w.uint32(56).uint64(m.OldLicenseTypeID);
            if (m.OldLicenseTypeName != null && Object.hasOwnProperty.call(m, "OldLicenseTypeName"))
                w.uint32(66).string(m.OldLicenseTypeName);
            if (m.OldMchCategory != null && Object.hasOwnProperty.call(m, "OldMchCategory"))
                w.uint32(72).int32(m.OldMchCategory);
            if (m.OldLicenseTypePrice != null && Object.hasOwnProperty.call(m, "OldLicenseTypePrice"))
                w.uint32(80).int64(m.OldLicenseTypePrice);
            if (m.OldPeriod != null && Object.hasOwnProperty.call(m, "OldPeriod"))
                w.uint32(88).int32(m.OldPeriod);
            if (m.LicenseTypeID != null && Object.hasOwnProperty.call(m, "LicenseTypeID"))
                w.uint32(96).uint64(m.LicenseTypeID);
            if (m.LicenseTypeName != null && Object.hasOwnProperty.call(m, "LicenseTypeName"))
                w.uint32(106).string(m.LicenseTypeName);
            if (m.MchCategory != null && Object.hasOwnProperty.call(m, "MchCategory"))
                w.uint32(112).int32(m.MchCategory);
            if (m.LicenseTypePrice != null && Object.hasOwnProperty.call(m, "LicenseTypePrice"))
                w.uint32(120).int64(m.LicenseTypePrice);
            if (m.Period != null && Object.hasOwnProperty.call(m, "Period"))
                w.uint32(128).int32(m.Period);
            if (m.TotalAmount != null && Object.hasOwnProperty.call(m, "TotalAmount"))
                w.uint32(136).int64(m.TotalAmount);
            if (m.LicenseBeginTime != null && Object.hasOwnProperty.call(m, "LicenseBeginTime"))
                w.uint32(144).int64(m.LicenseBeginTime);
            if (m.LicenseEndTime != null && Object.hasOwnProperty.call(m, "LicenseEndTime"))
                w.uint32(152).int64(m.LicenseEndTime);
            if (m.ApplyTime != null && Object.hasOwnProperty.call(m, "ApplyTime"))
                w.uint32(160).int64(m.ApplyTime);
            if (m.ApplicantID != null && Object.hasOwnProperty.call(m, "ApplicantID"))
                w.uint32(168).uint64(m.ApplicantID);
            if (m.PayID != null && Object.hasOwnProperty.call(m, "PayID"))
                w.uint32(178).string(m.PayID);
            if (m.PayTime != null && Object.hasOwnProperty.call(m, "PayTime"))
                w.uint32(184).int64(m.PayTime);
            if (m.PayState != null && Object.hasOwnProperty.call(m, "PayState"))
                w.uint32(192).int32(m.PayState);
            if (m.RecordMode != null && Object.hasOwnProperty.call(m, "RecordMode"))
                w.uint32(200).int32(m.RecordMode);
            if (m.ApplyNotes != null && Object.hasOwnProperty.call(m, "ApplyNotes"))
                w.uint32(210).string(m.ApplyNotes);
            if (m.IsCancel != null && Object.hasOwnProperty.call(m, "IsCancel"))
                w.uint32(216).int32(m.IsCancel);
            if (m.CancelerID != null && Object.hasOwnProperty.call(m, "CancelerID"))
                w.uint32(224).uint32(m.CancelerID);
            if (m.CancelTime != null && Object.hasOwnProperty.call(m, "CancelTime"))
                w.uint32(232).int64(m.CancelTime);
            if (m.CancelNotes != null && Object.hasOwnProperty.call(m, "CancelNotes"))
                w.uint32(242).string(m.CancelNotes);
            if (m.AgentID != null && Object.hasOwnProperty.call(m, "AgentID"))
                w.uint32(248).uint64(m.AgentID);
            if (m.CreateTime != null && Object.hasOwnProperty.call(m, "CreateTime"))
                w.uint32(256).int64(m.CreateTime);
            if (m.CreaterID != null && Object.hasOwnProperty.call(m, "CreaterID"))
                w.uint32(264).uint64(m.CreaterID);
            if (m.UpdateTime != null && Object.hasOwnProperty.call(m, "UpdateTime"))
                w.uint32(272).int64(m.UpdateTime);
            if (m.UpdaterID != null && Object.hasOwnProperty.call(m, "UpdaterID"))
                w.uint32(280).uint64(m.UpdaterID);
            if (m.Estate != null && Object.hasOwnProperty.call(m, "Estate"))
                w.uint32(288).int32(m.Estate);
            return w;
        };

        MchLicensePay.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.MchLicensePay();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        m.LicensePayID = r.string();
                        break;
                    }
                    case 2: {
                        m.MchID = r.uint64();
                        break;
                    }
                    case 3: {
                        m.ApplyID = r.string();
                        break;
                    }
                    case 4: {
                        m.MchName = r.string();
                        break;
                    }
                    case 5: {
                        m.MchShortName = r.string();
                        break;
                    }
                    case 6: {
                        m.IsNew = r.int32();
                        break;
                    }
                    case 7: {
                        m.OldLicenseTypeID = r.uint64();
                        break;
                    }
                    case 8: {
                        m.OldLicenseTypeName = r.string();
                        break;
                    }
                    case 9: {
                        m.OldMchCategory = r.int32();
                        break;
                    }
                    case 10: {
                        m.OldLicenseTypePrice = r.int64();
                        break;
                    }
                    case 11: {
                        m.OldPeriod = r.int32();
                        break;
                    }
                    case 12: {
                        m.LicenseTypeID = r.uint64();
                        break;
                    }
                    case 13: {
                        m.LicenseTypeName = r.string();
                        break;
                    }
                    case 14: {
                        m.MchCategory = r.int32();
                        break;
                    }
                    case 15: {
                        m.LicenseTypePrice = r.int64();
                        break;
                    }
                    case 16: {
                        m.Period = r.int32();
                        break;
                    }
                    case 17: {
                        m.TotalAmount = r.int64();
                        break;
                    }
                    case 18: {
                        m.LicenseBeginTime = r.int64();
                        break;
                    }
                    case 19: {
                        m.LicenseEndTime = r.int64();
                        break;
                    }
                    case 20: {
                        m.ApplyTime = r.int64();
                        break;
                    }
                    case 21: {
                        m.ApplicantID = r.uint64();
                        break;
                    }
                    case 22: {
                        m.PayID = r.string();
                        break;
                    }
                    case 23: {
                        m.PayTime = r.int64();
                        break;
                    }
                    case 24: {
                        m.PayState = r.int32();
                        break;
                    }
                    case 25: {
                        m.RecordMode = r.int32();
                        break;
                    }
                    case 26: {
                        m.ApplyNotes = r.string();
                        break;
                    }
                    case 27: {
                        m.IsCancel = r.int32();
                        break;
                    }
                    case 28: {
                        m.CancelerID = r.uint32();
                        break;
                    }
                    case 29: {
                        m.CancelTime = r.int64();
                        break;
                    }
                    case 30: {
                        m.CancelNotes = r.string();
                        break;
                    }
                    case 31: {
                        m.AgentID = r.uint64();
                        break;
                    }
                    case 32: {
                        m.CreateTime = r.int64();
                        break;
                    }
                    case 33: {
                        m.CreaterID = r.uint64();
                        break;
                    }
                    case 34: {
                        m.UpdateTime = r.int64();
                        break;
                    }
                    case 35: {
                        m.UpdaterID = r.uint64();
                        break;
                    }
                    case 36: {
                        m.Estate = r.int32();
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        MchLicensePay.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.MchLicensePay";
        };

        return MchLicensePay;
    })();

    PBEntity.MchLicensePays = (function () {

        function MchLicensePays(p) {
            this.MchLicensePays = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        MchLicensePays.prototype.MchLicensePays = $util.emptyArray;

        MchLicensePays.create = function create(properties) {
            return new MchLicensePays(properties);
        };

        MchLicensePays.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.MchLicensePays != null && m.MchLicensePays.length) {
                for (var i = 0; i < m.MchLicensePays.length; ++i)
                    $root.PBEntity.MchLicensePay.encode(m.MchLicensePays[i], w.uint32(10).fork()).ldelim();
            }
            return w;
        };

        MchLicensePays.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.MchLicensePays();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        if (!(m.MchLicensePays && m.MchLicensePays.length))
                            m.MchLicensePays = [];
                        m.MchLicensePays.push($root.PBEntity.MchLicensePay.decode(r, r.uint32()));
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        MchLicensePays.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.MchLicensePays";
        };

        return MchLicensePays;
    })();

    PBEntity.MchPayChannel = (function () {

        function MchPayChannel(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        MchPayChannel.prototype.PCID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        MchPayChannel.prototype.MchID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        MchPayChannel.prototype.AccID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        MchPayChannel.prototype.GroupID = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        MchPayChannel.prototype.Name1 = "";
        MchPayChannel.prototype.Name2 = "";
        MchPayChannel.prototype.Name3 = "";
        MchPayChannel.prototype.OnlineCategory = 0;
        MchPayChannel.prototype.IsOnline = 0;
        MchPayChannel.prototype.IsScanPay = 0;
        MchPayChannel.prototype.IsOffline = 0;
        MchPayChannel.prototype.IsCustomer = 0;
        MchPayChannel.prototype.IsPos = 0;
        MchPayChannel.prototype.IsCredit = 0;
        MchPayChannel.prototype.IsPoints = 0;
        MchPayChannel.prototype.IsStored = 0;
        MchPayChannel.prototype.IsPayment = 0;
        MchPayChannel.prototype.IsSys = 0;
        MchPayChannel.prototype.Priority = 0;
        MchPayChannel.prototype.CreateTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        MchPayChannel.prototype.CreaterID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        MchPayChannel.prototype.UpdateTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        MchPayChannel.prototype.UpdaterID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        MchPayChannel.prototype.Estate = 0;

        MchPayChannel.create = function create(properties) {
            return new MchPayChannel(properties);
        };

        MchPayChannel.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.PCID != null && Object.hasOwnProperty.call(m, "PCID"))
                w.uint32(8).uint64(m.PCID);
            if (m.MchID != null && Object.hasOwnProperty.call(m, "MchID"))
                w.uint32(16).uint64(m.MchID);
            if (m.AccID != null && Object.hasOwnProperty.call(m, "AccID"))
                w.uint32(24).uint64(m.AccID);
            if (m.GroupID != null && Object.hasOwnProperty.call(m, "GroupID"))
                w.uint32(32).int64(m.GroupID);
            if (m.Name1 != null && Object.hasOwnProperty.call(m, "Name1"))
                w.uint32(42).string(m.Name1);
            if (m.Name2 != null && Object.hasOwnProperty.call(m, "Name2"))
                w.uint32(50).string(m.Name2);
            if (m.Name3 != null && Object.hasOwnProperty.call(m, "Name3"))
                w.uint32(58).string(m.Name3);
            if (m.OnlineCategory != null && Object.hasOwnProperty.call(m, "OnlineCategory"))
                w.uint32(64).int32(m.OnlineCategory);
            if (m.IsOnline != null && Object.hasOwnProperty.call(m, "IsOnline"))
                w.uint32(72).int32(m.IsOnline);
            if (m.IsScanPay != null && Object.hasOwnProperty.call(m, "IsScanPay"))
                w.uint32(80).int32(m.IsScanPay);
            if (m.IsOffline != null && Object.hasOwnProperty.call(m, "IsOffline"))
                w.uint32(88).int32(m.IsOffline);
            if (m.IsCustomer != null && Object.hasOwnProperty.call(m, "IsCustomer"))
                w.uint32(96).int32(m.IsCustomer);
            if (m.IsPos != null && Object.hasOwnProperty.call(m, "IsPos"))
                w.uint32(104).int32(m.IsPos);
            if (m.IsCredit != null && Object.hasOwnProperty.call(m, "IsCredit"))
                w.uint32(112).int32(m.IsCredit);
            if (m.IsPoints != null && Object.hasOwnProperty.call(m, "IsPoints"))
                w.uint32(120).int32(m.IsPoints);
            if (m.IsStored != null && Object.hasOwnProperty.call(m, "IsStored"))
                w.uint32(128).int32(m.IsStored);
            if (m.IsPayment != null && Object.hasOwnProperty.call(m, "IsPayment"))
                w.uint32(136).int32(m.IsPayment);
            if (m.IsSys != null && Object.hasOwnProperty.call(m, "IsSys"))
                w.uint32(144).int32(m.IsSys);
            if (m.Priority != null && Object.hasOwnProperty.call(m, "Priority"))
                w.uint32(152).int32(m.Priority);
            if (m.CreateTime != null && Object.hasOwnProperty.call(m, "CreateTime"))
                w.uint32(160).int64(m.CreateTime);
            if (m.CreaterID != null && Object.hasOwnProperty.call(m, "CreaterID"))
                w.uint32(168).uint64(m.CreaterID);
            if (m.UpdateTime != null && Object.hasOwnProperty.call(m, "UpdateTime"))
                w.uint32(176).int64(m.UpdateTime);
            if (m.UpdaterID != null && Object.hasOwnProperty.call(m, "UpdaterID"))
                w.uint32(184).uint64(m.UpdaterID);
            if (m.Estate != null && Object.hasOwnProperty.call(m, "Estate"))
                w.uint32(192).int32(m.Estate);
            return w;
        };

        MchPayChannel.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.MchPayChannel();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        m.PCID = r.uint64();
                        break;
                    }
                    case 2: {
                        m.MchID = r.uint64();
                        break;
                    }
                    case 3: {
                        m.AccID = r.uint64();
                        break;
                    }
                    case 4: {
                        m.GroupID = r.int64();
                        break;
                    }
                    case 5: {
                        m.Name1 = r.string();
                        break;
                    }
                    case 6: {
                        m.Name2 = r.string();
                        break;
                    }
                    case 7: {
                        m.Name3 = r.string();
                        break;
                    }
                    case 8: {
                        m.OnlineCategory = r.int32();
                        break;
                    }
                    case 9: {
                        m.IsOnline = r.int32();
                        break;
                    }
                    case 10: {
                        m.IsScanPay = r.int32();
                        break;
                    }
                    case 11: {
                        m.IsOffline = r.int32();
                        break;
                    }
                    case 12: {
                        m.IsCustomer = r.int32();
                        break;
                    }
                    case 13: {
                        m.IsPos = r.int32();
                        break;
                    }
                    case 14: {
                        m.IsCredit = r.int32();
                        break;
                    }
                    case 15: {
                        m.IsPoints = r.int32();
                        break;
                    }
                    case 16: {
                        m.IsStored = r.int32();
                        break;
                    }
                    case 17: {
                        m.IsPayment = r.int32();
                        break;
                    }
                    case 18: {
                        m.IsSys = r.int32();
                        break;
                    }
                    case 19: {
                        m.Priority = r.int32();
                        break;
                    }
                    case 20: {
                        m.CreateTime = r.int64();
                        break;
                    }
                    case 21: {
                        m.CreaterID = r.uint64();
                        break;
                    }
                    case 22: {
                        m.UpdateTime = r.int64();
                        break;
                    }
                    case 23: {
                        m.UpdaterID = r.uint64();
                        break;
                    }
                    case 24: {
                        m.Estate = r.int32();
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        MchPayChannel.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.MchPayChannel";
        };

        return MchPayChannel;
    })();

    PBEntity.MchPayChannels = (function () {

        function MchPayChannels(p) {
            this.MchPayChannels = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        MchPayChannels.prototype.MchPayChannels = $util.emptyArray;

        MchPayChannels.create = function create(properties) {
            return new MchPayChannels(properties);
        };

        MchPayChannels.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.MchPayChannels != null && m.MchPayChannels.length) {
                for (var i = 0; i < m.MchPayChannels.length; ++i)
                    $root.PBEntity.MchPayChannel.encode(m.MchPayChannels[i], w.uint32(10).fork()).ldelim();
            }
            return w;
        };

        MchPayChannels.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.MchPayChannels();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        if (!(m.MchPayChannels && m.MchPayChannels.length))
                            m.MchPayChannels = [];
                        m.MchPayChannels.push($root.PBEntity.MchPayChannel.decode(r, r.uint32()));
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        MchPayChannels.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.MchPayChannels";
        };

        return MchPayChannels;
    })();

    PBEntity.MchPrinter = (function () {

        function MchPrinter(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        MchPrinter.prototype.PrinterID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        MchPrinter.prototype.MchID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        MchPrinter.prototype.PrinterName1 = "";
        MchPrinter.prototype.PrinterName2 = "";
        MchPrinter.prototype.PrinterName3 = "";
        MchPrinter.prototype.MachineCode = "";
        MchPrinter.prototype.PlatformCate = 0;
        MchPrinter.prototype.IsAuth = 0;
        MchPrinter.prototype.AccessToken = "";
        MchPrinter.prototype.RefreshToken = "";
        MchPrinter.prototype.LastRefreshTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        MchPrinter.prototype.ExpiresIn = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        MchPrinter.prototype.ExpiresTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        MchPrinter.prototype.Version = "";
        MchPrinter.prototype.Hardware = "";
        MchPrinter.prototype.Software = "";
        MchPrinter.prototype.PrintCate = 0;
        MchPrinter.prototype.PrintWidth = 0;
        MchPrinter.prototype.PrintHeight = 0;
        MchPrinter.prototype.PrintGap = 0;
        MchPrinter.prototype.PrintDir = 0;
        MchPrinter.prototype.KitchenMode = 0;
        MchPrinter.prototype.IsKitchenByNum = 0;
        MchPrinter.prototype.IsShopKitchen = 0;
        MchPrinter.prototype.IsShopCustomer = 0;
        MchPrinter.prototype.IsDeskUseRecord = 0;
        MchPrinter.prototype.IsRefundGoods = 0;
        MchPrinter.prototype.IsRefundAmt = 0;
        MchPrinter.prototype.IsTakeawayKitchen = 0;
        MchPrinter.prototype.IsTakeawayCustomer = 0;
        MchPrinter.prototype.IsYourselfKitchen = 0;
        MchPrinter.prototype.IsYourselfCustomer = 0;
        MchPrinter.prototype.IsOnlineTicket = 0;
        MchPrinter.prototype.IsOnlineCashier = 0;
        MchPrinter.prototype.IsPosTicket = 0;
        MchPrinter.prototype.IsPosCashier = 0;
        MchPrinter.prototype.IsAdvamtCustomer = 0;
        MchPrinter.prototype.IsAdvamtMerchant = 0;
        MchPrinter.prototype.IsBooking = 0;
        MchPrinter.prototype.IsBookingMerchant = 0;
        MchPrinter.prototype.IsShowOrderQR = 0;
        MchPrinter.prototype.IsShowShopQR = 0;
        MchPrinter.prototype.IsDeskCate = 0;
        MchPrinter.prototype.DeskCateList = "";
        MchPrinter.prototype.IsGoodsCate = 0;
        MchPrinter.prototype.GoodsCateList = "";
        MchPrinter.prototype.IsRcpay = 0;
        MchPrinter.prototype.IsRcpayVoice = 0;
        MchPrinter.prototype.IsCustomerShowAD = 0;
        MchPrinter.prototype.IsTicketShowAD = 0;
        MchPrinter.prototype.IsRcpayShowAD = 0;
        MchPrinter.prototype.ADContent = "";
        MchPrinter.prototype.PrintStatus = 0;
        MchPrinter.prototype.BindTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        MchPrinter.prototype.CreateTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        MchPrinter.prototype.CreaterID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        MchPrinter.prototype.UpdateTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        MchPrinter.prototype.UpdaterID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        MchPrinter.prototype.Estate = 0;

        MchPrinter.create = function create(properties) {
            return new MchPrinter(properties);
        };

        MchPrinter.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.PrinterID != null && Object.hasOwnProperty.call(m, "PrinterID"))
                w.uint32(8).uint64(m.PrinterID);
            if (m.MchID != null && Object.hasOwnProperty.call(m, "MchID"))
                w.uint32(16).uint64(m.MchID);
            if (m.PrinterName1 != null && Object.hasOwnProperty.call(m, "PrinterName1"))
                w.uint32(26).string(m.PrinterName1);
            if (m.PrinterName2 != null && Object.hasOwnProperty.call(m, "PrinterName2"))
                w.uint32(34).string(m.PrinterName2);
            if (m.PrinterName3 != null && Object.hasOwnProperty.call(m, "PrinterName3"))
                w.uint32(42).string(m.PrinterName3);
            if (m.MachineCode != null && Object.hasOwnProperty.call(m, "MachineCode"))
                w.uint32(50).string(m.MachineCode);
            if (m.PlatformCate != null && Object.hasOwnProperty.call(m, "PlatformCate"))
                w.uint32(56).int32(m.PlatformCate);
            if (m.IsAuth != null && Object.hasOwnProperty.call(m, "IsAuth"))
                w.uint32(64).int32(m.IsAuth);
            if (m.AccessToken != null && Object.hasOwnProperty.call(m, "AccessToken"))
                w.uint32(74).string(m.AccessToken);
            if (m.RefreshToken != null && Object.hasOwnProperty.call(m, "RefreshToken"))
                w.uint32(82).string(m.RefreshToken);
            if (m.LastRefreshTime != null && Object.hasOwnProperty.call(m, "LastRefreshTime"))
                w.uint32(88).int64(m.LastRefreshTime);
            if (m.ExpiresIn != null && Object.hasOwnProperty.call(m, "ExpiresIn"))
                w.uint32(96).int64(m.ExpiresIn);
            if (m.ExpiresTime != null && Object.hasOwnProperty.call(m, "ExpiresTime"))
                w.uint32(104).int64(m.ExpiresTime);
            if (m.Version != null && Object.hasOwnProperty.call(m, "Version"))
                w.uint32(114).string(m.Version);
            if (m.Hardware != null && Object.hasOwnProperty.call(m, "Hardware"))
                w.uint32(122).string(m.Hardware);
            if (m.Software != null && Object.hasOwnProperty.call(m, "Software"))
                w.uint32(130).string(m.Software);
            if (m.PrintCate != null && Object.hasOwnProperty.call(m, "PrintCate"))
                w.uint32(136).int32(m.PrintCate);
            if (m.PrintWidth != null && Object.hasOwnProperty.call(m, "PrintWidth"))
                w.uint32(144).int32(m.PrintWidth);
            if (m.PrintHeight != null && Object.hasOwnProperty.call(m, "PrintHeight"))
                w.uint32(152).int32(m.PrintHeight);
            if (m.PrintGap != null && Object.hasOwnProperty.call(m, "PrintGap"))
                w.uint32(160).int32(m.PrintGap);
            if (m.PrintDir != null && Object.hasOwnProperty.call(m, "PrintDir"))
                w.uint32(168).int32(m.PrintDir);
            if (m.KitchenMode != null && Object.hasOwnProperty.call(m, "KitchenMode"))
                w.uint32(176).int32(m.KitchenMode);
            if (m.IsKitchenByNum != null && Object.hasOwnProperty.call(m, "IsKitchenByNum"))
                w.uint32(184).int32(m.IsKitchenByNum);
            if (m.IsShopKitchen != null && Object.hasOwnProperty.call(m, "IsShopKitchen"))
                w.uint32(192).int32(m.IsShopKitchen);
            if (m.IsShopCustomer != null && Object.hasOwnProperty.call(m, "IsShopCustomer"))
                w.uint32(200).int32(m.IsShopCustomer);
            if (m.IsDeskUseRecord != null && Object.hasOwnProperty.call(m, "IsDeskUseRecord"))
                w.uint32(208).int32(m.IsDeskUseRecord);
            if (m.IsRefundGoods != null && Object.hasOwnProperty.call(m, "IsRefundGoods"))
                w.uint32(216).int32(m.IsRefundGoods);
            if (m.IsRefundAmt != null && Object.hasOwnProperty.call(m, "IsRefundAmt"))
                w.uint32(224).int32(m.IsRefundAmt);
            if (m.IsTakeawayKitchen != null && Object.hasOwnProperty.call(m, "IsTakeawayKitchen"))
                w.uint32(232).int32(m.IsTakeawayKitchen);
            if (m.IsTakeawayCustomer != null && Object.hasOwnProperty.call(m, "IsTakeawayCustomer"))
                w.uint32(240).int32(m.IsTakeawayCustomer);
            if (m.IsYourselfKitchen != null && Object.hasOwnProperty.call(m, "IsYourselfKitchen"))
                w.uint32(248).int32(m.IsYourselfKitchen);
            if (m.IsYourselfCustomer != null && Object.hasOwnProperty.call(m, "IsYourselfCustomer"))
                w.uint32(256).int32(m.IsYourselfCustomer);
            if (m.IsOnlineTicket != null && Object.hasOwnProperty.call(m, "IsOnlineTicket"))
                w.uint32(264).int32(m.IsOnlineTicket);
            if (m.IsOnlineCashier != null && Object.hasOwnProperty.call(m, "IsOnlineCashier"))
                w.uint32(272).int32(m.IsOnlineCashier);
            if (m.IsPosTicket != null && Object.hasOwnProperty.call(m, "IsPosTicket"))
                w.uint32(280).int32(m.IsPosTicket);
            if (m.IsPosCashier != null && Object.hasOwnProperty.call(m, "IsPosCashier"))
                w.uint32(288).int32(m.IsPosCashier);
            if (m.IsAdvamtCustomer != null && Object.hasOwnProperty.call(m, "IsAdvamtCustomer"))
                w.uint32(296).int32(m.IsAdvamtCustomer);
            if (m.IsAdvamtMerchant != null && Object.hasOwnProperty.call(m, "IsAdvamtMerchant"))
                w.uint32(304).int32(m.IsAdvamtMerchant);
            if (m.IsBooking != null && Object.hasOwnProperty.call(m, "IsBooking"))
                w.uint32(312).int32(m.IsBooking);
            if (m.IsBookingMerchant != null && Object.hasOwnProperty.call(m, "IsBookingMerchant"))
                w.uint32(320).int32(m.IsBookingMerchant);
            if (m.IsShowOrderQR != null && Object.hasOwnProperty.call(m, "IsShowOrderQR"))
                w.uint32(328).int32(m.IsShowOrderQR);
            if (m.IsShowShopQR != null && Object.hasOwnProperty.call(m, "IsShowShopQR"))
                w.uint32(336).int32(m.IsShowShopQR);
            if (m.IsDeskCate != null && Object.hasOwnProperty.call(m, "IsDeskCate"))
                w.uint32(344).int32(m.IsDeskCate);
            if (m.DeskCateList != null && Object.hasOwnProperty.call(m, "DeskCateList"))
                w.uint32(354).string(m.DeskCateList);
            if (m.IsGoodsCate != null && Object.hasOwnProperty.call(m, "IsGoodsCate"))
                w.uint32(360).int32(m.IsGoodsCate);
            if (m.GoodsCateList != null && Object.hasOwnProperty.call(m, "GoodsCateList"))
                w.uint32(370).string(m.GoodsCateList);
            if (m.IsRcpay != null && Object.hasOwnProperty.call(m, "IsRcpay"))
                w.uint32(376).int32(m.IsRcpay);
            if (m.IsRcpayVoice != null && Object.hasOwnProperty.call(m, "IsRcpayVoice"))
                w.uint32(384).int32(m.IsRcpayVoice);
            if (m.IsCustomerShowAD != null && Object.hasOwnProperty.call(m, "IsCustomerShowAD"))
                w.uint32(392).int32(m.IsCustomerShowAD);
            if (m.IsTicketShowAD != null && Object.hasOwnProperty.call(m, "IsTicketShowAD"))
                w.uint32(400).int32(m.IsTicketShowAD);
            if (m.IsRcpayShowAD != null && Object.hasOwnProperty.call(m, "IsRcpayShowAD"))
                w.uint32(408).int32(m.IsRcpayShowAD);
            if (m.ADContent != null && Object.hasOwnProperty.call(m, "ADContent"))
                w.uint32(418).string(m.ADContent);
            if (m.PrintStatus != null && Object.hasOwnProperty.call(m, "PrintStatus"))
                w.uint32(424).int32(m.PrintStatus);
            if (m.BindTime != null && Object.hasOwnProperty.call(m, "BindTime"))
                w.uint32(432).int64(m.BindTime);
            if (m.CreateTime != null && Object.hasOwnProperty.call(m, "CreateTime"))
                w.uint32(440).int64(m.CreateTime);
            if (m.CreaterID != null && Object.hasOwnProperty.call(m, "CreaterID"))
                w.uint32(448).uint64(m.CreaterID);
            if (m.UpdateTime != null && Object.hasOwnProperty.call(m, "UpdateTime"))
                w.uint32(456).int64(m.UpdateTime);
            if (m.UpdaterID != null && Object.hasOwnProperty.call(m, "UpdaterID"))
                w.uint32(464).uint64(m.UpdaterID);
            if (m.Estate != null && Object.hasOwnProperty.call(m, "Estate"))
                w.uint32(472).int32(m.Estate);
            return w;
        };

        MchPrinter.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.MchPrinter();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        m.PrinterID = r.uint64();
                        break;
                    }
                    case 2: {
                        m.MchID = r.uint64();
                        break;
                    }
                    case 3: {
                        m.PrinterName1 = r.string();
                        break;
                    }
                    case 4: {
                        m.PrinterName2 = r.string();
                        break;
                    }
                    case 5: {
                        m.PrinterName3 = r.string();
                        break;
                    }
                    case 6: {
                        m.MachineCode = r.string();
                        break;
                    }
                    case 7: {
                        m.PlatformCate = r.int32();
                        break;
                    }
                    case 8: {
                        m.IsAuth = r.int32();
                        break;
                    }
                    case 9: {
                        m.AccessToken = r.string();
                        break;
                    }
                    case 10: {
                        m.RefreshToken = r.string();
                        break;
                    }
                    case 11: {
                        m.LastRefreshTime = r.int64();
                        break;
                    }
                    case 12: {
                        m.ExpiresIn = r.int64();
                        break;
                    }
                    case 13: {
                        m.ExpiresTime = r.int64();
                        break;
                    }
                    case 14: {
                        m.Version = r.string();
                        break;
                    }
                    case 15: {
                        m.Hardware = r.string();
                        break;
                    }
                    case 16: {
                        m.Software = r.string();
                        break;
                    }
                    case 17: {
                        m.PrintCate = r.int32();
                        break;
                    }
                    case 18: {
                        m.PrintWidth = r.int32();
                        break;
                    }
                    case 19: {
                        m.PrintHeight = r.int32();
                        break;
                    }
                    case 20: {
                        m.PrintGap = r.int32();
                        break;
                    }
                    case 21: {
                        m.PrintDir = r.int32();
                        break;
                    }
                    case 22: {
                        m.KitchenMode = r.int32();
                        break;
                    }
                    case 23: {
                        m.IsKitchenByNum = r.int32();
                        break;
                    }
                    case 24: {
                        m.IsShopKitchen = r.int32();
                        break;
                    }
                    case 25: {
                        m.IsShopCustomer = r.int32();
                        break;
                    }
                    case 26: {
                        m.IsDeskUseRecord = r.int32();
                        break;
                    }
                    case 27: {
                        m.IsRefundGoods = r.int32();
                        break;
                    }
                    case 28: {
                        m.IsRefundAmt = r.int32();
                        break;
                    }
                    case 29: {
                        m.IsTakeawayKitchen = r.int32();
                        break;
                    }
                    case 30: {
                        m.IsTakeawayCustomer = r.int32();
                        break;
                    }
                    case 31: {
                        m.IsYourselfKitchen = r.int32();
                        break;
                    }
                    case 32: {
                        m.IsYourselfCustomer = r.int32();
                        break;
                    }
                    case 33: {
                        m.IsOnlineTicket = r.int32();
                        break;
                    }
                    case 34: {
                        m.IsOnlineCashier = r.int32();
                        break;
                    }
                    case 35: {
                        m.IsPosTicket = r.int32();
                        break;
                    }
                    case 36: {
                        m.IsPosCashier = r.int32();
                        break;
                    }
                    case 37: {
                        m.IsAdvamtCustomer = r.int32();
                        break;
                    }
                    case 38: {
                        m.IsAdvamtMerchant = r.int32();
                        break;
                    }
                    case 39: {
                        m.IsBooking = r.int32();
                        break;
                    }
                    case 40: {
                        m.IsBookingMerchant = r.int32();
                        break;
                    }
                    case 41: {
                        m.IsShowOrderQR = r.int32();
                        break;
                    }
                    case 42: {
                        m.IsShowShopQR = r.int32();
                        break;
                    }
                    case 43: {
                        m.IsDeskCate = r.int32();
                        break;
                    }
                    case 44: {
                        m.DeskCateList = r.string();
                        break;
                    }
                    case 45: {
                        m.IsGoodsCate = r.int32();
                        break;
                    }
                    case 46: {
                        m.GoodsCateList = r.string();
                        break;
                    }
                    case 47: {
                        m.IsRcpay = r.int32();
                        break;
                    }
                    case 48: {
                        m.IsRcpayVoice = r.int32();
                        break;
                    }
                    case 49: {
                        m.IsCustomerShowAD = r.int32();
                        break;
                    }
                    case 50: {
                        m.IsTicketShowAD = r.int32();
                        break;
                    }
                    case 51: {
                        m.IsRcpayShowAD = r.int32();
                        break;
                    }
                    case 52: {
                        m.ADContent = r.string();
                        break;
                    }
                    case 53: {
                        m.PrintStatus = r.int32();
                        break;
                    }
                    case 54: {
                        m.BindTime = r.int64();
                        break;
                    }
                    case 55: {
                        m.CreateTime = r.int64();
                        break;
                    }
                    case 56: {
                        m.CreaterID = r.uint64();
                        break;
                    }
                    case 57: {
                        m.UpdateTime = r.int64();
                        break;
                    }
                    case 58: {
                        m.UpdaterID = r.uint64();
                        break;
                    }
                    case 59: {
                        m.Estate = r.int32();
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        MchPrinter.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.MchPrinter";
        };

        return MchPrinter;
    })();

    PBEntity.MchPrinters = (function () {

        function MchPrinters(p) {
            this.MchPrinters = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        MchPrinters.prototype.MchPrinters = $util.emptyArray;

        MchPrinters.create = function create(properties) {
            return new MchPrinters(properties);
        };

        MchPrinters.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.MchPrinters != null && m.MchPrinters.length) {
                for (var i = 0; i < m.MchPrinters.length; ++i)
                    $root.PBEntity.MchPrinter.encode(m.MchPrinters[i], w.uint32(10).fork()).ldelim();
            }
            return w;
        };

        MchPrinters.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.MchPrinters();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        if (!(m.MchPrinters && m.MchPrinters.length))
                            m.MchPrinters = [];
                        m.MchPrinters.push($root.PBEntity.MchPrinter.decode(r, r.uint32()));
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        MchPrinters.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.MchPrinters";
        };

        return MchPrinters;
    })();

    PBEntity.MchQRCode = (function () {

        function MchQRCode(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        MchQRCode.prototype.MchID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        MchQRCode.prototype.HomeCategory = 0;
        MchQRCode.prototype.HomeCodeID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        MchQRCode.prototype.RCPayCategory = 0;
        MchQRCode.prototype.RCPayCodeID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        MchQRCode.prototype.TakeAwayCategory = 0;
        MchQRCode.prototype.TakeAwayCodeID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        MchQRCode.prototype.YourselfCategory = 0;
        MchQRCode.prototype.YourselfCodeID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        MchQRCode.prototype.CreateTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        MchQRCode.prototype.CreaterID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        MchQRCode.prototype.UpdateTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        MchQRCode.prototype.UpdaterID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        MchQRCode.prototype.Estate = 0;

        MchQRCode.create = function create(properties) {
            return new MchQRCode(properties);
        };

        MchQRCode.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.MchID != null && Object.hasOwnProperty.call(m, "MchID"))
                w.uint32(8).uint64(m.MchID);
            if (m.HomeCategory != null && Object.hasOwnProperty.call(m, "HomeCategory"))
                w.uint32(16).int32(m.HomeCategory);
            if (m.HomeCodeID != null && Object.hasOwnProperty.call(m, "HomeCodeID"))
                w.uint32(24).uint64(m.HomeCodeID);
            if (m.RCPayCategory != null && Object.hasOwnProperty.call(m, "RCPayCategory"))
                w.uint32(32).int32(m.RCPayCategory);
            if (m.RCPayCodeID != null && Object.hasOwnProperty.call(m, "RCPayCodeID"))
                w.uint32(40).uint64(m.RCPayCodeID);
            if (m.TakeAwayCategory != null && Object.hasOwnProperty.call(m, "TakeAwayCategory"))
                w.uint32(48).int32(m.TakeAwayCategory);
            if (m.TakeAwayCodeID != null && Object.hasOwnProperty.call(m, "TakeAwayCodeID"))
                w.uint32(56).uint64(m.TakeAwayCodeID);
            if (m.YourselfCategory != null && Object.hasOwnProperty.call(m, "YourselfCategory"))
                w.uint32(64).int32(m.YourselfCategory);
            if (m.YourselfCodeID != null && Object.hasOwnProperty.call(m, "YourselfCodeID"))
                w.uint32(72).uint64(m.YourselfCodeID);
            if (m.CreateTime != null && Object.hasOwnProperty.call(m, "CreateTime"))
                w.uint32(80).int64(m.CreateTime);
            if (m.CreaterID != null && Object.hasOwnProperty.call(m, "CreaterID"))
                w.uint32(88).uint64(m.CreaterID);
            if (m.UpdateTime != null && Object.hasOwnProperty.call(m, "UpdateTime"))
                w.uint32(96).int64(m.UpdateTime);
            if (m.UpdaterID != null && Object.hasOwnProperty.call(m, "UpdaterID"))
                w.uint32(104).uint64(m.UpdaterID);
            if (m.Estate != null && Object.hasOwnProperty.call(m, "Estate"))
                w.uint32(112).int32(m.Estate);
            return w;
        };

        MchQRCode.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.MchQRCode();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        m.MchID = r.uint64();
                        break;
                    }
                    case 2: {
                        m.HomeCategory = r.int32();
                        break;
                    }
                    case 3: {
                        m.HomeCodeID = r.uint64();
                        break;
                    }
                    case 4: {
                        m.RCPayCategory = r.int32();
                        break;
                    }
                    case 5: {
                        m.RCPayCodeID = r.uint64();
                        break;
                    }
                    case 6: {
                        m.TakeAwayCategory = r.int32();
                        break;
                    }
                    case 7: {
                        m.TakeAwayCodeID = r.uint64();
                        break;
                    }
                    case 8: {
                        m.YourselfCategory = r.int32();
                        break;
                    }
                    case 9: {
                        m.YourselfCodeID = r.uint64();
                        break;
                    }
                    case 10: {
                        m.CreateTime = r.int64();
                        break;
                    }
                    case 11: {
                        m.CreaterID = r.uint64();
                        break;
                    }
                    case 12: {
                        m.UpdateTime = r.int64();
                        break;
                    }
                    case 13: {
                        m.UpdaterID = r.uint64();
                        break;
                    }
                    case 14: {
                        m.Estate = r.int32();
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        MchQRCode.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.MchQRCode";
        };

        return MchQRCode;
    })();

    PBEntity.MchQRCodes = (function () {

        function MchQRCodes(p) {
            this.MchQRCodes = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        MchQRCodes.prototype.MchQRCodes = $util.emptyArray;

        MchQRCodes.create = function create(properties) {
            return new MchQRCodes(properties);
        };

        MchQRCodes.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.MchQRCodes != null && m.MchQRCodes.length) {
                for (var i = 0; i < m.MchQRCodes.length; ++i)
                    $root.PBEntity.MchQRCode.encode(m.MchQRCodes[i], w.uint32(10).fork()).ldelim();
            }
            return w;
        };

        MchQRCodes.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.MchQRCodes();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        if (!(m.MchQRCodes && m.MchQRCodes.length))
                            m.MchQRCodes = [];
                        m.MchQRCodes.push($root.PBEntity.MchQRCode.decode(r, r.uint32()));
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        MchQRCodes.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.MchQRCodes";
        };

        return MchQRCodes;
    })();

    PBEntity.MchRolePermission = (function () {

        function MchRolePermission(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        MchRolePermission.prototype.MchID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        MchRolePermission.prototype.RoleID = 0;
        MchRolePermission.prototype.ModuleID = "";
        MchRolePermission.prototype.Permission = 0;
        MchRolePermission.prototype.Permissions = "";

        MchRolePermission.create = function create(properties) {
            return new MchRolePermission(properties);
        };

        MchRolePermission.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.MchID != null && Object.hasOwnProperty.call(m, "MchID"))
                w.uint32(8).uint64(m.MchID);
            if (m.RoleID != null && Object.hasOwnProperty.call(m, "RoleID"))
                w.uint32(16).uint32(m.RoleID);
            if (m.ModuleID != null && Object.hasOwnProperty.call(m, "ModuleID"))
                w.uint32(26).string(m.ModuleID);
            if (m.Permission != null && Object.hasOwnProperty.call(m, "Permission"))
                w.uint32(32).int32(m.Permission);
            if (m.Permissions != null && Object.hasOwnProperty.call(m, "Permissions"))
                w.uint32(42).string(m.Permissions);
            return w;
        };

        MchRolePermission.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.MchRolePermission();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        m.MchID = r.uint64();
                        break;
                    }
                    case 2: {
                        m.RoleID = r.uint32();
                        break;
                    }
                    case 3: {
                        m.ModuleID = r.string();
                        break;
                    }
                    case 4: {
                        m.Permission = r.int32();
                        break;
                    }
                    case 5: {
                        m.Permissions = r.string();
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        MchRolePermission.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.MchRolePermission";
        };

        return MchRolePermission;
    })();

    PBEntity.MchRolePermissions = (function () {

        function MchRolePermissions(p) {
            this.MchRolePermissions = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        MchRolePermissions.prototype.MchRolePermissions = $util.emptyArray;

        MchRolePermissions.create = function create(properties) {
            return new MchRolePermissions(properties);
        };

        MchRolePermissions.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.MchRolePermissions != null && m.MchRolePermissions.length) {
                for (var i = 0; i < m.MchRolePermissions.length; ++i)
                    $root.PBEntity.MchRolePermission.encode(m.MchRolePermissions[i], w.uint32(10).fork()).ldelim();
            }
            return w;
        };

        MchRolePermissions.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.MchRolePermissions();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        if (!(m.MchRolePermissions && m.MchRolePermissions.length))
                            m.MchRolePermissions = [];
                        m.MchRolePermissions.push($root.PBEntity.MchRolePermission.decode(r, r.uint32()));
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        MchRolePermissions.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.MchRolePermissions";
        };

        return MchRolePermissions;
    })();

    PBEntity.MchSchedule = (function () {

        function MchSchedule(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        MchSchedule.prototype.ScheduleID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        MchSchedule.prototype.MchID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        MchSchedule.prototype.Name1 = "";
        MchSchedule.prototype.Name2 = "";
        MchSchedule.prototype.Name3 = "";
        MchSchedule.prototype.STime = 0;
        MchSchedule.prototype.ETime = 0;
        MchSchedule.prototype.EarlyTime = 0;
        MchSchedule.prototype.DelayTime = 0;
        MchSchedule.prototype.IsLimitWeek = 0;
        MchSchedule.prototype.LimitWeek = "";
        MchSchedule.prototype.IsActive = 0;
        MchSchedule.prototype.CreateTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        MchSchedule.prototype.CreaterID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        MchSchedule.prototype.UpdateTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        MchSchedule.prototype.UpdaterID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        MchSchedule.prototype.Estate = 0;

        MchSchedule.create = function create(properties) {
            return new MchSchedule(properties);
        };

        MchSchedule.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.ScheduleID != null && Object.hasOwnProperty.call(m, "ScheduleID"))
                w.uint32(8).uint64(m.ScheduleID);
            if (m.MchID != null && Object.hasOwnProperty.call(m, "MchID"))
                w.uint32(16).uint64(m.MchID);
            if (m.Name1 != null && Object.hasOwnProperty.call(m, "Name1"))
                w.uint32(26).string(m.Name1);
            if (m.Name2 != null && Object.hasOwnProperty.call(m, "Name2"))
                w.uint32(34).string(m.Name2);
            if (m.Name3 != null && Object.hasOwnProperty.call(m, "Name3"))
                w.uint32(42).string(m.Name3);
            if (m.STime != null && Object.hasOwnProperty.call(m, "STime"))
                w.uint32(49).double(m.STime);
            if (m.ETime != null && Object.hasOwnProperty.call(m, "ETime"))
                w.uint32(57).double(m.ETime);
            if (m.EarlyTime != null && Object.hasOwnProperty.call(m, "EarlyTime"))
                w.uint32(64).int32(m.EarlyTime);
            if (m.DelayTime != null && Object.hasOwnProperty.call(m, "DelayTime"))
                w.uint32(72).int32(m.DelayTime);
            if (m.IsLimitWeek != null && Object.hasOwnProperty.call(m, "IsLimitWeek"))
                w.uint32(80).int32(m.IsLimitWeek);
            if (m.LimitWeek != null && Object.hasOwnProperty.call(m, "LimitWeek"))
                w.uint32(90).string(m.LimitWeek);
            if (m.IsActive != null && Object.hasOwnProperty.call(m, "IsActive"))
                w.uint32(96).int32(m.IsActive);
            if (m.CreateTime != null && Object.hasOwnProperty.call(m, "CreateTime"))
                w.uint32(104).int64(m.CreateTime);
            if (m.CreaterID != null && Object.hasOwnProperty.call(m, "CreaterID"))
                w.uint32(112).uint64(m.CreaterID);
            if (m.UpdateTime != null && Object.hasOwnProperty.call(m, "UpdateTime"))
                w.uint32(120).int64(m.UpdateTime);
            if (m.UpdaterID != null && Object.hasOwnProperty.call(m, "UpdaterID"))
                w.uint32(128).uint64(m.UpdaterID);
            if (m.Estate != null && Object.hasOwnProperty.call(m, "Estate"))
                w.uint32(136).int32(m.Estate);
            return w;
        };

        MchSchedule.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.MchSchedule();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        m.ScheduleID = r.uint64();
                        break;
                    }
                    case 2: {
                        m.MchID = r.uint64();
                        break;
                    }
                    case 3: {
                        m.Name1 = r.string();
                        break;
                    }
                    case 4: {
                        m.Name2 = r.string();
                        break;
                    }
                    case 5: {
                        m.Name3 = r.string();
                        break;
                    }
                    case 6: {
                        m.STime = r.double();
                        break;
                    }
                    case 7: {
                        m.ETime = r.double();
                        break;
                    }
                    case 8: {
                        m.EarlyTime = r.int32();
                        break;
                    }
                    case 9: {
                        m.DelayTime = r.int32();
                        break;
                    }
                    case 10: {
                        m.IsLimitWeek = r.int32();
                        break;
                    }
                    case 11: {
                        m.LimitWeek = r.string();
                        break;
                    }
                    case 12: {
                        m.IsActive = r.int32();
                        break;
                    }
                    case 13: {
                        m.CreateTime = r.int64();
                        break;
                    }
                    case 14: {
                        m.CreaterID = r.uint64();
                        break;
                    }
                    case 15: {
                        m.UpdateTime = r.int64();
                        break;
                    }
                    case 16: {
                        m.UpdaterID = r.uint64();
                        break;
                    }
                    case 17: {
                        m.Estate = r.int32();
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        MchSchedule.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.MchSchedule";
        };

        return MchSchedule;
    })();

    PBEntity.MchSchedules = (function () {

        function MchSchedules(p) {
            this.MchSchedules = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        MchSchedules.prototype.MchSchedules = $util.emptyArray;

        MchSchedules.create = function create(properties) {
            return new MchSchedules(properties);
        };

        MchSchedules.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.MchSchedules != null && m.MchSchedules.length) {
                for (var i = 0; i < m.MchSchedules.length; ++i)
                    $root.PBEntity.MchSchedule.encode(m.MchSchedules[i], w.uint32(10).fork()).ldelim();
            }
            return w;
        };

        MchSchedules.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.MchSchedules();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        if (!(m.MchSchedules && m.MchSchedules.length))
                            m.MchSchedules = [];
                        m.MchSchedules.push($root.PBEntity.MchSchedule.decode(r, r.uint32()));
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        MchSchedules.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.MchSchedules";
        };

        return MchSchedules;
    })();

    PBEntity.MchStoredOption = (function () {

        function MchStoredOption(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        MchStoredOption.prototype.SOID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        MchStoredOption.prototype.MchID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        MchStoredOption.prototype.Category = 0;
        MchStoredOption.prototype.Title1 = "";
        MchStoredOption.prototype.Title2 = "";
        MchStoredOption.prototype.Title3 = "";
        MchStoredOption.prototype.Amount = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        MchStoredOption.prototype.RewardCategory = 0;
        MchStoredOption.prototype.RewardAmount = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        MchStoredOption.prototype.RewardRate = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        MchStoredOption.prototype.RewardPointsCategory = 0;
        MchStoredOption.prototype.RewardPoints = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        MchStoredOption.prototype.RewardPointsRate = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        MchStoredOption.prototype.IsAutoOff = 0;
        MchStoredOption.prototype.StartDate = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        MchStoredOption.prototype.EndDate = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        MchStoredOption.prototype.IsGiveCoupon = 0;
        MchStoredOption.prototype.GiveCouponID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        MchStoredOption.prototype.CreateTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        MchStoredOption.prototype.CreaterID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        MchStoredOption.prototype.UpdateTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        MchStoredOption.prototype.UpdaterID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        MchStoredOption.prototype.Estate = 0;

        MchStoredOption.create = function create(properties) {
            return new MchStoredOption(properties);
        };

        MchStoredOption.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.SOID != null && Object.hasOwnProperty.call(m, "SOID"))
                w.uint32(8).uint64(m.SOID);
            if (m.MchID != null && Object.hasOwnProperty.call(m, "MchID"))
                w.uint32(16).uint64(m.MchID);
            if (m.Category != null && Object.hasOwnProperty.call(m, "Category"))
                w.uint32(24).int32(m.Category);
            if (m.Title1 != null && Object.hasOwnProperty.call(m, "Title1"))
                w.uint32(34).string(m.Title1);
            if (m.Title2 != null && Object.hasOwnProperty.call(m, "Title2"))
                w.uint32(42).string(m.Title2);
            if (m.Title3 != null && Object.hasOwnProperty.call(m, "Title3"))
                w.uint32(50).string(m.Title3);
            if (m.Amount != null && Object.hasOwnProperty.call(m, "Amount"))
                w.uint32(56).int64(m.Amount);
            if (m.RewardCategory != null && Object.hasOwnProperty.call(m, "RewardCategory"))
                w.uint32(64).int32(m.RewardCategory);
            if (m.RewardAmount != null && Object.hasOwnProperty.call(m, "RewardAmount"))
                w.uint32(72).int64(m.RewardAmount);
            if (m.RewardRate != null && Object.hasOwnProperty.call(m, "RewardRate"))
                w.uint32(80).int64(m.RewardRate);
            if (m.RewardPointsCategory != null && Object.hasOwnProperty.call(m, "RewardPointsCategory"))
                w.uint32(88).int32(m.RewardPointsCategory);
            if (m.RewardPoints != null && Object.hasOwnProperty.call(m, "RewardPoints"))
                w.uint32(96).int64(m.RewardPoints);
            if (m.RewardPointsRate != null && Object.hasOwnProperty.call(m, "RewardPointsRate"))
                w.uint32(104).int64(m.RewardPointsRate);
            if (m.IsAutoOff != null && Object.hasOwnProperty.call(m, "IsAutoOff"))
                w.uint32(112).int32(m.IsAutoOff);
            if (m.StartDate != null && Object.hasOwnProperty.call(m, "StartDate"))
                w.uint32(120).int64(m.StartDate);
            if (m.EndDate != null && Object.hasOwnProperty.call(m, "EndDate"))
                w.uint32(128).int64(m.EndDate);
            if (m.IsGiveCoupon != null && Object.hasOwnProperty.call(m, "IsGiveCoupon"))
                w.uint32(136).int32(m.IsGiveCoupon);
            if (m.GiveCouponID != null && Object.hasOwnProperty.call(m, "GiveCouponID"))
                w.uint32(144).uint64(m.GiveCouponID);
            if (m.CreateTime != null && Object.hasOwnProperty.call(m, "CreateTime"))
                w.uint32(152).int64(m.CreateTime);
            if (m.CreaterID != null && Object.hasOwnProperty.call(m, "CreaterID"))
                w.uint32(160).uint64(m.CreaterID);
            if (m.UpdateTime != null && Object.hasOwnProperty.call(m, "UpdateTime"))
                w.uint32(168).int64(m.UpdateTime);
            if (m.UpdaterID != null && Object.hasOwnProperty.call(m, "UpdaterID"))
                w.uint32(176).uint64(m.UpdaterID);
            if (m.Estate != null && Object.hasOwnProperty.call(m, "Estate"))
                w.uint32(184).int32(m.Estate);
            return w;
        };

        MchStoredOption.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.MchStoredOption();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        m.SOID = r.uint64();
                        break;
                    }
                    case 2: {
                        m.MchID = r.uint64();
                        break;
                    }
                    case 3: {
                        m.Category = r.int32();
                        break;
                    }
                    case 4: {
                        m.Title1 = r.string();
                        break;
                    }
                    case 5: {
                        m.Title2 = r.string();
                        break;
                    }
                    case 6: {
                        m.Title3 = r.string();
                        break;
                    }
                    case 7: {
                        m.Amount = r.int64();
                        break;
                    }
                    case 8: {
                        m.RewardCategory = r.int32();
                        break;
                    }
                    case 9: {
                        m.RewardAmount = r.int64();
                        break;
                    }
                    case 10: {
                        m.RewardRate = r.int64();
                        break;
                    }
                    case 11: {
                        m.RewardPointsCategory = r.int32();
                        break;
                    }
                    case 12: {
                        m.RewardPoints = r.int64();
                        break;
                    }
                    case 13: {
                        m.RewardPointsRate = r.int64();
                        break;
                    }
                    case 14: {
                        m.IsAutoOff = r.int32();
                        break;
                    }
                    case 15: {
                        m.StartDate = r.int64();
                        break;
                    }
                    case 16: {
                        m.EndDate = r.int64();
                        break;
                    }
                    case 17: {
                        m.IsGiveCoupon = r.int32();
                        break;
                    }
                    case 18: {
                        m.GiveCouponID = r.uint64();
                        break;
                    }
                    case 19: {
                        m.CreateTime = r.int64();
                        break;
                    }
                    case 20: {
                        m.CreaterID = r.uint64();
                        break;
                    }
                    case 21: {
                        m.UpdateTime = r.int64();
                        break;
                    }
                    case 22: {
                        m.UpdaterID = r.uint64();
                        break;
                    }
                    case 23: {
                        m.Estate = r.int32();
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        MchStoredOption.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.MchStoredOption";
        };

        return MchStoredOption;
    })();

    PBEntity.MchStoredOptions = (function () {

        function MchStoredOptions(p) {
            this.MchStoredOptions = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        MchStoredOptions.prototype.MchStoredOptions = $util.emptyArray;

        MchStoredOptions.create = function create(properties) {
            return new MchStoredOptions(properties);
        };

        MchStoredOptions.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.MchStoredOptions != null && m.MchStoredOptions.length) {
                for (var i = 0; i < m.MchStoredOptions.length; ++i)
                    $root.PBEntity.MchStoredOption.encode(m.MchStoredOptions[i], w.uint32(10).fork()).ldelim();
            }
            return w;
        };

        MchStoredOptions.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.MchStoredOptions();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        if (!(m.MchStoredOptions && m.MchStoredOptions.length))
                            m.MchStoredOptions = [];
                        m.MchStoredOptions.push($root.PBEntity.MchStoredOption.decode(r, r.uint32()));
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        MchStoredOptions.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.MchStoredOptions";
        };

        return MchStoredOptions;
    })();

    PBEntity.MchSwiper = (function () {

        function MchSwiper(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        MchSwiper.prototype.SwiperID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        MchSwiper.prototype.MchID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        MchSwiper.prototype.Category = 0;
        MchSwiper.prototype.FileID = "";
        MchSwiper.prototype.Priority = 0;
        MchSwiper.prototype.LinkURL = "";
        MchSwiper.prototype.Name1 = "";
        MchSwiper.prototype.Name2 = "";
        MchSwiper.prototype.Name3 = "";
        MchSwiper.prototype.CreateTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        MchSwiper.prototype.CreaterID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        MchSwiper.prototype.UpdateTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        MchSwiper.prototype.UpdaterID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        MchSwiper.prototype.Estate = 0;

        MchSwiper.create = function create(properties) {
            return new MchSwiper(properties);
        };

        MchSwiper.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.SwiperID != null && Object.hasOwnProperty.call(m, "SwiperID"))
                w.uint32(8).uint64(m.SwiperID);
            if (m.MchID != null && Object.hasOwnProperty.call(m, "MchID"))
                w.uint32(16).uint64(m.MchID);
            if (m.Category != null && Object.hasOwnProperty.call(m, "Category"))
                w.uint32(24).int32(m.Category);
            if (m.FileID != null && Object.hasOwnProperty.call(m, "FileID"))
                w.uint32(34).string(m.FileID);
            if (m.Priority != null && Object.hasOwnProperty.call(m, "Priority"))
                w.uint32(40).int32(m.Priority);
            if (m.LinkURL != null && Object.hasOwnProperty.call(m, "LinkURL"))
                w.uint32(50).string(m.LinkURL);
            if (m.Name1 != null && Object.hasOwnProperty.call(m, "Name1"))
                w.uint32(58).string(m.Name1);
            if (m.Name2 != null && Object.hasOwnProperty.call(m, "Name2"))
                w.uint32(66).string(m.Name2);
            if (m.Name3 != null && Object.hasOwnProperty.call(m, "Name3"))
                w.uint32(74).string(m.Name3);
            if (m.CreateTime != null && Object.hasOwnProperty.call(m, "CreateTime"))
                w.uint32(80).int64(m.CreateTime);
            if (m.CreaterID != null && Object.hasOwnProperty.call(m, "CreaterID"))
                w.uint32(88).uint64(m.CreaterID);
            if (m.UpdateTime != null && Object.hasOwnProperty.call(m, "UpdateTime"))
                w.uint32(96).int64(m.UpdateTime);
            if (m.UpdaterID != null && Object.hasOwnProperty.call(m, "UpdaterID"))
                w.uint32(104).uint64(m.UpdaterID);
            if (m.Estate != null && Object.hasOwnProperty.call(m, "Estate"))
                w.uint32(112).int32(m.Estate);
            return w;
        };

        MchSwiper.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.MchSwiper();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        m.SwiperID = r.uint64();
                        break;
                    }
                    case 2: {
                        m.MchID = r.uint64();
                        break;
                    }
                    case 3: {
                        m.Category = r.int32();
                        break;
                    }
                    case 4: {
                        m.FileID = r.string();
                        break;
                    }
                    case 5: {
                        m.Priority = r.int32();
                        break;
                    }
                    case 6: {
                        m.LinkURL = r.string();
                        break;
                    }
                    case 7: {
                        m.Name1 = r.string();
                        break;
                    }
                    case 8: {
                        m.Name2 = r.string();
                        break;
                    }
                    case 9: {
                        m.Name3 = r.string();
                        break;
                    }
                    case 10: {
                        m.CreateTime = r.int64();
                        break;
                    }
                    case 11: {
                        m.CreaterID = r.uint64();
                        break;
                    }
                    case 12: {
                        m.UpdateTime = r.int64();
                        break;
                    }
                    case 13: {
                        m.UpdaterID = r.uint64();
                        break;
                    }
                    case 14: {
                        m.Estate = r.int32();
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        MchSwiper.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.MchSwiper";
        };

        return MchSwiper;
    })();

    PBEntity.MchSwipers = (function () {

        function MchSwipers(p) {
            this.MchSwipers = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        MchSwipers.prototype.MchSwipers = $util.emptyArray;

        MchSwipers.create = function create(properties) {
            return new MchSwipers(properties);
        };

        MchSwipers.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.MchSwipers != null && m.MchSwipers.length) {
                for (var i = 0; i < m.MchSwipers.length; ++i)
                    $root.PBEntity.MchSwiper.encode(m.MchSwipers[i], w.uint32(10).fork()).ldelim();
            }
            return w;
        };

        MchSwipers.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.MchSwipers();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        if (!(m.MchSwipers && m.MchSwipers.length))
                            m.MchSwipers = [];
                        m.MchSwipers.push($root.PBEntity.MchSwiper.decode(r, r.uint32()));
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        MchSwipers.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.MchSwipers";
        };

        return MchSwipers;
    })();

    PBEntity.MchTakePoint = (function () {

        function MchTakePoint(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        MchTakePoint.prototype.TakePointID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        MchTakePoint.prototype.MchID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        MchTakePoint.prototype.Name1 = "";
        MchTakePoint.prototype.Name2 = "";
        MchTakePoint.prototype.Name3 = "";
        MchTakePoint.prototype.Category = 0;
        MchTakePoint.prototype.UseID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        MchTakePoint.prototype.UseCategory = 0;
        MchTakePoint.prototype.Notes = "";
        MchTakePoint.prototype.GroupID = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        MchTakePoint.prototype.QRCodeType = 0;
        MchTakePoint.prototype.QRCodeID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        MchTakePoint.prototype.CreateTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        MchTakePoint.prototype.CreaterID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        MchTakePoint.prototype.UpdateTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        MchTakePoint.prototype.UpdaterID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        MchTakePoint.prototype.Estate = 0;

        MchTakePoint.create = function create(properties) {
            return new MchTakePoint(properties);
        };

        MchTakePoint.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.TakePointID != null && Object.hasOwnProperty.call(m, "TakePointID"))
                w.uint32(8).uint64(m.TakePointID);
            if (m.MchID != null && Object.hasOwnProperty.call(m, "MchID"))
                w.uint32(16).uint64(m.MchID);
            if (m.Name1 != null && Object.hasOwnProperty.call(m, "Name1"))
                w.uint32(26).string(m.Name1);
            if (m.Name2 != null && Object.hasOwnProperty.call(m, "Name2"))
                w.uint32(34).string(m.Name2);
            if (m.Name3 != null && Object.hasOwnProperty.call(m, "Name3"))
                w.uint32(42).string(m.Name3);
            if (m.Category != null && Object.hasOwnProperty.call(m, "Category"))
                w.uint32(48).int32(m.Category);
            if (m.UseID != null && Object.hasOwnProperty.call(m, "UseID"))
                w.uint32(56).uint64(m.UseID);
            if (m.UseCategory != null && Object.hasOwnProperty.call(m, "UseCategory"))
                w.uint32(64).int32(m.UseCategory);
            if (m.Notes != null && Object.hasOwnProperty.call(m, "Notes"))
                w.uint32(74).string(m.Notes);
            if (m.GroupID != null && Object.hasOwnProperty.call(m, "GroupID"))
                w.uint32(80).int64(m.GroupID);
            if (m.QRCodeType != null && Object.hasOwnProperty.call(m, "QRCodeType"))
                w.uint32(88).int32(m.QRCodeType);
            if (m.QRCodeID != null && Object.hasOwnProperty.call(m, "QRCodeID"))
                w.uint32(96).uint64(m.QRCodeID);
            if (m.CreateTime != null && Object.hasOwnProperty.call(m, "CreateTime"))
                w.uint32(104).int64(m.CreateTime);
            if (m.CreaterID != null && Object.hasOwnProperty.call(m, "CreaterID"))
                w.uint32(112).uint64(m.CreaterID);
            if (m.UpdateTime != null && Object.hasOwnProperty.call(m, "UpdateTime"))
                w.uint32(120).int64(m.UpdateTime);
            if (m.UpdaterID != null && Object.hasOwnProperty.call(m, "UpdaterID"))
                w.uint32(128).uint64(m.UpdaterID);
            if (m.Estate != null && Object.hasOwnProperty.call(m, "Estate"))
                w.uint32(136).int32(m.Estate);
            return w;
        };

        MchTakePoint.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.MchTakePoint();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        m.TakePointID = r.uint64();
                        break;
                    }
                    case 2: {
                        m.MchID = r.uint64();
                        break;
                    }
                    case 3: {
                        m.Name1 = r.string();
                        break;
                    }
                    case 4: {
                        m.Name2 = r.string();
                        break;
                    }
                    case 5: {
                        m.Name3 = r.string();
                        break;
                    }
                    case 6: {
                        m.Category = r.int32();
                        break;
                    }
                    case 7: {
                        m.UseID = r.uint64();
                        break;
                    }
                    case 8: {
                        m.UseCategory = r.int32();
                        break;
                    }
                    case 9: {
                        m.Notes = r.string();
                        break;
                    }
                    case 10: {
                        m.GroupID = r.int64();
                        break;
                    }
                    case 11: {
                        m.QRCodeType = r.int32();
                        break;
                    }
                    case 12: {
                        m.QRCodeID = r.uint64();
                        break;
                    }
                    case 13: {
                        m.CreateTime = r.int64();
                        break;
                    }
                    case 14: {
                        m.CreaterID = r.uint64();
                        break;
                    }
                    case 15: {
                        m.UpdateTime = r.int64();
                        break;
                    }
                    case 16: {
                        m.UpdaterID = r.uint64();
                        break;
                    }
                    case 17: {
                        m.Estate = r.int32();
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        MchTakePoint.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.MchTakePoint";
        };

        return MchTakePoint;
    })();

    PBEntity.MchTakePoints = (function () {

        function MchTakePoints(p) {
            this.MchTakePoints = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        MchTakePoints.prototype.MchTakePoints = $util.emptyArray;

        MchTakePoints.create = function create(properties) {
            return new MchTakePoints(properties);
        };

        MchTakePoints.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.MchTakePoints != null && m.MchTakePoints.length) {
                for (var i = 0; i < m.MchTakePoints.length; ++i)
                    $root.PBEntity.MchTakePoint.encode(m.MchTakePoints[i], w.uint32(10).fork()).ldelim();
            }
            return w;
        };

        MchTakePoints.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.MchTakePoints();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        if (!(m.MchTakePoints && m.MchTakePoints.length))
                            m.MchTakePoints = [];
                        m.MchTakePoints.push($root.PBEntity.MchTakePoint.decode(r, r.uint32()));
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        MchTakePoints.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.MchTakePoints";
        };

        return MchTakePoints;
    })();

    PBEntity.MchUserSchedule = (function () {

        function MchUserSchedule(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        MchUserSchedule.prototype.UserID = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        MchUserSchedule.prototype.MchID = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        MchUserSchedule.prototype.ScheduleID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        MchUserSchedule.prototype.CreateTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        MchUserSchedule.prototype.CreaterID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        MchUserSchedule.prototype.Estate = 0;

        MchUserSchedule.create = function create(properties) {
            return new MchUserSchedule(properties);
        };

        MchUserSchedule.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.UserID != null && Object.hasOwnProperty.call(m, "UserID"))
                w.uint32(8).int64(m.UserID);
            if (m.MchID != null && Object.hasOwnProperty.call(m, "MchID"))
                w.uint32(16).int64(m.MchID);
            if (m.ScheduleID != null && Object.hasOwnProperty.call(m, "ScheduleID"))
                w.uint32(24).uint64(m.ScheduleID);
            if (m.CreateTime != null && Object.hasOwnProperty.call(m, "CreateTime"))
                w.uint32(32).int64(m.CreateTime);
            if (m.CreaterID != null && Object.hasOwnProperty.call(m, "CreaterID"))
                w.uint32(40).uint64(m.CreaterID);
            if (m.Estate != null && Object.hasOwnProperty.call(m, "Estate"))
                w.uint32(48).int32(m.Estate);
            return w;
        };

        MchUserSchedule.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.MchUserSchedule();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        m.UserID = r.int64();
                        break;
                    }
                    case 2: {
                        m.MchID = r.int64();
                        break;
                    }
                    case 3: {
                        m.ScheduleID = r.uint64();
                        break;
                    }
                    case 4: {
                        m.CreateTime = r.int64();
                        break;
                    }
                    case 5: {
                        m.CreaterID = r.uint64();
                        break;
                    }
                    case 6: {
                        m.Estate = r.int32();
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        MchUserSchedule.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.MchUserSchedule";
        };

        return MchUserSchedule;
    })();

    PBEntity.MchUserSchedules = (function () {

        function MchUserSchedules(p) {
            this.MchUserSchedules = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        MchUserSchedules.prototype.MchUserSchedules = $util.emptyArray;

        MchUserSchedules.create = function create(properties) {
            return new MchUserSchedules(properties);
        };

        MchUserSchedules.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.MchUserSchedules != null && m.MchUserSchedules.length) {
                for (var i = 0; i < m.MchUserSchedules.length; ++i)
                    $root.PBEntity.MchUserSchedule.encode(m.MchUserSchedules[i], w.uint32(10).fork()).ldelim();
            }
            return w;
        };

        MchUserSchedules.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.MchUserSchedules();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        if (!(m.MchUserSchedules && m.MchUserSchedules.length))
                            m.MchUserSchedules = [];
                        m.MchUserSchedules.push($root.PBEntity.MchUserSchedule.decode(r, r.uint32()));
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        MchUserSchedules.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.MchUserSchedules";
        };

        return MchUserSchedules;
    })();

    PBEntity.MchVoice = (function () {

        function MchVoice(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        MchVoice.prototype.VoiceID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        MchVoice.prototype.VbName1 = "";
        MchVoice.prototype.VbName2 = "";
        MchVoice.prototype.VbName3 = "";
        MchVoice.prototype.MchID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        MchVoice.prototype.MachineSN = "";
        MchVoice.prototype.AccessCode = "";
        MchVoice.prototype.Cate = 0;
        MchVoice.prototype.Imei = "";
        MchVoice.prototype.Iccid = "";
        MchVoice.prototype.Imsi = "";
        MchVoice.prototype.Vendor = "";
        MchVoice.prototype.IsAt = 0;
        MchVoice.prototype.IsAtTakeaway = 0;
        MchVoice.prototype.IsAtYourself = 0;
        MchVoice.prototype.IsAtShop = 0;
        MchVoice.prototype.IsAtSeq = 0;
        MchVoice.prototype.IsAtAmt = 0;
        MchVoice.prototype.IsPay = 0;
        MchVoice.prototype.IsPayTakeaway = 0;
        MchVoice.prototype.IsPayYourself = 0;
        MchVoice.prototype.IsPayShop = 0;
        MchVoice.prototype.IsPaySeq = 0;
        MchVoice.prototype.IsPayAmt = 0;
        MchVoice.prototype.IsTake = 0;
        MchVoice.prototype.IsVbName = 0;
        MchVoice.prototype.IsRcpay = 0;
        MchVoice.prototype.IsRcpayChannel = 0;
        MchVoice.prototype.VoiceStatus = 0;
        MchVoice.prototype.BindTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        MchVoice.prototype.CreateTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        MchVoice.prototype.CreaterID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        MchVoice.prototype.UpdateTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        MchVoice.prototype.UpdaterID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        MchVoice.prototype.Estate = 0;

        MchVoice.create = function create(properties) {
            return new MchVoice(properties);
        };

        MchVoice.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.VoiceID != null && Object.hasOwnProperty.call(m, "VoiceID"))
                w.uint32(8).uint64(m.VoiceID);
            if (m.VbName1 != null && Object.hasOwnProperty.call(m, "VbName1"))
                w.uint32(18).string(m.VbName1);
            if (m.VbName2 != null && Object.hasOwnProperty.call(m, "VbName2"))
                w.uint32(26).string(m.VbName2);
            if (m.VbName3 != null && Object.hasOwnProperty.call(m, "VbName3"))
                w.uint32(34).string(m.VbName3);
            if (m.MchID != null && Object.hasOwnProperty.call(m, "MchID"))
                w.uint32(40).uint64(m.MchID);
            if (m.MachineSN != null && Object.hasOwnProperty.call(m, "MachineSN"))
                w.uint32(50).string(m.MachineSN);
            if (m.AccessCode != null && Object.hasOwnProperty.call(m, "AccessCode"))
                w.uint32(58).string(m.AccessCode);
            if (m.Cate != null && Object.hasOwnProperty.call(m, "Cate"))
                w.uint32(64).int32(m.Cate);
            if (m.Imei != null && Object.hasOwnProperty.call(m, "Imei"))
                w.uint32(74).string(m.Imei);
            if (m.Iccid != null && Object.hasOwnProperty.call(m, "Iccid"))
                w.uint32(82).string(m.Iccid);
            if (m.Imsi != null && Object.hasOwnProperty.call(m, "Imsi"))
                w.uint32(90).string(m.Imsi);
            if (m.Vendor != null && Object.hasOwnProperty.call(m, "Vendor"))
                w.uint32(98).string(m.Vendor);
            if (m.IsAt != null && Object.hasOwnProperty.call(m, "IsAt"))
                w.uint32(104).int32(m.IsAt);
            if (m.IsAtTakeaway != null && Object.hasOwnProperty.call(m, "IsAtTakeaway"))
                w.uint32(112).int32(m.IsAtTakeaway);
            if (m.IsAtYourself != null && Object.hasOwnProperty.call(m, "IsAtYourself"))
                w.uint32(120).int32(m.IsAtYourself);
            if (m.IsAtShop != null && Object.hasOwnProperty.call(m, "IsAtShop"))
                w.uint32(128).int32(m.IsAtShop);
            if (m.IsAtSeq != null && Object.hasOwnProperty.call(m, "IsAtSeq"))
                w.uint32(136).int32(m.IsAtSeq);
            if (m.IsAtAmt != null && Object.hasOwnProperty.call(m, "IsAtAmt"))
                w.uint32(144).int32(m.IsAtAmt);
            if (m.IsPay != null && Object.hasOwnProperty.call(m, "IsPay"))
                w.uint32(152).int32(m.IsPay);
            if (m.IsPayTakeaway != null && Object.hasOwnProperty.call(m, "IsPayTakeaway"))
                w.uint32(160).int32(m.IsPayTakeaway);
            if (m.IsPayYourself != null && Object.hasOwnProperty.call(m, "IsPayYourself"))
                w.uint32(168).int32(m.IsPayYourself);
            if (m.IsPayShop != null && Object.hasOwnProperty.call(m, "IsPayShop"))
                w.uint32(176).int32(m.IsPayShop);
            if (m.IsPaySeq != null && Object.hasOwnProperty.call(m, "IsPaySeq"))
                w.uint32(184).int32(m.IsPaySeq);
            if (m.IsPayAmt != null && Object.hasOwnProperty.call(m, "IsPayAmt"))
                w.uint32(192).int32(m.IsPayAmt);
            if (m.IsTake != null && Object.hasOwnProperty.call(m, "IsTake"))
                w.uint32(200).int32(m.IsTake);
            if (m.IsVbName != null && Object.hasOwnProperty.call(m, "IsVbName"))
                w.uint32(208).int32(m.IsVbName);
            if (m.IsRcpay != null && Object.hasOwnProperty.call(m, "IsRcpay"))
                w.uint32(216).int32(m.IsRcpay);
            if (m.IsRcpayChannel != null && Object.hasOwnProperty.call(m, "IsRcpayChannel"))
                w.uint32(224).int32(m.IsRcpayChannel);
            if (m.VoiceStatus != null && Object.hasOwnProperty.call(m, "VoiceStatus"))
                w.uint32(232).int32(m.VoiceStatus);
            if (m.BindTime != null && Object.hasOwnProperty.call(m, "BindTime"))
                w.uint32(240).int64(m.BindTime);
            if (m.CreateTime != null && Object.hasOwnProperty.call(m, "CreateTime"))
                w.uint32(248).int64(m.CreateTime);
            if (m.CreaterID != null && Object.hasOwnProperty.call(m, "CreaterID"))
                w.uint32(256).uint64(m.CreaterID);
            if (m.UpdateTime != null && Object.hasOwnProperty.call(m, "UpdateTime"))
                w.uint32(264).int64(m.UpdateTime);
            if (m.UpdaterID != null && Object.hasOwnProperty.call(m, "UpdaterID"))
                w.uint32(272).uint64(m.UpdaterID);
            if (m.Estate != null && Object.hasOwnProperty.call(m, "Estate"))
                w.uint32(280).int32(m.Estate);
            return w;
        };

        MchVoice.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.MchVoice();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        m.VoiceID = r.uint64();
                        break;
                    }
                    case 2: {
                        m.VbName1 = r.string();
                        break;
                    }
                    case 3: {
                        m.VbName2 = r.string();
                        break;
                    }
                    case 4: {
                        m.VbName3 = r.string();
                        break;
                    }
                    case 5: {
                        m.MchID = r.uint64();
                        break;
                    }
                    case 6: {
                        m.MachineSN = r.string();
                        break;
                    }
                    case 7: {
                        m.AccessCode = r.string();
                        break;
                    }
                    case 8: {
                        m.Cate = r.int32();
                        break;
                    }
                    case 9: {
                        m.Imei = r.string();
                        break;
                    }
                    case 10: {
                        m.Iccid = r.string();
                        break;
                    }
                    case 11: {
                        m.Imsi = r.string();
                        break;
                    }
                    case 12: {
                        m.Vendor = r.string();
                        break;
                    }
                    case 13: {
                        m.IsAt = r.int32();
                        break;
                    }
                    case 14: {
                        m.IsAtTakeaway = r.int32();
                        break;
                    }
                    case 15: {
                        m.IsAtYourself = r.int32();
                        break;
                    }
                    case 16: {
                        m.IsAtShop = r.int32();
                        break;
                    }
                    case 17: {
                        m.IsAtSeq = r.int32();
                        break;
                    }
                    case 18: {
                        m.IsAtAmt = r.int32();
                        break;
                    }
                    case 19: {
                        m.IsPay = r.int32();
                        break;
                    }
                    case 20: {
                        m.IsPayTakeaway = r.int32();
                        break;
                    }
                    case 21: {
                        m.IsPayYourself = r.int32();
                        break;
                    }
                    case 22: {
                        m.IsPayShop = r.int32();
                        break;
                    }
                    case 23: {
                        m.IsPaySeq = r.int32();
                        break;
                    }
                    case 24: {
                        m.IsPayAmt = r.int32();
                        break;
                    }
                    case 25: {
                        m.IsTake = r.int32();
                        break;
                    }
                    case 26: {
                        m.IsVbName = r.int32();
                        break;
                    }
                    case 27: {
                        m.IsRcpay = r.int32();
                        break;
                    }
                    case 28: {
                        m.IsRcpayChannel = r.int32();
                        break;
                    }
                    case 29: {
                        m.VoiceStatus = r.int32();
                        break;
                    }
                    case 30: {
                        m.BindTime = r.int64();
                        break;
                    }
                    case 31: {
                        m.CreateTime = r.int64();
                        break;
                    }
                    case 32: {
                        m.CreaterID = r.uint64();
                        break;
                    }
                    case 33: {
                        m.UpdateTime = r.int64();
                        break;
                    }
                    case 34: {
                        m.UpdaterID = r.uint64();
                        break;
                    }
                    case 35: {
                        m.Estate = r.int32();
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        MchVoice.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.MchVoice";
        };

        return MchVoice;
    })();

    PBEntity.MchVoices = (function () {

        function MchVoices(p) {
            this.MchVoices = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        MchVoices.prototype.MchVoices = $util.emptyArray;

        MchVoices.create = function create(properties) {
            return new MchVoices(properties);
        };

        MchVoices.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.MchVoices != null && m.MchVoices.length) {
                for (var i = 0; i < m.MchVoices.length; ++i)
                    $root.PBEntity.MchVoice.encode(m.MchVoices[i], w.uint32(10).fork()).ldelim();
            }
            return w;
        };

        MchVoices.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.MchVoices();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        if (!(m.MchVoices && m.MchVoices.length))
                            m.MchVoices = [];
                        m.MchVoices.push($root.PBEntity.MchVoice.decode(r, r.uint32()));
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        MchVoices.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.MchVoices";
        };

        return MchVoices;
    })();

    PBEntity.Merchant = (function () {

        function Merchant(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        Merchant.prototype.ID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        Merchant.prototype.Name1 = "";
        Merchant.prototype.Name2 = "";
        Merchant.prototype.Name3 = "";
        Merchant.prototype.CertType = 0;
        Merchant.prototype.CertNo = "";
        Merchant.prototype.Address = "";
        Merchant.prototype.LegalPerson = "";
        Merchant.prototype.LegalPersonMobile = "";
        Merchant.prototype.CSPhone = "";
        Merchant.prototype.LocalX = 0;
        Merchant.prototype.LocalY = 0;
        Merchant.prototype.LocalZ = 0;
        Merchant.prototype.Level = 0;
        Merchant.prototype.Category = 0;
        Merchant.prototype.GroupID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        Merchant.prototype.BelongStoredAccID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        Merchant.prototype.BelongPointsAccID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        Merchant.prototype.BusCategory = 0;
        Merchant.prototype.Cover = "";
        Merchant.prototype.EnableOperTime1 = 0;
        Merchant.prototype.OperStartTime1 = 0;
        Merchant.prototype.OperEndTime1 = 0;
        Merchant.prototype.EnableOperTime2 = 0;
        Merchant.prototype.OperStartTime2 = 0;
        Merchant.prototype.OperEndTime2 = 0;
        Merchant.prototype.EnableOperTime3 = 0;
        Merchant.prototype.OperStartTime3 = 0;
        Merchant.prototype.OperEndTime3 = 0;
        Merchant.prototype.HasStoredAmt = 0;
        Merchant.prototype.HasPos = 0;
        Merchant.prototype.HasWXMP = 0;
        Merchant.prototype.HasWXH5 = 0;
        Merchant.prototype.WXMchID = "";
        Merchant.prototype.WXAppID = "";
        Merchant.prototype.AllowOnlineZeroSale = 0;
        Merchant.prototype.HasOnlineReserve = 0;
        Merchant.prototype.ReserveKeepTime = 0;
        Merchant.prototype.ReserveMinTime = 0;
        Merchant.prototype.ReserveMaxTime = 0;
        Merchant.prototype.HasOnlineBuy = 0;
        Merchant.prototype.HasShopScanCode = 0;
        Merchant.prototype.HasShopOpenDesk = 0;
        Merchant.prototype.ShopPayMode = 0;
        Merchant.prototype.HasYourself = 0;
        Merchant.prototype.YourselfPayMode = 0;
        Merchant.prototype.HasTakeAway = 0;
        Merchant.prototype.TakeAwayPayMode = 0;
        Merchant.prototype.TakeAwayMinAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Merchant.prototype.TakeAwayCharge = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Merchant.prototype.TakeAwayFreeAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Merchant.prototype.DeliveryNotes = "";
        Merchant.prototype.HasEmpReserve = 0;
        Merchant.prototype.EmpReserveKeepTime = 0;
        Merchant.prototype.EmpReserveMinTime = 0;
        Merchant.prototype.EmpReserveMaxTime = 0;
        Merchant.prototype.HasEmpShop = 0;
        Merchant.prototype.EmpShopPayMode = 0;
        Merchant.prototype.HasEmpYourself = 0;
        Merchant.prototype.EmpYourselfPayMode = 0;
        Merchant.prototype.HasEmpTakeAway = 0;
        Merchant.prototype.EmpTakeAwayPayMode = 0;
        Merchant.prototype.EmpTakeAwayMinAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Merchant.prototype.EmpTakeAwayCharge = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Merchant.prototype.EmpTakeAwayFreeAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Merchant.prototype.EmpTakeAwayNotes = "";
        Merchant.prototype.HasPoints = 0;
        Merchant.prototype.PointsRatio = 0;
        Merchant.prototype.PointsTerm = 0;
        Merchant.prototype.HasAutoUpLevel = 0;
        Merchant.prototype.HasPointsDeduction = 0;
        Merchant.prototype.PointsDeductionRatio = 0;
        Merchant.prototype.HasCoupon = 0;
        Merchant.prototype.State = 0;
        Merchant.prototype.AdminID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        Merchant.prototype.IsOnlyDelivery = 0;
        Merchant.prototype.AllowTakePlanTime = 0;
        Merchant.prototype.AllowTakePlanTimeByClose = 0;
        Merchant.prototype.AutoClearByShopPay = 0;
        Merchant.prototype.AutoClearByEmpShopPay = 0;
        Merchant.prototype.PackAwayPackageFee = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Merchant.prototype.DeliverPackageFee = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Merchant.prototype.TakeSelfPackageFee = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Merchant.prototype.IsNotice = 0;
        Merchant.prototype.Notes = "";
        Merchant.prototype.PackAwayPackingCostCate = 0;
        Merchant.prototype.HomeDeliverPackingCostCate = 0;
        Merchant.prototype.StoreTakeyPackingCostCate = 0;
        Merchant.prototype.IsDeliveryByDistance = 0;
        Merchant.prototype.DeliveryChargeCate = 0;
        Merchant.prototype.DeliveryChargeRadiusMin = 0;
        Merchant.prototype.DeliveryChargeRadiusMax = 0;
        Merchant.prototype.TakeAwayCharge2 = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Merchant.prototype.DeliveryChargeRadiusMin2 = 0;
        Merchant.prototype.DeliveryChargeRadiusMax2 = 0;
        Merchant.prototype.DeliveryMaxRadius = 0;
        Merchant.prototype.LicenseTypeID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        Merchant.prototype.IsExpire = 0;
        Merchant.prototype.ExpireTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Merchant.prototype.MFNotes = "";
        Merchant.prototype.IsReserveNeeds = 0;
        Merchant.prototype.TakeSelfPayMode = 0;
        Merchant.prototype.UnOnlinePayAlert = "";
        Merchant.prototype.UnAdvAmtAlert = "";
        Merchant.prototype.AllowPayLater = 0;
        Merchant.prototype.ShowBuyCate = 0;
        Merchant.prototype.CountryID = 0;
        Merchant.prototype.ProvinceID = 0;
        Merchant.prototype.CityID = 0;
        Merchant.prototype.AreaName = "";
        Merchant.prototype.VoiceCount = 0;
        Merchant.prototype.PMPTakeAway = 0;
        Merchant.prototype.PMPYourself = 0;
        Merchant.prototype.PMPShop = 0;
        Merchant.prototype.IsYourselfPT = 0;
        Merchant.prototype.IsYourselfPTByClose = 0;
        Merchant.prototype.YourselfOpenTake = 0;
        Merchant.prototype.DailyBillingCycle = 0;
        Merchant.prototype.AutoFinishHour = 0;
        Merchant.prototype.IsMustGC = 0;
        Merchant.prototype.IsByGC = 0;
        Merchant.prototype.EveryDayStartSeq = 0;
        Merchant.prototype.HasWXRefund = 0;
        Merchant.prototype.HasZFBRefund = 0;
        Merchant.prototype.IsYourselfMustTable = 0;
        Merchant.prototype.IsTakeSelfMustPoint = 0;
        Merchant.prototype.AtOrderUserMinLevel = 0;
        Merchant.prototype.JoinVIPLimit = 0;
        Merchant.prototype.IsShowCS = 0;
        Merchant.prototype.TaxRate = 0;
        Merchant.prototype.SFRate = 0;
        Merchant.prototype.Language1 = 0;
        Merchant.prototype.Language2 = 0;
        Merchant.prototype.Language3 = 0;
        Merchant.prototype.Order30Count = 0;
        Merchant.prototype.Order30Amt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Merchant.prototype.OrderYestCount = 0;
        Merchant.prototype.OrderYestAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Merchant.prototype.ApproveTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Merchant.prototype.CreateTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Merchant.prototype.CreaterID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        Merchant.prototype.UpdateTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Merchant.prototype.UpdaterID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        Merchant.prototype.Estate = 0;

        Merchant.create = function create(properties) {
            return new Merchant(properties);
        };

        Merchant.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.ID != null && Object.hasOwnProperty.call(m, "ID"))
                w.uint32(8).uint64(m.ID);
            if (m.Name1 != null && Object.hasOwnProperty.call(m, "Name1"))
                w.uint32(18).string(m.Name1);
            if (m.Name2 != null && Object.hasOwnProperty.call(m, "Name2"))
                w.uint32(26).string(m.Name2);
            if (m.Name3 != null && Object.hasOwnProperty.call(m, "Name3"))
                w.uint32(34).string(m.Name3);
            if (m.CertType != null && Object.hasOwnProperty.call(m, "CertType"))
                w.uint32(40).int32(m.CertType);
            if (m.CertNo != null && Object.hasOwnProperty.call(m, "CertNo"))
                w.uint32(50).string(m.CertNo);
            if (m.Address != null && Object.hasOwnProperty.call(m, "Address"))
                w.uint32(58).string(m.Address);
            if (m.LegalPerson != null && Object.hasOwnProperty.call(m, "LegalPerson"))
                w.uint32(66).string(m.LegalPerson);
            if (m.LegalPersonMobile != null && Object.hasOwnProperty.call(m, "LegalPersonMobile"))
                w.uint32(74).string(m.LegalPersonMobile);
            if (m.CSPhone != null && Object.hasOwnProperty.call(m, "CSPhone"))
                w.uint32(82).string(m.CSPhone);
            if (m.LocalX != null && Object.hasOwnProperty.call(m, "LocalX"))
                w.uint32(89).double(m.LocalX);
            if (m.LocalY != null && Object.hasOwnProperty.call(m, "LocalY"))
                w.uint32(97).double(m.LocalY);
            if (m.LocalZ != null && Object.hasOwnProperty.call(m, "LocalZ"))
                w.uint32(105).double(m.LocalZ);
            if (m.Level != null && Object.hasOwnProperty.call(m, "Level"))
                w.uint32(112).int32(m.Level);
            if (m.Category != null && Object.hasOwnProperty.call(m, "Category"))
                w.uint32(120).int32(m.Category);
            if (m.GroupID != null && Object.hasOwnProperty.call(m, "GroupID"))
                w.uint32(128).uint64(m.GroupID);
            if (m.BelongStoredAccID != null && Object.hasOwnProperty.call(m, "BelongStoredAccID"))
                w.uint32(136).uint64(m.BelongStoredAccID);
            if (m.BelongPointsAccID != null && Object.hasOwnProperty.call(m, "BelongPointsAccID"))
                w.uint32(144).uint64(m.BelongPointsAccID);
            if (m.BusCategory != null && Object.hasOwnProperty.call(m, "BusCategory"))
                w.uint32(152).int32(m.BusCategory);
            if (m.Cover != null && Object.hasOwnProperty.call(m, "Cover"))
                w.uint32(162).string(m.Cover);
            if (m.EnableOperTime1 != null && Object.hasOwnProperty.call(m, "EnableOperTime1"))
                w.uint32(168).int32(m.EnableOperTime1);
            if (m.OperStartTime1 != null && Object.hasOwnProperty.call(m, "OperStartTime1"))
                w.uint32(177).double(m.OperStartTime1);
            if (m.OperEndTime1 != null && Object.hasOwnProperty.call(m, "OperEndTime1"))
                w.uint32(185).double(m.OperEndTime1);
            if (m.EnableOperTime2 != null && Object.hasOwnProperty.call(m, "EnableOperTime2"))
                w.uint32(192).int32(m.EnableOperTime2);
            if (m.OperStartTime2 != null && Object.hasOwnProperty.call(m, "OperStartTime2"))
                w.uint32(201).double(m.OperStartTime2);
            if (m.OperEndTime2 != null && Object.hasOwnProperty.call(m, "OperEndTime2"))
                w.uint32(209).double(m.OperEndTime2);
            if (m.EnableOperTime3 != null && Object.hasOwnProperty.call(m, "EnableOperTime3"))
                w.uint32(216).int32(m.EnableOperTime3);
            if (m.OperStartTime3 != null && Object.hasOwnProperty.call(m, "OperStartTime3"))
                w.uint32(225).double(m.OperStartTime3);
            if (m.OperEndTime3 != null && Object.hasOwnProperty.call(m, "OperEndTime3"))
                w.uint32(233).double(m.OperEndTime3);
            if (m.HasStoredAmt != null && Object.hasOwnProperty.call(m, "HasStoredAmt"))
                w.uint32(240).int32(m.HasStoredAmt);
            if (m.HasPos != null && Object.hasOwnProperty.call(m, "HasPos"))
                w.uint32(248).int32(m.HasPos);
            if (m.HasWXMP != null && Object.hasOwnProperty.call(m, "HasWXMP"))
                w.uint32(256).int32(m.HasWXMP);
            if (m.HasWXH5 != null && Object.hasOwnProperty.call(m, "HasWXH5"))
                w.uint32(264).int32(m.HasWXH5);
            if (m.WXMchID != null && Object.hasOwnProperty.call(m, "WXMchID"))
                w.uint32(274).string(m.WXMchID);
            if (m.WXAppID != null && Object.hasOwnProperty.call(m, "WXAppID"))
                w.uint32(282).string(m.WXAppID);
            if (m.AllowOnlineZeroSale != null && Object.hasOwnProperty.call(m, "AllowOnlineZeroSale"))
                w.uint32(288).int32(m.AllowOnlineZeroSale);
            if (m.HasOnlineReserve != null && Object.hasOwnProperty.call(m, "HasOnlineReserve"))
                w.uint32(296).int32(m.HasOnlineReserve);
            if (m.ReserveKeepTime != null && Object.hasOwnProperty.call(m, "ReserveKeepTime"))
                w.uint32(304).int32(m.ReserveKeepTime);
            if (m.ReserveMinTime != null && Object.hasOwnProperty.call(m, "ReserveMinTime"))
                w.uint32(312).int32(m.ReserveMinTime);
            if (m.ReserveMaxTime != null && Object.hasOwnProperty.call(m, "ReserveMaxTime"))
                w.uint32(320).int32(m.ReserveMaxTime);
            if (m.HasOnlineBuy != null && Object.hasOwnProperty.call(m, "HasOnlineBuy"))
                w.uint32(328).int32(m.HasOnlineBuy);
            if (m.HasShopScanCode != null && Object.hasOwnProperty.call(m, "HasShopScanCode"))
                w.uint32(336).int32(m.HasShopScanCode);
            if (m.HasShopOpenDesk != null && Object.hasOwnProperty.call(m, "HasShopOpenDesk"))
                w.uint32(344).int32(m.HasShopOpenDesk);
            if (m.ShopPayMode != null && Object.hasOwnProperty.call(m, "ShopPayMode"))
                w.uint32(352).int32(m.ShopPayMode);
            if (m.HasYourself != null && Object.hasOwnProperty.call(m, "HasYourself"))
                w.uint32(360).int32(m.HasYourself);
            if (m.YourselfPayMode != null && Object.hasOwnProperty.call(m, "YourselfPayMode"))
                w.uint32(368).int32(m.YourselfPayMode);
            if (m.HasTakeAway != null && Object.hasOwnProperty.call(m, "HasTakeAway"))
                w.uint32(376).int32(m.HasTakeAway);
            if (m.TakeAwayPayMode != null && Object.hasOwnProperty.call(m, "TakeAwayPayMode"))
                w.uint32(384).int32(m.TakeAwayPayMode);
            if (m.TakeAwayMinAmt != null && Object.hasOwnProperty.call(m, "TakeAwayMinAmt"))
                w.uint32(392).int64(m.TakeAwayMinAmt);
            if (m.TakeAwayCharge != null && Object.hasOwnProperty.call(m, "TakeAwayCharge"))
                w.uint32(400).int64(m.TakeAwayCharge);
            if (m.TakeAwayFreeAmt != null && Object.hasOwnProperty.call(m, "TakeAwayFreeAmt"))
                w.uint32(408).int64(m.TakeAwayFreeAmt);
            if (m.DeliveryNotes != null && Object.hasOwnProperty.call(m, "DeliveryNotes"))
                w.uint32(418).string(m.DeliveryNotes);
            if (m.HasEmpReserve != null && Object.hasOwnProperty.call(m, "HasEmpReserve"))
                w.uint32(424).int32(m.HasEmpReserve);
            if (m.EmpReserveKeepTime != null && Object.hasOwnProperty.call(m, "EmpReserveKeepTime"))
                w.uint32(432).int32(m.EmpReserveKeepTime);
            if (m.EmpReserveMinTime != null && Object.hasOwnProperty.call(m, "EmpReserveMinTime"))
                w.uint32(440).int32(m.EmpReserveMinTime);
            if (m.EmpReserveMaxTime != null && Object.hasOwnProperty.call(m, "EmpReserveMaxTime"))
                w.uint32(448).int32(m.EmpReserveMaxTime);
            if (m.HasEmpShop != null && Object.hasOwnProperty.call(m, "HasEmpShop"))
                w.uint32(456).int32(m.HasEmpShop);
            if (m.EmpShopPayMode != null && Object.hasOwnProperty.call(m, "EmpShopPayMode"))
                w.uint32(464).int32(m.EmpShopPayMode);
            if (m.HasEmpYourself != null && Object.hasOwnProperty.call(m, "HasEmpYourself"))
                w.uint32(472).int32(m.HasEmpYourself);
            if (m.EmpYourselfPayMode != null && Object.hasOwnProperty.call(m, "EmpYourselfPayMode"))
                w.uint32(480).int32(m.EmpYourselfPayMode);
            if (m.HasEmpTakeAway != null && Object.hasOwnProperty.call(m, "HasEmpTakeAway"))
                w.uint32(488).int32(m.HasEmpTakeAway);
            if (m.EmpTakeAwayPayMode != null && Object.hasOwnProperty.call(m, "EmpTakeAwayPayMode"))
                w.uint32(496).int32(m.EmpTakeAwayPayMode);
            if (m.EmpTakeAwayMinAmt != null && Object.hasOwnProperty.call(m, "EmpTakeAwayMinAmt"))
                w.uint32(504).int64(m.EmpTakeAwayMinAmt);
            if (m.EmpTakeAwayCharge != null && Object.hasOwnProperty.call(m, "EmpTakeAwayCharge"))
                w.uint32(512).int64(m.EmpTakeAwayCharge);
            if (m.EmpTakeAwayFreeAmt != null && Object.hasOwnProperty.call(m, "EmpTakeAwayFreeAmt"))
                w.uint32(520).int64(m.EmpTakeAwayFreeAmt);
            if (m.EmpTakeAwayNotes != null && Object.hasOwnProperty.call(m, "EmpTakeAwayNotes"))
                w.uint32(530).string(m.EmpTakeAwayNotes);
            if (m.HasPoints != null && Object.hasOwnProperty.call(m, "HasPoints"))
                w.uint32(536).int32(m.HasPoints);
            if (m.PointsRatio != null && Object.hasOwnProperty.call(m, "PointsRatio"))
                w.uint32(544).int32(m.PointsRatio);
            if (m.PointsTerm != null && Object.hasOwnProperty.call(m, "PointsTerm"))
                w.uint32(552).int32(m.PointsTerm);
            if (m.HasAutoUpLevel != null && Object.hasOwnProperty.call(m, "HasAutoUpLevel"))
                w.uint32(560).int32(m.HasAutoUpLevel);
            if (m.HasPointsDeduction != null && Object.hasOwnProperty.call(m, "HasPointsDeduction"))
                w.uint32(568).int32(m.HasPointsDeduction);
            if (m.PointsDeductionRatio != null && Object.hasOwnProperty.call(m, "PointsDeductionRatio"))
                w.uint32(576).int32(m.PointsDeductionRatio);
            if (m.HasCoupon != null && Object.hasOwnProperty.call(m, "HasCoupon"))
                w.uint32(584).int32(m.HasCoupon);
            if (m.State != null && Object.hasOwnProperty.call(m, "State"))
                w.uint32(592).int32(m.State);
            if (m.AdminID != null && Object.hasOwnProperty.call(m, "AdminID"))
                w.uint32(600).uint64(m.AdminID);
            if (m.IsOnlyDelivery != null && Object.hasOwnProperty.call(m, "IsOnlyDelivery"))
                w.uint32(608).int32(m.IsOnlyDelivery);
            if (m.AllowTakePlanTime != null && Object.hasOwnProperty.call(m, "AllowTakePlanTime"))
                w.uint32(616).int32(m.AllowTakePlanTime);
            if (m.AllowTakePlanTimeByClose != null && Object.hasOwnProperty.call(m, "AllowTakePlanTimeByClose"))
                w.uint32(624).int32(m.AllowTakePlanTimeByClose);
            if (m.AutoClearByShopPay != null && Object.hasOwnProperty.call(m, "AutoClearByShopPay"))
                w.uint32(632).int32(m.AutoClearByShopPay);
            if (m.AutoClearByEmpShopPay != null && Object.hasOwnProperty.call(m, "AutoClearByEmpShopPay"))
                w.uint32(640).int32(m.AutoClearByEmpShopPay);
            if (m.PackAwayPackageFee != null && Object.hasOwnProperty.call(m, "PackAwayPackageFee"))
                w.uint32(648).int64(m.PackAwayPackageFee);
            if (m.DeliverPackageFee != null && Object.hasOwnProperty.call(m, "DeliverPackageFee"))
                w.uint32(656).int64(m.DeliverPackageFee);
            if (m.TakeSelfPackageFee != null && Object.hasOwnProperty.call(m, "TakeSelfPackageFee"))
                w.uint32(664).int64(m.TakeSelfPackageFee);
            if (m.IsNotice != null && Object.hasOwnProperty.call(m, "IsNotice"))
                w.uint32(672).int32(m.IsNotice);
            if (m.Notes != null && Object.hasOwnProperty.call(m, "Notes"))
                w.uint32(682).string(m.Notes);
            if (m.PackAwayPackingCostCate != null && Object.hasOwnProperty.call(m, "PackAwayPackingCostCate"))
                w.uint32(688).int32(m.PackAwayPackingCostCate);
            if (m.HomeDeliverPackingCostCate != null && Object.hasOwnProperty.call(m, "HomeDeliverPackingCostCate"))
                w.uint32(696).int32(m.HomeDeliverPackingCostCate);
            if (m.StoreTakeyPackingCostCate != null && Object.hasOwnProperty.call(m, "StoreTakeyPackingCostCate"))
                w.uint32(704).int32(m.StoreTakeyPackingCostCate);
            if (m.IsDeliveryByDistance != null && Object.hasOwnProperty.call(m, "IsDeliveryByDistance"))
                w.uint32(712).int32(m.IsDeliveryByDistance);
            if (m.DeliveryChargeCate != null && Object.hasOwnProperty.call(m, "DeliveryChargeCate"))
                w.uint32(720).int32(m.DeliveryChargeCate);
            if (m.DeliveryChargeRadiusMin != null && Object.hasOwnProperty.call(m, "DeliveryChargeRadiusMin"))
                w.uint32(729).double(m.DeliveryChargeRadiusMin);
            if (m.DeliveryChargeRadiusMax != null && Object.hasOwnProperty.call(m, "DeliveryChargeRadiusMax"))
                w.uint32(737).double(m.DeliveryChargeRadiusMax);
            if (m.TakeAwayCharge2 != null && Object.hasOwnProperty.call(m, "TakeAwayCharge2"))
                w.uint32(744).int64(m.TakeAwayCharge2);
            if (m.DeliveryChargeRadiusMin2 != null && Object.hasOwnProperty.call(m, "DeliveryChargeRadiusMin2"))
                w.uint32(753).double(m.DeliveryChargeRadiusMin2);
            if (m.DeliveryChargeRadiusMax2 != null && Object.hasOwnProperty.call(m, "DeliveryChargeRadiusMax2"))
                w.uint32(761).double(m.DeliveryChargeRadiusMax2);
            if (m.DeliveryMaxRadius != null && Object.hasOwnProperty.call(m, "DeliveryMaxRadius"))
                w.uint32(769).double(m.DeliveryMaxRadius);
            if (m.LicenseTypeID != null && Object.hasOwnProperty.call(m, "LicenseTypeID"))
                w.uint32(776).uint64(m.LicenseTypeID);
            if (m.IsExpire != null && Object.hasOwnProperty.call(m, "IsExpire"))
                w.uint32(784).int32(m.IsExpire);
            if (m.ExpireTime != null && Object.hasOwnProperty.call(m, "ExpireTime"))
                w.uint32(792).int64(m.ExpireTime);
            if (m.MFNotes != null && Object.hasOwnProperty.call(m, "MFNotes"))
                w.uint32(802).string(m.MFNotes);
            if (m.IsReserveNeeds != null && Object.hasOwnProperty.call(m, "IsReserveNeeds"))
                w.uint32(808).int32(m.IsReserveNeeds);
            if (m.TakeSelfPayMode != null && Object.hasOwnProperty.call(m, "TakeSelfPayMode"))
                w.uint32(816).int32(m.TakeSelfPayMode);
            if (m.UnOnlinePayAlert != null && Object.hasOwnProperty.call(m, "UnOnlinePayAlert"))
                w.uint32(826).string(m.UnOnlinePayAlert);
            if (m.UnAdvAmtAlert != null && Object.hasOwnProperty.call(m, "UnAdvAmtAlert"))
                w.uint32(834).string(m.UnAdvAmtAlert);
            if (m.AllowPayLater != null && Object.hasOwnProperty.call(m, "AllowPayLater"))
                w.uint32(840).int32(m.AllowPayLater);
            if (m.ShowBuyCate != null && Object.hasOwnProperty.call(m, "ShowBuyCate"))
                w.uint32(848).int32(m.ShowBuyCate);
            if (m.CountryID != null && Object.hasOwnProperty.call(m, "CountryID"))
                w.uint32(856).int32(m.CountryID);
            if (m.ProvinceID != null && Object.hasOwnProperty.call(m, "ProvinceID"))
                w.uint32(864).int32(m.ProvinceID);
            if (m.CityID != null && Object.hasOwnProperty.call(m, "CityID"))
                w.uint32(872).int32(m.CityID);
            if (m.AreaName != null && Object.hasOwnProperty.call(m, "AreaName"))
                w.uint32(882).string(m.AreaName);
            if (m.VoiceCount != null && Object.hasOwnProperty.call(m, "VoiceCount"))
                w.uint32(888).int32(m.VoiceCount);
            if (m.PMPTakeAway != null && Object.hasOwnProperty.call(m, "PMPTakeAway"))
                w.uint32(896).int32(m.PMPTakeAway);
            if (m.PMPYourself != null && Object.hasOwnProperty.call(m, "PMPYourself"))
                w.uint32(904).int32(m.PMPYourself);
            if (m.PMPShop != null && Object.hasOwnProperty.call(m, "PMPShop"))
                w.uint32(912).int32(m.PMPShop);
            if (m.IsYourselfPT != null && Object.hasOwnProperty.call(m, "IsYourselfPT"))
                w.uint32(920).int32(m.IsYourselfPT);
            if (m.IsYourselfPTByClose != null && Object.hasOwnProperty.call(m, "IsYourselfPTByClose"))
                w.uint32(928).int32(m.IsYourselfPTByClose);
            if (m.YourselfOpenTake != null && Object.hasOwnProperty.call(m, "YourselfOpenTake"))
                w.uint32(936).int32(m.YourselfOpenTake);
            if (m.DailyBillingCycle != null && Object.hasOwnProperty.call(m, "DailyBillingCycle"))
                w.uint32(945).double(m.DailyBillingCycle);
            if (m.AutoFinishHour != null && Object.hasOwnProperty.call(m, "AutoFinishHour"))
                w.uint32(952).int32(m.AutoFinishHour);
            if (m.IsMustGC != null && Object.hasOwnProperty.call(m, "IsMustGC"))
                w.uint32(960).int32(m.IsMustGC);
            if (m.IsByGC != null && Object.hasOwnProperty.call(m, "IsByGC"))
                w.uint32(968).int32(m.IsByGC);
            if (m.EveryDayStartSeq != null && Object.hasOwnProperty.call(m, "EveryDayStartSeq"))
                w.uint32(976).int32(m.EveryDayStartSeq);
            if (m.HasWXRefund != null && Object.hasOwnProperty.call(m, "HasWXRefund"))
                w.uint32(984).int32(m.HasWXRefund);
            if (m.HasZFBRefund != null && Object.hasOwnProperty.call(m, "HasZFBRefund"))
                w.uint32(992).int32(m.HasZFBRefund);
            if (m.IsYourselfMustTable != null && Object.hasOwnProperty.call(m, "IsYourselfMustTable"))
                w.uint32(1000).int32(m.IsYourselfMustTable);
            if (m.IsTakeSelfMustPoint != null && Object.hasOwnProperty.call(m, "IsTakeSelfMustPoint"))
                w.uint32(1008).int32(m.IsTakeSelfMustPoint);
            if (m.AtOrderUserMinLevel != null && Object.hasOwnProperty.call(m, "AtOrderUserMinLevel"))
                w.uint32(1016).int32(m.AtOrderUserMinLevel);
            if (m.JoinVIPLimit != null && Object.hasOwnProperty.call(m, "JoinVIPLimit"))
                w.uint32(1024).int32(m.JoinVIPLimit);
            if (m.IsShowCS != null && Object.hasOwnProperty.call(m, "IsShowCS"))
                w.uint32(1032).int32(m.IsShowCS);
            if (m.TaxRate != null && Object.hasOwnProperty.call(m, "TaxRate"))
                w.uint32(1040).int32(m.TaxRate);
            if (m.SFRate != null && Object.hasOwnProperty.call(m, "SFRate"))
                w.uint32(1048).int32(m.SFRate);
            if (m.Language1 != null && Object.hasOwnProperty.call(m, "Language1"))
                w.uint32(1056).int32(m.Language1);
            if (m.Language2 != null && Object.hasOwnProperty.call(m, "Language2"))
                w.uint32(1064).int32(m.Language2);
            if (m.Language3 != null && Object.hasOwnProperty.call(m, "Language3"))
                w.uint32(1072).int32(m.Language3);
            if (m.Order30Count != null && Object.hasOwnProperty.call(m, "Order30Count"))
                w.uint32(1080).int32(m.Order30Count);
            if (m.Order30Amt != null && Object.hasOwnProperty.call(m, "Order30Amt"))
                w.uint32(1088).int64(m.Order30Amt);
            if (m.OrderYestCount != null && Object.hasOwnProperty.call(m, "OrderYestCount"))
                w.uint32(1096).int32(m.OrderYestCount);
            if (m.OrderYestAmt != null && Object.hasOwnProperty.call(m, "OrderYestAmt"))
                w.uint32(1104).int64(m.OrderYestAmt);
            if (m.ApproveTime != null && Object.hasOwnProperty.call(m, "ApproveTime"))
                w.uint32(1112).int64(m.ApproveTime);
            if (m.CreateTime != null && Object.hasOwnProperty.call(m, "CreateTime"))
                w.uint32(1120).int64(m.CreateTime);
            if (m.CreaterID != null && Object.hasOwnProperty.call(m, "CreaterID"))
                w.uint32(1128).uint64(m.CreaterID);
            if (m.UpdateTime != null && Object.hasOwnProperty.call(m, "UpdateTime"))
                w.uint32(1136).int64(m.UpdateTime);
            if (m.UpdaterID != null && Object.hasOwnProperty.call(m, "UpdaterID"))
                w.uint32(1144).uint64(m.UpdaterID);
            if (m.Estate != null && Object.hasOwnProperty.call(m, "Estate"))
                w.uint32(1152).int32(m.Estate);
            return w;
        };

        Merchant.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.Merchant();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        m.ID = r.uint64();
                        break;
                    }
                    case 2: {
                        m.Name1 = r.string();
                        break;
                    }
                    case 3: {
                        m.Name2 = r.string();
                        break;
                    }
                    case 4: {
                        m.Name3 = r.string();
                        break;
                    }
                    case 5: {
                        m.CertType = r.int32();
                        break;
                    }
                    case 6: {
                        m.CertNo = r.string();
                        break;
                    }
                    case 7: {
                        m.Address = r.string();
                        break;
                    }
                    case 8: {
                        m.LegalPerson = r.string();
                        break;
                    }
                    case 9: {
                        m.LegalPersonMobile = r.string();
                        break;
                    }
                    case 10: {
                        m.CSPhone = r.string();
                        break;
                    }
                    case 11: {
                        m.LocalX = r.double();
                        break;
                    }
                    case 12: {
                        m.LocalY = r.double();
                        break;
                    }
                    case 13: {
                        m.LocalZ = r.double();
                        break;
                    }
                    case 14: {
                        m.Level = r.int32();
                        break;
                    }
                    case 15: {
                        m.Category = r.int32();
                        break;
                    }
                    case 16: {
                        m.GroupID = r.uint64();
                        break;
                    }
                    case 17: {
                        m.BelongStoredAccID = r.uint64();
                        break;
                    }
                    case 18: {
                        m.BelongPointsAccID = r.uint64();
                        break;
                    }
                    case 19: {
                        m.BusCategory = r.int32();
                        break;
                    }
                    case 20: {
                        m.Cover = r.string();
                        break;
                    }
                    case 21: {
                        m.EnableOperTime1 = r.int32();
                        break;
                    }
                    case 22: {
                        m.OperStartTime1 = r.double();
                        break;
                    }
                    case 23: {
                        m.OperEndTime1 = r.double();
                        break;
                    }
                    case 24: {
                        m.EnableOperTime2 = r.int32();
                        break;
                    }
                    case 25: {
                        m.OperStartTime2 = r.double();
                        break;
                    }
                    case 26: {
                        m.OperEndTime2 = r.double();
                        break;
                    }
                    case 27: {
                        m.EnableOperTime3 = r.int32();
                        break;
                    }
                    case 28: {
                        m.OperStartTime3 = r.double();
                        break;
                    }
                    case 29: {
                        m.OperEndTime3 = r.double();
                        break;
                    }
                    case 30: {
                        m.HasStoredAmt = r.int32();
                        break;
                    }
                    case 31: {
                        m.HasPos = r.int32();
                        break;
                    }
                    case 32: {
                        m.HasWXMP = r.int32();
                        break;
                    }
                    case 33: {
                        m.HasWXH5 = r.int32();
                        break;
                    }
                    case 34: {
                        m.WXMchID = r.string();
                        break;
                    }
                    case 35: {
                        m.WXAppID = r.string();
                        break;
                    }
                    case 36: {
                        m.AllowOnlineZeroSale = r.int32();
                        break;
                    }
                    case 37: {
                        m.HasOnlineReserve = r.int32();
                        break;
                    }
                    case 38: {
                        m.ReserveKeepTime = r.int32();
                        break;
                    }
                    case 39: {
                        m.ReserveMinTime = r.int32();
                        break;
                    }
                    case 40: {
                        m.ReserveMaxTime = r.int32();
                        break;
                    }
                    case 41: {
                        m.HasOnlineBuy = r.int32();
                        break;
                    }
                    case 42: {
                        m.HasShopScanCode = r.int32();
                        break;
                    }
                    case 43: {
                        m.HasShopOpenDesk = r.int32();
                        break;
                    }
                    case 44: {
                        m.ShopPayMode = r.int32();
                        break;
                    }
                    case 45: {
                        m.HasYourself = r.int32();
                        break;
                    }
                    case 46: {
                        m.YourselfPayMode = r.int32();
                        break;
                    }
                    case 47: {
                        m.HasTakeAway = r.int32();
                        break;
                    }
                    case 48: {
                        m.TakeAwayPayMode = r.int32();
                        break;
                    }
                    case 49: {
                        m.TakeAwayMinAmt = r.int64();
                        break;
                    }
                    case 50: {
                        m.TakeAwayCharge = r.int64();
                        break;
                    }
                    case 51: {
                        m.TakeAwayFreeAmt = r.int64();
                        break;
                    }
                    case 52: {
                        m.DeliveryNotes = r.string();
                        break;
                    }
                    case 53: {
                        m.HasEmpReserve = r.int32();
                        break;
                    }
                    case 54: {
                        m.EmpReserveKeepTime = r.int32();
                        break;
                    }
                    case 55: {
                        m.EmpReserveMinTime = r.int32();
                        break;
                    }
                    case 56: {
                        m.EmpReserveMaxTime = r.int32();
                        break;
                    }
                    case 57: {
                        m.HasEmpShop = r.int32();
                        break;
                    }
                    case 58: {
                        m.EmpShopPayMode = r.int32();
                        break;
                    }
                    case 59: {
                        m.HasEmpYourself = r.int32();
                        break;
                    }
                    case 60: {
                        m.EmpYourselfPayMode = r.int32();
                        break;
                    }
                    case 61: {
                        m.HasEmpTakeAway = r.int32();
                        break;
                    }
                    case 62: {
                        m.EmpTakeAwayPayMode = r.int32();
                        break;
                    }
                    case 63: {
                        m.EmpTakeAwayMinAmt = r.int64();
                        break;
                    }
                    case 64: {
                        m.EmpTakeAwayCharge = r.int64();
                        break;
                    }
                    case 65: {
                        m.EmpTakeAwayFreeAmt = r.int64();
                        break;
                    }
                    case 66: {
                        m.EmpTakeAwayNotes = r.string();
                        break;
                    }
                    case 67: {
                        m.HasPoints = r.int32();
                        break;
                    }
                    case 68: {
                        m.PointsRatio = r.int32();
                        break;
                    }
                    case 69: {
                        m.PointsTerm = r.int32();
                        break;
                    }
                    case 70: {
                        m.HasAutoUpLevel = r.int32();
                        break;
                    }
                    case 71: {
                        m.HasPointsDeduction = r.int32();
                        break;
                    }
                    case 72: {
                        m.PointsDeductionRatio = r.int32();
                        break;
                    }
                    case 73: {
                        m.HasCoupon = r.int32();
                        break;
                    }
                    case 74: {
                        m.State = r.int32();
                        break;
                    }
                    case 75: {
                        m.AdminID = r.uint64();
                        break;
                    }
                    case 76: {
                        m.IsOnlyDelivery = r.int32();
                        break;
                    }
                    case 77: {
                        m.AllowTakePlanTime = r.int32();
                        break;
                    }
                    case 78: {
                        m.AllowTakePlanTimeByClose = r.int32();
                        break;
                    }
                    case 79: {
                        m.AutoClearByShopPay = r.int32();
                        break;
                    }
                    case 80: {
                        m.AutoClearByEmpShopPay = r.int32();
                        break;
                    }
                    case 81: {
                        m.PackAwayPackageFee = r.int64();
                        break;
                    }
                    case 82: {
                        m.DeliverPackageFee = r.int64();
                        break;
                    }
                    case 83: {
                        m.TakeSelfPackageFee = r.int64();
                        break;
                    }
                    case 84: {
                        m.IsNotice = r.int32();
                        break;
                    }
                    case 85: {
                        m.Notes = r.string();
                        break;
                    }
                    case 86: {
                        m.PackAwayPackingCostCate = r.int32();
                        break;
                    }
                    case 87: {
                        m.HomeDeliverPackingCostCate = r.int32();
                        break;
                    }
                    case 88: {
                        m.StoreTakeyPackingCostCate = r.int32();
                        break;
                    }
                    case 89: {
                        m.IsDeliveryByDistance = r.int32();
                        break;
                    }
                    case 90: {
                        m.DeliveryChargeCate = r.int32();
                        break;
                    }
                    case 91: {
                        m.DeliveryChargeRadiusMin = r.double();
                        break;
                    }
                    case 92: {
                        m.DeliveryChargeRadiusMax = r.double();
                        break;
                    }
                    case 93: {
                        m.TakeAwayCharge2 = r.int64();
                        break;
                    }
                    case 94: {
                        m.DeliveryChargeRadiusMin2 = r.double();
                        break;
                    }
                    case 95: {
                        m.DeliveryChargeRadiusMax2 = r.double();
                        break;
                    }
                    case 96: {
                        m.DeliveryMaxRadius = r.double();
                        break;
                    }
                    case 97: {
                        m.LicenseTypeID = r.uint64();
                        break;
                    }
                    case 98: {
                        m.IsExpire = r.int32();
                        break;
                    }
                    case 99: {
                        m.ExpireTime = r.int64();
                        break;
                    }
                    case 100: {
                        m.MFNotes = r.string();
                        break;
                    }
                    case 101: {
                        m.IsReserveNeeds = r.int32();
                        break;
                    }
                    case 102: {
                        m.TakeSelfPayMode = r.int32();
                        break;
                    }
                    case 103: {
                        m.UnOnlinePayAlert = r.string();
                        break;
                    }
                    case 104: {
                        m.UnAdvAmtAlert = r.string();
                        break;
                    }
                    case 105: {
                        m.AllowPayLater = r.int32();
                        break;
                    }
                    case 106: {
                        m.ShowBuyCate = r.int32();
                        break;
                    }
                    case 107: {
                        m.CountryID = r.int32();
                        break;
                    }
                    case 108: {
                        m.ProvinceID = r.int32();
                        break;
                    }
                    case 109: {
                        m.CityID = r.int32();
                        break;
                    }
                    case 110: {
                        m.AreaName = r.string();
                        break;
                    }
                    case 111: {
                        m.VoiceCount = r.int32();
                        break;
                    }
                    case 112: {
                        m.PMPTakeAway = r.int32();
                        break;
                    }
                    case 113: {
                        m.PMPYourself = r.int32();
                        break;
                    }
                    case 114: {
                        m.PMPShop = r.int32();
                        break;
                    }
                    case 115: {
                        m.IsYourselfPT = r.int32();
                        break;
                    }
                    case 116: {
                        m.IsYourselfPTByClose = r.int32();
                        break;
                    }
                    case 117: {
                        m.YourselfOpenTake = r.int32();
                        break;
                    }
                    case 118: {
                        m.DailyBillingCycle = r.double();
                        break;
                    }
                    case 119: {
                        m.AutoFinishHour = r.int32();
                        break;
                    }
                    case 120: {
                        m.IsMustGC = r.int32();
                        break;
                    }
                    case 121: {
                        m.IsByGC = r.int32();
                        break;
                    }
                    case 122: {
                        m.EveryDayStartSeq = r.int32();
                        break;
                    }
                    case 123: {
                        m.HasWXRefund = r.int32();
                        break;
                    }
                    case 124: {
                        m.HasZFBRefund = r.int32();
                        break;
                    }
                    case 125: {
                        m.IsYourselfMustTable = r.int32();
                        break;
                    }
                    case 126: {
                        m.IsTakeSelfMustPoint = r.int32();
                        break;
                    }
                    case 127: {
                        m.AtOrderUserMinLevel = r.int32();
                        break;
                    }
                    case 128: {
                        m.JoinVIPLimit = r.int32();
                        break;
                    }
                    case 129: {
                        m.IsShowCS = r.int32();
                        break;
                    }
                    case 130: {
                        m.TaxRate = r.int32();
                        break;
                    }
                    case 131: {
                        m.SFRate = r.int32();
                        break;
                    }
                    case 132: {
                        m.Language1 = r.int32();
                        break;
                    }
                    case 133: {
                        m.Language2 = r.int32();
                        break;
                    }
                    case 134: {
                        m.Language3 = r.int32();
                        break;
                    }
                    case 135: {
                        m.Order30Count = r.int32();
                        break;
                    }
                    case 136: {
                        m.Order30Amt = r.int64();
                        break;
                    }
                    case 137: {
                        m.OrderYestCount = r.int32();
                        break;
                    }
                    case 138: {
                        m.OrderYestAmt = r.int64();
                        break;
                    }
                    case 139: {
                        m.ApproveTime = r.int64();
                        break;
                    }
                    case 140: {
                        m.CreateTime = r.int64();
                        break;
                    }
                    case 141: {
                        m.CreaterID = r.uint64();
                        break;
                    }
                    case 142: {
                        m.UpdateTime = r.int64();
                        break;
                    }
                    case 143: {
                        m.UpdaterID = r.uint64();
                        break;
                    }
                    case 144: {
                        m.Estate = r.int32();
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        Merchant.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.Merchant";
        };

        return Merchant;
    })();

    PBEntity.Merchants = (function () {

        function Merchants(p) {
            this.Merchants = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        Merchants.prototype.Merchants = $util.emptyArray;

        Merchants.create = function create(properties) {
            return new Merchants(properties);
        };

        Merchants.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.Merchants != null && m.Merchants.length) {
                for (var i = 0; i < m.Merchants.length; ++i)
                    $root.PBEntity.Merchant.encode(m.Merchants[i], w.uint32(10).fork()).ldelim();
            }
            return w;
        };

        Merchants.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.Merchants();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        if (!(m.Merchants && m.Merchants.length))
                            m.Merchants = [];
                        m.Merchants.push($root.PBEntity.Merchant.decode(r, r.uint32()));
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        Merchants.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.Merchants";
        };

        return Merchants;
    })();

    PBEntity.Module = (function () {

        function Module(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        Module.prototype.ID = "";
        Module.prototype.ParentID = "";
        Module.prototype.Name = "";
        Module.prototype.Code = "";
        Module.prototype.IsMenu = 0;
        Module.prototype.Icon = "";
        Module.prototype.Oper = 0;
        Module.prototype.Estate = 0;
        Module.prototype.Priority = 0;
        Module.prototype.Abbr = "";
        Module.prototype.Desc = "";
        Module.prototype.Platform = 0;
        Module.prototype.URL = "";
        Module.prototype.CustomOper = "";
        Module.prototype.URL2 = "";
        Module.prototype.IsPC = 0;

        Module.create = function create(properties) {
            return new Module(properties);
        };

        Module.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.ID != null && Object.hasOwnProperty.call(m, "ID"))
                w.uint32(10).string(m.ID);
            if (m.ParentID != null && Object.hasOwnProperty.call(m, "ParentID"))
                w.uint32(18).string(m.ParentID);
            if (m.Name != null && Object.hasOwnProperty.call(m, "Name"))
                w.uint32(26).string(m.Name);
            if (m.Code != null && Object.hasOwnProperty.call(m, "Code"))
                w.uint32(34).string(m.Code);
            if (m.IsMenu != null && Object.hasOwnProperty.call(m, "IsMenu"))
                w.uint32(40).int32(m.IsMenu);
            if (m.Icon != null && Object.hasOwnProperty.call(m, "Icon"))
                w.uint32(50).string(m.Icon);
            if (m.Oper != null && Object.hasOwnProperty.call(m, "Oper"))
                w.uint32(56).int32(m.Oper);
            if (m.Estate != null && Object.hasOwnProperty.call(m, "Estate"))
                w.uint32(64).int32(m.Estate);
            if (m.Priority != null && Object.hasOwnProperty.call(m, "Priority"))
                w.uint32(72).int32(m.Priority);
            if (m.Abbr != null && Object.hasOwnProperty.call(m, "Abbr"))
                w.uint32(82).string(m.Abbr);
            if (m.Desc != null && Object.hasOwnProperty.call(m, "Desc"))
                w.uint32(90).string(m.Desc);
            if (m.Platform != null && Object.hasOwnProperty.call(m, "Platform"))
                w.uint32(96).int32(m.Platform);
            if (m.URL != null && Object.hasOwnProperty.call(m, "URL"))
                w.uint32(106).string(m.URL);
            if (m.CustomOper != null && Object.hasOwnProperty.call(m, "CustomOper"))
                w.uint32(114).string(m.CustomOper);
            if (m.URL2 != null && Object.hasOwnProperty.call(m, "URL2"))
                w.uint32(122).string(m.URL2);
            if (m.IsPC != null && Object.hasOwnProperty.call(m, "IsPC"))
                w.uint32(128).int32(m.IsPC);
            return w;
        };

        Module.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.Module();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        m.ID = r.string();
                        break;
                    }
                    case 2: {
                        m.ParentID = r.string();
                        break;
                    }
                    case 3: {
                        m.Name = r.string();
                        break;
                    }
                    case 4: {
                        m.Code = r.string();
                        break;
                    }
                    case 5: {
                        m.IsMenu = r.int32();
                        break;
                    }
                    case 6: {
                        m.Icon = r.string();
                        break;
                    }
                    case 7: {
                        m.Oper = r.int32();
                        break;
                    }
                    case 8: {
                        m.Estate = r.int32();
                        break;
                    }
                    case 9: {
                        m.Priority = r.int32();
                        break;
                    }
                    case 10: {
                        m.Abbr = r.string();
                        break;
                    }
                    case 11: {
                        m.Desc = r.string();
                        break;
                    }
                    case 12: {
                        m.Platform = r.int32();
                        break;
                    }
                    case 13: {
                        m.URL = r.string();
                        break;
                    }
                    case 14: {
                        m.CustomOper = r.string();
                        break;
                    }
                    case 15: {
                        m.URL2 = r.string();
                        break;
                    }
                    case 16: {
                        m.IsPC = r.int32();
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        Module.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.Module";
        };

        return Module;
    })();

    PBEntity.Modules = (function () {

        function Modules(p) {
            this.Modules = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        Modules.prototype.Modules = $util.emptyArray;

        Modules.create = function create(properties) {
            return new Modules(properties);
        };

        Modules.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.Modules != null && m.Modules.length) {
                for (var i = 0; i < m.Modules.length; ++i)
                    $root.PBEntity.Module.encode(m.Modules[i], w.uint32(10).fork()).ldelim();
            }
            return w;
        };

        Modules.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.Modules();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        if (!(m.Modules && m.Modules.length))
                            m.Modules = [];
                        m.Modules.push($root.PBEntity.Module.decode(r, r.uint32()));
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        Modules.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.Modules";
        };

        return Modules;
    })();

    PBEntity.Msg = (function () {

        function Msg(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        Msg.prototype.ID = "";
        Msg.prototype.MchID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        Msg.prototype.Category = 0;
        Msg.prototype.SenderID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        Msg.prototype.ToID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        Msg.prototype.UUID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        Msg.prototype.Title = "";
        Msg.prototype.Content = "";
        Msg.prototype.SendTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Msg.prototype.SendState = 0;
        Msg.prototype.ToState = 0;
        Msg.prototype.ViewTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Msg.prototype.Estate = 0;

        Msg.create = function create(properties) {
            return new Msg(properties);
        };

        Msg.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.ID != null && Object.hasOwnProperty.call(m, "ID"))
                w.uint32(10).string(m.ID);
            if (m.MchID != null && Object.hasOwnProperty.call(m, "MchID"))
                w.uint32(16).uint64(m.MchID);
            if (m.Category != null && Object.hasOwnProperty.call(m, "Category"))
                w.uint32(24).int32(m.Category);
            if (m.SenderID != null && Object.hasOwnProperty.call(m, "SenderID"))
                w.uint32(32).uint64(m.SenderID);
            if (m.ToID != null && Object.hasOwnProperty.call(m, "ToID"))
                w.uint32(40).uint64(m.ToID);
            if (m.UUID != null && Object.hasOwnProperty.call(m, "UUID"))
                w.uint32(48).uint64(m.UUID);
            if (m.Title != null && Object.hasOwnProperty.call(m, "Title"))
                w.uint32(58).string(m.Title);
            if (m.Content != null && Object.hasOwnProperty.call(m, "Content"))
                w.uint32(66).string(m.Content);
            if (m.SendTime != null && Object.hasOwnProperty.call(m, "SendTime"))
                w.uint32(72).int64(m.SendTime);
            if (m.SendState != null && Object.hasOwnProperty.call(m, "SendState"))
                w.uint32(80).int32(m.SendState);
            if (m.ToState != null && Object.hasOwnProperty.call(m, "ToState"))
                w.uint32(88).int32(m.ToState);
            if (m.ViewTime != null && Object.hasOwnProperty.call(m, "ViewTime"))
                w.uint32(96).int64(m.ViewTime);
            if (m.Estate != null && Object.hasOwnProperty.call(m, "Estate"))
                w.uint32(104).int32(m.Estate);
            return w;
        };

        Msg.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.Msg();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        m.ID = r.string();
                        break;
                    }
                    case 2: {
                        m.MchID = r.uint64();
                        break;
                    }
                    case 3: {
                        m.Category = r.int32();
                        break;
                    }
                    case 4: {
                        m.SenderID = r.uint64();
                        break;
                    }
                    case 5: {
                        m.ToID = r.uint64();
                        break;
                    }
                    case 6: {
                        m.UUID = r.uint64();
                        break;
                    }
                    case 7: {
                        m.Title = r.string();
                        break;
                    }
                    case 8: {
                        m.Content = r.string();
                        break;
                    }
                    case 9: {
                        m.SendTime = r.int64();
                        break;
                    }
                    case 10: {
                        m.SendState = r.int32();
                        break;
                    }
                    case 11: {
                        m.ToState = r.int32();
                        break;
                    }
                    case 12: {
                        m.ViewTime = r.int64();
                        break;
                    }
                    case 13: {
                        m.Estate = r.int32();
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        Msg.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.Msg";
        };

        return Msg;
    })();

    PBEntity.Msgs = (function () {

        function Msgs(p) {
            this.Msgs = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        Msgs.prototype.Msgs = $util.emptyArray;

        Msgs.create = function create(properties) {
            return new Msgs(properties);
        };

        Msgs.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.Msgs != null && m.Msgs.length) {
                for (var i = 0; i < m.Msgs.length; ++i)
                    $root.PBEntity.Msg.encode(m.Msgs[i], w.uint32(10).fork()).ldelim();
            }
            return w;
        };

        Msgs.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.Msgs();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        if (!(m.Msgs && m.Msgs.length))
                            m.Msgs = [];
                        m.Msgs.push($root.PBEntity.Msg.decode(r, r.uint32()));
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        Msgs.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.Msgs";
        };

        return Msgs;
    })();

    PBEntity.Notice = (function () {

        function Notice(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        Notice.prototype.ID = "";
        Notice.prototype.Title = "";
        Notice.prototype.Content = "";
        Notice.prototype.CoverImg = "";
        Notice.prototype.ShowCate = 0;
        Notice.prototype.StartTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Notice.prototype.EndTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Notice.prototype.Priority = 0;
        Notice.prototype.Author = "";
        Notice.prototype.ReadCount = 0;
        Notice.prototype.CreateTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Notice.prototype.CreaterID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        Notice.prototype.UpdateTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Notice.prototype.UpdaterID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        Notice.prototype.Estate = 0;

        Notice.create = function create(properties) {
            return new Notice(properties);
        };

        Notice.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.ID != null && Object.hasOwnProperty.call(m, "ID"))
                w.uint32(10).string(m.ID);
            if (m.Title != null && Object.hasOwnProperty.call(m, "Title"))
                w.uint32(18).string(m.Title);
            if (m.Content != null && Object.hasOwnProperty.call(m, "Content"))
                w.uint32(26).string(m.Content);
            if (m.CoverImg != null && Object.hasOwnProperty.call(m, "CoverImg"))
                w.uint32(34).string(m.CoverImg);
            if (m.ShowCate != null && Object.hasOwnProperty.call(m, "ShowCate"))
                w.uint32(40).int32(m.ShowCate);
            if (m.StartTime != null && Object.hasOwnProperty.call(m, "StartTime"))
                w.uint32(48).int64(m.StartTime);
            if (m.EndTime != null && Object.hasOwnProperty.call(m, "EndTime"))
                w.uint32(56).int64(m.EndTime);
            if (m.Priority != null && Object.hasOwnProperty.call(m, "Priority"))
                w.uint32(64).int32(m.Priority);
            if (m.Author != null && Object.hasOwnProperty.call(m, "Author"))
                w.uint32(74).string(m.Author);
            if (m.ReadCount != null && Object.hasOwnProperty.call(m, "ReadCount"))
                w.uint32(80).int32(m.ReadCount);
            if (m.CreateTime != null && Object.hasOwnProperty.call(m, "CreateTime"))
                w.uint32(88).int64(m.CreateTime);
            if (m.CreaterID != null && Object.hasOwnProperty.call(m, "CreaterID"))
                w.uint32(96).uint64(m.CreaterID);
            if (m.UpdateTime != null && Object.hasOwnProperty.call(m, "UpdateTime"))
                w.uint32(104).int64(m.UpdateTime);
            if (m.UpdaterID != null && Object.hasOwnProperty.call(m, "UpdaterID"))
                w.uint32(112).uint64(m.UpdaterID);
            if (m.Estate != null && Object.hasOwnProperty.call(m, "Estate"))
                w.uint32(120).int32(m.Estate);
            return w;
        };

        Notice.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.Notice();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        m.ID = r.string();
                        break;
                    }
                    case 2: {
                        m.Title = r.string();
                        break;
                    }
                    case 3: {
                        m.Content = r.string();
                        break;
                    }
                    case 4: {
                        m.CoverImg = r.string();
                        break;
                    }
                    case 5: {
                        m.ShowCate = r.int32();
                        break;
                    }
                    case 6: {
                        m.StartTime = r.int64();
                        break;
                    }
                    case 7: {
                        m.EndTime = r.int64();
                        break;
                    }
                    case 8: {
                        m.Priority = r.int32();
                        break;
                    }
                    case 9: {
                        m.Author = r.string();
                        break;
                    }
                    case 10: {
                        m.ReadCount = r.int32();
                        break;
                    }
                    case 11: {
                        m.CreateTime = r.int64();
                        break;
                    }
                    case 12: {
                        m.CreaterID = r.uint64();
                        break;
                    }
                    case 13: {
                        m.UpdateTime = r.int64();
                        break;
                    }
                    case 14: {
                        m.UpdaterID = r.uint64();
                        break;
                    }
                    case 15: {
                        m.Estate = r.int32();
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        Notice.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.Notice";
        };

        return Notice;
    })();

    PBEntity.Notices = (function () {

        function Notices(p) {
            this.Notices = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        Notices.prototype.Notices = $util.emptyArray;

        Notices.create = function create(properties) {
            return new Notices(properties);
        };

        Notices.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.Notices != null && m.Notices.length) {
                for (var i = 0; i < m.Notices.length; ++i)
                    $root.PBEntity.Notice.encode(m.Notices[i], w.uint32(10).fork()).ldelim();
            }
            return w;
        };

        Notices.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.Notices();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        if (!(m.Notices && m.Notices.length))
                            m.Notices = [];
                        m.Notices.push($root.PBEntity.Notice.decode(r, r.uint32()));
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        Notices.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.Notices";
        };

        return Notices;
    })();

    PBEntity.Order = (function () {

        function Order(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        Order.prototype.OrderID = "";
        Order.prototype.MchID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        Order.prototype.UserID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        Order.prototype.TransDate = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Order.prototype.SaleSeq = 0;
        Order.prototype.SeqCode = "";
        Order.prototype.SaleNo = "";
        Order.prototype.ReID = "";
        Order.prototype.OrderCate = 0;
        Order.prototype.AtUserCate = 0;
        Order.prototype.AtChannel = 0;
        Order.prototype.ToAccUserID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        Order.prototype.CustomLevel = 0;
        Order.prototype.AtOrderCate = 0;
        Order.prototype.PayMode = 0;
        Order.prototype.DistrMode = 0;
        Order.prototype.TakeMode = 0;
        Order.prototype.LinkName = "";
        Order.prototype.LinkPhone = "";
        Order.prototype.LinkAddress = "";
        Order.prototype.LinkLocateCate = 0;
        Order.prototype.LinkLocateX = 0;
        Order.prototype.LinkLocateY = 0;
        Order.prototype.LinkLocateName = "";
        Order.prototype.LinkLocateAddr = "";
        Order.prototype.DeskID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        Order.prototype.TakePointID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        Order.prototype.PostageCate = 0;
        Order.prototype.PostageAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Order.prototype.Distance = 0;
        Order.prototype.PeopleNum = 0;
        Order.prototype.IsTeaFee = 0;
        Order.prototype.TeaNum = 0;
        Order.prototype.TeaFee = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Order.prototype.TotalTeaFee = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Order.prototype.IsTablewareFee = 0;
        Order.prototype.TablewareNum = 0;
        Order.prototype.TablewareFee = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Order.prototype.TotalTablewareFee = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Order.prototype.IsPackageFee = 0;
        Order.prototype.PackageFee = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Order.prototype.PriceCate = 0;
        Order.prototype.TotalNum = 0;
        Order.prototype.TotalRecord = 0;
        Order.prototype.TotalDetailAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Order.prototype.TotalCostAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Order.prototype.TotalWeight = 0;
        Order.prototype.TotalMinusAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Order.prototype.TotalSavedAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Order.prototype.RevenueAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Order.prototype.TotalProfit = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Order.prototype.IsTak = 0;
        Order.prototype.TakAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Order.prototype.IsSF = 0;
        Order.prototype.SFAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Order.prototype.TotalAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Order.prototype.ReceiptAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Order.prototype.AtTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Order.prototype.OrderNotes = "";
        Order.prototype.PayState = 0;
        Order.prototype.PayExpires = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Order.prototype.PayTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Order.prototype.PayAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Order.prototype.OrderPayID = "";
        Order.prototype.PayID = "";
        Order.prototype.ReceiptNotes = "";
        Order.prototype.OrderState = 0;
        Order.prototype.IsNotice = 0;
        Order.prototype.IsAtPrint = 0;
        Order.prototype.IsSubsMsg = 0;
        Order.prototype.CallCount = 0;
        Order.prototype.RefundAmtState = 0;
        Order.prototype.RefundAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Order.prototype.SendTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Order.prototype.FinishTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Order.prototype.CancelTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Order.prototype.SendNotes = "";
        Order.prototype.GroupID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        Order.prototype.IsSale = 0;
        Order.prototype.IsRefund = 0;
        Order.prototype.IsPlanTime = 0;
        Order.prototype.PlanTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Order.prototype.FromIP = "";
        Order.prototype.FromTokeID = "";
        Order.prototype.CancelNotes = "";
        Order.prototype.RefundTeaNum = 0;
        Order.prototype.RefundTablewareNum = 0;
        Order.prototype.RefundPackageFee = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Order.prototype.RefundPostageAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Order.prototype.EvaluateState = 0;
        Order.prototype.EvaluateGrade = 0;
        Order.prototype.DeliveryChannel = 0;
        Order.prototype.DeliveryID = "";
        Order.prototype.DeliveryState = 0;
        Order.prototype.CreateTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Order.prototype.CreaterID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        Order.prototype.UpdateTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Order.prototype.UpdaterID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        Order.prototype.Estate = 0;

        Order.create = function create(properties) {
            return new Order(properties);
        };

        Order.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.OrderID != null && Object.hasOwnProperty.call(m, "OrderID"))
                w.uint32(10).string(m.OrderID);
            if (m.MchID != null && Object.hasOwnProperty.call(m, "MchID"))
                w.uint32(16).uint64(m.MchID);
            if (m.UserID != null && Object.hasOwnProperty.call(m, "UserID"))
                w.uint32(24).uint64(m.UserID);
            if (m.TransDate != null && Object.hasOwnProperty.call(m, "TransDate"))
                w.uint32(32).int64(m.TransDate);
            if (m.SaleSeq != null && Object.hasOwnProperty.call(m, "SaleSeq"))
                w.uint32(40).int32(m.SaleSeq);
            if (m.SeqCode != null && Object.hasOwnProperty.call(m, "SeqCode"))
                w.uint32(50).string(m.SeqCode);
            if (m.SaleNo != null && Object.hasOwnProperty.call(m, "SaleNo"))
                w.uint32(58).string(m.SaleNo);
            if (m.ReID != null && Object.hasOwnProperty.call(m, "ReID"))
                w.uint32(66).string(m.ReID);
            if (m.OrderCate != null && Object.hasOwnProperty.call(m, "OrderCate"))
                w.uint32(72).int32(m.OrderCate);
            if (m.AtUserCate != null && Object.hasOwnProperty.call(m, "AtUserCate"))
                w.uint32(80).int32(m.AtUserCate);
            if (m.AtChannel != null && Object.hasOwnProperty.call(m, "AtChannel"))
                w.uint32(88).int32(m.AtChannel);
            if (m.ToAccUserID != null && Object.hasOwnProperty.call(m, "ToAccUserID"))
                w.uint32(96).uint64(m.ToAccUserID);
            if (m.CustomLevel != null && Object.hasOwnProperty.call(m, "CustomLevel"))
                w.uint32(104).int32(m.CustomLevel);
            if (m.AtOrderCate != null && Object.hasOwnProperty.call(m, "AtOrderCate"))
                w.uint32(112).int32(m.AtOrderCate);
            if (m.PayMode != null && Object.hasOwnProperty.call(m, "PayMode"))
                w.uint32(120).int32(m.PayMode);
            if (m.DistrMode != null && Object.hasOwnProperty.call(m, "DistrMode"))
                w.uint32(128).int32(m.DistrMode);
            if (m.TakeMode != null && Object.hasOwnProperty.call(m, "TakeMode"))
                w.uint32(136).int32(m.TakeMode);
            if (m.LinkName != null && Object.hasOwnProperty.call(m, "LinkName"))
                w.uint32(146).string(m.LinkName);
            if (m.LinkPhone != null && Object.hasOwnProperty.call(m, "LinkPhone"))
                w.uint32(154).string(m.LinkPhone);
            if (m.LinkAddress != null && Object.hasOwnProperty.call(m, "LinkAddress"))
                w.uint32(162).string(m.LinkAddress);
            if (m.LinkLocateCate != null && Object.hasOwnProperty.call(m, "LinkLocateCate"))
                w.uint32(168).int32(m.LinkLocateCate);
            if (m.LinkLocateX != null && Object.hasOwnProperty.call(m, "LinkLocateX"))
                w.uint32(177).double(m.LinkLocateX);
            if (m.LinkLocateY != null && Object.hasOwnProperty.call(m, "LinkLocateY"))
                w.uint32(185).double(m.LinkLocateY);
            if (m.LinkLocateName != null && Object.hasOwnProperty.call(m, "LinkLocateName"))
                w.uint32(194).string(m.LinkLocateName);
            if (m.LinkLocateAddr != null && Object.hasOwnProperty.call(m, "LinkLocateAddr"))
                w.uint32(202).string(m.LinkLocateAddr);
            if (m.DeskID != null && Object.hasOwnProperty.call(m, "DeskID"))
                w.uint32(208).uint64(m.DeskID);
            if (m.TakePointID != null && Object.hasOwnProperty.call(m, "TakePointID"))
                w.uint32(216).uint64(m.TakePointID);
            if (m.PostageCate != null && Object.hasOwnProperty.call(m, "PostageCate"))
                w.uint32(224).int32(m.PostageCate);
            if (m.PostageAmt != null && Object.hasOwnProperty.call(m, "PostageAmt"))
                w.uint32(232).int64(m.PostageAmt);
            if (m.Distance != null && Object.hasOwnProperty.call(m, "Distance"))
                w.uint32(241).double(m.Distance);
            if (m.PeopleNum != null && Object.hasOwnProperty.call(m, "PeopleNum"))
                w.uint32(248).int32(m.PeopleNum);
            if (m.IsTeaFee != null && Object.hasOwnProperty.call(m, "IsTeaFee"))
                w.uint32(256).int32(m.IsTeaFee);
            if (m.TeaNum != null && Object.hasOwnProperty.call(m, "TeaNum"))
                w.uint32(264).int32(m.TeaNum);
            if (m.TeaFee != null && Object.hasOwnProperty.call(m, "TeaFee"))
                w.uint32(272).int64(m.TeaFee);
            if (m.TotalTeaFee != null && Object.hasOwnProperty.call(m, "TotalTeaFee"))
                w.uint32(280).int64(m.TotalTeaFee);
            if (m.IsTablewareFee != null && Object.hasOwnProperty.call(m, "IsTablewareFee"))
                w.uint32(288).int32(m.IsTablewareFee);
            if (m.TablewareNum != null && Object.hasOwnProperty.call(m, "TablewareNum"))
                w.uint32(296).int32(m.TablewareNum);
            if (m.TablewareFee != null && Object.hasOwnProperty.call(m, "TablewareFee"))
                w.uint32(304).int64(m.TablewareFee);
            if (m.TotalTablewareFee != null && Object.hasOwnProperty.call(m, "TotalTablewareFee"))
                w.uint32(312).int64(m.TotalTablewareFee);
            if (m.IsPackageFee != null && Object.hasOwnProperty.call(m, "IsPackageFee"))
                w.uint32(320).int32(m.IsPackageFee);
            if (m.PackageFee != null && Object.hasOwnProperty.call(m, "PackageFee"))
                w.uint32(328).int64(m.PackageFee);
            if (m.PriceCate != null && Object.hasOwnProperty.call(m, "PriceCate"))
                w.uint32(336).int32(m.PriceCate);
            if (m.TotalNum != null && Object.hasOwnProperty.call(m, "TotalNum"))
                w.uint32(345).double(m.TotalNum);
            if (m.TotalRecord != null && Object.hasOwnProperty.call(m, "TotalRecord"))
                w.uint32(352).int32(m.TotalRecord);
            if (m.TotalDetailAmt != null && Object.hasOwnProperty.call(m, "TotalDetailAmt"))
                w.uint32(360).int64(m.TotalDetailAmt);
            if (m.TotalCostAmt != null && Object.hasOwnProperty.call(m, "TotalCostAmt"))
                w.uint32(368).int64(m.TotalCostAmt);
            if (m.TotalWeight != null && Object.hasOwnProperty.call(m, "TotalWeight"))
                w.uint32(377).double(m.TotalWeight);
            if (m.TotalMinusAmt != null && Object.hasOwnProperty.call(m, "TotalMinusAmt"))
                w.uint32(384).int64(m.TotalMinusAmt);
            if (m.TotalSavedAmt != null && Object.hasOwnProperty.call(m, "TotalSavedAmt"))
                w.uint32(392).int64(m.TotalSavedAmt);
            if (m.RevenueAmt != null && Object.hasOwnProperty.call(m, "RevenueAmt"))
                w.uint32(400).int64(m.RevenueAmt);
            if (m.TotalProfit != null && Object.hasOwnProperty.call(m, "TotalProfit"))
                w.uint32(408).int64(m.TotalProfit);
            if (m.IsTak != null && Object.hasOwnProperty.call(m, "IsTak"))
                w.uint32(416).int32(m.IsTak);
            if (m.TakAmt != null && Object.hasOwnProperty.call(m, "TakAmt"))
                w.uint32(424).int64(m.TakAmt);
            if (m.IsSF != null && Object.hasOwnProperty.call(m, "IsSF"))
                w.uint32(432).int32(m.IsSF);
            if (m.SFAmt != null && Object.hasOwnProperty.call(m, "SFAmt"))
                w.uint32(440).int64(m.SFAmt);
            if (m.TotalAmt != null && Object.hasOwnProperty.call(m, "TotalAmt"))
                w.uint32(448).int64(m.TotalAmt);
            if (m.ReceiptAmt != null && Object.hasOwnProperty.call(m, "ReceiptAmt"))
                w.uint32(456).int64(m.ReceiptAmt);
            if (m.AtTime != null && Object.hasOwnProperty.call(m, "AtTime"))
                w.uint32(464).int64(m.AtTime);
            if (m.OrderNotes != null && Object.hasOwnProperty.call(m, "OrderNotes"))
                w.uint32(474).string(m.OrderNotes);
            if (m.PayState != null && Object.hasOwnProperty.call(m, "PayState"))
                w.uint32(480).int32(m.PayState);
            if (m.PayExpires != null && Object.hasOwnProperty.call(m, "PayExpires"))
                w.uint32(488).int64(m.PayExpires);
            if (m.PayTime != null && Object.hasOwnProperty.call(m, "PayTime"))
                w.uint32(496).int64(m.PayTime);
            if (m.PayAmt != null && Object.hasOwnProperty.call(m, "PayAmt"))
                w.uint32(504).int64(m.PayAmt);
            if (m.OrderPayID != null && Object.hasOwnProperty.call(m, "OrderPayID"))
                w.uint32(514).string(m.OrderPayID);
            if (m.PayID != null && Object.hasOwnProperty.call(m, "PayID"))
                w.uint32(522).string(m.PayID);
            if (m.ReceiptNotes != null && Object.hasOwnProperty.call(m, "ReceiptNotes"))
                w.uint32(530).string(m.ReceiptNotes);
            if (m.OrderState != null && Object.hasOwnProperty.call(m, "OrderState"))
                w.uint32(536).int32(m.OrderState);
            if (m.IsNotice != null && Object.hasOwnProperty.call(m, "IsNotice"))
                w.uint32(544).int32(m.IsNotice);
            if (m.IsAtPrint != null && Object.hasOwnProperty.call(m, "IsAtPrint"))
                w.uint32(552).int32(m.IsAtPrint);
            if (m.IsSubsMsg != null && Object.hasOwnProperty.call(m, "IsSubsMsg"))
                w.uint32(560).int32(m.IsSubsMsg);
            if (m.CallCount != null && Object.hasOwnProperty.call(m, "CallCount"))
                w.uint32(568).int32(m.CallCount);
            if (m.RefundAmtState != null && Object.hasOwnProperty.call(m, "RefundAmtState"))
                w.uint32(576).int32(m.RefundAmtState);
            if (m.RefundAmt != null && Object.hasOwnProperty.call(m, "RefundAmt"))
                w.uint32(584).int64(m.RefundAmt);
            if (m.SendTime != null && Object.hasOwnProperty.call(m, "SendTime"))
                w.uint32(592).int64(m.SendTime);
            if (m.FinishTime != null && Object.hasOwnProperty.call(m, "FinishTime"))
                w.uint32(600).int64(m.FinishTime);
            if (m.CancelTime != null && Object.hasOwnProperty.call(m, "CancelTime"))
                w.uint32(608).int64(m.CancelTime);
            if (m.SendNotes != null && Object.hasOwnProperty.call(m, "SendNotes"))
                w.uint32(618).string(m.SendNotes);
            if (m.GroupID != null && Object.hasOwnProperty.call(m, "GroupID"))
                w.uint32(624).uint64(m.GroupID);
            if (m.IsSale != null && Object.hasOwnProperty.call(m, "IsSale"))
                w.uint32(632).int32(m.IsSale);
            if (m.IsRefund != null && Object.hasOwnProperty.call(m, "IsRefund"))
                w.uint32(640).int32(m.IsRefund);
            if (m.IsPlanTime != null && Object.hasOwnProperty.call(m, "IsPlanTime"))
                w.uint32(648).int32(m.IsPlanTime);
            if (m.PlanTime != null && Object.hasOwnProperty.call(m, "PlanTime"))
                w.uint32(656).int64(m.PlanTime);
            if (m.FromIP != null && Object.hasOwnProperty.call(m, "FromIP"))
                w.uint32(666).string(m.FromIP);
            if (m.FromTokeID != null && Object.hasOwnProperty.call(m, "FromTokeID"))
                w.uint32(674).string(m.FromTokeID);
            if (m.CancelNotes != null && Object.hasOwnProperty.call(m, "CancelNotes"))
                w.uint32(682).string(m.CancelNotes);
            if (m.RefundTeaNum != null && Object.hasOwnProperty.call(m, "RefundTeaNum"))
                w.uint32(688).int32(m.RefundTeaNum);
            if (m.RefundTablewareNum != null && Object.hasOwnProperty.call(m, "RefundTablewareNum"))
                w.uint32(696).int32(m.RefundTablewareNum);
            if (m.RefundPackageFee != null && Object.hasOwnProperty.call(m, "RefundPackageFee"))
                w.uint32(704).int64(m.RefundPackageFee);
            if (m.RefundPostageAmt != null && Object.hasOwnProperty.call(m, "RefundPostageAmt"))
                w.uint32(712).int64(m.RefundPostageAmt);
            if (m.EvaluateState != null && Object.hasOwnProperty.call(m, "EvaluateState"))
                w.uint32(720).int32(m.EvaluateState);
            if (m.EvaluateGrade != null && Object.hasOwnProperty.call(m, "EvaluateGrade"))
                w.uint32(728).int32(m.EvaluateGrade);
            if (m.DeliveryChannel != null && Object.hasOwnProperty.call(m, "DeliveryChannel"))
                w.uint32(736).int32(m.DeliveryChannel);
            if (m.DeliveryID != null && Object.hasOwnProperty.call(m, "DeliveryID"))
                w.uint32(746).string(m.DeliveryID);
            if (m.DeliveryState != null && Object.hasOwnProperty.call(m, "DeliveryState"))
                w.uint32(752).int32(m.DeliveryState);
            if (m.CreateTime != null && Object.hasOwnProperty.call(m, "CreateTime"))
                w.uint32(760).int64(m.CreateTime);
            if (m.CreaterID != null && Object.hasOwnProperty.call(m, "CreaterID"))
                w.uint32(768).uint64(m.CreaterID);
            if (m.UpdateTime != null && Object.hasOwnProperty.call(m, "UpdateTime"))
                w.uint32(776).int64(m.UpdateTime);
            if (m.UpdaterID != null && Object.hasOwnProperty.call(m, "UpdaterID"))
                w.uint32(784).uint64(m.UpdaterID);
            if (m.Estate != null && Object.hasOwnProperty.call(m, "Estate"))
                w.uint32(792).int32(m.Estate);
            return w;
        };

        Order.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.Order();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        m.OrderID = r.string();
                        break;
                    }
                    case 2: {
                        m.MchID = r.uint64();
                        break;
                    }
                    case 3: {
                        m.UserID = r.uint64();
                        break;
                    }
                    case 4: {
                        m.TransDate = r.int64();
                        break;
                    }
                    case 5: {
                        m.SaleSeq = r.int32();
                        break;
                    }
                    case 6: {
                        m.SeqCode = r.string();
                        break;
                    }
                    case 7: {
                        m.SaleNo = r.string();
                        break;
                    }
                    case 8: {
                        m.ReID = r.string();
                        break;
                    }
                    case 9: {
                        m.OrderCate = r.int32();
                        break;
                    }
                    case 10: {
                        m.AtUserCate = r.int32();
                        break;
                    }
                    case 11: {
                        m.AtChannel = r.int32();
                        break;
                    }
                    case 12: {
                        m.ToAccUserID = r.uint64();
                        break;
                    }
                    case 13: {
                        m.CustomLevel = r.int32();
                        break;
                    }
                    case 14: {
                        m.AtOrderCate = r.int32();
                        break;
                    }
                    case 15: {
                        m.PayMode = r.int32();
                        break;
                    }
                    case 16: {
                        m.DistrMode = r.int32();
                        break;
                    }
                    case 17: {
                        m.TakeMode = r.int32();
                        break;
                    }
                    case 18: {
                        m.LinkName = r.string();
                        break;
                    }
                    case 19: {
                        m.LinkPhone = r.string();
                        break;
                    }
                    case 20: {
                        m.LinkAddress = r.string();
                        break;
                    }
                    case 21: {
                        m.LinkLocateCate = r.int32();
                        break;
                    }
                    case 22: {
                        m.LinkLocateX = r.double();
                        break;
                    }
                    case 23: {
                        m.LinkLocateY = r.double();
                        break;
                    }
                    case 24: {
                        m.LinkLocateName = r.string();
                        break;
                    }
                    case 25: {
                        m.LinkLocateAddr = r.string();
                        break;
                    }
                    case 26: {
                        m.DeskID = r.uint64();
                        break;
                    }
                    case 27: {
                        m.TakePointID = r.uint64();
                        break;
                    }
                    case 28: {
                        m.PostageCate = r.int32();
                        break;
                    }
                    case 29: {
                        m.PostageAmt = r.int64();
                        break;
                    }
                    case 30: {
                        m.Distance = r.double();
                        break;
                    }
                    case 31: {
                        m.PeopleNum = r.int32();
                        break;
                    }
                    case 32: {
                        m.IsTeaFee = r.int32();
                        break;
                    }
                    case 33: {
                        m.TeaNum = r.int32();
                        break;
                    }
                    case 34: {
                        m.TeaFee = r.int64();
                        break;
                    }
                    case 35: {
                        m.TotalTeaFee = r.int64();
                        break;
                    }
                    case 36: {
                        m.IsTablewareFee = r.int32();
                        break;
                    }
                    case 37: {
                        m.TablewareNum = r.int32();
                        break;
                    }
                    case 38: {
                        m.TablewareFee = r.int64();
                        break;
                    }
                    case 39: {
                        m.TotalTablewareFee = r.int64();
                        break;
                    }
                    case 40: {
                        m.IsPackageFee = r.int32();
                        break;
                    }
                    case 41: {
                        m.PackageFee = r.int64();
                        break;
                    }
                    case 42: {
                        m.PriceCate = r.int32();
                        break;
                    }
                    case 43: {
                        m.TotalNum = r.double();
                        break;
                    }
                    case 44: {
                        m.TotalRecord = r.int32();
                        break;
                    }
                    case 45: {
                        m.TotalDetailAmt = r.int64();
                        break;
                    }
                    case 46: {
                        m.TotalCostAmt = r.int64();
                        break;
                    }
                    case 47: {
                        m.TotalWeight = r.double();
                        break;
                    }
                    case 48: {
                        m.TotalMinusAmt = r.int64();
                        break;
                    }
                    case 49: {
                        m.TotalSavedAmt = r.int64();
                        break;
                    }
                    case 50: {
                        m.RevenueAmt = r.int64();
                        break;
                    }
                    case 51: {
                        m.TotalProfit = r.int64();
                        break;
                    }
                    case 52: {
                        m.IsTak = r.int32();
                        break;
                    }
                    case 53: {
                        m.TakAmt = r.int64();
                        break;
                    }
                    case 54: {
                        m.IsSF = r.int32();
                        break;
                    }
                    case 55: {
                        m.SFAmt = r.int64();
                        break;
                    }
                    case 56: {
                        m.TotalAmt = r.int64();
                        break;
                    }
                    case 57: {
                        m.ReceiptAmt = r.int64();
                        break;
                    }
                    case 58: {
                        m.AtTime = r.int64();
                        break;
                    }
                    case 59: {
                        m.OrderNotes = r.string();
                        break;
                    }
                    case 60: {
                        m.PayState = r.int32();
                        break;
                    }
                    case 61: {
                        m.PayExpires = r.int64();
                        break;
                    }
                    case 62: {
                        m.PayTime = r.int64();
                        break;
                    }
                    case 63: {
                        m.PayAmt = r.int64();
                        break;
                    }
                    case 64: {
                        m.OrderPayID = r.string();
                        break;
                    }
                    case 65: {
                        m.PayID = r.string();
                        break;
                    }
                    case 66: {
                        m.ReceiptNotes = r.string();
                        break;
                    }
                    case 67: {
                        m.OrderState = r.int32();
                        break;
                    }
                    case 68: {
                        m.IsNotice = r.int32();
                        break;
                    }
                    case 69: {
                        m.IsAtPrint = r.int32();
                        break;
                    }
                    case 70: {
                        m.IsSubsMsg = r.int32();
                        break;
                    }
                    case 71: {
                        m.CallCount = r.int32();
                        break;
                    }
                    case 72: {
                        m.RefundAmtState = r.int32();
                        break;
                    }
                    case 73: {
                        m.RefundAmt = r.int64();
                        break;
                    }
                    case 74: {
                        m.SendTime = r.int64();
                        break;
                    }
                    case 75: {
                        m.FinishTime = r.int64();
                        break;
                    }
                    case 76: {
                        m.CancelTime = r.int64();
                        break;
                    }
                    case 77: {
                        m.SendNotes = r.string();
                        break;
                    }
                    case 78: {
                        m.GroupID = r.uint64();
                        break;
                    }
                    case 79: {
                        m.IsSale = r.int32();
                        break;
                    }
                    case 80: {
                        m.IsRefund = r.int32();
                        break;
                    }
                    case 81: {
                        m.IsPlanTime = r.int32();
                        break;
                    }
                    case 82: {
                        m.PlanTime = r.int64();
                        break;
                    }
                    case 83: {
                        m.FromIP = r.string();
                        break;
                    }
                    case 84: {
                        m.FromTokeID = r.string();
                        break;
                    }
                    case 85: {
                        m.CancelNotes = r.string();
                        break;
                    }
                    case 86: {
                        m.RefundTeaNum = r.int32();
                        break;
                    }
                    case 87: {
                        m.RefundTablewareNum = r.int32();
                        break;
                    }
                    case 88: {
                        m.RefundPackageFee = r.int64();
                        break;
                    }
                    case 89: {
                        m.RefundPostageAmt = r.int64();
                        break;
                    }
                    case 90: {
                        m.EvaluateState = r.int32();
                        break;
                    }
                    case 91: {
                        m.EvaluateGrade = r.int32();
                        break;
                    }
                    case 92: {
                        m.DeliveryChannel = r.int32();
                        break;
                    }
                    case 93: {
                        m.DeliveryID = r.string();
                        break;
                    }
                    case 94: {
                        m.DeliveryState = r.int32();
                        break;
                    }
                    case 95: {
                        m.CreateTime = r.int64();
                        break;
                    }
                    case 96: {
                        m.CreaterID = r.uint64();
                        break;
                    }
                    case 97: {
                        m.UpdateTime = r.int64();
                        break;
                    }
                    case 98: {
                        m.UpdaterID = r.uint64();
                        break;
                    }
                    case 99: {
                        m.Estate = r.int32();
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        Order.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.Order";
        };

        return Order;
    })();

    PBEntity.Orders = (function () {

        function Orders(p) {
            this.Orders = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        Orders.prototype.Orders = $util.emptyArray;

        Orders.create = function create(properties) {
            return new Orders(properties);
        };

        Orders.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.Orders != null && m.Orders.length) {
                for (var i = 0; i < m.Orders.length; ++i)
                    $root.PBEntity.Order.encode(m.Orders[i], w.uint32(10).fork()).ldelim();
            }
            return w;
        };

        Orders.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.Orders();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        if (!(m.Orders && m.Orders.length))
                            m.Orders = [];
                        m.Orders.push($root.PBEntity.Order.decode(r, r.uint32()));
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        Orders.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.Orders";
        };

        return Orders;
    })();

    PBEntity.OrderDelivery = (function () {

        function OrderDelivery(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        OrderDelivery.prototype.DeliveryID = "";
        OrderDelivery.prototype.OrderNo = "";
        OrderDelivery.prototype.MchID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        OrderDelivery.prototype.GroupID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        OrderDelivery.prototype.DeliveryChannel = 0;
        OrderDelivery.prototype.DeliveryState = 0;
        OrderDelivery.prototype.RecName = "";
        OrderDelivery.prototype.RecAddr = "";
        OrderDelivery.prototype.RecLat = 0;
        OrderDelivery.prototype.RecLng = 0;
        OrderDelivery.prototype.RecPhone = "";
        OrderDelivery.prototype.IsUseInsurance = 0;
        OrderDelivery.prototype.SupplierName = "";
        OrderDelivery.prototype.SupplierAddress = "";
        OrderDelivery.prototype.SupplierPhone = "";
        OrderDelivery.prototype.SupplierLat = 0;
        OrderDelivery.prototype.SupplierLng = 0;
        OrderDelivery.prototype.OriTips = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderDelivery.prototype.OriInsuranceFee = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderDelivery.prototype.OriDeliveryFee = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderDelivery.prototype.OriFee = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderDelivery.prototype.OriActualFee = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderDelivery.prototype.MFKFee = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderDelivery.prototype.OriTotalFee = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderDelivery.prototype.SettlementType = 0;
        OrderDelivery.prototype.ReceivedAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderDelivery.prototype.PayAccID = "";
        OrderDelivery.prototype.Distance = 0;
        OrderDelivery.prototype.DeliveryFee = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderDelivery.prototype.DeliveryNo = "";
        OrderDelivery.prototype.CouponFee = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderDelivery.prototype.Fee = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderDelivery.prototype.ActualFee = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderDelivery.prototype.DeductFee = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderDelivery.prototype.Tips = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderDelivery.prototype.InsuranceFee = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderDelivery.prototype.SettlementStatus = 0;
        OrderDelivery.prototype.RefundAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderDelivery.prototype.TotalFee = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderDelivery.prototype.StatusMsg = "";
        OrderDelivery.prototype.TPName = "";
        OrderDelivery.prototype.TPPhone = "";
        OrderDelivery.prototype.TPLng = 0;
        OrderDelivery.prototype.TPLat = 0;
        OrderDelivery.prototype.SubmitTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderDelivery.prototype.SubmitStatus = 0;
        OrderDelivery.prototype.PickUpPos = "";
        OrderDelivery.prototype.FetchCode = "";
        OrderDelivery.prototype.SubmitError = "";
        OrderDelivery.prototype.AtTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderDelivery.prototype.CancelTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderDelivery.prototype.CancelReasonID = 0;
        OrderDelivery.prototype.CancelReason = "";
        OrderDelivery.prototype.CancelFrom = 0;
        OrderDelivery.prototype.ComplaintReasonID = 0;
        OrderDelivery.prototype.ComplaintTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderDelivery.prototype.AcceptTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderDelivery.prototype.FinishTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderDelivery.prototype.FetchTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderDelivery.prototype.IsNotice = 0;
        OrderDelivery.prototype.CreateTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderDelivery.prototype.CreaterID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        OrderDelivery.prototype.UpdateTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderDelivery.prototype.UpdaterID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        OrderDelivery.prototype.Estate = 0;

        OrderDelivery.create = function create(properties) {
            return new OrderDelivery(properties);
        };

        OrderDelivery.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.DeliveryID != null && Object.hasOwnProperty.call(m, "DeliveryID"))
                w.uint32(10).string(m.DeliveryID);
            if (m.OrderNo != null && Object.hasOwnProperty.call(m, "OrderNo"))
                w.uint32(18).string(m.OrderNo);
            if (m.MchID != null && Object.hasOwnProperty.call(m, "MchID"))
                w.uint32(24).uint64(m.MchID);
            if (m.GroupID != null && Object.hasOwnProperty.call(m, "GroupID"))
                w.uint32(32).uint64(m.GroupID);
            if (m.DeliveryChannel != null && Object.hasOwnProperty.call(m, "DeliveryChannel"))
                w.uint32(40).int32(m.DeliveryChannel);
            if (m.DeliveryState != null && Object.hasOwnProperty.call(m, "DeliveryState"))
                w.uint32(48).int32(m.DeliveryState);
            if (m.RecName != null && Object.hasOwnProperty.call(m, "RecName"))
                w.uint32(58).string(m.RecName);
            if (m.RecAddr != null && Object.hasOwnProperty.call(m, "RecAddr"))
                w.uint32(66).string(m.RecAddr);
            if (m.RecLat != null && Object.hasOwnProperty.call(m, "RecLat"))
                w.uint32(73).double(m.RecLat);
            if (m.RecLng != null && Object.hasOwnProperty.call(m, "RecLng"))
                w.uint32(81).double(m.RecLng);
            if (m.RecPhone != null && Object.hasOwnProperty.call(m, "RecPhone"))
                w.uint32(90).string(m.RecPhone);
            if (m.IsUseInsurance != null && Object.hasOwnProperty.call(m, "IsUseInsurance"))
                w.uint32(96).int32(m.IsUseInsurance);
            if (m.SupplierName != null && Object.hasOwnProperty.call(m, "SupplierName"))
                w.uint32(106).string(m.SupplierName);
            if (m.SupplierAddress != null && Object.hasOwnProperty.call(m, "SupplierAddress"))
                w.uint32(114).string(m.SupplierAddress);
            if (m.SupplierPhone != null && Object.hasOwnProperty.call(m, "SupplierPhone"))
                w.uint32(122).string(m.SupplierPhone);
            if (m.SupplierLat != null && Object.hasOwnProperty.call(m, "SupplierLat"))
                w.uint32(129).double(m.SupplierLat);
            if (m.SupplierLng != null && Object.hasOwnProperty.call(m, "SupplierLng"))
                w.uint32(137).double(m.SupplierLng);
            if (m.OriTips != null && Object.hasOwnProperty.call(m, "OriTips"))
                w.uint32(144).int64(m.OriTips);
            if (m.OriInsuranceFee != null && Object.hasOwnProperty.call(m, "OriInsuranceFee"))
                w.uint32(152).int64(m.OriInsuranceFee);
            if (m.OriDeliveryFee != null && Object.hasOwnProperty.call(m, "OriDeliveryFee"))
                w.uint32(160).int64(m.OriDeliveryFee);
            if (m.OriFee != null && Object.hasOwnProperty.call(m, "OriFee"))
                w.uint32(168).int64(m.OriFee);
            if (m.OriActualFee != null && Object.hasOwnProperty.call(m, "OriActualFee"))
                w.uint32(176).int64(m.OriActualFee);
            if (m.MFKFee != null && Object.hasOwnProperty.call(m, "MFKFee"))
                w.uint32(184).int64(m.MFKFee);
            if (m.OriTotalFee != null && Object.hasOwnProperty.call(m, "OriTotalFee"))
                w.uint32(192).int64(m.OriTotalFee);
            if (m.SettlementType != null && Object.hasOwnProperty.call(m, "SettlementType"))
                w.uint32(200).int32(m.SettlementType);
            if (m.ReceivedAmt != null && Object.hasOwnProperty.call(m, "ReceivedAmt"))
                w.uint32(208).int64(m.ReceivedAmt);
            if (m.PayAccID != null && Object.hasOwnProperty.call(m, "PayAccID"))
                w.uint32(218).string(m.PayAccID);
            if (m.Distance != null && Object.hasOwnProperty.call(m, "Distance"))
                w.uint32(225).double(m.Distance);
            if (m.DeliveryFee != null && Object.hasOwnProperty.call(m, "DeliveryFee"))
                w.uint32(232).int64(m.DeliveryFee);
            if (m.DeliveryNo != null && Object.hasOwnProperty.call(m, "DeliveryNo"))
                w.uint32(242).string(m.DeliveryNo);
            if (m.CouponFee != null && Object.hasOwnProperty.call(m, "CouponFee"))
                w.uint32(248).int64(m.CouponFee);
            if (m.Fee != null && Object.hasOwnProperty.call(m, "Fee"))
                w.uint32(256).int64(m.Fee);
            if (m.ActualFee != null && Object.hasOwnProperty.call(m, "ActualFee"))
                w.uint32(264).int64(m.ActualFee);
            if (m.DeductFee != null && Object.hasOwnProperty.call(m, "DeductFee"))
                w.uint32(272).int64(m.DeductFee);
            if (m.Tips != null && Object.hasOwnProperty.call(m, "Tips"))
                w.uint32(280).int64(m.Tips);
            if (m.InsuranceFee != null && Object.hasOwnProperty.call(m, "InsuranceFee"))
                w.uint32(288).int64(m.InsuranceFee);
            if (m.SettlementStatus != null && Object.hasOwnProperty.call(m, "SettlementStatus"))
                w.uint32(296).int32(m.SettlementStatus);
            if (m.RefundAmt != null && Object.hasOwnProperty.call(m, "RefundAmt"))
                w.uint32(304).int64(m.RefundAmt);
            if (m.TotalFee != null && Object.hasOwnProperty.call(m, "TotalFee"))
                w.uint32(312).int64(m.TotalFee);
            if (m.StatusMsg != null && Object.hasOwnProperty.call(m, "StatusMsg"))
                w.uint32(322).string(m.StatusMsg);
            if (m.TPName != null && Object.hasOwnProperty.call(m, "TPName"))
                w.uint32(330).string(m.TPName);
            if (m.TPPhone != null && Object.hasOwnProperty.call(m, "TPPhone"))
                w.uint32(338).string(m.TPPhone);
            if (m.TPLng != null && Object.hasOwnProperty.call(m, "TPLng"))
                w.uint32(345).double(m.TPLng);
            if (m.TPLat != null && Object.hasOwnProperty.call(m, "TPLat"))
                w.uint32(353).double(m.TPLat);
            if (m.SubmitTime != null && Object.hasOwnProperty.call(m, "SubmitTime"))
                w.uint32(360).int64(m.SubmitTime);
            if (m.SubmitStatus != null && Object.hasOwnProperty.call(m, "SubmitStatus"))
                w.uint32(368).int32(m.SubmitStatus);
            if (m.PickUpPos != null && Object.hasOwnProperty.call(m, "PickUpPos"))
                w.uint32(378).string(m.PickUpPos);
            if (m.FetchCode != null && Object.hasOwnProperty.call(m, "FetchCode"))
                w.uint32(386).string(m.FetchCode);
            if (m.SubmitError != null && Object.hasOwnProperty.call(m, "SubmitError"))
                w.uint32(394).string(m.SubmitError);
            if (m.AtTime != null && Object.hasOwnProperty.call(m, "AtTime"))
                w.uint32(400).int64(m.AtTime);
            if (m.CancelTime != null && Object.hasOwnProperty.call(m, "CancelTime"))
                w.uint32(408).int64(m.CancelTime);
            if (m.CancelReasonID != null && Object.hasOwnProperty.call(m, "CancelReasonID"))
                w.uint32(416).int32(m.CancelReasonID);
            if (m.CancelReason != null && Object.hasOwnProperty.call(m, "CancelReason"))
                w.uint32(426).string(m.CancelReason);
            if (m.CancelFrom != null && Object.hasOwnProperty.call(m, "CancelFrom"))
                w.uint32(432).int32(m.CancelFrom);
            if (m.ComplaintReasonID != null && Object.hasOwnProperty.call(m, "ComplaintReasonID"))
                w.uint32(440).int32(m.ComplaintReasonID);
            if (m.ComplaintTime != null && Object.hasOwnProperty.call(m, "ComplaintTime"))
                w.uint32(448).int64(m.ComplaintTime);
            if (m.AcceptTime != null && Object.hasOwnProperty.call(m, "AcceptTime"))
                w.uint32(456).int64(m.AcceptTime);
            if (m.FinishTime != null && Object.hasOwnProperty.call(m, "FinishTime"))
                w.uint32(464).int64(m.FinishTime);
            if (m.FetchTime != null && Object.hasOwnProperty.call(m, "FetchTime"))
                w.uint32(472).int64(m.FetchTime);
            if (m.IsNotice != null && Object.hasOwnProperty.call(m, "IsNotice"))
                w.uint32(480).int32(m.IsNotice);
            if (m.CreateTime != null && Object.hasOwnProperty.call(m, "CreateTime"))
                w.uint32(488).int64(m.CreateTime);
            if (m.CreaterID != null && Object.hasOwnProperty.call(m, "CreaterID"))
                w.uint32(496).uint64(m.CreaterID);
            if (m.UpdateTime != null && Object.hasOwnProperty.call(m, "UpdateTime"))
                w.uint32(504).int64(m.UpdateTime);
            if (m.UpdaterID != null && Object.hasOwnProperty.call(m, "UpdaterID"))
                w.uint32(512).uint64(m.UpdaterID);
            if (m.Estate != null && Object.hasOwnProperty.call(m, "Estate"))
                w.uint32(520).int32(m.Estate);
            return w;
        };

        OrderDelivery.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.OrderDelivery();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        m.DeliveryID = r.string();
                        break;
                    }
                    case 2: {
                        m.OrderNo = r.string();
                        break;
                    }
                    case 3: {
                        m.MchID = r.uint64();
                        break;
                    }
                    case 4: {
                        m.GroupID = r.uint64();
                        break;
                    }
                    case 5: {
                        m.DeliveryChannel = r.int32();
                        break;
                    }
                    case 6: {
                        m.DeliveryState = r.int32();
                        break;
                    }
                    case 7: {
                        m.RecName = r.string();
                        break;
                    }
                    case 8: {
                        m.RecAddr = r.string();
                        break;
                    }
                    case 9: {
                        m.RecLat = r.double();
                        break;
                    }
                    case 10: {
                        m.RecLng = r.double();
                        break;
                    }
                    case 11: {
                        m.RecPhone = r.string();
                        break;
                    }
                    case 12: {
                        m.IsUseInsurance = r.int32();
                        break;
                    }
                    case 13: {
                        m.SupplierName = r.string();
                        break;
                    }
                    case 14: {
                        m.SupplierAddress = r.string();
                        break;
                    }
                    case 15: {
                        m.SupplierPhone = r.string();
                        break;
                    }
                    case 16: {
                        m.SupplierLat = r.double();
                        break;
                    }
                    case 17: {
                        m.SupplierLng = r.double();
                        break;
                    }
                    case 18: {
                        m.OriTips = r.int64();
                        break;
                    }
                    case 19: {
                        m.OriInsuranceFee = r.int64();
                        break;
                    }
                    case 20: {
                        m.OriDeliveryFee = r.int64();
                        break;
                    }
                    case 21: {
                        m.OriFee = r.int64();
                        break;
                    }
                    case 22: {
                        m.OriActualFee = r.int64();
                        break;
                    }
                    case 23: {
                        m.MFKFee = r.int64();
                        break;
                    }
                    case 24: {
                        m.OriTotalFee = r.int64();
                        break;
                    }
                    case 25: {
                        m.SettlementType = r.int32();
                        break;
                    }
                    case 26: {
                        m.ReceivedAmt = r.int64();
                        break;
                    }
                    case 27: {
                        m.PayAccID = r.string();
                        break;
                    }
                    case 28: {
                        m.Distance = r.double();
                        break;
                    }
                    case 29: {
                        m.DeliveryFee = r.int64();
                        break;
                    }
                    case 30: {
                        m.DeliveryNo = r.string();
                        break;
                    }
                    case 31: {
                        m.CouponFee = r.int64();
                        break;
                    }
                    case 32: {
                        m.Fee = r.int64();
                        break;
                    }
                    case 33: {
                        m.ActualFee = r.int64();
                        break;
                    }
                    case 34: {
                        m.DeductFee = r.int64();
                        break;
                    }
                    case 35: {
                        m.Tips = r.int64();
                        break;
                    }
                    case 36: {
                        m.InsuranceFee = r.int64();
                        break;
                    }
                    case 37: {
                        m.SettlementStatus = r.int32();
                        break;
                    }
                    case 38: {
                        m.RefundAmt = r.int64();
                        break;
                    }
                    case 39: {
                        m.TotalFee = r.int64();
                        break;
                    }
                    case 40: {
                        m.StatusMsg = r.string();
                        break;
                    }
                    case 41: {
                        m.TPName = r.string();
                        break;
                    }
                    case 42: {
                        m.TPPhone = r.string();
                        break;
                    }
                    case 43: {
                        m.TPLng = r.double();
                        break;
                    }
                    case 44: {
                        m.TPLat = r.double();
                        break;
                    }
                    case 45: {
                        m.SubmitTime = r.int64();
                        break;
                    }
                    case 46: {
                        m.SubmitStatus = r.int32();
                        break;
                    }
                    case 47: {
                        m.PickUpPos = r.string();
                        break;
                    }
                    case 48: {
                        m.FetchCode = r.string();
                        break;
                    }
                    case 49: {
                        m.SubmitError = r.string();
                        break;
                    }
                    case 50: {
                        m.AtTime = r.int64();
                        break;
                    }
                    case 51: {
                        m.CancelTime = r.int64();
                        break;
                    }
                    case 52: {
                        m.CancelReasonID = r.int32();
                        break;
                    }
                    case 53: {
                        m.CancelReason = r.string();
                        break;
                    }
                    case 54: {
                        m.CancelFrom = r.int32();
                        break;
                    }
                    case 55: {
                        m.ComplaintReasonID = r.int32();
                        break;
                    }
                    case 56: {
                        m.ComplaintTime = r.int64();
                        break;
                    }
                    case 57: {
                        m.AcceptTime = r.int64();
                        break;
                    }
                    case 58: {
                        m.FinishTime = r.int64();
                        break;
                    }
                    case 59: {
                        m.FetchTime = r.int64();
                        break;
                    }
                    case 60: {
                        m.IsNotice = r.int32();
                        break;
                    }
                    case 61: {
                        m.CreateTime = r.int64();
                        break;
                    }
                    case 62: {
                        m.CreaterID = r.uint64();
                        break;
                    }
                    case 63: {
                        m.UpdateTime = r.int64();
                        break;
                    }
                    case 64: {
                        m.UpdaterID = r.uint64();
                        break;
                    }
                    case 65: {
                        m.Estate = r.int32();
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        OrderDelivery.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.OrderDelivery";
        };

        return OrderDelivery;
    })();

    PBEntity.OrderDeliverys = (function () {

        function OrderDeliverys(p) {
            this.OrderDeliverys = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        OrderDeliverys.prototype.OrderDeliverys = $util.emptyArray;

        OrderDeliverys.create = function create(properties) {
            return new OrderDeliverys(properties);
        };

        OrderDeliverys.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.OrderDeliverys != null && m.OrderDeliverys.length) {
                for (var i = 0; i < m.OrderDeliverys.length; ++i)
                    $root.PBEntity.OrderDelivery.encode(m.OrderDeliverys[i], w.uint32(10).fork()).ldelim();
            }
            return w;
        };

        OrderDeliverys.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.OrderDeliverys();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        if (!(m.OrderDeliverys && m.OrderDeliverys.length))
                            m.OrderDeliverys = [];
                        m.OrderDeliverys.push($root.PBEntity.OrderDelivery.decode(r, r.uint32()));
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        OrderDeliverys.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.OrderDeliverys";
        };

        return OrderDeliverys;
    })();

    PBEntity.OrderDeliveryFlow = (function () {

        function OrderDeliveryFlow(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        OrderDeliveryFlow.prototype.ID = "";
        OrderDeliveryFlow.prototype.OrderNo = "";
        OrderDeliveryFlow.prototype.MchID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        OrderDeliveryFlow.prototype.DeliveryState = 0;
        OrderDeliveryFlow.prototype.DeliveryChannel = 0;
        OrderDeliveryFlow.prototype.DeliveryID = "";
        OrderDeliveryFlow.prototype.OutDeliveryID = "";
        OrderDeliveryFlow.prototype.TransTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderDeliveryFlow.prototype.Notes = "";
        OrderDeliveryFlow.prototype.TPName = "";
        OrderDeliveryFlow.prototype.TPPhone = "";
        OrderDeliveryFlow.prototype.TPLng = 0;
        OrderDeliveryFlow.prototype.TPLat = 0;
        OrderDeliveryFlow.prototype.CreateTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderDeliveryFlow.prototype.CreaterID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        OrderDeliveryFlow.prototype.Estate = 0;

        OrderDeliveryFlow.create = function create(properties) {
            return new OrderDeliveryFlow(properties);
        };

        OrderDeliveryFlow.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.ID != null && Object.hasOwnProperty.call(m, "ID"))
                w.uint32(10).string(m.ID);
            if (m.OrderNo != null && Object.hasOwnProperty.call(m, "OrderNo"))
                w.uint32(18).string(m.OrderNo);
            if (m.MchID != null && Object.hasOwnProperty.call(m, "MchID"))
                w.uint32(24).uint64(m.MchID);
            if (m.DeliveryState != null && Object.hasOwnProperty.call(m, "DeliveryState"))
                w.uint32(32).int32(m.DeliveryState);
            if (m.DeliveryChannel != null && Object.hasOwnProperty.call(m, "DeliveryChannel"))
                w.uint32(40).int32(m.DeliveryChannel);
            if (m.DeliveryID != null && Object.hasOwnProperty.call(m, "DeliveryID"))
                w.uint32(50).string(m.DeliveryID);
            if (m.OutDeliveryID != null && Object.hasOwnProperty.call(m, "OutDeliveryID"))
                w.uint32(58).string(m.OutDeliveryID);
            if (m.TransTime != null && Object.hasOwnProperty.call(m, "TransTime"))
                w.uint32(64).int64(m.TransTime);
            if (m.Notes != null && Object.hasOwnProperty.call(m, "Notes"))
                w.uint32(74).string(m.Notes);
            if (m.TPName != null && Object.hasOwnProperty.call(m, "TPName"))
                w.uint32(82).string(m.TPName);
            if (m.TPPhone != null && Object.hasOwnProperty.call(m, "TPPhone"))
                w.uint32(90).string(m.TPPhone);
            if (m.TPLng != null && Object.hasOwnProperty.call(m, "TPLng"))
                w.uint32(97).double(m.TPLng);
            if (m.TPLat != null && Object.hasOwnProperty.call(m, "TPLat"))
                w.uint32(105).double(m.TPLat);
            if (m.CreateTime != null && Object.hasOwnProperty.call(m, "CreateTime"))
                w.uint32(112).int64(m.CreateTime);
            if (m.CreaterID != null && Object.hasOwnProperty.call(m, "CreaterID"))
                w.uint32(120).uint64(m.CreaterID);
            if (m.Estate != null && Object.hasOwnProperty.call(m, "Estate"))
                w.uint32(128).int32(m.Estate);
            return w;
        };

        OrderDeliveryFlow.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.OrderDeliveryFlow();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        m.ID = r.string();
                        break;
                    }
                    case 2: {
                        m.OrderNo = r.string();
                        break;
                    }
                    case 3: {
                        m.MchID = r.uint64();
                        break;
                    }
                    case 4: {
                        m.DeliveryState = r.int32();
                        break;
                    }
                    case 5: {
                        m.DeliveryChannel = r.int32();
                        break;
                    }
                    case 6: {
                        m.DeliveryID = r.string();
                        break;
                    }
                    case 7: {
                        m.OutDeliveryID = r.string();
                        break;
                    }
                    case 8: {
                        m.TransTime = r.int64();
                        break;
                    }
                    case 9: {
                        m.Notes = r.string();
                        break;
                    }
                    case 10: {
                        m.TPName = r.string();
                        break;
                    }
                    case 11: {
                        m.TPPhone = r.string();
                        break;
                    }
                    case 12: {
                        m.TPLng = r.double();
                        break;
                    }
                    case 13: {
                        m.TPLat = r.double();
                        break;
                    }
                    case 14: {
                        m.CreateTime = r.int64();
                        break;
                    }
                    case 15: {
                        m.CreaterID = r.uint64();
                        break;
                    }
                    case 16: {
                        m.Estate = r.int32();
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        OrderDeliveryFlow.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.OrderDeliveryFlow";
        };

        return OrderDeliveryFlow;
    })();

    PBEntity.OrderDeliveryFlows = (function () {

        function OrderDeliveryFlows(p) {
            this.OrderDeliveryFlows = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        OrderDeliveryFlows.prototype.OrderDeliveryFlows = $util.emptyArray;

        OrderDeliveryFlows.create = function create(properties) {
            return new OrderDeliveryFlows(properties);
        };

        OrderDeliveryFlows.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.OrderDeliveryFlows != null && m.OrderDeliveryFlows.length) {
                for (var i = 0; i < m.OrderDeliveryFlows.length; ++i)
                    $root.PBEntity.OrderDeliveryFlow.encode(m.OrderDeliveryFlows[i], w.uint32(10).fork()).ldelim();
            }
            return w;
        };

        OrderDeliveryFlows.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.OrderDeliveryFlows();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        if (!(m.OrderDeliveryFlows && m.OrderDeliveryFlows.length))
                            m.OrderDeliveryFlows = [];
                        m.OrderDeliveryFlows.push($root.PBEntity.OrderDeliveryFlow.decode(r, r.uint32()));
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        OrderDeliveryFlows.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.OrderDeliveryFlows";
        };

        return OrderDeliveryFlows;
    })();

    PBEntity.OrderDetail = (function () {

        function OrderDetail(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        OrderDetail.prototype.DetailID = "";
        OrderDetail.prototype.OrderID = "";
        OrderDetail.prototype.MchID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        OrderDetail.prototype.UserID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        OrderDetail.prototype.ReID = "";
        OrderDetail.prototype.SalesCate = 0;
        OrderDetail.prototype.Category = 0;
        OrderDetail.prototype.TransDate = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderDetail.prototype.Seq = 0;
        OrderDetail.prototype.BelongID = "";
        OrderDetail.prototype.GoodsID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        OrderDetail.prototype.GName1 = "";
        OrderDetail.prototype.GName2 = "";
        OrderDetail.prototype.GName3 = "";
        OrderDetail.prototype.GoodsImg = "";
        OrderDetail.prototype.GoodsCategoryID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        OrderDetail.prototype.SkuID = "";
        OrderDetail.prototype.SpecsID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        OrderDetail.prototype.SpecsName1 = "";
        OrderDetail.prototype.SpecsName2 = "";
        OrderDetail.prototype.SpecsName3 = "";
        OrderDetail.prototype.IsVal = 0;
        OrderDetail.prototype.IsGive = 0;
        OrderDetail.prototype.SideDishCount = 0;
        OrderDetail.prototype.OriSideDishPrice = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderDetail.prototype.SideDishPrice = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderDetail.prototype.SideDishTotalPirce = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderDetail.prototype.SideDishCostPrice = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderDetail.prototype.SideDishTotalCostPrice = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderDetail.prototype.Opt1Title1 = "";
        OrderDetail.prototype.Opt1Title2 = "";
        OrderDetail.prototype.Opt1Title3 = "";
        OrderDetail.prototype.Opt1Name1 = "";
        OrderDetail.prototype.Opt1Name2 = "";
        OrderDetail.prototype.Opt1Name3 = "";
        OrderDetail.prototype.OptID1 = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        OrderDetail.prototype.Opt2Title1 = "";
        OrderDetail.prototype.Opt2Title2 = "";
        OrderDetail.prototype.Opt2Title3 = "";
        OrderDetail.prototype.Opt2Name1 = "";
        OrderDetail.prototype.Opt2Name2 = "";
        OrderDetail.prototype.Opt2Name3 = "";
        OrderDetail.prototype.OptID2 = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        OrderDetail.prototype.Opt3Title1 = "";
        OrderDetail.prototype.Opt3Title2 = "";
        OrderDetail.prototype.Opt3Title3 = "";
        OrderDetail.prototype.Opt3Name1 = "";
        OrderDetail.prototype.Opt3Name2 = "";
        OrderDetail.prototype.Opt3Name3 = "";
        OrderDetail.prototype.OptID3 = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        OrderDetail.prototype.GsmName1 = "";
        OrderDetail.prototype.GsmName2 = "";
        OrderDetail.prototype.GsmName3 = "";
        OrderDetail.prototype.CGID = "";
        OrderDetail.prototype.UnitID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        OrderDetail.prototype.UnitName1 = "";
        OrderDetail.prototype.UnitName2 = "";
        OrderDetail.prototype.UnitName3 = "";
        OrderDetail.prototype.QuantityFrom = 0;
        OrderDetail.prototype.BaseQty = 0;
        OrderDetail.prototype.Quantity = 0;
        OrderDetail.prototype.OriQuantity = 0;
        OrderDetail.prototype.CostPrice = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderDetail.prototype.TotalCostPrice = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderDetail.prototype.OriPrice = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderDetail.prototype.IsSale = 0;
        OrderDetail.prototype.SaleRate = 0;
        OrderDetail.prototype.SaleAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderDetail.prototype.Price = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderDetail.prototype.PackingCharge = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderDetail.prototype.PriceCate = 0;
        OrderDetail.prototype.TotalPrice = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderDetail.prototype.TaxablePrice = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderDetail.prototype.IsTax = 0;
        OrderDetail.prototype.TaxAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderDetail.prototype.IsSF = 0;
        OrderDetail.prototype.SFAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderDetail.prototype.TotalAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderDetail.prototype.TotalProfit = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderDetail.prototype.TotalWeight = 0;
        OrderDetail.prototype.ShopState = 0;
        OrderDetail.prototype.IsSO = 0;
        OrderDetail.prototype.IsCS = 0;
        OrderDetail.prototype.QRCode = "";
        OrderDetail.prototype.IsRefund = 0;
        OrderDetail.prototype.RefundQuantity = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderDetail.prototype.RefundAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderDetail.prototype.IsUseStock = 0;
        OrderDetail.prototype.GoodsGrade = 0;
        OrderDetail.prototype.CreateTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderDetail.prototype.CreaterID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        OrderDetail.prototype.UpdateTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderDetail.prototype.UpdaterID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        OrderDetail.prototype.Estate = 0;

        OrderDetail.create = function create(properties) {
            return new OrderDetail(properties);
        };

        OrderDetail.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.DetailID != null && Object.hasOwnProperty.call(m, "DetailID"))
                w.uint32(10).string(m.DetailID);
            if (m.OrderID != null && Object.hasOwnProperty.call(m, "OrderID"))
                w.uint32(18).string(m.OrderID);
            if (m.MchID != null && Object.hasOwnProperty.call(m, "MchID"))
                w.uint32(24).uint64(m.MchID);
            if (m.UserID != null && Object.hasOwnProperty.call(m, "UserID"))
                w.uint32(32).uint64(m.UserID);
            if (m.ReID != null && Object.hasOwnProperty.call(m, "ReID"))
                w.uint32(42).string(m.ReID);
            if (m.SalesCate != null && Object.hasOwnProperty.call(m, "SalesCate"))
                w.uint32(48).int32(m.SalesCate);
            if (m.Category != null && Object.hasOwnProperty.call(m, "Category"))
                w.uint32(56).int32(m.Category);
            if (m.TransDate != null && Object.hasOwnProperty.call(m, "TransDate"))
                w.uint32(64).int64(m.TransDate);
            if (m.Seq != null && Object.hasOwnProperty.call(m, "Seq"))
                w.uint32(72).int32(m.Seq);
            if (m.BelongID != null && Object.hasOwnProperty.call(m, "BelongID"))
                w.uint32(82).string(m.BelongID);
            if (m.GoodsID != null && Object.hasOwnProperty.call(m, "GoodsID"))
                w.uint32(88).uint64(m.GoodsID);
            if (m.GName1 != null && Object.hasOwnProperty.call(m, "GName1"))
                w.uint32(98).string(m.GName1);
            if (m.GName2 != null && Object.hasOwnProperty.call(m, "GName2"))
                w.uint32(106).string(m.GName2);
            if (m.GName3 != null && Object.hasOwnProperty.call(m, "GName3"))
                w.uint32(114).string(m.GName3);
            if (m.GoodsImg != null && Object.hasOwnProperty.call(m, "GoodsImg"))
                w.uint32(122).string(m.GoodsImg);
            if (m.GoodsCategoryID != null && Object.hasOwnProperty.call(m, "GoodsCategoryID"))
                w.uint32(128).uint64(m.GoodsCategoryID);
            if (m.SkuID != null && Object.hasOwnProperty.call(m, "SkuID"))
                w.uint32(138).string(m.SkuID);
            if (m.SpecsID != null && Object.hasOwnProperty.call(m, "SpecsID"))
                w.uint32(144).uint64(m.SpecsID);
            if (m.SpecsName1 != null && Object.hasOwnProperty.call(m, "SpecsName1"))
                w.uint32(154).string(m.SpecsName1);
            if (m.SpecsName2 != null && Object.hasOwnProperty.call(m, "SpecsName2"))
                w.uint32(162).string(m.SpecsName2);
            if (m.SpecsName3 != null && Object.hasOwnProperty.call(m, "SpecsName3"))
                w.uint32(170).string(m.SpecsName3);
            if (m.IsVal != null && Object.hasOwnProperty.call(m, "IsVal"))
                w.uint32(176).int32(m.IsVal);
            if (m.IsGive != null && Object.hasOwnProperty.call(m, "IsGive"))
                w.uint32(184).int32(m.IsGive);
            if (m.SideDishCount != null && Object.hasOwnProperty.call(m, "SideDishCount"))
                w.uint32(192).int32(m.SideDishCount);
            if (m.OriSideDishPrice != null && Object.hasOwnProperty.call(m, "OriSideDishPrice"))
                w.uint32(200).int64(m.OriSideDishPrice);
            if (m.SideDishPrice != null && Object.hasOwnProperty.call(m, "SideDishPrice"))
                w.uint32(208).int64(m.SideDishPrice);
            if (m.SideDishTotalPirce != null && Object.hasOwnProperty.call(m, "SideDishTotalPirce"))
                w.uint32(216).int64(m.SideDishTotalPirce);
            if (m.SideDishCostPrice != null && Object.hasOwnProperty.call(m, "SideDishCostPrice"))
                w.uint32(224).int64(m.SideDishCostPrice);
            if (m.SideDishTotalCostPrice != null && Object.hasOwnProperty.call(m, "SideDishTotalCostPrice"))
                w.uint32(232).int64(m.SideDishTotalCostPrice);
            if (m.Opt1Title1 != null && Object.hasOwnProperty.call(m, "Opt1Title1"))
                w.uint32(242).string(m.Opt1Title1);
            if (m.Opt1Title2 != null && Object.hasOwnProperty.call(m, "Opt1Title2"))
                w.uint32(250).string(m.Opt1Title2);
            if (m.Opt1Title3 != null && Object.hasOwnProperty.call(m, "Opt1Title3"))
                w.uint32(258).string(m.Opt1Title3);
            if (m.Opt1Name1 != null && Object.hasOwnProperty.call(m, "Opt1Name1"))
                w.uint32(266).string(m.Opt1Name1);
            if (m.Opt1Name2 != null && Object.hasOwnProperty.call(m, "Opt1Name2"))
                w.uint32(274).string(m.Opt1Name2);
            if (m.Opt1Name3 != null && Object.hasOwnProperty.call(m, "Opt1Name3"))
                w.uint32(282).string(m.Opt1Name3);
            if (m.OptID1 != null && Object.hasOwnProperty.call(m, "OptID1"))
                w.uint32(288).uint64(m.OptID1);
            if (m.Opt2Title1 != null && Object.hasOwnProperty.call(m, "Opt2Title1"))
                w.uint32(298).string(m.Opt2Title1);
            if (m.Opt2Title2 != null && Object.hasOwnProperty.call(m, "Opt2Title2"))
                w.uint32(306).string(m.Opt2Title2);
            if (m.Opt2Title3 != null && Object.hasOwnProperty.call(m, "Opt2Title3"))
                w.uint32(314).string(m.Opt2Title3);
            if (m.Opt2Name1 != null && Object.hasOwnProperty.call(m, "Opt2Name1"))
                w.uint32(322).string(m.Opt2Name1);
            if (m.Opt2Name2 != null && Object.hasOwnProperty.call(m, "Opt2Name2"))
                w.uint32(330).string(m.Opt2Name2);
            if (m.Opt2Name3 != null && Object.hasOwnProperty.call(m, "Opt2Name3"))
                w.uint32(338).string(m.Opt2Name3);
            if (m.OptID2 != null && Object.hasOwnProperty.call(m, "OptID2"))
                w.uint32(344).uint64(m.OptID2);
            if (m.Opt3Title1 != null && Object.hasOwnProperty.call(m, "Opt3Title1"))
                w.uint32(354).string(m.Opt3Title1);
            if (m.Opt3Title2 != null && Object.hasOwnProperty.call(m, "Opt3Title2"))
                w.uint32(362).string(m.Opt3Title2);
            if (m.Opt3Title3 != null && Object.hasOwnProperty.call(m, "Opt3Title3"))
                w.uint32(370).string(m.Opt3Title3);
            if (m.Opt3Name1 != null && Object.hasOwnProperty.call(m, "Opt3Name1"))
                w.uint32(378).string(m.Opt3Name1);
            if (m.Opt3Name2 != null && Object.hasOwnProperty.call(m, "Opt3Name2"))
                w.uint32(386).string(m.Opt3Name2);
            if (m.Opt3Name3 != null && Object.hasOwnProperty.call(m, "Opt3Name3"))
                w.uint32(394).string(m.Opt3Name3);
            if (m.OptID3 != null && Object.hasOwnProperty.call(m, "OptID3"))
                w.uint32(400).uint64(m.OptID3);
            if (m.GsmName1 != null && Object.hasOwnProperty.call(m, "GsmName1"))
                w.uint32(410).string(m.GsmName1);
            if (m.GsmName2 != null && Object.hasOwnProperty.call(m, "GsmName2"))
                w.uint32(418).string(m.GsmName2);
            if (m.GsmName3 != null && Object.hasOwnProperty.call(m, "GsmName3"))
                w.uint32(426).string(m.GsmName3);
            if (m.CGID != null && Object.hasOwnProperty.call(m, "CGID"))
                w.uint32(434).string(m.CGID);
            if (m.UnitID != null && Object.hasOwnProperty.call(m, "UnitID"))
                w.uint32(440).uint64(m.UnitID);
            if (m.UnitName1 != null && Object.hasOwnProperty.call(m, "UnitName1"))
                w.uint32(450).string(m.UnitName1);
            if (m.UnitName2 != null && Object.hasOwnProperty.call(m, "UnitName2"))
                w.uint32(458).string(m.UnitName2);
            if (m.UnitName3 != null && Object.hasOwnProperty.call(m, "UnitName3"))
                w.uint32(466).string(m.UnitName3);
            if (m.QuantityFrom != null && Object.hasOwnProperty.call(m, "QuantityFrom"))
                w.uint32(472).int32(m.QuantityFrom);
            if (m.BaseQty != null && Object.hasOwnProperty.call(m, "BaseQty"))
                w.uint32(481).double(m.BaseQty);
            if (m.Quantity != null && Object.hasOwnProperty.call(m, "Quantity"))
                w.uint32(489).double(m.Quantity);
            if (m.OriQuantity != null && Object.hasOwnProperty.call(m, "OriQuantity"))
                w.uint32(497).double(m.OriQuantity);
            if (m.CostPrice != null && Object.hasOwnProperty.call(m, "CostPrice"))
                w.uint32(504).int64(m.CostPrice);
            if (m.TotalCostPrice != null && Object.hasOwnProperty.call(m, "TotalCostPrice"))
                w.uint32(512).int64(m.TotalCostPrice);
            if (m.OriPrice != null && Object.hasOwnProperty.call(m, "OriPrice"))
                w.uint32(520).int64(m.OriPrice);
            if (m.IsSale != null && Object.hasOwnProperty.call(m, "IsSale"))
                w.uint32(528).int32(m.IsSale);
            if (m.SaleRate != null && Object.hasOwnProperty.call(m, "SaleRate"))
                w.uint32(536).int32(m.SaleRate);
            if (m.SaleAmt != null && Object.hasOwnProperty.call(m, "SaleAmt"))
                w.uint32(544).int64(m.SaleAmt);
            if (m.Price != null && Object.hasOwnProperty.call(m, "Price"))
                w.uint32(552).int64(m.Price);
            if (m.PackingCharge != null && Object.hasOwnProperty.call(m, "PackingCharge"))
                w.uint32(560).int64(m.PackingCharge);
            if (m.PriceCate != null && Object.hasOwnProperty.call(m, "PriceCate"))
                w.uint32(568).int32(m.PriceCate);
            if (m.TotalPrice != null && Object.hasOwnProperty.call(m, "TotalPrice"))
                w.uint32(576).int64(m.TotalPrice);
            if (m.TaxablePrice != null && Object.hasOwnProperty.call(m, "TaxablePrice"))
                w.uint32(584).int64(m.TaxablePrice);
            if (m.IsTax != null && Object.hasOwnProperty.call(m, "IsTax"))
                w.uint32(592).int32(m.IsTax);
            if (m.TaxAmt != null && Object.hasOwnProperty.call(m, "TaxAmt"))
                w.uint32(600).int64(m.TaxAmt);
            if (m.IsSF != null && Object.hasOwnProperty.call(m, "IsSF"))
                w.uint32(608).int32(m.IsSF);
            if (m.SFAmt != null && Object.hasOwnProperty.call(m, "SFAmt"))
                w.uint32(616).int64(m.SFAmt);
            if (m.TotalAmt != null && Object.hasOwnProperty.call(m, "TotalAmt"))
                w.uint32(624).int64(m.TotalAmt);
            if (m.TotalProfit != null && Object.hasOwnProperty.call(m, "TotalProfit"))
                w.uint32(632).int64(m.TotalProfit);
            if (m.TotalWeight != null && Object.hasOwnProperty.call(m, "TotalWeight"))
                w.uint32(641).double(m.TotalWeight);
            if (m.ShopState != null && Object.hasOwnProperty.call(m, "ShopState"))
                w.uint32(648).int32(m.ShopState);
            if (m.IsSO != null && Object.hasOwnProperty.call(m, "IsSO"))
                w.uint32(656).int32(m.IsSO);
            if (m.IsCS != null && Object.hasOwnProperty.call(m, "IsCS"))
                w.uint32(664).int32(m.IsCS);
            if (m.QRCode != null && Object.hasOwnProperty.call(m, "QRCode"))
                w.uint32(674).string(m.QRCode);
            if (m.IsRefund != null && Object.hasOwnProperty.call(m, "IsRefund"))
                w.uint32(680).int32(m.IsRefund);
            if (m.RefundQuantity != null && Object.hasOwnProperty.call(m, "RefundQuantity"))
                w.uint32(688).int64(m.RefundQuantity);
            if (m.RefundAmt != null && Object.hasOwnProperty.call(m, "RefundAmt"))
                w.uint32(696).int64(m.RefundAmt);
            if (m.IsUseStock != null && Object.hasOwnProperty.call(m, "IsUseStock"))
                w.uint32(704).int32(m.IsUseStock);
            if (m.GoodsGrade != null && Object.hasOwnProperty.call(m, "GoodsGrade"))
                w.uint32(712).int32(m.GoodsGrade);
            if (m.CreateTime != null && Object.hasOwnProperty.call(m, "CreateTime"))
                w.uint32(720).int64(m.CreateTime);
            if (m.CreaterID != null && Object.hasOwnProperty.call(m, "CreaterID"))
                w.uint32(728).uint64(m.CreaterID);
            if (m.UpdateTime != null && Object.hasOwnProperty.call(m, "UpdateTime"))
                w.uint32(736).int64(m.UpdateTime);
            if (m.UpdaterID != null && Object.hasOwnProperty.call(m, "UpdaterID"))
                w.uint32(744).uint64(m.UpdaterID);
            if (m.Estate != null && Object.hasOwnProperty.call(m, "Estate"))
                w.uint32(752).int32(m.Estate);
            return w;
        };

        OrderDetail.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.OrderDetail();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        m.DetailID = r.string();
                        break;
                    }
                    case 2: {
                        m.OrderID = r.string();
                        break;
                    }
                    case 3: {
                        m.MchID = r.uint64();
                        break;
                    }
                    case 4: {
                        m.UserID = r.uint64();
                        break;
                    }
                    case 5: {
                        m.ReID = r.string();
                        break;
                    }
                    case 6: {
                        m.SalesCate = r.int32();
                        break;
                    }
                    case 7: {
                        m.Category = r.int32();
                        break;
                    }
                    case 8: {
                        m.TransDate = r.int64();
                        break;
                    }
                    case 9: {
                        m.Seq = r.int32();
                        break;
                    }
                    case 10: {
                        m.BelongID = r.string();
                        break;
                    }
                    case 11: {
                        m.GoodsID = r.uint64();
                        break;
                    }
                    case 12: {
                        m.GName1 = r.string();
                        break;
                    }
                    case 13: {
                        m.GName2 = r.string();
                        break;
                    }
                    case 14: {
                        m.GName3 = r.string();
                        break;
                    }
                    case 15: {
                        m.GoodsImg = r.string();
                        break;
                    }
                    case 16: {
                        m.GoodsCategoryID = r.uint64();
                        break;
                    }
                    case 17: {
                        m.SkuID = r.string();
                        break;
                    }
                    case 18: {
                        m.SpecsID = r.uint64();
                        break;
                    }
                    case 19: {
                        m.SpecsName1 = r.string();
                        break;
                    }
                    case 20: {
                        m.SpecsName2 = r.string();
                        break;
                    }
                    case 21: {
                        m.SpecsName3 = r.string();
                        break;
                    }
                    case 22: {
                        m.IsVal = r.int32();
                        break;
                    }
                    case 23: {
                        m.IsGive = r.int32();
                        break;
                    }
                    case 24: {
                        m.SideDishCount = r.int32();
                        break;
                    }
                    case 25: {
                        m.OriSideDishPrice = r.int64();
                        break;
                    }
                    case 26: {
                        m.SideDishPrice = r.int64();
                        break;
                    }
                    case 27: {
                        m.SideDishTotalPirce = r.int64();
                        break;
                    }
                    case 28: {
                        m.SideDishCostPrice = r.int64();
                        break;
                    }
                    case 29: {
                        m.SideDishTotalCostPrice = r.int64();
                        break;
                    }
                    case 30: {
                        m.Opt1Title1 = r.string();
                        break;
                    }
                    case 31: {
                        m.Opt1Title2 = r.string();
                        break;
                    }
                    case 32: {
                        m.Opt1Title3 = r.string();
                        break;
                    }
                    case 33: {
                        m.Opt1Name1 = r.string();
                        break;
                    }
                    case 34: {
                        m.Opt1Name2 = r.string();
                        break;
                    }
                    case 35: {
                        m.Opt1Name3 = r.string();
                        break;
                    }
                    case 36: {
                        m.OptID1 = r.uint64();
                        break;
                    }
                    case 37: {
                        m.Opt2Title1 = r.string();
                        break;
                    }
                    case 38: {
                        m.Opt2Title2 = r.string();
                        break;
                    }
                    case 39: {
                        m.Opt2Title3 = r.string();
                        break;
                    }
                    case 40: {
                        m.Opt2Name1 = r.string();
                        break;
                    }
                    case 41: {
                        m.Opt2Name2 = r.string();
                        break;
                    }
                    case 42: {
                        m.Opt2Name3 = r.string();
                        break;
                    }
                    case 43: {
                        m.OptID2 = r.uint64();
                        break;
                    }
                    case 44: {
                        m.Opt3Title1 = r.string();
                        break;
                    }
                    case 45: {
                        m.Opt3Title2 = r.string();
                        break;
                    }
                    case 46: {
                        m.Opt3Title3 = r.string();
                        break;
                    }
                    case 47: {
                        m.Opt3Name1 = r.string();
                        break;
                    }
                    case 48: {
                        m.Opt3Name2 = r.string();
                        break;
                    }
                    case 49: {
                        m.Opt3Name3 = r.string();
                        break;
                    }
                    case 50: {
                        m.OptID3 = r.uint64();
                        break;
                    }
                    case 51: {
                        m.GsmName1 = r.string();
                        break;
                    }
                    case 52: {
                        m.GsmName2 = r.string();
                        break;
                    }
                    case 53: {
                        m.GsmName3 = r.string();
                        break;
                    }
                    case 54: {
                        m.CGID = r.string();
                        break;
                    }
                    case 55: {
                        m.UnitID = r.uint64();
                        break;
                    }
                    case 56: {
                        m.UnitName1 = r.string();
                        break;
                    }
                    case 57: {
                        m.UnitName2 = r.string();
                        break;
                    }
                    case 58: {
                        m.UnitName3 = r.string();
                        break;
                    }
                    case 59: {
                        m.QuantityFrom = r.int32();
                        break;
                    }
                    case 60: {
                        m.BaseQty = r.double();
                        break;
                    }
                    case 61: {
                        m.Quantity = r.double();
                        break;
                    }
                    case 62: {
                        m.OriQuantity = r.double();
                        break;
                    }
                    case 63: {
                        m.CostPrice = r.int64();
                        break;
                    }
                    case 64: {
                        m.TotalCostPrice = r.int64();
                        break;
                    }
                    case 65: {
                        m.OriPrice = r.int64();
                        break;
                    }
                    case 66: {
                        m.IsSale = r.int32();
                        break;
                    }
                    case 67: {
                        m.SaleRate = r.int32();
                        break;
                    }
                    case 68: {
                        m.SaleAmt = r.int64();
                        break;
                    }
                    case 69: {
                        m.Price = r.int64();
                        break;
                    }
                    case 70: {
                        m.PackingCharge = r.int64();
                        break;
                    }
                    case 71: {
                        m.PriceCate = r.int32();
                        break;
                    }
                    case 72: {
                        m.TotalPrice = r.int64();
                        break;
                    }
                    case 73: {
                        m.TaxablePrice = r.int64();
                        break;
                    }
                    case 74: {
                        m.IsTax = r.int32();
                        break;
                    }
                    case 75: {
                        m.TaxAmt = r.int64();
                        break;
                    }
                    case 76: {
                        m.IsSF = r.int32();
                        break;
                    }
                    case 77: {
                        m.SFAmt = r.int64();
                        break;
                    }
                    case 78: {
                        m.TotalAmt = r.int64();
                        break;
                    }
                    case 79: {
                        m.TotalProfit = r.int64();
                        break;
                    }
                    case 80: {
                        m.TotalWeight = r.double();
                        break;
                    }
                    case 81: {
                        m.ShopState = r.int32();
                        break;
                    }
                    case 82: {
                        m.IsSO = r.int32();
                        break;
                    }
                    case 83: {
                        m.IsCS = r.int32();
                        break;
                    }
                    case 84: {
                        m.QRCode = r.string();
                        break;
                    }
                    case 85: {
                        m.IsRefund = r.int32();
                        break;
                    }
                    case 86: {
                        m.RefundQuantity = r.int64();
                        break;
                    }
                    case 87: {
                        m.RefundAmt = r.int64();
                        break;
                    }
                    case 88: {
                        m.IsUseStock = r.int32();
                        break;
                    }
                    case 89: {
                        m.GoodsGrade = r.int32();
                        break;
                    }
                    case 90: {
                        m.CreateTime = r.int64();
                        break;
                    }
                    case 91: {
                        m.CreaterID = r.uint64();
                        break;
                    }
                    case 92: {
                        m.UpdateTime = r.int64();
                        break;
                    }
                    case 93: {
                        m.UpdaterID = r.uint64();
                        break;
                    }
                    case 94: {
                        m.Estate = r.int32();
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        OrderDetail.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.OrderDetail";
        };

        return OrderDetail;
    })();

    PBEntity.OrderDetails = (function () {

        function OrderDetails(p) {
            this.OrderDetails = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        OrderDetails.prototype.OrderDetails = $util.emptyArray;

        OrderDetails.create = function create(properties) {
            return new OrderDetails(properties);
        };

        OrderDetails.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.OrderDetails != null && m.OrderDetails.length) {
                for (var i = 0; i < m.OrderDetails.length; ++i)
                    $root.PBEntity.OrderDetail.encode(m.OrderDetails[i], w.uint32(10).fork()).ldelim();
            }
            return w;
        };

        OrderDetails.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.OrderDetails();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        if (!(m.OrderDetails && m.OrderDetails.length))
                            m.OrderDetails = [];
                        m.OrderDetails.push($root.PBEntity.OrderDetail.decode(r, r.uint32()));
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        OrderDetails.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.OrderDetails";
        };

        return OrderDetails;
    })();

    PBEntity.OrderEmpNotice = (function () {

        function OrderEmpNotice(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        OrderEmpNotice.prototype.ID = "";
        OrderEmpNotice.prototype.NoticeCate = 0;
        OrderEmpNotice.prototype.MchID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        OrderEmpNotice.prototype.UserID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        OrderEmpNotice.prototype.ReID = "";
        OrderEmpNotice.prototype.ReIDCate = 0;
        OrderEmpNotice.prototype.DistrMode = 0;
        OrderEmpNotice.prototype.SendTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderEmpNotice.prototype.IsWX = 0;
        OrderEmpNotice.prototype.IsWin = 0;
        OrderEmpNotice.prototype.IsMerge = 0;
        OrderEmpNotice.prototype.NoticeResult = 0;
        OrderEmpNotice.prototype.NoticeOrderID = "";
        OrderEmpNotice.prototype.CreateTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderEmpNotice.prototype.CreaterID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        OrderEmpNotice.prototype.UpdateTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderEmpNotice.prototype.UpdaterID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        OrderEmpNotice.prototype.Estate = 0;

        OrderEmpNotice.create = function create(properties) {
            return new OrderEmpNotice(properties);
        };

        OrderEmpNotice.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.ID != null && Object.hasOwnProperty.call(m, "ID"))
                w.uint32(10).string(m.ID);
            if (m.NoticeCate != null && Object.hasOwnProperty.call(m, "NoticeCate"))
                w.uint32(16).int32(m.NoticeCate);
            if (m.MchID != null && Object.hasOwnProperty.call(m, "MchID"))
                w.uint32(24).uint64(m.MchID);
            if (m.UserID != null && Object.hasOwnProperty.call(m, "UserID"))
                w.uint32(32).uint64(m.UserID);
            if (m.ReID != null && Object.hasOwnProperty.call(m, "ReID"))
                w.uint32(42).string(m.ReID);
            if (m.ReIDCate != null && Object.hasOwnProperty.call(m, "ReIDCate"))
                w.uint32(48).int32(m.ReIDCate);
            if (m.DistrMode != null && Object.hasOwnProperty.call(m, "DistrMode"))
                w.uint32(56).int32(m.DistrMode);
            if (m.SendTime != null && Object.hasOwnProperty.call(m, "SendTime"))
                w.uint32(64).int64(m.SendTime);
            if (m.IsWX != null && Object.hasOwnProperty.call(m, "IsWX"))
                w.uint32(72).int32(m.IsWX);
            if (m.IsWin != null && Object.hasOwnProperty.call(m, "IsWin"))
                w.uint32(80).int32(m.IsWin);
            if (m.IsMerge != null && Object.hasOwnProperty.call(m, "IsMerge"))
                w.uint32(88).int32(m.IsMerge);
            if (m.NoticeResult != null && Object.hasOwnProperty.call(m, "NoticeResult"))
                w.uint32(96).int32(m.NoticeResult);
            if (m.NoticeOrderID != null && Object.hasOwnProperty.call(m, "NoticeOrderID"))
                w.uint32(106).string(m.NoticeOrderID);
            if (m.CreateTime != null && Object.hasOwnProperty.call(m, "CreateTime"))
                w.uint32(112).int64(m.CreateTime);
            if (m.CreaterID != null && Object.hasOwnProperty.call(m, "CreaterID"))
                w.uint32(120).uint64(m.CreaterID);
            if (m.UpdateTime != null && Object.hasOwnProperty.call(m, "UpdateTime"))
                w.uint32(128).int64(m.UpdateTime);
            if (m.UpdaterID != null && Object.hasOwnProperty.call(m, "UpdaterID"))
                w.uint32(136).uint64(m.UpdaterID);
            if (m.Estate != null && Object.hasOwnProperty.call(m, "Estate"))
                w.uint32(144).int32(m.Estate);
            return w;
        };

        OrderEmpNotice.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.OrderEmpNotice();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        m.ID = r.string();
                        break;
                    }
                    case 2: {
                        m.NoticeCate = r.int32();
                        break;
                    }
                    case 3: {
                        m.MchID = r.uint64();
                        break;
                    }
                    case 4: {
                        m.UserID = r.uint64();
                        break;
                    }
                    case 5: {
                        m.ReID = r.string();
                        break;
                    }
                    case 6: {
                        m.ReIDCate = r.int32();
                        break;
                    }
                    case 7: {
                        m.DistrMode = r.int32();
                        break;
                    }
                    case 8: {
                        m.SendTime = r.int64();
                        break;
                    }
                    case 9: {
                        m.IsWX = r.int32();
                        break;
                    }
                    case 10: {
                        m.IsWin = r.int32();
                        break;
                    }
                    case 11: {
                        m.IsMerge = r.int32();
                        break;
                    }
                    case 12: {
                        m.NoticeResult = r.int32();
                        break;
                    }
                    case 13: {
                        m.NoticeOrderID = r.string();
                        break;
                    }
                    case 14: {
                        m.CreateTime = r.int64();
                        break;
                    }
                    case 15: {
                        m.CreaterID = r.uint64();
                        break;
                    }
                    case 16: {
                        m.UpdateTime = r.int64();
                        break;
                    }
                    case 17: {
                        m.UpdaterID = r.uint64();
                        break;
                    }
                    case 18: {
                        m.Estate = r.int32();
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        OrderEmpNotice.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.OrderEmpNotice";
        };

        return OrderEmpNotice;
    })();

    PBEntity.OrderEmpNotices = (function () {

        function OrderEmpNotices(p) {
            this.OrderEmpNotices = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        OrderEmpNotices.prototype.OrderEmpNotices = $util.emptyArray;

        OrderEmpNotices.create = function create(properties) {
            return new OrderEmpNotices(properties);
        };

        OrderEmpNotices.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.OrderEmpNotices != null && m.OrderEmpNotices.length) {
                for (var i = 0; i < m.OrderEmpNotices.length; ++i)
                    $root.PBEntity.OrderEmpNotice.encode(m.OrderEmpNotices[i], w.uint32(10).fork()).ldelim();
            }
            return w;
        };

        OrderEmpNotices.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.OrderEmpNotices();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        if (!(m.OrderEmpNotices && m.OrderEmpNotices.length))
                            m.OrderEmpNotices = [];
                        m.OrderEmpNotices.push($root.PBEntity.OrderEmpNotice.decode(r, r.uint32()));
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        OrderEmpNotices.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.OrderEmpNotices";
        };

        return OrderEmpNotices;
    })();

    PBEntity.OrderEvaluate = (function () {

        function OrderEvaluate(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        OrderEvaluate.prototype.OrderNo = "";
        OrderEvaluate.prototype.MchID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        OrderEvaluate.prototype.UserID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        OrderEvaluate.prototype.UUID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        OrderEvaluate.prototype.SaleSeq = 0;
        OrderEvaluate.prototype.SeqCode = "";
        OrderEvaluate.prototype.SaleNo = "";
        OrderEvaluate.prototype.DistrMode = 0;
        OrderEvaluate.prototype.TakeMode = 0;
        OrderEvaluate.prototype.Grade = 0;
        OrderEvaluate.prototype.Notes = "";
        OrderEvaluate.prototype.IsImg = 0;
        OrderEvaluate.prototype.ImageID = "";
        OrderEvaluate.prototype.EvaluateState = 0;
        OrderEvaluate.prototype.ReplyNotes = "";
        OrderEvaluate.prototype.ReplyIsImg = 0;
        OrderEvaluate.prototype.ReplyImageID = "";
        OrderEvaluate.prototype.ReplyTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderEvaluate.prototype.ReplyUserID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        OrderEvaluate.prototype.ReplyUserName = "";
        OrderEvaluate.prototype.IsPublic = 0;
        OrderEvaluate.prototype.CreateTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderEvaluate.prototype.CreaterID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        OrderEvaluate.prototype.UpdateTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderEvaluate.prototype.UpdaterID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        OrderEvaluate.prototype.Estate = 0;

        OrderEvaluate.create = function create(properties) {
            return new OrderEvaluate(properties);
        };

        OrderEvaluate.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.OrderNo != null && Object.hasOwnProperty.call(m, "OrderNo"))
                w.uint32(10).string(m.OrderNo);
            if (m.MchID != null && Object.hasOwnProperty.call(m, "MchID"))
                w.uint32(16).uint64(m.MchID);
            if (m.UserID != null && Object.hasOwnProperty.call(m, "UserID"))
                w.uint32(24).uint64(m.UserID);
            if (m.UUID != null && Object.hasOwnProperty.call(m, "UUID"))
                w.uint32(32).uint64(m.UUID);
            if (m.SaleSeq != null && Object.hasOwnProperty.call(m, "SaleSeq"))
                w.uint32(40).int32(m.SaleSeq);
            if (m.SeqCode != null && Object.hasOwnProperty.call(m, "SeqCode"))
                w.uint32(50).string(m.SeqCode);
            if (m.SaleNo != null && Object.hasOwnProperty.call(m, "SaleNo"))
                w.uint32(58).string(m.SaleNo);
            if (m.DistrMode != null && Object.hasOwnProperty.call(m, "DistrMode"))
                w.uint32(64).int32(m.DistrMode);
            if (m.TakeMode != null && Object.hasOwnProperty.call(m, "TakeMode"))
                w.uint32(72).int32(m.TakeMode);
            if (m.Grade != null && Object.hasOwnProperty.call(m, "Grade"))
                w.uint32(80).int32(m.Grade);
            if (m.Notes != null && Object.hasOwnProperty.call(m, "Notes"))
                w.uint32(90).string(m.Notes);
            if (m.IsImg != null && Object.hasOwnProperty.call(m, "IsImg"))
                w.uint32(96).int32(m.IsImg);
            if (m.ImageID != null && Object.hasOwnProperty.call(m, "ImageID"))
                w.uint32(106).string(m.ImageID);
            if (m.EvaluateState != null && Object.hasOwnProperty.call(m, "EvaluateState"))
                w.uint32(112).int32(m.EvaluateState);
            if (m.ReplyNotes != null && Object.hasOwnProperty.call(m, "ReplyNotes"))
                w.uint32(122).string(m.ReplyNotes);
            if (m.ReplyIsImg != null && Object.hasOwnProperty.call(m, "ReplyIsImg"))
                w.uint32(128).int32(m.ReplyIsImg);
            if (m.ReplyImageID != null && Object.hasOwnProperty.call(m, "ReplyImageID"))
                w.uint32(138).string(m.ReplyImageID);
            if (m.ReplyTime != null && Object.hasOwnProperty.call(m, "ReplyTime"))
                w.uint32(144).int64(m.ReplyTime);
            if (m.ReplyUserID != null && Object.hasOwnProperty.call(m, "ReplyUserID"))
                w.uint32(152).uint64(m.ReplyUserID);
            if (m.ReplyUserName != null && Object.hasOwnProperty.call(m, "ReplyUserName"))
                w.uint32(162).string(m.ReplyUserName);
            if (m.IsPublic != null && Object.hasOwnProperty.call(m, "IsPublic"))
                w.uint32(168).int32(m.IsPublic);
            if (m.CreateTime != null && Object.hasOwnProperty.call(m, "CreateTime"))
                w.uint32(176).int64(m.CreateTime);
            if (m.CreaterID != null && Object.hasOwnProperty.call(m, "CreaterID"))
                w.uint32(184).uint64(m.CreaterID);
            if (m.UpdateTime != null && Object.hasOwnProperty.call(m, "UpdateTime"))
                w.uint32(192).int64(m.UpdateTime);
            if (m.UpdaterID != null && Object.hasOwnProperty.call(m, "UpdaterID"))
                w.uint32(200).uint64(m.UpdaterID);
            if (m.Estate != null && Object.hasOwnProperty.call(m, "Estate"))
                w.uint32(208).int32(m.Estate);
            return w;
        };

        OrderEvaluate.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.OrderEvaluate();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        m.OrderNo = r.string();
                        break;
                    }
                    case 2: {
                        m.MchID = r.uint64();
                        break;
                    }
                    case 3: {
                        m.UserID = r.uint64();
                        break;
                    }
                    case 4: {
                        m.UUID = r.uint64();
                        break;
                    }
                    case 5: {
                        m.SaleSeq = r.int32();
                        break;
                    }
                    case 6: {
                        m.SeqCode = r.string();
                        break;
                    }
                    case 7: {
                        m.SaleNo = r.string();
                        break;
                    }
                    case 8: {
                        m.DistrMode = r.int32();
                        break;
                    }
                    case 9: {
                        m.TakeMode = r.int32();
                        break;
                    }
                    case 10: {
                        m.Grade = r.int32();
                        break;
                    }
                    case 11: {
                        m.Notes = r.string();
                        break;
                    }
                    case 12: {
                        m.IsImg = r.int32();
                        break;
                    }
                    case 13: {
                        m.ImageID = r.string();
                        break;
                    }
                    case 14: {
                        m.EvaluateState = r.int32();
                        break;
                    }
                    case 15: {
                        m.ReplyNotes = r.string();
                        break;
                    }
                    case 16: {
                        m.ReplyIsImg = r.int32();
                        break;
                    }
                    case 17: {
                        m.ReplyImageID = r.string();
                        break;
                    }
                    case 18: {
                        m.ReplyTime = r.int64();
                        break;
                    }
                    case 19: {
                        m.ReplyUserID = r.uint64();
                        break;
                    }
                    case 20: {
                        m.ReplyUserName = r.string();
                        break;
                    }
                    case 21: {
                        m.IsPublic = r.int32();
                        break;
                    }
                    case 22: {
                        m.CreateTime = r.int64();
                        break;
                    }
                    case 23: {
                        m.CreaterID = r.uint64();
                        break;
                    }
                    case 24: {
                        m.UpdateTime = r.int64();
                        break;
                    }
                    case 25: {
                        m.UpdaterID = r.uint64();
                        break;
                    }
                    case 26: {
                        m.Estate = r.int32();
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        OrderEvaluate.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.OrderEvaluate";
        };

        return OrderEvaluate;
    })();

    PBEntity.OrderEvaluates = (function () {

        function OrderEvaluates(p) {
            this.OrderEvaluates = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        OrderEvaluates.prototype.OrderEvaluates = $util.emptyArray;

        OrderEvaluates.create = function create(properties) {
            return new OrderEvaluates(properties);
        };

        OrderEvaluates.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.OrderEvaluates != null && m.OrderEvaluates.length) {
                for (var i = 0; i < m.OrderEvaluates.length; ++i)
                    $root.PBEntity.OrderEvaluate.encode(m.OrderEvaluates[i], w.uint32(10).fork()).ldelim();
            }
            return w;
        };

        OrderEvaluates.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.OrderEvaluates();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        if (!(m.OrderEvaluates && m.OrderEvaluates.length))
                            m.OrderEvaluates = [];
                        m.OrderEvaluates.push($root.PBEntity.OrderEvaluate.decode(r, r.uint32()));
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        OrderEvaluates.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.OrderEvaluates";
        };

        return OrderEvaluates;
    })();

    PBEntity.OrderPayment = (function () {

        function OrderPayment(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        OrderPayment.prototype.OrderPayID = "";
        OrderPayment.prototype.MchID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        OrderPayment.prototype.TransDate = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderPayment.prototype.Category = 0;
        OrderPayment.prototype.UserID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        OrderPayment.prototype.UserCate = 0;
        OrderPayment.prototype.UserName = "";
        OrderPayment.prototype.DistrMode = 0;
        OrderPayment.prototype.TakeMode = 0;
        OrderPayment.prototype.FristOrderNo = "";
        OrderPayment.prototype.OrderCount = 0;
        OrderPayment.prototype.ORTitle = "";
        OrderPayment.prototype.LinkAddr = "";
        OrderPayment.prototype.DeskID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        OrderPayment.prototype.TakePointID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        OrderPayment.prototype.ReID = "";
        OrderPayment.prototype.ReIDCate = 0;
        OrderPayment.prototype.TotalRevenueAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderPayment.prototype.IsMakeUp = 0;
        OrderPayment.prototype.MakeUpAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderPayment.prototype.IsAdj = 0;
        OrderPayment.prototype.AdjAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderPayment.prototype.ToAccUserID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        OrderPayment.prototype.IsUsePoints = 0;
        OrderPayment.prototype.UsePoints = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderPayment.prototype.UsePointsRate = 0;
        OrderPayment.prototype.UsePointsAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderPayment.prototype.IsTax = 0;
        OrderPayment.prototype.TaxAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderPayment.prototype.TotalReceiptAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderPayment.prototype.NetWorthAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderPayment.prototype.IsUseAdvAmt = 0;
        OrderPayment.prototype.UseAdvAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderPayment.prototype.IsUseCash = 0;
        OrderPayment.prototype.UseCashAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderPayment.prototype.IsOfPay = 0;
        OrderPayment.prototype.PayChannel = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderPayment.prototype.PayPlatform = 0;
        OrderPayment.prototype.PayAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderPayment.prototype.PayState = 0;
        OrderPayment.prototype.PayTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderPayment.prototype.PayRetAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderPayment.prototype.PayRetTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderPayment.prototype.SeqCodeList = "";
        OrderPayment.prototype.PayID = "";
        OrderPayment.prototype.Notes = "";
        OrderPayment.prototype.CheckState = 0;
        OrderPayment.prototype.IsPayPrint = 0;
        OrderPayment.prototype.PayPrintCount = 0;
        OrderPayment.prototype.ObtainPointsRate = 0;
        OrderPayment.prototype.ObtainPoints = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderPayment.prototype.RefundCount = 0;
        OrderPayment.prototype.RefundTotalAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderPayment.prototype.FromTokeID = "";
        OrderPayment.prototype.FromIP = "";
        OrderPayment.prototype.HashOID = "";
        OrderPayment.prototype.GroupID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        OrderPayment.prototype.CreateTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderPayment.prototype.CreaterID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        OrderPayment.prototype.UpdateTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderPayment.prototype.UpdaterID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        OrderPayment.prototype.Estate = 0;

        OrderPayment.create = function create(properties) {
            return new OrderPayment(properties);
        };

        OrderPayment.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.OrderPayID != null && Object.hasOwnProperty.call(m, "OrderPayID"))
                w.uint32(10).string(m.OrderPayID);
            if (m.MchID != null && Object.hasOwnProperty.call(m, "MchID"))
                w.uint32(16).uint64(m.MchID);
            if (m.TransDate != null && Object.hasOwnProperty.call(m, "TransDate"))
                w.uint32(24).int64(m.TransDate);
            if (m.Category != null && Object.hasOwnProperty.call(m, "Category"))
                w.uint32(32).int32(m.Category);
            if (m.UserID != null && Object.hasOwnProperty.call(m, "UserID"))
                w.uint32(40).uint64(m.UserID);
            if (m.UserCate != null && Object.hasOwnProperty.call(m, "UserCate"))
                w.uint32(48).int32(m.UserCate);
            if (m.UserName != null && Object.hasOwnProperty.call(m, "UserName"))
                w.uint32(58).string(m.UserName);
            if (m.DistrMode != null && Object.hasOwnProperty.call(m, "DistrMode"))
                w.uint32(64).int32(m.DistrMode);
            if (m.TakeMode != null && Object.hasOwnProperty.call(m, "TakeMode"))
                w.uint32(72).int32(m.TakeMode);
            if (m.FristOrderNo != null && Object.hasOwnProperty.call(m, "FristOrderNo"))
                w.uint32(82).string(m.FristOrderNo);
            if (m.OrderCount != null && Object.hasOwnProperty.call(m, "OrderCount"))
                w.uint32(88).int32(m.OrderCount);
            if (m.ORTitle != null && Object.hasOwnProperty.call(m, "ORTitle"))
                w.uint32(98).string(m.ORTitle);
            if (m.LinkAddr != null && Object.hasOwnProperty.call(m, "LinkAddr"))
                w.uint32(106).string(m.LinkAddr);
            if (m.DeskID != null && Object.hasOwnProperty.call(m, "DeskID"))
                w.uint32(112).uint64(m.DeskID);
            if (m.TakePointID != null && Object.hasOwnProperty.call(m, "TakePointID"))
                w.uint32(120).uint64(m.TakePointID);
            if (m.ReID != null && Object.hasOwnProperty.call(m, "ReID"))
                w.uint32(130).string(m.ReID);
            if (m.ReIDCate != null && Object.hasOwnProperty.call(m, "ReIDCate"))
                w.uint32(136).int32(m.ReIDCate);
            if (m.TotalRevenueAmt != null && Object.hasOwnProperty.call(m, "TotalRevenueAmt"))
                w.uint32(144).int64(m.TotalRevenueAmt);
            if (m.IsMakeUp != null && Object.hasOwnProperty.call(m, "IsMakeUp"))
                w.uint32(152).int32(m.IsMakeUp);
            if (m.MakeUpAmt != null && Object.hasOwnProperty.call(m, "MakeUpAmt"))
                w.uint32(160).int64(m.MakeUpAmt);
            if (m.IsAdj != null && Object.hasOwnProperty.call(m, "IsAdj"))
                w.uint32(168).int32(m.IsAdj);
            if (m.AdjAmt != null && Object.hasOwnProperty.call(m, "AdjAmt"))
                w.uint32(176).int64(m.AdjAmt);
            if (m.ToAccUserID != null && Object.hasOwnProperty.call(m, "ToAccUserID"))
                w.uint32(184).uint64(m.ToAccUserID);
            if (m.IsUsePoints != null && Object.hasOwnProperty.call(m, "IsUsePoints"))
                w.uint32(192).int32(m.IsUsePoints);
            if (m.UsePoints != null && Object.hasOwnProperty.call(m, "UsePoints"))
                w.uint32(200).int64(m.UsePoints);
            if (m.UsePointsRate != null && Object.hasOwnProperty.call(m, "UsePointsRate"))
                w.uint32(208).int32(m.UsePointsRate);
            if (m.UsePointsAmt != null && Object.hasOwnProperty.call(m, "UsePointsAmt"))
                w.uint32(216).int64(m.UsePointsAmt);
            if (m.IsTax != null && Object.hasOwnProperty.call(m, "IsTax"))
                w.uint32(224).int32(m.IsTax);
            if (m.TaxAmt != null && Object.hasOwnProperty.call(m, "TaxAmt"))
                w.uint32(232).int64(m.TaxAmt);
            if (m.TotalReceiptAmt != null && Object.hasOwnProperty.call(m, "TotalReceiptAmt"))
                w.uint32(240).int64(m.TotalReceiptAmt);
            if (m.NetWorthAmt != null && Object.hasOwnProperty.call(m, "NetWorthAmt"))
                w.uint32(248).int64(m.NetWorthAmt);
            if (m.IsUseAdvAmt != null && Object.hasOwnProperty.call(m, "IsUseAdvAmt"))
                w.uint32(256).int32(m.IsUseAdvAmt);
            if (m.UseAdvAmt != null && Object.hasOwnProperty.call(m, "UseAdvAmt"))
                w.uint32(264).int64(m.UseAdvAmt);
            if (m.IsUseCash != null && Object.hasOwnProperty.call(m, "IsUseCash"))
                w.uint32(272).int32(m.IsUseCash);
            if (m.UseCashAmt != null && Object.hasOwnProperty.call(m, "UseCashAmt"))
                w.uint32(280).int64(m.UseCashAmt);
            if (m.IsOfPay != null && Object.hasOwnProperty.call(m, "IsOfPay"))
                w.uint32(288).int32(m.IsOfPay);
            if (m.PayChannel != null && Object.hasOwnProperty.call(m, "PayChannel"))
                w.uint32(296).int64(m.PayChannel);
            if (m.PayPlatform != null && Object.hasOwnProperty.call(m, "PayPlatform"))
                w.uint32(304).int32(m.PayPlatform);
            if (m.PayAmt != null && Object.hasOwnProperty.call(m, "PayAmt"))
                w.uint32(312).int64(m.PayAmt);
            if (m.PayState != null && Object.hasOwnProperty.call(m, "PayState"))
                w.uint32(320).int32(m.PayState);
            if (m.PayTime != null && Object.hasOwnProperty.call(m, "PayTime"))
                w.uint32(328).int64(m.PayTime);
            if (m.PayRetAmt != null && Object.hasOwnProperty.call(m, "PayRetAmt"))
                w.uint32(336).int64(m.PayRetAmt);
            if (m.PayRetTime != null && Object.hasOwnProperty.call(m, "PayRetTime"))
                w.uint32(344).int64(m.PayRetTime);
            if (m.SeqCodeList != null && Object.hasOwnProperty.call(m, "SeqCodeList"))
                w.uint32(354).string(m.SeqCodeList);
            if (m.PayID != null && Object.hasOwnProperty.call(m, "PayID"))
                w.uint32(362).string(m.PayID);
            if (m.Notes != null && Object.hasOwnProperty.call(m, "Notes"))
                w.uint32(370).string(m.Notes);
            if (m.CheckState != null && Object.hasOwnProperty.call(m, "CheckState"))
                w.uint32(376).int32(m.CheckState);
            if (m.IsPayPrint != null && Object.hasOwnProperty.call(m, "IsPayPrint"))
                w.uint32(384).int32(m.IsPayPrint);
            if (m.PayPrintCount != null && Object.hasOwnProperty.call(m, "PayPrintCount"))
                w.uint32(392).int32(m.PayPrintCount);
            if (m.ObtainPointsRate != null && Object.hasOwnProperty.call(m, "ObtainPointsRate"))
                w.uint32(400).int32(m.ObtainPointsRate);
            if (m.ObtainPoints != null && Object.hasOwnProperty.call(m, "ObtainPoints"))
                w.uint32(408).int64(m.ObtainPoints);
            if (m.RefundCount != null && Object.hasOwnProperty.call(m, "RefundCount"))
                w.uint32(416).int32(m.RefundCount);
            if (m.RefundTotalAmt != null && Object.hasOwnProperty.call(m, "RefundTotalAmt"))
                w.uint32(424).int64(m.RefundTotalAmt);
            if (m.FromTokeID != null && Object.hasOwnProperty.call(m, "FromTokeID"))
                w.uint32(434).string(m.FromTokeID);
            if (m.FromIP != null && Object.hasOwnProperty.call(m, "FromIP"))
                w.uint32(442).string(m.FromIP);
            if (m.HashOID != null && Object.hasOwnProperty.call(m, "HashOID"))
                w.uint32(450).string(m.HashOID);
            if (m.GroupID != null && Object.hasOwnProperty.call(m, "GroupID"))
                w.uint32(456).uint64(m.GroupID);
            if (m.CreateTime != null && Object.hasOwnProperty.call(m, "CreateTime"))
                w.uint32(464).int64(m.CreateTime);
            if (m.CreaterID != null && Object.hasOwnProperty.call(m, "CreaterID"))
                w.uint32(472).uint64(m.CreaterID);
            if (m.UpdateTime != null && Object.hasOwnProperty.call(m, "UpdateTime"))
                w.uint32(480).int64(m.UpdateTime);
            if (m.UpdaterID != null && Object.hasOwnProperty.call(m, "UpdaterID"))
                w.uint32(488).uint64(m.UpdaterID);
            if (m.Estate != null && Object.hasOwnProperty.call(m, "Estate"))
                w.uint32(496).int32(m.Estate);
            return w;
        };

        OrderPayment.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.OrderPayment();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        m.OrderPayID = r.string();
                        break;
                    }
                    case 2: {
                        m.MchID = r.uint64();
                        break;
                    }
                    case 3: {
                        m.TransDate = r.int64();
                        break;
                    }
                    case 4: {
                        m.Category = r.int32();
                        break;
                    }
                    case 5: {
                        m.UserID = r.uint64();
                        break;
                    }
                    case 6: {
                        m.UserCate = r.int32();
                        break;
                    }
                    case 7: {
                        m.UserName = r.string();
                        break;
                    }
                    case 8: {
                        m.DistrMode = r.int32();
                        break;
                    }
                    case 9: {
                        m.TakeMode = r.int32();
                        break;
                    }
                    case 10: {
                        m.FristOrderNo = r.string();
                        break;
                    }
                    case 11: {
                        m.OrderCount = r.int32();
                        break;
                    }
                    case 12: {
                        m.ORTitle = r.string();
                        break;
                    }
                    case 13: {
                        m.LinkAddr = r.string();
                        break;
                    }
                    case 14: {
                        m.DeskID = r.uint64();
                        break;
                    }
                    case 15: {
                        m.TakePointID = r.uint64();
                        break;
                    }
                    case 16: {
                        m.ReID = r.string();
                        break;
                    }
                    case 17: {
                        m.ReIDCate = r.int32();
                        break;
                    }
                    case 18: {
                        m.TotalRevenueAmt = r.int64();
                        break;
                    }
                    case 19: {
                        m.IsMakeUp = r.int32();
                        break;
                    }
                    case 20: {
                        m.MakeUpAmt = r.int64();
                        break;
                    }
                    case 21: {
                        m.IsAdj = r.int32();
                        break;
                    }
                    case 22: {
                        m.AdjAmt = r.int64();
                        break;
                    }
                    case 23: {
                        m.ToAccUserID = r.uint64();
                        break;
                    }
                    case 24: {
                        m.IsUsePoints = r.int32();
                        break;
                    }
                    case 25: {
                        m.UsePoints = r.int64();
                        break;
                    }
                    case 26: {
                        m.UsePointsRate = r.int32();
                        break;
                    }
                    case 27: {
                        m.UsePointsAmt = r.int64();
                        break;
                    }
                    case 28: {
                        m.IsTax = r.int32();
                        break;
                    }
                    case 29: {
                        m.TaxAmt = r.int64();
                        break;
                    }
                    case 30: {
                        m.TotalReceiptAmt = r.int64();
                        break;
                    }
                    case 31: {
                        m.NetWorthAmt = r.int64();
                        break;
                    }
                    case 32: {
                        m.IsUseAdvAmt = r.int32();
                        break;
                    }
                    case 33: {
                        m.UseAdvAmt = r.int64();
                        break;
                    }
                    case 34: {
                        m.IsUseCash = r.int32();
                        break;
                    }
                    case 35: {
                        m.UseCashAmt = r.int64();
                        break;
                    }
                    case 36: {
                        m.IsOfPay = r.int32();
                        break;
                    }
                    case 37: {
                        m.PayChannel = r.int64();
                        break;
                    }
                    case 38: {
                        m.PayPlatform = r.int32();
                        break;
                    }
                    case 39: {
                        m.PayAmt = r.int64();
                        break;
                    }
                    case 40: {
                        m.PayState = r.int32();
                        break;
                    }
                    case 41: {
                        m.PayTime = r.int64();
                        break;
                    }
                    case 42: {
                        m.PayRetAmt = r.int64();
                        break;
                    }
                    case 43: {
                        m.PayRetTime = r.int64();
                        break;
                    }
                    case 44: {
                        m.SeqCodeList = r.string();
                        break;
                    }
                    case 45: {
                        m.PayID = r.string();
                        break;
                    }
                    case 46: {
                        m.Notes = r.string();
                        break;
                    }
                    case 47: {
                        m.CheckState = r.int32();
                        break;
                    }
                    case 48: {
                        m.IsPayPrint = r.int32();
                        break;
                    }
                    case 49: {
                        m.PayPrintCount = r.int32();
                        break;
                    }
                    case 50: {
                        m.ObtainPointsRate = r.int32();
                        break;
                    }
                    case 51: {
                        m.ObtainPoints = r.int64();
                        break;
                    }
                    case 52: {
                        m.RefundCount = r.int32();
                        break;
                    }
                    case 53: {
                        m.RefundTotalAmt = r.int64();
                        break;
                    }
                    case 54: {
                        m.FromTokeID = r.string();
                        break;
                    }
                    case 55: {
                        m.FromIP = r.string();
                        break;
                    }
                    case 56: {
                        m.HashOID = r.string();
                        break;
                    }
                    case 57: {
                        m.GroupID = r.uint64();
                        break;
                    }
                    case 58: {
                        m.CreateTime = r.int64();
                        break;
                    }
                    case 59: {
                        m.CreaterID = r.uint64();
                        break;
                    }
                    case 60: {
                        m.UpdateTime = r.int64();
                        break;
                    }
                    case 61: {
                        m.UpdaterID = r.uint64();
                        break;
                    }
                    case 62: {
                        m.Estate = r.int32();
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        OrderPayment.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.OrderPayment";
        };

        return OrderPayment;
    })();

    PBEntity.OrderPayments = (function () {

        function OrderPayments(p) {
            this.OrderPayments = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        OrderPayments.prototype.OrderPayments = $util.emptyArray;

        OrderPayments.create = function create(properties) {
            return new OrderPayments(properties);
        };

        OrderPayments.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.OrderPayments != null && m.OrderPayments.length) {
                for (var i = 0; i < m.OrderPayments.length; ++i)
                    $root.PBEntity.OrderPayment.encode(m.OrderPayments[i], w.uint32(10).fork()).ldelim();
            }
            return w;
        };

        OrderPayments.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.OrderPayments();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        if (!(m.OrderPayments && m.OrderPayments.length))
                            m.OrderPayments = [];
                        m.OrderPayments.push($root.PBEntity.OrderPayment.decode(r, r.uint32()));
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        OrderPayments.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.OrderPayments";
        };

        return OrderPayments;
    })();

    PBEntity.OrderPaymentDetail = (function () {

        function OrderPaymentDetail(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        OrderPaymentDetail.prototype.OPDetailID = "";
        OrderPaymentDetail.prototype.OrderPayID = "";
        OrderPaymentDetail.prototype.OrderID = "";
        OrderPaymentDetail.prototype.MchID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        OrderPaymentDetail.prototype.UserID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        OrderPaymentDetail.prototype.LinkAddr = "";
        OrderPaymentDetail.prototype.DeskID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        OrderPaymentDetail.prototype.TakePointID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        OrderPaymentDetail.prototype.RevenueAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderPaymentDetail.prototype.IsUsePoints = 0;
        OrderPaymentDetail.prototype.UsePoints = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderPaymentDetail.prototype.UsePointsRate = 0;
        OrderPaymentDetail.prototype.UsePointsAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderPaymentDetail.prototype.IsAdj = 0;
        OrderPaymentDetail.prototype.AdjAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderPaymentDetail.prototype.IsMakeUp = 0;
        OrderPaymentDetail.prototype.MakeUpAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderPaymentDetail.prototype.ReceiptAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderPaymentDetail.prototype.IsTax = 0;
        OrderPaymentDetail.prototype.TaxAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderPaymentDetail.prototype.NetWorthAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderPaymentDetail.prototype.IsUseAdvAmt = 0;
        OrderPaymentDetail.prototype.UseAdvAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderPaymentDetail.prototype.IsUseCash = 0;
        OrderPaymentDetail.prototype.UseCashAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderPaymentDetail.prototype.IsOfPay = 0;
        OrderPaymentDetail.prototype.PayChannel = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        OrderPaymentDetail.prototype.PayPlatform = 0;
        OrderPaymentDetail.prototype.PayAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderPaymentDetail.prototype.ToAccUserID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        OrderPaymentDetail.prototype.PayState = 0;
        OrderPaymentDetail.prototype.PayTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderPaymentDetail.prototype.PayID = "";
        OrderPaymentDetail.prototype.RefundCount = 0;
        OrderPaymentDetail.prototype.RefundTotalAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderPaymentDetail.prototype.GroupID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        OrderPaymentDetail.prototype.CreateTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderPaymentDetail.prototype.CreaterID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        OrderPaymentDetail.prototype.UpdateTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderPaymentDetail.prototype.UpdaterID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        OrderPaymentDetail.prototype.Estate = 0;
        OrderPaymentDetail.prototype.ToAccUUID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;

        OrderPaymentDetail.create = function create(properties) {
            return new OrderPaymentDetail(properties);
        };

        OrderPaymentDetail.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.OPDetailID != null && Object.hasOwnProperty.call(m, "OPDetailID"))
                w.uint32(10).string(m.OPDetailID);
            if (m.OrderPayID != null && Object.hasOwnProperty.call(m, "OrderPayID"))
                w.uint32(18).string(m.OrderPayID);
            if (m.OrderID != null && Object.hasOwnProperty.call(m, "OrderID"))
                w.uint32(26).string(m.OrderID);
            if (m.MchID != null && Object.hasOwnProperty.call(m, "MchID"))
                w.uint32(32).uint64(m.MchID);
            if (m.UserID != null && Object.hasOwnProperty.call(m, "UserID"))
                w.uint32(40).uint64(m.UserID);
            if (m.LinkAddr != null && Object.hasOwnProperty.call(m, "LinkAddr"))
                w.uint32(50).string(m.LinkAddr);
            if (m.DeskID != null && Object.hasOwnProperty.call(m, "DeskID"))
                w.uint32(56).uint64(m.DeskID);
            if (m.TakePointID != null && Object.hasOwnProperty.call(m, "TakePointID"))
                w.uint32(64).uint64(m.TakePointID);
            if (m.RevenueAmt != null && Object.hasOwnProperty.call(m, "RevenueAmt"))
                w.uint32(72).int64(m.RevenueAmt);
            if (m.IsUsePoints != null && Object.hasOwnProperty.call(m, "IsUsePoints"))
                w.uint32(80).int32(m.IsUsePoints);
            if (m.UsePoints != null && Object.hasOwnProperty.call(m, "UsePoints"))
                w.uint32(88).int64(m.UsePoints);
            if (m.UsePointsRate != null && Object.hasOwnProperty.call(m, "UsePointsRate"))
                w.uint32(96).int32(m.UsePointsRate);
            if (m.UsePointsAmt != null && Object.hasOwnProperty.call(m, "UsePointsAmt"))
                w.uint32(104).int64(m.UsePointsAmt);
            if (m.IsAdj != null && Object.hasOwnProperty.call(m, "IsAdj"))
                w.uint32(112).int32(m.IsAdj);
            if (m.AdjAmt != null && Object.hasOwnProperty.call(m, "AdjAmt"))
                w.uint32(120).int64(m.AdjAmt);
            if (m.IsMakeUp != null && Object.hasOwnProperty.call(m, "IsMakeUp"))
                w.uint32(128).int32(m.IsMakeUp);
            if (m.MakeUpAmt != null && Object.hasOwnProperty.call(m, "MakeUpAmt"))
                w.uint32(136).int64(m.MakeUpAmt);
            if (m.ReceiptAmt != null && Object.hasOwnProperty.call(m, "ReceiptAmt"))
                w.uint32(144).int64(m.ReceiptAmt);
            if (m.IsTax != null && Object.hasOwnProperty.call(m, "IsTax"))
                w.uint32(152).int32(m.IsTax);
            if (m.TaxAmt != null && Object.hasOwnProperty.call(m, "TaxAmt"))
                w.uint32(160).int64(m.TaxAmt);
            if (m.NetWorthAmt != null && Object.hasOwnProperty.call(m, "NetWorthAmt"))
                w.uint32(168).int64(m.NetWorthAmt);
            if (m.IsUseAdvAmt != null && Object.hasOwnProperty.call(m, "IsUseAdvAmt"))
                w.uint32(176).int32(m.IsUseAdvAmt);
            if (m.UseAdvAmt != null && Object.hasOwnProperty.call(m, "UseAdvAmt"))
                w.uint32(184).int64(m.UseAdvAmt);
            if (m.IsUseCash != null && Object.hasOwnProperty.call(m, "IsUseCash"))
                w.uint32(192).int32(m.IsUseCash);
            if (m.UseCashAmt != null && Object.hasOwnProperty.call(m, "UseCashAmt"))
                w.uint32(200).int64(m.UseCashAmt);
            if (m.IsOfPay != null && Object.hasOwnProperty.call(m, "IsOfPay"))
                w.uint32(208).int32(m.IsOfPay);
            if (m.PayChannel != null && Object.hasOwnProperty.call(m, "PayChannel"))
                w.uint32(216).uint64(m.PayChannel);
            if (m.PayPlatform != null && Object.hasOwnProperty.call(m, "PayPlatform"))
                w.uint32(224).int32(m.PayPlatform);
            if (m.PayAmt != null && Object.hasOwnProperty.call(m, "PayAmt"))
                w.uint32(232).int64(m.PayAmt);
            if (m.ToAccUserID != null && Object.hasOwnProperty.call(m, "ToAccUserID"))
                w.uint32(240).uint64(m.ToAccUserID);
            if (m.PayState != null && Object.hasOwnProperty.call(m, "PayState"))
                w.uint32(248).int32(m.PayState);
            if (m.PayTime != null && Object.hasOwnProperty.call(m, "PayTime"))
                w.uint32(256).int64(m.PayTime);
            if (m.PayID != null && Object.hasOwnProperty.call(m, "PayID"))
                w.uint32(266).string(m.PayID);
            if (m.RefundCount != null && Object.hasOwnProperty.call(m, "RefundCount"))
                w.uint32(272).int32(m.RefundCount);
            if (m.RefundTotalAmt != null && Object.hasOwnProperty.call(m, "RefundTotalAmt"))
                w.uint32(280).int64(m.RefundTotalAmt);
            if (m.GroupID != null && Object.hasOwnProperty.call(m, "GroupID"))
                w.uint32(288).uint64(m.GroupID);
            if (m.CreateTime != null && Object.hasOwnProperty.call(m, "CreateTime"))
                w.uint32(296).int64(m.CreateTime);
            if (m.CreaterID != null && Object.hasOwnProperty.call(m, "CreaterID"))
                w.uint32(304).uint64(m.CreaterID);
            if (m.UpdateTime != null && Object.hasOwnProperty.call(m, "UpdateTime"))
                w.uint32(312).int64(m.UpdateTime);
            if (m.UpdaterID != null && Object.hasOwnProperty.call(m, "UpdaterID"))
                w.uint32(320).uint64(m.UpdaterID);
            if (m.Estate != null && Object.hasOwnProperty.call(m, "Estate"))
                w.uint32(328).int32(m.Estate);
            if (m.ToAccUUID != null && Object.hasOwnProperty.call(m, "ToAccUUID"))
                w.uint32(336).uint64(m.ToAccUUID);
            return w;
        };

        OrderPaymentDetail.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.OrderPaymentDetail();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        m.OPDetailID = r.string();
                        break;
                    }
                    case 2: {
                        m.OrderPayID = r.string();
                        break;
                    }
                    case 3: {
                        m.OrderID = r.string();
                        break;
                    }
                    case 4: {
                        m.MchID = r.uint64();
                        break;
                    }
                    case 5: {
                        m.UserID = r.uint64();
                        break;
                    }
                    case 6: {
                        m.LinkAddr = r.string();
                        break;
                    }
                    case 7: {
                        m.DeskID = r.uint64();
                        break;
                    }
                    case 8: {
                        m.TakePointID = r.uint64();
                        break;
                    }
                    case 9: {
                        m.RevenueAmt = r.int64();
                        break;
                    }
                    case 10: {
                        m.IsUsePoints = r.int32();
                        break;
                    }
                    case 11: {
                        m.UsePoints = r.int64();
                        break;
                    }
                    case 12: {
                        m.UsePointsRate = r.int32();
                        break;
                    }
                    case 13: {
                        m.UsePointsAmt = r.int64();
                        break;
                    }
                    case 14: {
                        m.IsAdj = r.int32();
                        break;
                    }
                    case 15: {
                        m.AdjAmt = r.int64();
                        break;
                    }
                    case 16: {
                        m.IsMakeUp = r.int32();
                        break;
                    }
                    case 17: {
                        m.MakeUpAmt = r.int64();
                        break;
                    }
                    case 18: {
                        m.ReceiptAmt = r.int64();
                        break;
                    }
                    case 19: {
                        m.IsTax = r.int32();
                        break;
                    }
                    case 20: {
                        m.TaxAmt = r.int64();
                        break;
                    }
                    case 21: {
                        m.NetWorthAmt = r.int64();
                        break;
                    }
                    case 22: {
                        m.IsUseAdvAmt = r.int32();
                        break;
                    }
                    case 23: {
                        m.UseAdvAmt = r.int64();
                        break;
                    }
                    case 24: {
                        m.IsUseCash = r.int32();
                        break;
                    }
                    case 25: {
                        m.UseCashAmt = r.int64();
                        break;
                    }
                    case 26: {
                        m.IsOfPay = r.int32();
                        break;
                    }
                    case 27: {
                        m.PayChannel = r.uint64();
                        break;
                    }
                    case 28: {
                        m.PayPlatform = r.int32();
                        break;
                    }
                    case 29: {
                        m.PayAmt = r.int64();
                        break;
                    }
                    case 30: {
                        m.ToAccUserID = r.uint64();
                        break;
                    }
                    case 31: {
                        m.PayState = r.int32();
                        break;
                    }
                    case 32: {
                        m.PayTime = r.int64();
                        break;
                    }
                    case 33: {
                        m.PayID = r.string();
                        break;
                    }
                    case 34: {
                        m.RefundCount = r.int32();
                        break;
                    }
                    case 35: {
                        m.RefundTotalAmt = r.int64();
                        break;
                    }
                    case 36: {
                        m.GroupID = r.uint64();
                        break;
                    }
                    case 37: {
                        m.CreateTime = r.int64();
                        break;
                    }
                    case 38: {
                        m.CreaterID = r.uint64();
                        break;
                    }
                    case 39: {
                        m.UpdateTime = r.int64();
                        break;
                    }
                    case 40: {
                        m.UpdaterID = r.uint64();
                        break;
                    }
                    case 41: {
                        m.Estate = r.int32();
                        break;
                    }
                    case 42: {
                        m.ToAccUUID = r.uint64();
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        OrderPaymentDetail.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.OrderPaymentDetail";
        };

        return OrderPaymentDetail;
    })();

    PBEntity.OrderPaymentDetails = (function () {

        function OrderPaymentDetails(p) {
            this.OrderPaymentDetails = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        OrderPaymentDetails.prototype.OrderPaymentDetails = $util.emptyArray;

        OrderPaymentDetails.create = function create(properties) {
            return new OrderPaymentDetails(properties);
        };

        OrderPaymentDetails.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.OrderPaymentDetails != null && m.OrderPaymentDetails.length) {
                for (var i = 0; i < m.OrderPaymentDetails.length; ++i)
                    $root.PBEntity.OrderPaymentDetail.encode(m.OrderPaymentDetails[i], w.uint32(10).fork()).ldelim();
            }
            return w;
        };

        OrderPaymentDetails.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.OrderPaymentDetails();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        if (!(m.OrderPaymentDetails && m.OrderPaymentDetails.length))
                            m.OrderPaymentDetails = [];
                        m.OrderPaymentDetails.push($root.PBEntity.OrderPaymentDetail.decode(r, r.uint32()));
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        OrderPaymentDetails.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.OrderPaymentDetails";
        };

        return OrderPaymentDetails;
    })();

    PBEntity.OrderPrintNotice = (function () {

        function OrderPrintNotice(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        OrderPrintNotice.prototype.ID = "";
        OrderPrintNotice.prototype.MchID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        OrderPrintNotice.prototype.UserID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        OrderPrintNotice.prototype.ReID = "";
        OrderPrintNotice.prototype.ReIDCate = 0;
        OrderPrintNotice.prototype.DistrMode = 0;
        OrderPrintNotice.prototype.PrintFrom = 0;
        OrderPrintNotice.prototype.PrinterID = "";
        OrderPrintNotice.prototype.IsCustomer = 0;
        OrderPrintNotice.prototype.IsKitchen = 0;
        OrderPrintNotice.prototype.IsMerge = 0;
        OrderPrintNotice.prototype.IsTicket = 0;
        OrderPrintNotice.prototype.IsCashier = 0;
        OrderPrintNotice.prototype.IsAdvAmt = 0;
        OrderPrintNotice.prototype.IsBooking = 0;
        OrderPrintNotice.prototype.IsRcpay = 0;
        OrderPrintNotice.prototype.IsRcpayVoice = 0;
        OrderPrintNotice.prototype.PrintTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderPrintNotice.prototype.PrintResult = 0;
        OrderPrintNotice.prototype.PrintOrderID = "";
        OrderPrintNotice.prototype.CreateTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderPrintNotice.prototype.CreaterID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        OrderPrintNotice.prototype.UpdateTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderPrintNotice.prototype.UpdaterID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        OrderPrintNotice.prototype.Estate = 0;

        OrderPrintNotice.create = function create(properties) {
            return new OrderPrintNotice(properties);
        };

        OrderPrintNotice.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.ID != null && Object.hasOwnProperty.call(m, "ID"))
                w.uint32(10).string(m.ID);
            if (m.MchID != null && Object.hasOwnProperty.call(m, "MchID"))
                w.uint32(16).uint64(m.MchID);
            if (m.UserID != null && Object.hasOwnProperty.call(m, "UserID"))
                w.uint32(24).uint64(m.UserID);
            if (m.ReID != null && Object.hasOwnProperty.call(m, "ReID"))
                w.uint32(34).string(m.ReID);
            if (m.ReIDCate != null && Object.hasOwnProperty.call(m, "ReIDCate"))
                w.uint32(40).int32(m.ReIDCate);
            if (m.DistrMode != null && Object.hasOwnProperty.call(m, "DistrMode"))
                w.uint32(48).int32(m.DistrMode);
            if (m.PrintFrom != null && Object.hasOwnProperty.call(m, "PrintFrom"))
                w.uint32(56).int32(m.PrintFrom);
            if (m.PrinterID != null && Object.hasOwnProperty.call(m, "PrinterID"))
                w.uint32(66).string(m.PrinterID);
            if (m.IsCustomer != null && Object.hasOwnProperty.call(m, "IsCustomer"))
                w.uint32(72).int32(m.IsCustomer);
            if (m.IsKitchen != null && Object.hasOwnProperty.call(m, "IsKitchen"))
                w.uint32(80).int32(m.IsKitchen);
            if (m.IsMerge != null && Object.hasOwnProperty.call(m, "IsMerge"))
                w.uint32(88).int32(m.IsMerge);
            if (m.IsTicket != null && Object.hasOwnProperty.call(m, "IsTicket"))
                w.uint32(96).int32(m.IsTicket);
            if (m.IsCashier != null && Object.hasOwnProperty.call(m, "IsCashier"))
                w.uint32(104).int32(m.IsCashier);
            if (m.IsAdvAmt != null && Object.hasOwnProperty.call(m, "IsAdvAmt"))
                w.uint32(112).int32(m.IsAdvAmt);
            if (m.IsBooking != null && Object.hasOwnProperty.call(m, "IsBooking"))
                w.uint32(120).int32(m.IsBooking);
            if (m.IsRcpay != null && Object.hasOwnProperty.call(m, "IsRcpay"))
                w.uint32(128).int32(m.IsRcpay);
            if (m.IsRcpayVoice != null && Object.hasOwnProperty.call(m, "IsRcpayVoice"))
                w.uint32(136).int32(m.IsRcpayVoice);
            if (m.PrintTime != null && Object.hasOwnProperty.call(m, "PrintTime"))
                w.uint32(144).int64(m.PrintTime);
            if (m.PrintResult != null && Object.hasOwnProperty.call(m, "PrintResult"))
                w.uint32(152).int32(m.PrintResult);
            if (m.PrintOrderID != null && Object.hasOwnProperty.call(m, "PrintOrderID"))
                w.uint32(162).string(m.PrintOrderID);
            if (m.CreateTime != null && Object.hasOwnProperty.call(m, "CreateTime"))
                w.uint32(168).int64(m.CreateTime);
            if (m.CreaterID != null && Object.hasOwnProperty.call(m, "CreaterID"))
                w.uint32(176).uint64(m.CreaterID);
            if (m.UpdateTime != null && Object.hasOwnProperty.call(m, "UpdateTime"))
                w.uint32(184).int64(m.UpdateTime);
            if (m.UpdaterID != null && Object.hasOwnProperty.call(m, "UpdaterID"))
                w.uint32(192).uint64(m.UpdaterID);
            if (m.Estate != null && Object.hasOwnProperty.call(m, "Estate"))
                w.uint32(200).int32(m.Estate);
            return w;
        };

        OrderPrintNotice.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.OrderPrintNotice();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        m.ID = r.string();
                        break;
                    }
                    case 2: {
                        m.MchID = r.uint64();
                        break;
                    }
                    case 3: {
                        m.UserID = r.uint64();
                        break;
                    }
                    case 4: {
                        m.ReID = r.string();
                        break;
                    }
                    case 5: {
                        m.ReIDCate = r.int32();
                        break;
                    }
                    case 6: {
                        m.DistrMode = r.int32();
                        break;
                    }
                    case 7: {
                        m.PrintFrom = r.int32();
                        break;
                    }
                    case 8: {
                        m.PrinterID = r.string();
                        break;
                    }
                    case 9: {
                        m.IsCustomer = r.int32();
                        break;
                    }
                    case 10: {
                        m.IsKitchen = r.int32();
                        break;
                    }
                    case 11: {
                        m.IsMerge = r.int32();
                        break;
                    }
                    case 12: {
                        m.IsTicket = r.int32();
                        break;
                    }
                    case 13: {
                        m.IsCashier = r.int32();
                        break;
                    }
                    case 14: {
                        m.IsAdvAmt = r.int32();
                        break;
                    }
                    case 15: {
                        m.IsBooking = r.int32();
                        break;
                    }
                    case 16: {
                        m.IsRcpay = r.int32();
                        break;
                    }
                    case 17: {
                        m.IsRcpayVoice = r.int32();
                        break;
                    }
                    case 18: {
                        m.PrintTime = r.int64();
                        break;
                    }
                    case 19: {
                        m.PrintResult = r.int32();
                        break;
                    }
                    case 20: {
                        m.PrintOrderID = r.string();
                        break;
                    }
                    case 21: {
                        m.CreateTime = r.int64();
                        break;
                    }
                    case 22: {
                        m.CreaterID = r.uint64();
                        break;
                    }
                    case 23: {
                        m.UpdateTime = r.int64();
                        break;
                    }
                    case 24: {
                        m.UpdaterID = r.uint64();
                        break;
                    }
                    case 25: {
                        m.Estate = r.int32();
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        OrderPrintNotice.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.OrderPrintNotice";
        };

        return OrderPrintNotice;
    })();

    PBEntity.OrderPrintNotices = (function () {

        function OrderPrintNotices(p) {
            this.OrderPrintNotices = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        OrderPrintNotices.prototype.OrderPrintNotices = $util.emptyArray;

        OrderPrintNotices.create = function create(properties) {
            return new OrderPrintNotices(properties);
        };

        OrderPrintNotices.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.OrderPrintNotices != null && m.OrderPrintNotices.length) {
                for (var i = 0; i < m.OrderPrintNotices.length; ++i)
                    $root.PBEntity.OrderPrintNotice.encode(m.OrderPrintNotices[i], w.uint32(10).fork()).ldelim();
            }
            return w;
        };

        OrderPrintNotices.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.OrderPrintNotices();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        if (!(m.OrderPrintNotices && m.OrderPrintNotices.length))
                            m.OrderPrintNotices = [];
                        m.OrderPrintNotices.push($root.PBEntity.OrderPrintNotice.decode(r, r.uint32()));
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        OrderPrintNotices.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.OrderPrintNotices";
        };

        return OrderPrintNotices;
    })();

    PBEntity.OrderRefund = (function () {

        function OrderRefund(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        OrderRefund.prototype.RefundID = "";
        OrderRefund.prototype.OrderID = "";
        OrderRefund.prototype.RefundDate = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderRefund.prototype.RefundSeq = 0;
        OrderRefund.prototype.MchID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        OrderRefund.prototype.UserID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        OrderRefund.prototype.ToAccUserID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        OrderRefund.prototype.DistrMode = 0;
        OrderRefund.prototype.TakeMode = 0;
        OrderRefund.prototype.SaleSeq = 0;
        OrderRefund.prototype.SeqCode = "";
        OrderRefund.prototype.SaleNo = "";
        OrderRefund.prototype.DeskID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        OrderRefund.prototype.DeskName1 = "";
        OrderRefund.prototype.DeskName2 = "";
        OrderRefund.prototype.DeskName3 = "";
        OrderRefund.prototype.DeskUseID = "";
        OrderRefund.prototype.OriOrderState = 0;
        OrderRefund.prototype.OriPayState = 0;
        OrderRefund.prototype.OriQuantity = 0;
        OrderRefund.prototype.OriTotalCost = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderRefund.prototype.OriTotalDetailAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderRefund.prototype.RefundUserID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        OrderRefund.prototype.RefundUserName = "";
        OrderRefund.prototype.RefundResult = 0;
        OrderRefund.prototype.RefundNotes = "";
        OrderRefund.prototype.IsRestoreStock = 0;
        OrderRefund.prototype.TotalRecord = 0;
        OrderRefund.prototype.TotalNum = 0;
        OrderRefund.prototype.TotalDetailAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderRefund.prototype.TotalCostAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderRefund.prototype.TotalWeight = 0;
        OrderRefund.prototype.TeaFee = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderRefund.prototype.TeaNum = 0;
        OrderRefund.prototype.TeaTotalAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderRefund.prototype.TablewareFee = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderRefund.prototype.TablewareNum = 0;
        OrderRefund.prototype.TablewareTotalAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderRefund.prototype.PackageFee = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderRefund.prototype.PostageAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderRefund.prototype.RevenueAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderRefund.prototype.IsRefundAmt = 0;
        OrderRefund.prototype.OriRevenueAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderRefund.prototype.OriReceiptAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderRefund.prototype.OriAdjAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderRefund.prototype.OriMakeUpAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderRefund.prototype.OriUseAdvAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderRefund.prototype.OriUsePoints = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderRefund.prototype.OriUseCashAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderRefund.prototype.OriUseGroupBuyAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderRefund.prototype.OriGroupBuyVerifyID = "";
        OrderRefund.prototype.OriGroupBuyVerifyTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderRefund.prototype.OriPayAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderRefund.prototype.OriSPTotalGoodsAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderRefund.prototype.SPTotalGoodsAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderRefund.prototype.SPSalesAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderRefund.prototype.SPDisSalesAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderRefund.prototype.OriCSTotalGoodsAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderRefund.prototype.CSTotalGoodsAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderRefund.prototype.CSSalesAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderRefund.prototype.CSSalesPostageAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderRefund.prototype.CCSalesAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderRefund.prototype.AdjSalesAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderRefund.prototype.RefundAmtState = 0;
        OrderRefund.prototype.RefundAmtNotes = "";
        OrderRefund.prototype.RefundToUserID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        OrderRefund.prototype.CanRefundAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderRefund.prototype.RefundAdjAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderRefund.prototype.RefundMakeUpAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderRefund.prototype.CanRefundPoints = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderRefund.prototype.CanRefundPointsAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderRefund.prototype.CanRefundCashAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderRefund.prototype.CanRefundAdvAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderRefund.prototype.CanRefundGroupBuyAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderRefund.prototype.CanRefundPayAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderRefund.prototype.BackObtainPoints = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderRefund.prototype.BackSPGivePoints = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderRefund.prototype.BackCSGivePoints = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderRefund.prototype.BackSPGiveAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderRefund.prototype.BackCSGiveAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderRefund.prototype.BackSPGiveCSRecID = "";
        OrderRefund.prototype.OriPayPlatform = 0;
        OrderRefund.prototype.OriOrderPayID = "";
        OrderRefund.prototype.OriOrderPayDetailID = "";
        OrderRefund.prototype.OriPayID = "";
        OrderRefund.prototype.RefundAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderRefund.prototype.RefundAmtTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderRefund.prototype.RefundPoints = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderRefund.prototype.RefundPointsAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderRefund.prototype.RefundAdvAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderRefund.prototype.RefundCashAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderRefund.prototype.RefundGroupBuyAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderRefund.prototype.RefundGroupBuyVerifyID = "";
        OrderRefund.prototype.RefundGroupBuyCancelID = "";
        OrderRefund.prototype.RefundPayPlatform = 0;
        OrderRefund.prototype.RefundPayAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderRefund.prototype.RefundPayResult = 0;
        OrderRefund.prototype.RefundApplyID = "";
        OrderRefund.prototype.RefundRetTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderRefund.prototype.RefundAmtUserID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        OrderRefund.prototype.RefundAmtUserName = "";
        OrderRefund.prototype.GroupID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        OrderRefund.prototype.PrintCount = 0;
        OrderRefund.prototype.RefundPrintCount = 0;
        OrderRefund.prototype.CreateTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderRefund.prototype.CreaterID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        OrderRefund.prototype.UpdateTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderRefund.prototype.UpdaterID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        OrderRefund.prototype.Estate = 0;
        OrderRefund.prototype.FromIP = "";
        OrderRefund.prototype.FromTokeID = "";

        OrderRefund.create = function create(properties) {
            return new OrderRefund(properties);
        };

        OrderRefund.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.RefundID != null && Object.hasOwnProperty.call(m, "RefundID"))
                w.uint32(10).string(m.RefundID);
            if (m.OrderID != null && Object.hasOwnProperty.call(m, "OrderID"))
                w.uint32(18).string(m.OrderID);
            if (m.RefundDate != null && Object.hasOwnProperty.call(m, "RefundDate"))
                w.uint32(24).int64(m.RefundDate);
            if (m.RefundSeq != null && Object.hasOwnProperty.call(m, "RefundSeq"))
                w.uint32(32).int32(m.RefundSeq);
            if (m.MchID != null && Object.hasOwnProperty.call(m, "MchID"))
                w.uint32(40).uint64(m.MchID);
            if (m.UserID != null && Object.hasOwnProperty.call(m, "UserID"))
                w.uint32(48).uint64(m.UserID);
            if (m.ToAccUserID != null && Object.hasOwnProperty.call(m, "ToAccUserID"))
                w.uint32(56).uint64(m.ToAccUserID);
            if (m.DistrMode != null && Object.hasOwnProperty.call(m, "DistrMode"))
                w.uint32(64).int32(m.DistrMode);
            if (m.TakeMode != null && Object.hasOwnProperty.call(m, "TakeMode"))
                w.uint32(72).int32(m.TakeMode);
            if (m.SaleSeq != null && Object.hasOwnProperty.call(m, "SaleSeq"))
                w.uint32(80).int32(m.SaleSeq);
            if (m.SeqCode != null && Object.hasOwnProperty.call(m, "SeqCode"))
                w.uint32(90).string(m.SeqCode);
            if (m.SaleNo != null && Object.hasOwnProperty.call(m, "SaleNo"))
                w.uint32(98).string(m.SaleNo);
            if (m.DeskID != null && Object.hasOwnProperty.call(m, "DeskID"))
                w.uint32(104).uint64(m.DeskID);
            if (m.DeskName1 != null && Object.hasOwnProperty.call(m, "DeskName1"))
                w.uint32(114).string(m.DeskName1);
            if (m.DeskName2 != null && Object.hasOwnProperty.call(m, "DeskName2"))
                w.uint32(122).string(m.DeskName2);
            if (m.DeskName3 != null && Object.hasOwnProperty.call(m, "DeskName3"))
                w.uint32(130).string(m.DeskName3);
            if (m.DeskUseID != null && Object.hasOwnProperty.call(m, "DeskUseID"))
                w.uint32(138).string(m.DeskUseID);
            if (m.OriOrderState != null && Object.hasOwnProperty.call(m, "OriOrderState"))
                w.uint32(144).int32(m.OriOrderState);
            if (m.OriPayState != null && Object.hasOwnProperty.call(m, "OriPayState"))
                w.uint32(152).int32(m.OriPayState);
            if (m.OriQuantity != null && Object.hasOwnProperty.call(m, "OriQuantity"))
                w.uint32(161).double(m.OriQuantity);
            if (m.OriTotalCost != null && Object.hasOwnProperty.call(m, "OriTotalCost"))
                w.uint32(168).int64(m.OriTotalCost);
            if (m.OriTotalDetailAmt != null && Object.hasOwnProperty.call(m, "OriTotalDetailAmt"))
                w.uint32(176).int64(m.OriTotalDetailAmt);
            if (m.RefundUserID != null && Object.hasOwnProperty.call(m, "RefundUserID"))
                w.uint32(184).uint64(m.RefundUserID);
            if (m.RefundUserName != null && Object.hasOwnProperty.call(m, "RefundUserName"))
                w.uint32(194).string(m.RefundUserName);
            if (m.RefundResult != null && Object.hasOwnProperty.call(m, "RefundResult"))
                w.uint32(200).int32(m.RefundResult);
            if (m.RefundNotes != null && Object.hasOwnProperty.call(m, "RefundNotes"))
                w.uint32(210).string(m.RefundNotes);
            if (m.IsRestoreStock != null && Object.hasOwnProperty.call(m, "IsRestoreStock"))
                w.uint32(216).int32(m.IsRestoreStock);
            if (m.TotalRecord != null && Object.hasOwnProperty.call(m, "TotalRecord"))
                w.uint32(224).int32(m.TotalRecord);
            if (m.TotalNum != null && Object.hasOwnProperty.call(m, "TotalNum"))
                w.uint32(233).double(m.TotalNum);
            if (m.TotalDetailAmt != null && Object.hasOwnProperty.call(m, "TotalDetailAmt"))
                w.uint32(240).int64(m.TotalDetailAmt);
            if (m.TotalCostAmt != null && Object.hasOwnProperty.call(m, "TotalCostAmt"))
                w.uint32(248).int64(m.TotalCostAmt);
            if (m.TotalWeight != null && Object.hasOwnProperty.call(m, "TotalWeight"))
                w.uint32(257).double(m.TotalWeight);
            if (m.TeaFee != null && Object.hasOwnProperty.call(m, "TeaFee"))
                w.uint32(264).int64(m.TeaFee);
            if (m.TeaNum != null && Object.hasOwnProperty.call(m, "TeaNum"))
                w.uint32(272).int32(m.TeaNum);
            if (m.TeaTotalAmt != null && Object.hasOwnProperty.call(m, "TeaTotalAmt"))
                w.uint32(280).int64(m.TeaTotalAmt);
            if (m.TablewareFee != null && Object.hasOwnProperty.call(m, "TablewareFee"))
                w.uint32(288).int64(m.TablewareFee);
            if (m.TablewareNum != null && Object.hasOwnProperty.call(m, "TablewareNum"))
                w.uint32(296).int32(m.TablewareNum);
            if (m.TablewareTotalAmt != null && Object.hasOwnProperty.call(m, "TablewareTotalAmt"))
                w.uint32(304).int64(m.TablewareTotalAmt);
            if (m.PackageFee != null && Object.hasOwnProperty.call(m, "PackageFee"))
                w.uint32(312).int64(m.PackageFee);
            if (m.PostageAmt != null && Object.hasOwnProperty.call(m, "PostageAmt"))
                w.uint32(320).int64(m.PostageAmt);
            if (m.RevenueAmt != null && Object.hasOwnProperty.call(m, "RevenueAmt"))
                w.uint32(328).int64(m.RevenueAmt);
            if (m.IsRefundAmt != null && Object.hasOwnProperty.call(m, "IsRefundAmt"))
                w.uint32(336).int32(m.IsRefundAmt);
            if (m.OriRevenueAmt != null && Object.hasOwnProperty.call(m, "OriRevenueAmt"))
                w.uint32(344).int64(m.OriRevenueAmt);
            if (m.OriReceiptAmt != null && Object.hasOwnProperty.call(m, "OriReceiptAmt"))
                w.uint32(352).int64(m.OriReceiptAmt);
            if (m.OriAdjAmt != null && Object.hasOwnProperty.call(m, "OriAdjAmt"))
                w.uint32(360).int64(m.OriAdjAmt);
            if (m.OriMakeUpAmt != null && Object.hasOwnProperty.call(m, "OriMakeUpAmt"))
                w.uint32(368).int64(m.OriMakeUpAmt);
            if (m.OriUseAdvAmt != null && Object.hasOwnProperty.call(m, "OriUseAdvAmt"))
                w.uint32(376).int64(m.OriUseAdvAmt);
            if (m.OriUsePoints != null && Object.hasOwnProperty.call(m, "OriUsePoints"))
                w.uint32(384).int64(m.OriUsePoints);
            if (m.OriUseCashAmt != null && Object.hasOwnProperty.call(m, "OriUseCashAmt"))
                w.uint32(392).int64(m.OriUseCashAmt);
            if (m.OriUseGroupBuyAmt != null && Object.hasOwnProperty.call(m, "OriUseGroupBuyAmt"))
                w.uint32(400).int64(m.OriUseGroupBuyAmt);
            if (m.OriGroupBuyVerifyID != null && Object.hasOwnProperty.call(m, "OriGroupBuyVerifyID"))
                w.uint32(410).string(m.OriGroupBuyVerifyID);
            if (m.OriGroupBuyVerifyTime != null && Object.hasOwnProperty.call(m, "OriGroupBuyVerifyTime"))
                w.uint32(416).int64(m.OriGroupBuyVerifyTime);
            if (m.OriPayAmt != null && Object.hasOwnProperty.call(m, "OriPayAmt"))
                w.uint32(424).int64(m.OriPayAmt);
            if (m.OriSPTotalGoodsAmt != null && Object.hasOwnProperty.call(m, "OriSPTotalGoodsAmt"))
                w.uint32(432).int64(m.OriSPTotalGoodsAmt);
            if (m.SPTotalGoodsAmt != null && Object.hasOwnProperty.call(m, "SPTotalGoodsAmt"))
                w.uint32(440).int64(m.SPTotalGoodsAmt);
            if (m.SPSalesAmt != null && Object.hasOwnProperty.call(m, "SPSalesAmt"))
                w.uint32(448).int64(m.SPSalesAmt);
            if (m.SPDisSalesAmt != null && Object.hasOwnProperty.call(m, "SPDisSalesAmt"))
                w.uint32(456).int64(m.SPDisSalesAmt);
            if (m.OriCSTotalGoodsAmt != null && Object.hasOwnProperty.call(m, "OriCSTotalGoodsAmt"))
                w.uint32(464).int64(m.OriCSTotalGoodsAmt);
            if (m.CSTotalGoodsAmt != null && Object.hasOwnProperty.call(m, "CSTotalGoodsAmt"))
                w.uint32(472).int64(m.CSTotalGoodsAmt);
            if (m.CSSalesAmt != null && Object.hasOwnProperty.call(m, "CSSalesAmt"))
                w.uint32(480).int64(m.CSSalesAmt);
            if (m.CSSalesPostageAmt != null && Object.hasOwnProperty.call(m, "CSSalesPostageAmt"))
                w.uint32(488).int64(m.CSSalesPostageAmt);
            if (m.CCSalesAmt != null && Object.hasOwnProperty.call(m, "CCSalesAmt"))
                w.uint32(496).int64(m.CCSalesAmt);
            if (m.AdjSalesAmt != null && Object.hasOwnProperty.call(m, "AdjSalesAmt"))
                w.uint32(504).int64(m.AdjSalesAmt);
            if (m.RefundAmtState != null && Object.hasOwnProperty.call(m, "RefundAmtState"))
                w.uint32(512).int32(m.RefundAmtState);
            if (m.RefundAmtNotes != null && Object.hasOwnProperty.call(m, "RefundAmtNotes"))
                w.uint32(522).string(m.RefundAmtNotes);
            if (m.RefundToUserID != null && Object.hasOwnProperty.call(m, "RefundToUserID"))
                w.uint32(528).uint64(m.RefundToUserID);
            if (m.CanRefundAmt != null && Object.hasOwnProperty.call(m, "CanRefundAmt"))
                w.uint32(536).int64(m.CanRefundAmt);
            if (m.RefundAdjAmt != null && Object.hasOwnProperty.call(m, "RefundAdjAmt"))
                w.uint32(544).int64(m.RefundAdjAmt);
            if (m.RefundMakeUpAmt != null && Object.hasOwnProperty.call(m, "RefundMakeUpAmt"))
                w.uint32(552).int64(m.RefundMakeUpAmt);
            if (m.CanRefundPoints != null && Object.hasOwnProperty.call(m, "CanRefundPoints"))
                w.uint32(560).int64(m.CanRefundPoints);
            if (m.CanRefundPointsAmt != null && Object.hasOwnProperty.call(m, "CanRefundPointsAmt"))
                w.uint32(568).int64(m.CanRefundPointsAmt);
            if (m.CanRefundCashAmt != null && Object.hasOwnProperty.call(m, "CanRefundCashAmt"))
                w.uint32(576).int64(m.CanRefundCashAmt);
            if (m.CanRefundAdvAmt != null && Object.hasOwnProperty.call(m, "CanRefundAdvAmt"))
                w.uint32(584).int64(m.CanRefundAdvAmt);
            if (m.CanRefundGroupBuyAmt != null && Object.hasOwnProperty.call(m, "CanRefundGroupBuyAmt"))
                w.uint32(592).int64(m.CanRefundGroupBuyAmt);
            if (m.CanRefundPayAmt != null && Object.hasOwnProperty.call(m, "CanRefundPayAmt"))
                w.uint32(600).int64(m.CanRefundPayAmt);
            if (m.BackObtainPoints != null && Object.hasOwnProperty.call(m, "BackObtainPoints"))
                w.uint32(608).int64(m.BackObtainPoints);
            if (m.BackSPGivePoints != null && Object.hasOwnProperty.call(m, "BackSPGivePoints"))
                w.uint32(616).int64(m.BackSPGivePoints);
            if (m.BackCSGivePoints != null && Object.hasOwnProperty.call(m, "BackCSGivePoints"))
                w.uint32(624).int64(m.BackCSGivePoints);
            if (m.BackSPGiveAmt != null && Object.hasOwnProperty.call(m, "BackSPGiveAmt"))
                w.uint32(632).int64(m.BackSPGiveAmt);
            if (m.BackCSGiveAmt != null && Object.hasOwnProperty.call(m, "BackCSGiveAmt"))
                w.uint32(640).int64(m.BackCSGiveAmt);
            if (m.BackSPGiveCSRecID != null && Object.hasOwnProperty.call(m, "BackSPGiveCSRecID"))
                w.uint32(650).string(m.BackSPGiveCSRecID);
            if (m.OriPayPlatform != null && Object.hasOwnProperty.call(m, "OriPayPlatform"))
                w.uint32(656).int32(m.OriPayPlatform);
            if (m.OriOrderPayID != null && Object.hasOwnProperty.call(m, "OriOrderPayID"))
                w.uint32(666).string(m.OriOrderPayID);
            if (m.OriOrderPayDetailID != null && Object.hasOwnProperty.call(m, "OriOrderPayDetailID"))
                w.uint32(674).string(m.OriOrderPayDetailID);
            if (m.OriPayID != null && Object.hasOwnProperty.call(m, "OriPayID"))
                w.uint32(682).string(m.OriPayID);
            if (m.RefundAmt != null && Object.hasOwnProperty.call(m, "RefundAmt"))
                w.uint32(688).int64(m.RefundAmt);
            if (m.RefundAmtTime != null && Object.hasOwnProperty.call(m, "RefundAmtTime"))
                w.uint32(696).int64(m.RefundAmtTime);
            if (m.RefundPoints != null && Object.hasOwnProperty.call(m, "RefundPoints"))
                w.uint32(704).int64(m.RefundPoints);
            if (m.RefundPointsAmt != null && Object.hasOwnProperty.call(m, "RefundPointsAmt"))
                w.uint32(712).int64(m.RefundPointsAmt);
            if (m.RefundAdvAmt != null && Object.hasOwnProperty.call(m, "RefundAdvAmt"))
                w.uint32(720).int64(m.RefundAdvAmt);
            if (m.RefundCashAmt != null && Object.hasOwnProperty.call(m, "RefundCashAmt"))
                w.uint32(728).int64(m.RefundCashAmt);
            if (m.RefundGroupBuyAmt != null && Object.hasOwnProperty.call(m, "RefundGroupBuyAmt"))
                w.uint32(736).int64(m.RefundGroupBuyAmt);
            if (m.RefundGroupBuyVerifyID != null && Object.hasOwnProperty.call(m, "RefundGroupBuyVerifyID"))
                w.uint32(746).string(m.RefundGroupBuyVerifyID);
            if (m.RefundGroupBuyCancelID != null && Object.hasOwnProperty.call(m, "RefundGroupBuyCancelID"))
                w.uint32(754).string(m.RefundGroupBuyCancelID);
            if (m.RefundPayPlatform != null && Object.hasOwnProperty.call(m, "RefundPayPlatform"))
                w.uint32(760).int32(m.RefundPayPlatform);
            if (m.RefundPayAmt != null && Object.hasOwnProperty.call(m, "RefundPayAmt"))
                w.uint32(768).int64(m.RefundPayAmt);
            if (m.RefundPayResult != null && Object.hasOwnProperty.call(m, "RefundPayResult"))
                w.uint32(776).int32(m.RefundPayResult);
            if (m.RefundApplyID != null && Object.hasOwnProperty.call(m, "RefundApplyID"))
                w.uint32(786).string(m.RefundApplyID);
            if (m.RefundRetTime != null && Object.hasOwnProperty.call(m, "RefundRetTime"))
                w.uint32(792).int64(m.RefundRetTime);
            if (m.RefundAmtUserID != null && Object.hasOwnProperty.call(m, "RefundAmtUserID"))
                w.uint32(800).uint64(m.RefundAmtUserID);
            if (m.RefundAmtUserName != null && Object.hasOwnProperty.call(m, "RefundAmtUserName"))
                w.uint32(810).string(m.RefundAmtUserName);
            if (m.GroupID != null && Object.hasOwnProperty.call(m, "GroupID"))
                w.uint32(816).uint64(m.GroupID);
            if (m.PrintCount != null && Object.hasOwnProperty.call(m, "PrintCount"))
                w.uint32(824).int32(m.PrintCount);
            if (m.RefundPrintCount != null && Object.hasOwnProperty.call(m, "RefundPrintCount"))
                w.uint32(832).int32(m.RefundPrintCount);
            if (m.CreateTime != null && Object.hasOwnProperty.call(m, "CreateTime"))
                w.uint32(840).int64(m.CreateTime);
            if (m.CreaterID != null && Object.hasOwnProperty.call(m, "CreaterID"))
                w.uint32(848).uint64(m.CreaterID);
            if (m.UpdateTime != null && Object.hasOwnProperty.call(m, "UpdateTime"))
                w.uint32(856).int64(m.UpdateTime);
            if (m.UpdaterID != null && Object.hasOwnProperty.call(m, "UpdaterID"))
                w.uint32(864).uint64(m.UpdaterID);
            if (m.Estate != null && Object.hasOwnProperty.call(m, "Estate"))
                w.uint32(872).int32(m.Estate);
            if (m.FromIP != null && Object.hasOwnProperty.call(m, "FromIP"))
                w.uint32(882).string(m.FromIP);
            if (m.FromTokeID != null && Object.hasOwnProperty.call(m, "FromTokeID"))
                w.uint32(890).string(m.FromTokeID);
            return w;
        };

        OrderRefund.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.OrderRefund();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        m.RefundID = r.string();
                        break;
                    }
                    case 2: {
                        m.OrderID = r.string();
                        break;
                    }
                    case 3: {
                        m.RefundDate = r.int64();
                        break;
                    }
                    case 4: {
                        m.RefundSeq = r.int32();
                        break;
                    }
                    case 5: {
                        m.MchID = r.uint64();
                        break;
                    }
                    case 6: {
                        m.UserID = r.uint64();
                        break;
                    }
                    case 7: {
                        m.ToAccUserID = r.uint64();
                        break;
                    }
                    case 8: {
                        m.DistrMode = r.int32();
                        break;
                    }
                    case 9: {
                        m.TakeMode = r.int32();
                        break;
                    }
                    case 10: {
                        m.SaleSeq = r.int32();
                        break;
                    }
                    case 11: {
                        m.SeqCode = r.string();
                        break;
                    }
                    case 12: {
                        m.SaleNo = r.string();
                        break;
                    }
                    case 13: {
                        m.DeskID = r.uint64();
                        break;
                    }
                    case 14: {
                        m.DeskName1 = r.string();
                        break;
                    }
                    case 15: {
                        m.DeskName2 = r.string();
                        break;
                    }
                    case 16: {
                        m.DeskName3 = r.string();
                        break;
                    }
                    case 17: {
                        m.DeskUseID = r.string();
                        break;
                    }
                    case 18: {
                        m.OriOrderState = r.int32();
                        break;
                    }
                    case 19: {
                        m.OriPayState = r.int32();
                        break;
                    }
                    case 20: {
                        m.OriQuantity = r.double();
                        break;
                    }
                    case 21: {
                        m.OriTotalCost = r.int64();
                        break;
                    }
                    case 22: {
                        m.OriTotalDetailAmt = r.int64();
                        break;
                    }
                    case 23: {
                        m.RefundUserID = r.uint64();
                        break;
                    }
                    case 24: {
                        m.RefundUserName = r.string();
                        break;
                    }
                    case 25: {
                        m.RefundResult = r.int32();
                        break;
                    }
                    case 26: {
                        m.RefundNotes = r.string();
                        break;
                    }
                    case 27: {
                        m.IsRestoreStock = r.int32();
                        break;
                    }
                    case 28: {
                        m.TotalRecord = r.int32();
                        break;
                    }
                    case 29: {
                        m.TotalNum = r.double();
                        break;
                    }
                    case 30: {
                        m.TotalDetailAmt = r.int64();
                        break;
                    }
                    case 31: {
                        m.TotalCostAmt = r.int64();
                        break;
                    }
                    case 32: {
                        m.TotalWeight = r.double();
                        break;
                    }
                    case 33: {
                        m.TeaFee = r.int64();
                        break;
                    }
                    case 34: {
                        m.TeaNum = r.int32();
                        break;
                    }
                    case 35: {
                        m.TeaTotalAmt = r.int64();
                        break;
                    }
                    case 36: {
                        m.TablewareFee = r.int64();
                        break;
                    }
                    case 37: {
                        m.TablewareNum = r.int32();
                        break;
                    }
                    case 38: {
                        m.TablewareTotalAmt = r.int64();
                        break;
                    }
                    case 39: {
                        m.PackageFee = r.int64();
                        break;
                    }
                    case 40: {
                        m.PostageAmt = r.int64();
                        break;
                    }
                    case 41: {
                        m.RevenueAmt = r.int64();
                        break;
                    }
                    case 42: {
                        m.IsRefundAmt = r.int32();
                        break;
                    }
                    case 43: {
                        m.OriRevenueAmt = r.int64();
                        break;
                    }
                    case 44: {
                        m.OriReceiptAmt = r.int64();
                        break;
                    }
                    case 45: {
                        m.OriAdjAmt = r.int64();
                        break;
                    }
                    case 46: {
                        m.OriMakeUpAmt = r.int64();
                        break;
                    }
                    case 47: {
                        m.OriUseAdvAmt = r.int64();
                        break;
                    }
                    case 48: {
                        m.OriUsePoints = r.int64();
                        break;
                    }
                    case 49: {
                        m.OriUseCashAmt = r.int64();
                        break;
                    }
                    case 50: {
                        m.OriUseGroupBuyAmt = r.int64();
                        break;
                    }
                    case 51: {
                        m.OriGroupBuyVerifyID = r.string();
                        break;
                    }
                    case 52: {
                        m.OriGroupBuyVerifyTime = r.int64();
                        break;
                    }
                    case 53: {
                        m.OriPayAmt = r.int64();
                        break;
                    }
                    case 54: {
                        m.OriSPTotalGoodsAmt = r.int64();
                        break;
                    }
                    case 55: {
                        m.SPTotalGoodsAmt = r.int64();
                        break;
                    }
                    case 56: {
                        m.SPSalesAmt = r.int64();
                        break;
                    }
                    case 57: {
                        m.SPDisSalesAmt = r.int64();
                        break;
                    }
                    case 58: {
                        m.OriCSTotalGoodsAmt = r.int64();
                        break;
                    }
                    case 59: {
                        m.CSTotalGoodsAmt = r.int64();
                        break;
                    }
                    case 60: {
                        m.CSSalesAmt = r.int64();
                        break;
                    }
                    case 61: {
                        m.CSSalesPostageAmt = r.int64();
                        break;
                    }
                    case 62: {
                        m.CCSalesAmt = r.int64();
                        break;
                    }
                    case 63: {
                        m.AdjSalesAmt = r.int64();
                        break;
                    }
                    case 64: {
                        m.RefundAmtState = r.int32();
                        break;
                    }
                    case 65: {
                        m.RefundAmtNotes = r.string();
                        break;
                    }
                    case 66: {
                        m.RefundToUserID = r.uint64();
                        break;
                    }
                    case 67: {
                        m.CanRefundAmt = r.int64();
                        break;
                    }
                    case 68: {
                        m.RefundAdjAmt = r.int64();
                        break;
                    }
                    case 69: {
                        m.RefundMakeUpAmt = r.int64();
                        break;
                    }
                    case 70: {
                        m.CanRefundPoints = r.int64();
                        break;
                    }
                    case 71: {
                        m.CanRefundPointsAmt = r.int64();
                        break;
                    }
                    case 72: {
                        m.CanRefundCashAmt = r.int64();
                        break;
                    }
                    case 73: {
                        m.CanRefundAdvAmt = r.int64();
                        break;
                    }
                    case 74: {
                        m.CanRefundGroupBuyAmt = r.int64();
                        break;
                    }
                    case 75: {
                        m.CanRefundPayAmt = r.int64();
                        break;
                    }
                    case 76: {
                        m.BackObtainPoints = r.int64();
                        break;
                    }
                    case 77: {
                        m.BackSPGivePoints = r.int64();
                        break;
                    }
                    case 78: {
                        m.BackCSGivePoints = r.int64();
                        break;
                    }
                    case 79: {
                        m.BackSPGiveAmt = r.int64();
                        break;
                    }
                    case 80: {
                        m.BackCSGiveAmt = r.int64();
                        break;
                    }
                    case 81: {
                        m.BackSPGiveCSRecID = r.string();
                        break;
                    }
                    case 82: {
                        m.OriPayPlatform = r.int32();
                        break;
                    }
                    case 83: {
                        m.OriOrderPayID = r.string();
                        break;
                    }
                    case 84: {
                        m.OriOrderPayDetailID = r.string();
                        break;
                    }
                    case 85: {
                        m.OriPayID = r.string();
                        break;
                    }
                    case 86: {
                        m.RefundAmt = r.int64();
                        break;
                    }
                    case 87: {
                        m.RefundAmtTime = r.int64();
                        break;
                    }
                    case 88: {
                        m.RefundPoints = r.int64();
                        break;
                    }
                    case 89: {
                        m.RefundPointsAmt = r.int64();
                        break;
                    }
                    case 90: {
                        m.RefundAdvAmt = r.int64();
                        break;
                    }
                    case 91: {
                        m.RefundCashAmt = r.int64();
                        break;
                    }
                    case 92: {
                        m.RefundGroupBuyAmt = r.int64();
                        break;
                    }
                    case 93: {
                        m.RefundGroupBuyVerifyID = r.string();
                        break;
                    }
                    case 94: {
                        m.RefundGroupBuyCancelID = r.string();
                        break;
                    }
                    case 95: {
                        m.RefundPayPlatform = r.int32();
                        break;
                    }
                    case 96: {
                        m.RefundPayAmt = r.int64();
                        break;
                    }
                    case 97: {
                        m.RefundPayResult = r.int32();
                        break;
                    }
                    case 98: {
                        m.RefundApplyID = r.string();
                        break;
                    }
                    case 99: {
                        m.RefundRetTime = r.int64();
                        break;
                    }
                    case 100: {
                        m.RefundAmtUserID = r.uint64();
                        break;
                    }
                    case 101: {
                        m.RefundAmtUserName = r.string();
                        break;
                    }
                    case 102: {
                        m.GroupID = r.uint64();
                        break;
                    }
                    case 103: {
                        m.PrintCount = r.int32();
                        break;
                    }
                    case 104: {
                        m.RefundPrintCount = r.int32();
                        break;
                    }
                    case 105: {
                        m.CreateTime = r.int64();
                        break;
                    }
                    case 106: {
                        m.CreaterID = r.uint64();
                        break;
                    }
                    case 107: {
                        m.UpdateTime = r.int64();
                        break;
                    }
                    case 108: {
                        m.UpdaterID = r.uint64();
                        break;
                    }
                    case 109: {
                        m.Estate = r.int32();
                        break;
                    }
                    case 110: {
                        m.FromIP = r.string();
                        break;
                    }
                    case 111: {
                        m.FromTokeID = r.string();
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        OrderRefund.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.OrderRefund";
        };

        return OrderRefund;
    })();

    PBEntity.OrderRefunds = (function () {

        function OrderRefunds(p) {
            this.OrderRefunds = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        OrderRefunds.prototype.OrderRefunds = $util.emptyArray;

        OrderRefunds.create = function create(properties) {
            return new OrderRefunds(properties);
        };

        OrderRefunds.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.OrderRefunds != null && m.OrderRefunds.length) {
                for (var i = 0; i < m.OrderRefunds.length; ++i)
                    $root.PBEntity.OrderRefund.encode(m.OrderRefunds[i], w.uint32(10).fork()).ldelim();
            }
            return w;
        };

        OrderRefunds.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.OrderRefunds();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        if (!(m.OrderRefunds && m.OrderRefunds.length))
                            m.OrderRefunds = [];
                        m.OrderRefunds.push($root.PBEntity.OrderRefund.decode(r, r.uint32()));
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        OrderRefunds.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.OrderRefunds";
        };

        return OrderRefunds;
    })();

    PBEntity.OrderSale = (function () {

        function OrderSale(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        OrderSale.prototype.OrderID = "";
        OrderSale.prototype.MchID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        OrderSale.prototype.UserID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        OrderSale.prototype.TransDate = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderSale.prototype.PromoID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        OrderSale.prototype.SPTitle1 = "";
        OrderSale.prototype.SPTitle2 = "";
        OrderSale.prototype.SPTitle3 = "";
        OrderSale.prototype.SPTotalGoodsAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderSale.prototype.SPIsSalesAmt = 0;
        OrderSale.prototype.SPSalesAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderSale.prototype.SPDisSalesAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderSale.prototype.SPIsGiveAmt = 0;
        OrderSale.prototype.SPGiveAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderSale.prototype.SPIsGivePoints = 0;
        OrderSale.prototype.SPGivePoints = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderSale.prototype.SPIsGiveGoods = 0;
        OrderSale.prototype.SPIsGiveCoupon = 0;
        OrderSale.prototype.SPGiveCSID = "";
        OrderSale.prototype.SPGiveCSTitle = "";
        OrderSale.prototype.SPGiveCSRecID = "";
        OrderSale.prototype.SPGiveCSNotes = "";
        OrderSale.prototype.CSID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        OrderSale.prototype.CSRecID = "";
        OrderSale.prototype.CSTitle1 = "";
        OrderSale.prototype.CSTitle2 = "";
        OrderSale.prototype.CSTitle3 = "";
        OrderSale.prototype.CSCate = 0;
        OrderSale.prototype.CSTotalGoodsAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderSale.prototype.CSSalesAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderSale.prototype.CSIsGiveGoods = 0;
        OrderSale.prototype.CSIsGiveAmt = 0;
        OrderSale.prototype.CSGiveAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderSale.prototype.CSIsGivePoints = 0;
        OrderSale.prototype.CSGivePoints = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderSale.prototype.CSSalesPostageAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderSale.prototype.CSOnSalesAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderSale.prototype.IsAdjSales = 0;
        OrderSale.prototype.AdjSalesAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderSale.prototype.IsCC = 0;
        OrderSale.prototype.CCTitle1 = "";
        OrderSale.prototype.CCTitle2 = "";
        OrderSale.prototype.CCTitle3 = "";
        OrderSale.prototype.CCCate = 0;
        OrderSale.prototype.CCDisRate = 0;
        OrderSale.prototype.CCSalesAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderSale.prototype.CCSalesMaxAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderSale.prototype.CCSalesNotes = "";
        OrderSale.prototype.GiveState = 0;
        OrderSale.prototype.IsDisSale = 0;
        OrderSale.prototype.TotalDisSaleAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderSale.prototype.CreateTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderSale.prototype.CreaterID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        OrderSale.prototype.UpdateTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderSale.prototype.UpdaterID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        OrderSale.prototype.Estate = 0;

        OrderSale.create = function create(properties) {
            return new OrderSale(properties);
        };

        OrderSale.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.OrderID != null && Object.hasOwnProperty.call(m, "OrderID"))
                w.uint32(10).string(m.OrderID);
            if (m.MchID != null && Object.hasOwnProperty.call(m, "MchID"))
                w.uint32(16).uint64(m.MchID);
            if (m.UserID != null && Object.hasOwnProperty.call(m, "UserID"))
                w.uint32(24).uint64(m.UserID);
            if (m.TransDate != null && Object.hasOwnProperty.call(m, "TransDate"))
                w.uint32(32).int64(m.TransDate);
            if (m.PromoID != null && Object.hasOwnProperty.call(m, "PromoID"))
                w.uint32(40).uint64(m.PromoID);
            if (m.SPTitle1 != null && Object.hasOwnProperty.call(m, "SPTitle1"))
                w.uint32(50).string(m.SPTitle1);
            if (m.SPTitle2 != null && Object.hasOwnProperty.call(m, "SPTitle2"))
                w.uint32(58).string(m.SPTitle2);
            if (m.SPTitle3 != null && Object.hasOwnProperty.call(m, "SPTitle3"))
                w.uint32(66).string(m.SPTitle3);
            if (m.SPTotalGoodsAmt != null && Object.hasOwnProperty.call(m, "SPTotalGoodsAmt"))
                w.uint32(72).int64(m.SPTotalGoodsAmt);
            if (m.SPIsSalesAmt != null && Object.hasOwnProperty.call(m, "SPIsSalesAmt"))
                w.uint32(80).int32(m.SPIsSalesAmt);
            if (m.SPSalesAmt != null && Object.hasOwnProperty.call(m, "SPSalesAmt"))
                w.uint32(88).int64(m.SPSalesAmt);
            if (m.SPDisSalesAmt != null && Object.hasOwnProperty.call(m, "SPDisSalesAmt"))
                w.uint32(96).int64(m.SPDisSalesAmt);
            if (m.SPIsGiveAmt != null && Object.hasOwnProperty.call(m, "SPIsGiveAmt"))
                w.uint32(104).int32(m.SPIsGiveAmt);
            if (m.SPGiveAmt != null && Object.hasOwnProperty.call(m, "SPGiveAmt"))
                w.uint32(112).int64(m.SPGiveAmt);
            if (m.SPIsGivePoints != null && Object.hasOwnProperty.call(m, "SPIsGivePoints"))
                w.uint32(120).int32(m.SPIsGivePoints);
            if (m.SPGivePoints != null && Object.hasOwnProperty.call(m, "SPGivePoints"))
                w.uint32(128).int64(m.SPGivePoints);
            if (m.SPIsGiveGoods != null && Object.hasOwnProperty.call(m, "SPIsGiveGoods"))
                w.uint32(136).int32(m.SPIsGiveGoods);
            if (m.SPIsGiveCoupon != null && Object.hasOwnProperty.call(m, "SPIsGiveCoupon"))
                w.uint32(144).int32(m.SPIsGiveCoupon);
            if (m.SPGiveCSID != null && Object.hasOwnProperty.call(m, "SPGiveCSID"))
                w.uint32(154).string(m.SPGiveCSID);
            if (m.SPGiveCSTitle != null && Object.hasOwnProperty.call(m, "SPGiveCSTitle"))
                w.uint32(162).string(m.SPGiveCSTitle);
            if (m.SPGiveCSRecID != null && Object.hasOwnProperty.call(m, "SPGiveCSRecID"))
                w.uint32(170).string(m.SPGiveCSRecID);
            if (m.SPGiveCSNotes != null && Object.hasOwnProperty.call(m, "SPGiveCSNotes"))
                w.uint32(178).string(m.SPGiveCSNotes);
            if (m.CSID != null && Object.hasOwnProperty.call(m, "CSID"))
                w.uint32(184).uint64(m.CSID);
            if (m.CSRecID != null && Object.hasOwnProperty.call(m, "CSRecID"))
                w.uint32(194).string(m.CSRecID);
            if (m.CSTitle1 != null && Object.hasOwnProperty.call(m, "CSTitle1"))
                w.uint32(202).string(m.CSTitle1);
            if (m.CSTitle2 != null && Object.hasOwnProperty.call(m, "CSTitle2"))
                w.uint32(210).string(m.CSTitle2);
            if (m.CSTitle3 != null && Object.hasOwnProperty.call(m, "CSTitle3"))
                w.uint32(218).string(m.CSTitle3);
            if (m.CSCate != null && Object.hasOwnProperty.call(m, "CSCate"))
                w.uint32(224).int32(m.CSCate);
            if (m.CSTotalGoodsAmt != null && Object.hasOwnProperty.call(m, "CSTotalGoodsAmt"))
                w.uint32(232).int64(m.CSTotalGoodsAmt);
            if (m.CSSalesAmt != null && Object.hasOwnProperty.call(m, "CSSalesAmt"))
                w.uint32(240).int64(m.CSSalesAmt);
            if (m.CSIsGiveGoods != null && Object.hasOwnProperty.call(m, "CSIsGiveGoods"))
                w.uint32(248).int32(m.CSIsGiveGoods);
            if (m.CSIsGiveAmt != null && Object.hasOwnProperty.call(m, "CSIsGiveAmt"))
                w.uint32(256).int32(m.CSIsGiveAmt);
            if (m.CSGiveAmt != null && Object.hasOwnProperty.call(m, "CSGiveAmt"))
                w.uint32(264).int64(m.CSGiveAmt);
            if (m.CSIsGivePoints != null && Object.hasOwnProperty.call(m, "CSIsGivePoints"))
                w.uint32(272).int32(m.CSIsGivePoints);
            if (m.CSGivePoints != null && Object.hasOwnProperty.call(m, "CSGivePoints"))
                w.uint32(280).int64(m.CSGivePoints);
            if (m.CSSalesPostageAmt != null && Object.hasOwnProperty.call(m, "CSSalesPostageAmt"))
                w.uint32(288).int64(m.CSSalesPostageAmt);
            if (m.CSOnSalesAmt != null && Object.hasOwnProperty.call(m, "CSOnSalesAmt"))
                w.uint32(296).int64(m.CSOnSalesAmt);
            if (m.IsAdjSales != null && Object.hasOwnProperty.call(m, "IsAdjSales"))
                w.uint32(304).int32(m.IsAdjSales);
            if (m.AdjSalesAmt != null && Object.hasOwnProperty.call(m, "AdjSalesAmt"))
                w.uint32(312).int64(m.AdjSalesAmt);
            if (m.IsCC != null && Object.hasOwnProperty.call(m, "IsCC"))
                w.uint32(320).int32(m.IsCC);
            if (m.CCTitle1 != null && Object.hasOwnProperty.call(m, "CCTitle1"))
                w.uint32(330).string(m.CCTitle1);
            if (m.CCTitle2 != null && Object.hasOwnProperty.call(m, "CCTitle2"))
                w.uint32(338).string(m.CCTitle2);
            if (m.CCTitle3 != null && Object.hasOwnProperty.call(m, "CCTitle3"))
                w.uint32(346).string(m.CCTitle3);
            if (m.CCCate != null && Object.hasOwnProperty.call(m, "CCCate"))
                w.uint32(352).int32(m.CCCate);
            if (m.CCDisRate != null && Object.hasOwnProperty.call(m, "CCDisRate"))
                w.uint32(360).int32(m.CCDisRate);
            if (m.CCSalesAmt != null && Object.hasOwnProperty.call(m, "CCSalesAmt"))
                w.uint32(368).int64(m.CCSalesAmt);
            if (m.CCSalesMaxAmt != null && Object.hasOwnProperty.call(m, "CCSalesMaxAmt"))
                w.uint32(376).int64(m.CCSalesMaxAmt);
            if (m.CCSalesNotes != null && Object.hasOwnProperty.call(m, "CCSalesNotes"))
                w.uint32(386).string(m.CCSalesNotes);
            if (m.GiveState != null && Object.hasOwnProperty.call(m, "GiveState"))
                w.uint32(392).int32(m.GiveState);
            if (m.IsDisSale != null && Object.hasOwnProperty.call(m, "IsDisSale"))
                w.uint32(400).int32(m.IsDisSale);
            if (m.TotalDisSaleAmt != null && Object.hasOwnProperty.call(m, "TotalDisSaleAmt"))
                w.uint32(408).int64(m.TotalDisSaleAmt);
            if (m.CreateTime != null && Object.hasOwnProperty.call(m, "CreateTime"))
                w.uint32(416).int64(m.CreateTime);
            if (m.CreaterID != null && Object.hasOwnProperty.call(m, "CreaterID"))
                w.uint32(424).uint64(m.CreaterID);
            if (m.UpdateTime != null && Object.hasOwnProperty.call(m, "UpdateTime"))
                w.uint32(432).int64(m.UpdateTime);
            if (m.UpdaterID != null && Object.hasOwnProperty.call(m, "UpdaterID"))
                w.uint32(440).uint64(m.UpdaterID);
            if (m.Estate != null && Object.hasOwnProperty.call(m, "Estate"))
                w.uint32(448).int32(m.Estate);
            return w;
        };

        OrderSale.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.OrderSale();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        m.OrderID = r.string();
                        break;
                    }
                    case 2: {
                        m.MchID = r.uint64();
                        break;
                    }
                    case 3: {
                        m.UserID = r.uint64();
                        break;
                    }
                    case 4: {
                        m.TransDate = r.int64();
                        break;
                    }
                    case 5: {
                        m.PromoID = r.uint64();
                        break;
                    }
                    case 6: {
                        m.SPTitle1 = r.string();
                        break;
                    }
                    case 7: {
                        m.SPTitle2 = r.string();
                        break;
                    }
                    case 8: {
                        m.SPTitle3 = r.string();
                        break;
                    }
                    case 9: {
                        m.SPTotalGoodsAmt = r.int64();
                        break;
                    }
                    case 10: {
                        m.SPIsSalesAmt = r.int32();
                        break;
                    }
                    case 11: {
                        m.SPSalesAmt = r.int64();
                        break;
                    }
                    case 12: {
                        m.SPDisSalesAmt = r.int64();
                        break;
                    }
                    case 13: {
                        m.SPIsGiveAmt = r.int32();
                        break;
                    }
                    case 14: {
                        m.SPGiveAmt = r.int64();
                        break;
                    }
                    case 15: {
                        m.SPIsGivePoints = r.int32();
                        break;
                    }
                    case 16: {
                        m.SPGivePoints = r.int64();
                        break;
                    }
                    case 17: {
                        m.SPIsGiveGoods = r.int32();
                        break;
                    }
                    case 18: {
                        m.SPIsGiveCoupon = r.int32();
                        break;
                    }
                    case 19: {
                        m.SPGiveCSID = r.string();
                        break;
                    }
                    case 20: {
                        m.SPGiveCSTitle = r.string();
                        break;
                    }
                    case 21: {
                        m.SPGiveCSRecID = r.string();
                        break;
                    }
                    case 22: {
                        m.SPGiveCSNotes = r.string();
                        break;
                    }
                    case 23: {
                        m.CSID = r.uint64();
                        break;
                    }
                    case 24: {
                        m.CSRecID = r.string();
                        break;
                    }
                    case 25: {
                        m.CSTitle1 = r.string();
                        break;
                    }
                    case 26: {
                        m.CSTitle2 = r.string();
                        break;
                    }
                    case 27: {
                        m.CSTitle3 = r.string();
                        break;
                    }
                    case 28: {
                        m.CSCate = r.int32();
                        break;
                    }
                    case 29: {
                        m.CSTotalGoodsAmt = r.int64();
                        break;
                    }
                    case 30: {
                        m.CSSalesAmt = r.int64();
                        break;
                    }
                    case 31: {
                        m.CSIsGiveGoods = r.int32();
                        break;
                    }
                    case 32: {
                        m.CSIsGiveAmt = r.int32();
                        break;
                    }
                    case 33: {
                        m.CSGiveAmt = r.int64();
                        break;
                    }
                    case 34: {
                        m.CSIsGivePoints = r.int32();
                        break;
                    }
                    case 35: {
                        m.CSGivePoints = r.int64();
                        break;
                    }
                    case 36: {
                        m.CSSalesPostageAmt = r.int64();
                        break;
                    }
                    case 37: {
                        m.CSOnSalesAmt = r.int64();
                        break;
                    }
                    case 38: {
                        m.IsAdjSales = r.int32();
                        break;
                    }
                    case 39: {
                        m.AdjSalesAmt = r.int64();
                        break;
                    }
                    case 40: {
                        m.IsCC = r.int32();
                        break;
                    }
                    case 41: {
                        m.CCTitle1 = r.string();
                        break;
                    }
                    case 42: {
                        m.CCTitle2 = r.string();
                        break;
                    }
                    case 43: {
                        m.CCTitle3 = r.string();
                        break;
                    }
                    case 44: {
                        m.CCCate = r.int32();
                        break;
                    }
                    case 45: {
                        m.CCDisRate = r.int32();
                        break;
                    }
                    case 46: {
                        m.CCSalesAmt = r.int64();
                        break;
                    }
                    case 47: {
                        m.CCSalesMaxAmt = r.int64();
                        break;
                    }
                    case 48: {
                        m.CCSalesNotes = r.string();
                        break;
                    }
                    case 49: {
                        m.GiveState = r.int32();
                        break;
                    }
                    case 50: {
                        m.IsDisSale = r.int32();
                        break;
                    }
                    case 51: {
                        m.TotalDisSaleAmt = r.int64();
                        break;
                    }
                    case 52: {
                        m.CreateTime = r.int64();
                        break;
                    }
                    case 53: {
                        m.CreaterID = r.uint64();
                        break;
                    }
                    case 54: {
                        m.UpdateTime = r.int64();
                        break;
                    }
                    case 55: {
                        m.UpdaterID = r.uint64();
                        break;
                    }
                    case 56: {
                        m.Estate = r.int32();
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        OrderSale.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.OrderSale";
        };

        return OrderSale;
    })();

    PBEntity.OrderSales = (function () {

        function OrderSales(p) {
            this.OrderSales = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        OrderSales.prototype.OrderSales = $util.emptyArray;

        OrderSales.create = function create(properties) {
            return new OrderSales(properties);
        };

        OrderSales.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.OrderSales != null && m.OrderSales.length) {
                for (var i = 0; i < m.OrderSales.length; ++i)
                    $root.PBEntity.OrderSale.encode(m.OrderSales[i], w.uint32(10).fork()).ldelim();
            }
            return w;
        };

        OrderSales.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.OrderSales();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        if (!(m.OrderSales && m.OrderSales.length))
                            m.OrderSales = [];
                        m.OrderSales.push($root.PBEntity.OrderSale.decode(r, r.uint32()));
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        OrderSales.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.OrderSales";
        };

        return OrderSales;
    })();

    PBEntity.OrderSubsNotice = (function () {

        function OrderSubsNotice(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        OrderSubsNotice.prototype.ID = "";
        OrderSubsNotice.prototype.OrderCate = 0;
        OrderSubsNotice.prototype.MchID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        OrderSubsNotice.prototype.MchCate = 0;
        OrderSubsNotice.prototype.UserID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        OrderSubsNotice.prototype.AtChannel = 0;
        OrderSubsNotice.prototype.IsNAO = 0;
        OrderSubsNotice.prototype.NAOSend = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderSubsNotice.prototype.IsNSO = 0;
        OrderSubsNotice.prototype.NSOSend = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderSubsNotice.prototype.IsNFO = 0;
        OrderSubsNotice.prototype.NFOSend = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderSubsNotice.prototype.CreateTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderSubsNotice.prototype.CreaterID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        OrderSubsNotice.prototype.UpdateTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderSubsNotice.prototype.UpdaterID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        OrderSubsNotice.prototype.Estate = 0;

        OrderSubsNotice.create = function create(properties) {
            return new OrderSubsNotice(properties);
        };

        OrderSubsNotice.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.ID != null && Object.hasOwnProperty.call(m, "ID"))
                w.uint32(10).string(m.ID);
            if (m.OrderCate != null && Object.hasOwnProperty.call(m, "OrderCate"))
                w.uint32(16).int32(m.OrderCate);
            if (m.MchID != null && Object.hasOwnProperty.call(m, "MchID"))
                w.uint32(24).uint64(m.MchID);
            if (m.MchCate != null && Object.hasOwnProperty.call(m, "MchCate"))
                w.uint32(32).int32(m.MchCate);
            if (m.UserID != null && Object.hasOwnProperty.call(m, "UserID"))
                w.uint32(40).uint64(m.UserID);
            if (m.AtChannel != null && Object.hasOwnProperty.call(m, "AtChannel"))
                w.uint32(48).int32(m.AtChannel);
            if (m.IsNAO != null && Object.hasOwnProperty.call(m, "IsNAO"))
                w.uint32(56).int32(m.IsNAO);
            if (m.NAOSend != null && Object.hasOwnProperty.call(m, "NAOSend"))
                w.uint32(64).int64(m.NAOSend);
            if (m.IsNSO != null && Object.hasOwnProperty.call(m, "IsNSO"))
                w.uint32(72).int32(m.IsNSO);
            if (m.NSOSend != null && Object.hasOwnProperty.call(m, "NSOSend"))
                w.uint32(80).int64(m.NSOSend);
            if (m.IsNFO != null && Object.hasOwnProperty.call(m, "IsNFO"))
                w.uint32(88).int32(m.IsNFO);
            if (m.NFOSend != null && Object.hasOwnProperty.call(m, "NFOSend"))
                w.uint32(96).int64(m.NFOSend);
            if (m.CreateTime != null && Object.hasOwnProperty.call(m, "CreateTime"))
                w.uint32(104).int64(m.CreateTime);
            if (m.CreaterID != null && Object.hasOwnProperty.call(m, "CreaterID"))
                w.uint32(112).uint64(m.CreaterID);
            if (m.UpdateTime != null && Object.hasOwnProperty.call(m, "UpdateTime"))
                w.uint32(120).int64(m.UpdateTime);
            if (m.UpdaterID != null && Object.hasOwnProperty.call(m, "UpdaterID"))
                w.uint32(128).uint64(m.UpdaterID);
            if (m.Estate != null && Object.hasOwnProperty.call(m, "Estate"))
                w.uint32(136).int32(m.Estate);
            return w;
        };

        OrderSubsNotice.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.OrderSubsNotice();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        m.ID = r.string();
                        break;
                    }
                    case 2: {
                        m.OrderCate = r.int32();
                        break;
                    }
                    case 3: {
                        m.MchID = r.uint64();
                        break;
                    }
                    case 4: {
                        m.MchCate = r.int32();
                        break;
                    }
                    case 5: {
                        m.UserID = r.uint64();
                        break;
                    }
                    case 6: {
                        m.AtChannel = r.int32();
                        break;
                    }
                    case 7: {
                        m.IsNAO = r.int32();
                        break;
                    }
                    case 8: {
                        m.NAOSend = r.int64();
                        break;
                    }
                    case 9: {
                        m.IsNSO = r.int32();
                        break;
                    }
                    case 10: {
                        m.NSOSend = r.int64();
                        break;
                    }
                    case 11: {
                        m.IsNFO = r.int32();
                        break;
                    }
                    case 12: {
                        m.NFOSend = r.int64();
                        break;
                    }
                    case 13: {
                        m.CreateTime = r.int64();
                        break;
                    }
                    case 14: {
                        m.CreaterID = r.uint64();
                        break;
                    }
                    case 15: {
                        m.UpdateTime = r.int64();
                        break;
                    }
                    case 16: {
                        m.UpdaterID = r.uint64();
                        break;
                    }
                    case 17: {
                        m.Estate = r.int32();
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        OrderSubsNotice.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.OrderSubsNotice";
        };

        return OrderSubsNotice;
    })();

    PBEntity.OrderSubsNotices = (function () {

        function OrderSubsNotices(p) {
            this.OrderSubsNotices = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        OrderSubsNotices.prototype.OrderSubsNotices = $util.emptyArray;

        OrderSubsNotices.create = function create(properties) {
            return new OrderSubsNotices(properties);
        };

        OrderSubsNotices.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.OrderSubsNotices != null && m.OrderSubsNotices.length) {
                for (var i = 0; i < m.OrderSubsNotices.length; ++i)
                    $root.PBEntity.OrderSubsNotice.encode(m.OrderSubsNotices[i], w.uint32(10).fork()).ldelim();
            }
            return w;
        };

        OrderSubsNotices.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.OrderSubsNotices();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        if (!(m.OrderSubsNotices && m.OrderSubsNotices.length))
                            m.OrderSubsNotices = [];
                        m.OrderSubsNotices.push($root.PBEntity.OrderSubsNotice.decode(r, r.uint32()));
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        OrderSubsNotices.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.OrderSubsNotices";
        };

        return OrderSubsNotices;
    })();

    PBEntity.OrderVoiceNotice = (function () {

        function OrderVoiceNotice(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        OrderVoiceNotice.prototype.ID = "";
        OrderVoiceNotice.prototype.VbID = "";
        OrderVoiceNotice.prototype.VbName = "";
        OrderVoiceNotice.prototype.MchID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        OrderVoiceNotice.prototype.ClientID = "";
        OrderVoiceNotice.prototype.VbCate = 0;
        OrderVoiceNotice.prototype.ReID = "";
        OrderVoiceNotice.prototype.ReIDCate = 0;
        OrderVoiceNotice.prototype.DistrMode = 0;
        OrderVoiceNotice.prototype.SaleSeq = 0;
        OrderVoiceNotice.prototype.DeskName = "";
        OrderVoiceNotice.prototype.Amt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderVoiceNotice.prototype.PayChannel = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        OrderVoiceNotice.prototype.VbContent = "";
        OrderVoiceNotice.prototype.VbResult = 0;
        OrderVoiceNotice.prototype.VbTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderVoiceNotice.prototype.CreateTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderVoiceNotice.prototype.CreaterID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        OrderVoiceNotice.prototype.UpdateTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        OrderVoiceNotice.prototype.UpdaterID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        OrderVoiceNotice.prototype.Estate = 0;

        OrderVoiceNotice.create = function create(properties) {
            return new OrderVoiceNotice(properties);
        };

        OrderVoiceNotice.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.ID != null && Object.hasOwnProperty.call(m, "ID"))
                w.uint32(10).string(m.ID);
            if (m.VbID != null && Object.hasOwnProperty.call(m, "VbID"))
                w.uint32(18).string(m.VbID);
            if (m.VbName != null && Object.hasOwnProperty.call(m, "VbName"))
                w.uint32(26).string(m.VbName);
            if (m.MchID != null && Object.hasOwnProperty.call(m, "MchID"))
                w.uint32(32).uint64(m.MchID);
            if (m.ClientID != null && Object.hasOwnProperty.call(m, "ClientID"))
                w.uint32(42).string(m.ClientID);
            if (m.VbCate != null && Object.hasOwnProperty.call(m, "VbCate"))
                w.uint32(48).int32(m.VbCate);
            if (m.ReID != null && Object.hasOwnProperty.call(m, "ReID"))
                w.uint32(58).string(m.ReID);
            if (m.ReIDCate != null && Object.hasOwnProperty.call(m, "ReIDCate"))
                w.uint32(64).int32(m.ReIDCate);
            if (m.DistrMode != null && Object.hasOwnProperty.call(m, "DistrMode"))
                w.uint32(72).int32(m.DistrMode);
            if (m.SaleSeq != null && Object.hasOwnProperty.call(m, "SaleSeq"))
                w.uint32(80).int32(m.SaleSeq);
            if (m.DeskName != null && Object.hasOwnProperty.call(m, "DeskName"))
                w.uint32(90).string(m.DeskName);
            if (m.Amt != null && Object.hasOwnProperty.call(m, "Amt"))
                w.uint32(96).int64(m.Amt);
            if (m.PayChannel != null && Object.hasOwnProperty.call(m, "PayChannel"))
                w.uint32(104).uint64(m.PayChannel);
            if (m.VbContent != null && Object.hasOwnProperty.call(m, "VbContent"))
                w.uint32(114).string(m.VbContent);
            if (m.VbResult != null && Object.hasOwnProperty.call(m, "VbResult"))
                w.uint32(120).int32(m.VbResult);
            if (m.VbTime != null && Object.hasOwnProperty.call(m, "VbTime"))
                w.uint32(128).int64(m.VbTime);
            if (m.CreateTime != null && Object.hasOwnProperty.call(m, "CreateTime"))
                w.uint32(136).int64(m.CreateTime);
            if (m.CreaterID != null && Object.hasOwnProperty.call(m, "CreaterID"))
                w.uint32(144).uint64(m.CreaterID);
            if (m.UpdateTime != null && Object.hasOwnProperty.call(m, "UpdateTime"))
                w.uint32(152).int64(m.UpdateTime);
            if (m.UpdaterID != null && Object.hasOwnProperty.call(m, "UpdaterID"))
                w.uint32(160).uint64(m.UpdaterID);
            if (m.Estate != null && Object.hasOwnProperty.call(m, "Estate"))
                w.uint32(168).int32(m.Estate);
            return w;
        };

        OrderVoiceNotice.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.OrderVoiceNotice();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        m.ID = r.string();
                        break;
                    }
                    case 2: {
                        m.VbID = r.string();
                        break;
                    }
                    case 3: {
                        m.VbName = r.string();
                        break;
                    }
                    case 4: {
                        m.MchID = r.uint64();
                        break;
                    }
                    case 5: {
                        m.ClientID = r.string();
                        break;
                    }
                    case 6: {
                        m.VbCate = r.int32();
                        break;
                    }
                    case 7: {
                        m.ReID = r.string();
                        break;
                    }
                    case 8: {
                        m.ReIDCate = r.int32();
                        break;
                    }
                    case 9: {
                        m.DistrMode = r.int32();
                        break;
                    }
                    case 10: {
                        m.SaleSeq = r.int32();
                        break;
                    }
                    case 11: {
                        m.DeskName = r.string();
                        break;
                    }
                    case 12: {
                        m.Amt = r.int64();
                        break;
                    }
                    case 13: {
                        m.PayChannel = r.uint64();
                        break;
                    }
                    case 14: {
                        m.VbContent = r.string();
                        break;
                    }
                    case 15: {
                        m.VbResult = r.int32();
                        break;
                    }
                    case 16: {
                        m.VbTime = r.int64();
                        break;
                    }
                    case 17: {
                        m.CreateTime = r.int64();
                        break;
                    }
                    case 18: {
                        m.CreaterID = r.uint64();
                        break;
                    }
                    case 19: {
                        m.UpdateTime = r.int64();
                        break;
                    }
                    case 20: {
                        m.UpdaterID = r.uint64();
                        break;
                    }
                    case 21: {
                        m.Estate = r.int32();
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        OrderVoiceNotice.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.OrderVoiceNotice";
        };

        return OrderVoiceNotice;
    })();

    PBEntity.OrderVoiceNotices = (function () {

        function OrderVoiceNotices(p) {
            this.OrderVoiceNotices = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        OrderVoiceNotices.prototype.OrderVoiceNotices = $util.emptyArray;

        OrderVoiceNotices.create = function create(properties) {
            return new OrderVoiceNotices(properties);
        };

        OrderVoiceNotices.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.OrderVoiceNotices != null && m.OrderVoiceNotices.length) {
                for (var i = 0; i < m.OrderVoiceNotices.length; ++i)
                    $root.PBEntity.OrderVoiceNotice.encode(m.OrderVoiceNotices[i], w.uint32(10).fork()).ldelim();
            }
            return w;
        };

        OrderVoiceNotices.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.OrderVoiceNotices();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        if (!(m.OrderVoiceNotices && m.OrderVoiceNotices.length))
                            m.OrderVoiceNotices = [];
                        m.OrderVoiceNotices.push($root.PBEntity.OrderVoiceNotice.decode(r, r.uint32()));
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        OrderVoiceNotices.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.OrderVoiceNotices";
        };

        return OrderVoiceNotices;
    })();

    PBEntity.PayOrder = (function () {

        function PayOrder(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        PayOrder.prototype.ID = "";
        PayOrder.prototype.ReID = "";
        PayOrder.prototype.ReIDCate = 0;
        PayOrder.prototype.MchID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        PayOrder.prototype.PayCate = 0;
        PayOrder.prototype.UserID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        PayOrder.prototype.ToAccUserID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        PayOrder.prototype.UUID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        PayOrder.prototype.PayPlatform = 0;
        PayOrder.prototype.PayChannel = 0;
        PayOrder.prototype.PayTitle = "";
        PayOrder.prototype.PayState = 0;
        PayOrder.prototype.PayAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        PayOrder.prototype.PayExpires = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        PayOrder.prototype.AppID = "";
        PayOrder.prototype.SubAppID = "";
        PayOrder.prototype.PayMchID = "";
        PayOrder.prototype.PaySubMchID = "";
        PayOrder.prototype.PayOpenID = "";
        PayOrder.prototype.TradeNo = "";
        PayOrder.prototype.ZfbAppAuthToken = "";
        PayOrder.prototype.ZfbShopID = "";
        PayOrder.prototype.ZfbRecordID = "";
        PayOrder.prototype.ZfbOrderID = "";
        PayOrder.prototype.ZfbOrderStatus = "";
        PayOrder.prototype.ZfbService = 0;
        PayOrder.prototype.ZfbSyncTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        PayOrder.prototype.AuthCode = "";
        PayOrder.prototype.PrepayID = "";
        PayOrder.prototype.CodeURL = "";
        PayOrder.prototype.NWebURL = "";
        PayOrder.prototype.ResultCode = "";
        PayOrder.prototype.ReturnTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        PayOrder.prototype.RetIP = "";
        PayOrder.prototype.RetTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        PayOrder.prototype.RetAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        PayOrder.prototype.RetTradeState = "";
        PayOrder.prototype.RetTradeStateDesc = "";
        PayOrder.prototype.FromIP = "";
        PayOrder.prototype.FromTokeID = "";
        PayOrder.prototype.RefundAmtCount = 0;
        PayOrder.prototype.RefundAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        PayOrder.prototype.OnRefundAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        PayOrder.prototype.SyncState = 0;
        PayOrder.prototype.SyncTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        PayOrder.prototype.GroupID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        PayOrder.prototype.AgentID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        PayOrder.prototype.CreateTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        PayOrder.prototype.CreaterID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        PayOrder.prototype.UpdateTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        PayOrder.prototype.UpdaterID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        PayOrder.prototype.Estate = 0;

        PayOrder.create = function create(properties) {
            return new PayOrder(properties);
        };

        PayOrder.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.ID != null && Object.hasOwnProperty.call(m, "ID"))
                w.uint32(10).string(m.ID);
            if (m.ReID != null && Object.hasOwnProperty.call(m, "ReID"))
                w.uint32(18).string(m.ReID);
            if (m.ReIDCate != null && Object.hasOwnProperty.call(m, "ReIDCate"))
                w.uint32(24).int32(m.ReIDCate);
            if (m.MchID != null && Object.hasOwnProperty.call(m, "MchID"))
                w.uint32(32).uint64(m.MchID);
            if (m.PayCate != null && Object.hasOwnProperty.call(m, "PayCate"))
                w.uint32(40).int32(m.PayCate);
            if (m.UserID != null && Object.hasOwnProperty.call(m, "UserID"))
                w.uint32(48).uint64(m.UserID);
            if (m.ToAccUserID != null && Object.hasOwnProperty.call(m, "ToAccUserID"))
                w.uint32(56).uint64(m.ToAccUserID);
            if (m.UUID != null && Object.hasOwnProperty.call(m, "UUID"))
                w.uint32(64).uint64(m.UUID);
            if (m.PayPlatform != null && Object.hasOwnProperty.call(m, "PayPlatform"))
                w.uint32(72).int32(m.PayPlatform);
            if (m.PayChannel != null && Object.hasOwnProperty.call(m, "PayChannel"))
                w.uint32(80).int32(m.PayChannel);
            if (m.PayTitle != null && Object.hasOwnProperty.call(m, "PayTitle"))
                w.uint32(90).string(m.PayTitle);
            if (m.PayState != null && Object.hasOwnProperty.call(m, "PayState"))
                w.uint32(96).int32(m.PayState);
            if (m.PayAmt != null && Object.hasOwnProperty.call(m, "PayAmt"))
                w.uint32(104).int64(m.PayAmt);
            if (m.PayExpires != null && Object.hasOwnProperty.call(m, "PayExpires"))
                w.uint32(112).int64(m.PayExpires);
            if (m.AppID != null && Object.hasOwnProperty.call(m, "AppID"))
                w.uint32(122).string(m.AppID);
            if (m.SubAppID != null && Object.hasOwnProperty.call(m, "SubAppID"))
                w.uint32(130).string(m.SubAppID);
            if (m.PayMchID != null && Object.hasOwnProperty.call(m, "PayMchID"))
                w.uint32(138).string(m.PayMchID);
            if (m.PaySubMchID != null && Object.hasOwnProperty.call(m, "PaySubMchID"))
                w.uint32(146).string(m.PaySubMchID);
            if (m.PayOpenID != null && Object.hasOwnProperty.call(m, "PayOpenID"))
                w.uint32(154).string(m.PayOpenID);
            if (m.TradeNo != null && Object.hasOwnProperty.call(m, "TradeNo"))
                w.uint32(162).string(m.TradeNo);
            if (m.ZfbAppAuthToken != null && Object.hasOwnProperty.call(m, "ZfbAppAuthToken"))
                w.uint32(170).string(m.ZfbAppAuthToken);
            if (m.ZfbShopID != null && Object.hasOwnProperty.call(m, "ZfbShopID"))
                w.uint32(178).string(m.ZfbShopID);
            if (m.ZfbRecordID != null && Object.hasOwnProperty.call(m, "ZfbRecordID"))
                w.uint32(186).string(m.ZfbRecordID);
            if (m.ZfbOrderID != null && Object.hasOwnProperty.call(m, "ZfbOrderID"))
                w.uint32(194).string(m.ZfbOrderID);
            if (m.ZfbOrderStatus != null && Object.hasOwnProperty.call(m, "ZfbOrderStatus"))
                w.uint32(202).string(m.ZfbOrderStatus);
            if (m.ZfbService != null && Object.hasOwnProperty.call(m, "ZfbService"))
                w.uint32(208).int32(m.ZfbService);
            if (m.ZfbSyncTime != null && Object.hasOwnProperty.call(m, "ZfbSyncTime"))
                w.uint32(216).int64(m.ZfbSyncTime);
            if (m.AuthCode != null && Object.hasOwnProperty.call(m, "AuthCode"))
                w.uint32(226).string(m.AuthCode);
            if (m.PrepayID != null && Object.hasOwnProperty.call(m, "PrepayID"))
                w.uint32(234).string(m.PrepayID);
            if (m.CodeURL != null && Object.hasOwnProperty.call(m, "CodeURL"))
                w.uint32(242).string(m.CodeURL);
            if (m.NWebURL != null && Object.hasOwnProperty.call(m, "NWebURL"))
                w.uint32(250).string(m.NWebURL);
            if (m.ResultCode != null && Object.hasOwnProperty.call(m, "ResultCode"))
                w.uint32(258).string(m.ResultCode);
            if (m.ReturnTime != null && Object.hasOwnProperty.call(m, "ReturnTime"))
                w.uint32(264).int64(m.ReturnTime);
            if (m.RetIP != null && Object.hasOwnProperty.call(m, "RetIP"))
                w.uint32(274).string(m.RetIP);
            if (m.RetTime != null && Object.hasOwnProperty.call(m, "RetTime"))
                w.uint32(280).int64(m.RetTime);
            if (m.RetAmt != null && Object.hasOwnProperty.call(m, "RetAmt"))
                w.uint32(288).int64(m.RetAmt);
            if (m.RetTradeState != null && Object.hasOwnProperty.call(m, "RetTradeState"))
                w.uint32(298).string(m.RetTradeState);
            if (m.RetTradeStateDesc != null && Object.hasOwnProperty.call(m, "RetTradeStateDesc"))
                w.uint32(306).string(m.RetTradeStateDesc);
            if (m.FromIP != null && Object.hasOwnProperty.call(m, "FromIP"))
                w.uint32(314).string(m.FromIP);
            if (m.FromTokeID != null && Object.hasOwnProperty.call(m, "FromTokeID"))
                w.uint32(322).string(m.FromTokeID);
            if (m.RefundAmtCount != null && Object.hasOwnProperty.call(m, "RefundAmtCount"))
                w.uint32(328).int32(m.RefundAmtCount);
            if (m.RefundAmt != null && Object.hasOwnProperty.call(m, "RefundAmt"))
                w.uint32(336).int64(m.RefundAmt);
            if (m.OnRefundAmt != null && Object.hasOwnProperty.call(m, "OnRefundAmt"))
                w.uint32(344).int64(m.OnRefundAmt);
            if (m.SyncState != null && Object.hasOwnProperty.call(m, "SyncState"))
                w.uint32(352).int32(m.SyncState);
            if (m.SyncTime != null && Object.hasOwnProperty.call(m, "SyncTime"))
                w.uint32(360).int64(m.SyncTime);
            if (m.GroupID != null && Object.hasOwnProperty.call(m, "GroupID"))
                w.uint32(368).uint64(m.GroupID);
            if (m.AgentID != null && Object.hasOwnProperty.call(m, "AgentID"))
                w.uint32(376).uint64(m.AgentID);
            if (m.CreateTime != null && Object.hasOwnProperty.call(m, "CreateTime"))
                w.uint32(384).int64(m.CreateTime);
            if (m.CreaterID != null && Object.hasOwnProperty.call(m, "CreaterID"))
                w.uint32(392).uint64(m.CreaterID);
            if (m.UpdateTime != null && Object.hasOwnProperty.call(m, "UpdateTime"))
                w.uint32(400).int64(m.UpdateTime);
            if (m.UpdaterID != null && Object.hasOwnProperty.call(m, "UpdaterID"))
                w.uint32(408).uint64(m.UpdaterID);
            if (m.Estate != null && Object.hasOwnProperty.call(m, "Estate"))
                w.uint32(416).int32(m.Estate);
            return w;
        };

        PayOrder.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.PayOrder();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        m.ID = r.string();
                        break;
                    }
                    case 2: {
                        m.ReID = r.string();
                        break;
                    }
                    case 3: {
                        m.ReIDCate = r.int32();
                        break;
                    }
                    case 4: {
                        m.MchID = r.uint64();
                        break;
                    }
                    case 5: {
                        m.PayCate = r.int32();
                        break;
                    }
                    case 6: {
                        m.UserID = r.uint64();
                        break;
                    }
                    case 7: {
                        m.ToAccUserID = r.uint64();
                        break;
                    }
                    case 8: {
                        m.UUID = r.uint64();
                        break;
                    }
                    case 9: {
                        m.PayPlatform = r.int32();
                        break;
                    }
                    case 10: {
                        m.PayChannel = r.int32();
                        break;
                    }
                    case 11: {
                        m.PayTitle = r.string();
                        break;
                    }
                    case 12: {
                        m.PayState = r.int32();
                        break;
                    }
                    case 13: {
                        m.PayAmt = r.int64();
                        break;
                    }
                    case 14: {
                        m.PayExpires = r.int64();
                        break;
                    }
                    case 15: {
                        m.AppID = r.string();
                        break;
                    }
                    case 16: {
                        m.SubAppID = r.string();
                        break;
                    }
                    case 17: {
                        m.PayMchID = r.string();
                        break;
                    }
                    case 18: {
                        m.PaySubMchID = r.string();
                        break;
                    }
                    case 19: {
                        m.PayOpenID = r.string();
                        break;
                    }
                    case 20: {
                        m.TradeNo = r.string();
                        break;
                    }
                    case 21: {
                        m.ZfbAppAuthToken = r.string();
                        break;
                    }
                    case 22: {
                        m.ZfbShopID = r.string();
                        break;
                    }
                    case 23: {
                        m.ZfbRecordID = r.string();
                        break;
                    }
                    case 24: {
                        m.ZfbOrderID = r.string();
                        break;
                    }
                    case 25: {
                        m.ZfbOrderStatus = r.string();
                        break;
                    }
                    case 26: {
                        m.ZfbService = r.int32();
                        break;
                    }
                    case 27: {
                        m.ZfbSyncTime = r.int64();
                        break;
                    }
                    case 28: {
                        m.AuthCode = r.string();
                        break;
                    }
                    case 29: {
                        m.PrepayID = r.string();
                        break;
                    }
                    case 30: {
                        m.CodeURL = r.string();
                        break;
                    }
                    case 31: {
                        m.NWebURL = r.string();
                        break;
                    }
                    case 32: {
                        m.ResultCode = r.string();
                        break;
                    }
                    case 33: {
                        m.ReturnTime = r.int64();
                        break;
                    }
                    case 34: {
                        m.RetIP = r.string();
                        break;
                    }
                    case 35: {
                        m.RetTime = r.int64();
                        break;
                    }
                    case 36: {
                        m.RetAmt = r.int64();
                        break;
                    }
                    case 37: {
                        m.RetTradeState = r.string();
                        break;
                    }
                    case 38: {
                        m.RetTradeStateDesc = r.string();
                        break;
                    }
                    case 39: {
                        m.FromIP = r.string();
                        break;
                    }
                    case 40: {
                        m.FromTokeID = r.string();
                        break;
                    }
                    case 41: {
                        m.RefundAmtCount = r.int32();
                        break;
                    }
                    case 42: {
                        m.RefundAmt = r.int64();
                        break;
                    }
                    case 43: {
                        m.OnRefundAmt = r.int64();
                        break;
                    }
                    case 44: {
                        m.SyncState = r.int32();
                        break;
                    }
                    case 45: {
                        m.SyncTime = r.int64();
                        break;
                    }
                    case 46: {
                        m.GroupID = r.uint64();
                        break;
                    }
                    case 47: {
                        m.AgentID = r.uint64();
                        break;
                    }
                    case 48: {
                        m.CreateTime = r.int64();
                        break;
                    }
                    case 49: {
                        m.CreaterID = r.uint64();
                        break;
                    }
                    case 50: {
                        m.UpdateTime = r.int64();
                        break;
                    }
                    case 51: {
                        m.UpdaterID = r.uint64();
                        break;
                    }
                    case 52: {
                        m.Estate = r.int32();
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        PayOrder.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.PayOrder";
        };

        return PayOrder;
    })();

    PBEntity.PayOrders = (function () {

        function PayOrders(p) {
            this.PayOrders = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        PayOrders.prototype.PayOrders = $util.emptyArray;

        PayOrders.create = function create(properties) {
            return new PayOrders(properties);
        };

        PayOrders.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.PayOrders != null && m.PayOrders.length) {
                for (var i = 0; i < m.PayOrders.length; ++i)
                    $root.PBEntity.PayOrder.encode(m.PayOrders[i], w.uint32(10).fork()).ldelim();
            }
            return w;
        };

        PayOrders.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.PayOrders();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        if (!(m.PayOrders && m.PayOrders.length))
                            m.PayOrders = [];
                        m.PayOrders.push($root.PBEntity.PayOrder.decode(r, r.uint32()));
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        PayOrders.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.PayOrders";
        };

        return PayOrders;
    })();

    PBEntity.PayOrderAbnormal = (function () {

        function PayOrderAbnormal(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        PayOrderAbnormal.prototype.ID = "";
        PayOrderAbnormal.prototype.AbnormalCate = 0;
        PayOrderAbnormal.prototype.MchID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        PayOrderAbnormal.prototype.UserID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        PayOrderAbnormal.prototype.ToAccUserID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        PayOrderAbnormal.prototype.UUID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        PayOrderAbnormal.prototype.ReID = "";
        PayOrderAbnormal.prototype.ReIDCate = 0;
        PayOrderAbnormal.prototype.PayCate = 0;
        PayOrderAbnormal.prototype.PayPlatform = 0;
        PayOrderAbnormal.prototype.PayChannel = 0;
        PayOrderAbnormal.prototype.PayTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        PayOrderAbnormal.prototype.PayAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        PayOrderAbnormal.prototype.RetTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        PayOrderAbnormal.prototype.RetAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        PayOrderAbnormal.prototype.RetTradeState = "";
        PayOrderAbnormal.prototype.RetTradeNo = "";
        PayOrderAbnormal.prototype.ErrMsg = "";
        PayOrderAbnormal.prototype.ProcessTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        PayOrderAbnormal.prototype.ProcessState = 0;
        PayOrderAbnormal.prototype.ProcessNotes = "";
        PayOrderAbnormal.prototype.ProcessUserID = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        PayOrderAbnormal.prototype.RefundAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        PayOrderAbnormal.prototype.RefundAmtCate = 0;
        PayOrderAbnormal.prototype.CreateTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        PayOrderAbnormal.prototype.CreaterID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        PayOrderAbnormal.prototype.UpdateTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        PayOrderAbnormal.prototype.UpdaterID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        PayOrderAbnormal.prototype.Estate = 0;

        PayOrderAbnormal.create = function create(properties) {
            return new PayOrderAbnormal(properties);
        };

        PayOrderAbnormal.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.ID != null && Object.hasOwnProperty.call(m, "ID"))
                w.uint32(10).string(m.ID);
            if (m.AbnormalCate != null && Object.hasOwnProperty.call(m, "AbnormalCate"))
                w.uint32(16).int32(m.AbnormalCate);
            if (m.MchID != null && Object.hasOwnProperty.call(m, "MchID"))
                w.uint32(24).uint64(m.MchID);
            if (m.UserID != null && Object.hasOwnProperty.call(m, "UserID"))
                w.uint32(32).uint64(m.UserID);
            if (m.ToAccUserID != null && Object.hasOwnProperty.call(m, "ToAccUserID"))
                w.uint32(40).uint64(m.ToAccUserID);
            if (m.UUID != null && Object.hasOwnProperty.call(m, "UUID"))
                w.uint32(48).uint64(m.UUID);
            if (m.ReID != null && Object.hasOwnProperty.call(m, "ReID"))
                w.uint32(58).string(m.ReID);
            if (m.ReIDCate != null && Object.hasOwnProperty.call(m, "ReIDCate"))
                w.uint32(64).int32(m.ReIDCate);
            if (m.PayCate != null && Object.hasOwnProperty.call(m, "PayCate"))
                w.uint32(72).int32(m.PayCate);
            if (m.PayPlatform != null && Object.hasOwnProperty.call(m, "PayPlatform"))
                w.uint32(80).int32(m.PayPlatform);
            if (m.PayChannel != null && Object.hasOwnProperty.call(m, "PayChannel"))
                w.uint32(88).int32(m.PayChannel);
            if (m.PayTime != null && Object.hasOwnProperty.call(m, "PayTime"))
                w.uint32(96).int64(m.PayTime);
            if (m.PayAmt != null && Object.hasOwnProperty.call(m, "PayAmt"))
                w.uint32(104).int64(m.PayAmt);
            if (m.RetTime != null && Object.hasOwnProperty.call(m, "RetTime"))
                w.uint32(112).int64(m.RetTime);
            if (m.RetAmt != null && Object.hasOwnProperty.call(m, "RetAmt"))
                w.uint32(120).int64(m.RetAmt);
            if (m.RetTradeState != null && Object.hasOwnProperty.call(m, "RetTradeState"))
                w.uint32(130).string(m.RetTradeState);
            if (m.RetTradeNo != null && Object.hasOwnProperty.call(m, "RetTradeNo"))
                w.uint32(138).string(m.RetTradeNo);
            if (m.ErrMsg != null && Object.hasOwnProperty.call(m, "ErrMsg"))
                w.uint32(146).string(m.ErrMsg);
            if (m.ProcessTime != null && Object.hasOwnProperty.call(m, "ProcessTime"))
                w.uint32(152).int64(m.ProcessTime);
            if (m.ProcessState != null && Object.hasOwnProperty.call(m, "ProcessState"))
                w.uint32(160).int32(m.ProcessState);
            if (m.ProcessNotes != null && Object.hasOwnProperty.call(m, "ProcessNotes"))
                w.uint32(170).string(m.ProcessNotes);
            if (m.ProcessUserID != null && Object.hasOwnProperty.call(m, "ProcessUserID"))
                w.uint32(176).int64(m.ProcessUserID);
            if (m.RefundAmt != null && Object.hasOwnProperty.call(m, "RefundAmt"))
                w.uint32(184).int64(m.RefundAmt);
            if (m.RefundAmtCate != null && Object.hasOwnProperty.call(m, "RefundAmtCate"))
                w.uint32(192).int32(m.RefundAmtCate);
            if (m.CreateTime != null && Object.hasOwnProperty.call(m, "CreateTime"))
                w.uint32(200).int64(m.CreateTime);
            if (m.CreaterID != null && Object.hasOwnProperty.call(m, "CreaterID"))
                w.uint32(208).uint64(m.CreaterID);
            if (m.UpdateTime != null && Object.hasOwnProperty.call(m, "UpdateTime"))
                w.uint32(216).int64(m.UpdateTime);
            if (m.UpdaterID != null && Object.hasOwnProperty.call(m, "UpdaterID"))
                w.uint32(224).uint64(m.UpdaterID);
            if (m.Estate != null && Object.hasOwnProperty.call(m, "Estate"))
                w.uint32(232).int32(m.Estate);
            return w;
        };

        PayOrderAbnormal.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.PayOrderAbnormal();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        m.ID = r.string();
                        break;
                    }
                    case 2: {
                        m.AbnormalCate = r.int32();
                        break;
                    }
                    case 3: {
                        m.MchID = r.uint64();
                        break;
                    }
                    case 4: {
                        m.UserID = r.uint64();
                        break;
                    }
                    case 5: {
                        m.ToAccUserID = r.uint64();
                        break;
                    }
                    case 6: {
                        m.UUID = r.uint64();
                        break;
                    }
                    case 7: {
                        m.ReID = r.string();
                        break;
                    }
                    case 8: {
                        m.ReIDCate = r.int32();
                        break;
                    }
                    case 9: {
                        m.PayCate = r.int32();
                        break;
                    }
                    case 10: {
                        m.PayPlatform = r.int32();
                        break;
                    }
                    case 11: {
                        m.PayChannel = r.int32();
                        break;
                    }
                    case 12: {
                        m.PayTime = r.int64();
                        break;
                    }
                    case 13: {
                        m.PayAmt = r.int64();
                        break;
                    }
                    case 14: {
                        m.RetTime = r.int64();
                        break;
                    }
                    case 15: {
                        m.RetAmt = r.int64();
                        break;
                    }
                    case 16: {
                        m.RetTradeState = r.string();
                        break;
                    }
                    case 17: {
                        m.RetTradeNo = r.string();
                        break;
                    }
                    case 18: {
                        m.ErrMsg = r.string();
                        break;
                    }
                    case 19: {
                        m.ProcessTime = r.int64();
                        break;
                    }
                    case 20: {
                        m.ProcessState = r.int32();
                        break;
                    }
                    case 21: {
                        m.ProcessNotes = r.string();
                        break;
                    }
                    case 22: {
                        m.ProcessUserID = r.int64();
                        break;
                    }
                    case 23: {
                        m.RefundAmt = r.int64();
                        break;
                    }
                    case 24: {
                        m.RefundAmtCate = r.int32();
                        break;
                    }
                    case 25: {
                        m.CreateTime = r.int64();
                        break;
                    }
                    case 26: {
                        m.CreaterID = r.uint64();
                        break;
                    }
                    case 27: {
                        m.UpdateTime = r.int64();
                        break;
                    }
                    case 28: {
                        m.UpdaterID = r.uint64();
                        break;
                    }
                    case 29: {
                        m.Estate = r.int32();
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        PayOrderAbnormal.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.PayOrderAbnormal";
        };

        return PayOrderAbnormal;
    })();

    PBEntity.PayOrderAbnormals = (function () {

        function PayOrderAbnormals(p) {
            this.PayOrderAbnormals = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        PayOrderAbnormals.prototype.PayOrderAbnormals = $util.emptyArray;

        PayOrderAbnormals.create = function create(properties) {
            return new PayOrderAbnormals(properties);
        };

        PayOrderAbnormals.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.PayOrderAbnormals != null && m.PayOrderAbnormals.length) {
                for (var i = 0; i < m.PayOrderAbnormals.length; ++i)
                    $root.PBEntity.PayOrderAbnormal.encode(m.PayOrderAbnormals[i], w.uint32(10).fork()).ldelim();
            }
            return w;
        };

        PayOrderAbnormals.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.PayOrderAbnormals();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        if (!(m.PayOrderAbnormals && m.PayOrderAbnormals.length))
                            m.PayOrderAbnormals = [];
                        m.PayOrderAbnormals.push($root.PBEntity.PayOrderAbnormal.decode(r, r.uint32()));
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        PayOrderAbnormals.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.PayOrderAbnormals";
        };

        return PayOrderAbnormals;
    })();

    PBEntity.PaymentCodeOrder = (function () {

        function PaymentCodeOrder(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        PaymentCodeOrder.prototype.ID = "";
        PaymentCodeOrder.prototype.MchID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        PaymentCodeOrder.prototype.UserID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        PaymentCodeOrder.prototype.UUID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        PaymentCodeOrder.prototype.TransDate = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        PaymentCodeOrder.prototype.SaleSeq = 0;
        PaymentCodeOrder.prototype.SeqCode = "";
        PaymentCodeOrder.prototype.AtTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        PaymentCodeOrder.prototype.AtChannel = 0;
        PaymentCodeOrder.prototype.OrderNotes = "";
        PaymentCodeOrder.prototype.OrderState = 0;
        PaymentCodeOrder.prototype.RevenueAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        PaymentCodeOrder.prototype.IsUsePoints = 0;
        PaymentCodeOrder.prototype.UsePoints = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        PaymentCodeOrder.prototype.UsePointsRate = 0;
        PaymentCodeOrder.prototype.UsePointsAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        PaymentCodeOrder.prototype.ReceiptAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        PaymentCodeOrder.prototype.IsUseAdvAmt = 0;
        PaymentCodeOrder.prototype.UseAdvAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        PaymentCodeOrder.prototype.PayPlatform = 0;
        PaymentCodeOrder.prototype.PayChannel = 0;
        PaymentCodeOrder.prototype.PayState = 0;
        PaymentCodeOrder.prototype.PayExpires = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        PaymentCodeOrder.prototype.PayTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        PaymentCodeOrder.prototype.PayAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        PaymentCodeOrder.prototype.PayID = "";
        PaymentCodeOrder.prototype.GroupID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        PaymentCodeOrder.prototype.AgentID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        PaymentCodeOrder.prototype.IsRefund = 0;
        PaymentCodeOrder.prototype.IsComm = 0;
        PaymentCodeOrder.prototype.FromIP = "";
        PaymentCodeOrder.prototype.FromTokeID = "";
        PaymentCodeOrder.prototype.CheckState = 0;
        PaymentCodeOrder.prototype.IsPrint = 0;
        PaymentCodeOrder.prototype.IsSubsMsg = 0;
        PaymentCodeOrder.prototype.IsNotice = 0;
        PaymentCodeOrder.prototype.CallCount = 0;
        PaymentCodeOrder.prototype.FinishTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        PaymentCodeOrder.prototype.ObtainPointsRate = 0;
        PaymentCodeOrder.prototype.ObtainPoints = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        PaymentCodeOrder.prototype.RefundAmtState = 0;
        PaymentCodeOrder.prototype.RefundAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        PaymentCodeOrder.prototype.CreateTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        PaymentCodeOrder.prototype.CreaterID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        PaymentCodeOrder.prototype.UpdateTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        PaymentCodeOrder.prototype.UpdaterID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        PaymentCodeOrder.prototype.Estate = 0;

        PaymentCodeOrder.create = function create(properties) {
            return new PaymentCodeOrder(properties);
        };

        PaymentCodeOrder.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.ID != null && Object.hasOwnProperty.call(m, "ID"))
                w.uint32(10).string(m.ID);
            if (m.MchID != null && Object.hasOwnProperty.call(m, "MchID"))
                w.uint32(16).uint64(m.MchID);
            if (m.UserID != null && Object.hasOwnProperty.call(m, "UserID"))
                w.uint32(24).uint64(m.UserID);
            if (m.UUID != null && Object.hasOwnProperty.call(m, "UUID"))
                w.uint32(32).uint64(m.UUID);
            if (m.TransDate != null && Object.hasOwnProperty.call(m, "TransDate"))
                w.uint32(40).int64(m.TransDate);
            if (m.SaleSeq != null && Object.hasOwnProperty.call(m, "SaleSeq"))
                w.uint32(48).int32(m.SaleSeq);
            if (m.SeqCode != null && Object.hasOwnProperty.call(m, "SeqCode"))
                w.uint32(58).string(m.SeqCode);
            if (m.AtTime != null && Object.hasOwnProperty.call(m, "AtTime"))
                w.uint32(64).int64(m.AtTime);
            if (m.AtChannel != null && Object.hasOwnProperty.call(m, "AtChannel"))
                w.uint32(72).int32(m.AtChannel);
            if (m.OrderNotes != null && Object.hasOwnProperty.call(m, "OrderNotes"))
                w.uint32(82).string(m.OrderNotes);
            if (m.OrderState != null && Object.hasOwnProperty.call(m, "OrderState"))
                w.uint32(88).int32(m.OrderState);
            if (m.RevenueAmt != null && Object.hasOwnProperty.call(m, "RevenueAmt"))
                w.uint32(96).int64(m.RevenueAmt);
            if (m.IsUsePoints != null && Object.hasOwnProperty.call(m, "IsUsePoints"))
                w.uint32(104).int32(m.IsUsePoints);
            if (m.UsePoints != null && Object.hasOwnProperty.call(m, "UsePoints"))
                w.uint32(112).int64(m.UsePoints);
            if (m.UsePointsRate != null && Object.hasOwnProperty.call(m, "UsePointsRate"))
                w.uint32(120).int32(m.UsePointsRate);
            if (m.UsePointsAmt != null && Object.hasOwnProperty.call(m, "UsePointsAmt"))
                w.uint32(128).int64(m.UsePointsAmt);
            if (m.ReceiptAmt != null && Object.hasOwnProperty.call(m, "ReceiptAmt"))
                w.uint32(136).int64(m.ReceiptAmt);
            if (m.IsUseAdvAmt != null && Object.hasOwnProperty.call(m, "IsUseAdvAmt"))
                w.uint32(144).int32(m.IsUseAdvAmt);
            if (m.UseAdvAmt != null && Object.hasOwnProperty.call(m, "UseAdvAmt"))
                w.uint32(152).int64(m.UseAdvAmt);
            if (m.PayPlatform != null && Object.hasOwnProperty.call(m, "PayPlatform"))
                w.uint32(160).int32(m.PayPlatform);
            if (m.PayChannel != null && Object.hasOwnProperty.call(m, "PayChannel"))
                w.uint32(168).int32(m.PayChannel);
            if (m.PayState != null && Object.hasOwnProperty.call(m, "PayState"))
                w.uint32(176).int32(m.PayState);
            if (m.PayExpires != null && Object.hasOwnProperty.call(m, "PayExpires"))
                w.uint32(184).int64(m.PayExpires);
            if (m.PayTime != null && Object.hasOwnProperty.call(m, "PayTime"))
                w.uint32(192).int64(m.PayTime);
            if (m.PayAmt != null && Object.hasOwnProperty.call(m, "PayAmt"))
                w.uint32(200).int64(m.PayAmt);
            if (m.PayID != null && Object.hasOwnProperty.call(m, "PayID"))
                w.uint32(210).string(m.PayID);
            if (m.GroupID != null && Object.hasOwnProperty.call(m, "GroupID"))
                w.uint32(216).uint64(m.GroupID);
            if (m.AgentID != null && Object.hasOwnProperty.call(m, "AgentID"))
                w.uint32(224).uint64(m.AgentID);
            if (m.IsRefund != null && Object.hasOwnProperty.call(m, "IsRefund"))
                w.uint32(232).int32(m.IsRefund);
            if (m.IsComm != null && Object.hasOwnProperty.call(m, "IsComm"))
                w.uint32(240).int32(m.IsComm);
            if (m.FromIP != null && Object.hasOwnProperty.call(m, "FromIP"))
                w.uint32(250).string(m.FromIP);
            if (m.FromTokeID != null && Object.hasOwnProperty.call(m, "FromTokeID"))
                w.uint32(258).string(m.FromTokeID);
            if (m.CheckState != null && Object.hasOwnProperty.call(m, "CheckState"))
                w.uint32(264).int32(m.CheckState);
            if (m.IsPrint != null && Object.hasOwnProperty.call(m, "IsPrint"))
                w.uint32(272).int32(m.IsPrint);
            if (m.IsSubsMsg != null && Object.hasOwnProperty.call(m, "IsSubsMsg"))
                w.uint32(280).int32(m.IsSubsMsg);
            if (m.IsNotice != null && Object.hasOwnProperty.call(m, "IsNotice"))
                w.uint32(288).int32(m.IsNotice);
            if (m.CallCount != null && Object.hasOwnProperty.call(m, "CallCount"))
                w.uint32(296).int32(m.CallCount);
            if (m.FinishTime != null && Object.hasOwnProperty.call(m, "FinishTime"))
                w.uint32(304).int64(m.FinishTime);
            if (m.ObtainPointsRate != null && Object.hasOwnProperty.call(m, "ObtainPointsRate"))
                w.uint32(312).int32(m.ObtainPointsRate);
            if (m.ObtainPoints != null && Object.hasOwnProperty.call(m, "ObtainPoints"))
                w.uint32(320).int64(m.ObtainPoints);
            if (m.RefundAmtState != null && Object.hasOwnProperty.call(m, "RefundAmtState"))
                w.uint32(328).int32(m.RefundAmtState);
            if (m.RefundAmt != null && Object.hasOwnProperty.call(m, "RefundAmt"))
                w.uint32(336).int64(m.RefundAmt);
            if (m.CreateTime != null && Object.hasOwnProperty.call(m, "CreateTime"))
                w.uint32(344).int64(m.CreateTime);
            if (m.CreaterID != null && Object.hasOwnProperty.call(m, "CreaterID"))
                w.uint32(352).uint64(m.CreaterID);
            if (m.UpdateTime != null && Object.hasOwnProperty.call(m, "UpdateTime"))
                w.uint32(360).int64(m.UpdateTime);
            if (m.UpdaterID != null && Object.hasOwnProperty.call(m, "UpdaterID"))
                w.uint32(368).uint64(m.UpdaterID);
            if (m.Estate != null && Object.hasOwnProperty.call(m, "Estate"))
                w.uint32(376).int32(m.Estate);
            return w;
        };

        PaymentCodeOrder.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.PaymentCodeOrder();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        m.ID = r.string();
                        break;
                    }
                    case 2: {
                        m.MchID = r.uint64();
                        break;
                    }
                    case 3: {
                        m.UserID = r.uint64();
                        break;
                    }
                    case 4: {
                        m.UUID = r.uint64();
                        break;
                    }
                    case 5: {
                        m.TransDate = r.int64();
                        break;
                    }
                    case 6: {
                        m.SaleSeq = r.int32();
                        break;
                    }
                    case 7: {
                        m.SeqCode = r.string();
                        break;
                    }
                    case 8: {
                        m.AtTime = r.int64();
                        break;
                    }
                    case 9: {
                        m.AtChannel = r.int32();
                        break;
                    }
                    case 10: {
                        m.OrderNotes = r.string();
                        break;
                    }
                    case 11: {
                        m.OrderState = r.int32();
                        break;
                    }
                    case 12: {
                        m.RevenueAmt = r.int64();
                        break;
                    }
                    case 13: {
                        m.IsUsePoints = r.int32();
                        break;
                    }
                    case 14: {
                        m.UsePoints = r.int64();
                        break;
                    }
                    case 15: {
                        m.UsePointsRate = r.int32();
                        break;
                    }
                    case 16: {
                        m.UsePointsAmt = r.int64();
                        break;
                    }
                    case 17: {
                        m.ReceiptAmt = r.int64();
                        break;
                    }
                    case 18: {
                        m.IsUseAdvAmt = r.int32();
                        break;
                    }
                    case 19: {
                        m.UseAdvAmt = r.int64();
                        break;
                    }
                    case 20: {
                        m.PayPlatform = r.int32();
                        break;
                    }
                    case 21: {
                        m.PayChannel = r.int32();
                        break;
                    }
                    case 22: {
                        m.PayState = r.int32();
                        break;
                    }
                    case 23: {
                        m.PayExpires = r.int64();
                        break;
                    }
                    case 24: {
                        m.PayTime = r.int64();
                        break;
                    }
                    case 25: {
                        m.PayAmt = r.int64();
                        break;
                    }
                    case 26: {
                        m.PayID = r.string();
                        break;
                    }
                    case 27: {
                        m.GroupID = r.uint64();
                        break;
                    }
                    case 28: {
                        m.AgentID = r.uint64();
                        break;
                    }
                    case 29: {
                        m.IsRefund = r.int32();
                        break;
                    }
                    case 30: {
                        m.IsComm = r.int32();
                        break;
                    }
                    case 31: {
                        m.FromIP = r.string();
                        break;
                    }
                    case 32: {
                        m.FromTokeID = r.string();
                        break;
                    }
                    case 33: {
                        m.CheckState = r.int32();
                        break;
                    }
                    case 34: {
                        m.IsPrint = r.int32();
                        break;
                    }
                    case 35: {
                        m.IsSubsMsg = r.int32();
                        break;
                    }
                    case 36: {
                        m.IsNotice = r.int32();
                        break;
                    }
                    case 37: {
                        m.CallCount = r.int32();
                        break;
                    }
                    case 38: {
                        m.FinishTime = r.int64();
                        break;
                    }
                    case 39: {
                        m.ObtainPointsRate = r.int32();
                        break;
                    }
                    case 40: {
                        m.ObtainPoints = r.int64();
                        break;
                    }
                    case 41: {
                        m.RefundAmtState = r.int32();
                        break;
                    }
                    case 42: {
                        m.RefundAmt = r.int64();
                        break;
                    }
                    case 43: {
                        m.CreateTime = r.int64();
                        break;
                    }
                    case 44: {
                        m.CreaterID = r.uint64();
                        break;
                    }
                    case 45: {
                        m.UpdateTime = r.int64();
                        break;
                    }
                    case 46: {
                        m.UpdaterID = r.uint64();
                        break;
                    }
                    case 47: {
                        m.Estate = r.int32();
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        PaymentCodeOrder.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.PaymentCodeOrder";
        };

        return PaymentCodeOrder;
    })();

    PBEntity.PaymentCodeOrders = (function () {

        function PaymentCodeOrders(p) {
            this.PaymentCodeOrders = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        PaymentCodeOrders.prototype.PaymentCodeOrders = $util.emptyArray;

        PaymentCodeOrders.create = function create(properties) {
            return new PaymentCodeOrders(properties);
        };

        PaymentCodeOrders.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.PaymentCodeOrders != null && m.PaymentCodeOrders.length) {
                for (var i = 0; i < m.PaymentCodeOrders.length; ++i)
                    $root.PBEntity.PaymentCodeOrder.encode(m.PaymentCodeOrders[i], w.uint32(10).fork()).ldelim();
            }
            return w;
        };

        PaymentCodeOrders.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.PaymentCodeOrders();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        if (!(m.PaymentCodeOrders && m.PaymentCodeOrders.length))
                            m.PaymentCodeOrders = [];
                        m.PaymentCodeOrders.push($root.PBEntity.PaymentCodeOrder.decode(r, r.uint32()));
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        PaymentCodeOrders.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.PaymentCodeOrders";
        };

        return PaymentCodeOrders;
    })();

    PBEntity.PaymentReceipt = (function () {

        function PaymentReceipt(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        PaymentReceipt.prototype.RecPayID = "";
        PaymentReceipt.prototype.MchID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        PaymentReceipt.prototype.TransDate = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        PaymentReceipt.prototype.Category = 0;
        PaymentReceipt.prototype.ReMode = 0;
        PaymentReceipt.prototype.FromID = "";
        PaymentReceipt.prototype.ToAccUserID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        PaymentReceipt.prototype.UserID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        PaymentReceipt.prototype.UserCate = 0;
        PaymentReceipt.prototype.UserName = "";
        PaymentReceipt.prototype.ReID = "";
        PaymentReceipt.prototype.ReIDCate = 0;
        PaymentReceipt.prototype.RTitle = "";
        PaymentReceipt.prototype.ReceiptAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        PaymentReceipt.prototype.IsUsePoints = 0;
        PaymentReceipt.prototype.UsePoints = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        PaymentReceipt.prototype.UsePointsRate = 0;
        PaymentReceipt.prototype.UsePointsAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        PaymentReceipt.prototype.IsUseAdvAmt = 0;
        PaymentReceipt.prototype.UseAdvAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        PaymentReceipt.prototype.IsUseCash = 0;
        PaymentReceipt.prototype.UseCashAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        PaymentReceipt.prototype.IsUseGroupBuy = 0;
        PaymentReceipt.prototype.UseGroupBuyAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        PaymentReceipt.prototype.GroupBuyVerifyID = "";
        PaymentReceipt.prototype.PayPlatform = 0;
        PaymentReceipt.prototype.PayChannel = 0;
        PaymentReceipt.prototype.PayAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        PaymentReceipt.prototype.PayTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        PaymentReceipt.prototype.ActualReceiptAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        PaymentReceipt.prototype.RefundCount = 0;
        PaymentReceipt.prototype.RefundTotalAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        PaymentReceipt.prototype.NetWorthAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        PaymentReceipt.prototype.ReceiptTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        PaymentReceipt.prototype.GroupID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        PaymentReceipt.prototype.CreateTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        PaymentReceipt.prototype.CreaterID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        PaymentReceipt.prototype.UpdateTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        PaymentReceipt.prototype.UpdaterID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        PaymentReceipt.prototype.Estate = 0;

        PaymentReceipt.create = function create(properties) {
            return new PaymentReceipt(properties);
        };

        PaymentReceipt.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.RecPayID != null && Object.hasOwnProperty.call(m, "RecPayID"))
                w.uint32(10).string(m.RecPayID);
            if (m.MchID != null && Object.hasOwnProperty.call(m, "MchID"))
                w.uint32(16).uint64(m.MchID);
            if (m.TransDate != null && Object.hasOwnProperty.call(m, "TransDate"))
                w.uint32(24).int64(m.TransDate);
            if (m.Category != null && Object.hasOwnProperty.call(m, "Category"))
                w.uint32(32).int32(m.Category);
            if (m.ReMode != null && Object.hasOwnProperty.call(m, "ReMode"))
                w.uint32(40).int32(m.ReMode);
            if (m.FromID != null && Object.hasOwnProperty.call(m, "FromID"))
                w.uint32(50).string(m.FromID);
            if (m.ToAccUserID != null && Object.hasOwnProperty.call(m, "ToAccUserID"))
                w.uint32(56).uint64(m.ToAccUserID);
            if (m.UserID != null && Object.hasOwnProperty.call(m, "UserID"))
                w.uint32(64).uint64(m.UserID);
            if (m.UserCate != null && Object.hasOwnProperty.call(m, "UserCate"))
                w.uint32(72).int32(m.UserCate);
            if (m.UserName != null && Object.hasOwnProperty.call(m, "UserName"))
                w.uint32(82).string(m.UserName);
            if (m.ReID != null && Object.hasOwnProperty.call(m, "ReID"))
                w.uint32(90).string(m.ReID);
            if (m.ReIDCate != null && Object.hasOwnProperty.call(m, "ReIDCate"))
                w.uint32(96).int32(m.ReIDCate);
            if (m.RTitle != null && Object.hasOwnProperty.call(m, "RTitle"))
                w.uint32(106).string(m.RTitle);
            if (m.ReceiptAmt != null && Object.hasOwnProperty.call(m, "ReceiptAmt"))
                w.uint32(112).int64(m.ReceiptAmt);
            if (m.IsUsePoints != null && Object.hasOwnProperty.call(m, "IsUsePoints"))
                w.uint32(120).int32(m.IsUsePoints);
            if (m.UsePoints != null && Object.hasOwnProperty.call(m, "UsePoints"))
                w.uint32(128).int64(m.UsePoints);
            if (m.UsePointsRate != null && Object.hasOwnProperty.call(m, "UsePointsRate"))
                w.uint32(136).int32(m.UsePointsRate);
            if (m.UsePointsAmt != null && Object.hasOwnProperty.call(m, "UsePointsAmt"))
                w.uint32(144).int64(m.UsePointsAmt);
            if (m.IsUseAdvAmt != null && Object.hasOwnProperty.call(m, "IsUseAdvAmt"))
                w.uint32(152).int32(m.IsUseAdvAmt);
            if (m.UseAdvAmt != null && Object.hasOwnProperty.call(m, "UseAdvAmt"))
                w.uint32(160).int64(m.UseAdvAmt);
            if (m.IsUseCash != null && Object.hasOwnProperty.call(m, "IsUseCash"))
                w.uint32(168).int32(m.IsUseCash);
            if (m.UseCashAmt != null && Object.hasOwnProperty.call(m, "UseCashAmt"))
                w.uint32(176).int64(m.UseCashAmt);
            if (m.IsUseGroupBuy != null && Object.hasOwnProperty.call(m, "IsUseGroupBuy"))
                w.uint32(184).int32(m.IsUseGroupBuy);
            if (m.UseGroupBuyAmt != null && Object.hasOwnProperty.call(m, "UseGroupBuyAmt"))
                w.uint32(192).int64(m.UseGroupBuyAmt);
            if (m.GroupBuyVerifyID != null && Object.hasOwnProperty.call(m, "GroupBuyVerifyID"))
                w.uint32(202).string(m.GroupBuyVerifyID);
            if (m.PayPlatform != null && Object.hasOwnProperty.call(m, "PayPlatform"))
                w.uint32(208).int32(m.PayPlatform);
            if (m.PayChannel != null && Object.hasOwnProperty.call(m, "PayChannel"))
                w.uint32(216).int32(m.PayChannel);
            if (m.PayAmt != null && Object.hasOwnProperty.call(m, "PayAmt"))
                w.uint32(224).int64(m.PayAmt);
            if (m.PayTime != null && Object.hasOwnProperty.call(m, "PayTime"))
                w.uint32(232).int64(m.PayTime);
            if (m.ActualReceiptAmt != null && Object.hasOwnProperty.call(m, "ActualReceiptAmt"))
                w.uint32(240).int64(m.ActualReceiptAmt);
            if (m.RefundCount != null && Object.hasOwnProperty.call(m, "RefundCount"))
                w.uint32(248).int32(m.RefundCount);
            if (m.RefundTotalAmt != null && Object.hasOwnProperty.call(m, "RefundTotalAmt"))
                w.uint32(256).int64(m.RefundTotalAmt);
            if (m.NetWorthAmt != null && Object.hasOwnProperty.call(m, "NetWorthAmt"))
                w.uint32(264).int64(m.NetWorthAmt);
            if (m.ReceiptTime != null && Object.hasOwnProperty.call(m, "ReceiptTime"))
                w.uint32(272).int64(m.ReceiptTime);
            if (m.GroupID != null && Object.hasOwnProperty.call(m, "GroupID"))
                w.uint32(280).uint64(m.GroupID);
            if (m.CreateTime != null && Object.hasOwnProperty.call(m, "CreateTime"))
                w.uint32(288).int64(m.CreateTime);
            if (m.CreaterID != null && Object.hasOwnProperty.call(m, "CreaterID"))
                w.uint32(296).uint64(m.CreaterID);
            if (m.UpdateTime != null && Object.hasOwnProperty.call(m, "UpdateTime"))
                w.uint32(304).int64(m.UpdateTime);
            if (m.UpdaterID != null && Object.hasOwnProperty.call(m, "UpdaterID"))
                w.uint32(312).uint64(m.UpdaterID);
            if (m.Estate != null && Object.hasOwnProperty.call(m, "Estate"))
                w.uint32(320).int32(m.Estate);
            return w;
        };

        PaymentReceipt.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.PaymentReceipt();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        m.RecPayID = r.string();
                        break;
                    }
                    case 2: {
                        m.MchID = r.uint64();
                        break;
                    }
                    case 3: {
                        m.TransDate = r.int64();
                        break;
                    }
                    case 4: {
                        m.Category = r.int32();
                        break;
                    }
                    case 5: {
                        m.ReMode = r.int32();
                        break;
                    }
                    case 6: {
                        m.FromID = r.string();
                        break;
                    }
                    case 7: {
                        m.ToAccUserID = r.uint64();
                        break;
                    }
                    case 8: {
                        m.UserID = r.uint64();
                        break;
                    }
                    case 9: {
                        m.UserCate = r.int32();
                        break;
                    }
                    case 10: {
                        m.UserName = r.string();
                        break;
                    }
                    case 11: {
                        m.ReID = r.string();
                        break;
                    }
                    case 12: {
                        m.ReIDCate = r.int32();
                        break;
                    }
                    case 13: {
                        m.RTitle = r.string();
                        break;
                    }
                    case 14: {
                        m.ReceiptAmt = r.int64();
                        break;
                    }
                    case 15: {
                        m.IsUsePoints = r.int32();
                        break;
                    }
                    case 16: {
                        m.UsePoints = r.int64();
                        break;
                    }
                    case 17: {
                        m.UsePointsRate = r.int32();
                        break;
                    }
                    case 18: {
                        m.UsePointsAmt = r.int64();
                        break;
                    }
                    case 19: {
                        m.IsUseAdvAmt = r.int32();
                        break;
                    }
                    case 20: {
                        m.UseAdvAmt = r.int64();
                        break;
                    }
                    case 21: {
                        m.IsUseCash = r.int32();
                        break;
                    }
                    case 22: {
                        m.UseCashAmt = r.int64();
                        break;
                    }
                    case 23: {
                        m.IsUseGroupBuy = r.int32();
                        break;
                    }
                    case 24: {
                        m.UseGroupBuyAmt = r.int64();
                        break;
                    }
                    case 25: {
                        m.GroupBuyVerifyID = r.string();
                        break;
                    }
                    case 26: {
                        m.PayPlatform = r.int32();
                        break;
                    }
                    case 27: {
                        m.PayChannel = r.int32();
                        break;
                    }
                    case 28: {
                        m.PayAmt = r.int64();
                        break;
                    }
                    case 29: {
                        m.PayTime = r.int64();
                        break;
                    }
                    case 30: {
                        m.ActualReceiptAmt = r.int64();
                        break;
                    }
                    case 31: {
                        m.RefundCount = r.int32();
                        break;
                    }
                    case 32: {
                        m.RefundTotalAmt = r.int64();
                        break;
                    }
                    case 33: {
                        m.NetWorthAmt = r.int64();
                        break;
                    }
                    case 34: {
                        m.ReceiptTime = r.int64();
                        break;
                    }
                    case 35: {
                        m.GroupID = r.uint64();
                        break;
                    }
                    case 36: {
                        m.CreateTime = r.int64();
                        break;
                    }
                    case 37: {
                        m.CreaterID = r.uint64();
                        break;
                    }
                    case 38: {
                        m.UpdateTime = r.int64();
                        break;
                    }
                    case 39: {
                        m.UpdaterID = r.uint64();
                        break;
                    }
                    case 40: {
                        m.Estate = r.int32();
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        PaymentReceipt.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.PaymentReceipt";
        };

        return PaymentReceipt;
    })();

    PBEntity.PaymentReceipts = (function () {

        function PaymentReceipts(p) {
            this.PaymentReceipts = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        PaymentReceipts.prototype.PaymentReceipts = $util.emptyArray;

        PaymentReceipts.create = function create(properties) {
            return new PaymentReceipts(properties);
        };

        PaymentReceipts.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.PaymentReceipts != null && m.PaymentReceipts.length) {
                for (var i = 0; i < m.PaymentReceipts.length; ++i)
                    $root.PBEntity.PaymentReceipt.encode(m.PaymentReceipts[i], w.uint32(10).fork()).ldelim();
            }
            return w;
        };

        PaymentReceipts.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.PaymentReceipts();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        if (!(m.PaymentReceipts && m.PaymentReceipts.length))
                            m.PaymentReceipts = [];
                        m.PaymentReceipts.push($root.PBEntity.PaymentReceipt.decode(r, r.uint32()));
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        PaymentReceipts.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.PaymentReceipts";
        };

        return PaymentReceipts;
    })();

    PBEntity.Promo = (function () {

        function Promo(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        Promo.prototype.PromoID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        Promo.prototype.MchID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        Promo.prototype.SPTitle1 = "";
        Promo.prototype.SPTitle2 = "";
        Promo.prototype.SPTitle3 = "";
        Promo.prototype.SPCate = 0;
        Promo.prototype.IsShop = 0;
        Promo.prototype.IsTakeAway = 0;
        Promo.prototype.IsYourself = 0;
        Promo.prototype.MinAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Promo.prototype.IsLimitGC = 0;
        Promo.prototype.LimitGCJson = "";
        Promo.prototype.IsLimitWeek = 0;
        Promo.prototype.LimitWeek = "";
        Promo.prototype.IsLimitTime = 0;
        Promo.prototype.STime = 0;
        Promo.prototype.ETime = 0;
        Promo.prototype.IsSaleAmt = 0;
        Promo.prototype.SaleAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Promo.prototype.IsGiveAmt = 0;
        Promo.prototype.GiveAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Promo.prototype.IsGivePoints = 0;
        Promo.prototype.GivePoints = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Promo.prototype.IsGiveGoods = 0;
        Promo.prototype.GiveMaxGoods = 0;
        Promo.prototype.IsBuyGoods = 0;
        Promo.prototype.IsDis = 0;
        Promo.prototype.DisRate = 0;
        Promo.prototype.DisMaxAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Promo.prototype.IsGiveCoupon = 0;
        Promo.prototype.GiveCopuonID = "";
        Promo.prototype.IsPostage = 0;
        Promo.prototype.PostageAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Promo.prototype.IsHalf = 0;
        Promo.prototype.HalfMax = 0;
        Promo.prototype.IsBofo = 0;
        Promo.prototype.BofoMax = 0;
        Promo.prototype.SDate = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Promo.prototype.EDate = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Promo.prototype.PromoState = 0;
        Promo.prototype.GroupID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        Promo.prototype.PublishTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Promo.prototype.PublishUserID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        Promo.prototype.CloseTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Promo.prototype.CloseUserID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        Promo.prototype.CloseCate = 0;
        Promo.prototype.OrderValue = 0;
        Promo.prototype.CreateTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Promo.prototype.CreaterID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        Promo.prototype.UpdateTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Promo.prototype.UpdaterID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        Promo.prototype.Estate = 0;

        Promo.create = function create(properties) {
            return new Promo(properties);
        };

        Promo.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.PromoID != null && Object.hasOwnProperty.call(m, "PromoID"))
                w.uint32(8).uint64(m.PromoID);
            if (m.MchID != null && Object.hasOwnProperty.call(m, "MchID"))
                w.uint32(16).uint64(m.MchID);
            if (m.SPTitle1 != null && Object.hasOwnProperty.call(m, "SPTitle1"))
                w.uint32(26).string(m.SPTitle1);
            if (m.SPTitle2 != null && Object.hasOwnProperty.call(m, "SPTitle2"))
                w.uint32(34).string(m.SPTitle2);
            if (m.SPTitle3 != null && Object.hasOwnProperty.call(m, "SPTitle3"))
                w.uint32(42).string(m.SPTitle3);
            if (m.SPCate != null && Object.hasOwnProperty.call(m, "SPCate"))
                w.uint32(48).int32(m.SPCate);
            if (m.IsShop != null && Object.hasOwnProperty.call(m, "IsShop"))
                w.uint32(56).int32(m.IsShop);
            if (m.IsTakeAway != null && Object.hasOwnProperty.call(m, "IsTakeAway"))
                w.uint32(64).int32(m.IsTakeAway);
            if (m.IsYourself != null && Object.hasOwnProperty.call(m, "IsYourself"))
                w.uint32(72).int32(m.IsYourself);
            if (m.MinAmt != null && Object.hasOwnProperty.call(m, "MinAmt"))
                w.uint32(80).int64(m.MinAmt);
            if (m.IsLimitGC != null && Object.hasOwnProperty.call(m, "IsLimitGC"))
                w.uint32(88).int32(m.IsLimitGC);
            if (m.LimitGCJson != null && Object.hasOwnProperty.call(m, "LimitGCJson"))
                w.uint32(98).string(m.LimitGCJson);
            if (m.IsLimitWeek != null && Object.hasOwnProperty.call(m, "IsLimitWeek"))
                w.uint32(104).int32(m.IsLimitWeek);
            if (m.LimitWeek != null && Object.hasOwnProperty.call(m, "LimitWeek"))
                w.uint32(114).string(m.LimitWeek);
            if (m.IsLimitTime != null && Object.hasOwnProperty.call(m, "IsLimitTime"))
                w.uint32(120).int32(m.IsLimitTime);
            if (m.STime != null && Object.hasOwnProperty.call(m, "STime"))
                w.uint32(129).double(m.STime);
            if (m.ETime != null && Object.hasOwnProperty.call(m, "ETime"))
                w.uint32(137).double(m.ETime);
            if (m.IsSaleAmt != null && Object.hasOwnProperty.call(m, "IsSaleAmt"))
                w.uint32(144).int32(m.IsSaleAmt);
            if (m.SaleAmt != null && Object.hasOwnProperty.call(m, "SaleAmt"))
                w.uint32(152).int64(m.SaleAmt);
            if (m.IsGiveAmt != null && Object.hasOwnProperty.call(m, "IsGiveAmt"))
                w.uint32(160).int32(m.IsGiveAmt);
            if (m.GiveAmt != null && Object.hasOwnProperty.call(m, "GiveAmt"))
                w.uint32(168).int64(m.GiveAmt);
            if (m.IsGivePoints != null && Object.hasOwnProperty.call(m, "IsGivePoints"))
                w.uint32(176).int32(m.IsGivePoints);
            if (m.GivePoints != null && Object.hasOwnProperty.call(m, "GivePoints"))
                w.uint32(184).int64(m.GivePoints);
            if (m.IsGiveGoods != null && Object.hasOwnProperty.call(m, "IsGiveGoods"))
                w.uint32(192).int32(m.IsGiveGoods);
            if (m.GiveMaxGoods != null && Object.hasOwnProperty.call(m, "GiveMaxGoods"))
                w.uint32(200).int32(m.GiveMaxGoods);
            if (m.IsBuyGoods != null && Object.hasOwnProperty.call(m, "IsBuyGoods"))
                w.uint32(208).int32(m.IsBuyGoods);
            if (m.IsDis != null && Object.hasOwnProperty.call(m, "IsDis"))
                w.uint32(216).int32(m.IsDis);
            if (m.DisRate != null && Object.hasOwnProperty.call(m, "DisRate"))
                w.uint32(224).int32(m.DisRate);
            if (m.DisMaxAmt != null && Object.hasOwnProperty.call(m, "DisMaxAmt"))
                w.uint32(232).int64(m.DisMaxAmt);
            if (m.IsGiveCoupon != null && Object.hasOwnProperty.call(m, "IsGiveCoupon"))
                w.uint32(240).int32(m.IsGiveCoupon);
            if (m.GiveCopuonID != null && Object.hasOwnProperty.call(m, "GiveCopuonID"))
                w.uint32(250).string(m.GiveCopuonID);
            if (m.IsPostage != null && Object.hasOwnProperty.call(m, "IsPostage"))
                w.uint32(256).int32(m.IsPostage);
            if (m.PostageAmt != null && Object.hasOwnProperty.call(m, "PostageAmt"))
                w.uint32(264).int64(m.PostageAmt);
            if (m.IsHalf != null && Object.hasOwnProperty.call(m, "IsHalf"))
                w.uint32(272).int32(m.IsHalf);
            if (m.HalfMax != null && Object.hasOwnProperty.call(m, "HalfMax"))
                w.uint32(280).int32(m.HalfMax);
            if (m.IsBofo != null && Object.hasOwnProperty.call(m, "IsBofo"))
                w.uint32(288).int32(m.IsBofo);
            if (m.BofoMax != null && Object.hasOwnProperty.call(m, "BofoMax"))
                w.uint32(296).int32(m.BofoMax);
            if (m.SDate != null && Object.hasOwnProperty.call(m, "SDate"))
                w.uint32(304).int64(m.SDate);
            if (m.EDate != null && Object.hasOwnProperty.call(m, "EDate"))
                w.uint32(312).int64(m.EDate);
            if (m.PromoState != null && Object.hasOwnProperty.call(m, "PromoState"))
                w.uint32(320).int32(m.PromoState);
            if (m.GroupID != null && Object.hasOwnProperty.call(m, "GroupID"))
                w.uint32(328).uint64(m.GroupID);
            if (m.PublishTime != null && Object.hasOwnProperty.call(m, "PublishTime"))
                w.uint32(336).int64(m.PublishTime);
            if (m.PublishUserID != null && Object.hasOwnProperty.call(m, "PublishUserID"))
                w.uint32(344).uint64(m.PublishUserID);
            if (m.CloseTime != null && Object.hasOwnProperty.call(m, "CloseTime"))
                w.uint32(352).int64(m.CloseTime);
            if (m.CloseUserID != null && Object.hasOwnProperty.call(m, "CloseUserID"))
                w.uint32(360).uint64(m.CloseUserID);
            if (m.CloseCate != null && Object.hasOwnProperty.call(m, "CloseCate"))
                w.uint32(368).int32(m.CloseCate);
            if (m.OrderValue != null && Object.hasOwnProperty.call(m, "OrderValue"))
                w.uint32(376).int32(m.OrderValue);
            if (m.CreateTime != null && Object.hasOwnProperty.call(m, "CreateTime"))
                w.uint32(384).int64(m.CreateTime);
            if (m.CreaterID != null && Object.hasOwnProperty.call(m, "CreaterID"))
                w.uint32(392).uint64(m.CreaterID);
            if (m.UpdateTime != null && Object.hasOwnProperty.call(m, "UpdateTime"))
                w.uint32(400).int64(m.UpdateTime);
            if (m.UpdaterID != null && Object.hasOwnProperty.call(m, "UpdaterID"))
                w.uint32(408).uint64(m.UpdaterID);
            if (m.Estate != null && Object.hasOwnProperty.call(m, "Estate"))
                w.uint32(416).int32(m.Estate);
            return w;
        };

        Promo.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.Promo();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        m.PromoID = r.uint64();
                        break;
                    }
                    case 2: {
                        m.MchID = r.uint64();
                        break;
                    }
                    case 3: {
                        m.SPTitle1 = r.string();
                        break;
                    }
                    case 4: {
                        m.SPTitle2 = r.string();
                        break;
                    }
                    case 5: {
                        m.SPTitle3 = r.string();
                        break;
                    }
                    case 6: {
                        m.SPCate = r.int32();
                        break;
                    }
                    case 7: {
                        m.IsShop = r.int32();
                        break;
                    }
                    case 8: {
                        m.IsTakeAway = r.int32();
                        break;
                    }
                    case 9: {
                        m.IsYourself = r.int32();
                        break;
                    }
                    case 10: {
                        m.MinAmt = r.int64();
                        break;
                    }
                    case 11: {
                        m.IsLimitGC = r.int32();
                        break;
                    }
                    case 12: {
                        m.LimitGCJson = r.string();
                        break;
                    }
                    case 13: {
                        m.IsLimitWeek = r.int32();
                        break;
                    }
                    case 14: {
                        m.LimitWeek = r.string();
                        break;
                    }
                    case 15: {
                        m.IsLimitTime = r.int32();
                        break;
                    }
                    case 16: {
                        m.STime = r.double();
                        break;
                    }
                    case 17: {
                        m.ETime = r.double();
                        break;
                    }
                    case 18: {
                        m.IsSaleAmt = r.int32();
                        break;
                    }
                    case 19: {
                        m.SaleAmt = r.int64();
                        break;
                    }
                    case 20: {
                        m.IsGiveAmt = r.int32();
                        break;
                    }
                    case 21: {
                        m.GiveAmt = r.int64();
                        break;
                    }
                    case 22: {
                        m.IsGivePoints = r.int32();
                        break;
                    }
                    case 23: {
                        m.GivePoints = r.int64();
                        break;
                    }
                    case 24: {
                        m.IsGiveGoods = r.int32();
                        break;
                    }
                    case 25: {
                        m.GiveMaxGoods = r.int32();
                        break;
                    }
                    case 26: {
                        m.IsBuyGoods = r.int32();
                        break;
                    }
                    case 27: {
                        m.IsDis = r.int32();
                        break;
                    }
                    case 28: {
                        m.DisRate = r.int32();
                        break;
                    }
                    case 29: {
                        m.DisMaxAmt = r.int64();
                        break;
                    }
                    case 30: {
                        m.IsGiveCoupon = r.int32();
                        break;
                    }
                    case 31: {
                        m.GiveCopuonID = r.string();
                        break;
                    }
                    case 32: {
                        m.IsPostage = r.int32();
                        break;
                    }
                    case 33: {
                        m.PostageAmt = r.int64();
                        break;
                    }
                    case 34: {
                        m.IsHalf = r.int32();
                        break;
                    }
                    case 35: {
                        m.HalfMax = r.int32();
                        break;
                    }
                    case 36: {
                        m.IsBofo = r.int32();
                        break;
                    }
                    case 37: {
                        m.BofoMax = r.int32();
                        break;
                    }
                    case 38: {
                        m.SDate = r.int64();
                        break;
                    }
                    case 39: {
                        m.EDate = r.int64();
                        break;
                    }
                    case 40: {
                        m.PromoState = r.int32();
                        break;
                    }
                    case 41: {
                        m.GroupID = r.uint64();
                        break;
                    }
                    case 42: {
                        m.PublishTime = r.int64();
                        break;
                    }
                    case 43: {
                        m.PublishUserID = r.uint64();
                        break;
                    }
                    case 44: {
                        m.CloseTime = r.int64();
                        break;
                    }
                    case 45: {
                        m.CloseUserID = r.uint64();
                        break;
                    }
                    case 46: {
                        m.CloseCate = r.int32();
                        break;
                    }
                    case 47: {
                        m.OrderValue = r.int32();
                        break;
                    }
                    case 48: {
                        m.CreateTime = r.int64();
                        break;
                    }
                    case 49: {
                        m.CreaterID = r.uint64();
                        break;
                    }
                    case 50: {
                        m.UpdateTime = r.int64();
                        break;
                    }
                    case 51: {
                        m.UpdaterID = r.uint64();
                        break;
                    }
                    case 52: {
                        m.Estate = r.int32();
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        Promo.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.Promo";
        };

        return Promo;
    })();

    PBEntity.Promos = (function () {

        function Promos(p) {
            this.Promos = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        Promos.prototype.Promos = $util.emptyArray;

        Promos.create = function create(properties) {
            return new Promos(properties);
        };

        Promos.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.Promos != null && m.Promos.length) {
                for (var i = 0; i < m.Promos.length; ++i)
                    $root.PBEntity.Promo.encode(m.Promos[i], w.uint32(10).fork()).ldelim();
            }
            return w;
        };

        Promos.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.Promos();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        if (!(m.Promos && m.Promos.length))
                            m.Promos = [];
                        m.Promos.push($root.PBEntity.Promo.decode(r, r.uint32()));
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        Promos.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.Promos";
        };

        return Promos;
    })();

    PBEntity.PromoGoods = (function () {

        function PromoGoods(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        PromoGoods.prototype.BelongID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        PromoGoods.prototype.GoodsID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        PromoGoods.prototype.BelongCate = 0;
        PromoGoods.prototype.MchID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        PromoGoods.prototype.SaleCate = 0;
        PromoGoods.prototype.SKUID = "";
        PromoGoods.prototype.SpecsID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        PromoGoods.prototype.OptID1 = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        PromoGoods.prototype.OptID2 = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        PromoGoods.prototype.OptID3 = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        PromoGoods.prototype.Num = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        PromoGoods.prototype.MinNum = 0;
        PromoGoods.prototype.MaxNum = 0;
        PromoGoods.prototype.IsDefault = 0;
        PromoGoods.prototype.PriceCate = 0;
        PromoGoods.prototype.SalePrice = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        PromoGoods.prototype.SaleDisRate = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        PromoGoods.prototype.OrderValue = 0;
        PromoGoods.prototype.CreateTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        PromoGoods.prototype.CreaterID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        PromoGoods.prototype.UpdateTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        PromoGoods.prototype.UpdaterID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        PromoGoods.prototype.Estate = 0;

        PromoGoods.create = function create(properties) {
            return new PromoGoods(properties);
        };

        PromoGoods.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.BelongID != null && Object.hasOwnProperty.call(m, "BelongID"))
                w.uint32(8).uint64(m.BelongID);
            if (m.GoodsID != null && Object.hasOwnProperty.call(m, "GoodsID"))
                w.uint32(16).uint64(m.GoodsID);
            if (m.BelongCate != null && Object.hasOwnProperty.call(m, "BelongCate"))
                w.uint32(24).int32(m.BelongCate);
            if (m.MchID != null && Object.hasOwnProperty.call(m, "MchID"))
                w.uint32(32).uint64(m.MchID);
            if (m.SaleCate != null && Object.hasOwnProperty.call(m, "SaleCate"))
                w.uint32(40).int32(m.SaleCate);
            if (m.SKUID != null && Object.hasOwnProperty.call(m, "SKUID"))
                w.uint32(50).string(m.SKUID);
            if (m.SpecsID != null && Object.hasOwnProperty.call(m, "SpecsID"))
                w.uint32(56).uint64(m.SpecsID);
            if (m.OptID1 != null && Object.hasOwnProperty.call(m, "OptID1"))
                w.uint32(64).uint64(m.OptID1);
            if (m.OptID2 != null && Object.hasOwnProperty.call(m, "OptID2"))
                w.uint32(72).uint64(m.OptID2);
            if (m.OptID3 != null && Object.hasOwnProperty.call(m, "OptID3"))
                w.uint32(80).uint64(m.OptID3);
            if (m.Num != null && Object.hasOwnProperty.call(m, "Num"))
                w.uint32(88).int64(m.Num);
            if (m.MinNum != null && Object.hasOwnProperty.call(m, "MinNum"))
                w.uint32(96).int32(m.MinNum);
            if (m.MaxNum != null && Object.hasOwnProperty.call(m, "MaxNum"))
                w.uint32(104).int32(m.MaxNum);
            if (m.IsDefault != null && Object.hasOwnProperty.call(m, "IsDefault"))
                w.uint32(112).int32(m.IsDefault);
            if (m.PriceCate != null && Object.hasOwnProperty.call(m, "PriceCate"))
                w.uint32(120).int32(m.PriceCate);
            if (m.SalePrice != null && Object.hasOwnProperty.call(m, "SalePrice"))
                w.uint32(128).int64(m.SalePrice);
            if (m.SaleDisRate != null && Object.hasOwnProperty.call(m, "SaleDisRate"))
                w.uint32(136).int64(m.SaleDisRate);
            if (m.OrderValue != null && Object.hasOwnProperty.call(m, "OrderValue"))
                w.uint32(144).int32(m.OrderValue);
            if (m.CreateTime != null && Object.hasOwnProperty.call(m, "CreateTime"))
                w.uint32(152).int64(m.CreateTime);
            if (m.CreaterID != null && Object.hasOwnProperty.call(m, "CreaterID"))
                w.uint32(160).uint64(m.CreaterID);
            if (m.UpdateTime != null && Object.hasOwnProperty.call(m, "UpdateTime"))
                w.uint32(168).int64(m.UpdateTime);
            if (m.UpdaterID != null && Object.hasOwnProperty.call(m, "UpdaterID"))
                w.uint32(176).uint64(m.UpdaterID);
            if (m.Estate != null && Object.hasOwnProperty.call(m, "Estate"))
                w.uint32(184).int32(m.Estate);
            return w;
        };

        PromoGoods.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.PromoGoods();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        m.BelongID = r.uint64();
                        break;
                    }
                    case 2: {
                        m.GoodsID = r.uint64();
                        break;
                    }
                    case 3: {
                        m.BelongCate = r.int32();
                        break;
                    }
                    case 4: {
                        m.MchID = r.uint64();
                        break;
                    }
                    case 5: {
                        m.SaleCate = r.int32();
                        break;
                    }
                    case 6: {
                        m.SKUID = r.string();
                        break;
                    }
                    case 7: {
                        m.SpecsID = r.uint64();
                        break;
                    }
                    case 8: {
                        m.OptID1 = r.uint64();
                        break;
                    }
                    case 9: {
                        m.OptID2 = r.uint64();
                        break;
                    }
                    case 10: {
                        m.OptID3 = r.uint64();
                        break;
                    }
                    case 11: {
                        m.Num = r.int64();
                        break;
                    }
                    case 12: {
                        m.MinNum = r.int32();
                        break;
                    }
                    case 13: {
                        m.MaxNum = r.int32();
                        break;
                    }
                    case 14: {
                        m.IsDefault = r.int32();
                        break;
                    }
                    case 15: {
                        m.PriceCate = r.int32();
                        break;
                    }
                    case 16: {
                        m.SalePrice = r.int64();
                        break;
                    }
                    case 17: {
                        m.SaleDisRate = r.int64();
                        break;
                    }
                    case 18: {
                        m.OrderValue = r.int32();
                        break;
                    }
                    case 19: {
                        m.CreateTime = r.int64();
                        break;
                    }
                    case 20: {
                        m.CreaterID = r.uint64();
                        break;
                    }
                    case 21: {
                        m.UpdateTime = r.int64();
                        break;
                    }
                    case 22: {
                        m.UpdaterID = r.uint64();
                        break;
                    }
                    case 23: {
                        m.Estate = r.int32();
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        PromoGoods.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.PromoGoods";
        };

        return PromoGoods;
    })();

    PBEntity.PromoGoodss = (function () {

        function PromoGoodss(p) {
            this.PromoGoodss = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        PromoGoodss.prototype.PromoGoodss = $util.emptyArray;

        PromoGoodss.create = function create(properties) {
            return new PromoGoodss(properties);
        };

        PromoGoodss.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.PromoGoodss != null && m.PromoGoodss.length) {
                for (var i = 0; i < m.PromoGoodss.length; ++i)
                    $root.PBEntity.PromoGoods.encode(m.PromoGoodss[i], w.uint32(10).fork()).ldelim();
            }
            return w;
        };

        PromoGoodss.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.PromoGoodss();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        if (!(m.PromoGoodss && m.PromoGoodss.length))
                            m.PromoGoodss = [];
                        m.PromoGoodss.push($root.PBEntity.PromoGoods.decode(r, r.uint32()));
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        PromoGoodss.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.PromoGoodss";
        };

        return PromoGoodss;
    })();

    PBEntity.QRCode = (function () {

        function QRCode(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        QRCode.prototype.ID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        QRCode.prototype.Category = 0;
        QRCode.prototype.RelatedID = "";
        QRCode.prototype.MchID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        QRCode.prototype.ToID = "";
        QRCode.prototype.BindStatus = 0;
        QRCode.prototype.BindCount = 0;
        QRCode.prototype.BindTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        QRCode.prototype.BindUserID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        QRCode.prototype.UnBindTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        QRCode.prototype.UnBindUserID = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        QRCode.prototype.CreateTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        QRCode.prototype.CreaterID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        QRCode.prototype.UpdateTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        QRCode.prototype.UpdaterID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        QRCode.prototype.Estate = 0;

        QRCode.create = function create(properties) {
            return new QRCode(properties);
        };

        QRCode.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.ID != null && Object.hasOwnProperty.call(m, "ID"))
                w.uint32(8).uint64(m.ID);
            if (m.Category != null && Object.hasOwnProperty.call(m, "Category"))
                w.uint32(16).int32(m.Category);
            if (m.RelatedID != null && Object.hasOwnProperty.call(m, "RelatedID"))
                w.uint32(26).string(m.RelatedID);
            if (m.MchID != null && Object.hasOwnProperty.call(m, "MchID"))
                w.uint32(32).uint64(m.MchID);
            if (m.ToID != null && Object.hasOwnProperty.call(m, "ToID"))
                w.uint32(42).string(m.ToID);
            if (m.BindStatus != null && Object.hasOwnProperty.call(m, "BindStatus"))
                w.uint32(48).int32(m.BindStatus);
            if (m.BindCount != null && Object.hasOwnProperty.call(m, "BindCount"))
                w.uint32(56).int32(m.BindCount);
            if (m.BindTime != null && Object.hasOwnProperty.call(m, "BindTime"))
                w.uint32(64).int64(m.BindTime);
            if (m.BindUserID != null && Object.hasOwnProperty.call(m, "BindUserID"))
                w.uint32(72).uint64(m.BindUserID);
            if (m.UnBindTime != null && Object.hasOwnProperty.call(m, "UnBindTime"))
                w.uint32(80).int64(m.UnBindTime);
            if (m.UnBindUserID != null && Object.hasOwnProperty.call(m, "UnBindUserID"))
                w.uint32(88).int64(m.UnBindUserID);
            if (m.CreateTime != null && Object.hasOwnProperty.call(m, "CreateTime"))
                w.uint32(96).int64(m.CreateTime);
            if (m.CreaterID != null && Object.hasOwnProperty.call(m, "CreaterID"))
                w.uint32(104).uint64(m.CreaterID);
            if (m.UpdateTime != null && Object.hasOwnProperty.call(m, "UpdateTime"))
                w.uint32(112).int64(m.UpdateTime);
            if (m.UpdaterID != null && Object.hasOwnProperty.call(m, "UpdaterID"))
                w.uint32(120).uint64(m.UpdaterID);
            if (m.Estate != null && Object.hasOwnProperty.call(m, "Estate"))
                w.uint32(128).int32(m.Estate);
            return w;
        };

        QRCode.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.QRCode();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        m.ID = r.uint64();
                        break;
                    }
                    case 2: {
                        m.Category = r.int32();
                        break;
                    }
                    case 3: {
                        m.RelatedID = r.string();
                        break;
                    }
                    case 4: {
                        m.MchID = r.uint64();
                        break;
                    }
                    case 5: {
                        m.ToID = r.string();
                        break;
                    }
                    case 6: {
                        m.BindStatus = r.int32();
                        break;
                    }
                    case 7: {
                        m.BindCount = r.int32();
                        break;
                    }
                    case 8: {
                        m.BindTime = r.int64();
                        break;
                    }
                    case 9: {
                        m.BindUserID = r.uint64();
                        break;
                    }
                    case 10: {
                        m.UnBindTime = r.int64();
                        break;
                    }
                    case 11: {
                        m.UnBindUserID = r.int64();
                        break;
                    }
                    case 12: {
                        m.CreateTime = r.int64();
                        break;
                    }
                    case 13: {
                        m.CreaterID = r.uint64();
                        break;
                    }
                    case 14: {
                        m.UpdateTime = r.int64();
                        break;
                    }
                    case 15: {
                        m.UpdaterID = r.uint64();
                        break;
                    }
                    case 16: {
                        m.Estate = r.int32();
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        QRCode.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.QRCode";
        };

        return QRCode;
    })();

    PBEntity.QRCodes = (function () {

        function QRCodes(p) {
            this.QRCodes = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        QRCodes.prototype.QRCodes = $util.emptyArray;

        QRCodes.create = function create(properties) {
            return new QRCodes(properties);
        };

        QRCodes.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.QRCodes != null && m.QRCodes.length) {
                for (var i = 0; i < m.QRCodes.length; ++i)
                    $root.PBEntity.QRCode.encode(m.QRCodes[i], w.uint32(10).fork()).ldelim();
            }
            return w;
        };

        QRCodes.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.QRCodes();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        if (!(m.QRCodes && m.QRCodes.length))
                            m.QRCodes = [];
                        m.QRCodes.push($root.PBEntity.QRCode.decode(r, r.uint32()));
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        QRCodes.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.QRCodes";
        };

        return QRCodes;
    })();

    PBEntity.Recharge = (function () {

        function Recharge(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        Recharge.prototype.ID = "";
        Recharge.prototype.MchID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        Recharge.prototype.UserID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        Recharge.prototype.UUID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        Recharge.prototype.TransDate = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Recharge.prototype.RCID = "";
        Recharge.prototype.OpUserCate = 0;
        Recharge.prototype.OpUserID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        Recharge.prototype.OpUserName = "";
        Recharge.prototype.Amount = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Recharge.prototype.RewardCategory = 0;
        Recharge.prototype.RewardAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Recharge.prototype.RewardRate = 0;
        Recharge.prototype.RewardPointsCategory = 0;
        Recharge.prototype.RewardPoints = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Recharge.prototype.RewardPointsRate = 0;
        Recharge.prototype.IsGiveCoupon = 0;
        Recharge.prototype.GiveCouponID = "";
        Recharge.prototype.GiveCouponTitle = "";
        Recharge.prototype.GiveCouponResult = 0;
        Recharge.prototype.GiveCouponNotes = "";
        Recharge.prototype.Notes = "";
        Recharge.prototype.PayTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Recharge.prototype.PayPlatform = 0;
        Recharge.prototype.PayChannel = 0;
        Recharge.prototype.PayState = 0;
        Recharge.prototype.PayID = "";
        Recharge.prototype.GiveCouponRecID = "";
        Recharge.prototype.RewardState = 0;
        Recharge.prototype.CheckState = 0;
        Recharge.prototype.PrintCount = 0;
        Recharge.prototype.IsNotice = 0;
        Recharge.prototype.GroupID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        Recharge.prototype.AgentID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        Recharge.prototype.CreateTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Recharge.prototype.CreaterID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        Recharge.prototype.UpdateTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Recharge.prototype.UpdaterID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        Recharge.prototype.Estate = 0;
        Recharge.prototype.AccCate = 0;
        Recharge.prototype.AccID = "";
        Recharge.prototype.ReceiptID = "";

        Recharge.create = function create(properties) {
            return new Recharge(properties);
        };

        Recharge.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.ID != null && Object.hasOwnProperty.call(m, "ID"))
                w.uint32(10).string(m.ID);
            if (m.MchID != null && Object.hasOwnProperty.call(m, "MchID"))
                w.uint32(16).uint64(m.MchID);
            if (m.UserID != null && Object.hasOwnProperty.call(m, "UserID"))
                w.uint32(24).uint64(m.UserID);
            if (m.UUID != null && Object.hasOwnProperty.call(m, "UUID"))
                w.uint32(32).uint64(m.UUID);
            if (m.TransDate != null && Object.hasOwnProperty.call(m, "TransDate"))
                w.uint32(40).int64(m.TransDate);
            if (m.RCID != null && Object.hasOwnProperty.call(m, "RCID"))
                w.uint32(50).string(m.RCID);
            if (m.OpUserCate != null && Object.hasOwnProperty.call(m, "OpUserCate"))
                w.uint32(56).int32(m.OpUserCate);
            if (m.OpUserID != null && Object.hasOwnProperty.call(m, "OpUserID"))
                w.uint32(64).uint64(m.OpUserID);
            if (m.OpUserName != null && Object.hasOwnProperty.call(m, "OpUserName"))
                w.uint32(74).string(m.OpUserName);
            if (m.Amount != null && Object.hasOwnProperty.call(m, "Amount"))
                w.uint32(80).int64(m.Amount);
            if (m.RewardCategory != null && Object.hasOwnProperty.call(m, "RewardCategory"))
                w.uint32(88).int32(m.RewardCategory);
            if (m.RewardAmt != null && Object.hasOwnProperty.call(m, "RewardAmt"))
                w.uint32(96).int64(m.RewardAmt);
            if (m.RewardRate != null && Object.hasOwnProperty.call(m, "RewardRate"))
                w.uint32(104).int32(m.RewardRate);
            if (m.RewardPointsCategory != null && Object.hasOwnProperty.call(m, "RewardPointsCategory"))
                w.uint32(112).int32(m.RewardPointsCategory);
            if (m.RewardPoints != null && Object.hasOwnProperty.call(m, "RewardPoints"))
                w.uint32(120).int64(m.RewardPoints);
            if (m.RewardPointsRate != null && Object.hasOwnProperty.call(m, "RewardPointsRate"))
                w.uint32(128).int32(m.RewardPointsRate);
            if (m.IsGiveCoupon != null && Object.hasOwnProperty.call(m, "IsGiveCoupon"))
                w.uint32(136).int32(m.IsGiveCoupon);
            if (m.GiveCouponID != null && Object.hasOwnProperty.call(m, "GiveCouponID"))
                w.uint32(146).string(m.GiveCouponID);
            if (m.GiveCouponTitle != null && Object.hasOwnProperty.call(m, "GiveCouponTitle"))
                w.uint32(154).string(m.GiveCouponTitle);
            if (m.GiveCouponResult != null && Object.hasOwnProperty.call(m, "GiveCouponResult"))
                w.uint32(160).int32(m.GiveCouponResult);
            if (m.GiveCouponNotes != null && Object.hasOwnProperty.call(m, "GiveCouponNotes"))
                w.uint32(170).string(m.GiveCouponNotes);
            if (m.Notes != null && Object.hasOwnProperty.call(m, "Notes"))
                w.uint32(178).string(m.Notes);
            if (m.PayTime != null && Object.hasOwnProperty.call(m, "PayTime"))
                w.uint32(184).int64(m.PayTime);
            if (m.PayPlatform != null && Object.hasOwnProperty.call(m, "PayPlatform"))
                w.uint32(192).int32(m.PayPlatform);
            if (m.PayChannel != null && Object.hasOwnProperty.call(m, "PayChannel"))
                w.uint32(200).int32(m.PayChannel);
            if (m.PayState != null && Object.hasOwnProperty.call(m, "PayState"))
                w.uint32(208).int32(m.PayState);
            if (m.PayID != null && Object.hasOwnProperty.call(m, "PayID"))
                w.uint32(218).string(m.PayID);
            if (m.GiveCouponRecID != null && Object.hasOwnProperty.call(m, "GiveCouponRecID"))
                w.uint32(226).string(m.GiveCouponRecID);
            if (m.RewardState != null && Object.hasOwnProperty.call(m, "RewardState"))
                w.uint32(232).int32(m.RewardState);
            if (m.CheckState != null && Object.hasOwnProperty.call(m, "CheckState"))
                w.uint32(240).int32(m.CheckState);
            if (m.PrintCount != null && Object.hasOwnProperty.call(m, "PrintCount"))
                w.uint32(248).int32(m.PrintCount);
            if (m.IsNotice != null && Object.hasOwnProperty.call(m, "IsNotice"))
                w.uint32(256).int32(m.IsNotice);
            if (m.GroupID != null && Object.hasOwnProperty.call(m, "GroupID"))
                w.uint32(264).uint64(m.GroupID);
            if (m.AgentID != null && Object.hasOwnProperty.call(m, "AgentID"))
                w.uint32(272).uint64(m.AgentID);
            if (m.CreateTime != null && Object.hasOwnProperty.call(m, "CreateTime"))
                w.uint32(280).int64(m.CreateTime);
            if (m.CreaterID != null && Object.hasOwnProperty.call(m, "CreaterID"))
                w.uint32(288).uint64(m.CreaterID);
            if (m.UpdateTime != null && Object.hasOwnProperty.call(m, "UpdateTime"))
                w.uint32(296).int64(m.UpdateTime);
            if (m.UpdaterID != null && Object.hasOwnProperty.call(m, "UpdaterID"))
                w.uint32(304).uint64(m.UpdaterID);
            if (m.Estate != null && Object.hasOwnProperty.call(m, "Estate"))
                w.uint32(312).int32(m.Estate);
            if (m.AccCate != null && Object.hasOwnProperty.call(m, "AccCate"))
                w.uint32(320).int32(m.AccCate);
            if (m.AccID != null && Object.hasOwnProperty.call(m, "AccID"))
                w.uint32(330).string(m.AccID);
            if (m.ReceiptID != null && Object.hasOwnProperty.call(m, "ReceiptID"))
                w.uint32(338).string(m.ReceiptID);
            return w;
        };

        Recharge.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.Recharge();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        m.ID = r.string();
                        break;
                    }
                    case 2: {
                        m.MchID = r.uint64();
                        break;
                    }
                    case 3: {
                        m.UserID = r.uint64();
                        break;
                    }
                    case 4: {
                        m.UUID = r.uint64();
                        break;
                    }
                    case 5: {
                        m.TransDate = r.int64();
                        break;
                    }
                    case 6: {
                        m.RCID = r.string();
                        break;
                    }
                    case 7: {
                        m.OpUserCate = r.int32();
                        break;
                    }
                    case 8: {
                        m.OpUserID = r.uint64();
                        break;
                    }
                    case 9: {
                        m.OpUserName = r.string();
                        break;
                    }
                    case 10: {
                        m.Amount = r.int64();
                        break;
                    }
                    case 11: {
                        m.RewardCategory = r.int32();
                        break;
                    }
                    case 12: {
                        m.RewardAmt = r.int64();
                        break;
                    }
                    case 13: {
                        m.RewardRate = r.int32();
                        break;
                    }
                    case 14: {
                        m.RewardPointsCategory = r.int32();
                        break;
                    }
                    case 15: {
                        m.RewardPoints = r.int64();
                        break;
                    }
                    case 16: {
                        m.RewardPointsRate = r.int32();
                        break;
                    }
                    case 17: {
                        m.IsGiveCoupon = r.int32();
                        break;
                    }
                    case 18: {
                        m.GiveCouponID = r.string();
                        break;
                    }
                    case 19: {
                        m.GiveCouponTitle = r.string();
                        break;
                    }
                    case 20: {
                        m.GiveCouponResult = r.int32();
                        break;
                    }
                    case 21: {
                        m.GiveCouponNotes = r.string();
                        break;
                    }
                    case 22: {
                        m.Notes = r.string();
                        break;
                    }
                    case 23: {
                        m.PayTime = r.int64();
                        break;
                    }
                    case 24: {
                        m.PayPlatform = r.int32();
                        break;
                    }
                    case 25: {
                        m.PayChannel = r.int32();
                        break;
                    }
                    case 26: {
                        m.PayState = r.int32();
                        break;
                    }
                    case 27: {
                        m.PayID = r.string();
                        break;
                    }
                    case 28: {
                        m.GiveCouponRecID = r.string();
                        break;
                    }
                    case 29: {
                        m.RewardState = r.int32();
                        break;
                    }
                    case 30: {
                        m.CheckState = r.int32();
                        break;
                    }
                    case 31: {
                        m.PrintCount = r.int32();
                        break;
                    }
                    case 32: {
                        m.IsNotice = r.int32();
                        break;
                    }
                    case 33: {
                        m.GroupID = r.uint64();
                        break;
                    }
                    case 34: {
                        m.AgentID = r.uint64();
                        break;
                    }
                    case 35: {
                        m.CreateTime = r.int64();
                        break;
                    }
                    case 36: {
                        m.CreaterID = r.uint64();
                        break;
                    }
                    case 37: {
                        m.UpdateTime = r.int64();
                        break;
                    }
                    case 38: {
                        m.UpdaterID = r.uint64();
                        break;
                    }
                    case 39: {
                        m.Estate = r.int32();
                        break;
                    }
                    case 40: {
                        m.AccCate = r.int32();
                        break;
                    }
                    case 41: {
                        m.AccID = r.string();
                        break;
                    }
                    case 42: {
                        m.ReceiptID = r.string();
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        Recharge.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.Recharge";
        };

        return Recharge;
    })();

    PBEntity.Recharges = (function () {

        function Recharges(p) {
            this.Recharges = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        Recharges.prototype.Recharges = $util.emptyArray;

        Recharges.create = function create(properties) {
            return new Recharges(properties);
        };

        Recharges.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.Recharges != null && m.Recharges.length) {
                for (var i = 0; i < m.Recharges.length; ++i)
                    $root.PBEntity.Recharge.encode(m.Recharges[i], w.uint32(10).fork()).ldelim();
            }
            return w;
        };

        Recharges.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.Recharges();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        if (!(m.Recharges && m.Recharges.length))
                            m.Recharges = [];
                        m.Recharges.push($root.PBEntity.Recharge.decode(r, r.uint32()));
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        Recharges.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.Recharges";
        };

        return Recharges;
    })();

    PBEntity.Role = (function () {

        function Role(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        Role.prototype.ID = "";
        Role.prototype.Name = "";
        Role.prototype.Estate = 0;
        Role.prototype.Platform = 0;
        Role.prototype.RelatedID = "";

        Role.create = function create(properties) {
            return new Role(properties);
        };

        Role.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.ID != null && Object.hasOwnProperty.call(m, "ID"))
                w.uint32(10).string(m.ID);
            if (m.Name != null && Object.hasOwnProperty.call(m, "Name"))
                w.uint32(18).string(m.Name);
            if (m.Estate != null && Object.hasOwnProperty.call(m, "Estate"))
                w.uint32(24).int32(m.Estate);
            if (m.Platform != null && Object.hasOwnProperty.call(m, "Platform"))
                w.uint32(32).int32(m.Platform);
            if (m.RelatedID != null && Object.hasOwnProperty.call(m, "RelatedID"))
                w.uint32(42).string(m.RelatedID);
            return w;
        };

        Role.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.Role();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        m.ID = r.string();
                        break;
                    }
                    case 2: {
                        m.Name = r.string();
                        break;
                    }
                    case 3: {
                        m.Estate = r.int32();
                        break;
                    }
                    case 4: {
                        m.Platform = r.int32();
                        break;
                    }
                    case 5: {
                        m.RelatedID = r.string();
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        Role.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.Role";
        };

        return Role;
    })();

    PBEntity.Roles = (function () {

        function Roles(p) {
            this.Roles = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        Roles.prototype.Roles = $util.emptyArray;

        Roles.create = function create(properties) {
            return new Roles(properties);
        };

        Roles.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.Roles != null && m.Roles.length) {
                for (var i = 0; i < m.Roles.length; ++i)
                    $root.PBEntity.Role.encode(m.Roles[i], w.uint32(10).fork()).ldelim();
            }
            return w;
        };

        Roles.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.Roles();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        if (!(m.Roles && m.Roles.length))
                            m.Roles = [];
                        m.Roles.push($root.PBEntity.Role.decode(r, r.uint32()));
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        Roles.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.Roles";
        };

        return Roles;
    })();

    PBEntity.RolePermission = (function () {

        function RolePermission(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        RolePermission.prototype.RoleID = "";
        RolePermission.prototype.ModuleID = "";
        RolePermission.prototype.Permission = 0;

        RolePermission.create = function create(properties) {
            return new RolePermission(properties);
        };

        RolePermission.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.RoleID != null && Object.hasOwnProperty.call(m, "RoleID"))
                w.uint32(10).string(m.RoleID);
            if (m.ModuleID != null && Object.hasOwnProperty.call(m, "ModuleID"))
                w.uint32(18).string(m.ModuleID);
            if (m.Permission != null && Object.hasOwnProperty.call(m, "Permission"))
                w.uint32(24).int32(m.Permission);
            return w;
        };

        RolePermission.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.RolePermission();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        m.RoleID = r.string();
                        break;
                    }
                    case 2: {
                        m.ModuleID = r.string();
                        break;
                    }
                    case 3: {
                        m.Permission = r.int32();
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        RolePermission.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.RolePermission";
        };

        return RolePermission;
    })();

    PBEntity.RolePermissions = (function () {

        function RolePermissions(p) {
            this.RolePermissions = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        RolePermissions.prototype.RolePermissions = $util.emptyArray;

        RolePermissions.create = function create(properties) {
            return new RolePermissions(properties);
        };

        RolePermissions.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.RolePermissions != null && m.RolePermissions.length) {
                for (var i = 0; i < m.RolePermissions.length; ++i)
                    $root.PBEntity.RolePermission.encode(m.RolePermissions[i], w.uint32(10).fork()).ldelim();
            }
            return w;
        };

        RolePermissions.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.RolePermissions();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        if (!(m.RolePermissions && m.RolePermissions.length))
                            m.RolePermissions = [];
                        m.RolePermissions.push($root.PBEntity.RolePermission.decode(r, r.uint32()));
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        RolePermissions.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.RolePermissions";
        };

        return RolePermissions;
    })();

    PBEntity.SysConfig = (function () {

        function SysConfig(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        SysConfig.prototype.ID = "";
        SysConfig.prototype.Code = "";
        SysConfig.prototype.Value = "";
        SysConfig.prototype.Data = $util.newBuffer([]);
        SysConfig.prototype.Estate = 0;
        SysConfig.prototype.Desc = "";

        SysConfig.create = function create(properties) {
            return new SysConfig(properties);
        };

        SysConfig.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.ID != null && Object.hasOwnProperty.call(m, "ID"))
                w.uint32(10).string(m.ID);
            if (m.Code != null && Object.hasOwnProperty.call(m, "Code"))
                w.uint32(18).string(m.Code);
            if (m.Value != null && Object.hasOwnProperty.call(m, "Value"))
                w.uint32(26).string(m.Value);
            if (m.Data != null && Object.hasOwnProperty.call(m, "Data"))
                w.uint32(34).bytes(m.Data);
            if (m.Estate != null && Object.hasOwnProperty.call(m, "Estate"))
                w.uint32(40).int32(m.Estate);
            if (m.Desc != null && Object.hasOwnProperty.call(m, "Desc"))
                w.uint32(50).string(m.Desc);
            return w;
        };

        SysConfig.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.SysConfig();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        m.ID = r.string();
                        break;
                    }
                    case 2: {
                        m.Code = r.string();
                        break;
                    }
                    case 3: {
                        m.Value = r.string();
                        break;
                    }
                    case 4: {
                        m.Data = r.bytes();
                        break;
                    }
                    case 5: {
                        m.Estate = r.int32();
                        break;
                    }
                    case 6: {
                        m.Desc = r.string();
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        SysConfig.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.SysConfig";
        };

        return SysConfig;
    })();

    PBEntity.SysConfigs = (function () {

        function SysConfigs(p) {
            this.SysConfigs = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        SysConfigs.prototype.SysConfigs = $util.emptyArray;

        SysConfigs.create = function create(properties) {
            return new SysConfigs(properties);
        };

        SysConfigs.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.SysConfigs != null && m.SysConfigs.length) {
                for (var i = 0; i < m.SysConfigs.length; ++i)
                    $root.PBEntity.SysConfig.encode(m.SysConfigs[i], w.uint32(10).fork()).ldelim();
            }
            return w;
        };

        SysConfigs.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.SysConfigs();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        if (!(m.SysConfigs && m.SysConfigs.length))
                            m.SysConfigs = [];
                        m.SysConfigs.push($root.PBEntity.SysConfig.decode(r, r.uint32()));
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        SysConfigs.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.SysConfigs";
        };

        return SysConfigs;
    })();

    PBEntity.SysPKConfig = (function () {

        function SysPKConfig(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        SysPKConfig.prototype.PKID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        SysPKConfig.prototype.MchID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        SysPKConfig.prototype.BusCategory = 0;
        SysPKConfig.prototype.EffectiveDate = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        SysPKConfig.prototype.NextValue = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        SysPKConfig.prototype.StepValue = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        SysPKConfig.prototype.MinValue = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        SysPKConfig.prototype.MaxValue = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        SysPKConfig.prototype.Estate = 0;

        SysPKConfig.create = function create(properties) {
            return new SysPKConfig(properties);
        };

        SysPKConfig.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.PKID != null && Object.hasOwnProperty.call(m, "PKID"))
                w.uint32(8).uint64(m.PKID);
            if (m.MchID != null && Object.hasOwnProperty.call(m, "MchID"))
                w.uint32(16).uint64(m.MchID);
            if (m.BusCategory != null && Object.hasOwnProperty.call(m, "BusCategory"))
                w.uint32(24).int32(m.BusCategory);
            if (m.EffectiveDate != null && Object.hasOwnProperty.call(m, "EffectiveDate"))
                w.uint32(32).int64(m.EffectiveDate);
            if (m.NextValue != null && Object.hasOwnProperty.call(m, "NextValue"))
                w.uint32(40).uint64(m.NextValue);
            if (m.StepValue != null && Object.hasOwnProperty.call(m, "StepValue"))
                w.uint32(48).uint64(m.StepValue);
            if (m.MinValue != null && Object.hasOwnProperty.call(m, "MinValue"))
                w.uint32(56).uint64(m.MinValue);
            if (m.MaxValue != null && Object.hasOwnProperty.call(m, "MaxValue"))
                w.uint32(64).uint64(m.MaxValue);
            if (m.Estate != null && Object.hasOwnProperty.call(m, "Estate"))
                w.uint32(72).int32(m.Estate);
            return w;
        };

        SysPKConfig.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.SysPKConfig();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        m.PKID = r.uint64();
                        break;
                    }
                    case 2: {
                        m.MchID = r.uint64();
                        break;
                    }
                    case 3: {
                        m.BusCategory = r.int32();
                        break;
                    }
                    case 4: {
                        m.EffectiveDate = r.int64();
                        break;
                    }
                    case 5: {
                        m.NextValue = r.uint64();
                        break;
                    }
                    case 6: {
                        m.StepValue = r.uint64();
                        break;
                    }
                    case 7: {
                        m.MinValue = r.uint64();
                        break;
                    }
                    case 8: {
                        m.MaxValue = r.uint64();
                        break;
                    }
                    case 9: {
                        m.Estate = r.int32();
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        SysPKConfig.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.SysPKConfig";
        };

        return SysPKConfig;
    })();

    PBEntity.SysPKConfigs = (function () {

        function SysPKConfigs(p) {
            this.SysPKConfigs = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        SysPKConfigs.prototype.SysPKConfigs = $util.emptyArray;

        SysPKConfigs.create = function create(properties) {
            return new SysPKConfigs(properties);
        };

        SysPKConfigs.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.SysPKConfigs != null && m.SysPKConfigs.length) {
                for (var i = 0; i < m.SysPKConfigs.length; ++i)
                    $root.PBEntity.SysPKConfig.encode(m.SysPKConfigs[i], w.uint32(10).fork()).ldelim();
            }
            return w;
        };

        SysPKConfigs.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.SysPKConfigs();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        if (!(m.SysPKConfigs && m.SysPKConfigs.length))
                            m.SysPKConfigs = [];
                        m.SysPKConfigs.push($root.PBEntity.SysPKConfig.decode(r, r.uint32()));
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        SysPKConfigs.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.SysPKConfigs";
        };

        return SysPKConfigs;
    })();

    PBEntity.User = (function () {

        function User(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        User.prototype.UserID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        User.prototype.UserName = "";
        User.prototype.IsSetUserName = 0;
        User.prototype.DisplayName = "";
        User.prototype.Password = "";
        User.prototype.LinkName = "";
        User.prototype.LinkPhone = "";
        User.prototype.LinkMobile = "";
        User.prototype.MobileState = 0;
        User.prototype.Address = "";
        User.prototype.LinkMail = "";
        User.prototype.LinkQQ = "";
        User.prototype.LinkWX = "";
        User.prototype.UserLevel = 0;
        User.prototype.RegTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        User.prototype.RegIP = "";
        User.prototype.RegInviteCode = "";
        User.prototype.RegSource = 0;
        User.prototype.LastLoginTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        User.prototype.LastLoginIP = "";
        User.prototype.LastLoginSource = 0;
        User.prototype.LastLoginID = "";
        User.prototype.HeadImage = "";
        User.prototype.MchCount = 0;
        User.prototype.VisitedCount = 0;
        User.prototype.LoginCount = 0;
        User.prototype.Estate = 0;

        User.create = function create(properties) {
            return new User(properties);
        };

        User.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.UserID != null && Object.hasOwnProperty.call(m, "UserID"))
                w.uint32(8).uint64(m.UserID);
            if (m.UserName != null && Object.hasOwnProperty.call(m, "UserName"))
                w.uint32(18).string(m.UserName);
            if (m.IsSetUserName != null && Object.hasOwnProperty.call(m, "IsSetUserName"))
                w.uint32(24).int32(m.IsSetUserName);
            if (m.DisplayName != null && Object.hasOwnProperty.call(m, "DisplayName"))
                w.uint32(34).string(m.DisplayName);
            if (m.Password != null && Object.hasOwnProperty.call(m, "Password"))
                w.uint32(42).string(m.Password);
            if (m.LinkName != null && Object.hasOwnProperty.call(m, "LinkName"))
                w.uint32(50).string(m.LinkName);
            if (m.LinkPhone != null && Object.hasOwnProperty.call(m, "LinkPhone"))
                w.uint32(58).string(m.LinkPhone);
            if (m.LinkMobile != null && Object.hasOwnProperty.call(m, "LinkMobile"))
                w.uint32(66).string(m.LinkMobile);
            if (m.MobileState != null && Object.hasOwnProperty.call(m, "MobileState"))
                w.uint32(72).int32(m.MobileState);
            if (m.Address != null && Object.hasOwnProperty.call(m, "Address"))
                w.uint32(82).string(m.Address);
            if (m.LinkMail != null && Object.hasOwnProperty.call(m, "LinkMail"))
                w.uint32(90).string(m.LinkMail);
            if (m.LinkQQ != null && Object.hasOwnProperty.call(m, "LinkQQ"))
                w.uint32(98).string(m.LinkQQ);
            if (m.LinkWX != null && Object.hasOwnProperty.call(m, "LinkWX"))
                w.uint32(106).string(m.LinkWX);
            if (m.UserLevel != null && Object.hasOwnProperty.call(m, "UserLevel"))
                w.uint32(112).int32(m.UserLevel);
            if (m.RegTime != null && Object.hasOwnProperty.call(m, "RegTime"))
                w.uint32(120).int64(m.RegTime);
            if (m.RegIP != null && Object.hasOwnProperty.call(m, "RegIP"))
                w.uint32(130).string(m.RegIP);
            if (m.RegInviteCode != null && Object.hasOwnProperty.call(m, "RegInviteCode"))
                w.uint32(138).string(m.RegInviteCode);
            if (m.RegSource != null && Object.hasOwnProperty.call(m, "RegSource"))
                w.uint32(144).int32(m.RegSource);
            if (m.LastLoginTime != null && Object.hasOwnProperty.call(m, "LastLoginTime"))
                w.uint32(152).int64(m.LastLoginTime);
            if (m.LastLoginIP != null && Object.hasOwnProperty.call(m, "LastLoginIP"))
                w.uint32(162).string(m.LastLoginIP);
            if (m.LastLoginSource != null && Object.hasOwnProperty.call(m, "LastLoginSource"))
                w.uint32(168).int32(m.LastLoginSource);
            if (m.LastLoginID != null && Object.hasOwnProperty.call(m, "LastLoginID"))
                w.uint32(178).string(m.LastLoginID);
            if (m.HeadImage != null && Object.hasOwnProperty.call(m, "HeadImage"))
                w.uint32(186).string(m.HeadImage);
            if (m.MchCount != null && Object.hasOwnProperty.call(m, "MchCount"))
                w.uint32(192).int32(m.MchCount);
            if (m.VisitedCount != null && Object.hasOwnProperty.call(m, "VisitedCount"))
                w.uint32(200).int32(m.VisitedCount);
            if (m.LoginCount != null && Object.hasOwnProperty.call(m, "LoginCount"))
                w.uint32(208).int32(m.LoginCount);
            if (m.Estate != null && Object.hasOwnProperty.call(m, "Estate"))
                w.uint32(216).int32(m.Estate);
            return w;
        };

        User.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.User();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        m.UserID = r.uint64();
                        break;
                    }
                    case 2: {
                        m.UserName = r.string();
                        break;
                    }
                    case 3: {
                        m.IsSetUserName = r.int32();
                        break;
                    }
                    case 4: {
                        m.DisplayName = r.string();
                        break;
                    }
                    case 5: {
                        m.Password = r.string();
                        break;
                    }
                    case 6: {
                        m.LinkName = r.string();
                        break;
                    }
                    case 7: {
                        m.LinkPhone = r.string();
                        break;
                    }
                    case 8: {
                        m.LinkMobile = r.string();
                        break;
                    }
                    case 9: {
                        m.MobileState = r.int32();
                        break;
                    }
                    case 10: {
                        m.Address = r.string();
                        break;
                    }
                    case 11: {
                        m.LinkMail = r.string();
                        break;
                    }
                    case 12: {
                        m.LinkQQ = r.string();
                        break;
                    }
                    case 13: {
                        m.LinkWX = r.string();
                        break;
                    }
                    case 14: {
                        m.UserLevel = r.int32();
                        break;
                    }
                    case 15: {
                        m.RegTime = r.int64();
                        break;
                    }
                    case 16: {
                        m.RegIP = r.string();
                        break;
                    }
                    case 17: {
                        m.RegInviteCode = r.string();
                        break;
                    }
                    case 18: {
                        m.RegSource = r.int32();
                        break;
                    }
                    case 19: {
                        m.LastLoginTime = r.int64();
                        break;
                    }
                    case 20: {
                        m.LastLoginIP = r.string();
                        break;
                    }
                    case 21: {
                        m.LastLoginSource = r.int32();
                        break;
                    }
                    case 22: {
                        m.LastLoginID = r.string();
                        break;
                    }
                    case 23: {
                        m.HeadImage = r.string();
                        break;
                    }
                    case 24: {
                        m.MchCount = r.int32();
                        break;
                    }
                    case 25: {
                        m.VisitedCount = r.int32();
                        break;
                    }
                    case 26: {
                        m.LoginCount = r.int32();
                        break;
                    }
                    case 27: {
                        m.Estate = r.int32();
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        User.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.User";
        };

        return User;
    })();

    PBEntity.Users = (function () {

        function Users(p) {
            this.Users = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        Users.prototype.Users = $util.emptyArray;

        Users.create = function create(properties) {
            return new Users(properties);
        };

        Users.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.Users != null && m.Users.length) {
                for (var i = 0; i < m.Users.length; ++i)
                    $root.PBEntity.User.encode(m.Users[i], w.uint32(10).fork()).ldelim();
            }
            return w;
        };

        Users.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.Users();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        if (!(m.Users && m.Users.length))
                            m.Users = [];
                        m.Users.push($root.PBEntity.User.decode(r, r.uint32()));
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        Users.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.Users";
        };

        return Users;
    })();

    PBEntity.UserAddres = (function () {

        function UserAddres(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        UserAddres.prototype.AddrID = "";
        UserAddres.prototype.UserID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        UserAddres.prototype.PrvID = 0;
        UserAddres.prototype.AreaID = 0;
        UserAddres.prototype.CityID = 0;
        UserAddres.prototype.CountyID = 0;
        UserAddres.prototype.Town = 0;
        UserAddres.prototype.PrvCityName = "";
        UserAddres.prototype.LocateCate = 0;
        UserAddres.prototype.LocateX = 0;
        UserAddres.prototype.LocateY = 0;
        UserAddres.prototype.LocateName = "";
        UserAddres.prototype.LocateAddr = "";
        UserAddres.prototype.Address = "";
        UserAddres.prototype.LinkName = "";
        UserAddres.prototype.LinkPhone = "";
        UserAddres.prototype.IsDefault = 0;
        UserAddres.prototype.OrderValue = 0;
        UserAddres.prototype.MchID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        UserAddres.prototype.CreateTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        UserAddres.prototype.CreaterID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        UserAddres.prototype.UpdateTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        UserAddres.prototype.UpdaterID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        UserAddres.prototype.Estate = 0;

        UserAddres.create = function create(properties) {
            return new UserAddres(properties);
        };

        UserAddres.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.AddrID != null && Object.hasOwnProperty.call(m, "AddrID"))
                w.uint32(10).string(m.AddrID);
            if (m.UserID != null && Object.hasOwnProperty.call(m, "UserID"))
                w.uint32(16).uint64(m.UserID);
            if (m.PrvID != null && Object.hasOwnProperty.call(m, "PrvID"))
                w.uint32(24).int32(m.PrvID);
            if (m.AreaID != null && Object.hasOwnProperty.call(m, "AreaID"))
                w.uint32(32).int32(m.AreaID);
            if (m.CityID != null && Object.hasOwnProperty.call(m, "CityID"))
                w.uint32(40).int32(m.CityID);
            if (m.CountyID != null && Object.hasOwnProperty.call(m, "CountyID"))
                w.uint32(48).int32(m.CountyID);
            if (m.Town != null && Object.hasOwnProperty.call(m, "Town"))
                w.uint32(56).int32(m.Town);
            if (m.PrvCityName != null && Object.hasOwnProperty.call(m, "PrvCityName"))
                w.uint32(66).string(m.PrvCityName);
            if (m.LocateCate != null && Object.hasOwnProperty.call(m, "LocateCate"))
                w.uint32(72).int32(m.LocateCate);
            if (m.LocateX != null && Object.hasOwnProperty.call(m, "LocateX"))
                w.uint32(81).double(m.LocateX);
            if (m.LocateY != null && Object.hasOwnProperty.call(m, "LocateY"))
                w.uint32(89).double(m.LocateY);
            if (m.LocateName != null && Object.hasOwnProperty.call(m, "LocateName"))
                w.uint32(98).string(m.LocateName);
            if (m.LocateAddr != null && Object.hasOwnProperty.call(m, "LocateAddr"))
                w.uint32(106).string(m.LocateAddr);
            if (m.Address != null && Object.hasOwnProperty.call(m, "Address"))
                w.uint32(114).string(m.Address);
            if (m.LinkName != null && Object.hasOwnProperty.call(m, "LinkName"))
                w.uint32(122).string(m.LinkName);
            if (m.LinkPhone != null && Object.hasOwnProperty.call(m, "LinkPhone"))
                w.uint32(130).string(m.LinkPhone);
            if (m.IsDefault != null && Object.hasOwnProperty.call(m, "IsDefault"))
                w.uint32(136).int32(m.IsDefault);
            if (m.OrderValue != null && Object.hasOwnProperty.call(m, "OrderValue"))
                w.uint32(144).int32(m.OrderValue);
            if (m.MchID != null && Object.hasOwnProperty.call(m, "MchID"))
                w.uint32(152).uint64(m.MchID);
            if (m.CreateTime != null && Object.hasOwnProperty.call(m, "CreateTime"))
                w.uint32(160).int64(m.CreateTime);
            if (m.CreaterID != null && Object.hasOwnProperty.call(m, "CreaterID"))
                w.uint32(168).uint64(m.CreaterID);
            if (m.UpdateTime != null && Object.hasOwnProperty.call(m, "UpdateTime"))
                w.uint32(176).int64(m.UpdateTime);
            if (m.UpdaterID != null && Object.hasOwnProperty.call(m, "UpdaterID"))
                w.uint32(184).uint64(m.UpdaterID);
            if (m.Estate != null && Object.hasOwnProperty.call(m, "Estate"))
                w.uint32(192).int32(m.Estate);
            return w;
        };

        UserAddres.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.UserAddres();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        m.AddrID = r.string();
                        break;
                    }
                    case 2: {
                        m.UserID = r.uint64();
                        break;
                    }
                    case 3: {
                        m.PrvID = r.int32();
                        break;
                    }
                    case 4: {
                        m.AreaID = r.int32();
                        break;
                    }
                    case 5: {
                        m.CityID = r.int32();
                        break;
                    }
                    case 6: {
                        m.CountyID = r.int32();
                        break;
                    }
                    case 7: {
                        m.Town = r.int32();
                        break;
                    }
                    case 8: {
                        m.PrvCityName = r.string();
                        break;
                    }
                    case 9: {
                        m.LocateCate = r.int32();
                        break;
                    }
                    case 10: {
                        m.LocateX = r.double();
                        break;
                    }
                    case 11: {
                        m.LocateY = r.double();
                        break;
                    }
                    case 12: {
                        m.LocateName = r.string();
                        break;
                    }
                    case 13: {
                        m.LocateAddr = r.string();
                        break;
                    }
                    case 14: {
                        m.Address = r.string();
                        break;
                    }
                    case 15: {
                        m.LinkName = r.string();
                        break;
                    }
                    case 16: {
                        m.LinkPhone = r.string();
                        break;
                    }
                    case 17: {
                        m.IsDefault = r.int32();
                        break;
                    }
                    case 18: {
                        m.OrderValue = r.int32();
                        break;
                    }
                    case 19: {
                        m.MchID = r.uint64();
                        break;
                    }
                    case 20: {
                        m.CreateTime = r.int64();
                        break;
                    }
                    case 21: {
                        m.CreaterID = r.uint64();
                        break;
                    }
                    case 22: {
                        m.UpdateTime = r.int64();
                        break;
                    }
                    case 23: {
                        m.UpdaterID = r.uint64();
                        break;
                    }
                    case 24: {
                        m.Estate = r.int32();
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        UserAddres.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.UserAddres";
        };

        return UserAddres;
    })();

    PBEntity.UserAddress = (function () {

        function UserAddress(p) {
            this.UserAddress = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        UserAddress.prototype.UserAddress = $util.emptyArray;

        UserAddress.create = function create(properties) {
            return new UserAddress(properties);
        };

        UserAddress.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.UserAddress != null && m.UserAddress.length) {
                for (var i = 0; i < m.UserAddress.length; ++i)
                    $root.PBEntity.UserAddres.encode(m.UserAddress[i], w.uint32(10).fork()).ldelim();
            }
            return w;
        };

        UserAddress.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.UserAddress();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        if (!(m.UserAddress && m.UserAddress.length))
                            m.UserAddress = [];
                        m.UserAddress.push($root.PBEntity.UserAddres.decode(r, r.uint32()));
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        UserAddress.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.UserAddress";
        };

        return UserAddress;
    })();

    PBEntity.UserRole = (function () {

        function UserRole(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        UserRole.prototype.UserID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        UserRole.prototype.RoleID = "";
        UserRole.prototype.UUID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;

        UserRole.create = function create(properties) {
            return new UserRole(properties);
        };

        UserRole.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.UserID != null && Object.hasOwnProperty.call(m, "UserID"))
                w.uint32(8).uint64(m.UserID);
            if (m.RoleID != null && Object.hasOwnProperty.call(m, "RoleID"))
                w.uint32(18).string(m.RoleID);
            if (m.UUID != null && Object.hasOwnProperty.call(m, "UUID"))
                w.uint32(24).uint64(m.UUID);
            return w;
        };

        UserRole.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.UserRole();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        m.UserID = r.uint64();
                        break;
                    }
                    case 2: {
                        m.RoleID = r.string();
                        break;
                    }
                    case 3: {
                        m.UUID = r.uint64();
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        UserRole.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.UserRole";
        };

        return UserRole;
    })();

    PBEntity.UserRoles = (function () {

        function UserRoles(p) {
            this.UserRoles = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        UserRoles.prototype.UserRoles = $util.emptyArray;

        UserRoles.create = function create(properties) {
            return new UserRoles(properties);
        };

        UserRoles.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.UserRoles != null && m.UserRoles.length) {
                for (var i = 0; i < m.UserRoles.length; ++i)
                    $root.PBEntity.UserRole.encode(m.UserRoles[i], w.uint32(10).fork()).ldelim();
            }
            return w;
        };

        UserRoles.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.UserRoles();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        if (!(m.UserRoles && m.UserRoles.length))
                            m.UserRoles = [];
                        m.UserRoles.push($root.PBEntity.UserRole.decode(r, r.uint32()));
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        UserRoles.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.UserRoles";
        };

        return UserRoles;
    })();

    PBEntity.VerifyFile = (function () {

        function VerifyFile(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        VerifyFile.prototype.ID = "";
        VerifyFile.prototype.MchID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        VerifyFile.prototype.FileName = "";
        VerifyFile.prototype.FileContent = "";
        VerifyFile.prototype.Desc = "";
        VerifyFile.prototype.CreateTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        VerifyFile.prototype.CreaterID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        VerifyFile.prototype.UpdateTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        VerifyFile.prototype.UpdaterID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        VerifyFile.prototype.Estate = 0;

        VerifyFile.create = function create(properties) {
            return new VerifyFile(properties);
        };

        VerifyFile.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.ID != null && Object.hasOwnProperty.call(m, "ID"))
                w.uint32(10).string(m.ID);
            if (m.MchID != null && Object.hasOwnProperty.call(m, "MchID"))
                w.uint32(16).uint64(m.MchID);
            if (m.FileName != null && Object.hasOwnProperty.call(m, "FileName"))
                w.uint32(26).string(m.FileName);
            if (m.FileContent != null && Object.hasOwnProperty.call(m, "FileContent"))
                w.uint32(34).string(m.FileContent);
            if (m.Desc != null && Object.hasOwnProperty.call(m, "Desc"))
                w.uint32(42).string(m.Desc);
            if (m.CreateTime != null && Object.hasOwnProperty.call(m, "CreateTime"))
                w.uint32(48).int64(m.CreateTime);
            if (m.CreaterID != null && Object.hasOwnProperty.call(m, "CreaterID"))
                w.uint32(56).uint64(m.CreaterID);
            if (m.UpdateTime != null && Object.hasOwnProperty.call(m, "UpdateTime"))
                w.uint32(64).int64(m.UpdateTime);
            if (m.UpdaterID != null && Object.hasOwnProperty.call(m, "UpdaterID"))
                w.uint32(72).uint64(m.UpdaterID);
            if (m.Estate != null && Object.hasOwnProperty.call(m, "Estate"))
                w.uint32(80).int32(m.Estate);
            return w;
        };

        VerifyFile.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.VerifyFile();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        m.ID = r.string();
                        break;
                    }
                    case 2: {
                        m.MchID = r.uint64();
                        break;
                    }
                    case 3: {
                        m.FileName = r.string();
                        break;
                    }
                    case 4: {
                        m.FileContent = r.string();
                        break;
                    }
                    case 5: {
                        m.Desc = r.string();
                        break;
                    }
                    case 6: {
                        m.CreateTime = r.int64();
                        break;
                    }
                    case 7: {
                        m.CreaterID = r.uint64();
                        break;
                    }
                    case 8: {
                        m.UpdateTime = r.int64();
                        break;
                    }
                    case 9: {
                        m.UpdaterID = r.uint64();
                        break;
                    }
                    case 10: {
                        m.Estate = r.int32();
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        VerifyFile.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.VerifyFile";
        };

        return VerifyFile;
    })();

    PBEntity.VerifyFiles = (function () {

        function VerifyFiles(p) {
            this.VerifyFiles = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        VerifyFiles.prototype.VerifyFiles = $util.emptyArray;

        VerifyFiles.create = function create(properties) {
            return new VerifyFiles(properties);
        };

        VerifyFiles.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.VerifyFiles != null && m.VerifyFiles.length) {
                for (var i = 0; i < m.VerifyFiles.length; ++i)
                    $root.PBEntity.VerifyFile.encode(m.VerifyFiles[i], w.uint32(10).fork()).ldelim();
            }
            return w;
        };

        VerifyFiles.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.VerifyFiles();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        if (!(m.VerifyFiles && m.VerifyFiles.length))
                            m.VerifyFiles = [];
                        m.VerifyFiles.push($root.PBEntity.VerifyFile.decode(r, r.uint32()));
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        VerifyFiles.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.VerifyFiles";
        };

        return VerifyFiles;
    })();

    PBEntity.WeChatUser = (function () {

        function WeChatUser(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        WeChatUser.prototype.WXID = "";
        WeChatUser.prototype.UnionID = "";
        WeChatUser.prototype.UserID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        WeChatUser.prototype.NickName = "";
        WeChatUser.prototype.Sex = 0;
        WeChatUser.prototype.Province = "";
        WeChatUser.prototype.City = "";
        WeChatUser.prototype.Country = "";
        WeChatUser.prototype.AppIDJSApi = "";
        WeChatUser.prototype.OpenIDJSApi = "";
        WeChatUser.prototype.AppIDNative = "";
        WeChatUser.prototype.OpenIDNative = "";
        WeChatUser.prototype.AppIDApplet = "";
        WeChatUser.prototype.OpenIDApplet = "";
        WeChatUser.prototype.HeadImgURL = "";
        WeChatUser.prototype.HeadImgDownloadState = 0;
        WeChatUser.prototype.HeadImgLastDownloadTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        WeChatUser.prototype.NAOCount = 0;
        WeChatUser.prototype.NSOCount = 0;
        WeChatUser.prototype.NFOCount = 0;
        WeChatUser.prototype.AppIDAppletMch = "";
        WeChatUser.prototype.OpenIDAppletMch = "";
        WeChatUser.prototype.UpdateTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        WeChatUser.prototype.UpdaterID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        WeChatUser.prototype.Estate = 0;

        WeChatUser.create = function create(properties) {
            return new WeChatUser(properties);
        };

        WeChatUser.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.WXID != null && Object.hasOwnProperty.call(m, "WXID"))
                w.uint32(10).string(m.WXID);
            if (m.UnionID != null && Object.hasOwnProperty.call(m, "UnionID"))
                w.uint32(18).string(m.UnionID);
            if (m.UserID != null && Object.hasOwnProperty.call(m, "UserID"))
                w.uint32(24).uint64(m.UserID);
            if (m.NickName != null && Object.hasOwnProperty.call(m, "NickName"))
                w.uint32(34).string(m.NickName);
            if (m.Sex != null && Object.hasOwnProperty.call(m, "Sex"))
                w.uint32(40).int32(m.Sex);
            if (m.Province != null && Object.hasOwnProperty.call(m, "Province"))
                w.uint32(50).string(m.Province);
            if (m.City != null && Object.hasOwnProperty.call(m, "City"))
                w.uint32(58).string(m.City);
            if (m.Country != null && Object.hasOwnProperty.call(m, "Country"))
                w.uint32(66).string(m.Country);
            if (m.AppIDJSApi != null && Object.hasOwnProperty.call(m, "AppIDJSApi"))
                w.uint32(74).string(m.AppIDJSApi);
            if (m.OpenIDJSApi != null && Object.hasOwnProperty.call(m, "OpenIDJSApi"))
                w.uint32(82).string(m.OpenIDJSApi);
            if (m.AppIDNative != null && Object.hasOwnProperty.call(m, "AppIDNative"))
                w.uint32(90).string(m.AppIDNative);
            if (m.OpenIDNative != null && Object.hasOwnProperty.call(m, "OpenIDNative"))
                w.uint32(98).string(m.OpenIDNative);
            if (m.AppIDApplet != null && Object.hasOwnProperty.call(m, "AppIDApplet"))
                w.uint32(106).string(m.AppIDApplet);
            if (m.OpenIDApplet != null && Object.hasOwnProperty.call(m, "OpenIDApplet"))
                w.uint32(114).string(m.OpenIDApplet);
            if (m.HeadImgURL != null && Object.hasOwnProperty.call(m, "HeadImgURL"))
                w.uint32(122).string(m.HeadImgURL);
            if (m.HeadImgDownloadState != null && Object.hasOwnProperty.call(m, "HeadImgDownloadState"))
                w.uint32(128).int32(m.HeadImgDownloadState);
            if (m.HeadImgLastDownloadTime != null && Object.hasOwnProperty.call(m, "HeadImgLastDownloadTime"))
                w.uint32(136).int64(m.HeadImgLastDownloadTime);
            if (m.NAOCount != null && Object.hasOwnProperty.call(m, "NAOCount"))
                w.uint32(144).int32(m.NAOCount);
            if (m.NSOCount != null && Object.hasOwnProperty.call(m, "NSOCount"))
                w.uint32(152).int32(m.NSOCount);
            if (m.NFOCount != null && Object.hasOwnProperty.call(m, "NFOCount"))
                w.uint32(160).int32(m.NFOCount);
            if (m.AppIDAppletMch != null && Object.hasOwnProperty.call(m, "AppIDAppletMch"))
                w.uint32(170).string(m.AppIDAppletMch);
            if (m.OpenIDAppletMch != null && Object.hasOwnProperty.call(m, "OpenIDAppletMch"))
                w.uint32(178).string(m.OpenIDAppletMch);
            if (m.UpdateTime != null && Object.hasOwnProperty.call(m, "UpdateTime"))
                w.uint32(184).int64(m.UpdateTime);
            if (m.UpdaterID != null && Object.hasOwnProperty.call(m, "UpdaterID"))
                w.uint32(192).uint64(m.UpdaterID);
            if (m.Estate != null && Object.hasOwnProperty.call(m, "Estate"))
                w.uint32(200).int32(m.Estate);
            return w;
        };

        WeChatUser.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.WeChatUser();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        m.WXID = r.string();
                        break;
                    }
                    case 2: {
                        m.UnionID = r.string();
                        break;
                    }
                    case 3: {
                        m.UserID = r.uint64();
                        break;
                    }
                    case 4: {
                        m.NickName = r.string();
                        break;
                    }
                    case 5: {
                        m.Sex = r.int32();
                        break;
                    }
                    case 6: {
                        m.Province = r.string();
                        break;
                    }
                    case 7: {
                        m.City = r.string();
                        break;
                    }
                    case 8: {
                        m.Country = r.string();
                        break;
                    }
                    case 9: {
                        m.AppIDJSApi = r.string();
                        break;
                    }
                    case 10: {
                        m.OpenIDJSApi = r.string();
                        break;
                    }
                    case 11: {
                        m.AppIDNative = r.string();
                        break;
                    }
                    case 12: {
                        m.OpenIDNative = r.string();
                        break;
                    }
                    case 13: {
                        m.AppIDApplet = r.string();
                        break;
                    }
                    case 14: {
                        m.OpenIDApplet = r.string();
                        break;
                    }
                    case 15: {
                        m.HeadImgURL = r.string();
                        break;
                    }
                    case 16: {
                        m.HeadImgDownloadState = r.int32();
                        break;
                    }
                    case 17: {
                        m.HeadImgLastDownloadTime = r.int64();
                        break;
                    }
                    case 18: {
                        m.NAOCount = r.int32();
                        break;
                    }
                    case 19: {
                        m.NSOCount = r.int32();
                        break;
                    }
                    case 20: {
                        m.NFOCount = r.int32();
                        break;
                    }
                    case 21: {
                        m.AppIDAppletMch = r.string();
                        break;
                    }
                    case 22: {
                        m.OpenIDAppletMch = r.string();
                        break;
                    }
                    case 23: {
                        m.UpdateTime = r.int64();
                        break;
                    }
                    case 24: {
                        m.UpdaterID = r.uint64();
                        break;
                    }
                    case 25: {
                        m.Estate = r.int32();
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        WeChatUser.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.WeChatUser";
        };

        return WeChatUser;
    })();

    PBEntity.WeChatUsers = (function () {

        function WeChatUsers(p) {
            this.WeChatUsers = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        WeChatUsers.prototype.WeChatUsers = $util.emptyArray;

        WeChatUsers.create = function create(properties) {
            return new WeChatUsers(properties);
        };

        WeChatUsers.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.WeChatUsers != null && m.WeChatUsers.length) {
                for (var i = 0; i < m.WeChatUsers.length; ++i)
                    $root.PBEntity.WeChatUser.encode(m.WeChatUsers[i], w.uint32(10).fork()).ldelim();
            }
            return w;
        };

        WeChatUsers.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.WeChatUsers();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        if (!(m.WeChatUsers && m.WeChatUsers.length))
                            m.WeChatUsers = [];
                        m.WeChatUsers.push($root.PBEntity.WeChatUser.decode(r, r.uint32()));
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        WeChatUsers.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.WeChatUsers";
        };

        return WeChatUsers;
    })();

    PBEntity.AuthCodeCategory = (function () {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "AuthCodeCategory_None"] = 0;
        values[valuesById[1] = "AuthCodeCategory_AddEmployee"] = 1;
        values[valuesById[2] = "AuthCodeCategory_GPPrint"] = 2;
        values[valuesById[3] = "AuthCodeCategory_ChangeMchAdmin"] = 3;
        return values;
    })();

    PBEntity.AuthCodeError = (function () {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "AuthCodeError_Invalid"] = 0;
        values[valuesById[1] = "AuthCodeError_Expired"] = 1;
        values[valuesById[2] = "AuthCodeError_Used"] = 2;
        values[valuesById[3] = "AuthCodeError_IsEmploy"] = 3;
        values[valuesById[4] = "AuthCodeError_IsAdmin"] = 4;
        return values;
    })();

    PBEntity.DeskState = (function () {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "DeskState_Idle"] = 0;
        values[valuesById[2] = "DeskState_Using"] = 2;
        values[valuesById[3] = "DeskState_Ended"] = 3;
        return values;
    })();

    PBEntity.DeskUseFrom = (function () {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "DeskUseFrom_None"] = 0;
        values[valuesById[1] = "DeskUseFrom_EmpOpen"] = 1;
        values[valuesById[2] = "DeskUseFrom_BySelf"] = 2;
        values[valuesById[3] = "DeskUseFrom_ScanCodeOpen"] = 3;
        values[valuesById[4] = "DeskUseFrom_BookingOpen"] = 4;
        return values;
    })();

    PBEntity.DeskOpenMode = (function () {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "DeskOpenMode_None"] = 0;
        values[valuesById[1] = "DeskOpenMode_Manual"] = 1;
        values[valuesById[2] = "DeskOpenMode_Auto"] = 2;
        values[valuesById[3] = "DeskOpenMode_AutoClearOpen"] = 3;
        return values;
    })();

    PBEntity.ReserveState = (function () {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "ReserveState_Draft"] = 0;
        values[valuesById[-6] = "ReserveState_OverTime"] = -6;
        values[valuesById[-5] = "ReserveState_Reject"] = -5;
        values[valuesById[-3] = "ReserveState_SystemCancel"] = -3;
        values[valuesById[-2] = "ReserveState_MchCancel"] = -2;
        values[valuesById[-1] = "ReserveState_UserCancel"] = -1;
        values[valuesById[1] = "ReserveState_WaitPayDeposit"] = 1;
        values[valuesById[2] = "ReserveState_WaitConfirm"] = 2;
        values[valuesById[3] = "ReserveState_ConfirmSucceed"] = 3;
        values[valuesById[4] = "ReserveState_InUse"] = 4;
        values[valuesById[5] = "ReserveState_Finish"] = 5;
        return values;
    })();

    PBEntity.ClearDeskCategory = (function () {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "ClearDeskCategory_None"] = 0;
        values[valuesById[1] = "ClearDeskCategory_Customer"] = 1;
        values[valuesById[2] = "ClearDeskCategory_Mch"] = 2;
        values[valuesById[11] = "ClearDeskCategory_CustomerAuto"] = 11;
        values[valuesById[12] = "ClearDeskCategory_MchAuto"] = 12;
        return values;
    })();

    PBEntity.CouponCategory = (function () {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "CouponCategory_None"] = 0;
        values[valuesById[1] = "CouponCategory_SALE"] = 1;
        values[valuesById[2] = "CouponCategory_GIVE"] = 2;
        values[valuesById[3] = "CouponCategory_DIS"] = 3;
        values[valuesById[4] = "CouponCategory_POSTAGE"] = 4;
        values[valuesById[11] = "CouponCategory_HALF"] = 11;
        values[valuesById[12] = "CouponCategory_BOFO"] = 12;
        return values;
    })();

    PBEntity.CouponGiveCategory = (function () {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "CouponGiveCategory_None"] = 0;
        values[valuesById[1] = "CouponGiveCategory_Promo"] = 1;
        values[valuesById[2] = "CouponGiveCategory_User"] = 2;
        return values;
    })();

    PBEntity.CouponLimitCategory = (function () {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "CouponLimitCategory_None"] = 0;
        values[valuesById[1] = "CouponLimitCategory_ByGoodsCategory"] = 1;
        values[valuesById[2] = "CouponLimitCategory_ByGoods"] = 2;
        return values;
    })();

    PBEntity.CouponTermCategory = (function () {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "CouponTermCategory_None"] = 0;
        values[valuesById[1] = "CouponTermCategory_NDay"] = 1;
        values[valuesById[2] = "CouponTermCategory_Fixed"] = 2;
        return values;
    })();

    PBEntity.PromoPriceCategory = (function () {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "PromoPriceCategory_None"] = 0;
        values[valuesById[1] = "PromoPriceCategory_Free"] = 1;
        values[valuesById[2] = "PromoPriceCategory_GoodsOriPrice"] = 2;
        values[valuesById[3] = "PromoPriceCategory_GoodsSalePrice"] = 3;
        values[valuesById[4] = "PromoPriceCategory_AssignPrice"] = 4;
        values[valuesById[5] = "PromoPriceCategory_ByOriPriceDis"] = 5;
        values[valuesById[6] = "PromoPriceCategory_BySalePriceDis"] = 6;
        return values;
    })();

    PBEntity.GiveGoodsUseCategory = (function () {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "GiveGoodsUseCategory_None"] = 0;
        values[valuesById[1] = "GiveGoodsUseCategory_Promo"] = 1;
        values[valuesById[2] = "GiveGoodsUseCategory_Coupon"] = 2;
        return values;
    })();

    PBEntity.CouponLimitCountCategory = (function () {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "CouponLimitCountCategory_User"] = 0;
        values[valuesById[1] = "CouponLimitCountCategory_Day"] = 1;
        values[valuesById[7] = "CouponLimitCountCategory_Week"] = 7;
        values[valuesById[30] = "CouponLimitCountCategory_Month"] = 30;
        values[valuesById[90] = "CouponLimitCountCategory_Quarter"] = 90;
        values[valuesById[180] = "CouponLimitCountCategory_HalfYear"] = 180;
        values[valuesById[365] = "CouponLimitCountCategory_Year"] = 365;
        return values;
    })();

    PBEntity.DiscountCategory = (function () {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "DiscountCategory_None"] = 0;
        values[valuesById[1] = "DiscountCategory_NoChange"] = 1;
        values[valuesById[2] = "DiscountCategory_FixedAmount"] = 2;
        values[valuesById[3] = "DiscountCategory_FixedRate"] = 3;
        return values;
    })();

    PBEntity.CouponState = (function () {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "Coupon_Draft"] = 0;
        values[valuesById[1] = "Coupon_Normal"] = 1;
        values[valuesById[2] = "Coupon_End"] = 2;
        return values;
    })();

    PBEntity.CouponRecordState = (function () {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "CouponState_NotActive"] = 0;
        values[valuesById[1] = "CouponState_Normal"] = 1;
        values[valuesById[2] = "CouponState_InUse"] = 2;
        values[valuesById[3] = "CouponState_Succeed"] = 3;
        values[valuesById[-1] = "CouponState_Expired"] = -1;
        values[valuesById[-2] = "CouponState_Invalid"] = -2;
        values[valuesById[-3] = "CouponState_Recovery"] = -3;
        return values;
    })();

    PBEntity.GiveProcessState = (function () {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "GiveProcessState_None"] = 0;
        values[valuesById[1] = "GiveProcessState_Wait"] = 1;
        values[valuesById[2] = "GiveProcessState_Success"] = 2;
        values[valuesById[-1] = "GiveProcessState_Fail"] = -1;
        return values;
    })();

    PBEntity.UserLevel = (function () {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UserLevel_Normal"] = 0;
        values[valuesById[1] = "UserLevel_Customer"] = 1;
        values[valuesById[2] = "UserLevel_Merchant"] = 2;
        values[valuesById[3] = "UserLevel_Agent"] = 3;
        values[valuesById[10] = "MchAdministrator"] = 10;
        values[valuesById[50] = "AgentAdministrator"] = 50;
        values[valuesById[90] = "Administrators"] = 90;
        return values;
    })();

    PBEntity.MerchantCategory = (function () {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "MerchantCategory_Platform"] = 0;
        values[valuesById[20] = "MerchantCategory_IndependentWeChatShop"] = 20;
        values[valuesById[21] = "MerchantCategory_IndependentWeChatH5"] = 21;
        values[valuesById[22] = "MerchantCategory_IndependentWeChatApplet"] = 22;
        return values;
    })();

    PBEntity.ShopCategory = (function () {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "ShopCategory_Single"] = 0;
        values[valuesById[1] = "ShopCategory_Chain"] = 1;
        values[valuesById[2] = "ShopCategory_ChanFlagship"] = 2;
        return values;
    })();

    PBEntity.ShopState = (function () {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "ShopState_Applying"] = 0;
        values[valuesById[-1] = "ShopState_CloseDown"] = -1;
        values[valuesById[1] = "ShopState_Closed"] = 1;
        values[valuesById[2] = "ShopState_Opening"] = 2;
        return values;
    })();

    PBEntity.MerchantOpenMode = (function () {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "OpenMode_Unknown"] = 0;
        values[valuesById[1] = "OpenMode_ManualApprove"] = 1;
        values[valuesById[2] = "OpenMode_OnlinePayment"] = 2;
        return values;
    })();

    PBEntity.MerchantBusCategory = (function () {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "BusCategory_Unknown"] = 0;
        values[valuesById[1] = "BusCategory_Supermarket"] = 1;
        values[valuesById[2] = "BusCategory_Catering"] = 2;
        values[valuesById[3] = "BusCategory_Clothing"] = 3;
        values[valuesById[4] = "BusCategory_Fruit"] = 4;
        values[valuesById[5] = "BusCategory_Hardware"] = 5;
        values[valuesById[6] = "BusCategory_MilkTea"] = 6;
        return values;
    })();

    PBEntity.PaymentMode = (function () {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "PaymentMode_Unknown"] = 0;
        values[valuesById[1] = "PaymentMode_PayFirst"] = 1;
        values[valuesById[2] = "PaymentMode_ServeFirst"] = 2;
        return values;
    })();

    PBEntity.ApproveStatus = (function () {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "WaitApprove"] = 0;
        values[valuesById[-1] = "ApproveCancel"] = -1;
        values[valuesById[-2] = "ApproveReject"] = -2;
        values[valuesById[1] = "ApproveReview"] = 1;
        values[valuesById[2] = "ApprovePass"] = 2;
        return values;
    })();

    PBEntity.RecordMode = (function () {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "RecordMode_Unknown"] = 0;
        values[valuesById[1] = "RecordMode_Online"] = 1;
        values[valuesById[2] = "RecordMode_Manager"] = 2;
        return values;
    })();

    PBEntity.MsgState = (function () {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "MsgState_WaitRead"] = 0;
        values[valuesById[-1] = "MsgState_Delete"] = -1;
        values[valuesById[1] = "MsgState_Read"] = 1;
        return values;
    })();

    PBEntity.MsgCategory = (function () {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "MsgCategory_Unknown"] = 0;
        values[valuesById[1] = "MsgCategory_System"] = 1;
        return values;
    })();

    PBEntity.ShowBuyCategory = (function () {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "ShowBuyCategory_None"] = 0;
        values[valuesById[1] = "ShowBuyCategory_ShopIn"] = 1;
        values[valuesById[2] = "ShowBuyCategory_YourSelf"] = 2;
        values[valuesById[3] = "ShowBuyCategory_TakeAway"] = 3;
        values[valuesById[8] = "ShowBuyCategory_NotShopIn"] = 8;
        values[valuesById[9] = "ShowBuyCategory_All"] = 9;
        return values;
    })();

    PBEntity.AccountCategory = (function () {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "AccountCategory_Unknown"] = 0;
        values[valuesById[1] = "AccountCategory_Site"] = 1;
        values[valuesById[2] = "AccountCategory_Point"] = 2;
        values[valuesById[9] = "AccountCategory_MFK"] = 9;
        values[valuesById[20] = "AccountCategory_WeChat"] = 20;
        values[valuesById[30] = "AccountCategory_Alipay"] = 30;
        values[valuesById[97] = "AccountCategory_WeChatCash"] = 97;
        values[valuesById[98] = "AccountCategory_AlipayCash"] = 98;
        values[valuesById[99] = "AccountCategory_Cash"] = 99;
        return values;
    })();

    PBEntity.EmpCategory = (function () {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "EmpCategory_Clerk"] = 0;
        values[valuesById[3] = "EmpCategory_Cashier"] = 3;
        values[valuesById[6] = "EmpCategory_Manager"] = 6;
        values[valuesById[7] = "EmpCategory_Admin"] = 7;
        return values;
    })();

    PBEntity.RechargeCategory = (function () {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "RechargeCategory_Any"] = 0;
        values[valuesById[1] = "RechargeCategory_Fixed"] = 1;
        return values;
    })();

    PBEntity.ComputeMode = (function () {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "ComputeMode_None"] = 0;
        values[valuesById[1] = "ComputeMode_Rate"] = 1;
        values[valuesById[2] = "ComputeMode_Fixed"] = 2;
        return values;
    })();

    PBEntity.QRCodeCategory = (function () {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "QRCodeCategory_Unknown"] = 0;
        values[valuesById[1] = "QRCodeCategory_Fixed"] = 1;
        values[valuesById[2] = "QRCodeCategory_Activity"] = 2;
        return values;
    })();

    PBEntity.AgentJoinMethod = (function () {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "AgentJoinMethod_Unknown"] = 0;
        values[valuesById[1] = "AgentJoinMethod_System"] = 1;
        values[valuesById[2] = "AgentJoinMethod_Register"] = 2;
        values[valuesById[3] = "AgentJoinMethod_Apply"] = 3;
        return values;
    })();

    PBEntity.AgentMchStatus = (function () {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "AgentMchStatus_None"] = 0;
        values[valuesById[1] = "AgentMchStatus_Pause"] = 1;
        values[valuesById[2] = "AgentMchStatus_Joined"] = 2;
        return values;
    })();

    PBEntity.AgentPayMode = (function () {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "AgentPayMode_None"] = 0;
        values[valuesById[1] = "AgentPayMode_Platform"] = 1;
        values[valuesById[2] = "AgentPayMode_Agent"] = 2;
        return values;
    })();

    PBEntity.MchLogCategory = (function () {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "MchLogCategory_None"] = 0;
        values[valuesById[1] = "MchLogCategory_Info"] = 1;
        values[valuesById[2] = "MchLogCategory_AuthType"] = 2;
        values[valuesById[3] = "MchLogCategory_WeChatPay"] = 3;
        values[valuesById[4] = "MchLogCategory_Function"] = 4;
        values[valuesById[5] = "MchLogCategory_WeChatCategory"] = 5;
        values[valuesById[6] = "MchLogCategory_AiliPay"] = 6;
        values[valuesById[7] = "MchLogCategory_PayMode"] = 7;
        values[valuesById[8] = "MchLogCategory_Tiktok"] = 8;
        values[valuesById[9] = "MchLogCategory_DaDa"] = 9;
        return values;
    })();

    PBEntity.QRCodeBindStatus = (function () {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "QRCodeBindStatus_Wait"] = 0;
        values[valuesById[1] = "QRCodeBindStatus_Success"] = 1;
        values[valuesById[-1] = "QRCodeBindStatus_UnBind"] = -1;
        return values;
    })();

    PBEntity.QRCodeBindCategory = (function () {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "QRCodeBindCategory_Unknown"] = 0;
        values[valuesById[1] = "QRCodeBindCategory_Home"] = 1;
        values[valuesById[3] = "QRCodeBindCategory_ShopIn"] = 3;
        values[valuesById[4] = "QRCodeBindCategory_Yourself"] = 4;
        values[valuesById[5] = "QRCodeBindCategory_Takeaway"] = 5;
        values[valuesById[19] = "QRCodeBindCategory_JoinChannel"] = 19;
        values[valuesById[20] = "QRCodeBindCategory_RCPay"] = 20;
        return values;
    })();

    PBEntity.ShopGoToCategory = (function () {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "ShopGoToCategory_Back"] = 0;
        values[valuesById[1] = "ShopGoToCategory_Home"] = 1;
        values[valuesById[2] = "ShopGoToCategory_Booking"] = 2;
        values[valuesById[3] = "ShopGoToCategory_ShopIn"] = 3;
        values[valuesById[4] = "ShopGoToCategory_Yourself"] = 4;
        values[valuesById[5] = "ShopGoToCategory_Takeaway"] = 5;
        values[valuesById[6] = "ShopGoToCategory_Order"] = 6;
        values[valuesById[7] = "ShopGoToCategory_PayOrder"] = 7;
        values[valuesById[8] = "ShopGoToCategory_OrderList"] = 8;
        values[valuesById[9] = "ShopGoToCategory_My"] = 9;
        values[valuesById[10] = "ShopGoToCategory_Auth"] = 10;
        values[valuesById[11] = "ShopGoToCategory_MchOrder"] = 11;
        values[valuesById[12] = "ShopGoToCategory_MchDeskOrder"] = 12;
        values[valuesById[13] = "ShopGoToCategory_MchBooking"] = 13;
        values[valuesById[14] = "ShopGoToCategory_DeskOrder"] = 14;
        values[valuesById[15] = "ShopGoToCategory_BookingResult"] = 15;
        values[valuesById[16] = "ShopGoToCategory_Recharge"] = 16;
        values[valuesById[17] = "ShopGoToCategory_Group"] = 17;
        values[valuesById[18] = "ShopGoToCategory_Promo"] = 18;
        values[valuesById[19] = "ShopGoToCategory_JoinChannel"] = 19;
        values[valuesById[20] = "ShopGoToCategory_RCPay"] = 20;
        values[valuesById[21] = "ShopGoToCategory_RCPayResult"] = 21;
        values[valuesById[22] = "ShopGoToCategory_GroupTakePoint"] = 22;
        values[valuesById[23] = "ShopGoToCategory_PromoInfo"] = 23;
        values[valuesById[24] = "ShopGoToCategory_CouponInfo"] = 24;
        values[valuesById[25] = "ShopGoToCategory_MchPaymentReceipt"] = 25;
        values[valuesById[26] = "ShopGoToCategory_OrderDelivery"] = 26;
        values[valuesById[27] = "ShopGoToCategory_MchList"] = 27;
        values[valuesById[28] = "ShopGoToCategory_IR"] = 28;
        return values;
    })();

    PBEntity.PackingFee = (function () {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "PackingFee_None"] = 0;
        values[valuesById[1] = "PackingFee_Fixed"] = 1;
        values[valuesById[2] = "PackingFee_Accrual"] = 2;
        return values;
    })();

    PBEntity.TakeawayFun = (function () {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "TakeawayFun_ALL"] = 0;
        values[valuesById[1] = "TakeawayFun_DeliveryOnly"] = 1;
        values[valuesById[2] = "TakeawayFun_PickupOnly"] = 2;
        return values;
    })();

    PBEntity.YourselfOpenTake = (function () {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "YourselfOpenTake_ALL"] = 0;
        values[valuesById[1] = "YourselfOpenTake_OnlyDine"] = 1;
        values[valuesById[2] = "YourselfOpenTake_OnlyTakeaway"] = 2;
        return values;
    })();

    PBEntity.DeliveryFeeCategory = (function () {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "DeliveryFeeCategory_None"] = 0;
        values[valuesById[1] = "DeliveryFeeCategory_Fixed"] = 1;
        values[valuesById[2] = "DeliveryFeeCategory_ByDistance"] = 2;
        values[valuesById[11] = "DeliveryFeeCategory_ByDaDa"] = 11;
        return values;
    })();

    PBEntity.FileCategory = (function () {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "FileCategory_None"] = 0;
        values[valuesById[1] = "FileCategory_HeadPic"] = 1;
        values[valuesById[2] = "FileCategory_MchLogo"] = 2;
        values[valuesById[3] = "FileCategory_MchRotating"] = 3;
        values[valuesById[4] = "FileCategory_GoodsCateImg"] = 4;
        values[valuesById[5] = "FileCategory_GoodsImg"] = 5;
        values[valuesById[6] = "FileCategory_MchApplyImg"] = 6;
        values[valuesById[7] = "FileCategory_GoodsDetailImg"] = 7;
        values[valuesById[8] = "FileCategory_GrpRotating"] = 8;
        values[valuesById[9] = "FileCategory_NoticeCoverImg"] = 9;
        values[valuesById[50] = "FileCategory_BusinessLicense"] = 50;
        values[valuesById[51] = "FileCategory_LegalPersonProto"] = 51;
        values[valuesById[52] = "FileCategory_BankPhoto"] = 52;
        values[valuesById[53] = "FileCategory_ShopPhoto"] = 53;
        values[valuesById[54] = "FileCategory_WeMpAuthMaterial"] = 54;
        values[valuesById[60] = "FileCategory_WeMpHeadImg"] = 60;
        return values;
    })();

    PBEntity.FileEstate = (function () {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "FileEstate_Temp"] = 0;
        values[valuesById[-100] = "FileEstate_Deleted"] = -100;
        values[valuesById[-1] = "FileEstate_MarkDeletion"] = -1;
        values[valuesById[1] = "FileEstate_Uploading"] = 1;
        values[valuesById[100] = "FileEstate_Normal"] = 100;
        return values;
    })();

    PBEntity.HandleStatus = (function () {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "HandleStatus_None"] = 0;
        values[valuesById[1] = "HandleStatus_Processing"] = 1;
        values[valuesById[10] = "HandleStatus_Success"] = 10;
        values[valuesById[-1] = "HandleStatus_Fail"] = -1;
        return values;
    })();

    PBEntity.SwiperCategory = (function () {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "SwiperCategory_None"] = 0;
        values[valuesById[1] = "SwiperCategory_Home"] = 1;
        return values;
    })();

    PBEntity.TakePointCategory = (function () {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "TakePointCategory_Unknown"] = 0;
        values[valuesById[2] = "TakePointCategory_Table"] = 2;
        values[valuesById[3] = "TakePointCategory_DeliveryPoint"] = 3;
        return values;
    })();

    PBEntity.YourselfMustTableCategory = (function () {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "YourselfMustTable_None"] = 0;
        values[valuesById[1] = "YourselfMustTable_OnlyDine"] = 1;
        values[valuesById[2] = "YourselfMustTable_OnlyTakeaway"] = 2;
        values[valuesById[3] = "YourselfMustTable_ALL"] = 3;
        return values;
    })();

    PBEntity.TakeSelfMustPointCategory = (function () {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "TakeSelfMustPoint_None"] = 0;
        values[valuesById[1] = "TakeSelfMustPoint_DeliveryOnly"] = 1;
        values[valuesById[2] = "TakeSelfMustPoint_PickupOnly"] = 2;
        values[valuesById[3] = "TakeSelfMustPoint_ALL"] = 3;
        return values;
    })();

    PBEntity.TransCate = (function () {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "TransCate_None"] = 0;
        values[valuesById[1] = "TransCate_OrderPayAmt"] = 1;
        values[valuesById[2] = "TransCate_AdvAmtPay"] = 2;
        values[valuesById[3] = "TransCate_PromoAdvAmtPay"] = 3;
        values[valuesById[4] = "TransCate_CouponAdvAmtPay"] = 4;
        values[valuesById[5] = "TransCate_ReceiptAmtPay"] = 5;
        values[valuesById[6] = "TransCate_AdvAmtDeduct"] = 6;
        values[valuesById[7] = "TransCate_RefundAdvAmtInp"] = 7;
        values[valuesById[8] = "TransCate_DeliveryFeeDeduct"] = 8;
        values[valuesById[9] = "TransCate_MchCharge"] = 9;
        values[valuesById[10] = "TransCate_MchIRToAdv"] = 10;
        values[valuesById[11] = "TransCate_BackSPGiveAmtOut"] = 11;
        values[valuesById[12] = "TransCate_BackCSGiveAmtOut"] = 12;
        values[valuesById[13] = "TransCate_BackDeliveryFee"] = 13;
        values[valuesById[14] = "TransCate_MchChargeBack"] = 14;
        values[valuesById[51] = "TransCate_OrderReceiptAmt"] = 51;
        values[valuesById[52] = "TransCate_AdvAmtReceipt"] = 52;
        values[valuesById[55] = "TransCate_RecAmtReceipt"] = 55;
        values[valuesById[56] = "TransCate_AdvAmtDeductReceipt"] = 56;
        values[valuesById[57] = "TransCate_MchChargeReceipt"] = 57;
        values[valuesById[58] = "TransCate_DeliveryFeeReceipt"] = 58;
        values[valuesById[61] = "TransCate_BackSPGiveAmtInp"] = 61;
        values[valuesById[62] = "TransCate_BackCSGiveAmtInp"] = 62;
        values[valuesById[90] = "TransCate_OrderPayRefund"] = 90;
        values[valuesById[92] = "TransCate_RefundAdvAmtOut"] = 92;
        values[valuesById[93] = "TransCate_RefundAmtOut"] = 93;
        return values;
    })();

    PBEntity.PointsTransCate = (function () {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "PointsTransCate_None"] = 0;
        values[valuesById[31] = "PointsTransCate_Deduction"] = 31;
        values[valuesById[32] = "PointsTransCate_GrantPoints"] = 32;
        values[valuesById[33] = "PointsTransCate_AdvAmtPoints"] = 33;
        values[valuesById[34] = "PointsTransCate_PromoPoints"] = 34;
        values[valuesById[35] = "PointsTransCate_CouponPoints"] = 35;
        values[valuesById[42] = "PointsTransCate_RefundBackObtainOut"] = 42;
        values[valuesById[43] = "PointsTransCate_RefundBackSPGivePointsOut"] = 43;
        values[valuesById[44] = "PointsTransCate_RefundBackCSGivePointsOut"] = 44;
        values[valuesById[45] = "PointsTransCate_RefundBackPointsOut"] = 45;
        values[valuesById[81] = "PointsTransCate_ConsumePoints"] = 81;
        values[valuesById[82] = "PointsTransCate_DeductionRecover"] = 82;
        values[valuesById[91] = "PointsTransCate_PointsRefund"] = 91;
        values[valuesById[92] = "PointsTransCate_RefundBackObtainInp"] = 92;
        values[valuesById[93] = "PointsTransCate_RefundBackSPGivePointsInp"] = 93;
        values[valuesById[94] = "PointsTransCate_RefundBackCSGivePointsInp"] = 94;
        values[valuesById[95] = "PointsTransCate_RefundBackPointsInp"] = 95;
        return values;
    })();

    PBEntity.DirCate = (function () {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "NoneDir"] = 0;
        values[valuesById[-3] = "ExpenseLock"] = -3;
        values[valuesById[-2] = "Lock"] = -2;
        values[valuesById[-1] = "Expense"] = -1;
        values[valuesById[1] = "Income"] = 1;
        values[valuesById[2] = "UnLock"] = 2;
        return values;
    })();

    PBEntity.LocateType = (function () {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "LocateType_None"] = 0;
        values[valuesById[1] = "LocateType_Select"] = 1;
        values[valuesById[2] = "LocateType_Parse"] = 2;
        return values;
    })();

    PBEntity.MemberLevel = (function () {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "MemberLevel_User"] = 0;
        values[valuesById[1] = "MemberLevel_Vip"] = 1;
        values[valuesById[-1] = "MemberLevel_Block"] = -1;
        return values;
    })();

    PBEntity.IsActive = (function () {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "Stop"] = 0;
        values[valuesById[-1] = "Disable"] = -1;
        values[valuesById[1] = "Enable"] = 1;
        return values;
    })();

    PBEntity.UseState = (function () {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UseState_WaitUse"] = 0;
        values[valuesById[-2] = "UseState_Reject"] = -2;
        values[valuesById[-1] = "UseState_Cancel"] = -1;
        values[valuesById[1] = "UseState_Using"] = 1;
        values[valuesById[2] = "UseState_Used"] = 2;
        return values;
    })();

    PBEntity.NoticeShowCategory = (function () {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "NoticeShowCategory_None"] = 0;
        values[valuesById[1] = "NoticeShowCategory_Client"] = 1;
        values[valuesById[2] = "NoticeShowCategory_Mch"] = 2;
        return values;
    })();

    PBEntity.DistanceCalcCategory = (function () {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "DistanceCalcCategory_None"] = 0;
        values[valuesById[1] = "DistanceCalcCategory_Linear"] = 1;
        values[valuesById[2] = "DistanceCalcCategory_Cycling"] = 2;
        return values;
    })();

    PBEntity.GroupMchLinkCategory = (function () {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "GroupMchLinkCategory_Unknown"] = 0;
        values[valuesById[1] = "GroupMchLinkCategory_Home"] = 1;
        values[valuesById[4] = "GroupMchLinkCategory_Yourself"] = 4;
        values[valuesById[5] = "GroupMchLinkCategory_Takeaway"] = 5;
        values[valuesById[20] = "GroupMchLinkCategory_RCPay"] = 20;
        return values;
    })();

    PBEntity.MQTTClientType = (function () {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "MQTTClientType_Unknown"] = 0;
        values[valuesById[100] = "MQTTClientType_MCH_PC"] = 100;
        return values;
    })();

    PBEntity.GoodsPrintCategory = (function () {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "GoodsPrintCategory_Unknown"] = 0;
        values[valuesById[1] = "GoodsPrintCategory_Dish"] = 1;
        values[valuesById[2] = "GoodsPrintCategory_Drinks"] = 2;
        values[valuesById[6] = "GoodsPrintCategory_PackageFee"] = 6;
        values[valuesById[7] = "GoodsPrintCategory_MealSeatFee"] = 7;
        values[valuesById[8] = "GoodsPrintCategory_TeaFee"] = 8;
        values[valuesById[9] = "GoodsPrintCategory_Other"] = 9;
        return values;
    })();

    PBEntity.GoodsPlanCategory = (function () {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "GoodsPlanCategory_None"] = 0;
        values[valuesById[1] = "GoodsPlanCategory_ByDate"] = 1;
        values[valuesById[2] = "GoodsPlanCategory_ByTimeSlot"] = 2;
        return values;
    })();

    PBEntity.AttrCategory = (function () {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "AttrCategory_Unknown"] = 0;
        values[valuesById[1] = "AttrCategory_Specs"] = 1;
        values[valuesById[2] = "AttrCategory_Taste"] = 2;
        values[valuesById[3] = "AttrCategory_Option"] = 3;
        values[valuesById[4] = "AttrCategory_Preset"] = 4;
        return values;
    })();

    PBEntity.GoodsOptionMode = (function () {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "GoodsOptionMode_None"] = 0;
        values[valuesById[1] = "GoodsOptionMode_Global"] = 1;
        values[valuesById[2] = "GoodsOptionMode_Custom"] = 2;
        return values;
    })();

    PBEntity.IDCate = (function () {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "None"] = 0;
        values[valuesById[1] = "UserID"] = 1;
        values[valuesById[2] = "UUID"] = 2;
        values[valuesById[3] = "RndCodeID"] = 3;
        values[valuesById[4] = "MchLogID"] = 4;
        values[valuesById[5] = "MerchantID"] = 5;
        values[valuesById[6] = "QRCodeID"] = 6;
        values[valuesById[7] = "GroupID"] = 7;
        values[valuesById[8] = "UserActiveID"] = 8;
        values[valuesById[9] = "PayChannelID"] = 9;
        values[valuesById[10] = "GoodsUnitID"] = 10;
        values[valuesById[12] = "DeskCateID"] = 12;
        values[valuesById[13] = "DeskID"] = 13;
        values[valuesById[14] = "GoodsCateID"] = 14;
        values[valuesById[15] = "GoodsID"] = 15;
        values[valuesById[16] = "SpecsID"] = 16;
        values[valuesById[17] = "TasteID"] = 17;
        values[valuesById[18] = "PrinterID"] = 18;
        values[valuesById[19] = "GoaID"] = 19;
        values[valuesById[20] = "BookingID"] = 20;
        values[valuesById[21] = "DeskLogID"] = 21;
        values[valuesById[22] = "CartID"] = 22;
        values[valuesById[23] = "OrderNo"] = 23;
        values[valuesById[24] = "AFCID"] = 24;
        values[valuesById[25] = "MFLogID"] = 25;
        values[valuesById[26] = "OrderSeq"] = 26;
        values[valuesById[27] = "TransID"] = 27;
        values[valuesById[28] = "AmtCashID"] = 28;
        values[valuesById[29] = "CouponGoodsID"] = 29;
        values[valuesById[30] = "FileID"] = 30;
        values[valuesById[31] = "AddressID"] = 31;
        values[valuesById[32] = "OnlineAuthID"] = 32;
        values[valuesById[33] = "OrderActiveID"] = 33;
        values[valuesById[34] = "SwiperID"] = 34;
        values[valuesById[35] = "HeadImgID"] = 35;
        values[valuesById[36] = "MchApplyID"] = 36;
        values[valuesById[37] = "ArticleID"] = 37;
        values[valuesById[38] = "MchApplyQueryID"] = 38;
        values[valuesById[39] = "CouponCateID"] = 39;
        values[valuesById[40] = "PayID"] = 40;
        values[valuesById[41] = "OrderFundID"] = 41;
        values[valuesById[42] = "MsgID"] = 42;
        values[valuesById[43] = "DTPayID"] = 43;
        values[valuesById[44] = "OrderMQID"] = 44;
        values[valuesById[45] = "PrintLogID"] = 45;
        values[valuesById[46] = "FundLogID"] = 46;
        values[valuesById[47] = "PointsLogID"] = 47;
        values[valuesById[48] = "NoticeLogID"] = 48;
        values[valuesById[49] = "WXPhoneID"] = 49;
        values[valuesById[50] = "PromoID"] = 50;
        values[valuesById[51] = "PromoGoodsID"] = 51;
        values[valuesById[52] = "RefundNo"] = 52;
        values[valuesById[53] = "AuthVerApplyID"] = 53;
        values[valuesById[54] = "WXSubsMsgID"] = 54;
        values[valuesById[55] = "WXOPNoticeID"] = 55;
        values[valuesById[56] = "WXFastRegApplyID"] = 56;
        values[valuesById[57] = "WXPreAuthCodeID"] = 57;
        values[valuesById[58] = "WXAppid"] = 58;
        values[valuesById[59] = "CouponID"] = 59;
        values[valuesById[60] = "CouponRecID"] = 60;
        values[valuesById[61] = "AdID"] = 61;
        values[valuesById[62] = "LOID"] = 62;
        values[valuesById[63] = "LOAID"] = 63;
        values[valuesById[64] = "LORID"] = 64;
        values[valuesById[65] = "LORPID"] = 65;
        values[valuesById[66] = "LOSID"] = 66;
        values[valuesById[67] = "LCCID"] = 67;
        values[valuesById[68] = "ZFBPhoneID"] = 68;
        values[valuesById[69] = "ZFBSPAID"] = 69;
        values[valuesById[70] = "ZFBShopCreateID"] = 70;
        values[valuesById[71] = "ZFBAgentSignID"] = 71;
        values[valuesById[72] = "ZFBMninCreateID"] = 72;
        values[valuesById[73] = "ABAccID"] = 73;
        values[valuesById[74] = "ABTradeCateID"] = 74;
        values[valuesById[75] = "ABTradeID"] = 75;
        values[valuesById[76] = "RecCodeOrderNo"] = 76;
        values[valuesById[77] = "VBID"] = 77;
        values[valuesById[78] = "VBLogID"] = 78;
        values[valuesById[79] = "PresetNotesID"] = 79;
        values[valuesById[80] = "TakePointID"] = 80;
        values[valuesById[81] = "RcpayAwardPayID"] = 81;
        values[valuesById[82] = "QRCodeBindLogID"] = 82;
        values[valuesById[83] = "MchFunID"] = 83;
        values[valuesById[84] = "ShopTableID"] = 84;
        values[valuesById[85] = "OrderDeliveryID"] = 85;
        values[valuesById[86] = "OrderDeliveryLogID"] = 86;
        values[valuesById[87] = "MchChargeID"] = 87;
        values[valuesById[90] = "MenuID"] = 90;
        values[valuesById[91] = "RoleID"] = 91;
        values[valuesById[92] = "StoreReferenceID"] = 92;
        values[valuesById[93] = "AuthCodeID"] = 93;
        values[valuesById[94] = "LicenseTypeID"] = 94;
        values[valuesById[95] = "GoodSKUID"] = 95;
        values[valuesById[96] = "GoodsAttrID"] = 96;
        values[valuesById[97] = "GoodsAttrCateID"] = 97;
        values[valuesById[98] = "GoodsAttrGrpID"] = 98;
        values[valuesById[99] = "ModuleID"] = 99;
        values[valuesById[100] = "AccountID"] = 100;
        values[valuesById[101] = "SysConfigID"] = 101;
        values[valuesById[102] = "MobileBindLogID"] = 102;
        values[valuesById[103] = "JumpQRCodeID"] = 103;
        values[valuesById[104] = "WeMpAuthApplyID"] = 104;
        values[valuesById[105] = "GoodsGsmID"] = 105;
        values[valuesById[106] = "GoodsGsmOptionID"] = 106;
        values[valuesById[107] = "TTAuthURL"] = 107;
        values[valuesById[108] = "TTEventNoticeID"] = 108;
        values[valuesById[109] = "TTCertificateVerifyID"] = 109;
        values[valuesById[110] = "TTCertificateID"] = 110;
        values[valuesById[111] = "TTCertificateCancelID"] = 111;
        values[valuesById[115] = "VerifyFileID"] = 115;
        values[valuesById[116] = "DDMchID"] = 116;
        values[valuesById[117] = "DDShopID"] = 117;
        values[valuesById[118] = "DDOrderID"] = 118;
        values[valuesById[119] = "DDNotifyID"] = 119;
        values[valuesById[120] = "IRCodeID"] = 120;
        values[valuesById[121] = "IRPayID"] = 121;
        values[valuesById[122] = "WeMpModifyID"] = 122;
        values[valuesById[123] = "WeMpCategoryID"] = 123;
        values[valuesById[124] = "WeMpFaceVerifyTaskID"] = 124;
        values[valuesById[125] = "MchSQLoginID"] = 125;
        values[valuesById[126] = "MQClientID"] = 126;
        return values;
    })();

    PBEntity.MQTTClientCategory = (function () {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "MQTTClientCategory_Unknown"] = 0;
        values[valuesById[1] = "MQTTClientCategory_System"] = 1;
        values[valuesById[2] = "MQTTClientCategory_Printer"] = 2;
        values[valuesById[3] = "MQTTClientCategory_Voice"] = 3;
        values[valuesById[4] = "MQTTClientCategory_PC"] = 4;
        return values;
    })();

    PBEntity.MQTTConnStatus = (function () {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "MQTTConnStatus_Unknown"] = 0;
        values[valuesById[1] = "MQTTConnStatus_Connected"] = 1;
        values[valuesById[2] = "MQTTConnStatus_Disconnected"] = 2;
        return values;
    })();

    PBEntity.MQTTVerifyCategory = (function () {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "MQTTVerifyCategory_Unknown"] = 0;
        values[valuesById[1] = "MQTTVerifyCategory_PassWord"] = 1;
        values[valuesById[2] = "MQTTVerifyCategory_LoginToken"] = 2;
        return values;
    })();

    PBEntity.MQTTClientPermission = (function () {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "MQTTClientPermission_Disable"] = 0;
        values[valuesById[1] = "MQTTClientPermission_Subscribe"] = 1;
        values[valuesById[2] = "MQTTClientPermission_Publish"] = 2;
        values[valuesById[3] = "MQTTClientPermission_SubscribeAndPublish"] = 3;
        return values;
    })();

    PBEntity.Platform = (function () {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UnKnownPlatform"] = 0;
        values[valuesById[80] = "MerchantPOS"] = 80;
        values[valuesById[89] = "MerchantAdmin"] = 89;
        values[valuesById[90] = "AgentPlatform"] = 90;
        values[valuesById[100] = "AdminPlatform"] = 100;
        return values;
    })();

    PBEntity.LoginCate = (function () {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "LoginCate_Auto"] = 0;
        values[valuesById[10] = "LoginCate_Pwd"] = 10;
        values[valuesById[19] = "LoginCate_AdminPwd"] = 19;
        values[valuesById[-99] = "LoginCate_None"] = -99;
        return values;
    })();

    PBEntity.MerchantLevel = (function () {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "MerchantLevel_Platform"] = 0;
        values[valuesById[1] = "MerchantLevel_Independent"] = 1;
        values[valuesById[2] = "MerchantLevel_AuthMiniProgram"] = 2;
        return values;
    })();

    PBEntity.MchNoticeShowMode = (function () {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "MchNoticeShowModel_None"] = 0;
        values[valuesById[1] = "MchNoticeShowModel_OnlyScroll"] = 1;
        values[valuesById[2] = "MchNoticeShowModel_OnlyAlert"] = 2;
        values[valuesById[3] = "MchNoticeShowModel_ScrollAndAlert"] = 3;
        return values;
    })();

    PBEntity.MchAtOrderMinUserLevelLimit = (function () {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "MinUserLevelLimit_None"] = 0;
        values[valuesById[1] = "MinUserLevelLimit_VIP"] = 1;
        values[valuesById[2] = "MinUserLevelLimit_Channel"] = 2;
        return values;
    })();

    PBEntity.JoinLimitCategory = (function () {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "JoinLimitCategory_None"] = 0;
        values[valuesById[1] = "JoinLimitCategory_HitListNotAllowed"] = 1;
        values[valuesById[2] = "JoinLimitCategory_HitListAllowed"] = 2;
        return values;
    })();

    PBEntity.SubjectType = (function () {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "SubjectType_None"] = 0;
        values[valuesById[1] = "SubjectType_Personal"] = 1;
        values[valuesById[2] = "SubjectType_IndividualBusiness"] = 2;
        values[valuesById[3] = "SubjectType_Enterprise"] = 3;
        return values;
    })();

    PBEntity.IDCardType = (function () {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "IDCardType_None"] = 0;
        values[valuesById[1] = "IDCardType_IDCard"] = 1;
        values[valuesById[2] = "IDCardType_Passport"] = 2;
        values[valuesById[3] = "IDCardType_HongKong"] = 3;
        values[valuesById[4] = "IDCardType_Macau"] = 4;
        values[valuesById[5] = "IDCardType_Taiwan"] = 5;
        return values;
    })();

    PBEntity.BankAccountType = (function () {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "BankAccountType_None"] = 0;
        values[valuesById[1] = "BankAccountType_Personal"] = 1;
        values[valuesById[2] = "BankAccountType_Company"] = 2;
        return values;
    })();

    PBEntity.NoticeCategory = (function () {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "NoticeCategory_None"] = 0;
        values[valuesById[1] = "NoticeCategory_Reserve"] = 1;
        values[valuesById[2] = "NoticeCategory_Order"] = 2;
        values[valuesById[3] = "NoticeCategory_PayOrder"] = 3;
        values[valuesById[4] = "NoticeCategory_AdvAmt"] = 4;
        values[valuesById[5] = "NoticeCategory_Refund"] = 5;
        values[valuesById[6] = "NoticeCategory_DeskUseLog"] = 6;
        values[valuesById[7] = "NoticeCategory_RcPay"] = 7;
        return values;
    })();

    PBEntity.SubsMsgNoticeCategory = (function () {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "SubsMsgNoticeCategory_None"] = 0;
        values[valuesById[1] = "SubsMsgNoticeCategory_AtOrder"] = 1;
        values[valuesById[2] = "SubsMsgNoticeCategory_OrderReady"] = 2;
        values[valuesById[3] = "SubsMsgNoticeCategory_Finish"] = 3;
        return values;
    })();

    PBEntity.SubsMsgNoticeState = (function () {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "NoticeState_None"] = 0;
        values[valuesById[1] = "NoticeState_Subscribe"] = 1;
        values[valuesById[2] = "NoticeState_WaitSend"] = 2;
        values[valuesById[3] = "NoticeState_Send"] = 3;
        values[valuesById[-1] = "NoticeState_Cancel"] = -1;
        values[valuesById[-2] = "NoticeState_Fail"] = -2;
        values[valuesById[-3] = "NoticeState_NoTemp"] = -3;
        return values;
    })();

    PBEntity.ReceiptsCate = (function () {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "ReceiptsCateNone"] = 0;
        values[valuesById[1] = "PurchasePutStore"] = 1;
        values[valuesById[2] = "PurchaseReturned"] = 2;
        values[valuesById[6] = "SalesStockPick"] = 6;
        values[valuesById[7] = "SalesReturned"] = 7;
        return values;
    })();

    PBEntity.OrderState = (function () {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "OrderDraft"] = 0;
        values[valuesById[1] = "WaitAtOrder"] = 1;
        values[valuesById[11] = "WaitServeFood"] = 11;
        values[valuesById[12] = "WaitPack"] = 12;
        values[valuesById[13] = "WaitSendGoods"] = 13;
        values[valuesById[21] = "OnServeFood"] = 21;
        values[valuesById[22] = "WaitTakePack"] = 22;
        values[valuesById[23] = "WaitBuyerConfirmGoods"] = 23;
        values[valuesById[31] = "FinishServeFood"] = 31;
        values[valuesById[32] = "TakePack"] = 32;
        values[valuesById[33] = "TransBuyerSigned"] = 33;
        values[valuesById[99] = "OrderFinish"] = 99;
        values[valuesById[-9] = "SystemClose"] = -9;
        values[valuesById[-2] = "MchReject"] = -2;
        values[valuesById[-1] = "UserCancel"] = -1;
        return values;
    })();

    PBEntity.OrderStateSeg = (function () {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "OrderStateSeg_Draft"] = 0;
        values[valuesById[-90] = "OrderStateSeg_AllAtOrder"] = -90;
        values[valuesById[-9] = "OrderStateSeg_Close"] = -9;
        values[valuesById[1] = "OrderStateSeg_WaitAtOrder"] = 1;
        values[valuesById[10] = "OrderStateSeg_Process"] = 10;
        values[valuesById[20] = "OrderStateSeg_Receive"] = 20;
        values[valuesById[30] = "OrderStateSeg_Confirm"] = 30;
        values[valuesById[99] = "OrderStateSeg_Finish"] = 99;
        return values;
    })();

    PBEntity.PriceCate = (function () {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "DefaultPrice"] = 0;
        values[valuesById[1] = "NoChangePrice"] = 1;
        values[valuesById[2] = "FixedAmtPrice"] = 2;
        values[valuesById[3] = "DisSalesPrice"] = 3;
        values[valuesById[4] = "VIPPrice"] = 4;
        return values;
    })();

    PBEntity.OrderCategory = (function () {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "OrderCategory_Unknown"] = 0;
        values[valuesById[1] = "OrderCategory_Consume"] = 1;
        values[valuesById[2] = "OrderCategory_Deposit"] = 2;
        values[valuesById[3] = "OrderCategory_Receipt"] = 3;
        values[valuesById[4] = "OrderCategory_MchCharge"] = 4;
        values[valuesById[8] = "OrderCategory_MchDeposit"] = 8;
        values[valuesById[9] = "OrderCategory_AuthType"] = 9;
        return values;
    })();

    PBEntity.TakeMode = (function () {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "TakeMode_None"] = 0;
        values[valuesById[11] = "TakeMode_ShopDesk"] = 11;
        values[valuesById[21] = "TakeMode_ShopScene"] = 21;
        values[valuesById[22] = "TakeMode_PackAway"] = 22;
        values[valuesById[31] = "TakeMode_HomeDeliver"] = 31;
        values[valuesById[32] = "TakeMode_StoreTake"] = 32;
        return values;
    })();

    PBEntity.DeliveryMode = (function () {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "DeliveryMode_None"] = 0;
        values[valuesById[1] = "DeliveryMode_ShopIn"] = 1;
        values[valuesById[2] = "DeliveryMode_Yourself"] = 2;
        values[valuesById[3] = "DeliveryMode_Takeaway"] = 3;
        return values;
    })();

    PBEntity.SalesCategory = (function () {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "SalesCategory_Unknown"] = 0;
        values[valuesById[1] = "SalesCategory_Main"] = 1;
        values[valuesById[2] = "SalesCategory_Sub"] = 2;
        values[valuesById[3] = "SalesCategory_MainOrSub"] = 3;
        values[valuesById[4] = "SalesCategory_ByWeigh"] = 4;
        values[valuesById[5] = "SalesCategory_SetMeal"] = 5;
        return values;
    })();

    PBEntity.PaymentCodeOrderState = (function () {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "PaymentCodeOrderState_Draft"] = 0;
        values[valuesById[1] = "PaymentCodeOrderState_WaitAtOrder"] = 1;
        values[valuesById[14] = "PaymentCodeOrderState_WaitServeFood"] = 14;
        values[valuesById[24] = "PaymentCodeOrderState_OnServeFood"] = 24;
        values[valuesById[34] = "PaymentCodeOrderState_FinishServeFood"] = 34;
        values[valuesById[99] = "PaymentCodeOrderState_OrderFinish"] = 99;
        values[valuesById[-9] = "PaymentCodeOrderState_SystemClose"] = -9;
        values[valuesById[-2] = "PaymentCodeOrderState_MchReject"] = -2;
        values[valuesById[-1] = "PaymentCodeOrderState_UserCancel"] = -1;
        return values;
    })();

    PBEntity.AtOrderCategory = (function () {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "AtOrderCategory_None"] = 0;
        values[valuesById[1] = "AtOrderCategory_Customer"] = 1;
        values[valuesById[2] = "AtOrderCategory_Merchant"] = 2;
        values[valuesById[11] = "AtOrderCategory_CustomerTiktokGroupBuy"] = 11;
        values[valuesById[12] = "AtOrderCategory_MerchantTiktokGroupBuy"] = 12;
        return values;
    })();

    PBEntity.EvaluateState = (function () {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "EvaluateState_None"] = 0;
        values[valuesById[1] = "EvaluateState_Evaluated"] = 1;
        values[valuesById[2] = "EvaluateState_Replied"] = 2;
        return values;
    })();

    PBEntity.DeliveryChannel = (function () {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "DeliverChannel_None"] = 0;
        values[valuesById[1] = "DeliverChannel_Mch"] = 1;
        values[valuesById[2] = "DeliverChannel_Group"] = 2;
        values[valuesById[3] = "DeliverChannel_Agent"] = 3;
        values[valuesById[5] = "DeliverChannel_MFK"] = 5;
        values[valuesById[11] = "DeliverChannel_Dada"] = 11;
        return values;
    })();

    PBEntity.OrderDeliveryStatus = (function () {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "OrderDeliveryStatus_None"] = 0;
        values[valuesById[1] = "OrderDeliveryStatus_Created"] = 1;
        values[valuesById[2] = "OrderDeliveryStatus_PendingOrder"] = 2;
        values[valuesById[3] = "OrderDeliveryStatus_WaitingPickup"] = 3;
        values[valuesById[4] = "OrderDeliveryStatus_Assigned"] = 4;
        values[valuesById[5] = "OrderDeliveryStatus_KnightArrived"] = 5;
        values[valuesById[6] = "OrderDeliveryStatus_Delivering"] = 6;
        values[valuesById[7] = "OrderDeliveryStatus_Returning"] = 7;
        values[valuesById[9] = "OrderDeliveryStatus_Completed"] = 9;
        values[valuesById[-1] = "OrderDeliveryStatus_CreateFailed"] = -1;
        values[valuesById[-2] = "OrderDeliveryStatus_Canceled"] = -2;
        values[valuesById[-3] = "OrderDeliveryStatus_Expired"] = -3;
        values[valuesById[-4] = "OrderDeliveryStatus_Returned"] = -4;
        return values;
    })();

    PBEntity.DeliverySettlement = (function () {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "DeliverSettlement_None"] = 0;
        values[valuesById[1] = "DeliverSettlement_Mch"] = 1;
        values[valuesById[2] = "DeliverSettlement_Group"] = 2;
        values[valuesById[3] = "DeliverSettlement_Agent"] = 3;
        values[valuesById[5] = "DeliverSettlement_MFK"] = 5;
        return values;
    })();

    PBEntity.DeliveryOrderCancelReason = (function () {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "DeliveryOrderCancelReason_None"] = 0;
        values[valuesById[1] = "DeliveryOrderCancelReason_NoDeliveryMan"] = 1;
        values[valuesById[2] = "DeliveryOrderCancelReason_DeliveryManNoArrived"] = 2;
        values[valuesById[3] = "DeliveryOrderCancelReason_DeliveryManBadAttitude"] = 3;
        values[valuesById[4] = "DeliveryOrderCancelReason_CustomerCancel"] = 4;
        values[valuesById[5] = "DeliveryOrderCancelReason_OrderFillError"] = 5;
        values[valuesById[10] = "DeliveryOrderCancelReason_DeliveryManCancel"] = 10;
        values[valuesById[11] = "DeliveryOrderCancelReason_DeliveryManRefuse"] = 11;
        values[valuesById[13] = "DeliveryOrderCancelReason_DeliveryManCannotComplete"] = 13;
        values[valuesById[20] = "DeliveryOrderCancelReason_DontNeedDelivery"] = 20;
        values[valuesById[99] = "DeliveryOrderCancelReason_Other"] = 99;
        return values;
    })();

    PBEntity.DeliveryOrderCancelForm = (function () {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "DeliveryOrderCancelForm_None"] = 0;
        values[valuesById[1] = "DeliveryOrderCancelForm_TP"] = 1;
        values[valuesById[2] = "DeliveryOrderCancelForm_Mch"] = 2;
        values[valuesById[3] = "DeliveryOrderCancelForm_System"] = 3;
        return values;
    })();

    PBEntity.MchChargeCategory = (function () {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "MchChargeCategory_None"] = 0;
        values[valuesById[1] = "MchChargeCategory_VIP"] = 1;
        values[valuesById[2] = "MchChargeCategory_IR"] = 2;
        return values;
    })();

    PBEntity.PayCategory = (function () {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "PayCategory_Unknown"] = 0;
        values[valuesById[1] = "PayCategory_Points"] = 1;
        values[valuesById[2] = "PayCategory_StoredAmount"] = 2;
        values[valuesById[3] = "PayCategory_Cash"] = 3;
        values[valuesById[4] = "PayCategory_Credit"] = 4;
        values[valuesById[9] = "PayCategory_ThirdParty"] = 9;
        values[valuesById[10] = "PayCategory_Other"] = 10;
        return values;
    })();

    PBEntity.PayState = (function () {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "PayState_WaitPay"] = 0;
        values[valuesById[-2] = "PayState_Refunded"] = -2;
        values[valuesById[-1] = "PayState_Cancel"] = -1;
        values[valuesById[1] = "PayState_Paying"] = 1;
        values[valuesById[2] = "PayState_Success"] = 2;
        return values;
    })();

    PBEntity.PayAbnormalCate = (function () {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "PayAbnormalCate_Unknown"] = 0;
        values[valuesById[1] = "PayAbnormalCate_Repeat"] = 1;
        values[valuesById[2] = "PayAbnormalCate_AmtNotMatch"] = 2;
        values[valuesById[3] = "PayAbnormalCate_ReOrderNotExist"] = 3;
        values[valuesById[4] = "PayAbnormalCate_OutTransNoNotMatch"] = 4;
        values[valuesById[5] = "PayAbnormalCate_ReOrderCategoryNotMatch"] = 5;
        values[valuesById[6] = "PayAbnormalCate_ReOrderProcessError"] = 6;
        return values;
    })();

    PBEntity.MakeUpState = (function () {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "MakeUpState_None"] = 0;
        values[valuesById[-1] = "MakeUpState_NotReceipt"] = -1;
        values[valuesById[1] = "MakeUpState_NeedMarkUp"] = 1;
        return values;
    })();

    PBEntity.PaymentReceiptCategory = (function () {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "ReceiptCategory_None"] = 0;
        values[valuesById[1] = "ConsumeReceipt"] = 1;
        values[valuesById[2] = "AdvAmtReceipt"] = 2;
        values[valuesById[3] = "PaymentCodeReceipt"] = 3;
        values[valuesById[9] = "MerchantServiceReceipt"] = 9;
        return values;
    })();

    PBEntity.PrinterStatus = (function () {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "PrinterStatus_WaitBind"] = 0;
        values[valuesById[1] = "PrinterStatus_Offline"] = 1;
        values[valuesById[2] = "PrinterStatus_Online"] = 2;
        values[valuesById[-1] = "PrinterStatus_BindFail"] = -1;
        return values;
    })();

    PBEntity.PrinterPlatform = (function () {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "PrinterPlatform_None"] = 0;
        values[valuesById[1] = "PrinterPlatform_Com"] = 1;
        values[valuesById[2] = "PrinterPlatform_Blue"] = 2;
        values[valuesById[3] = "PrinterPlatform_Net"] = 3;
        values[valuesById[4] = "PrinterPlatform_USB"] = 4;
        values[valuesById[10] = "PrinterPlatform_YLY"] = 10;
        values[valuesById[20] = "PrinterPlatform_FE"] = 20;
        values[valuesById[30] = "PrinterPlatform_GP"] = 30;
        values[valuesById[40] = "PrinterPlatform_XP"] = 40;
        return values;
    })();

    PBEntity.PrintType = (function () {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "PrinterType_None"] = 0;
        values[valuesById[1] = "PrinterType_Receipt"] = 1;
        values[valuesById[2] = "PrinterType_Label"] = 2;
        return values;
    })();

    PBEntity.PrintFromCate = (function () {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "PrintFromCate_None"] = 0;
        values[valuesById[1] = "PrintFromCate_Booking"] = 1;
        values[valuesById[2] = "PrintFromCate_AtOrder"] = 2;
        values[valuesById[3] = "PrintFromCate_PayOrder"] = 3;
        values[valuesById[4] = "PrintFromCate_AdvAmtOrder"] = 4;
        values[valuesById[5] = "PrintFromCate_RefundGoods"] = 5;
        values[valuesById[6] = "PrintFromCate_DeskUseRecord"] = 6;
        values[valuesById[7] = "PrintFromCate_RcPay"] = 7;
        values[valuesById[8] = "PrintFromCate_RefundAmt"] = 8;
        values[valuesById[9] = "PrintFormCate_DeliveryOrder"] = 9;
        return values;
    })();

    PBEntity.PrintReceiptCate = (function () {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "PrintReceiptCate_None"] = 0;
        values[valuesById[1] = "PrintReceiptCate_AtCustomer"] = 1;
        values[valuesById[2] = "PrintReceiptCate_AtKitchen"] = 2;
        values[valuesById[3] = "PrintReceiptCate_PosKitchen"] = 3;
        values[valuesById[4] = "PrintReceiptCate_PosCashier"] = 4;
        values[valuesById[5] = "PrintReceiptCate_AdvKitchen"] = 5;
        values[valuesById[6] = "PrintReceiptCate_BookingKitchen"] = 6;
        return values;
    })();

    PBEntity.KitchenPrintMode = (function () {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "KitchenPrintMode_None"] = 0;
        values[valuesById[1] = "KitchenPrintMode_ByDesk"] = 1;
        values[valuesById[2] = "KitchenPrintMode_ByGoods"] = 2;
        values[valuesById[3] = "KitchenPrintMode_ByNum"] = 3;
        return values;
    })();

    PBEntity.PrintWidth = (function () {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "PrintWidth_None"] = 0;
        values[valuesById[80] = "PrintWidth_80"] = 80;
        values[valuesById[58] = "PrintWidth_58"] = 58;
        return values;
    })();

    PBEntity.MchEmpNoticeCate = (function () {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "MchEmpNoticeMode_None"] = 0;
        values[valuesById[1] = "MchEmpNoticeMode_WX"] = 1;
        values[valuesById[2] = "MchEmpNoticeMode_Win"] = 2;
        values[valuesById[9] = "MchEmpNoticeMode_ALL"] = 9;
        return values;
    })();

    PBEntity.PrintPlatformCategory = (function () {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "PrintPlatformCategory_None"] = 0;
        values[valuesById[1] = "PrintPlatformCategory_Local"] = 1;
        values[valuesById[10] = "PrintPlatformCategory_Cloud"] = 10;
        return values;
    })();

    PBEntity.RefundState = (function () {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "RefundState_Wait"] = 0;
        values[valuesById[1] = "RefundState_Processing"] = 1;
        values[valuesById[2] = "RefundState_Completed"] = 2;
        values[valuesById[-1] = "RefundState_NeedNot"] = -1;
        values[valuesById[-2] = "RefundState_Failed"] = -2;
        return values;
    })();

    PBEntity.BindStatus = (function () {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "Unbind"] = 0;
        values[valuesById[1] = "Bind"] = 1;
        values[valuesById[-1] = "Cancel"] = -1;
        return values;
    })();

    PBEntity.SpeakerCategory = (function () {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "SpeakerCategory_None"] = 0;
        values[valuesById[1] = "SpeakerCategory_PC"] = 1;
        return values;
    })();

    PBEntity.VoiceCategory = (function () {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "VoiceCategory_None"] = 0;
        values[valuesById[1] = "VoiceCategory_AtOrder"] = 1;
        values[valuesById[2] = "VoiceCategory_PayOrder"] = 2;
        values[valuesById[3] = "VoiceCategory_TakeOrder"] = 3;
        values[valuesById[4] = "VoiceCategory_RcPay"] = 4;
        values[valuesById[5] = "VoiceCategory_RcPayTakeOrder"] = 5;
        values[valuesById[90] = "VoiceCategory_BindSucceed"] = 90;
        return values;
    })();

    PBEntity.BusinessAnalysis = (function () {

        function BusinessAnalysis(p) {
            this.ByTime = [];
            this.ByPrice = [];
            this.AmountRanking = [];
            this.CountRanking = [];
            this.Trend = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        BusinessAnalysis.prototype.ReceivePayment = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        BusinessAnalysis.prototype.Refund = 0;
        BusinessAnalysis.prototype.RefundAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        BusinessAnalysis.prototype.ReceiveCount = 0;
        BusinessAnalysis.prototype.CustomerCount = 0;
        BusinessAnalysis.prototype.RepeatCustomerCount = 0;
        BusinessAnalysis.prototype.RepeatCustomerOrderCount = 0;
        BusinessAnalysis.prototype.RepeatCustomerOrderAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        BusinessAnalysis.prototype.ByTime = $util.emptyArray;
        BusinessAnalysis.prototype.ByPrice = $util.emptyArray;
        BusinessAnalysis.prototype.AmountRanking = $util.emptyArray;
        BusinessAnalysis.prototype.CountRanking = $util.emptyArray;
        BusinessAnalysis.prototype.Trend = $util.emptyArray;
        BusinessAnalysis.prototype.StartTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        BusinessAnalysis.prototype.EndTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

        BusinessAnalysis.create = function create(properties) {
            return new BusinessAnalysis(properties);
        };

        BusinessAnalysis.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.ReceivePayment != null && Object.hasOwnProperty.call(m, "ReceivePayment"))
                w.uint32(8).int64(m.ReceivePayment);
            if (m.Refund != null && Object.hasOwnProperty.call(m, "Refund"))
                w.uint32(16).uint32(m.Refund);
            if (m.RefundAmt != null && Object.hasOwnProperty.call(m, "RefundAmt"))
                w.uint32(24).int64(m.RefundAmt);
            if (m.ReceiveCount != null && Object.hasOwnProperty.call(m, "ReceiveCount"))
                w.uint32(32).uint32(m.ReceiveCount);
            if (m.CustomerCount != null && Object.hasOwnProperty.call(m, "CustomerCount"))
                w.uint32(40).uint32(m.CustomerCount);
            if (m.RepeatCustomerCount != null && Object.hasOwnProperty.call(m, "RepeatCustomerCount"))
                w.uint32(48).uint32(m.RepeatCustomerCount);
            if (m.RepeatCustomerOrderCount != null && Object.hasOwnProperty.call(m, "RepeatCustomerOrderCount"))
                w.uint32(56).uint32(m.RepeatCustomerOrderCount);
            if (m.RepeatCustomerOrderAmt != null && Object.hasOwnProperty.call(m, "RepeatCustomerOrderAmt"))
                w.uint32(64).int64(m.RepeatCustomerOrderAmt);
            if (m.ByTime != null && m.ByTime.length) {
                for (var i = 0; i < m.ByTime.length; ++i)
                    $root.PBEntity.Distribution.encode(m.ByTime[i], w.uint32(82).fork()).ldelim();
            }
            if (m.ByPrice != null && m.ByPrice.length) {
                for (var i = 0; i < m.ByPrice.length; ++i)
                    $root.PBEntity.Distribution.encode(m.ByPrice[i], w.uint32(90).fork()).ldelim();
            }
            if (m.AmountRanking != null && m.AmountRanking.length) {
                for (var i = 0; i < m.AmountRanking.length; ++i)
                    $root.PBEntity.CustomerAnalysis.encode(m.AmountRanking[i], w.uint32(98).fork()).ldelim();
            }
            if (m.CountRanking != null && m.CountRanking.length) {
                for (var i = 0; i < m.CountRanking.length; ++i)
                    $root.PBEntity.CustomerAnalysis.encode(m.CountRanking[i], w.uint32(106).fork()).ldelim();
            }
            if (m.Trend != null && m.Trend.length) {
                for (var i = 0; i < m.Trend.length; ++i)
                    $root.PBEntity.Distribution.encode(m.Trend[i], w.uint32(114).fork()).ldelim();
            }
            if (m.StartTime != null && Object.hasOwnProperty.call(m, "StartTime"))
                w.uint32(120).int64(m.StartTime);
            if (m.EndTime != null && Object.hasOwnProperty.call(m, "EndTime"))
                w.uint32(128).int64(m.EndTime);
            return w;
        };

        BusinessAnalysis.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.BusinessAnalysis();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        m.ReceivePayment = r.int64();
                        break;
                    }
                    case 2: {
                        m.Refund = r.uint32();
                        break;
                    }
                    case 3: {
                        m.RefundAmt = r.int64();
                        break;
                    }
                    case 4: {
                        m.ReceiveCount = r.uint32();
                        break;
                    }
                    case 5: {
                        m.CustomerCount = r.uint32();
                        break;
                    }
                    case 6: {
                        m.RepeatCustomerCount = r.uint32();
                        break;
                    }
                    case 7: {
                        m.RepeatCustomerOrderCount = r.uint32();
                        break;
                    }
                    case 8: {
                        m.RepeatCustomerOrderAmt = r.int64();
                        break;
                    }
                    case 10: {
                        if (!(m.ByTime && m.ByTime.length))
                            m.ByTime = [];
                        m.ByTime.push($root.PBEntity.Distribution.decode(r, r.uint32()));
                        break;
                    }
                    case 11: {
                        if (!(m.ByPrice && m.ByPrice.length))
                            m.ByPrice = [];
                        m.ByPrice.push($root.PBEntity.Distribution.decode(r, r.uint32()));
                        break;
                    }
                    case 12: {
                        if (!(m.AmountRanking && m.AmountRanking.length))
                            m.AmountRanking = [];
                        m.AmountRanking.push($root.PBEntity.CustomerAnalysis.decode(r, r.uint32()));
                        break;
                    }
                    case 13: {
                        if (!(m.CountRanking && m.CountRanking.length))
                            m.CountRanking = [];
                        m.CountRanking.push($root.PBEntity.CustomerAnalysis.decode(r, r.uint32()));
                        break;
                    }
                    case 14: {
                        if (!(m.Trend && m.Trend.length))
                            m.Trend = [];
                        m.Trend.push($root.PBEntity.Distribution.decode(r, r.uint32()));
                        break;
                    }
                    case 15: {
                        m.StartTime = r.int64();
                        break;
                    }
                    case 16: {
                        m.EndTime = r.int64();
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        BusinessAnalysis.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.BusinessAnalysis";
        };

        return BusinessAnalysis;
    })();

    PBEntity.Distribution = (function () {

        function Distribution(p) {
            this.CustomerTemp = {};
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        Distribution.prototype.Name = "";
        Distribution.prototype.Start = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Distribution.prototype.End = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Distribution.prototype.Count = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        Distribution.prototype.Amount = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Distribution.prototype.Refund = 0;
        Distribution.prototype.RefundAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        Distribution.prototype.CustomerCount = 0;
        Distribution.prototype.RepeatCstCount = 0;
        Distribution.prototype.CustomerTemp = $util.emptyObject;

        Distribution.create = function create(properties) {
            return new Distribution(properties);
        };

        Distribution.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.Name != null && Object.hasOwnProperty.call(m, "Name"))
                w.uint32(10).string(m.Name);
            if (m.Start != null && Object.hasOwnProperty.call(m, "Start"))
                w.uint32(16).int64(m.Start);
            if (m.End != null && Object.hasOwnProperty.call(m, "End"))
                w.uint32(24).int64(m.End);
            if (m.Count != null && Object.hasOwnProperty.call(m, "Count"))
                w.uint32(32).uint64(m.Count);
            if (m.Amount != null && Object.hasOwnProperty.call(m, "Amount"))
                w.uint32(40).int64(m.Amount);
            if (m.Refund != null && Object.hasOwnProperty.call(m, "Refund"))
                w.uint32(56).uint32(m.Refund);
            if (m.RefundAmt != null && Object.hasOwnProperty.call(m, "RefundAmt"))
                w.uint32(64).int64(m.RefundAmt);
            if (m.CustomerCount != null && Object.hasOwnProperty.call(m, "CustomerCount"))
                w.uint32(80).uint32(m.CustomerCount);
            if (m.RepeatCstCount != null && Object.hasOwnProperty.call(m, "RepeatCstCount"))
                w.uint32(88).uint32(m.RepeatCstCount);
            if (m.CustomerTemp != null && Object.hasOwnProperty.call(m, "CustomerTemp")) {
                for (var ks = Object.keys(m.CustomerTemp), i = 0; i < ks.length; ++i) {
                    w.uint32(98).fork().uint32(8).uint64(ks[i]);
                    $root.PBEntity.CustomerAnalysis.encode(m.CustomerTemp[ks[i]], w.uint32(18).fork()).ldelim().ldelim();
                }
            }
            return w;
        };

        Distribution.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.Distribution(), k, value;
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        m.Name = r.string();
                        break;
                    }
                    case 2: {
                        m.Start = r.int64();
                        break;
                    }
                    case 3: {
                        m.End = r.int64();
                        break;
                    }
                    case 4: {
                        m.Count = r.uint64();
                        break;
                    }
                    case 5: {
                        m.Amount = r.int64();
                        break;
                    }
                    case 7: {
                        m.Refund = r.uint32();
                        break;
                    }
                    case 8: {
                        m.RefundAmt = r.int64();
                        break;
                    }
                    case 10: {
                        m.CustomerCount = r.uint32();
                        break;
                    }
                    case 11: {
                        m.RepeatCstCount = r.uint32();
                        break;
                    }
                    case 12: {
                        if (m.CustomerTemp === $util.emptyObject)
                            m.CustomerTemp = {};
                        var c2 = r.uint32() + r.pos;
                        k = 0;
                        value = null;
                        while (r.pos < c2) {
                            var tag2 = r.uint32();
                            switch (tag2 >>> 3) {
                                case 1:
                                    k = r.uint64();
                                    break;
                                case 2:
                                    value = $root.PBEntity.CustomerAnalysis.decode(r, r.uint32());
                                    break;
                                default:
                                    r.skipType(tag2 & 7);
                                    break;
                            }
                        }
                        m.CustomerTemp[typeof k === "object" ? $util.longToHash(k) : k] = value;
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        Distribution.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.Distribution";
        };

        return Distribution;
    })();

    PBEntity.CustomerAnalysis = (function () {

        function CustomerAnalysis(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        CustomerAnalysis.prototype.UserID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        CustomerAnalysis.prototype.UserName = "";
        CustomerAnalysis.prototype.FirstOrderTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        CustomerAnalysis.prototype.ReceiveCount = 0;
        CustomerAnalysis.prototype.ReceivePayment = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

        CustomerAnalysis.create = function create(properties) {
            return new CustomerAnalysis(properties);
        };

        CustomerAnalysis.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.UserID != null && Object.hasOwnProperty.call(m, "UserID"))
                w.uint32(8).uint64(m.UserID);
            if (m.UserName != null && Object.hasOwnProperty.call(m, "UserName"))
                w.uint32(18).string(m.UserName);
            if (m.FirstOrderTime != null && Object.hasOwnProperty.call(m, "FirstOrderTime"))
                w.uint32(24).int64(m.FirstOrderTime);
            if (m.ReceiveCount != null && Object.hasOwnProperty.call(m, "ReceiveCount"))
                w.uint32(32).uint32(m.ReceiveCount);
            if (m.ReceivePayment != null && Object.hasOwnProperty.call(m, "ReceivePayment"))
                w.uint32(40).int64(m.ReceivePayment);
            return w;
        };

        CustomerAnalysis.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.CustomerAnalysis();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        m.UserID = r.uint64();
                        break;
                    }
                    case 2: {
                        m.UserName = r.string();
                        break;
                    }
                    case 3: {
                        m.FirstOrderTime = r.int64();
                        break;
                    }
                    case 4: {
                        m.ReceiveCount = r.uint32();
                        break;
                    }
                    case 5: {
                        m.ReceivePayment = r.int64();
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        CustomerAnalysis.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.CustomerAnalysis";
        };

        return CustomerAnalysis;
    })();

    PBEntity.PaymentReceiptDaily = (function () {

        function PaymentReceiptDaily(p) {
            this.ByTime = [];
            this.ByPrice = [];
            this.CustomerAnalysis = [];
            this.ByTimeTemp = {};
            this.ByPriceTemp = {};
            this.CustomerAnalysisTemp = {};
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        PaymentReceiptDaily.prototype.MchID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        PaymentReceiptDaily.prototype.TransDate = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        PaymentReceiptDaily.prototype.BillingCycleStart = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        PaymentReceiptDaily.prototype.BillingCycleEnd = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        PaymentReceiptDaily.prototype.CreateTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        PaymentReceiptDaily.prototype.ReceivePayment = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        PaymentReceiptDaily.prototype.Refund = 0;
        PaymentReceiptDaily.prototype.RefundAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        PaymentReceiptDaily.prototype.ReceiveCount = 0;
        PaymentReceiptDaily.prototype.MaxReceivePayment = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        PaymentReceiptDaily.prototype.MaxReceivePaymentID = "";
        PaymentReceiptDaily.prototype.MaxReceivePaymentUserID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        PaymentReceiptDaily.prototype.ByTime = $util.emptyArray;
        PaymentReceiptDaily.prototype.ByPrice = $util.emptyArray;
        PaymentReceiptDaily.prototype.CustomerAnalysis = $util.emptyArray;
        PaymentReceiptDaily.prototype.ByTimeTemp = $util.emptyObject;
        PaymentReceiptDaily.prototype.ByPriceTemp = $util.emptyObject;
        PaymentReceiptDaily.prototype.CustomerAnalysisTemp = $util.emptyObject;

        PaymentReceiptDaily.create = function create(properties) {
            return new PaymentReceiptDaily(properties);
        };

        PaymentReceiptDaily.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.MchID != null && Object.hasOwnProperty.call(m, "MchID"))
                w.uint32(8).uint64(m.MchID);
            if (m.TransDate != null && Object.hasOwnProperty.call(m, "TransDate"))
                w.uint32(16).int64(m.TransDate);
            if (m.BillingCycleStart != null && Object.hasOwnProperty.call(m, "BillingCycleStart"))
                w.uint32(24).int64(m.BillingCycleStart);
            if (m.BillingCycleEnd != null && Object.hasOwnProperty.call(m, "BillingCycleEnd"))
                w.uint32(32).int64(m.BillingCycleEnd);
            if (m.CreateTime != null && Object.hasOwnProperty.call(m, "CreateTime"))
                w.uint32(40).int64(m.CreateTime);
            if (m.ReceivePayment != null && Object.hasOwnProperty.call(m, "ReceivePayment"))
                w.uint32(80).int64(m.ReceivePayment);
            if (m.Refund != null && Object.hasOwnProperty.call(m, "Refund"))
                w.uint32(88).int32(m.Refund);
            if (m.RefundAmt != null && Object.hasOwnProperty.call(m, "RefundAmt"))
                w.uint32(96).int64(m.RefundAmt);
            if (m.ReceiveCount != null && Object.hasOwnProperty.call(m, "ReceiveCount"))
                w.uint32(104).int32(m.ReceiveCount);
            if (m.MaxReceivePayment != null && Object.hasOwnProperty.call(m, "MaxReceivePayment"))
                w.uint32(112).int64(m.MaxReceivePayment);
            if (m.MaxReceivePaymentID != null && Object.hasOwnProperty.call(m, "MaxReceivePaymentID"))
                w.uint32(122).string(m.MaxReceivePaymentID);
            if (m.MaxReceivePaymentUserID != null && Object.hasOwnProperty.call(m, "MaxReceivePaymentUserID"))
                w.uint32(128).uint64(m.MaxReceivePaymentUserID);
            if (m.ByTime != null && m.ByTime.length) {
                for (var i = 0; i < m.ByTime.length; ++i)
                    $root.PBEntity.Distribution.encode(m.ByTime[i], w.uint32(162).fork()).ldelim();
            }
            if (m.ByPrice != null && m.ByPrice.length) {
                for (var i = 0; i < m.ByPrice.length; ++i)
                    $root.PBEntity.Distribution.encode(m.ByPrice[i], w.uint32(170).fork()).ldelim();
            }
            if (m.CustomerAnalysis != null && m.CustomerAnalysis.length) {
                for (var i = 0; i < m.CustomerAnalysis.length; ++i)
                    $root.PBEntity.CustomerAnalysis.encode(m.CustomerAnalysis[i], w.uint32(178).fork()).ldelim();
            }
            if (m.ByTimeTemp != null && Object.hasOwnProperty.call(m, "ByTimeTemp")) {
                for (var ks = Object.keys(m.ByTimeTemp), i = 0; i < ks.length; ++i) {
                    w.uint32(242).fork().uint32(8).int32(ks[i]);
                    $root.PBEntity.Distribution.encode(m.ByTimeTemp[ks[i]], w.uint32(18).fork()).ldelim().ldelim();
                }
            }
            if (m.ByPriceTemp != null && Object.hasOwnProperty.call(m, "ByPriceTemp")) {
                for (var ks = Object.keys(m.ByPriceTemp), i = 0; i < ks.length; ++i) {
                    w.uint32(250).fork().uint32(8).int64(ks[i]);
                    $root.PBEntity.Distribution.encode(m.ByPriceTemp[ks[i]], w.uint32(18).fork()).ldelim().ldelim();
                }
            }
            if (m.CustomerAnalysisTemp != null && Object.hasOwnProperty.call(m, "CustomerAnalysisTemp")) {
                for (var ks = Object.keys(m.CustomerAnalysisTemp), i = 0; i < ks.length; ++i) {
                    w.uint32(258).fork().uint32(8).uint64(ks[i]);
                    $root.PBEntity.CustomerAnalysis.encode(m.CustomerAnalysisTemp[ks[i]], w.uint32(18).fork()).ldelim().ldelim();
                }
            }
            return w;
        };

        PaymentReceiptDaily.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.PaymentReceiptDaily(), k, value;
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        m.MchID = r.uint64();
                        break;
                    }
                    case 2: {
                        m.TransDate = r.int64();
                        break;
                    }
                    case 3: {
                        m.BillingCycleStart = r.int64();
                        break;
                    }
                    case 4: {
                        m.BillingCycleEnd = r.int64();
                        break;
                    }
                    case 5: {
                        m.CreateTime = r.int64();
                        break;
                    }
                    case 10: {
                        m.ReceivePayment = r.int64();
                        break;
                    }
                    case 11: {
                        m.Refund = r.int32();
                        break;
                    }
                    case 12: {
                        m.RefundAmt = r.int64();
                        break;
                    }
                    case 13: {
                        m.ReceiveCount = r.int32();
                        break;
                    }
                    case 14: {
                        m.MaxReceivePayment = r.int64();
                        break;
                    }
                    case 15: {
                        m.MaxReceivePaymentID = r.string();
                        break;
                    }
                    case 16: {
                        m.MaxReceivePaymentUserID = r.uint64();
                        break;
                    }
                    case 20: {
                        if (!(m.ByTime && m.ByTime.length))
                            m.ByTime = [];
                        m.ByTime.push($root.PBEntity.Distribution.decode(r, r.uint32()));
                        break;
                    }
                    case 21: {
                        if (!(m.ByPrice && m.ByPrice.length))
                            m.ByPrice = [];
                        m.ByPrice.push($root.PBEntity.Distribution.decode(r, r.uint32()));
                        break;
                    }
                    case 22: {
                        if (!(m.CustomerAnalysis && m.CustomerAnalysis.length))
                            m.CustomerAnalysis = [];
                        m.CustomerAnalysis.push($root.PBEntity.CustomerAnalysis.decode(r, r.uint32()));
                        break;
                    }
                    case 30: {
                        if (m.ByTimeTemp === $util.emptyObject)
                            m.ByTimeTemp = {};
                        var c2 = r.uint32() + r.pos;
                        k = 0;
                        value = null;
                        while (r.pos < c2) {
                            var tag2 = r.uint32();
                            switch (tag2 >>> 3) {
                                case 1:
                                    k = r.int32();
                                    break;
                                case 2:
                                    value = $root.PBEntity.Distribution.decode(r, r.uint32());
                                    break;
                                default:
                                    r.skipType(tag2 & 7);
                                    break;
                            }
                        }
                        m.ByTimeTemp[k] = value;
                        break;
                    }
                    case 31: {
                        if (m.ByPriceTemp === $util.emptyObject)
                            m.ByPriceTemp = {};
                        var c2 = r.uint32() + r.pos;
                        k = 0;
                        value = null;
                        while (r.pos < c2) {
                            var tag2 = r.uint32();
                            switch (tag2 >>> 3) {
                                case 1:
                                    k = r.int64();
                                    break;
                                case 2:
                                    value = $root.PBEntity.Distribution.decode(r, r.uint32());
                                    break;
                                default:
                                    r.skipType(tag2 & 7);
                                    break;
                            }
                        }
                        m.ByPriceTemp[typeof k === "object" ? $util.longToHash(k) : k] = value;
                        break;
                    }
                    case 32: {
                        if (m.CustomerAnalysisTemp === $util.emptyObject)
                            m.CustomerAnalysisTemp = {};
                        var c2 = r.uint32() + r.pos;
                        k = 0;
                        value = null;
                        while (r.pos < c2) {
                            var tag2 = r.uint32();
                            switch (tag2 >>> 3) {
                                case 1:
                                    k = r.uint64();
                                    break;
                                case 2:
                                    value = $root.PBEntity.CustomerAnalysis.decode(r, r.uint32());
                                    break;
                                default:
                                    r.skipType(tag2 & 7);
                                    break;
                            }
                        }
                        m.CustomerAnalysisTemp[typeof k === "object" ? $util.longToHash(k) : k] = value;
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        PaymentReceiptDaily.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.PaymentReceiptDaily";
        };

        return PaymentReceiptDaily;
    })();

    PBEntity.DailyBill = (function () {

        function DailyBill(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        DailyBill.prototype.MchID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        DailyBill.prototype.TransDate = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        DailyBill.prototype.BillingCycleStart = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        DailyBill.prototype.BillingCycleEnd = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        DailyBill.prototype.CreateTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        DailyBill.prototype.WeChatPaymentSummary = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        DailyBill.prototype.WeChatPaymentCountSummary = 0;
        DailyBill.prototype.AlipayPaymentSummary = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        DailyBill.prototype.AlipayPaymentCountSummary = 0;
        DailyBill.prototype.TotalOrderAmount = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        DailyBill.prototype.TotalOrderCount = 0;
        DailyBill.prototype.TotalOrderNetIncome = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        DailyBill.prototype.TotalOrderNetIncomeCount = 0;
        DailyBill.prototype.TotalQRCodeAmount = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        DailyBill.prototype.TotalQRCodeCount = 0;
        DailyBill.prototype.TotalMemberStoredAmount = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        DailyBill.prototype.TotalMemberStoredCount = 0;
        DailyBill.prototype.ManualDiscountAmount = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        DailyBill.prototype.PointsDeductionAmount = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        DailyBill.prototype.PointsDeductionCount = 0;
        DailyBill.prototype.WeChatOrderPayAmount = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        DailyBill.prototype.WeChatOrderPayCount = 0;
        DailyBill.prototype.AlipayOrderPayAmount = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        DailyBill.prototype.AlipayOrderPayCount = 0;
        DailyBill.prototype.CashOrderPayAmount = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        DailyBill.prototype.CashOrderPayCount = 0;
        DailyBill.prototype.StoredOrderPayAmount = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        DailyBill.prototype.StoredOrderPayCount = 0;
        DailyBill.prototype.RewardsPoints = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        DailyBill.prototype.OrderPayAmount = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        DailyBill.prototype.OrderPayGroupBuyCount = 0;
        DailyBill.prototype.OrderPayGroupBuyAmount = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        DailyBill.prototype.WeChatStoredAmount = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        DailyBill.prototype.WeChatStoredCount = 0;
        DailyBill.prototype.AlipayStoredAmount = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        DailyBill.prototype.AlipayStoredCount = 0;
        DailyBill.prototype.CashStoredAmount = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        DailyBill.prototype.CashStoredCount = 0;
        DailyBill.prototype.StoredGiftPoints = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        DailyBill.prototype.StoredGiftAmount = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        DailyBill.prototype.StoredGiftCoupon = 0;
        DailyBill.prototype.PromoSalesAmount = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        DailyBill.prototype.PromoDisSalesAmount = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        DailyBill.prototype.PromoGiftStoredAmount = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        DailyBill.prototype.PromoGiftPoints = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        DailyBill.prototype.PromoGiftGoods = 0;
        DailyBill.prototype.PromoGiftCoupon = 0;
        DailyBill.prototype.ChannelDisCountAmount = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        DailyBill.prototype.CouponDiscountAmount = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        DailyBill.prototype.CouponGiftPoints = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        DailyBill.prototype.CouponGiftGoods = 0;
        DailyBill.prototype.CouponGiftStoredAmount = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        DailyBill.prototype.WeChatQRPayAmount = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        DailyBill.prototype.WeChatQRPayCount = 0;
        DailyBill.prototype.AlipayQRPayAmount = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        DailyBill.prototype.AlipayQRPayCount = 0;

        DailyBill.create = function create(properties) {
            return new DailyBill(properties);
        };

        DailyBill.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.MchID != null && Object.hasOwnProperty.call(m, "MchID"))
                w.uint32(8).uint64(m.MchID);
            if (m.TransDate != null && Object.hasOwnProperty.call(m, "TransDate"))
                w.uint32(16).int64(m.TransDate);
            if (m.BillingCycleStart != null && Object.hasOwnProperty.call(m, "BillingCycleStart"))
                w.uint32(24).int64(m.BillingCycleStart);
            if (m.BillingCycleEnd != null && Object.hasOwnProperty.call(m, "BillingCycleEnd"))
                w.uint32(32).int64(m.BillingCycleEnd);
            if (m.CreateTime != null && Object.hasOwnProperty.call(m, "CreateTime"))
                w.uint32(40).int64(m.CreateTime);
            if (m.WeChatPaymentSummary != null && Object.hasOwnProperty.call(m, "WeChatPaymentSummary"))
                w.uint32(80).int64(m.WeChatPaymentSummary);
            if (m.WeChatPaymentCountSummary != null && Object.hasOwnProperty.call(m, "WeChatPaymentCountSummary"))
                w.uint32(88).int32(m.WeChatPaymentCountSummary);
            if (m.AlipayPaymentSummary != null && Object.hasOwnProperty.call(m, "AlipayPaymentSummary"))
                w.uint32(96).int64(m.AlipayPaymentSummary);
            if (m.AlipayPaymentCountSummary != null && Object.hasOwnProperty.call(m, "AlipayPaymentCountSummary"))
                w.uint32(104).int32(m.AlipayPaymentCountSummary);
            if (m.TotalOrderAmount != null && Object.hasOwnProperty.call(m, "TotalOrderAmount"))
                w.uint32(112).int64(m.TotalOrderAmount);
            if (m.TotalOrderCount != null && Object.hasOwnProperty.call(m, "TotalOrderCount"))
                w.uint32(120).int32(m.TotalOrderCount);
            if (m.TotalOrderNetIncome != null && Object.hasOwnProperty.call(m, "TotalOrderNetIncome"))
                w.uint32(128).int64(m.TotalOrderNetIncome);
            if (m.TotalOrderNetIncomeCount != null && Object.hasOwnProperty.call(m, "TotalOrderNetIncomeCount"))
                w.uint32(136).int32(m.TotalOrderNetIncomeCount);
            if (m.TotalQRCodeAmount != null && Object.hasOwnProperty.call(m, "TotalQRCodeAmount"))
                w.uint32(144).int64(m.TotalQRCodeAmount);
            if (m.TotalQRCodeCount != null && Object.hasOwnProperty.call(m, "TotalQRCodeCount"))
                w.uint32(152).int32(m.TotalQRCodeCount);
            if (m.TotalMemberStoredAmount != null && Object.hasOwnProperty.call(m, "TotalMemberStoredAmount"))
                w.uint32(160).int64(m.TotalMemberStoredAmount);
            if (m.TotalMemberStoredCount != null && Object.hasOwnProperty.call(m, "TotalMemberStoredCount"))
                w.uint32(168).int32(m.TotalMemberStoredCount);
            if (m.ManualDiscountAmount != null && Object.hasOwnProperty.call(m, "ManualDiscountAmount"))
                w.uint32(240).int64(m.ManualDiscountAmount);
            if (m.PointsDeductionAmount != null && Object.hasOwnProperty.call(m, "PointsDeductionAmount"))
                w.uint32(248).int64(m.PointsDeductionAmount);
            if (m.PointsDeductionCount != null && Object.hasOwnProperty.call(m, "PointsDeductionCount"))
                w.uint32(256).int32(m.PointsDeductionCount);
            if (m.WeChatOrderPayAmount != null && Object.hasOwnProperty.call(m, "WeChatOrderPayAmount"))
                w.uint32(264).int64(m.WeChatOrderPayAmount);
            if (m.WeChatOrderPayCount != null && Object.hasOwnProperty.call(m, "WeChatOrderPayCount"))
                w.uint32(272).int32(m.WeChatOrderPayCount);
            if (m.AlipayOrderPayAmount != null && Object.hasOwnProperty.call(m, "AlipayOrderPayAmount"))
                w.uint32(280).int64(m.AlipayOrderPayAmount);
            if (m.AlipayOrderPayCount != null && Object.hasOwnProperty.call(m, "AlipayOrderPayCount"))
                w.uint32(288).int32(m.AlipayOrderPayCount);
            if (m.CashOrderPayAmount != null && Object.hasOwnProperty.call(m, "CashOrderPayAmount"))
                w.uint32(296).int64(m.CashOrderPayAmount);
            if (m.CashOrderPayCount != null && Object.hasOwnProperty.call(m, "CashOrderPayCount"))
                w.uint32(304).int32(m.CashOrderPayCount);
            if (m.StoredOrderPayAmount != null && Object.hasOwnProperty.call(m, "StoredOrderPayAmount"))
                w.uint32(312).int64(m.StoredOrderPayAmount);
            if (m.StoredOrderPayCount != null && Object.hasOwnProperty.call(m, "StoredOrderPayCount"))
                w.uint32(320).int32(m.StoredOrderPayCount);
            if (m.RewardsPoints != null && Object.hasOwnProperty.call(m, "RewardsPoints"))
                w.uint32(328).int64(m.RewardsPoints);
            if (m.OrderPayAmount != null && Object.hasOwnProperty.call(m, "OrderPayAmount"))
                w.uint32(336).int64(m.OrderPayAmount);
            if (m.OrderPayGroupBuyCount != null && Object.hasOwnProperty.call(m, "OrderPayGroupBuyCount"))
                w.uint32(344).int32(m.OrderPayGroupBuyCount);
            if (m.OrderPayGroupBuyAmount != null && Object.hasOwnProperty.call(m, "OrderPayGroupBuyAmount"))
                w.uint32(352).int64(m.OrderPayGroupBuyAmount);
            if (m.WeChatStoredAmount != null && Object.hasOwnProperty.call(m, "WeChatStoredAmount"))
                w.uint32(400).int64(m.WeChatStoredAmount);
            if (m.WeChatStoredCount != null && Object.hasOwnProperty.call(m, "WeChatStoredCount"))
                w.uint32(408).int32(m.WeChatStoredCount);
            if (m.AlipayStoredAmount != null && Object.hasOwnProperty.call(m, "AlipayStoredAmount"))
                w.uint32(416).int64(m.AlipayStoredAmount);
            if (m.AlipayStoredCount != null && Object.hasOwnProperty.call(m, "AlipayStoredCount"))
                w.uint32(424).int32(m.AlipayStoredCount);
            if (m.CashStoredAmount != null && Object.hasOwnProperty.call(m, "CashStoredAmount"))
                w.uint32(432).int64(m.CashStoredAmount);
            if (m.CashStoredCount != null && Object.hasOwnProperty.call(m, "CashStoredCount"))
                w.uint32(440).int32(m.CashStoredCount);
            if (m.StoredGiftPoints != null && Object.hasOwnProperty.call(m, "StoredGiftPoints"))
                w.uint32(448).int64(m.StoredGiftPoints);
            if (m.StoredGiftAmount != null && Object.hasOwnProperty.call(m, "StoredGiftAmount"))
                w.uint32(456).int64(m.StoredGiftAmount);
            if (m.StoredGiftCoupon != null && Object.hasOwnProperty.call(m, "StoredGiftCoupon"))
                w.uint32(464).int32(m.StoredGiftCoupon);
            if (m.PromoSalesAmount != null && Object.hasOwnProperty.call(m, "PromoSalesAmount"))
                w.uint32(480).int64(m.PromoSalesAmount);
            if (m.PromoDisSalesAmount != null && Object.hasOwnProperty.call(m, "PromoDisSalesAmount"))
                w.uint32(488).int64(m.PromoDisSalesAmount);
            if (m.PromoGiftStoredAmount != null && Object.hasOwnProperty.call(m, "PromoGiftStoredAmount"))
                w.uint32(496).int64(m.PromoGiftStoredAmount);
            if (m.PromoGiftPoints != null && Object.hasOwnProperty.call(m, "PromoGiftPoints"))
                w.uint32(504).int64(m.PromoGiftPoints);
            if (m.PromoGiftGoods != null && Object.hasOwnProperty.call(m, "PromoGiftGoods"))
                w.uint32(512).int32(m.PromoGiftGoods);
            if (m.PromoGiftCoupon != null && Object.hasOwnProperty.call(m, "PromoGiftCoupon"))
                w.uint32(520).int32(m.PromoGiftCoupon);
            if (m.ChannelDisCountAmount != null && Object.hasOwnProperty.call(m, "ChannelDisCountAmount"))
                w.uint32(528).int64(m.ChannelDisCountAmount);
            if (m.CouponDiscountAmount != null && Object.hasOwnProperty.call(m, "CouponDiscountAmount"))
                w.uint32(560).int64(m.CouponDiscountAmount);
            if (m.CouponGiftPoints != null && Object.hasOwnProperty.call(m, "CouponGiftPoints"))
                w.uint32(568).int64(m.CouponGiftPoints);
            if (m.CouponGiftGoods != null && Object.hasOwnProperty.call(m, "CouponGiftGoods"))
                w.uint32(576).int32(m.CouponGiftGoods);
            if (m.CouponGiftStoredAmount != null && Object.hasOwnProperty.call(m, "CouponGiftStoredAmount"))
                w.uint32(584).int64(m.CouponGiftStoredAmount);
            if (m.WeChatQRPayAmount != null && Object.hasOwnProperty.call(m, "WeChatQRPayAmount"))
                w.uint32(640).int64(m.WeChatQRPayAmount);
            if (m.WeChatQRPayCount != null && Object.hasOwnProperty.call(m, "WeChatQRPayCount"))
                w.uint32(648).int32(m.WeChatQRPayCount);
            if (m.AlipayQRPayAmount != null && Object.hasOwnProperty.call(m, "AlipayQRPayAmount"))
                w.uint32(656).int64(m.AlipayQRPayAmount);
            if (m.AlipayQRPayCount != null && Object.hasOwnProperty.call(m, "AlipayQRPayCount"))
                w.uint32(664).int32(m.AlipayQRPayCount);
            return w;
        };

        DailyBill.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.DailyBill();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        m.MchID = r.uint64();
                        break;
                    }
                    case 2: {
                        m.TransDate = r.int64();
                        break;
                    }
                    case 3: {
                        m.BillingCycleStart = r.int64();
                        break;
                    }
                    case 4: {
                        m.BillingCycleEnd = r.int64();
                        break;
                    }
                    case 5: {
                        m.CreateTime = r.int64();
                        break;
                    }
                    case 10: {
                        m.WeChatPaymentSummary = r.int64();
                        break;
                    }
                    case 11: {
                        m.WeChatPaymentCountSummary = r.int32();
                        break;
                    }
                    case 12: {
                        m.AlipayPaymentSummary = r.int64();
                        break;
                    }
                    case 13: {
                        m.AlipayPaymentCountSummary = r.int32();
                        break;
                    }
                    case 14: {
                        m.TotalOrderAmount = r.int64();
                        break;
                    }
                    case 15: {
                        m.TotalOrderCount = r.int32();
                        break;
                    }
                    case 16: {
                        m.TotalOrderNetIncome = r.int64();
                        break;
                    }
                    case 17: {
                        m.TotalOrderNetIncomeCount = r.int32();
                        break;
                    }
                    case 18: {
                        m.TotalQRCodeAmount = r.int64();
                        break;
                    }
                    case 19: {
                        m.TotalQRCodeCount = r.int32();
                        break;
                    }
                    case 20: {
                        m.TotalMemberStoredAmount = r.int64();
                        break;
                    }
                    case 21: {
                        m.TotalMemberStoredCount = r.int32();
                        break;
                    }
                    case 30: {
                        m.ManualDiscountAmount = r.int64();
                        break;
                    }
                    case 31: {
                        m.PointsDeductionAmount = r.int64();
                        break;
                    }
                    case 32: {
                        m.PointsDeductionCount = r.int32();
                        break;
                    }
                    case 33: {
                        m.WeChatOrderPayAmount = r.int64();
                        break;
                    }
                    case 34: {
                        m.WeChatOrderPayCount = r.int32();
                        break;
                    }
                    case 35: {
                        m.AlipayOrderPayAmount = r.int64();
                        break;
                    }
                    case 36: {
                        m.AlipayOrderPayCount = r.int32();
                        break;
                    }
                    case 37: {
                        m.CashOrderPayAmount = r.int64();
                        break;
                    }
                    case 38: {
                        m.CashOrderPayCount = r.int32();
                        break;
                    }
                    case 39: {
                        m.StoredOrderPayAmount = r.int64();
                        break;
                    }
                    case 40: {
                        m.StoredOrderPayCount = r.int32();
                        break;
                    }
                    case 41: {
                        m.RewardsPoints = r.int64();
                        break;
                    }
                    case 42: {
                        m.OrderPayAmount = r.int64();
                        break;
                    }
                    case 43: {
                        m.OrderPayGroupBuyCount = r.int32();
                        break;
                    }
                    case 44: {
                        m.OrderPayGroupBuyAmount = r.int64();
                        break;
                    }
                    case 50: {
                        m.WeChatStoredAmount = r.int64();
                        break;
                    }
                    case 51: {
                        m.WeChatStoredCount = r.int32();
                        break;
                    }
                    case 52: {
                        m.AlipayStoredAmount = r.int64();
                        break;
                    }
                    case 53: {
                        m.AlipayStoredCount = r.int32();
                        break;
                    }
                    case 54: {
                        m.CashStoredAmount = r.int64();
                        break;
                    }
                    case 55: {
                        m.CashStoredCount = r.int32();
                        break;
                    }
                    case 56: {
                        m.StoredGiftPoints = r.int64();
                        break;
                    }
                    case 57: {
                        m.StoredGiftAmount = r.int64();
                        break;
                    }
                    case 58: {
                        m.StoredGiftCoupon = r.int32();
                        break;
                    }
                    case 60: {
                        m.PromoSalesAmount = r.int64();
                        break;
                    }
                    case 61: {
                        m.PromoDisSalesAmount = r.int64();
                        break;
                    }
                    case 62: {
                        m.PromoGiftStoredAmount = r.int64();
                        break;
                    }
                    case 63: {
                        m.PromoGiftPoints = r.int64();
                        break;
                    }
                    case 64: {
                        m.PromoGiftGoods = r.int32();
                        break;
                    }
                    case 65: {
                        m.PromoGiftCoupon = r.int32();
                        break;
                    }
                    case 66: {
                        m.ChannelDisCountAmount = r.int64();
                        break;
                    }
                    case 70: {
                        m.CouponDiscountAmount = r.int64();
                        break;
                    }
                    case 71: {
                        m.CouponGiftPoints = r.int64();
                        break;
                    }
                    case 72: {
                        m.CouponGiftGoods = r.int32();
                        break;
                    }
                    case 73: {
                        m.CouponGiftStoredAmount = r.int64();
                        break;
                    }
                    case 80: {
                        m.WeChatQRPayAmount = r.int64();
                        break;
                    }
                    case 81: {
                        m.WeChatQRPayCount = r.int32();
                        break;
                    }
                    case 82: {
                        m.AlipayQRPayAmount = r.int64();
                        break;
                    }
                    case 83: {
                        m.AlipayQRPayCount = r.int32();
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        DailyBill.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.DailyBill";
        };

        return DailyBill;
    })();

    PBEntity.SaleStatistics = (function () {

        function SaleStatistics(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        SaleStatistics.prototype.TransDate = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        SaleStatistics.prototype.TotalReceiptAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        SaleStatistics.prototype.TotalOrderCount = 0;
        SaleStatistics.prototype.TotalRevenueAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

        SaleStatistics.create = function create(properties) {
            return new SaleStatistics(properties);
        };

        SaleStatistics.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.TransDate != null && Object.hasOwnProperty.call(m, "TransDate"))
                w.uint32(8).int64(m.TransDate);
            if (m.TotalReceiptAmt != null && Object.hasOwnProperty.call(m, "TotalReceiptAmt"))
                w.uint32(16).int64(m.TotalReceiptAmt);
            if (m.TotalOrderCount != null && Object.hasOwnProperty.call(m, "TotalOrderCount"))
                w.uint32(24).int32(m.TotalOrderCount);
            if (m.TotalRevenueAmt != null && Object.hasOwnProperty.call(m, "TotalRevenueAmt"))
                w.uint32(32).int64(m.TotalRevenueAmt);
            return w;
        };

        SaleStatistics.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.SaleStatistics();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        m.TransDate = r.int64();
                        break;
                    }
                    case 2: {
                        m.TotalReceiptAmt = r.int64();
                        break;
                    }
                    case 3: {
                        m.TotalOrderCount = r.int32();
                        break;
                    }
                    case 4: {
                        m.TotalRevenueAmt = r.int64();
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        SaleStatistics.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.SaleStatistics";
        };

        return SaleStatistics;
    })();

    PBEntity.SaleStatisticsList = (function () {

        function SaleStatisticsList(p) {
            this.SaleStatistics = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        SaleStatisticsList.prototype.SaleStatistics = $util.emptyArray;
        SaleStatisticsList.prototype.TotalReceiptAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        SaleStatisticsList.prototype.TotalOrderCount = 0;
        SaleStatisticsList.prototype.TotalRevenueAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

        SaleStatisticsList.create = function create(properties) {
            return new SaleStatisticsList(properties);
        };

        SaleStatisticsList.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.SaleStatistics != null && m.SaleStatistics.length) {
                for (var i = 0; i < m.SaleStatistics.length; ++i)
                    $root.PBEntity.SaleStatistics.encode(m.SaleStatistics[i], w.uint32(10).fork()).ldelim();
            }
            if (m.TotalReceiptAmt != null && Object.hasOwnProperty.call(m, "TotalReceiptAmt"))
                w.uint32(16).int64(m.TotalReceiptAmt);
            if (m.TotalOrderCount != null && Object.hasOwnProperty.call(m, "TotalOrderCount"))
                w.uint32(24).int32(m.TotalOrderCount);
            if (m.TotalRevenueAmt != null && Object.hasOwnProperty.call(m, "TotalRevenueAmt"))
                w.uint32(32).int64(m.TotalRevenueAmt);
            return w;
        };

        SaleStatisticsList.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.SaleStatisticsList();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        if (!(m.SaleStatistics && m.SaleStatistics.length))
                            m.SaleStatistics = [];
                        m.SaleStatistics.push($root.PBEntity.SaleStatistics.decode(r, r.uint32()));
                        break;
                    }
                    case 2: {
                        m.TotalReceiptAmt = r.int64();
                        break;
                    }
                    case 3: {
                        m.TotalOrderCount = r.int32();
                        break;
                    }
                    case 4: {
                        m.TotalRevenueAmt = r.int64();
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        SaleStatisticsList.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.SaleStatisticsList";
        };

        return SaleStatisticsList;
    })();

    PBEntity.DailySalesStat = (function () {

        function DailySalesStat(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        DailySalesStat.prototype.TransDate = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        DailySalesStat.prototype.SaleCount = 0;
        DailySalesStat.prototype.SaleAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

        DailySalesStat.create = function create(properties) {
            return new DailySalesStat(properties);
        };

        DailySalesStat.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.TransDate != null && Object.hasOwnProperty.call(m, "TransDate"))
                w.uint32(8).int64(m.TransDate);
            if (m.SaleCount != null && Object.hasOwnProperty.call(m, "SaleCount"))
                w.uint32(25).double(m.SaleCount);
            if (m.SaleAmt != null && Object.hasOwnProperty.call(m, "SaleAmt"))
                w.uint32(32).int64(m.SaleAmt);
            return w;
        };

        DailySalesStat.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.DailySalesStat();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        m.TransDate = r.int64();
                        break;
                    }
                    case 3: {
                        m.SaleCount = r.double();
                        break;
                    }
                    case 4: {
                        m.SaleAmt = r.int64();
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        DailySalesStat.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.DailySalesStat";
        };

        return DailySalesStat;
    })();

    PBEntity.SalesStat = (function () {

        function SalesStat(p) {
            this.DailySalesStat = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        SalesStat.prototype.ID = "";
        SalesStat.prototype.Name = "";
        SalesStat.prototype.SaleCount = 0;
        SalesStat.prototype.SaleAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        SalesStat.prototype.UnitName = "";
        SalesStat.prototype.DailySalesStat = $util.emptyArray;

        SalesStat.create = function create(properties) {
            return new SalesStat(properties);
        };

        SalesStat.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.ID != null && Object.hasOwnProperty.call(m, "ID"))
                w.uint32(10).string(m.ID);
            if (m.Name != null && Object.hasOwnProperty.call(m, "Name"))
                w.uint32(18).string(m.Name);
            if (m.SaleCount != null && Object.hasOwnProperty.call(m, "SaleCount"))
                w.uint32(25).double(m.SaleCount);
            if (m.SaleAmt != null && Object.hasOwnProperty.call(m, "SaleAmt"))
                w.uint32(32).int64(m.SaleAmt);
            if (m.UnitName != null && Object.hasOwnProperty.call(m, "UnitName"))
                w.uint32(42).string(m.UnitName);
            if (m.DailySalesStat != null && m.DailySalesStat.length) {
                for (var i = 0; i < m.DailySalesStat.length; ++i)
                    $root.PBEntity.DailySalesStat.encode(m.DailySalesStat[i], w.uint32(50).fork()).ldelim();
            }
            return w;
        };

        SalesStat.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.SalesStat();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        m.ID = r.string();
                        break;
                    }
                    case 2: {
                        m.Name = r.string();
                        break;
                    }
                    case 3: {
                        m.SaleCount = r.double();
                        break;
                    }
                    case 4: {
                        m.SaleAmt = r.int64();
                        break;
                    }
                    case 5: {
                        m.UnitName = r.string();
                        break;
                    }
                    case 6: {
                        if (!(m.DailySalesStat && m.DailySalesStat.length))
                            m.DailySalesStat = [];
                        m.DailySalesStat.push($root.PBEntity.DailySalesStat.decode(r, r.uint32()));
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        SalesStat.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.SalesStat";
        };

        return SalesStat;
    })();

    PBEntity.SalesStatList = (function () {

        function SalesStatList(p) {
            this.SalesStats = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        SalesStatList.prototype.SalesStats = $util.emptyArray;
        SalesStatList.prototype.TotalCount = 0;
        SalesStatList.prototype.TotalAmt = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

        SalesStatList.create = function create(properties) {
            return new SalesStatList(properties);
        };

        SalesStatList.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.SalesStats != null && m.SalesStats.length) {
                for (var i = 0; i < m.SalesStats.length; ++i)
                    $root.PBEntity.SalesStat.encode(m.SalesStats[i], w.uint32(10).fork()).ldelim();
            }
            if (m.TotalCount != null && Object.hasOwnProperty.call(m, "TotalCount"))
                w.uint32(17).double(m.TotalCount);
            if (m.TotalAmt != null && Object.hasOwnProperty.call(m, "TotalAmt"))
                w.uint32(24).int64(m.TotalAmt);
            return w;
        };

        SalesStatList.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.SalesStatList();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        if (!(m.SalesStats && m.SalesStats.length))
                            m.SalesStats = [];
                        m.SalesStats.push($root.PBEntity.SalesStat.decode(r, r.uint32()));
                        break;
                    }
                    case 2: {
                        m.TotalCount = r.double();
                        break;
                    }
                    case 3: {
                        m.TotalAmt = r.int64();
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        SalesStatList.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.SalesStatList";
        };

        return SalesStatList;
    })();

    PBEntity.UserAddr = (function () {

        function UserAddr(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        UserAddr.prototype.ID = "";
        UserAddr.prototype.UserID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        UserAddr.prototype.UUID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        UserAddr.prototype.LocateCate = 0;
        UserAddr.prototype.LocateX = 0;
        UserAddr.prototype.LocateY = 0;
        UserAddr.prototype.LocateName = "";
        UserAddr.prototype.LocateAddr = "";
        UserAddr.prototype.Address = "";
        UserAddr.prototype.LinkName = "";
        UserAddr.prototype.LinkPhone = "";
        UserAddr.prototype.IsDefault = 0;
        UserAddr.prototype.OrderValue = 0;

        UserAddr.create = function create(properties) {
            return new UserAddr(properties);
        };

        UserAddr.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.ID != null && Object.hasOwnProperty.call(m, "ID"))
                w.uint32(10).string(m.ID);
            if (m.UserID != null && Object.hasOwnProperty.call(m, "UserID"))
                w.uint32(16).uint64(m.UserID);
            if (m.UUID != null && Object.hasOwnProperty.call(m, "UUID"))
                w.uint32(24).uint64(m.UUID);
            if (m.LocateCate != null && Object.hasOwnProperty.call(m, "LocateCate"))
                w.uint32(80).int32(m.LocateCate);
            if (m.LocateX != null && Object.hasOwnProperty.call(m, "LocateX"))
                w.uint32(89).double(m.LocateX);
            if (m.LocateY != null && Object.hasOwnProperty.call(m, "LocateY"))
                w.uint32(97).double(m.LocateY);
            if (m.LocateName != null && Object.hasOwnProperty.call(m, "LocateName"))
                w.uint32(106).string(m.LocateName);
            if (m.LocateAddr != null && Object.hasOwnProperty.call(m, "LocateAddr"))
                w.uint32(114).string(m.LocateAddr);
            if (m.Address != null && Object.hasOwnProperty.call(m, "Address"))
                w.uint32(122).string(m.Address);
            if (m.LinkName != null && Object.hasOwnProperty.call(m, "LinkName"))
                w.uint32(130).string(m.LinkName);
            if (m.LinkPhone != null && Object.hasOwnProperty.call(m, "LinkPhone"))
                w.uint32(138).string(m.LinkPhone);
            if (m.IsDefault != null && Object.hasOwnProperty.call(m, "IsDefault"))
                w.uint32(144).int32(m.IsDefault);
            if (m.OrderValue != null && Object.hasOwnProperty.call(m, "OrderValue"))
                w.uint32(152).int32(m.OrderValue);
            return w;
        };

        UserAddr.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.UserAddr();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        m.ID = r.string();
                        break;
                    }
                    case 2: {
                        m.UserID = r.uint64();
                        break;
                    }
                    case 3: {
                        m.UUID = r.uint64();
                        break;
                    }
                    case 10: {
                        m.LocateCate = r.int32();
                        break;
                    }
                    case 11: {
                        m.LocateX = r.double();
                        break;
                    }
                    case 12: {
                        m.LocateY = r.double();
                        break;
                    }
                    case 13: {
                        m.LocateName = r.string();
                        break;
                    }
                    case 14: {
                        m.LocateAddr = r.string();
                        break;
                    }
                    case 15: {
                        m.Address = r.string();
                        break;
                    }
                    case 16: {
                        m.LinkName = r.string();
                        break;
                    }
                    case 17: {
                        m.LinkPhone = r.string();
                        break;
                    }
                    case 18: {
                        m.IsDefault = r.int32();
                        break;
                    }
                    case 19: {
                        m.OrderValue = r.int32();
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        UserAddr.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.UserAddr";
        };

        return UserAddr;
    })();

    PBEntity.UserAddrList = (function () {

        function UserAddrList(p) {
            this.List = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        UserAddrList.prototype.List = $util.emptyArray;
        UserAddrList.prototype.Count = 0;

        UserAddrList.create = function create(properties) {
            return new UserAddrList(properties);
        };

        UserAddrList.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.List != null && m.List.length) {
                for (var i = 0; i < m.List.length; ++i)
                    $root.PBEntity.UserAddr.encode(m.List[i], w.uint32(10).fork()).ldelim();
            }
            if (m.Count != null && Object.hasOwnProperty.call(m, "Count"))
                w.uint32(16).int32(m.Count);
            return w;
        };

        UserAddrList.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.UserAddrList();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        if (!(m.List && m.List.length))
                            m.List = [];
                        m.List.push($root.PBEntity.UserAddr.decode(r, r.uint32()));
                        break;
                    }
                    case 2: {
                        m.Count = r.int32();
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        UserAddrList.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.UserAddrList";
        };

        return UserAddrList;
    })();

    PBEntity.CaptchaInfo = (function () {

        function CaptchaInfo(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        CaptchaInfo.prototype.CaptchaID = "";
        CaptchaInfo.prototype.Captcha = "";
        CaptchaInfo.prototype.ReID = "";
        CaptchaInfo.prototype.UseType = 0;
        CaptchaInfo.prototype.ExpireTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

        CaptchaInfo.create = function create(properties) {
            return new CaptchaInfo(properties);
        };

        CaptchaInfo.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.CaptchaID != null && Object.hasOwnProperty.call(m, "CaptchaID"))
                w.uint32(10).string(m.CaptchaID);
            if (m.Captcha != null && Object.hasOwnProperty.call(m, "Captcha"))
                w.uint32(18).string(m.Captcha);
            if (m.ReID != null && Object.hasOwnProperty.call(m, "ReID"))
                w.uint32(26).string(m.ReID);
            if (m.UseType != null && Object.hasOwnProperty.call(m, "UseType"))
                w.uint32(32).int32(m.UseType);
            if (m.ExpireTime != null && Object.hasOwnProperty.call(m, "ExpireTime"))
                w.uint32(40).int64(m.ExpireTime);
            return w;
        };

        CaptchaInfo.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.CaptchaInfo();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        m.CaptchaID = r.string();
                        break;
                    }
                    case 2: {
                        m.Captcha = r.string();
                        break;
                    }
                    case 3: {
                        m.ReID = r.string();
                        break;
                    }
                    case 4: {
                        m.UseType = r.int32();
                        break;
                    }
                    case 5: {
                        m.ExpireTime = r.int64();
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        CaptchaInfo.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.CaptchaInfo";
        };

        return CaptchaInfo;
    })();

    PBEntity.File = (function () {

        function File(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        File.prototype.ID = "";
        File.prototype.MchID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        File.prototype.FileCategory = 0;
        File.prototype.RelatedID = "";
        File.prototype.Name = "";
        File.prototype.Suffix = "";
        File.prototype.Size = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        File.prototype.MD5 = "";
        File.prototype.CreateTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        File.prototype.CreateUser = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        File.prototype.FromIP = "";
        File.prototype.Estate = 0;
        File.prototype.Thumbnail = 0;
        File.prototype.Transcoded = 0;
        File.prototype.StoragePath = "";
        File.prototype.DeleteTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        File.prototype.DeleterID = "";
        File.prototype.ThirdStatus = 0;
        File.prototype.ThirdID = "";
        File.prototype.UploadZFB = 0;
        File.prototype.ZFBID = "";
        File.prototype.ZFBKey = "";
        File.prototype.ZFBUpdateTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        File.prototype.HardLink = false;
        File.prototype.CacheID = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

        File.create = function create(properties) {
            return new File(properties);
        };

        File.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.ID != null && Object.hasOwnProperty.call(m, "ID"))
                w.uint32(10).string(m.ID);
            if (m.MchID != null && Object.hasOwnProperty.call(m, "MchID"))
                w.uint32(16).uint64(m.MchID);
            if (m.FileCategory != null && Object.hasOwnProperty.call(m, "FileCategory"))
                w.uint32(24).int32(m.FileCategory);
            if (m.RelatedID != null && Object.hasOwnProperty.call(m, "RelatedID"))
                w.uint32(34).string(m.RelatedID);
            if (m.Name != null && Object.hasOwnProperty.call(m, "Name"))
                w.uint32(42).string(m.Name);
            if (m.Suffix != null && Object.hasOwnProperty.call(m, "Suffix"))
                w.uint32(50).string(m.Suffix);
            if (m.Size != null && Object.hasOwnProperty.call(m, "Size"))
                w.uint32(56).uint64(m.Size);
            if (m.MD5 != null && Object.hasOwnProperty.call(m, "MD5"))
                w.uint32(66).string(m.MD5);
            if (m.CreateTime != null && Object.hasOwnProperty.call(m, "CreateTime"))
                w.uint32(72).int64(m.CreateTime);
            if (m.CreateUser != null && Object.hasOwnProperty.call(m, "CreateUser"))
                w.uint32(80).uint64(m.CreateUser);
            if (m.FromIP != null && Object.hasOwnProperty.call(m, "FromIP"))
                w.uint32(90).string(m.FromIP);
            if (m.Estate != null && Object.hasOwnProperty.call(m, "Estate"))
                w.uint32(96).int32(m.Estate);
            if (m.Thumbnail != null && Object.hasOwnProperty.call(m, "Thumbnail"))
                w.uint32(104).int32(m.Thumbnail);
            if (m.Transcoded != null && Object.hasOwnProperty.call(m, "Transcoded"))
                w.uint32(112).int32(m.Transcoded);
            if (m.StoragePath != null && Object.hasOwnProperty.call(m, "StoragePath"))
                w.uint32(122).string(m.StoragePath);
            if (m.DeleteTime != null && Object.hasOwnProperty.call(m, "DeleteTime"))
                w.uint32(128).int64(m.DeleteTime);
            if (m.DeleterID != null && Object.hasOwnProperty.call(m, "DeleterID"))
                w.uint32(138).string(m.DeleterID);
            if (m.ThirdStatus != null && Object.hasOwnProperty.call(m, "ThirdStatus"))
                w.uint32(144).int32(m.ThirdStatus);
            if (m.ThirdID != null && Object.hasOwnProperty.call(m, "ThirdID"))
                w.uint32(154).string(m.ThirdID);
            if (m.UploadZFB != null && Object.hasOwnProperty.call(m, "UploadZFB"))
                w.uint32(160).int32(m.UploadZFB);
            if (m.ZFBID != null && Object.hasOwnProperty.call(m, "ZFBID"))
                w.uint32(170).string(m.ZFBID);
            if (m.ZFBKey != null && Object.hasOwnProperty.call(m, "ZFBKey"))
                w.uint32(178).string(m.ZFBKey);
            if (m.ZFBUpdateTime != null && Object.hasOwnProperty.call(m, "ZFBUpdateTime"))
                w.uint32(184).int64(m.ZFBUpdateTime);
            if (m.HardLink != null && Object.hasOwnProperty.call(m, "HardLink"))
                w.uint32(192).bool(m.HardLink);
            if (m.CacheID != null && Object.hasOwnProperty.call(m, "CacheID"))
                w.uint32(200).int64(m.CacheID);
            return w;
        };

        File.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.File();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        m.ID = r.string();
                        break;
                    }
                    case 2: {
                        m.MchID = r.uint64();
                        break;
                    }
                    case 3: {
                        m.FileCategory = r.int32();
                        break;
                    }
                    case 4: {
                        m.RelatedID = r.string();
                        break;
                    }
                    case 5: {
                        m.Name = r.string();
                        break;
                    }
                    case 6: {
                        m.Suffix = r.string();
                        break;
                    }
                    case 7: {
                        m.Size = r.uint64();
                        break;
                    }
                    case 8: {
                        m.MD5 = r.string();
                        break;
                    }
                    case 9: {
                        m.CreateTime = r.int64();
                        break;
                    }
                    case 10: {
                        m.CreateUser = r.uint64();
                        break;
                    }
                    case 11: {
                        m.FromIP = r.string();
                        break;
                    }
                    case 12: {
                        m.Estate = r.int32();
                        break;
                    }
                    case 13: {
                        m.Thumbnail = r.int32();
                        break;
                    }
                    case 14: {
                        m.Transcoded = r.int32();
                        break;
                    }
                    case 15: {
                        m.StoragePath = r.string();
                        break;
                    }
                    case 16: {
                        m.DeleteTime = r.int64();
                        break;
                    }
                    case 17: {
                        m.DeleterID = r.string();
                        break;
                    }
                    case 18: {
                        m.ThirdStatus = r.int32();
                        break;
                    }
                    case 19: {
                        m.ThirdID = r.string();
                        break;
                    }
                    case 20: {
                        m.UploadZFB = r.int32();
                        break;
                    }
                    case 21: {
                        m.ZFBID = r.string();
                        break;
                    }
                    case 22: {
                        m.ZFBKey = r.string();
                        break;
                    }
                    case 23: {
                        m.ZFBUpdateTime = r.int64();
                        break;
                    }
                    case 24: {
                        m.HardLink = r.bool();
                        break;
                    }
                    case 25: {
                        m.CacheID = r.int64();
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        File.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.File";
        };

        return File;
    })();

    PBEntity.CreateUploadReq = (function () {

        function CreateUploadReq(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        CreateUploadReq.prototype.FileName = "";
        CreateUploadReq.prototype.Size = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        CreateUploadReq.prototype.MD5 = "";
        CreateUploadReq.prototype.FileCategory = 0;
        CreateUploadReq.prototype.ReID = "";

        CreateUploadReq.create = function create(properties) {
            return new CreateUploadReq(properties);
        };

        CreateUploadReq.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.FileName != null && Object.hasOwnProperty.call(m, "FileName"))
                w.uint32(10).string(m.FileName);
            if (m.Size != null && Object.hasOwnProperty.call(m, "Size"))
                w.uint32(16).uint64(m.Size);
            if (m.MD5 != null && Object.hasOwnProperty.call(m, "MD5"))
                w.uint32(26).string(m.MD5);
            if (m.FileCategory != null && Object.hasOwnProperty.call(m, "FileCategory"))
                w.uint32(32).int32(m.FileCategory);
            if (m.ReID != null && Object.hasOwnProperty.call(m, "ReID"))
                w.uint32(42).string(m.ReID);
            return w;
        };

        CreateUploadReq.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.CreateUploadReq();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        m.FileName = r.string();
                        break;
                    }
                    case 2: {
                        m.Size = r.uint64();
                        break;
                    }
                    case 3: {
                        m.MD5 = r.string();
                        break;
                    }
                    case 4: {
                        m.FileCategory = r.int32();
                        break;
                    }
                    case 5: {
                        m.ReID = r.string();
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        CreateUploadReq.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.CreateUploadReq";
        };

        return CreateUploadReq;
    })();

    PBEntity.CreateUploadResp = (function () {

        function CreateUploadResp(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        CreateUploadResp.prototype.FileID = "";
        CreateUploadResp.prototype.QuickUpload = false;
        CreateUploadResp.prototype.Breakpoint = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

        CreateUploadResp.create = function create(properties) {
            return new CreateUploadResp(properties);
        };

        CreateUploadResp.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.FileID != null && Object.hasOwnProperty.call(m, "FileID"))
                w.uint32(10).string(m.FileID);
            if (m.QuickUpload != null && Object.hasOwnProperty.call(m, "QuickUpload"))
                w.uint32(16).bool(m.QuickUpload);
            if (m.Breakpoint != null && Object.hasOwnProperty.call(m, "Breakpoint"))
                w.uint32(24).int64(m.Breakpoint);
            return w;
        };

        CreateUploadResp.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.CreateUploadResp();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        m.FileID = r.string();
                        break;
                    }
                    case 2: {
                        m.QuickUpload = r.bool();
                        break;
                    }
                    case 3: {
                        m.Breakpoint = r.int64();
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        CreateUploadResp.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.CreateUploadResp";
        };

        return CreateUploadResp;
    })();

    PBEntity.GetOperationLogRequest = (function () {

        function GetOperationLogRequest(p) {
            this.LogTimeRange = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        GetOperationLogRequest.prototype.UserID = null;
        GetOperationLogRequest.prototype.LogTimeRange = $util.emptyArray;
        GetOperationLogRequest.prototype.PageIndex = 0;
        GetOperationLogRequest.prototype.PageSize = 0;
        GetOperationLogRequest.prototype.Service = "";
        GetOperationLogRequest.prototype.Module = "";
        GetOperationLogRequest.prototype.Action = null;
        GetOperationLogRequest.prototype.Result = null;
        GetOperationLogRequest.prototype.Key = "";
        GetOperationLogRequest.prototype.SortBy = "";
        GetOperationLogRequest.prototype.OrderBy = 0;

        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(GetOperationLogRequest.prototype, "_UserID", {
            get: $util.oneOfGetter($oneOfFields = ["UserID"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(GetOperationLogRequest.prototype, "_Action", {
            get: $util.oneOfGetter($oneOfFields = ["Action"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(GetOperationLogRequest.prototype, "_Result", {
            get: $util.oneOfGetter($oneOfFields = ["Result"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        GetOperationLogRequest.create = function create(properties) {
            return new GetOperationLogRequest(properties);
        };

        GetOperationLogRequest.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.UserID != null && Object.hasOwnProperty.call(m, "UserID"))
                w.uint32(8).uint64(m.UserID);
            if (m.LogTimeRange != null && m.LogTimeRange.length) {
                w.uint32(18).fork();
                for (var i = 0; i < m.LogTimeRange.length; ++i)
                    w.uint64(m.LogTimeRange[i]);
                w.ldelim();
            }
            if (m.PageIndex != null && Object.hasOwnProperty.call(m, "PageIndex"))
                w.uint32(24).uint32(m.PageIndex);
            if (m.PageSize != null && Object.hasOwnProperty.call(m, "PageSize"))
                w.uint32(32).uint32(m.PageSize);
            if (m.Service != null && Object.hasOwnProperty.call(m, "Service"))
                w.uint32(42).string(m.Service);
            if (m.Module != null && Object.hasOwnProperty.call(m, "Module"))
                w.uint32(50).string(m.Module);
            if (m.Action != null && Object.hasOwnProperty.call(m, "Action"))
                w.uint32(72).uint32(m.Action);
            if (m.Result != null && Object.hasOwnProperty.call(m, "Result"))
                w.uint32(80).bool(m.Result);
            if (m.Key != null && Object.hasOwnProperty.call(m, "Key"))
                w.uint32(90).string(m.Key);
            if (m.SortBy != null && Object.hasOwnProperty.call(m, "SortBy"))
                w.uint32(98).string(m.SortBy);
            if (m.OrderBy != null && Object.hasOwnProperty.call(m, "OrderBy"))
                w.uint32(104).int32(m.OrderBy);
            return w;
        };

        GetOperationLogRequest.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.GetOperationLogRequest();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        m.UserID = r.uint64();
                        break;
                    }
                    case 2: {
                        if (!(m.LogTimeRange && m.LogTimeRange.length))
                            m.LogTimeRange = [];
                        if ((t & 7) === 2) {
                            var c2 = r.uint32() + r.pos;
                            while (r.pos < c2)
                                m.LogTimeRange.push(r.uint64());
                        } else
                            m.LogTimeRange.push(r.uint64());
                        break;
                    }
                    case 3: {
                        m.PageIndex = r.uint32();
                        break;
                    }
                    case 4: {
                        m.PageSize = r.uint32();
                        break;
                    }
                    case 5: {
                        m.Service = r.string();
                        break;
                    }
                    case 6: {
                        m.Module = r.string();
                        break;
                    }
                    case 9: {
                        m.Action = r.uint32();
                        break;
                    }
                    case 10: {
                        m.Result = r.bool();
                        break;
                    }
                    case 11: {
                        m.Key = r.string();
                        break;
                    }
                    case 12: {
                        m.SortBy = r.string();
                        break;
                    }
                    case 13: {
                        m.OrderBy = r.int32();
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        GetOperationLogRequest.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.GetOperationLogRequest";
        };

        return GetOperationLogRequest;
    })();

    PBEntity.MQTTClientInfo = (function () {

        function MQTTClientInfo(p) {
            this.Topic = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        MQTTClientInfo.prototype.Client = null;
        MQTTClientInfo.prototype.UserInfo = null;
        MQTTClientInfo.prototype.Topic = $util.emptyArray;
        MQTTClientInfo.prototype.Status = 0;

        MQTTClientInfo.create = function create(properties) {
            return new MQTTClientInfo(properties);
        };

        MQTTClientInfo.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.Client != null && Object.hasOwnProperty.call(m, "Client"))
                $root.PBEntity.MQClient.encode(m.Client, w.uint32(10).fork()).ldelim();
            if (m.UserInfo != null && Object.hasOwnProperty.call(m, "UserInfo"))
                $root.PBEntity.UserLoginInfo.encode(m.UserInfo, w.uint32(18).fork()).ldelim();
            if (m.Topic != null && m.Topic.length) {
                for (var i = 0; i < m.Topic.length; ++i)
                    w.uint32(26).string(m.Topic[i]);
            }
            if (m.Status != null && Object.hasOwnProperty.call(m, "Status"))
                w.uint32(32).int32(m.Status);
            return w;
        };

        MQTTClientInfo.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.MQTTClientInfo();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        m.Client = $root.PBEntity.MQClient.decode(r, r.uint32());
                        break;
                    }
                    case 2: {
                        m.UserInfo = $root.PBEntity.UserLoginInfo.decode(r, r.uint32());
                        break;
                    }
                    case 3: {
                        if (!(m.Topic && m.Topic.length))
                            m.Topic = [];
                        m.Topic.push(r.string());
                        break;
                    }
                    case 4: {
                        m.Status = r.int32();
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        MQTTClientInfo.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.MQTTClientInfo";
        };

        return MQTTClientInfo;
    })();

    PBEntity.MQTTPublish = (function () {

        function MQTTPublish(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        MQTTPublish.prototype.MchID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        MQTTPublish.prototype.Topic = "";
        MQTTPublish.prototype.Payload = "";

        MQTTPublish.create = function create(properties) {
            return new MQTTPublish(properties);
        };

        MQTTPublish.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.MchID != null && Object.hasOwnProperty.call(m, "MchID"))
                w.uint32(8).uint64(m.MchID);
            if (m.Topic != null && Object.hasOwnProperty.call(m, "Topic"))
                w.uint32(18).string(m.Topic);
            if (m.Payload != null && Object.hasOwnProperty.call(m, "Payload"))
                w.uint32(26).string(m.Payload);
            return w;
        };

        MQTTPublish.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.MQTTPublish();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        m.MchID = r.uint64();
                        break;
                    }
                    case 2: {
                        m.Topic = r.string();
                        break;
                    }
                    case 3: {
                        m.Payload = r.string();
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        MQTTPublish.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.MQTTPublish";
        };

        return MQTTPublish;
    })();

    PBEntity.UserLoginInfo = (function () {

        function UserLoginInfo(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        UserLoginInfo.prototype.UserID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        UserLoginInfo.prototype.UserName = "";
        UserLoginInfo.prototype.DisplayName = "";
        UserLoginInfo.prototype.IsSetUserName = 0;
        UserLoginInfo.prototype.IsSetPassword = false;
        UserLoginInfo.prototype.Token = "";
        UserLoginInfo.prototype.IP = "";
        UserLoginInfo.prototype.LoginTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        UserLoginInfo.prototype.ExpireTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;
        UserLoginInfo.prototype.Platform = 0;

        UserLoginInfo.create = function create(properties) {
            return new UserLoginInfo(properties);
        };

        UserLoginInfo.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.UserID != null && Object.hasOwnProperty.call(m, "UserID"))
                w.uint32(8).uint64(m.UserID);
            if (m.UserName != null && Object.hasOwnProperty.call(m, "UserName"))
                w.uint32(18).string(m.UserName);
            if (m.DisplayName != null && Object.hasOwnProperty.call(m, "DisplayName"))
                w.uint32(26).string(m.DisplayName);
            if (m.IsSetUserName != null && Object.hasOwnProperty.call(m, "IsSetUserName"))
                w.uint32(32).int32(m.IsSetUserName);
            if (m.IsSetPassword != null && Object.hasOwnProperty.call(m, "IsSetPassword"))
                w.uint32(40).bool(m.IsSetPassword);
            if (m.Token != null && Object.hasOwnProperty.call(m, "Token"))
                w.uint32(50).string(m.Token);
            if (m.IP != null && Object.hasOwnProperty.call(m, "IP"))
                w.uint32(58).string(m.IP);
            if (m.LoginTime != null && Object.hasOwnProperty.call(m, "LoginTime"))
                w.uint32(64).int64(m.LoginTime);
            if (m.ExpireTime != null && Object.hasOwnProperty.call(m, "ExpireTime"))
                w.uint32(72).int64(m.ExpireTime);
            if (m.Platform != null && Object.hasOwnProperty.call(m, "Platform"))
                w.uint32(80).int32(m.Platform);
            return w;
        };

        UserLoginInfo.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.UserLoginInfo();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        m.UserID = r.uint64();
                        break;
                    }
                    case 2: {
                        m.UserName = r.string();
                        break;
                    }
                    case 3: {
                        m.DisplayName = r.string();
                        break;
                    }
                    case 4: {
                        m.IsSetUserName = r.int32();
                        break;
                    }
                    case 5: {
                        m.IsSetPassword = r.bool();
                        break;
                    }
                    case 6: {
                        m.Token = r.string();
                        break;
                    }
                    case 7: {
                        m.IP = r.string();
                        break;
                    }
                    case 8: {
                        m.LoginTime = r.int64();
                        break;
                    }
                    case 9: {
                        m.ExpireTime = r.int64();
                        break;
                    }
                    case 10: {
                        m.Platform = r.int32();
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        UserLoginInfo.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.UserLoginInfo";
        };

        return UserLoginInfo;
    })();

    PBEntity.UserPermissionItem = (function () {

        function UserPermissionItem(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        UserPermissionItem.prototype.ID = "";
        UserPermissionItem.prototype.Code = "";
        UserPermissionItem.prototype.Name = "";
        UserPermissionItem.prototype.Oper = 0;
        UserPermissionItem.prototype.Permission = 0;
        UserPermissionItem.prototype.CustomOper = "";
        UserPermissionItem.prototype.CustomOperateCodes = "";
        UserPermissionItem.prototype.ParentID = "";
        UserPermissionItem.prototype.ParentCode = "";
        UserPermissionItem.prototype.HasChildren = false;

        UserPermissionItem.create = function create(properties) {
            return new UserPermissionItem(properties);
        };

        UserPermissionItem.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.ID != null && Object.hasOwnProperty.call(m, "ID"))
                w.uint32(10).string(m.ID);
            if (m.Code != null && Object.hasOwnProperty.call(m, "Code"))
                w.uint32(18).string(m.Code);
            if (m.Name != null && Object.hasOwnProperty.call(m, "Name"))
                w.uint32(26).string(m.Name);
            if (m.Oper != null && Object.hasOwnProperty.call(m, "Oper"))
                w.uint32(32).int32(m.Oper);
            if (m.Permission != null && Object.hasOwnProperty.call(m, "Permission"))
                w.uint32(40).int32(m.Permission);
            if (m.CustomOper != null && Object.hasOwnProperty.call(m, "CustomOper"))
                w.uint32(50).string(m.CustomOper);
            if (m.CustomOperateCodes != null && Object.hasOwnProperty.call(m, "CustomOperateCodes"))
                w.uint32(58).string(m.CustomOperateCodes);
            if (m.ParentID != null && Object.hasOwnProperty.call(m, "ParentID"))
                w.uint32(66).string(m.ParentID);
            if (m.ParentCode != null && Object.hasOwnProperty.call(m, "ParentCode"))
                w.uint32(74).string(m.ParentCode);
            if (m.HasChildren != null && Object.hasOwnProperty.call(m, "HasChildren"))
                w.uint32(80).bool(m.HasChildren);
            return w;
        };

        UserPermissionItem.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.UserPermissionItem();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        m.ID = r.string();
                        break;
                    }
                    case 2: {
                        m.Code = r.string();
                        break;
                    }
                    case 3: {
                        m.Name = r.string();
                        break;
                    }
                    case 4: {
                        m.Oper = r.int32();
                        break;
                    }
                    case 5: {
                        m.Permission = r.int32();
                        break;
                    }
                    case 6: {
                        m.CustomOper = r.string();
                        break;
                    }
                    case 7: {
                        m.CustomOperateCodes = r.string();
                        break;
                    }
                    case 8: {
                        m.ParentID = r.string();
                        break;
                    }
                    case 9: {
                        m.ParentCode = r.string();
                        break;
                    }
                    case 10: {
                        m.HasChildren = r.bool();
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        UserPermissionItem.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.UserPermissionItem";
        };

        return UserPermissionItem;
    })();

    PBEntity.UserPermission = (function () {

        function UserPermission(p) {
            this.PermissionList = {};
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        UserPermission.prototype.UserID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        UserPermission.prototype.PermissionList = $util.emptyObject;

        UserPermission.create = function create(properties) {
            return new UserPermission(properties);
        };

        UserPermission.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.UserID != null && Object.hasOwnProperty.call(m, "UserID"))
                w.uint32(8).uint64(m.UserID);
            if (m.PermissionList != null && Object.hasOwnProperty.call(m, "PermissionList")) {
                for (var ks = Object.keys(m.PermissionList), i = 0; i < ks.length; ++i) {
                    w.uint32(18).fork().uint32(10).string(ks[i]);
                    $root.PBEntity.UserPermissionItem.encode(m.PermissionList[ks[i]], w.uint32(18).fork()).ldelim().ldelim();
                }
            }
            return w;
        };

        UserPermission.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.UserPermission(), k, value;
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        m.UserID = r.uint64();
                        break;
                    }
                    case 2: {
                        if (m.PermissionList === $util.emptyObject)
                            m.PermissionList = {};
                        var c2 = r.uint32() + r.pos;
                        k = "";
                        value = null;
                        while (r.pos < c2) {
                            var tag2 = r.uint32();
                            switch (tag2 >>> 3) {
                                case 1:
                                    k = r.string();
                                    break;
                                case 2:
                                    value = $root.PBEntity.UserPermissionItem.decode(r, r.uint32());
                                    break;
                                default:
                                    r.skipType(tag2 & 7);
                                    break;
                            }
                        }
                        m.PermissionList[k] = value;
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        UserPermission.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.UserPermission";
        };

        return UserPermission;
    })();

    PBEntity.ChangePwdReq = (function () {

        function ChangePwdReq(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        ChangePwdReq.prototype.OldPwd = "";
        ChangePwdReq.prototype.NewPwd = "";

        ChangePwdReq.create = function create(properties) {
            return new ChangePwdReq(properties);
        };

        ChangePwdReq.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.OldPwd != null && Object.hasOwnProperty.call(m, "OldPwd"))
                w.uint32(10).string(m.OldPwd);
            if (m.NewPwd != null && Object.hasOwnProperty.call(m, "NewPwd"))
                w.uint32(18).string(m.NewPwd);
            return w;
        };

        ChangePwdReq.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.ChangePwdReq();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        m.OldPwd = r.string();
                        break;
                    }
                    case 2: {
                        m.NewPwd = r.string();
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        ChangePwdReq.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.ChangePwdReq";
        };

        return ChangePwdReq;
    })();

    PBEntity.LoginReq = (function () {

        function LoginReq(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        LoginReq.prototype.LoginName = "";
        LoginReq.prototype.Pwd = "";
        LoginReq.prototype.KeepTime = 0;
        LoginReq.prototype.CaptchaID = "";
        LoginReq.prototype.CaptchaCode = "";
        LoginReq.prototype.Platform = 0;
        LoginReq.prototype.DeviceID = "";

        LoginReq.create = function create(properties) {
            return new LoginReq(properties);
        };

        LoginReq.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.LoginName != null && Object.hasOwnProperty.call(m, "LoginName"))
                w.uint32(10).string(m.LoginName);
            if (m.Pwd != null && Object.hasOwnProperty.call(m, "Pwd"))
                w.uint32(18).string(m.Pwd);
            if (m.KeepTime != null && Object.hasOwnProperty.call(m, "KeepTime"))
                w.uint32(24).int32(m.KeepTime);
            if (m.CaptchaID != null && Object.hasOwnProperty.call(m, "CaptchaID"))
                w.uint32(34).string(m.CaptchaID);
            if (m.CaptchaCode != null && Object.hasOwnProperty.call(m, "CaptchaCode"))
                w.uint32(42).string(m.CaptchaCode);
            if (m.Platform != null && Object.hasOwnProperty.call(m, "Platform"))
                w.uint32(48).int32(m.Platform);
            if (m.DeviceID != null && Object.hasOwnProperty.call(m, "DeviceID"))
                w.uint32(58).string(m.DeviceID);
            return w;
        };

        LoginReq.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.LoginReq();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        m.LoginName = r.string();
                        break;
                    }
                    case 2: {
                        m.Pwd = r.string();
                        break;
                    }
                    case 3: {
                        m.KeepTime = r.int32();
                        break;
                    }
                    case 4: {
                        m.CaptchaID = r.string();
                        break;
                    }
                    case 5: {
                        m.CaptchaCode = r.string();
                        break;
                    }
                    case 6: {
                        m.Platform = r.int32();
                        break;
                    }
                    case 7: {
                        m.DeviceID = r.string();
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        LoginReq.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.LoginReq";
        };

        return LoginReq;
    })();

    PBEntity.RegReq = (function () {

        function RegReq(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        RegReq.prototype.UserName = "";
        RegReq.prototype.Pwd = "";
        RegReq.prototype.RegCode = "";

        RegReq.create = function create(properties) {
            return new RegReq(properties);
        };

        RegReq.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.UserName != null && Object.hasOwnProperty.call(m, "UserName"))
                w.uint32(10).string(m.UserName);
            if (m.Pwd != null && Object.hasOwnProperty.call(m, "Pwd"))
                w.uint32(18).string(m.Pwd);
            if (m.RegCode != null && Object.hasOwnProperty.call(m, "RegCode"))
                w.uint32(26).string(m.RegCode);
            return w;
        };

        RegReq.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.RegReq();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        m.UserName = r.string();
                        break;
                    }
                    case 2: {
                        m.Pwd = r.string();
                        break;
                    }
                    case 3: {
                        m.RegCode = r.string();
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        RegReq.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.RegReq";
        };

        return RegReq;
    })();

    PBEntity.Picker = (function () {

        function Picker(p) {
            this.OptionList = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        Picker.prototype.OptionList = $util.emptyArray;

        Picker.create = function create(properties) {
            return new Picker(properties);
        };

        Picker.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.OptionList != null && m.OptionList.length) {
                for (var i = 0; i < m.OptionList.length; ++i)
                    $root.PBEntity.PickerOption.encode(m.OptionList[i], w.uint32(10).fork()).ldelim();
            }
            return w;
        };

        Picker.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.Picker();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        if (!(m.OptionList && m.OptionList.length))
                            m.OptionList = [];
                        m.OptionList.push($root.PBEntity.PickerOption.decode(r, r.uint32()));
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        Picker.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.Picker";
        };

        return Picker;
    })();

    PBEntity.PickerOption = (function () {

        function PickerOption(p) {
            this.children = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        PickerOption.prototype.text = "";
        PickerOption.prototype.value = "";
        PickerOption.prototype.children = $util.emptyArray;

        PickerOption.create = function create(properties) {
            return new PickerOption(properties);
        };

        PickerOption.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.text != null && Object.hasOwnProperty.call(m, "text"))
                w.uint32(10).string(m.text);
            if (m.value != null && Object.hasOwnProperty.call(m, "value"))
                w.uint32(18).string(m.value);
            if (m.children != null && m.children.length) {
                for (var i = 0; i < m.children.length; ++i)
                    $root.PBEntity.PickerChildrenOption.encode(m.children[i], w.uint32(26).fork()).ldelim();
            }
            return w;
        };

        PickerOption.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.PickerOption();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        m.text = r.string();
                        break;
                    }
                    case 2: {
                        m.value = r.string();
                        break;
                    }
                    case 3: {
                        if (!(m.children && m.children.length))
                            m.children = [];
                        m.children.push($root.PBEntity.PickerChildrenOption.decode(r, r.uint32()));
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        PickerOption.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.PickerOption";
        };

        return PickerOption;
    })();

    PBEntity.PickerChildrenOption = (function () {

        function PickerChildrenOption(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        PickerChildrenOption.prototype.text = "";
        PickerChildrenOption.prototype.value = "";

        PickerChildrenOption.create = function create(properties) {
            return new PickerChildrenOption(properties);
        };

        PickerChildrenOption.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.text != null && Object.hasOwnProperty.call(m, "text"))
                w.uint32(10).string(m.text);
            if (m.value != null && Object.hasOwnProperty.call(m, "value"))
                w.uint32(18).string(m.value);
            return w;
        };

        PickerChildrenOption.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.PickerChildrenOption();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        m.text = r.string();
                        break;
                    }
                    case 2: {
                        m.value = r.string();
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        PickerChildrenOption.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.PickerChildrenOption";
        };

        return PickerChildrenOption;
    })();

    PBEntity.ScanQRCodeResp = (function () {

        function ScanQRCodeResp(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        ScanQRCodeResp.prototype.MchID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        ScanQRCodeResp.prototype.ToCate = 0;
        ScanQRCodeResp.prototype.ReID = "";
        ScanQRCodeResp.prototype.GroupID = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        ScanQRCodeResp.prototype.ICode = "";

        ScanQRCodeResp.create = function create(properties) {
            return new ScanQRCodeResp(properties);
        };

        ScanQRCodeResp.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.MchID != null && Object.hasOwnProperty.call(m, "MchID"))
                w.uint32(8).uint64(m.MchID);
            if (m.ToCate != null && Object.hasOwnProperty.call(m, "ToCate"))
                w.uint32(16).int32(m.ToCate);
            if (m.ReID != null && Object.hasOwnProperty.call(m, "ReID"))
                w.uint32(26).string(m.ReID);
            if (m.GroupID != null && Object.hasOwnProperty.call(m, "GroupID"))
                w.uint32(32).uint64(m.GroupID);
            if (m.ICode != null && Object.hasOwnProperty.call(m, "ICode"))
                w.uint32(42).string(m.ICode);
            return w;
        };

        ScanQRCodeResp.decode = function decode(r, l, e) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PBEntity.ScanQRCodeResp();
            while (r.pos < c) {
                var t = r.uint32();
                if (t === e)
                    break;
                switch (t >>> 3) {
                    case 1: {
                        m.MchID = r.uint64();
                        break;
                    }
                    case 2: {
                        m.ToCate = r.int32();
                        break;
                    }
                    case 3: {
                        m.ReID = r.string();
                        break;
                    }
                    case 4: {
                        m.GroupID = r.uint64();
                        break;
                    }
                    case 5: {
                        m.ICode = r.string();
                        break;
                    }
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };

        ScanQRCodeResp.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/PBEntity.ScanQRCodeResp";
        };

        return ScanQRCodeResp;
    })();

    return PBEntity;
})();

export {$root as default};
